/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.common = (function() {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    var common = {};

    common.Empty = (function() {

        /**
         * Properties of an Empty.
         * @memberof common
         * @interface IEmpty
         */

        /**
         * Constructs a new Empty.
         * @memberof common
         * @classdesc Represents an Empty.
         * @implements IEmpty
         * @constructor
         * @param {common.IEmpty=} [properties] Properties to set
         */
        function Empty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Empty instance using the specified properties.
         * @function create
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty=} [properties] Properties to set
         * @returns {common.Empty} Empty instance
         */
        Empty.create = function create(properties) {
            return new Empty(properties);
        };

        /**
         * Encodes the specified Empty message. Does not implicitly {@link common.Empty.verify|verify} messages.
         * @function encode
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty} message Empty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Empty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Empty message, length delimited. Does not implicitly {@link common.Empty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty} message Empty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Empty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Empty message from the specified reader or buffer.
         * @function decode
         * @memberof common.Empty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Empty} Empty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Empty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Empty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Empty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Empty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Empty} Empty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Empty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Empty message.
         * @function verify
         * @memberof common.Empty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Empty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an Empty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Empty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Empty} Empty
         */
        Empty.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Empty)
                return object;
            return new $root.common.Empty();
        };

        /**
         * Creates a plain object from an Empty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Empty
         * @static
         * @param {common.Empty} message Empty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Empty.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Empty to JSON.
         * @function toJSON
         * @memberof common.Empty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Empty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Empty;
    })();

    common.Count = (function() {

        /**
         * Properties of a Count.
         * @memberof common
         * @interface ICount
         * @property {number|Long|null} [count] Count count
         */

        /**
         * Constructs a new Count.
         * @memberof common
         * @classdesc Represents a Count.
         * @implements ICount
         * @constructor
         * @param {common.ICount=} [properties] Properties to set
         */
        function Count(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Count count.
         * @member {number|Long} count
         * @memberof common.Count
         * @instance
         */
        Count.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Count instance using the specified properties.
         * @function create
         * @memberof common.Count
         * @static
         * @param {common.ICount=} [properties] Properties to set
         * @returns {common.Count} Count instance
         */
        Count.create = function create(properties) {
            return new Count(properties);
        };

        /**
         * Encodes the specified Count message. Does not implicitly {@link common.Count.verify|verify} messages.
         * @function encode
         * @memberof common.Count
         * @static
         * @param {common.ICount} message Count message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Count.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.count);
            return writer;
        };

        /**
         * Encodes the specified Count message, length delimited. Does not implicitly {@link common.Count.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Count
         * @static
         * @param {common.ICount} message Count message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Count.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Count message from the specified reader or buffer.
         * @function decode
         * @memberof common.Count
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Count} Count
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Count.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Count();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.count = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Count message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Count
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Count} Count
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Count.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Count message.
         * @function verify
         * @memberof common.Count
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Count.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.count != null && message.hasOwnProperty("count"))
                if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                    return "count: integer|Long expected";
            return null;
        };

        /**
         * Creates a Count message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Count
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Count} Count
         */
        Count.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Count)
                return object;
            var message = new $root.common.Count();
            if (object.count != null)
                if ($util.Long)
                    (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                else if (typeof object.count === "string")
                    message.count = parseInt(object.count, 10);
                else if (typeof object.count === "number")
                    message.count = object.count;
                else if (typeof object.count === "object")
                    message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Count message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Count
         * @static
         * @param {common.Count} message Count
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Count.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.count = options.longs === String ? "0" : 0;
            if (message.count != null && message.hasOwnProperty("count"))
                if (typeof message.count === "number")
                    object.count = options.longs === String ? String(message.count) : message.count;
                else
                    object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
            return object;
        };

        /**
         * Converts this Count to JSON.
         * @function toJSON
         * @memberof common.Count
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Count.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Count;
    })();

    common.Pager = (function() {

        /**
         * Properties of a Pager.
         * @memberof common
         * @interface IPager
         * @property {number|null} [page] Pager page
         * @property {number|null} [offset] Pager offset
         */

        /**
         * Constructs a new Pager.
         * @memberof common
         * @classdesc Represents a Pager.
         * @implements IPager
         * @constructor
         * @param {common.IPager=} [properties] Properties to set
         */
        function Pager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pager page.
         * @member {number} page
         * @memberof common.Pager
         * @instance
         */
        Pager.prototype.page = 0;

        /**
         * Pager offset.
         * @member {number} offset
         * @memberof common.Pager
         * @instance
         */
        Pager.prototype.offset = 0;

        /**
         * Creates a new Pager instance using the specified properties.
         * @function create
         * @memberof common.Pager
         * @static
         * @param {common.IPager=} [properties] Properties to set
         * @returns {common.Pager} Pager instance
         */
        Pager.create = function create(properties) {
            return new Pager(properties);
        };

        /**
         * Encodes the specified Pager message. Does not implicitly {@link common.Pager.verify|verify} messages.
         * @function encode
         * @memberof common.Pager
         * @static
         * @param {common.IPager} message Pager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.page);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.offset);
            return writer;
        };

        /**
         * Encodes the specified Pager message, length delimited. Does not implicitly {@link common.Pager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Pager
         * @static
         * @param {common.IPager} message Pager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Pager message from the specified reader or buffer.
         * @function decode
         * @memberof common.Pager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Pager} Pager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Pager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.page = reader.int32();
                    break;
                case 2:
                    message.offset = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Pager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Pager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Pager} Pager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Pager message.
         * @function verify
         * @memberof common.Pager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Pager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.page != null && message.hasOwnProperty("page"))
                if (!$util.isInteger(message.page))
                    return "page: integer expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset))
                    return "offset: integer expected";
            return null;
        };

        /**
         * Creates a Pager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Pager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Pager} Pager
         */
        Pager.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Pager)
                return object;
            var message = new $root.common.Pager();
            if (object.page != null)
                message.page = object.page | 0;
            if (object.offset != null)
                message.offset = object.offset | 0;
            return message;
        };

        /**
         * Creates a plain object from a Pager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Pager
         * @static
         * @param {common.Pager} message Pager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.page = 0;
                object.offset = 0;
            }
            if (message.page != null && message.hasOwnProperty("page"))
                object.page = message.page;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            return object;
        };

        /**
         * Converts this Pager to JSON.
         * @function toJSON
         * @memberof common.Pager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Pager;
    })();

    common.YMD = (function() {

        /**
         * Properties of a YMD.
         * @memberof common
         * @interface IYMD
         * @property {number|null} [year] YMD year
         * @property {number|null} [month] YMD month
         * @property {number|null} [day] YMD day
         */

        /**
         * Constructs a new YMD.
         * @memberof common
         * @classdesc Represents a YMD.
         * @implements IYMD
         * @constructor
         * @param {common.IYMD=} [properties] Properties to set
         */
        function YMD(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * YMD year.
         * @member {number} year
         * @memberof common.YMD
         * @instance
         */
        YMD.prototype.year = 0;

        /**
         * YMD month.
         * @member {number} month
         * @memberof common.YMD
         * @instance
         */
        YMD.prototype.month = 0;

        /**
         * YMD day.
         * @member {number} day
         * @memberof common.YMD
         * @instance
         */
        YMD.prototype.day = 0;

        /**
         * Creates a new YMD instance using the specified properties.
         * @function create
         * @memberof common.YMD
         * @static
         * @param {common.IYMD=} [properties] Properties to set
         * @returns {common.YMD} YMD instance
         */
        YMD.create = function create(properties) {
            return new YMD(properties);
        };

        /**
         * Encodes the specified YMD message. Does not implicitly {@link common.YMD.verify|verify} messages.
         * @function encode
         * @memberof common.YMD
         * @static
         * @param {common.IYMD} message YMD message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        YMD.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
            if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
            if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
            return writer;
        };

        /**
         * Encodes the specified YMD message, length delimited. Does not implicitly {@link common.YMD.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.YMD
         * @static
         * @param {common.IYMD} message YMD message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        YMD.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a YMD message from the specified reader or buffer.
         * @function decode
         * @memberof common.YMD
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.YMD} YMD
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        YMD.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.YMD();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.year = reader.int32();
                    break;
                case 2:
                    message.month = reader.int32();
                    break;
                case 3:
                    message.day = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a YMD message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.YMD
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.YMD} YMD
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        YMD.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a YMD message.
         * @function verify
         * @memberof common.YMD
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        YMD.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.year != null && message.hasOwnProperty("year"))
                if (!$util.isInteger(message.year))
                    return "year: integer expected";
            if (message.month != null && message.hasOwnProperty("month"))
                if (!$util.isInteger(message.month))
                    return "month: integer expected";
            if (message.day != null && message.hasOwnProperty("day"))
                if (!$util.isInteger(message.day))
                    return "day: integer expected";
            return null;
        };

        /**
         * Creates a YMD message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.YMD
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.YMD} YMD
         */
        YMD.fromObject = function fromObject(object) {
            if (object instanceof $root.common.YMD)
                return object;
            var message = new $root.common.YMD();
            if (object.year != null)
                message.year = object.year | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.day != null)
                message.day = object.day | 0;
            return message;
        };

        /**
         * Creates a plain object from a YMD message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.YMD
         * @static
         * @param {common.YMD} message YMD
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        YMD.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.year = 0;
                object.month = 0;
                object.day = 0;
            }
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            return object;
        };

        /**
         * Converts this YMD to JSON.
         * @function toJSON
         * @memberof common.YMD
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        YMD.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return YMD;
    })();

    common.TextResult = (function() {

        /**
         * Properties of a TextResult.
         * @memberof common
         * @interface ITextResult
         * @property {string|null} [result] TextResult result
         */

        /**
         * Constructs a new TextResult.
         * @memberof common
         * @classdesc Represents a TextResult.
         * @implements ITextResult
         * @constructor
         * @param {common.ITextResult=} [properties] Properties to set
         */
        function TextResult(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TextResult result.
         * @member {string} result
         * @memberof common.TextResult
         * @instance
         */
        TextResult.prototype.result = "";

        /**
         * Creates a new TextResult instance using the specified properties.
         * @function create
         * @memberof common.TextResult
         * @static
         * @param {common.ITextResult=} [properties] Properties to set
         * @returns {common.TextResult} TextResult instance
         */
        TextResult.create = function create(properties) {
            return new TextResult(properties);
        };

        /**
         * Encodes the specified TextResult message. Does not implicitly {@link common.TextResult.verify|verify} messages.
         * @function encode
         * @memberof common.TextResult
         * @static
         * @param {common.ITextResult} message TextResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TextResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.result);
            return writer;
        };

        /**
         * Encodes the specified TextResult message, length delimited. Does not implicitly {@link common.TextResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TextResult
         * @static
         * @param {common.ITextResult} message TextResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TextResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TextResult message from the specified reader or buffer.
         * @function decode
         * @memberof common.TextResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TextResult} TextResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TextResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TextResult();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TextResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TextResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TextResult} TextResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TextResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TextResult message.
         * @function verify
         * @memberof common.TextResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TextResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isString(message.result))
                    return "result: string expected";
            return null;
        };

        /**
         * Creates a TextResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TextResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TextResult} TextResult
         */
        TextResult.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TextResult)
                return object;
            var message = new $root.common.TextResult();
            if (object.result != null)
                message.result = String(object.result);
            return message;
        };

        /**
         * Creates a plain object from a TextResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TextResult
         * @static
         * @param {common.TextResult} message TextResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TextResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = "";
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this TextResult to JSON.
         * @function toJSON
         * @memberof common.TextResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TextResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TextResult;
    })();

    common.DateRange = (function() {

        /**
         * Properties of a DateRange.
         * @memberof common
         * @interface IDateRange
         * @property {string|null} [from] DateRange from
         * @property {string|null} [to] DateRange to
         */

        /**
         * Constructs a new DateRange.
         * @memberof common
         * @classdesc Represents a DateRange.
         * @implements IDateRange
         * @constructor
         * @param {common.IDateRange=} [properties] Properties to set
         */
        function DateRange(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DateRange from.
         * @member {string} from
         * @memberof common.DateRange
         * @instance
         */
        DateRange.prototype.from = "";

        /**
         * DateRange to.
         * @member {string} to
         * @memberof common.DateRange
         * @instance
         */
        DateRange.prototype.to = "";

        /**
         * Creates a new DateRange instance using the specified properties.
         * @function create
         * @memberof common.DateRange
         * @static
         * @param {common.IDateRange=} [properties] Properties to set
         * @returns {common.DateRange} DateRange instance
         */
        DateRange.create = function create(properties) {
            return new DateRange(properties);
        };

        /**
         * Encodes the specified DateRange message. Does not implicitly {@link common.DateRange.verify|verify} messages.
         * @function encode
         * @memberof common.DateRange
         * @static
         * @param {common.IDateRange} message DateRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.from);
            if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.to);
            return writer;
        };

        /**
         * Encodes the specified DateRange message, length delimited. Does not implicitly {@link common.DateRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.DateRange
         * @static
         * @param {common.IDateRange} message DateRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DateRange message from the specified reader or buffer.
         * @function decode
         * @memberof common.DateRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.DateRange} DateRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateRange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.DateRange();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.from = reader.string();
                    break;
                case 2:
                    message.to = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DateRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.DateRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.DateRange} DateRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DateRange message.
         * @function verify
         * @memberof common.DateRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DateRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.from != null && message.hasOwnProperty("from"))
                if (!$util.isString(message.from))
                    return "from: string expected";
            if (message.to != null && message.hasOwnProperty("to"))
                if (!$util.isString(message.to))
                    return "to: string expected";
            return null;
        };

        /**
         * Creates a DateRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DateRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DateRange} DateRange
         */
        DateRange.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DateRange)
                return object;
            var message = new $root.common.DateRange();
            if (object.from != null)
                message.from = String(object.from);
            if (object.to != null)
                message.to = String(object.to);
            return message;
        };

        /**
         * Creates a plain object from a DateRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DateRange
         * @static
         * @param {common.DateRange} message DateRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DateRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.from = "";
                object.to = "";
            }
            if (message.from != null && message.hasOwnProperty("from"))
                object.from = message.from;
            if (message.to != null && message.hasOwnProperty("to"))
                object.to = message.to;
            return object;
        };

        /**
         * Converts this DateRange to JSON.
         * @function toJSON
         * @memberof common.DateRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DateRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DateRange;
    })();

    return common;
})();

$root.entity = (function() {

    /**
     * Namespace entity.
     * @exports entity
     * @namespace
     */
    var entity = {};

    entity.AdminUser = (function() {

        /**
         * Properties of an AdminUser.
         * @memberof entity
         * @interface IAdminUser
         * @property {string|null} [id] AdminUser id
         * @property {string|null} [email] AdminUser email
         * @property {string|null} [name] AdminUser name
         */

        /**
         * Constructs a new AdminUser.
         * @memberof entity
         * @classdesc Represents an AdminUser.
         * @implements IAdminUser
         * @constructor
         * @param {entity.IAdminUser=} [properties] Properties to set
         */
        function AdminUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdminUser id.
         * @member {string} id
         * @memberof entity.AdminUser
         * @instance
         */
        AdminUser.prototype.id = "";

        /**
         * AdminUser email.
         * @member {string} email
         * @memberof entity.AdminUser
         * @instance
         */
        AdminUser.prototype.email = "";

        /**
         * AdminUser name.
         * @member {string} name
         * @memberof entity.AdminUser
         * @instance
         */
        AdminUser.prototype.name = "";

        /**
         * Creates a new AdminUser instance using the specified properties.
         * @function create
         * @memberof entity.AdminUser
         * @static
         * @param {entity.IAdminUser=} [properties] Properties to set
         * @returns {entity.AdminUser} AdminUser instance
         */
        AdminUser.create = function create(properties) {
            return new AdminUser(properties);
        };

        /**
         * Encodes the specified AdminUser message. Does not implicitly {@link entity.AdminUser.verify|verify} messages.
         * @function encode
         * @memberof entity.AdminUser
         * @static
         * @param {entity.IAdminUser} message AdminUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified AdminUser message, length delimited. Does not implicitly {@link entity.AdminUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.AdminUser
         * @static
         * @param {entity.IAdminUser} message AdminUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdminUser message from the specified reader or buffer.
         * @function decode
         * @memberof entity.AdminUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.AdminUser} AdminUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUser.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.AdminUser();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.email = reader.string();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdminUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.AdminUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.AdminUser} AdminUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdminUser message.
         * @function verify
         * @memberof entity.AdminUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdminUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates an AdminUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.AdminUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.AdminUser} AdminUser
         */
        AdminUser.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.AdminUser)
                return object;
            var message = new $root.entity.AdminUser();
            if (object.id != null)
                message.id = String(object.id);
            if (object.email != null)
                message.email = String(object.email);
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from an AdminUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.AdminUser
         * @static
         * @param {entity.AdminUser} message AdminUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdminUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.email = "";
                object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this AdminUser to JSON.
         * @function toJSON
         * @memberof entity.AdminUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdminUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdminUser;
    })();

    entity.AdminUserList = (function() {

        /**
         * Properties of an AdminUserList.
         * @memberof entity
         * @interface IAdminUserList
         * @property {Array.<entity.IAdminUser>|null} [items] AdminUserList items
         */

        /**
         * Constructs a new AdminUserList.
         * @memberof entity
         * @classdesc Represents an AdminUserList.
         * @implements IAdminUserList
         * @constructor
         * @param {entity.IAdminUserList=} [properties] Properties to set
         */
        function AdminUserList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdminUserList items.
         * @member {Array.<entity.IAdminUser>} items
         * @memberof entity.AdminUserList
         * @instance
         */
        AdminUserList.prototype.items = $util.emptyArray;

        /**
         * Creates a new AdminUserList instance using the specified properties.
         * @function create
         * @memberof entity.AdminUserList
         * @static
         * @param {entity.IAdminUserList=} [properties] Properties to set
         * @returns {entity.AdminUserList} AdminUserList instance
         */
        AdminUserList.create = function create(properties) {
            return new AdminUserList(properties);
        };

        /**
         * Encodes the specified AdminUserList message. Does not implicitly {@link entity.AdminUserList.verify|verify} messages.
         * @function encode
         * @memberof entity.AdminUserList
         * @static
         * @param {entity.IAdminUserList} message AdminUserList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUserList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.AdminUser.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AdminUserList message, length delimited. Does not implicitly {@link entity.AdminUserList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.AdminUserList
         * @static
         * @param {entity.IAdminUserList} message AdminUserList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdminUserList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdminUserList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.AdminUserList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.AdminUserList} AdminUserList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUserList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.AdminUserList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.AdminUser.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdminUserList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.AdminUserList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.AdminUserList} AdminUserList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdminUserList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdminUserList message.
         * @function verify
         * @memberof entity.AdminUserList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdminUserList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.AdminUser.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AdminUserList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.AdminUserList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.AdminUserList} AdminUserList
         */
        AdminUserList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.AdminUserList)
                return object;
            var message = new $root.entity.AdminUserList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.AdminUserList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.AdminUserList.items: object expected");
                    message.items[i] = $root.entity.AdminUser.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AdminUserList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.AdminUserList
         * @static
         * @param {entity.AdminUserList} message AdminUserList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdminUserList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.AdminUser.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this AdminUserList to JSON.
         * @function toJSON
         * @memberof entity.AdminUserList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdminUserList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdminUserList;
    })();

    entity.ApplyClientID = (function() {

        /**
         * Properties of an ApplyClientID.
         * @memberof entity
         * @interface IApplyClientID
         * @property {string|null} [email] ApplyClientID email
         */

        /**
         * Constructs a new ApplyClientID.
         * @memberof entity
         * @classdesc Represents an ApplyClientID.
         * @implements IApplyClientID
         * @constructor
         * @param {entity.IApplyClientID=} [properties] Properties to set
         */
        function ApplyClientID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ApplyClientID email.
         * @member {string} email
         * @memberof entity.ApplyClientID
         * @instance
         */
        ApplyClientID.prototype.email = "";

        /**
         * Creates a new ApplyClientID instance using the specified properties.
         * @function create
         * @memberof entity.ApplyClientID
         * @static
         * @param {entity.IApplyClientID=} [properties] Properties to set
         * @returns {entity.ApplyClientID} ApplyClientID instance
         */
        ApplyClientID.create = function create(properties) {
            return new ApplyClientID(properties);
        };

        /**
         * Encodes the specified ApplyClientID message. Does not implicitly {@link entity.ApplyClientID.verify|verify} messages.
         * @function encode
         * @memberof entity.ApplyClientID
         * @static
         * @param {entity.IApplyClientID} message ApplyClientID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClientID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified ApplyClientID message, length delimited. Does not implicitly {@link entity.ApplyClientID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ApplyClientID
         * @static
         * @param {entity.IApplyClientID} message ApplyClientID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClientID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ApplyClientID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ApplyClientID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ApplyClientID} ApplyClientID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClientID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ApplyClientID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ApplyClientID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ApplyClientID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ApplyClientID} ApplyClientID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClientID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ApplyClientID message.
         * @function verify
         * @memberof entity.ApplyClientID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ApplyClientID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates an ApplyClientID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ApplyClientID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ApplyClientID} ApplyClientID
         */
        ApplyClientID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ApplyClientID)
                return object;
            var message = new $root.entity.ApplyClientID();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from an ApplyClientID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ApplyClientID
         * @static
         * @param {entity.ApplyClientID} message ApplyClientID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ApplyClientID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this ApplyClientID to JSON.
         * @function toJSON
         * @memberof entity.ApplyClientID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ApplyClientID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ApplyClientID;
    })();

    entity.ApplyClient = (function() {

        /**
         * Properties of an ApplyClient.
         * @memberof entity
         * @interface IApplyClient
         * @property {string|null} [email] ApplyClient email
         * @property {string|null} [phoneNumber] ApplyClient phoneNumber
         * @property {string|null} [companyName] ApplyClient companyName
         * @property {string|null} [webURL] ApplyClient webURL
         * @property {string|null} [accountName] ApplyClient accountName
         * @property {string|null} [accountNameKana] ApplyClient accountNameKana
         * @property {string|null} [position] ApplyClient position
         * @property {entity.ApplyClient.Status|null} [status] ApplyClient status
         * @property {string|null} [createdAt] ApplyClient createdAt
         * @property {string|null} [routeInfo] ApplyClient routeInfo
         */

        /**
         * Constructs a new ApplyClient.
         * @memberof entity
         * @classdesc Represents an ApplyClient.
         * @implements IApplyClient
         * @constructor
         * @param {entity.IApplyClient=} [properties] Properties to set
         */
        function ApplyClient(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ApplyClient email.
         * @member {string} email
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.email = "";

        /**
         * ApplyClient phoneNumber.
         * @member {string} phoneNumber
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.phoneNumber = "";

        /**
         * ApplyClient companyName.
         * @member {string} companyName
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.companyName = "";

        /**
         * ApplyClient webURL.
         * @member {string} webURL
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.webURL = "";

        /**
         * ApplyClient accountName.
         * @member {string} accountName
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.accountName = "";

        /**
         * ApplyClient accountNameKana.
         * @member {string} accountNameKana
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.accountNameKana = "";

        /**
         * ApplyClient position.
         * @member {string} position
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.position = "";

        /**
         * ApplyClient status.
         * @member {entity.ApplyClient.Status} status
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.status = 0;

        /**
         * ApplyClient createdAt.
         * @member {string} createdAt
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.createdAt = "";

        /**
         * ApplyClient routeInfo.
         * @member {string} routeInfo
         * @memberof entity.ApplyClient
         * @instance
         */
        ApplyClient.prototype.routeInfo = "";

        /**
         * Creates a new ApplyClient instance using the specified properties.
         * @function create
         * @memberof entity.ApplyClient
         * @static
         * @param {entity.IApplyClient=} [properties] Properties to set
         * @returns {entity.ApplyClient} ApplyClient instance
         */
        ApplyClient.create = function create(properties) {
            return new ApplyClient(properties);
        };

        /**
         * Encodes the specified ApplyClient message. Does not implicitly {@link entity.ApplyClient.verify|verify} messages.
         * @function encode
         * @memberof entity.ApplyClient
         * @static
         * @param {entity.IApplyClient} message ApplyClient message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClient.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNumber);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyName);
            if (message.webURL != null && Object.hasOwnProperty.call(message, "webURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.webURL);
            if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.accountName);
            if (message.accountNameKana != null && Object.hasOwnProperty.call(message, "accountNameKana"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.accountNameKana);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.position);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.createdAt);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.routeInfo);
            return writer;
        };

        /**
         * Encodes the specified ApplyClient message, length delimited. Does not implicitly {@link entity.ApplyClient.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ApplyClient
         * @static
         * @param {entity.IApplyClient} message ApplyClient message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClient.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ApplyClient message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ApplyClient
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ApplyClient} ApplyClient
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClient.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ApplyClient();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                case 2:
                    message.phoneNumber = reader.string();
                    break;
                case 3:
                    message.companyName = reader.string();
                    break;
                case 4:
                    message.webURL = reader.string();
                    break;
                case 5:
                    message.accountName = reader.string();
                    break;
                case 6:
                    message.accountNameKana = reader.string();
                    break;
                case 7:
                    message.position = reader.string();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.createdAt = reader.string();
                    break;
                case 10:
                    message.routeInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ApplyClient message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ApplyClient
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ApplyClient} ApplyClient
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClient.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ApplyClient message.
         * @function verify
         * @memberof entity.ApplyClient
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ApplyClient.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                if (!$util.isString(message.webURL))
                    return "webURL: string expected";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                if (!$util.isString(message.accountName))
                    return "accountName: string expected";
            if (message.accountNameKana != null && message.hasOwnProperty("accountNameKana"))
                if (!$util.isString(message.accountNameKana))
                    return "accountNameKana: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            return null;
        };

        /**
         * Creates an ApplyClient message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ApplyClient
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ApplyClient} ApplyClient
         */
        ApplyClient.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ApplyClient)
                return object;
            var message = new $root.entity.ApplyClient();
            if (object.email != null)
                message.email = String(object.email);
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.webURL != null)
                message.webURL = String(object.webURL);
            if (object.accountName != null)
                message.accountName = String(object.accountName);
            if (object.accountNameKana != null)
                message.accountNameKana = String(object.accountNameKana);
            if (object.position != null)
                message.position = String(object.position);
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Inspection":
            case 1:
                message.status = 1;
                break;
            case "Status_Denied":
            case 2:
                message.status = 2;
                break;
            case "Status_Accepted":
            case 3:
                message.status = 3;
                break;
            }
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            return message;
        };

        /**
         * Creates a plain object from an ApplyClient message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ApplyClient
         * @static
         * @param {entity.ApplyClient} message ApplyClient
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ApplyClient.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.email = "";
                object.phoneNumber = "";
                object.companyName = "";
                object.webURL = "";
                object.accountName = "";
                object.accountNameKana = "";
                object.position = "";
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.createdAt = "";
                object.routeInfo = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                object.webURL = message.webURL;
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                object.accountName = message.accountName;
            if (message.accountNameKana != null && message.hasOwnProperty("accountNameKana"))
                object.accountNameKana = message.accountNameKana;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.ApplyClient.Status[message.status] : message.status;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            return object;
        };

        /**
         * Converts this ApplyClient to JSON.
         * @function toJSON
         * @memberof entity.ApplyClient
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ApplyClient.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Status enum.
         * @name entity.ApplyClient.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_Inspection=1 Status_Inspection value
         * @property {number} Status_Denied=2 Status_Denied value
         * @property {number} Status_Accepted=3 Status_Accepted value
         */
        ApplyClient.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_Inspection"] = 1;
            values[valuesById[2] = "Status_Denied"] = 2;
            values[valuesById[3] = "Status_Accepted"] = 3;
            return values;
        })();

        /**
         * Source enum.
         * @name entity.ApplyClient.Source
         * @enum {number}
         * @property {number} Source_Unknown=0 Source_Unknown value
         * @property {number} Source_Internal=1 Source_Internal value
         * @property {number} Source_Lafool=2 Source_Lafool value
         * @property {number} Source_LafoolMedical=3 Source_LafoolMedical value
         */
        ApplyClient.Source = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Source_Unknown"] = 0;
            values[valuesById[1] = "Source_Internal"] = 1;
            values[valuesById[2] = "Source_Lafool"] = 2;
            values[valuesById[3] = "Source_LafoolMedical"] = 3;
            return values;
        })();

        return ApplyClient;
    })();

    entity.ApplyClientList = (function() {

        /**
         * Properties of an ApplyClientList.
         * @memberof entity
         * @interface IApplyClientList
         * @property {Array.<entity.IApplyClient>|null} [items] ApplyClientList items
         */

        /**
         * Constructs a new ApplyClientList.
         * @memberof entity
         * @classdesc Represents an ApplyClientList.
         * @implements IApplyClientList
         * @constructor
         * @param {entity.IApplyClientList=} [properties] Properties to set
         */
        function ApplyClientList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ApplyClientList items.
         * @member {Array.<entity.IApplyClient>} items
         * @memberof entity.ApplyClientList
         * @instance
         */
        ApplyClientList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ApplyClientList instance using the specified properties.
         * @function create
         * @memberof entity.ApplyClientList
         * @static
         * @param {entity.IApplyClientList=} [properties] Properties to set
         * @returns {entity.ApplyClientList} ApplyClientList instance
         */
        ApplyClientList.create = function create(properties) {
            return new ApplyClientList(properties);
        };

        /**
         * Encodes the specified ApplyClientList message. Does not implicitly {@link entity.ApplyClientList.verify|verify} messages.
         * @function encode
         * @memberof entity.ApplyClientList
         * @static
         * @param {entity.IApplyClientList} message ApplyClientList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClientList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.ApplyClient.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ApplyClientList message, length delimited. Does not implicitly {@link entity.ApplyClientList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ApplyClientList
         * @static
         * @param {entity.IApplyClientList} message ApplyClientList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplyClientList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ApplyClientList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ApplyClientList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ApplyClientList} ApplyClientList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClientList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ApplyClientList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.ApplyClient.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ApplyClientList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ApplyClientList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ApplyClientList} ApplyClientList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplyClientList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ApplyClientList message.
         * @function verify
         * @memberof entity.ApplyClientList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ApplyClientList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.ApplyClient.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ApplyClientList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ApplyClientList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ApplyClientList} ApplyClientList
         */
        ApplyClientList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ApplyClientList)
                return object;
            var message = new $root.entity.ApplyClientList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ApplyClientList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ApplyClientList.items: object expected");
                    message.items[i] = $root.entity.ApplyClient.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ApplyClientList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ApplyClientList
         * @static
         * @param {entity.ApplyClientList} message ApplyClientList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ApplyClientList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.ApplyClient.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ApplyClientList to JSON.
         * @function toJSON
         * @memberof entity.ApplyClientList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ApplyClientList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ApplyClientList;
    })();

    entity.ClientBookmark = (function() {

        /**
         * Properties of a ClientBookmark.
         * @memberof entity
         * @interface IClientBookmark
         * @property {string|null} [clientID] ClientBookmark clientID
         * @property {string|null} [customerID] ClientBookmark customerID
         * @property {string|null} [createdAt] ClientBookmark createdAt
         */

        /**
         * Constructs a new ClientBookmark.
         * @memberof entity
         * @classdesc Represents a ClientBookmark.
         * @implements IClientBookmark
         * @constructor
         * @param {entity.IClientBookmark=} [properties] Properties to set
         */
        function ClientBookmark(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientBookmark clientID.
         * @member {string} clientID
         * @memberof entity.ClientBookmark
         * @instance
         */
        ClientBookmark.prototype.clientID = "";

        /**
         * ClientBookmark customerID.
         * @member {string} customerID
         * @memberof entity.ClientBookmark
         * @instance
         */
        ClientBookmark.prototype.customerID = "";

        /**
         * ClientBookmark createdAt.
         * @member {string} createdAt
         * @memberof entity.ClientBookmark
         * @instance
         */
        ClientBookmark.prototype.createdAt = "";

        /**
         * Creates a new ClientBookmark instance using the specified properties.
         * @function create
         * @memberof entity.ClientBookmark
         * @static
         * @param {entity.IClientBookmark=} [properties] Properties to set
         * @returns {entity.ClientBookmark} ClientBookmark instance
         */
        ClientBookmark.create = function create(properties) {
            return new ClientBookmark(properties);
        };

        /**
         * Encodes the specified ClientBookmark message. Does not implicitly {@link entity.ClientBookmark.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientBookmark
         * @static
         * @param {entity.IClientBookmark} message ClientBookmark message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBookmark.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.clientID != null && Object.hasOwnProperty.call(message, "clientID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified ClientBookmark message, length delimited. Does not implicitly {@link entity.ClientBookmark.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientBookmark
         * @static
         * @param {entity.IClientBookmark} message ClientBookmark message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBookmark.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientBookmark message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientBookmark
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientBookmark} ClientBookmark
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBookmark.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientBookmark();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.clientID = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientBookmark message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientBookmark
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientBookmark} ClientBookmark
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBookmark.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientBookmark message.
         * @function verify
         * @memberof entity.ClientBookmark
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientBookmark.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                if (!$util.isString(message.clientID))
                    return "clientID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a ClientBookmark message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientBookmark
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientBookmark} ClientBookmark
         */
        ClientBookmark.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientBookmark)
                return object;
            var message = new $root.entity.ClientBookmark();
            if (object.clientID != null)
                message.clientID = String(object.clientID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a ClientBookmark message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientBookmark
         * @static
         * @param {entity.ClientBookmark} message ClientBookmark
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientBookmark.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.clientID = "";
                object.customerID = "";
                object.createdAt = "";
            }
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                object.clientID = message.clientID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this ClientBookmark to JSON.
         * @function toJSON
         * @memberof entity.ClientBookmark
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientBookmark.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientBookmark;
    })();

    entity.ClientBookmarkList = (function() {

        /**
         * Properties of a ClientBookmarkList.
         * @memberof entity
         * @interface IClientBookmarkList
         * @property {Array.<entity.IClientBookmark>|null} [items] ClientBookmarkList items
         */

        /**
         * Constructs a new ClientBookmarkList.
         * @memberof entity
         * @classdesc Represents a ClientBookmarkList.
         * @implements IClientBookmarkList
         * @constructor
         * @param {entity.IClientBookmarkList=} [properties] Properties to set
         */
        function ClientBookmarkList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientBookmarkList items.
         * @member {Array.<entity.IClientBookmark>} items
         * @memberof entity.ClientBookmarkList
         * @instance
         */
        ClientBookmarkList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ClientBookmarkList instance using the specified properties.
         * @function create
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {entity.IClientBookmarkList=} [properties] Properties to set
         * @returns {entity.ClientBookmarkList} ClientBookmarkList instance
         */
        ClientBookmarkList.create = function create(properties) {
            return new ClientBookmarkList(properties);
        };

        /**
         * Encodes the specified ClientBookmarkList message. Does not implicitly {@link entity.ClientBookmarkList.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {entity.IClientBookmarkList} message ClientBookmarkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBookmarkList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.ClientBookmark.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientBookmarkList message, length delimited. Does not implicitly {@link entity.ClientBookmarkList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {entity.IClientBookmarkList} message ClientBookmarkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBookmarkList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientBookmarkList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientBookmarkList} ClientBookmarkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBookmarkList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientBookmarkList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.ClientBookmark.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientBookmarkList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientBookmarkList} ClientBookmarkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBookmarkList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientBookmarkList message.
         * @function verify
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientBookmarkList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.ClientBookmark.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ClientBookmarkList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientBookmarkList} ClientBookmarkList
         */
        ClientBookmarkList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientBookmarkList)
                return object;
            var message = new $root.entity.ClientBookmarkList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ClientBookmarkList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ClientBookmarkList.items: object expected");
                    message.items[i] = $root.entity.ClientBookmark.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientBookmarkList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientBookmarkList
         * @static
         * @param {entity.ClientBookmarkList} message ClientBookmarkList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientBookmarkList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.ClientBookmark.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ClientBookmarkList to JSON.
         * @function toJSON
         * @memberof entity.ClientBookmarkList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientBookmarkList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientBookmarkList;
    })();

    entity.ClientBrowsingHistory = (function() {

        /**
         * Properties of a ClientBrowsingHistory.
         * @memberof entity
         * @interface IClientBrowsingHistory
         * @property {string|null} [clientID] ClientBrowsingHistory clientID
         * @property {string|null} [customerID] ClientBrowsingHistory customerID
         * @property {string|null} [createdAt] ClientBrowsingHistory createdAt
         */

        /**
         * Constructs a new ClientBrowsingHistory.
         * @memberof entity
         * @classdesc Represents a ClientBrowsingHistory.
         * @implements IClientBrowsingHistory
         * @constructor
         * @param {entity.IClientBrowsingHistory=} [properties] Properties to set
         */
        function ClientBrowsingHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientBrowsingHistory clientID.
         * @member {string} clientID
         * @memberof entity.ClientBrowsingHistory
         * @instance
         */
        ClientBrowsingHistory.prototype.clientID = "";

        /**
         * ClientBrowsingHistory customerID.
         * @member {string} customerID
         * @memberof entity.ClientBrowsingHistory
         * @instance
         */
        ClientBrowsingHistory.prototype.customerID = "";

        /**
         * ClientBrowsingHistory createdAt.
         * @member {string} createdAt
         * @memberof entity.ClientBrowsingHistory
         * @instance
         */
        ClientBrowsingHistory.prototype.createdAt = "";

        /**
         * Creates a new ClientBrowsingHistory instance using the specified properties.
         * @function create
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {entity.IClientBrowsingHistory=} [properties] Properties to set
         * @returns {entity.ClientBrowsingHistory} ClientBrowsingHistory instance
         */
        ClientBrowsingHistory.create = function create(properties) {
            return new ClientBrowsingHistory(properties);
        };

        /**
         * Encodes the specified ClientBrowsingHistory message. Does not implicitly {@link entity.ClientBrowsingHistory.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {entity.IClientBrowsingHistory} message ClientBrowsingHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBrowsingHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.clientID != null && Object.hasOwnProperty.call(message, "clientID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified ClientBrowsingHistory message, length delimited. Does not implicitly {@link entity.ClientBrowsingHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {entity.IClientBrowsingHistory} message ClientBrowsingHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBrowsingHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientBrowsingHistory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientBrowsingHistory} ClientBrowsingHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBrowsingHistory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientBrowsingHistory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.clientID = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientBrowsingHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientBrowsingHistory} ClientBrowsingHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBrowsingHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientBrowsingHistory message.
         * @function verify
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientBrowsingHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                if (!$util.isString(message.clientID))
                    return "clientID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a ClientBrowsingHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientBrowsingHistory} ClientBrowsingHistory
         */
        ClientBrowsingHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientBrowsingHistory)
                return object;
            var message = new $root.entity.ClientBrowsingHistory();
            if (object.clientID != null)
                message.clientID = String(object.clientID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a ClientBrowsingHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientBrowsingHistory
         * @static
         * @param {entity.ClientBrowsingHistory} message ClientBrowsingHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientBrowsingHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.clientID = "";
                object.customerID = "";
                object.createdAt = "";
            }
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                object.clientID = message.clientID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this ClientBrowsingHistory to JSON.
         * @function toJSON
         * @memberof entity.ClientBrowsingHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientBrowsingHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientBrowsingHistory;
    })();

    entity.ClientBrowsingHistoryList = (function() {

        /**
         * Properties of a ClientBrowsingHistoryList.
         * @memberof entity
         * @interface IClientBrowsingHistoryList
         * @property {Array.<entity.IClientBrowsingHistory>|null} [items] ClientBrowsingHistoryList items
         */

        /**
         * Constructs a new ClientBrowsingHistoryList.
         * @memberof entity
         * @classdesc Represents a ClientBrowsingHistoryList.
         * @implements IClientBrowsingHistoryList
         * @constructor
         * @param {entity.IClientBrowsingHistoryList=} [properties] Properties to set
         */
        function ClientBrowsingHistoryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientBrowsingHistoryList items.
         * @member {Array.<entity.IClientBrowsingHistory>} items
         * @memberof entity.ClientBrowsingHistoryList
         * @instance
         */
        ClientBrowsingHistoryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ClientBrowsingHistoryList instance using the specified properties.
         * @function create
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {entity.IClientBrowsingHistoryList=} [properties] Properties to set
         * @returns {entity.ClientBrowsingHistoryList} ClientBrowsingHistoryList instance
         */
        ClientBrowsingHistoryList.create = function create(properties) {
            return new ClientBrowsingHistoryList(properties);
        };

        /**
         * Encodes the specified ClientBrowsingHistoryList message. Does not implicitly {@link entity.ClientBrowsingHistoryList.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {entity.IClientBrowsingHistoryList} message ClientBrowsingHistoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBrowsingHistoryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.ClientBrowsingHistory.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientBrowsingHistoryList message, length delimited. Does not implicitly {@link entity.ClientBrowsingHistoryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {entity.IClientBrowsingHistoryList} message ClientBrowsingHistoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientBrowsingHistoryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientBrowsingHistoryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientBrowsingHistoryList} ClientBrowsingHistoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBrowsingHistoryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientBrowsingHistoryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.ClientBrowsingHistory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientBrowsingHistoryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientBrowsingHistoryList} ClientBrowsingHistoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientBrowsingHistoryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientBrowsingHistoryList message.
         * @function verify
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientBrowsingHistoryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.ClientBrowsingHistory.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ClientBrowsingHistoryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientBrowsingHistoryList} ClientBrowsingHistoryList
         */
        ClientBrowsingHistoryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientBrowsingHistoryList)
                return object;
            var message = new $root.entity.ClientBrowsingHistoryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ClientBrowsingHistoryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ClientBrowsingHistoryList.items: object expected");
                    message.items[i] = $root.entity.ClientBrowsingHistory.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientBrowsingHistoryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientBrowsingHistoryList
         * @static
         * @param {entity.ClientBrowsingHistoryList} message ClientBrowsingHistoryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientBrowsingHistoryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.ClientBrowsingHistory.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ClientBrowsingHistoryList to JSON.
         * @function toJSON
         * @memberof entity.ClientBrowsingHistoryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientBrowsingHistoryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientBrowsingHistoryList;
    })();

    entity.ClientID = (function() {

        /**
         * Properties of a ClientID.
         * @memberof entity
         * @interface IClientID
         * @property {string|null} [id] ClientID id
         */

        /**
         * Constructs a new ClientID.
         * @memberof entity
         * @classdesc Represents a ClientID.
         * @implements IClientID
         * @constructor
         * @param {entity.IClientID=} [properties] Properties to set
         */
        function ClientID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientID id.
         * @member {string} id
         * @memberof entity.ClientID
         * @instance
         */
        ClientID.prototype.id = "";

        /**
         * Creates a new ClientID instance using the specified properties.
         * @function create
         * @memberof entity.ClientID
         * @static
         * @param {entity.IClientID=} [properties] Properties to set
         * @returns {entity.ClientID} ClientID instance
         */
        ClientID.create = function create(properties) {
            return new ClientID(properties);
        };

        /**
         * Encodes the specified ClientID message. Does not implicitly {@link entity.ClientID.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientID
         * @static
         * @param {entity.IClientID} message ClientID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ClientID message, length delimited. Does not implicitly {@link entity.ClientID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientID
         * @static
         * @param {entity.IClientID} message ClientID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientID} ClientID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientID} ClientID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientID message.
         * @function verify
         * @memberof entity.ClientID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ClientID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientID} ClientID
         */
        ClientID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientID)
                return object;
            var message = new $root.entity.ClientID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ClientID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientID
         * @static
         * @param {entity.ClientID} message ClientID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ClientID to JSON.
         * @function toJSON
         * @memberof entity.ClientID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientID;
    })();

    entity.ClientIDList = (function() {

        /**
         * Properties of a ClientIDList.
         * @memberof entity
         * @interface IClientIDList
         * @property {Array.<string>|null} [ids] ClientIDList ids
         */

        /**
         * Constructs a new ClientIDList.
         * @memberof entity
         * @classdesc Represents a ClientIDList.
         * @implements IClientIDList
         * @constructor
         * @param {entity.IClientIDList=} [properties] Properties to set
         */
        function ClientIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.ClientIDList
         * @instance
         */
        ClientIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new ClientIDList instance using the specified properties.
         * @function create
         * @memberof entity.ClientIDList
         * @static
         * @param {entity.IClientIDList=} [properties] Properties to set
         * @returns {entity.ClientIDList} ClientIDList instance
         */
        ClientIDList.create = function create(properties) {
            return new ClientIDList(properties);
        };

        /**
         * Encodes the specified ClientIDList message. Does not implicitly {@link entity.ClientIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientIDList
         * @static
         * @param {entity.IClientIDList} message ClientIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified ClientIDList message, length delimited. Does not implicitly {@link entity.ClientIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientIDList
         * @static
         * @param {entity.IClientIDList} message ClientIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientIDList} ClientIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientIDList} ClientIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientIDList message.
         * @function verify
         * @memberof entity.ClientIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ClientIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientIDList} ClientIDList
         */
        ClientIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientIDList)
                return object;
            var message = new $root.entity.ClientIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.ClientIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientIDList
         * @static
         * @param {entity.ClientIDList} message ClientIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this ClientIDList to JSON.
         * @function toJSON
         * @memberof entity.ClientIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientIDList;
    })();

    entity.Client = (function() {

        /**
         * Properties of a Client.
         * @memberof entity
         * @interface IClient
         * @property {string|null} [id] Client id
         * @property {string|null} [companyID] Client companyID
         * @property {string|null} [name] Client name
         * @property {string|null} [nameKana] Client nameKana
         * @property {string|null} [gsIconURL] Client gsIconURL
         * @property {string|null} [signedIconURL] Client signedIconURL
         * @property {string|null} [phoneNumber] Client phoneNumber
         * @property {string|null} [position] Client position
         * @property {string|null} [email] Client email
         * @property {string|null} [createdAt] Client createdAt
         * @property {entity.Client.Role|null} [role] Client role
         * @property {string|null} [department] Client department
         * @property {string|null} [companyName] Client companyName
         */

        /**
         * Constructs a new Client.
         * @memberof entity
         * @classdesc Represents a Client.
         * @implements IClient
         * @constructor
         * @param {entity.IClient=} [properties] Properties to set
         */
        function Client(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Client id.
         * @member {string} id
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.id = "";

        /**
         * Client companyID.
         * @member {string} companyID
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.companyID = "";

        /**
         * Client name.
         * @member {string} name
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.name = "";

        /**
         * Client nameKana.
         * @member {string} nameKana
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.nameKana = "";

        /**
         * Client gsIconURL.
         * @member {string} gsIconURL
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.gsIconURL = "";

        /**
         * Client signedIconURL.
         * @member {string} signedIconURL
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.signedIconURL = "";

        /**
         * Client phoneNumber.
         * @member {string} phoneNumber
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.phoneNumber = "";

        /**
         * Client position.
         * @member {string} position
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.position = "";

        /**
         * Client email.
         * @member {string} email
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.email = "";

        /**
         * Client createdAt.
         * @member {string} createdAt
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.createdAt = "";

        /**
         * Client role.
         * @member {entity.Client.Role} role
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.role = 0;

        /**
         * Client department.
         * @member {string} department
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.department = "";

        /**
         * Client companyName.
         * @member {string} companyName
         * @memberof entity.Client
         * @instance
         */
        Client.prototype.companyName = "";

        /**
         * Creates a new Client instance using the specified properties.
         * @function create
         * @memberof entity.Client
         * @static
         * @param {entity.IClient=} [properties] Properties to set
         * @returns {entity.Client} Client instance
         */
        Client.create = function create(properties) {
            return new Client(properties);
        };

        /**
         * Encodes the specified Client message. Does not implicitly {@link entity.Client.verify|verify} messages.
         * @function encode
         * @memberof entity.Client
         * @static
         * @param {entity.IClient} message Client message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Client.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyID);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nameKana);
            if (message.gsIconURL != null && Object.hasOwnProperty.call(message, "gsIconURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.gsIconURL);
            if (message.signedIconURL != null && Object.hasOwnProperty.call(message, "signedIconURL"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.signedIconURL);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.phoneNumber);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.position);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.email);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.createdAt);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.role);
            if (message.department != null && Object.hasOwnProperty.call(message, "department"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.department);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.companyName);
            return writer;
        };

        /**
         * Encodes the specified Client message, length delimited. Does not implicitly {@link entity.Client.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Client
         * @static
         * @param {entity.IClient} message Client message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Client.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Client message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Client
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Client} Client
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Client.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Client();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyID = reader.string();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                case 4:
                    message.nameKana = reader.string();
                    break;
                case 5:
                    message.gsIconURL = reader.string();
                    break;
                case 6:
                    message.signedIconURL = reader.string();
                    break;
                case 7:
                    message.phoneNumber = reader.string();
                    break;
                case 8:
                    message.position = reader.string();
                    break;
                case 9:
                    message.email = reader.string();
                    break;
                case 10:
                    message.createdAt = reader.string();
                    break;
                case 11:
                    message.role = reader.int32();
                    break;
                case 12:
                    message.department = reader.string();
                    break;
                case 13:
                    message.companyName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Client message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Client
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Client} Client
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Client.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Client message.
         * @function verify
         * @memberof entity.Client
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Client.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                if (!$util.isString(message.gsIconURL))
                    return "gsIconURL: string expected";
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                if (!$util.isString(message.signedIconURL))
                    return "signedIconURL: string expected";
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.department != null && message.hasOwnProperty("department"))
                if (!$util.isString(message.department))
                    return "department: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            return null;
        };

        /**
         * Creates a Client message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Client
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Client} Client
         */
        Client.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Client)
                return object;
            var message = new $root.entity.Client();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            if (object.gsIconURL != null)
                message.gsIconURL = String(object.gsIconURL);
            if (object.signedIconURL != null)
                message.signedIconURL = String(object.signedIconURL);
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.position != null)
                message.position = String(object.position);
            if (object.email != null)
                message.email = String(object.email);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            switch (object.role) {
            case "Role_Unknown":
            case 0:
                message.role = 0;
                break;
            case "Role_Admin":
            case 1:
                message.role = 1;
                break;
            case "Role_Member":
            case 2:
                message.role = 2;
                break;
            }
            if (object.department != null)
                message.department = String(object.department);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            return message;
        };

        /**
         * Creates a plain object from a Client message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Client
         * @static
         * @param {entity.Client} message Client
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Client.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.companyID = "";
                object.name = "";
                object.nameKana = "";
                object.gsIconURL = "";
                object.signedIconURL = "";
                object.phoneNumber = "";
                object.position = "";
                object.email = "";
                object.createdAt = "";
                object.role = options.enums === String ? "Role_Unknown" : 0;
                object.department = "";
                object.companyName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                object.gsIconURL = message.gsIconURL;
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                object.signedIconURL = message.signedIconURL;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.entity.Client.Role[message.role] : message.role;
            if (message.department != null && message.hasOwnProperty("department"))
                object.department = message.department;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            return object;
        };

        /**
         * Converts this Client to JSON.
         * @function toJSON
         * @memberof entity.Client
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Client.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Role enum.
         * @name entity.Client.Role
         * @enum {number}
         * @property {number} Role_Unknown=0 Role_Unknown value
         * @property {number} Role_Admin=1 Role_Admin value
         * @property {number} Role_Member=2 Role_Member value
         */
        Client.Role = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Role_Unknown"] = 0;
            values[valuesById[1] = "Role_Admin"] = 1;
            values[valuesById[2] = "Role_Member"] = 2;
            return values;
        })();

        return Client;
    })();

    entity.ClientList = (function() {

        /**
         * Properties of a ClientList.
         * @memberof entity
         * @interface IClientList
         * @property {Array.<entity.IClient>|null} [items] ClientList items
         */

        /**
         * Constructs a new ClientList.
         * @memberof entity
         * @classdesc Represents a ClientList.
         * @implements IClientList
         * @constructor
         * @param {entity.IClientList=} [properties] Properties to set
         */
        function ClientList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientList items.
         * @member {Array.<entity.IClient>} items
         * @memberof entity.ClientList
         * @instance
         */
        ClientList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ClientList instance using the specified properties.
         * @function create
         * @memberof entity.ClientList
         * @static
         * @param {entity.IClientList=} [properties] Properties to set
         * @returns {entity.ClientList} ClientList instance
         */
        ClientList.create = function create(properties) {
            return new ClientList(properties);
        };

        /**
         * Encodes the specified ClientList message. Does not implicitly {@link entity.ClientList.verify|verify} messages.
         * @function encode
         * @memberof entity.ClientList
         * @static
         * @param {entity.IClientList} message ClientList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Client.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientList message, length delimited. Does not implicitly {@link entity.ClientList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ClientList
         * @static
         * @param {entity.IClientList} message ClientList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ClientList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ClientList} ClientList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ClientList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Client.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ClientList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ClientList} ClientList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientList message.
         * @function verify
         * @memberof entity.ClientList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Client.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ClientList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ClientList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ClientList} ClientList
         */
        ClientList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ClientList)
                return object;
            var message = new $root.entity.ClientList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ClientList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ClientList.items: object expected");
                    message.items[i] = $root.entity.Client.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ClientList
         * @static
         * @param {entity.ClientList} message ClientList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Client.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ClientList to JSON.
         * @function toJSON
         * @memberof entity.ClientList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientList;
    })();

    entity.CompanyInvoiceEmail = (function() {

        /**
         * Properties of a CompanyInvoiceEmail.
         * @memberof entity
         * @interface ICompanyInvoiceEmail
         * @property {string|null} [id] CompanyInvoiceEmail id
         * @property {string|null} [companyID] CompanyInvoiceEmail companyID
         * @property {entity.CompanyInvoiceEmail.SendType|null} [sendType] CompanyInvoiceEmail sendType
         * @property {string|null} [clientID] CompanyInvoiceEmail clientID
         * @property {string|null} [clientName] CompanyInvoiceEmail clientName
         * @property {string|null} [clientEmail] CompanyInvoiceEmail clientEmail
         * @property {string|null} [externalName] CompanyInvoiceEmail externalName
         * @property {string|null} [externalEmail] CompanyInvoiceEmail externalEmail
         * @property {string|null} [projectID] CompanyInvoiceEmail projectID
         * @property {string|null} [createdAt] CompanyInvoiceEmail createdAt
         */

        /**
         * Constructs a new CompanyInvoiceEmail.
         * @memberof entity
         * @classdesc Represents a CompanyInvoiceEmail.
         * @implements ICompanyInvoiceEmail
         * @constructor
         * @param {entity.ICompanyInvoiceEmail=} [properties] Properties to set
         */
        function CompanyInvoiceEmail(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyInvoiceEmail id.
         * @member {string} id
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.id = "";

        /**
         * CompanyInvoiceEmail companyID.
         * @member {string} companyID
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.companyID = "";

        /**
         * CompanyInvoiceEmail sendType.
         * @member {entity.CompanyInvoiceEmail.SendType} sendType
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.sendType = 0;

        /**
         * CompanyInvoiceEmail clientID.
         * @member {string} clientID
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.clientID = "";

        /**
         * CompanyInvoiceEmail clientName.
         * @member {string} clientName
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.clientName = "";

        /**
         * CompanyInvoiceEmail clientEmail.
         * @member {string} clientEmail
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.clientEmail = "";

        /**
         * CompanyInvoiceEmail externalName.
         * @member {string} externalName
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.externalName = "";

        /**
         * CompanyInvoiceEmail externalEmail.
         * @member {string} externalEmail
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.externalEmail = "";

        /**
         * CompanyInvoiceEmail projectID.
         * @member {string} projectID
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.projectID = "";

        /**
         * CompanyInvoiceEmail createdAt.
         * @member {string} createdAt
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         */
        CompanyInvoiceEmail.prototype.createdAt = "";

        /**
         * Creates a new CompanyInvoiceEmail instance using the specified properties.
         * @function create
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {entity.ICompanyInvoiceEmail=} [properties] Properties to set
         * @returns {entity.CompanyInvoiceEmail} CompanyInvoiceEmail instance
         */
        CompanyInvoiceEmail.create = function create(properties) {
            return new CompanyInvoiceEmail(properties);
        };

        /**
         * Encodes the specified CompanyInvoiceEmail message. Does not implicitly {@link entity.CompanyInvoiceEmail.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {entity.ICompanyInvoiceEmail} message CompanyInvoiceEmail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyInvoiceEmail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyID);
            if (message.sendType != null && Object.hasOwnProperty.call(message, "sendType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sendType);
            if (message.clientID != null && Object.hasOwnProperty.call(message, "clientID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientID);
            if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clientName);
            if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.clientEmail);
            if (message.externalName != null && Object.hasOwnProperty.call(message, "externalName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.externalName);
            if (message.externalEmail != null && Object.hasOwnProperty.call(message, "externalEmail"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.externalEmail);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.projectID);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified CompanyInvoiceEmail message, length delimited. Does not implicitly {@link entity.CompanyInvoiceEmail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {entity.ICompanyInvoiceEmail} message CompanyInvoiceEmail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyInvoiceEmail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyInvoiceEmail message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyInvoiceEmail} CompanyInvoiceEmail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyInvoiceEmail.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyInvoiceEmail();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyID = reader.string();
                    break;
                case 3:
                    message.sendType = reader.int32();
                    break;
                case 4:
                    message.clientID = reader.string();
                    break;
                case 5:
                    message.clientName = reader.string();
                    break;
                case 6:
                    message.clientEmail = reader.string();
                    break;
                case 7:
                    message.externalName = reader.string();
                    break;
                case 8:
                    message.externalEmail = reader.string();
                    break;
                case 10:
                    message.projectID = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyInvoiceEmail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyInvoiceEmail} CompanyInvoiceEmail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyInvoiceEmail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyInvoiceEmail message.
         * @function verify
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyInvoiceEmail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.sendType != null && message.hasOwnProperty("sendType"))
                switch (message.sendType) {
                default:
                    return "sendType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                if (!$util.isString(message.clientID))
                    return "clientID: string expected";
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                if (!$util.isString(message.clientName))
                    return "clientName: string expected";
            if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                if (!$util.isString(message.clientEmail))
                    return "clientEmail: string expected";
            if (message.externalName != null && message.hasOwnProperty("externalName"))
                if (!$util.isString(message.externalName))
                    return "externalName: string expected";
            if (message.externalEmail != null && message.hasOwnProperty("externalEmail"))
                if (!$util.isString(message.externalEmail))
                    return "externalEmail: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a CompanyInvoiceEmail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyInvoiceEmail} CompanyInvoiceEmail
         */
        CompanyInvoiceEmail.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyInvoiceEmail)
                return object;
            var message = new $root.entity.CompanyInvoiceEmail();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            switch (object.sendType) {
            case "SendType_Unknown":
            case 0:
                message.sendType = 0;
                break;
            case "SendType_To":
            case 1:
                message.sendType = 1;
                break;
            case "SendType_Cc":
            case 2:
                message.sendType = 2;
                break;
            }
            if (object.clientID != null)
                message.clientID = String(object.clientID);
            if (object.clientName != null)
                message.clientName = String(object.clientName);
            if (object.clientEmail != null)
                message.clientEmail = String(object.clientEmail);
            if (object.externalName != null)
                message.externalName = String(object.externalName);
            if (object.externalEmail != null)
                message.externalEmail = String(object.externalEmail);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a CompanyInvoiceEmail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyInvoiceEmail
         * @static
         * @param {entity.CompanyInvoiceEmail} message CompanyInvoiceEmail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyInvoiceEmail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.companyID = "";
                object.sendType = options.enums === String ? "SendType_Unknown" : 0;
                object.clientID = "";
                object.clientName = "";
                object.clientEmail = "";
                object.externalName = "";
                object.externalEmail = "";
                object.projectID = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.sendType != null && message.hasOwnProperty("sendType"))
                object.sendType = options.enums === String ? $root.entity.CompanyInvoiceEmail.SendType[message.sendType] : message.sendType;
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                object.clientID = message.clientID;
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                object.clientName = message.clientName;
            if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                object.clientEmail = message.clientEmail;
            if (message.externalName != null && message.hasOwnProperty("externalName"))
                object.externalName = message.externalName;
            if (message.externalEmail != null && message.hasOwnProperty("externalEmail"))
                object.externalEmail = message.externalEmail;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this CompanyInvoiceEmail to JSON.
         * @function toJSON
         * @memberof entity.CompanyInvoiceEmail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyInvoiceEmail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * SendType enum.
         * @name entity.CompanyInvoiceEmail.SendType
         * @enum {number}
         * @property {number} SendType_Unknown=0 SendType_Unknown value
         * @property {number} SendType_To=1 SendType_To value
         * @property {number} SendType_Cc=2 SendType_Cc value
         */
        CompanyInvoiceEmail.SendType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SendType_Unknown"] = 0;
            values[valuesById[1] = "SendType_To"] = 1;
            values[valuesById[2] = "SendType_Cc"] = 2;
            return values;
        })();

        return CompanyInvoiceEmail;
    })();

    entity.CompanyInvoiceEmailList = (function() {

        /**
         * Properties of a CompanyInvoiceEmailList.
         * @memberof entity
         * @interface ICompanyInvoiceEmailList
         * @property {Array.<entity.ICompanyInvoiceEmail>|null} [items] CompanyInvoiceEmailList items
         */

        /**
         * Constructs a new CompanyInvoiceEmailList.
         * @memberof entity
         * @classdesc Represents a CompanyInvoiceEmailList.
         * @implements ICompanyInvoiceEmailList
         * @constructor
         * @param {entity.ICompanyInvoiceEmailList=} [properties] Properties to set
         */
        function CompanyInvoiceEmailList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyInvoiceEmailList items.
         * @member {Array.<entity.ICompanyInvoiceEmail>} items
         * @memberof entity.CompanyInvoiceEmailList
         * @instance
         */
        CompanyInvoiceEmailList.prototype.items = $util.emptyArray;

        /**
         * Creates a new CompanyInvoiceEmailList instance using the specified properties.
         * @function create
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {entity.ICompanyInvoiceEmailList=} [properties] Properties to set
         * @returns {entity.CompanyInvoiceEmailList} CompanyInvoiceEmailList instance
         */
        CompanyInvoiceEmailList.create = function create(properties) {
            return new CompanyInvoiceEmailList(properties);
        };

        /**
         * Encodes the specified CompanyInvoiceEmailList message. Does not implicitly {@link entity.CompanyInvoiceEmailList.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {entity.ICompanyInvoiceEmailList} message CompanyInvoiceEmailList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyInvoiceEmailList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.CompanyInvoiceEmail.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompanyInvoiceEmailList message, length delimited. Does not implicitly {@link entity.CompanyInvoiceEmailList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {entity.ICompanyInvoiceEmailList} message CompanyInvoiceEmailList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyInvoiceEmailList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyInvoiceEmailList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyInvoiceEmailList} CompanyInvoiceEmailList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyInvoiceEmailList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyInvoiceEmailList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.CompanyInvoiceEmail.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyInvoiceEmailList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyInvoiceEmailList} CompanyInvoiceEmailList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyInvoiceEmailList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyInvoiceEmailList message.
         * @function verify
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyInvoiceEmailList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.CompanyInvoiceEmail.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompanyInvoiceEmailList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyInvoiceEmailList} CompanyInvoiceEmailList
         */
        CompanyInvoiceEmailList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyInvoiceEmailList)
                return object;
            var message = new $root.entity.CompanyInvoiceEmailList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.CompanyInvoiceEmailList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.CompanyInvoiceEmailList.items: object expected");
                    message.items[i] = $root.entity.CompanyInvoiceEmail.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyInvoiceEmailList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyInvoiceEmailList
         * @static
         * @param {entity.CompanyInvoiceEmailList} message CompanyInvoiceEmailList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyInvoiceEmailList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.CompanyInvoiceEmail.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CompanyInvoiceEmailList to JSON.
         * @function toJSON
         * @memberof entity.CompanyInvoiceEmailList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyInvoiceEmailList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyInvoiceEmailList;
    })();

    entity.CompanyID = (function() {

        /**
         * Properties of a CompanyID.
         * @memberof entity
         * @interface ICompanyID
         * @property {string|null} [id] CompanyID id
         */

        /**
         * Constructs a new CompanyID.
         * @memberof entity
         * @classdesc Represents a CompanyID.
         * @implements ICompanyID
         * @constructor
         * @param {entity.ICompanyID=} [properties] Properties to set
         */
        function CompanyID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyID id.
         * @member {string} id
         * @memberof entity.CompanyID
         * @instance
         */
        CompanyID.prototype.id = "";

        /**
         * Creates a new CompanyID instance using the specified properties.
         * @function create
         * @memberof entity.CompanyID
         * @static
         * @param {entity.ICompanyID=} [properties] Properties to set
         * @returns {entity.CompanyID} CompanyID instance
         */
        CompanyID.create = function create(properties) {
            return new CompanyID(properties);
        };

        /**
         * Encodes the specified CompanyID message. Does not implicitly {@link entity.CompanyID.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyID
         * @static
         * @param {entity.ICompanyID} message CompanyID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified CompanyID message, length delimited. Does not implicitly {@link entity.CompanyID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyID
         * @static
         * @param {entity.ICompanyID} message CompanyID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyID} CompanyID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyID} CompanyID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyID message.
         * @function verify
         * @memberof entity.CompanyID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a CompanyID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyID} CompanyID
         */
        CompanyID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyID)
                return object;
            var message = new $root.entity.CompanyID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a CompanyID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyID
         * @static
         * @param {entity.CompanyID} message CompanyID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this CompanyID to JSON.
         * @function toJSON
         * @memberof entity.CompanyID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyID;
    })();

    entity.CompanyIDList = (function() {

        /**
         * Properties of a CompanyIDList.
         * @memberof entity
         * @interface ICompanyIDList
         * @property {Array.<string>|null} [ids] CompanyIDList ids
         */

        /**
         * Constructs a new CompanyIDList.
         * @memberof entity
         * @classdesc Represents a CompanyIDList.
         * @implements ICompanyIDList
         * @constructor
         * @param {entity.ICompanyIDList=} [properties] Properties to set
         */
        function CompanyIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.CompanyIDList
         * @instance
         */
        CompanyIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new CompanyIDList instance using the specified properties.
         * @function create
         * @memberof entity.CompanyIDList
         * @static
         * @param {entity.ICompanyIDList=} [properties] Properties to set
         * @returns {entity.CompanyIDList} CompanyIDList instance
         */
        CompanyIDList.create = function create(properties) {
            return new CompanyIDList(properties);
        };

        /**
         * Encodes the specified CompanyIDList message. Does not implicitly {@link entity.CompanyIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyIDList
         * @static
         * @param {entity.ICompanyIDList} message CompanyIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified CompanyIDList message, length delimited. Does not implicitly {@link entity.CompanyIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyIDList
         * @static
         * @param {entity.ICompanyIDList} message CompanyIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyIDList} CompanyIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyIDList} CompanyIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyIDList message.
         * @function verify
         * @memberof entity.CompanyIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a CompanyIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyIDList} CompanyIDList
         */
        CompanyIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyIDList)
                return object;
            var message = new $root.entity.CompanyIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.CompanyIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyIDList
         * @static
         * @param {entity.CompanyIDList} message CompanyIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this CompanyIDList to JSON.
         * @function toJSON
         * @memberof entity.CompanyIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyIDList;
    })();

    entity.CompanyIDWithPager = (function() {

        /**
         * Properties of a CompanyIDWithPager.
         * @memberof entity
         * @interface ICompanyIDWithPager
         * @property {string|null} [id] CompanyIDWithPager id
         * @property {common.IPager|null} [pager] CompanyIDWithPager pager
         */

        /**
         * Constructs a new CompanyIDWithPager.
         * @memberof entity
         * @classdesc Represents a CompanyIDWithPager.
         * @implements ICompanyIDWithPager
         * @constructor
         * @param {entity.ICompanyIDWithPager=} [properties] Properties to set
         */
        function CompanyIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyIDWithPager id.
         * @member {string} id
         * @memberof entity.CompanyIDWithPager
         * @instance
         */
        CompanyIDWithPager.prototype.id = "";

        /**
         * CompanyIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.CompanyIDWithPager
         * @instance
         */
        CompanyIDWithPager.prototype.pager = null;

        /**
         * Creates a new CompanyIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {entity.ICompanyIDWithPager=} [properties] Properties to set
         * @returns {entity.CompanyIDWithPager} CompanyIDWithPager instance
         */
        CompanyIDWithPager.create = function create(properties) {
            return new CompanyIDWithPager(properties);
        };

        /**
         * Encodes the specified CompanyIDWithPager message. Does not implicitly {@link entity.CompanyIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {entity.ICompanyIDWithPager} message CompanyIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompanyIDWithPager message, length delimited. Does not implicitly {@link entity.CompanyIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {entity.ICompanyIDWithPager} message CompanyIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyIDWithPager} CompanyIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyIDWithPager} CompanyIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyIDWithPager message.
         * @function verify
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a CompanyIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyIDWithPager} CompanyIDWithPager
         */
        CompanyIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyIDWithPager)
                return object;
            var message = new $root.entity.CompanyIDWithPager();
            if (object.id != null)
                message.id = String(object.id);
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.CompanyIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyIDWithPager
         * @static
         * @param {entity.CompanyIDWithPager} message CompanyIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.pager = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this CompanyIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.CompanyIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyIDWithPager;
    })();

    entity.Company = (function() {

        /**
         * Properties of a Company.
         * @memberof entity
         * @interface ICompany
         * @property {string|null} [id] Company id
         * @property {string|null} [name] Company name
         * @property {string|null} [gsLogoURL] Company gsLogoURL
         * @property {string|null} [signedLogoURL] Company signedLogoURL
         * @property {string|null} [webURL] Company webURL
         * @property {string|null} [establishedDate] Company establishedDate
         * @property {string|null} [postalCode] Company postalCode
         * @property {string|null} [place] Company place
         * @property {Array.<entity.Company.Business>|null} [business] Company business
         * @property {string|null} [representativeName] Company representativeName
         * @property {string|null} [capitalStock] Company capitalStock
         * @property {entity.Company.EmployeeScale|null} [employeeScale] Company employeeScale
         * @property {string|null} [introduction] Company introduction
         * @property {string|null} [accordingCompanyName] Company accordingCompanyName
         * @property {string|null} [accordingCompanyPostalCode] Company accordingCompanyPostalCode
         * @property {string|null} [accordingCompanyAddress] Company accordingCompanyAddress
         * @property {entity.Company.Status|null} [status] Company status
         * @property {boolean|null} [isAgreeTerms] Company isAgreeTerms
         * @property {string|null} [createdAt] Company createdAt
         * @property {boolean|null} [isAdmin] Company isAdmin
         * @property {string|null} [acceptedAdminUserID] Company acceptedAdminUserID
         * @property {string|null} [acceptedAdminUserEmail] Company acceptedAdminUserEmail
         * @property {string|null} [acceptedAdminUserName] Company acceptedAdminUserName
         * @property {string|null} [managerAdminUserID] Company managerAdminUserID
         * @property {string|null} [managerAdminUserEmail] Company managerAdminUserEmail
         * @property {string|null} [managerAdminUserName] Company managerAdminUserName
         * @property {string|null} [firstClientID] Company firstClientID
         * @property {string|null} [firstClientName] Company firstClientName
         * @property {string|null} [lastUpdatedAdminUserID] Company lastUpdatedAdminUserID
         * @property {string|null} [lastUpdatedAdminUserName] Company lastUpdatedAdminUserName
         * @property {string|null} [lastUpdatedAtByAdminUser] Company lastUpdatedAtByAdminUser
         * @property {string|null} [latestProjectUpdatedAdminUserID] Company latestProjectUpdatedAdminUserID
         * @property {string|null} [latestProjectUpdatedAdminUserName] Company latestProjectUpdatedAdminUserName
         * @property {string|null} [latestProjectUpdatedAtByAdminUser] Company latestProjectUpdatedAtByAdminUser
         * @property {Array.<string>|null} [businessNames] Company businessNames
         * @property {string|null} [invoiceDepartmentName] Company invoiceDepartmentName
         * @property {string|null} [surveyJSON] Company surveyJSON
         * @property {boolean|null} [isSendInvoiceMailPerProject] Company isSendInvoiceMailPerProject
         */

        /**
         * Constructs a new Company.
         * @memberof entity
         * @classdesc Represents a Company.
         * @implements ICompany
         * @constructor
         * @param {entity.ICompany=} [properties] Properties to set
         */
        function Company(properties) {
            this.business = [];
            this.businessNames = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Company id.
         * @member {string} id
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.id = "";

        /**
         * Company name.
         * @member {string} name
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.name = "";

        /**
         * Company gsLogoURL.
         * @member {string} gsLogoURL
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.gsLogoURL = "";

        /**
         * Company signedLogoURL.
         * @member {string} signedLogoURL
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.signedLogoURL = "";

        /**
         * Company webURL.
         * @member {string} webURL
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.webURL = "";

        /**
         * Company establishedDate.
         * @member {string} establishedDate
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.establishedDate = "";

        /**
         * Company postalCode.
         * @member {string} postalCode
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.postalCode = "";

        /**
         * Company place.
         * @member {string} place
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.place = "";

        /**
         * Company business.
         * @member {Array.<entity.Company.Business>} business
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.business = $util.emptyArray;

        /**
         * Company representativeName.
         * @member {string} representativeName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.representativeName = "";

        /**
         * Company capitalStock.
         * @member {string} capitalStock
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.capitalStock = "";

        /**
         * Company employeeScale.
         * @member {entity.Company.EmployeeScale} employeeScale
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.employeeScale = 0;

        /**
         * Company introduction.
         * @member {string} introduction
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.introduction = "";

        /**
         * Company accordingCompanyName.
         * @member {string} accordingCompanyName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.accordingCompanyName = "";

        /**
         * Company accordingCompanyPostalCode.
         * @member {string} accordingCompanyPostalCode
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.accordingCompanyPostalCode = "";

        /**
         * Company accordingCompanyAddress.
         * @member {string} accordingCompanyAddress
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.accordingCompanyAddress = "";

        /**
         * Company status.
         * @member {entity.Company.Status} status
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.status = 0;

        /**
         * Company isAgreeTerms.
         * @member {boolean} isAgreeTerms
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.isAgreeTerms = false;

        /**
         * Company createdAt.
         * @member {string} createdAt
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.createdAt = "";

        /**
         * Company isAdmin.
         * @member {boolean} isAdmin
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.isAdmin = false;

        /**
         * Company acceptedAdminUserID.
         * @member {string} acceptedAdminUserID
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.acceptedAdminUserID = "";

        /**
         * Company acceptedAdminUserEmail.
         * @member {string} acceptedAdminUserEmail
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.acceptedAdminUserEmail = "";

        /**
         * Company acceptedAdminUserName.
         * @member {string} acceptedAdminUserName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.acceptedAdminUserName = "";

        /**
         * Company managerAdminUserID.
         * @member {string} managerAdminUserID
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.managerAdminUserID = "";

        /**
         * Company managerAdminUserEmail.
         * @member {string} managerAdminUserEmail
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.managerAdminUserEmail = "";

        /**
         * Company managerAdminUserName.
         * @member {string} managerAdminUserName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.managerAdminUserName = "";

        /**
         * Company firstClientID.
         * @member {string} firstClientID
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.firstClientID = "";

        /**
         * Company firstClientName.
         * @member {string} firstClientName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.firstClientName = "";

        /**
         * Company lastUpdatedAdminUserID.
         * @member {string} lastUpdatedAdminUserID
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.lastUpdatedAdminUserID = "";

        /**
         * Company lastUpdatedAdminUserName.
         * @member {string} lastUpdatedAdminUserName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.lastUpdatedAdminUserName = "";

        /**
         * Company lastUpdatedAtByAdminUser.
         * @member {string} lastUpdatedAtByAdminUser
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.lastUpdatedAtByAdminUser = "";

        /**
         * Company latestProjectUpdatedAdminUserID.
         * @member {string} latestProjectUpdatedAdminUserID
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.latestProjectUpdatedAdminUserID = "";

        /**
         * Company latestProjectUpdatedAdminUserName.
         * @member {string} latestProjectUpdatedAdminUserName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.latestProjectUpdatedAdminUserName = "";

        /**
         * Company latestProjectUpdatedAtByAdminUser.
         * @member {string} latestProjectUpdatedAtByAdminUser
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.latestProjectUpdatedAtByAdminUser = "";

        /**
         * Company businessNames.
         * @member {Array.<string>} businessNames
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.businessNames = $util.emptyArray;

        /**
         * Company invoiceDepartmentName.
         * @member {string} invoiceDepartmentName
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.invoiceDepartmentName = "";

        /**
         * Company surveyJSON.
         * @member {string} surveyJSON
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.surveyJSON = "";

        /**
         * Company isSendInvoiceMailPerProject.
         * @member {boolean} isSendInvoiceMailPerProject
         * @memberof entity.Company
         * @instance
         */
        Company.prototype.isSendInvoiceMailPerProject = false;

        /**
         * Creates a new Company instance using the specified properties.
         * @function create
         * @memberof entity.Company
         * @static
         * @param {entity.ICompany=} [properties] Properties to set
         * @returns {entity.Company} Company instance
         */
        Company.create = function create(properties) {
            return new Company(properties);
        };

        /**
         * Encodes the specified Company message. Does not implicitly {@link entity.Company.verify|verify} messages.
         * @function encode
         * @memberof entity.Company
         * @static
         * @param {entity.ICompany} message Company message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Company.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.gsLogoURL != null && Object.hasOwnProperty.call(message, "gsLogoURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gsLogoURL);
            if (message.signedLogoURL != null && Object.hasOwnProperty.call(message, "signedLogoURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.signedLogoURL);
            if (message.webURL != null && Object.hasOwnProperty.call(message, "webURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.webURL);
            if (message.establishedDate != null && Object.hasOwnProperty.call(message, "establishedDate"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.establishedDate);
            if (message.postalCode != null && Object.hasOwnProperty.call(message, "postalCode"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.postalCode);
            if (message.place != null && Object.hasOwnProperty.call(message, "place"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.place);
            if (message.business != null && message.business.length) {
                writer.uint32(/* id 9, wireType 2 =*/74).fork();
                for (var i = 0; i < message.business.length; ++i)
                    writer.int32(message.business[i]);
                writer.ldelim();
            }
            if (message.representativeName != null && Object.hasOwnProperty.call(message, "representativeName"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.representativeName);
            if (message.capitalStock != null && Object.hasOwnProperty.call(message, "capitalStock"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.capitalStock);
            if (message.employeeScale != null && Object.hasOwnProperty.call(message, "employeeScale"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.employeeScale);
            if (message.introduction != null && Object.hasOwnProperty.call(message, "introduction"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.introduction);
            if (message.accordingCompanyName != null && Object.hasOwnProperty.call(message, "accordingCompanyName"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.accordingCompanyName);
            if (message.accordingCompanyPostalCode != null && Object.hasOwnProperty.call(message, "accordingCompanyPostalCode"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.accordingCompanyPostalCode);
            if (message.accordingCompanyAddress != null && Object.hasOwnProperty.call(message, "accordingCompanyAddress"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.accordingCompanyAddress);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.status);
            if (message.isAgreeTerms != null && Object.hasOwnProperty.call(message, "isAgreeTerms"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.isAgreeTerms);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.createdAt);
            if (message.isAdmin != null && Object.hasOwnProperty.call(message, "isAdmin"))
                writer.uint32(/* id 27, wireType 0 =*/216).bool(message.isAdmin);
            if (message.acceptedAdminUserID != null && Object.hasOwnProperty.call(message, "acceptedAdminUserID"))
                writer.uint32(/* id 28, wireType 2 =*/226).string(message.acceptedAdminUserID);
            if (message.acceptedAdminUserEmail != null && Object.hasOwnProperty.call(message, "acceptedAdminUserEmail"))
                writer.uint32(/* id 29, wireType 2 =*/234).string(message.acceptedAdminUserEmail);
            if (message.acceptedAdminUserName != null && Object.hasOwnProperty.call(message, "acceptedAdminUserName"))
                writer.uint32(/* id 30, wireType 2 =*/242).string(message.acceptedAdminUserName);
            if (message.managerAdminUserID != null && Object.hasOwnProperty.call(message, "managerAdminUserID"))
                writer.uint32(/* id 31, wireType 2 =*/250).string(message.managerAdminUserID);
            if (message.managerAdminUserEmail != null && Object.hasOwnProperty.call(message, "managerAdminUserEmail"))
                writer.uint32(/* id 32, wireType 2 =*/258).string(message.managerAdminUserEmail);
            if (message.managerAdminUserName != null && Object.hasOwnProperty.call(message, "managerAdminUserName"))
                writer.uint32(/* id 33, wireType 2 =*/266).string(message.managerAdminUserName);
            if (message.firstClientID != null && Object.hasOwnProperty.call(message, "firstClientID"))
                writer.uint32(/* id 34, wireType 2 =*/274).string(message.firstClientID);
            if (message.firstClientName != null && Object.hasOwnProperty.call(message, "firstClientName"))
                writer.uint32(/* id 35, wireType 2 =*/282).string(message.firstClientName);
            if (message.lastUpdatedAdminUserID != null && Object.hasOwnProperty.call(message, "lastUpdatedAdminUserID"))
                writer.uint32(/* id 36, wireType 2 =*/290).string(message.lastUpdatedAdminUserID);
            if (message.lastUpdatedAdminUserName != null && Object.hasOwnProperty.call(message, "lastUpdatedAdminUserName"))
                writer.uint32(/* id 37, wireType 2 =*/298).string(message.lastUpdatedAdminUserName);
            if (message.lastUpdatedAtByAdminUser != null && Object.hasOwnProperty.call(message, "lastUpdatedAtByAdminUser"))
                writer.uint32(/* id 38, wireType 2 =*/306).string(message.lastUpdatedAtByAdminUser);
            if (message.latestProjectUpdatedAdminUserID != null && Object.hasOwnProperty.call(message, "latestProjectUpdatedAdminUserID"))
                writer.uint32(/* id 39, wireType 2 =*/314).string(message.latestProjectUpdatedAdminUserID);
            if (message.latestProjectUpdatedAdminUserName != null && Object.hasOwnProperty.call(message, "latestProjectUpdatedAdminUserName"))
                writer.uint32(/* id 40, wireType 2 =*/322).string(message.latestProjectUpdatedAdminUserName);
            if (message.latestProjectUpdatedAtByAdminUser != null && Object.hasOwnProperty.call(message, "latestProjectUpdatedAtByAdminUser"))
                writer.uint32(/* id 41, wireType 2 =*/330).string(message.latestProjectUpdatedAtByAdminUser);
            if (message.businessNames != null && message.businessNames.length)
                for (var i = 0; i < message.businessNames.length; ++i)
                    writer.uint32(/* id 42, wireType 2 =*/338).string(message.businessNames[i]);
            if (message.invoiceDepartmentName != null && Object.hasOwnProperty.call(message, "invoiceDepartmentName"))
                writer.uint32(/* id 43, wireType 2 =*/346).string(message.invoiceDepartmentName);
            if (message.surveyJSON != null && Object.hasOwnProperty.call(message, "surveyJSON"))
                writer.uint32(/* id 44, wireType 2 =*/354).string(message.surveyJSON);
            if (message.isSendInvoiceMailPerProject != null && Object.hasOwnProperty.call(message, "isSendInvoiceMailPerProject"))
                writer.uint32(/* id 45, wireType 0 =*/360).bool(message.isSendInvoiceMailPerProject);
            return writer;
        };

        /**
         * Encodes the specified Company message, length delimited. Does not implicitly {@link entity.Company.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Company
         * @static
         * @param {entity.ICompany} message Company message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Company.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Company message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Company
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Company} Company
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Company.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Company();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.gsLogoURL = reader.string();
                    break;
                case 4:
                    message.signedLogoURL = reader.string();
                    break;
                case 5:
                    message.webURL = reader.string();
                    break;
                case 6:
                    message.establishedDate = reader.string();
                    break;
                case 7:
                    message.postalCode = reader.string();
                    break;
                case 8:
                    message.place = reader.string();
                    break;
                case 9:
                    if (!(message.business && message.business.length))
                        message.business = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.business.push(reader.int32());
                    } else
                        message.business.push(reader.int32());
                    break;
                case 10:
                    message.representativeName = reader.string();
                    break;
                case 11:
                    message.capitalStock = reader.string();
                    break;
                case 12:
                    message.employeeScale = reader.int32();
                    break;
                case 13:
                    message.introduction = reader.string();
                    break;
                case 14:
                    message.accordingCompanyName = reader.string();
                    break;
                case 15:
                    message.accordingCompanyPostalCode = reader.string();
                    break;
                case 16:
                    message.accordingCompanyAddress = reader.string();
                    break;
                case 17:
                    message.status = reader.int32();
                    break;
                case 18:
                    message.isAgreeTerms = reader.bool();
                    break;
                case 24:
                    message.createdAt = reader.string();
                    break;
                case 27:
                    message.isAdmin = reader.bool();
                    break;
                case 28:
                    message.acceptedAdminUserID = reader.string();
                    break;
                case 29:
                    message.acceptedAdminUserEmail = reader.string();
                    break;
                case 30:
                    message.acceptedAdminUserName = reader.string();
                    break;
                case 31:
                    message.managerAdminUserID = reader.string();
                    break;
                case 32:
                    message.managerAdminUserEmail = reader.string();
                    break;
                case 33:
                    message.managerAdminUserName = reader.string();
                    break;
                case 34:
                    message.firstClientID = reader.string();
                    break;
                case 35:
                    message.firstClientName = reader.string();
                    break;
                case 36:
                    message.lastUpdatedAdminUserID = reader.string();
                    break;
                case 37:
                    message.lastUpdatedAdminUserName = reader.string();
                    break;
                case 38:
                    message.lastUpdatedAtByAdminUser = reader.string();
                    break;
                case 39:
                    message.latestProjectUpdatedAdminUserID = reader.string();
                    break;
                case 40:
                    message.latestProjectUpdatedAdminUserName = reader.string();
                    break;
                case 41:
                    message.latestProjectUpdatedAtByAdminUser = reader.string();
                    break;
                case 42:
                    if (!(message.businessNames && message.businessNames.length))
                        message.businessNames = [];
                    message.businessNames.push(reader.string());
                    break;
                case 43:
                    message.invoiceDepartmentName = reader.string();
                    break;
                case 44:
                    message.surveyJSON = reader.string();
                    break;
                case 45:
                    message.isSendInvoiceMailPerProject = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Company message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Company
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Company} Company
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Company.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Company message.
         * @function verify
         * @memberof entity.Company
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Company.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.gsLogoURL != null && message.hasOwnProperty("gsLogoURL"))
                if (!$util.isString(message.gsLogoURL))
                    return "gsLogoURL: string expected";
            if (message.signedLogoURL != null && message.hasOwnProperty("signedLogoURL"))
                if (!$util.isString(message.signedLogoURL))
                    return "signedLogoURL: string expected";
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                if (!$util.isString(message.webURL))
                    return "webURL: string expected";
            if (message.establishedDate != null && message.hasOwnProperty("establishedDate"))
                if (!$util.isString(message.establishedDate))
                    return "establishedDate: string expected";
            if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                if (!$util.isString(message.postalCode))
                    return "postalCode: string expected";
            if (message.place != null && message.hasOwnProperty("place"))
                if (!$util.isString(message.place))
                    return "place: string expected";
            if (message.business != null && message.hasOwnProperty("business")) {
                if (!Array.isArray(message.business))
                    return "business: array expected";
                for (var i = 0; i < message.business.length; ++i)
                    switch (message.business[i]) {
                    default:
                        return "business: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                        break;
                    }
            }
            if (message.representativeName != null && message.hasOwnProperty("representativeName"))
                if (!$util.isString(message.representativeName))
                    return "representativeName: string expected";
            if (message.capitalStock != null && message.hasOwnProperty("capitalStock"))
                if (!$util.isString(message.capitalStock))
                    return "capitalStock: string expected";
            if (message.employeeScale != null && message.hasOwnProperty("employeeScale"))
                switch (message.employeeScale) {
                default:
                    return "employeeScale: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.introduction != null && message.hasOwnProperty("introduction"))
                if (!$util.isString(message.introduction))
                    return "introduction: string expected";
            if (message.accordingCompanyName != null && message.hasOwnProperty("accordingCompanyName"))
                if (!$util.isString(message.accordingCompanyName))
                    return "accordingCompanyName: string expected";
            if (message.accordingCompanyPostalCode != null && message.hasOwnProperty("accordingCompanyPostalCode"))
                if (!$util.isString(message.accordingCompanyPostalCode))
                    return "accordingCompanyPostalCode: string expected";
            if (message.accordingCompanyAddress != null && message.hasOwnProperty("accordingCompanyAddress"))
                if (!$util.isString(message.accordingCompanyAddress))
                    return "accordingCompanyAddress: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.isAgreeTerms != null && message.hasOwnProperty("isAgreeTerms"))
                if (typeof message.isAgreeTerms !== "boolean")
                    return "isAgreeTerms: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.isAdmin != null && message.hasOwnProperty("isAdmin"))
                if (typeof message.isAdmin !== "boolean")
                    return "isAdmin: boolean expected";
            if (message.acceptedAdminUserID != null && message.hasOwnProperty("acceptedAdminUserID"))
                if (!$util.isString(message.acceptedAdminUserID))
                    return "acceptedAdminUserID: string expected";
            if (message.acceptedAdminUserEmail != null && message.hasOwnProperty("acceptedAdminUserEmail"))
                if (!$util.isString(message.acceptedAdminUserEmail))
                    return "acceptedAdminUserEmail: string expected";
            if (message.acceptedAdminUserName != null && message.hasOwnProperty("acceptedAdminUserName"))
                if (!$util.isString(message.acceptedAdminUserName))
                    return "acceptedAdminUserName: string expected";
            if (message.managerAdminUserID != null && message.hasOwnProperty("managerAdminUserID"))
                if (!$util.isString(message.managerAdminUserID))
                    return "managerAdminUserID: string expected";
            if (message.managerAdminUserEmail != null && message.hasOwnProperty("managerAdminUserEmail"))
                if (!$util.isString(message.managerAdminUserEmail))
                    return "managerAdminUserEmail: string expected";
            if (message.managerAdminUserName != null && message.hasOwnProperty("managerAdminUserName"))
                if (!$util.isString(message.managerAdminUserName))
                    return "managerAdminUserName: string expected";
            if (message.firstClientID != null && message.hasOwnProperty("firstClientID"))
                if (!$util.isString(message.firstClientID))
                    return "firstClientID: string expected";
            if (message.firstClientName != null && message.hasOwnProperty("firstClientName"))
                if (!$util.isString(message.firstClientName))
                    return "firstClientName: string expected";
            if (message.lastUpdatedAdminUserID != null && message.hasOwnProperty("lastUpdatedAdminUserID"))
                if (!$util.isString(message.lastUpdatedAdminUserID))
                    return "lastUpdatedAdminUserID: string expected";
            if (message.lastUpdatedAdminUserName != null && message.hasOwnProperty("lastUpdatedAdminUserName"))
                if (!$util.isString(message.lastUpdatedAdminUserName))
                    return "lastUpdatedAdminUserName: string expected";
            if (message.lastUpdatedAtByAdminUser != null && message.hasOwnProperty("lastUpdatedAtByAdminUser"))
                if (!$util.isString(message.lastUpdatedAtByAdminUser))
                    return "lastUpdatedAtByAdminUser: string expected";
            if (message.latestProjectUpdatedAdminUserID != null && message.hasOwnProperty("latestProjectUpdatedAdminUserID"))
                if (!$util.isString(message.latestProjectUpdatedAdminUserID))
                    return "latestProjectUpdatedAdminUserID: string expected";
            if (message.latestProjectUpdatedAdminUserName != null && message.hasOwnProperty("latestProjectUpdatedAdminUserName"))
                if (!$util.isString(message.latestProjectUpdatedAdminUserName))
                    return "latestProjectUpdatedAdminUserName: string expected";
            if (message.latestProjectUpdatedAtByAdminUser != null && message.hasOwnProperty("latestProjectUpdatedAtByAdminUser"))
                if (!$util.isString(message.latestProjectUpdatedAtByAdminUser))
                    return "latestProjectUpdatedAtByAdminUser: string expected";
            if (message.businessNames != null && message.hasOwnProperty("businessNames")) {
                if (!Array.isArray(message.businessNames))
                    return "businessNames: array expected";
                for (var i = 0; i < message.businessNames.length; ++i)
                    if (!$util.isString(message.businessNames[i]))
                        return "businessNames: string[] expected";
            }
            if (message.invoiceDepartmentName != null && message.hasOwnProperty("invoiceDepartmentName"))
                if (!$util.isString(message.invoiceDepartmentName))
                    return "invoiceDepartmentName: string expected";
            if (message.surveyJSON != null && message.hasOwnProperty("surveyJSON"))
                if (!$util.isString(message.surveyJSON))
                    return "surveyJSON: string expected";
            if (message.isSendInvoiceMailPerProject != null && message.hasOwnProperty("isSendInvoiceMailPerProject"))
                if (typeof message.isSendInvoiceMailPerProject !== "boolean")
                    return "isSendInvoiceMailPerProject: boolean expected";
            return null;
        };

        /**
         * Creates a Company message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Company
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Company} Company
         */
        Company.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Company)
                return object;
            var message = new $root.entity.Company();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.gsLogoURL != null)
                message.gsLogoURL = String(object.gsLogoURL);
            if (object.signedLogoURL != null)
                message.signedLogoURL = String(object.signedLogoURL);
            if (object.webURL != null)
                message.webURL = String(object.webURL);
            if (object.establishedDate != null)
                message.establishedDate = String(object.establishedDate);
            if (object.postalCode != null)
                message.postalCode = String(object.postalCode);
            if (object.place != null)
                message.place = String(object.place);
            if (object.business) {
                if (!Array.isArray(object.business))
                    throw TypeError(".entity.Company.business: array expected");
                message.business = [];
                for (var i = 0; i < object.business.length; ++i)
                    switch (object.business[i]) {
                    default:
                    case "Business_Unknown":
                    case 0:
                        message.business[i] = 0;
                        break;
                    case "Business_AgricultureForestryAndFisheries":
                    case 1:
                        message.business[i] = 1;
                        break;
                    case "Business_MiningIndustry":
                    case 2:
                        message.business[i] = 2;
                        break;
                    case "Business_ConstructionIndustry":
                    case 3:
                        message.business[i] = 3;
                        break;
                    case "Business_ManufacturingIndustry":
                    case 4:
                        message.business[i] = 4;
                        break;
                    case "Business_ElectricPowerAndGas":
                    case 5:
                        message.business[i] = 5;
                        break;
                    case "Business_InformationAndCommunicationIndustry":
                    case 6:
                        message.business[i] = 6;
                        break;
                    case "Business_TransportationIndustry":
                    case 7:
                        message.business[i] = 7;
                        break;
                    case "Business_WholesaleAndRetailTrade":
                    case 8:
                        message.business[i] = 8;
                        break;
                    case "Business_RestaurantBusiness":
                    case 9:
                        message.business[i] = 9;
                        break;
                    case "Business_FinanceAndInsurance":
                    case 10:
                        message.business[i] = 10;
                        break;
                    case "Business_RealEstateBusiness":
                    case 11:
                        message.business[i] = 11;
                        break;
                    case "Business_ServiceIndustry":
                    case 12:
                        message.business[i] = 12;
                        break;
                    case "Business_LodgingIndustry":
                    case 13:
                        message.business[i] = 13;
                        break;
                    case "Business_EducationBusiness":
                    case 14:
                        message.business[i] = 14;
                        break;
                    case "Business_MedicalAndWelfare":
                    case 15:
                        message.business[i] = 15;
                        break;
                    case "Business_AcademicAndResearch":
                    case 16:
                        message.business[i] = 16;
                        break;
                    case "Business_OfficialBusiness":
                    case 17:
                        message.business[i] = 17;
                        break;
                    case "Business_PoliticalEconomy":
                    case 18:
                        message.business[i] = 18;
                        break;
                    case "Business_OtherBusiness":
                    case 19:
                        message.business[i] = 19;
                        break;
                    }
            }
            if (object.representativeName != null)
                message.representativeName = String(object.representativeName);
            if (object.capitalStock != null)
                message.capitalStock = String(object.capitalStock);
            switch (object.employeeScale) {
            case "EmployeeScale_Unknown":
            case 0:
                message.employeeScale = 0;
                break;
            case "EmployeeScale_Under_10_People":
            case 1:
                message.employeeScale = 1;
                break;
            case "EmployeeScale_10_100_People":
            case 2:
                message.employeeScale = 2;
                break;
            case "EmployeeScale_100_1000_People":
            case 3:
                message.employeeScale = 3;
                break;
            case "EmployeeScale_Over_1000_People":
            case 4:
                message.employeeScale = 4;
                break;
            }
            if (object.introduction != null)
                message.introduction = String(object.introduction);
            if (object.accordingCompanyName != null)
                message.accordingCompanyName = String(object.accordingCompanyName);
            if (object.accordingCompanyPostalCode != null)
                message.accordingCompanyPostalCode = String(object.accordingCompanyPostalCode);
            if (object.accordingCompanyAddress != null)
                message.accordingCompanyAddress = String(object.accordingCompanyAddress);
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Active":
            case 1:
                message.status = 1;
                break;
            case "Status_BAN":
            case 2:
                message.status = 2;
                break;
            case "Status_Demo":
            case 3:
                message.status = 3;
                break;
            }
            if (object.isAgreeTerms != null)
                message.isAgreeTerms = Boolean(object.isAgreeTerms);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.isAdmin != null)
                message.isAdmin = Boolean(object.isAdmin);
            if (object.acceptedAdminUserID != null)
                message.acceptedAdminUserID = String(object.acceptedAdminUserID);
            if (object.acceptedAdminUserEmail != null)
                message.acceptedAdminUserEmail = String(object.acceptedAdminUserEmail);
            if (object.acceptedAdminUserName != null)
                message.acceptedAdminUserName = String(object.acceptedAdminUserName);
            if (object.managerAdminUserID != null)
                message.managerAdminUserID = String(object.managerAdminUserID);
            if (object.managerAdminUserEmail != null)
                message.managerAdminUserEmail = String(object.managerAdminUserEmail);
            if (object.managerAdminUserName != null)
                message.managerAdminUserName = String(object.managerAdminUserName);
            if (object.firstClientID != null)
                message.firstClientID = String(object.firstClientID);
            if (object.firstClientName != null)
                message.firstClientName = String(object.firstClientName);
            if (object.lastUpdatedAdminUserID != null)
                message.lastUpdatedAdminUserID = String(object.lastUpdatedAdminUserID);
            if (object.lastUpdatedAdminUserName != null)
                message.lastUpdatedAdminUserName = String(object.lastUpdatedAdminUserName);
            if (object.lastUpdatedAtByAdminUser != null)
                message.lastUpdatedAtByAdminUser = String(object.lastUpdatedAtByAdminUser);
            if (object.latestProjectUpdatedAdminUserID != null)
                message.latestProjectUpdatedAdminUserID = String(object.latestProjectUpdatedAdminUserID);
            if (object.latestProjectUpdatedAdminUserName != null)
                message.latestProjectUpdatedAdminUserName = String(object.latestProjectUpdatedAdminUserName);
            if (object.latestProjectUpdatedAtByAdminUser != null)
                message.latestProjectUpdatedAtByAdminUser = String(object.latestProjectUpdatedAtByAdminUser);
            if (object.businessNames) {
                if (!Array.isArray(object.businessNames))
                    throw TypeError(".entity.Company.businessNames: array expected");
                message.businessNames = [];
                for (var i = 0; i < object.businessNames.length; ++i)
                    message.businessNames[i] = String(object.businessNames[i]);
            }
            if (object.invoiceDepartmentName != null)
                message.invoiceDepartmentName = String(object.invoiceDepartmentName);
            if (object.surveyJSON != null)
                message.surveyJSON = String(object.surveyJSON);
            if (object.isSendInvoiceMailPerProject != null)
                message.isSendInvoiceMailPerProject = Boolean(object.isSendInvoiceMailPerProject);
            return message;
        };

        /**
         * Creates a plain object from a Company message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Company
         * @static
         * @param {entity.Company} message Company
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Company.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.business = [];
                object.businessNames = [];
            }
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.gsLogoURL = "";
                object.signedLogoURL = "";
                object.webURL = "";
                object.establishedDate = "";
                object.postalCode = "";
                object.place = "";
                object.representativeName = "";
                object.capitalStock = "";
                object.employeeScale = options.enums === String ? "EmployeeScale_Unknown" : 0;
                object.introduction = "";
                object.accordingCompanyName = "";
                object.accordingCompanyPostalCode = "";
                object.accordingCompanyAddress = "";
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.isAgreeTerms = false;
                object.createdAt = "";
                object.isAdmin = false;
                object.acceptedAdminUserID = "";
                object.acceptedAdminUserEmail = "";
                object.acceptedAdminUserName = "";
                object.managerAdminUserID = "";
                object.managerAdminUserEmail = "";
                object.managerAdminUserName = "";
                object.firstClientID = "";
                object.firstClientName = "";
                object.lastUpdatedAdminUserID = "";
                object.lastUpdatedAdminUserName = "";
                object.lastUpdatedAtByAdminUser = "";
                object.latestProjectUpdatedAdminUserID = "";
                object.latestProjectUpdatedAdminUserName = "";
                object.latestProjectUpdatedAtByAdminUser = "";
                object.invoiceDepartmentName = "";
                object.surveyJSON = "";
                object.isSendInvoiceMailPerProject = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.gsLogoURL != null && message.hasOwnProperty("gsLogoURL"))
                object.gsLogoURL = message.gsLogoURL;
            if (message.signedLogoURL != null && message.hasOwnProperty("signedLogoURL"))
                object.signedLogoURL = message.signedLogoURL;
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                object.webURL = message.webURL;
            if (message.establishedDate != null && message.hasOwnProperty("establishedDate"))
                object.establishedDate = message.establishedDate;
            if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                object.postalCode = message.postalCode;
            if (message.place != null && message.hasOwnProperty("place"))
                object.place = message.place;
            if (message.business && message.business.length) {
                object.business = [];
                for (var j = 0; j < message.business.length; ++j)
                    object.business[j] = options.enums === String ? $root.entity.Company.Business[message.business[j]] : message.business[j];
            }
            if (message.representativeName != null && message.hasOwnProperty("representativeName"))
                object.representativeName = message.representativeName;
            if (message.capitalStock != null && message.hasOwnProperty("capitalStock"))
                object.capitalStock = message.capitalStock;
            if (message.employeeScale != null && message.hasOwnProperty("employeeScale"))
                object.employeeScale = options.enums === String ? $root.entity.Company.EmployeeScale[message.employeeScale] : message.employeeScale;
            if (message.introduction != null && message.hasOwnProperty("introduction"))
                object.introduction = message.introduction;
            if (message.accordingCompanyName != null && message.hasOwnProperty("accordingCompanyName"))
                object.accordingCompanyName = message.accordingCompanyName;
            if (message.accordingCompanyPostalCode != null && message.hasOwnProperty("accordingCompanyPostalCode"))
                object.accordingCompanyPostalCode = message.accordingCompanyPostalCode;
            if (message.accordingCompanyAddress != null && message.hasOwnProperty("accordingCompanyAddress"))
                object.accordingCompanyAddress = message.accordingCompanyAddress;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.Company.Status[message.status] : message.status;
            if (message.isAgreeTerms != null && message.hasOwnProperty("isAgreeTerms"))
                object.isAgreeTerms = message.isAgreeTerms;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.isAdmin != null && message.hasOwnProperty("isAdmin"))
                object.isAdmin = message.isAdmin;
            if (message.acceptedAdminUserID != null && message.hasOwnProperty("acceptedAdminUserID"))
                object.acceptedAdminUserID = message.acceptedAdminUserID;
            if (message.acceptedAdminUserEmail != null && message.hasOwnProperty("acceptedAdminUserEmail"))
                object.acceptedAdminUserEmail = message.acceptedAdminUserEmail;
            if (message.acceptedAdminUserName != null && message.hasOwnProperty("acceptedAdminUserName"))
                object.acceptedAdminUserName = message.acceptedAdminUserName;
            if (message.managerAdminUserID != null && message.hasOwnProperty("managerAdminUserID"))
                object.managerAdminUserID = message.managerAdminUserID;
            if (message.managerAdminUserEmail != null && message.hasOwnProperty("managerAdminUserEmail"))
                object.managerAdminUserEmail = message.managerAdminUserEmail;
            if (message.managerAdminUserName != null && message.hasOwnProperty("managerAdminUserName"))
                object.managerAdminUserName = message.managerAdminUserName;
            if (message.firstClientID != null && message.hasOwnProperty("firstClientID"))
                object.firstClientID = message.firstClientID;
            if (message.firstClientName != null && message.hasOwnProperty("firstClientName"))
                object.firstClientName = message.firstClientName;
            if (message.lastUpdatedAdminUserID != null && message.hasOwnProperty("lastUpdatedAdminUserID"))
                object.lastUpdatedAdminUserID = message.lastUpdatedAdminUserID;
            if (message.lastUpdatedAdminUserName != null && message.hasOwnProperty("lastUpdatedAdminUserName"))
                object.lastUpdatedAdminUserName = message.lastUpdatedAdminUserName;
            if (message.lastUpdatedAtByAdminUser != null && message.hasOwnProperty("lastUpdatedAtByAdminUser"))
                object.lastUpdatedAtByAdminUser = message.lastUpdatedAtByAdminUser;
            if (message.latestProjectUpdatedAdminUserID != null && message.hasOwnProperty("latestProjectUpdatedAdminUserID"))
                object.latestProjectUpdatedAdminUserID = message.latestProjectUpdatedAdminUserID;
            if (message.latestProjectUpdatedAdminUserName != null && message.hasOwnProperty("latestProjectUpdatedAdminUserName"))
                object.latestProjectUpdatedAdminUserName = message.latestProjectUpdatedAdminUserName;
            if (message.latestProjectUpdatedAtByAdminUser != null && message.hasOwnProperty("latestProjectUpdatedAtByAdminUser"))
                object.latestProjectUpdatedAtByAdminUser = message.latestProjectUpdatedAtByAdminUser;
            if (message.businessNames && message.businessNames.length) {
                object.businessNames = [];
                for (var j = 0; j < message.businessNames.length; ++j)
                    object.businessNames[j] = message.businessNames[j];
            }
            if (message.invoiceDepartmentName != null && message.hasOwnProperty("invoiceDepartmentName"))
                object.invoiceDepartmentName = message.invoiceDepartmentName;
            if (message.surveyJSON != null && message.hasOwnProperty("surveyJSON"))
                object.surveyJSON = message.surveyJSON;
            if (message.isSendInvoiceMailPerProject != null && message.hasOwnProperty("isSendInvoiceMailPerProject"))
                object.isSendInvoiceMailPerProject = message.isSendInvoiceMailPerProject;
            return object;
        };

        /**
         * Converts this Company to JSON.
         * @function toJSON
         * @memberof entity.Company
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Company.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Business enum.
         * @name entity.Company.Business
         * @enum {number}
         * @property {number} Business_Unknown=0 Business_Unknown value
         * @property {number} Business_AgricultureForestryAndFisheries=1 Business_AgricultureForestryAndFisheries value
         * @property {number} Business_MiningIndustry=2 Business_MiningIndustry value
         * @property {number} Business_ConstructionIndustry=3 Business_ConstructionIndustry value
         * @property {number} Business_ManufacturingIndustry=4 Business_ManufacturingIndustry value
         * @property {number} Business_ElectricPowerAndGas=5 Business_ElectricPowerAndGas value
         * @property {number} Business_InformationAndCommunicationIndustry=6 Business_InformationAndCommunicationIndustry value
         * @property {number} Business_TransportationIndustry=7 Business_TransportationIndustry value
         * @property {number} Business_WholesaleAndRetailTrade=8 Business_WholesaleAndRetailTrade value
         * @property {number} Business_RestaurantBusiness=9 Business_RestaurantBusiness value
         * @property {number} Business_FinanceAndInsurance=10 Business_FinanceAndInsurance value
         * @property {number} Business_RealEstateBusiness=11 Business_RealEstateBusiness value
         * @property {number} Business_ServiceIndustry=12 Business_ServiceIndustry value
         * @property {number} Business_LodgingIndustry=13 Business_LodgingIndustry value
         * @property {number} Business_EducationBusiness=14 Business_EducationBusiness value
         * @property {number} Business_MedicalAndWelfare=15 Business_MedicalAndWelfare value
         * @property {number} Business_AcademicAndResearch=16 Business_AcademicAndResearch value
         * @property {number} Business_OfficialBusiness=17 Business_OfficialBusiness value
         * @property {number} Business_PoliticalEconomy=18 Business_PoliticalEconomy value
         * @property {number} Business_OtherBusiness=19 Business_OtherBusiness value
         */
        Company.Business = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Business_Unknown"] = 0;
            values[valuesById[1] = "Business_AgricultureForestryAndFisheries"] = 1;
            values[valuesById[2] = "Business_MiningIndustry"] = 2;
            values[valuesById[3] = "Business_ConstructionIndustry"] = 3;
            values[valuesById[4] = "Business_ManufacturingIndustry"] = 4;
            values[valuesById[5] = "Business_ElectricPowerAndGas"] = 5;
            values[valuesById[6] = "Business_InformationAndCommunicationIndustry"] = 6;
            values[valuesById[7] = "Business_TransportationIndustry"] = 7;
            values[valuesById[8] = "Business_WholesaleAndRetailTrade"] = 8;
            values[valuesById[9] = "Business_RestaurantBusiness"] = 9;
            values[valuesById[10] = "Business_FinanceAndInsurance"] = 10;
            values[valuesById[11] = "Business_RealEstateBusiness"] = 11;
            values[valuesById[12] = "Business_ServiceIndustry"] = 12;
            values[valuesById[13] = "Business_LodgingIndustry"] = 13;
            values[valuesById[14] = "Business_EducationBusiness"] = 14;
            values[valuesById[15] = "Business_MedicalAndWelfare"] = 15;
            values[valuesById[16] = "Business_AcademicAndResearch"] = 16;
            values[valuesById[17] = "Business_OfficialBusiness"] = 17;
            values[valuesById[18] = "Business_PoliticalEconomy"] = 18;
            values[valuesById[19] = "Business_OtherBusiness"] = 19;
            return values;
        })();

        /**
         * EmployeeScale enum.
         * @name entity.Company.EmployeeScale
         * @enum {number}
         * @property {number} EmployeeScale_Unknown=0 EmployeeScale_Unknown value
         * @property {number} EmployeeScale_Under_10_People=1 EmployeeScale_Under_10_People value
         * @property {number} EmployeeScale_10_100_People=2 EmployeeScale_10_100_People value
         * @property {number} EmployeeScale_100_1000_People=3 EmployeeScale_100_1000_People value
         * @property {number} EmployeeScale_Over_1000_People=4 EmployeeScale_Over_1000_People value
         */
        Company.EmployeeScale = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EmployeeScale_Unknown"] = 0;
            values[valuesById[1] = "EmployeeScale_Under_10_People"] = 1;
            values[valuesById[2] = "EmployeeScale_10_100_People"] = 2;
            values[valuesById[3] = "EmployeeScale_100_1000_People"] = 3;
            values[valuesById[4] = "EmployeeScale_Over_1000_People"] = 4;
            return values;
        })();

        /**
         * Status enum.
         * @name entity.Company.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_Active=1 Status_Active value
         * @property {number} Status_BAN=2 Status_BAN value
         * @property {number} Status_Demo=3 Status_Demo value
         */
        Company.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_Active"] = 1;
            values[valuesById[2] = "Status_BAN"] = 2;
            values[valuesById[3] = "Status_Demo"] = 3;
            return values;
        })();

        return Company;
    })();

    entity.CompanyList = (function() {

        /**
         * Properties of a CompanyList.
         * @memberof entity
         * @interface ICompanyList
         * @property {Array.<entity.ICompany>|null} [items] CompanyList items
         */

        /**
         * Constructs a new CompanyList.
         * @memberof entity
         * @classdesc Represents a CompanyList.
         * @implements ICompanyList
         * @constructor
         * @param {entity.ICompanyList=} [properties] Properties to set
         */
        function CompanyList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyList items.
         * @member {Array.<entity.ICompany>} items
         * @memberof entity.CompanyList
         * @instance
         */
        CompanyList.prototype.items = $util.emptyArray;

        /**
         * Creates a new CompanyList instance using the specified properties.
         * @function create
         * @memberof entity.CompanyList
         * @static
         * @param {entity.ICompanyList=} [properties] Properties to set
         * @returns {entity.CompanyList} CompanyList instance
         */
        CompanyList.create = function create(properties) {
            return new CompanyList(properties);
        };

        /**
         * Encodes the specified CompanyList message. Does not implicitly {@link entity.CompanyList.verify|verify} messages.
         * @function encode
         * @memberof entity.CompanyList
         * @static
         * @param {entity.ICompanyList} message CompanyList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Company.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompanyList message, length delimited. Does not implicitly {@link entity.CompanyList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CompanyList
         * @static
         * @param {entity.ICompanyList} message CompanyList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CompanyList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CompanyList} CompanyList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CompanyList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Company.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CompanyList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CompanyList} CompanyList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyList message.
         * @function verify
         * @memberof entity.CompanyList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Company.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompanyList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CompanyList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CompanyList} CompanyList
         */
        CompanyList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CompanyList)
                return object;
            var message = new $root.entity.CompanyList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.CompanyList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.CompanyList.items: object expected");
                    message.items[i] = $root.entity.Company.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CompanyList
         * @static
         * @param {entity.CompanyList} message CompanyList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Company.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CompanyList to JSON.
         * @function toJSON
         * @memberof entity.CompanyList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyList;
    })();

    entity.ContractCustomerReportID = (function() {

        /**
         * Properties of a ContractCustomerReportID.
         * @memberof entity
         * @interface IContractCustomerReportID
         * @property {string|null} [id] ContractCustomerReportID id
         */

        /**
         * Constructs a new ContractCustomerReportID.
         * @memberof entity
         * @classdesc Represents a ContractCustomerReportID.
         * @implements IContractCustomerReportID
         * @constructor
         * @param {entity.IContractCustomerReportID=} [properties] Properties to set
         */
        function ContractCustomerReportID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractCustomerReportID id.
         * @member {string} id
         * @memberof entity.ContractCustomerReportID
         * @instance
         */
        ContractCustomerReportID.prototype.id = "";

        /**
         * Creates a new ContractCustomerReportID instance using the specified properties.
         * @function create
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {entity.IContractCustomerReportID=} [properties] Properties to set
         * @returns {entity.ContractCustomerReportID} ContractCustomerReportID instance
         */
        ContractCustomerReportID.create = function create(properties) {
            return new ContractCustomerReportID(properties);
        };

        /**
         * Encodes the specified ContractCustomerReportID message. Does not implicitly {@link entity.ContractCustomerReportID.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {entity.IContractCustomerReportID} message ContractCustomerReportID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReportID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ContractCustomerReportID message, length delimited. Does not implicitly {@link entity.ContractCustomerReportID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {entity.IContractCustomerReportID} message ContractCustomerReportID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReportID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractCustomerReportID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractCustomerReportID} ContractCustomerReportID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReportID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractCustomerReportID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractCustomerReportID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractCustomerReportID} ContractCustomerReportID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReportID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractCustomerReportID message.
         * @function verify
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractCustomerReportID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ContractCustomerReportID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractCustomerReportID} ContractCustomerReportID
         */
        ContractCustomerReportID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractCustomerReportID)
                return object;
            var message = new $root.entity.ContractCustomerReportID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ContractCustomerReportID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractCustomerReportID
         * @static
         * @param {entity.ContractCustomerReportID} message ContractCustomerReportID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractCustomerReportID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ContractCustomerReportID to JSON.
         * @function toJSON
         * @memberof entity.ContractCustomerReportID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractCustomerReportID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractCustomerReportID;
    })();

    entity.ContractCustomerReport = (function() {

        /**
         * Properties of a ContractCustomerReport.
         * @memberof entity
         * @interface IContractCustomerReport
         * @property {string|null} [id] ContractCustomerReport id
         * @property {string|null} [contractID] ContractCustomerReport contractID
         * @property {string|null} [targetYM] ContractCustomerReport targetYM
         * @property {string|null} [detail] ContractCustomerReport detail
         * @property {entity.ContractOperationReport.SatisfactionLevel|null} [satisfactionLevel] ContractCustomerReport satisfactionLevel
         * @property {entity.ContractOperationReport.ContinuationLevel|null} [continuationLevel] ContractCustomerReport continuationLevel
         * @property {string|null} [supportRequest] ContractCustomerReport supportRequest
         * @property {string|null} [otherRequest] ContractCustomerReport otherRequest
         * @property {string|null} [createdAt] ContractCustomerReport createdAt
         */

        /**
         * Constructs a new ContractCustomerReport.
         * @memberof entity
         * @classdesc Represents a ContractCustomerReport.
         * @implements IContractCustomerReport
         * @constructor
         * @param {entity.IContractCustomerReport=} [properties] Properties to set
         */
        function ContractCustomerReport(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractCustomerReport id.
         * @member {string} id
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.id = "";

        /**
         * ContractCustomerReport contractID.
         * @member {string} contractID
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.contractID = "";

        /**
         * ContractCustomerReport targetYM.
         * @member {string} targetYM
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.targetYM = "";

        /**
         * ContractCustomerReport detail.
         * @member {string} detail
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.detail = "";

        /**
         * ContractCustomerReport satisfactionLevel.
         * @member {entity.ContractOperationReport.SatisfactionLevel} satisfactionLevel
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.satisfactionLevel = 0;

        /**
         * ContractCustomerReport continuationLevel.
         * @member {entity.ContractOperationReport.ContinuationLevel} continuationLevel
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.continuationLevel = 0;

        /**
         * ContractCustomerReport supportRequest.
         * @member {string} supportRequest
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.supportRequest = "";

        /**
         * ContractCustomerReport otherRequest.
         * @member {string} otherRequest
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.otherRequest = "";

        /**
         * ContractCustomerReport createdAt.
         * @member {string} createdAt
         * @memberof entity.ContractCustomerReport
         * @instance
         */
        ContractCustomerReport.prototype.createdAt = "";

        /**
         * Creates a new ContractCustomerReport instance using the specified properties.
         * @function create
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {entity.IContractCustomerReport=} [properties] Properties to set
         * @returns {entity.ContractCustomerReport} ContractCustomerReport instance
         */
        ContractCustomerReport.create = function create(properties) {
            return new ContractCustomerReport(properties);
        };

        /**
         * Encodes the specified ContractCustomerReport message. Does not implicitly {@link entity.ContractCustomerReport.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {entity.IContractCustomerReport} message ContractCustomerReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReport.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.contractID != null && Object.hasOwnProperty.call(message, "contractID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.contractID);
            if (message.targetYM != null && Object.hasOwnProperty.call(message, "targetYM"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetYM);
            if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.detail);
            if (message.satisfactionLevel != null && Object.hasOwnProperty.call(message, "satisfactionLevel"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.satisfactionLevel);
            if (message.continuationLevel != null && Object.hasOwnProperty.call(message, "continuationLevel"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.continuationLevel);
            if (message.supportRequest != null && Object.hasOwnProperty.call(message, "supportRequest"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.supportRequest);
            if (message.otherRequest != null && Object.hasOwnProperty.call(message, "otherRequest"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.otherRequest);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified ContractCustomerReport message, length delimited. Does not implicitly {@link entity.ContractCustomerReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {entity.IContractCustomerReport} message ContractCustomerReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractCustomerReport message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractCustomerReport} ContractCustomerReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReport.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractCustomerReport();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.contractID = reader.string();
                    break;
                case 3:
                    message.targetYM = reader.string();
                    break;
                case 4:
                    message.detail = reader.string();
                    break;
                case 5:
                    message.satisfactionLevel = reader.int32();
                    break;
                case 6:
                    message.continuationLevel = reader.int32();
                    break;
                case 7:
                    message.supportRequest = reader.string();
                    break;
                case 8:
                    message.otherRequest = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractCustomerReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractCustomerReport} ContractCustomerReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractCustomerReport message.
         * @function verify
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractCustomerReport.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                if (!$util.isString(message.contractID))
                    return "contractID: string expected";
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                if (!$util.isString(message.targetYM))
                    return "targetYM: string expected";
            if (message.detail != null && message.hasOwnProperty("detail"))
                if (!$util.isString(message.detail))
                    return "detail: string expected";
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                switch (message.satisfactionLevel) {
                default:
                    return "satisfactionLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                switch (message.continuationLevel) {
                default:
                    return "continuationLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                if (!$util.isString(message.supportRequest))
                    return "supportRequest: string expected";
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                if (!$util.isString(message.otherRequest))
                    return "otherRequest: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a ContractCustomerReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractCustomerReport} ContractCustomerReport
         */
        ContractCustomerReport.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractCustomerReport)
                return object;
            var message = new $root.entity.ContractCustomerReport();
            if (object.id != null)
                message.id = String(object.id);
            if (object.contractID != null)
                message.contractID = String(object.contractID);
            if (object.targetYM != null)
                message.targetYM = String(object.targetYM);
            if (object.detail != null)
                message.detail = String(object.detail);
            switch (object.satisfactionLevel) {
            case "SatisfactionLevel_Unknown":
            case 0:
                message.satisfactionLevel = 0;
                break;
            case "SatisfactionLevel_Good":
            case 1:
                message.satisfactionLevel = 1;
                break;
            case "SatisfactionLevel_Normal":
            case 2:
                message.satisfactionLevel = 2;
                break;
            case "SatisfactionLevel_Bad":
            case 3:
                message.satisfactionLevel = 3;
                break;
            }
            switch (object.continuationLevel) {
            case "ContinuationLevel_Unknown":
            case 0:
                message.continuationLevel = 0;
                break;
            case "ContinuationLevel_Continue":
            case 1:
                message.continuationLevel = 1;
                break;
            case "ContinuationLevel_Consider":
            case 2:
                message.continuationLevel = 2;
                break;
            case "ContinuationLevel_Stop":
            case 3:
                message.continuationLevel = 3;
                break;
            }
            if (object.supportRequest != null)
                message.supportRequest = String(object.supportRequest);
            if (object.otherRequest != null)
                message.otherRequest = String(object.otherRequest);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a ContractCustomerReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractCustomerReport
         * @static
         * @param {entity.ContractCustomerReport} message ContractCustomerReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractCustomerReport.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.contractID = "";
                object.targetYM = "";
                object.detail = "";
                object.satisfactionLevel = options.enums === String ? "SatisfactionLevel_Unknown" : 0;
                object.continuationLevel = options.enums === String ? "ContinuationLevel_Unknown" : 0;
                object.supportRequest = "";
                object.otherRequest = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                object.contractID = message.contractID;
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                object.targetYM = message.targetYM;
            if (message.detail != null && message.hasOwnProperty("detail"))
                object.detail = message.detail;
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                object.satisfactionLevel = options.enums === String ? $root.entity.ContractOperationReport.SatisfactionLevel[message.satisfactionLevel] : message.satisfactionLevel;
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                object.continuationLevel = options.enums === String ? $root.entity.ContractOperationReport.ContinuationLevel[message.continuationLevel] : message.continuationLevel;
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                object.supportRequest = message.supportRequest;
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                object.otherRequest = message.otherRequest;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this ContractCustomerReport to JSON.
         * @function toJSON
         * @memberof entity.ContractCustomerReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractCustomerReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractCustomerReport;
    })();

    entity.ContractCustomerReportList = (function() {

        /**
         * Properties of a ContractCustomerReportList.
         * @memberof entity
         * @interface IContractCustomerReportList
         * @property {Array.<entity.IContractCustomerReport>|null} [items] ContractCustomerReportList items
         */

        /**
         * Constructs a new ContractCustomerReportList.
         * @memberof entity
         * @classdesc Represents a ContractCustomerReportList.
         * @implements IContractCustomerReportList
         * @constructor
         * @param {entity.IContractCustomerReportList=} [properties] Properties to set
         */
        function ContractCustomerReportList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractCustomerReportList items.
         * @member {Array.<entity.IContractCustomerReport>} items
         * @memberof entity.ContractCustomerReportList
         * @instance
         */
        ContractCustomerReportList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ContractCustomerReportList instance using the specified properties.
         * @function create
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {entity.IContractCustomerReportList=} [properties] Properties to set
         * @returns {entity.ContractCustomerReportList} ContractCustomerReportList instance
         */
        ContractCustomerReportList.create = function create(properties) {
            return new ContractCustomerReportList(properties);
        };

        /**
         * Encodes the specified ContractCustomerReportList message. Does not implicitly {@link entity.ContractCustomerReportList.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {entity.IContractCustomerReportList} message ContractCustomerReportList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReportList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.ContractCustomerReport.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContractCustomerReportList message, length delimited. Does not implicitly {@link entity.ContractCustomerReportList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {entity.IContractCustomerReportList} message ContractCustomerReportList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractCustomerReportList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractCustomerReportList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractCustomerReportList} ContractCustomerReportList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReportList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractCustomerReportList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.ContractCustomerReport.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractCustomerReportList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractCustomerReportList} ContractCustomerReportList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractCustomerReportList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractCustomerReportList message.
         * @function verify
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractCustomerReportList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.ContractCustomerReport.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ContractCustomerReportList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractCustomerReportList} ContractCustomerReportList
         */
        ContractCustomerReportList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractCustomerReportList)
                return object;
            var message = new $root.entity.ContractCustomerReportList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ContractCustomerReportList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ContractCustomerReportList.items: object expected");
                    message.items[i] = $root.entity.ContractCustomerReport.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractCustomerReportList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractCustomerReportList
         * @static
         * @param {entity.ContractCustomerReportList} message ContractCustomerReportList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractCustomerReportList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.ContractCustomerReport.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ContractCustomerReportList to JSON.
         * @function toJSON
         * @memberof entity.ContractCustomerReportList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractCustomerReportList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractCustomerReportList;
    })();

    entity.ContractOperationReportID = (function() {

        /**
         * Properties of a ContractOperationReportID.
         * @memberof entity
         * @interface IContractOperationReportID
         * @property {string|null} [id] ContractOperationReportID id
         */

        /**
         * Constructs a new ContractOperationReportID.
         * @memberof entity
         * @classdesc Represents a ContractOperationReportID.
         * @implements IContractOperationReportID
         * @constructor
         * @param {entity.IContractOperationReportID=} [properties] Properties to set
         */
        function ContractOperationReportID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractOperationReportID id.
         * @member {string} id
         * @memberof entity.ContractOperationReportID
         * @instance
         */
        ContractOperationReportID.prototype.id = "";

        /**
         * Creates a new ContractOperationReportID instance using the specified properties.
         * @function create
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {entity.IContractOperationReportID=} [properties] Properties to set
         * @returns {entity.ContractOperationReportID} ContractOperationReportID instance
         */
        ContractOperationReportID.create = function create(properties) {
            return new ContractOperationReportID(properties);
        };

        /**
         * Encodes the specified ContractOperationReportID message. Does not implicitly {@link entity.ContractOperationReportID.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {entity.IContractOperationReportID} message ContractOperationReportID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReportID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ContractOperationReportID message, length delimited. Does not implicitly {@link entity.ContractOperationReportID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {entity.IContractOperationReportID} message ContractOperationReportID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReportID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractOperationReportID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractOperationReportID} ContractOperationReportID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReportID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractOperationReportID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractOperationReportID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractOperationReportID} ContractOperationReportID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReportID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractOperationReportID message.
         * @function verify
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractOperationReportID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ContractOperationReportID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractOperationReportID} ContractOperationReportID
         */
        ContractOperationReportID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractOperationReportID)
                return object;
            var message = new $root.entity.ContractOperationReportID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ContractOperationReportID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractOperationReportID
         * @static
         * @param {entity.ContractOperationReportID} message ContractOperationReportID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractOperationReportID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ContractOperationReportID to JSON.
         * @function toJSON
         * @memberof entity.ContractOperationReportID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractOperationReportID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractOperationReportID;
    })();

    entity.ContractOperationReport = (function() {

        /**
         * Properties of a ContractOperationReport.
         * @memberof entity
         * @interface IContractOperationReport
         * @property {string|null} [id] ContractOperationReport id
         * @property {string|null} [contractID] ContractOperationReport contractID
         * @property {string|null} [targetYM] ContractOperationReport targetYM
         * @property {string|null} [detail] ContractOperationReport detail
         * @property {entity.ContractOperationReport.SatisfactionLevel|null} [satisfactionLevel] ContractOperationReport satisfactionLevel
         * @property {entity.ContractOperationReport.ContinuationLevel|null} [continuationLevel] ContractOperationReport continuationLevel
         * @property {string|null} [supportRequest] ContractOperationReport supportRequest
         * @property {string|null} [otherRequest] ContractOperationReport otherRequest
         * @property {string|null} [createdAt] ContractOperationReport createdAt
         */

        /**
         * Constructs a new ContractOperationReport.
         * @memberof entity
         * @classdesc Represents a ContractOperationReport.
         * @implements IContractOperationReport
         * @constructor
         * @param {entity.IContractOperationReport=} [properties] Properties to set
         */
        function ContractOperationReport(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractOperationReport id.
         * @member {string} id
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.id = "";

        /**
         * ContractOperationReport contractID.
         * @member {string} contractID
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.contractID = "";

        /**
         * ContractOperationReport targetYM.
         * @member {string} targetYM
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.targetYM = "";

        /**
         * ContractOperationReport detail.
         * @member {string} detail
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.detail = "";

        /**
         * ContractOperationReport satisfactionLevel.
         * @member {entity.ContractOperationReport.SatisfactionLevel} satisfactionLevel
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.satisfactionLevel = 0;

        /**
         * ContractOperationReport continuationLevel.
         * @member {entity.ContractOperationReport.ContinuationLevel} continuationLevel
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.continuationLevel = 0;

        /**
         * ContractOperationReport supportRequest.
         * @member {string} supportRequest
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.supportRequest = "";

        /**
         * ContractOperationReport otherRequest.
         * @member {string} otherRequest
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.otherRequest = "";

        /**
         * ContractOperationReport createdAt.
         * @member {string} createdAt
         * @memberof entity.ContractOperationReport
         * @instance
         */
        ContractOperationReport.prototype.createdAt = "";

        /**
         * Creates a new ContractOperationReport instance using the specified properties.
         * @function create
         * @memberof entity.ContractOperationReport
         * @static
         * @param {entity.IContractOperationReport=} [properties] Properties to set
         * @returns {entity.ContractOperationReport} ContractOperationReport instance
         */
        ContractOperationReport.create = function create(properties) {
            return new ContractOperationReport(properties);
        };

        /**
         * Encodes the specified ContractOperationReport message. Does not implicitly {@link entity.ContractOperationReport.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractOperationReport
         * @static
         * @param {entity.IContractOperationReport} message ContractOperationReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReport.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.contractID != null && Object.hasOwnProperty.call(message, "contractID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.contractID);
            if (message.targetYM != null && Object.hasOwnProperty.call(message, "targetYM"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetYM);
            if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.detail);
            if (message.satisfactionLevel != null && Object.hasOwnProperty.call(message, "satisfactionLevel"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.satisfactionLevel);
            if (message.continuationLevel != null && Object.hasOwnProperty.call(message, "continuationLevel"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.continuationLevel);
            if (message.supportRequest != null && Object.hasOwnProperty.call(message, "supportRequest"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.supportRequest);
            if (message.otherRequest != null && Object.hasOwnProperty.call(message, "otherRequest"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.otherRequest);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified ContractOperationReport message, length delimited. Does not implicitly {@link entity.ContractOperationReport.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractOperationReport
         * @static
         * @param {entity.IContractOperationReport} message ContractOperationReport message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReport.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractOperationReport message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractOperationReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractOperationReport} ContractOperationReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReport.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractOperationReport();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.contractID = reader.string();
                    break;
                case 3:
                    message.targetYM = reader.string();
                    break;
                case 4:
                    message.detail = reader.string();
                    break;
                case 5:
                    message.satisfactionLevel = reader.int32();
                    break;
                case 6:
                    message.continuationLevel = reader.int32();
                    break;
                case 7:
                    message.supportRequest = reader.string();
                    break;
                case 8:
                    message.otherRequest = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractOperationReport message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractOperationReport
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractOperationReport} ContractOperationReport
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReport.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractOperationReport message.
         * @function verify
         * @memberof entity.ContractOperationReport
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractOperationReport.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                if (!$util.isString(message.contractID))
                    return "contractID: string expected";
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                if (!$util.isString(message.targetYM))
                    return "targetYM: string expected";
            if (message.detail != null && message.hasOwnProperty("detail"))
                if (!$util.isString(message.detail))
                    return "detail: string expected";
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                switch (message.satisfactionLevel) {
                default:
                    return "satisfactionLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                switch (message.continuationLevel) {
                default:
                    return "continuationLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                if (!$util.isString(message.supportRequest))
                    return "supportRequest: string expected";
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                if (!$util.isString(message.otherRequest))
                    return "otherRequest: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a ContractOperationReport message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractOperationReport
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractOperationReport} ContractOperationReport
         */
        ContractOperationReport.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractOperationReport)
                return object;
            var message = new $root.entity.ContractOperationReport();
            if (object.id != null)
                message.id = String(object.id);
            if (object.contractID != null)
                message.contractID = String(object.contractID);
            if (object.targetYM != null)
                message.targetYM = String(object.targetYM);
            if (object.detail != null)
                message.detail = String(object.detail);
            switch (object.satisfactionLevel) {
            case "SatisfactionLevel_Unknown":
            case 0:
                message.satisfactionLevel = 0;
                break;
            case "SatisfactionLevel_Good":
            case 1:
                message.satisfactionLevel = 1;
                break;
            case "SatisfactionLevel_Normal":
            case 2:
                message.satisfactionLevel = 2;
                break;
            case "SatisfactionLevel_Bad":
            case 3:
                message.satisfactionLevel = 3;
                break;
            }
            switch (object.continuationLevel) {
            case "ContinuationLevel_Unknown":
            case 0:
                message.continuationLevel = 0;
                break;
            case "ContinuationLevel_Continue":
            case 1:
                message.continuationLevel = 1;
                break;
            case "ContinuationLevel_Consider":
            case 2:
                message.continuationLevel = 2;
                break;
            case "ContinuationLevel_Stop":
            case 3:
                message.continuationLevel = 3;
                break;
            }
            if (object.supportRequest != null)
                message.supportRequest = String(object.supportRequest);
            if (object.otherRequest != null)
                message.otherRequest = String(object.otherRequest);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a ContractOperationReport message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractOperationReport
         * @static
         * @param {entity.ContractOperationReport} message ContractOperationReport
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractOperationReport.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.contractID = "";
                object.targetYM = "";
                object.detail = "";
                object.satisfactionLevel = options.enums === String ? "SatisfactionLevel_Unknown" : 0;
                object.continuationLevel = options.enums === String ? "ContinuationLevel_Unknown" : 0;
                object.supportRequest = "";
                object.otherRequest = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                object.contractID = message.contractID;
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                object.targetYM = message.targetYM;
            if (message.detail != null && message.hasOwnProperty("detail"))
                object.detail = message.detail;
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                object.satisfactionLevel = options.enums === String ? $root.entity.ContractOperationReport.SatisfactionLevel[message.satisfactionLevel] : message.satisfactionLevel;
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                object.continuationLevel = options.enums === String ? $root.entity.ContractOperationReport.ContinuationLevel[message.continuationLevel] : message.continuationLevel;
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                object.supportRequest = message.supportRequest;
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                object.otherRequest = message.otherRequest;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this ContractOperationReport to JSON.
         * @function toJSON
         * @memberof entity.ContractOperationReport
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractOperationReport.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * SatisfactionLevel enum.
         * @name entity.ContractOperationReport.SatisfactionLevel
         * @enum {number}
         * @property {number} SatisfactionLevel_Unknown=0 SatisfactionLevel_Unknown value
         * @property {number} SatisfactionLevel_Good=1 SatisfactionLevel_Good value
         * @property {number} SatisfactionLevel_Normal=2 SatisfactionLevel_Normal value
         * @property {number} SatisfactionLevel_Bad=3 SatisfactionLevel_Bad value
         */
        ContractOperationReport.SatisfactionLevel = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SatisfactionLevel_Unknown"] = 0;
            values[valuesById[1] = "SatisfactionLevel_Good"] = 1;
            values[valuesById[2] = "SatisfactionLevel_Normal"] = 2;
            values[valuesById[3] = "SatisfactionLevel_Bad"] = 3;
            return values;
        })();

        /**
         * ContinuationLevel enum.
         * @name entity.ContractOperationReport.ContinuationLevel
         * @enum {number}
         * @property {number} ContinuationLevel_Unknown=0 ContinuationLevel_Unknown value
         * @property {number} ContinuationLevel_Continue=1 ContinuationLevel_Continue value
         * @property {number} ContinuationLevel_Consider=2 ContinuationLevel_Consider value
         * @property {number} ContinuationLevel_Stop=3 ContinuationLevel_Stop value
         */
        ContractOperationReport.ContinuationLevel = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ContinuationLevel_Unknown"] = 0;
            values[valuesById[1] = "ContinuationLevel_Continue"] = 1;
            values[valuesById[2] = "ContinuationLevel_Consider"] = 2;
            values[valuesById[3] = "ContinuationLevel_Stop"] = 3;
            return values;
        })();

        return ContractOperationReport;
    })();

    entity.ContractOperationReportList = (function() {

        /**
         * Properties of a ContractOperationReportList.
         * @memberof entity
         * @interface IContractOperationReportList
         * @property {Array.<entity.IContractOperationReport>|null} [items] ContractOperationReportList items
         */

        /**
         * Constructs a new ContractOperationReportList.
         * @memberof entity
         * @classdesc Represents a ContractOperationReportList.
         * @implements IContractOperationReportList
         * @constructor
         * @param {entity.IContractOperationReportList=} [properties] Properties to set
         */
        function ContractOperationReportList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractOperationReportList items.
         * @member {Array.<entity.IContractOperationReport>} items
         * @memberof entity.ContractOperationReportList
         * @instance
         */
        ContractOperationReportList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ContractOperationReportList instance using the specified properties.
         * @function create
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {entity.IContractOperationReportList=} [properties] Properties to set
         * @returns {entity.ContractOperationReportList} ContractOperationReportList instance
         */
        ContractOperationReportList.create = function create(properties) {
            return new ContractOperationReportList(properties);
        };

        /**
         * Encodes the specified ContractOperationReportList message. Does not implicitly {@link entity.ContractOperationReportList.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {entity.IContractOperationReportList} message ContractOperationReportList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReportList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.ContractOperationReport.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContractOperationReportList message, length delimited. Does not implicitly {@link entity.ContractOperationReportList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {entity.IContractOperationReportList} message ContractOperationReportList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperationReportList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractOperationReportList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractOperationReportList} ContractOperationReportList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReportList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractOperationReportList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.ContractOperationReport.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractOperationReportList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractOperationReportList} ContractOperationReportList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperationReportList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractOperationReportList message.
         * @function verify
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractOperationReportList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.ContractOperationReport.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ContractOperationReportList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractOperationReportList} ContractOperationReportList
         */
        ContractOperationReportList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractOperationReportList)
                return object;
            var message = new $root.entity.ContractOperationReportList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ContractOperationReportList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ContractOperationReportList.items: object expected");
                    message.items[i] = $root.entity.ContractOperationReport.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractOperationReportList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractOperationReportList
         * @static
         * @param {entity.ContractOperationReportList} message ContractOperationReportList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractOperationReportList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.ContractOperationReport.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ContractOperationReportList to JSON.
         * @function toJSON
         * @memberof entity.ContractOperationReportList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractOperationReportList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractOperationReportList;
    })();

    entity.ContractOperation = (function() {

        /**
         * Properties of a ContractOperation.
         * @memberof entity
         * @interface IContractOperation
         * @property {string|null} [contractID] ContractOperation contractID
         * @property {entity.ContractOperation.Status|null} [status] ContractOperation status
         * @property {string|null} [startedDate] ContractOperation startedDate
         * @property {string|null} [endScheduledYM] ContractOperation endScheduledYM
         * @property {string|null} [endedDate] ContractOperation endedDate
         * @property {boolean|null} [reportCompleted] ContractOperation reportCompleted
         * @property {Array.<string>|null} [noReportYMList] ContractOperation noReportYMList
         * @property {common.IDateRange|null} [suspendDateRange] ContractOperation suspendDateRange
         */

        /**
         * Constructs a new ContractOperation.
         * @memberof entity
         * @classdesc Represents a ContractOperation.
         * @implements IContractOperation
         * @constructor
         * @param {entity.IContractOperation=} [properties] Properties to set
         */
        function ContractOperation(properties) {
            this.noReportYMList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractOperation contractID.
         * @member {string} contractID
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.contractID = "";

        /**
         * ContractOperation status.
         * @member {entity.ContractOperation.Status} status
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.status = 0;

        /**
         * ContractOperation startedDate.
         * @member {string} startedDate
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.startedDate = "";

        /**
         * ContractOperation endScheduledYM.
         * @member {string} endScheduledYM
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.endScheduledYM = "";

        /**
         * ContractOperation endedDate.
         * @member {string} endedDate
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.endedDate = "";

        /**
         * ContractOperation reportCompleted.
         * @member {boolean} reportCompleted
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.reportCompleted = false;

        /**
         * ContractOperation noReportYMList.
         * @member {Array.<string>} noReportYMList
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.noReportYMList = $util.emptyArray;

        /**
         * ContractOperation suspendDateRange.
         * @member {common.IDateRange|null|undefined} suspendDateRange
         * @memberof entity.ContractOperation
         * @instance
         */
        ContractOperation.prototype.suspendDateRange = null;

        /**
         * Creates a new ContractOperation instance using the specified properties.
         * @function create
         * @memberof entity.ContractOperation
         * @static
         * @param {entity.IContractOperation=} [properties] Properties to set
         * @returns {entity.ContractOperation} ContractOperation instance
         */
        ContractOperation.create = function create(properties) {
            return new ContractOperation(properties);
        };

        /**
         * Encodes the specified ContractOperation message. Does not implicitly {@link entity.ContractOperation.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractOperation
         * @static
         * @param {entity.IContractOperation} message ContractOperation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.contractID != null && Object.hasOwnProperty.call(message, "contractID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.contractID);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.startedDate != null && Object.hasOwnProperty.call(message, "startedDate"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.startedDate);
            if (message.endScheduledYM != null && Object.hasOwnProperty.call(message, "endScheduledYM"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.endScheduledYM);
            if (message.endedDate != null && Object.hasOwnProperty.call(message, "endedDate"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.endedDate);
            if (message.reportCompleted != null && Object.hasOwnProperty.call(message, "reportCompleted"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.reportCompleted);
            if (message.noReportYMList != null && message.noReportYMList.length)
                for (var i = 0; i < message.noReportYMList.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.noReportYMList[i]);
            if (message.suspendDateRange != null && Object.hasOwnProperty.call(message, "suspendDateRange"))
                $root.common.DateRange.encode(message.suspendDateRange, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContractOperation message, length delimited. Does not implicitly {@link entity.ContractOperation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractOperation
         * @static
         * @param {entity.IContractOperation} message ContractOperation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractOperation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractOperation message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractOperation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractOperation} ContractOperation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractOperation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.contractID = reader.string();
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                case 3:
                    message.startedDate = reader.string();
                    break;
                case 4:
                    message.endScheduledYM = reader.string();
                    break;
                case 5:
                    message.endedDate = reader.string();
                    break;
                case 6:
                    message.reportCompleted = reader.bool();
                    break;
                case 7:
                    if (!(message.noReportYMList && message.noReportYMList.length))
                        message.noReportYMList = [];
                    message.noReportYMList.push(reader.string());
                    break;
                case 8:
                    message.suspendDateRange = $root.common.DateRange.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractOperation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractOperation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractOperation} ContractOperation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractOperation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractOperation message.
         * @function verify
         * @memberof entity.ContractOperation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractOperation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                if (!$util.isString(message.contractID))
                    return "contractID: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.startedDate != null && message.hasOwnProperty("startedDate"))
                if (!$util.isString(message.startedDate))
                    return "startedDate: string expected";
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                if (!$util.isString(message.endScheduledYM))
                    return "endScheduledYM: string expected";
            if (message.endedDate != null && message.hasOwnProperty("endedDate"))
                if (!$util.isString(message.endedDate))
                    return "endedDate: string expected";
            if (message.reportCompleted != null && message.hasOwnProperty("reportCompleted"))
                if (typeof message.reportCompleted !== "boolean")
                    return "reportCompleted: boolean expected";
            if (message.noReportYMList != null && message.hasOwnProperty("noReportYMList")) {
                if (!Array.isArray(message.noReportYMList))
                    return "noReportYMList: array expected";
                for (var i = 0; i < message.noReportYMList.length; ++i)
                    if (!$util.isString(message.noReportYMList[i]))
                        return "noReportYMList: string[] expected";
            }
            if (message.suspendDateRange != null && message.hasOwnProperty("suspendDateRange")) {
                var error = $root.common.DateRange.verify(message.suspendDateRange);
                if (error)
                    return "suspendDateRange." + error;
            }
            return null;
        };

        /**
         * Creates a ContractOperation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractOperation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractOperation} ContractOperation
         */
        ContractOperation.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractOperation)
                return object;
            var message = new $root.entity.ContractOperation();
            if (object.contractID != null)
                message.contractID = String(object.contractID);
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_InProgress":
            case 1:
                message.status = 1;
                break;
            case "Status_Completed":
            case 2:
                message.status = 2;
                break;
            case "Status_Suspended":
            case 3:
                message.status = 3;
                break;
            }
            if (object.startedDate != null)
                message.startedDate = String(object.startedDate);
            if (object.endScheduledYM != null)
                message.endScheduledYM = String(object.endScheduledYM);
            if (object.endedDate != null)
                message.endedDate = String(object.endedDate);
            if (object.reportCompleted != null)
                message.reportCompleted = Boolean(object.reportCompleted);
            if (object.noReportYMList) {
                if (!Array.isArray(object.noReportYMList))
                    throw TypeError(".entity.ContractOperation.noReportYMList: array expected");
                message.noReportYMList = [];
                for (var i = 0; i < object.noReportYMList.length; ++i)
                    message.noReportYMList[i] = String(object.noReportYMList[i]);
            }
            if (object.suspendDateRange != null) {
                if (typeof object.suspendDateRange !== "object")
                    throw TypeError(".entity.ContractOperation.suspendDateRange: object expected");
                message.suspendDateRange = $root.common.DateRange.fromObject(object.suspendDateRange);
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractOperation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractOperation
         * @static
         * @param {entity.ContractOperation} message ContractOperation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractOperation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.noReportYMList = [];
            if (options.defaults) {
                object.contractID = "";
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.startedDate = "";
                object.endScheduledYM = "";
                object.endedDate = "";
                object.reportCompleted = false;
                object.suspendDateRange = null;
            }
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                object.contractID = message.contractID;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.ContractOperation.Status[message.status] : message.status;
            if (message.startedDate != null && message.hasOwnProperty("startedDate"))
                object.startedDate = message.startedDate;
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                object.endScheduledYM = message.endScheduledYM;
            if (message.endedDate != null && message.hasOwnProperty("endedDate"))
                object.endedDate = message.endedDate;
            if (message.reportCompleted != null && message.hasOwnProperty("reportCompleted"))
                object.reportCompleted = message.reportCompleted;
            if (message.noReportYMList && message.noReportYMList.length) {
                object.noReportYMList = [];
                for (var j = 0; j < message.noReportYMList.length; ++j)
                    object.noReportYMList[j] = message.noReportYMList[j];
            }
            if (message.suspendDateRange != null && message.hasOwnProperty("suspendDateRange"))
                object.suspendDateRange = $root.common.DateRange.toObject(message.suspendDateRange, options);
            return object;
        };

        /**
         * Converts this ContractOperation to JSON.
         * @function toJSON
         * @memberof entity.ContractOperation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractOperation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Status enum.
         * @name entity.ContractOperation.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_InProgress=1 Status_InProgress value
         * @property {number} Status_Completed=2 Status_Completed value
         * @property {number} Status_Suspended=3 Status_Suspended value
         */
        ContractOperation.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_InProgress"] = 1;
            values[valuesById[2] = "Status_Completed"] = 2;
            values[valuesById[3] = "Status_Suspended"] = 3;
            return values;
        })();

        return ContractOperation;
    })();

    entity.ContractID = (function() {

        /**
         * Properties of a ContractID.
         * @memberof entity
         * @interface IContractID
         * @property {string|null} [id] ContractID id
         */

        /**
         * Constructs a new ContractID.
         * @memberof entity
         * @classdesc Represents a ContractID.
         * @implements IContractID
         * @constructor
         * @param {entity.IContractID=} [properties] Properties to set
         */
        function ContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractID id.
         * @member {string} id
         * @memberof entity.ContractID
         * @instance
         */
        ContractID.prototype.id = "";

        /**
         * Creates a new ContractID instance using the specified properties.
         * @function create
         * @memberof entity.ContractID
         * @static
         * @param {entity.IContractID=} [properties] Properties to set
         * @returns {entity.ContractID} ContractID instance
         */
        ContractID.create = function create(properties) {
            return new ContractID(properties);
        };

        /**
         * Encodes the specified ContractID message. Does not implicitly {@link entity.ContractID.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractID
         * @static
         * @param {entity.IContractID} message ContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ContractID message, length delimited. Does not implicitly {@link entity.ContractID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractID
         * @static
         * @param {entity.IContractID} message ContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractID} ContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractID} ContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractID message.
         * @function verify
         * @memberof entity.ContractID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ContractID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractID} ContractID
         */
        ContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractID)
                return object;
            var message = new $root.entity.ContractID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ContractID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractID
         * @static
         * @param {entity.ContractID} message ContractID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ContractID to JSON.
         * @function toJSON
         * @memberof entity.ContractID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractID;
    })();

    entity.ContractIDWithPager = (function() {

        /**
         * Properties of a ContractIDWithPager.
         * @memberof entity
         * @interface IContractIDWithPager
         * @property {string|null} [id] ContractIDWithPager id
         * @property {common.IPager|null} [pager] ContractIDWithPager pager
         */

        /**
         * Constructs a new ContractIDWithPager.
         * @memberof entity
         * @classdesc Represents a ContractIDWithPager.
         * @implements IContractIDWithPager
         * @constructor
         * @param {entity.IContractIDWithPager=} [properties] Properties to set
         */
        function ContractIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractIDWithPager id.
         * @member {string} id
         * @memberof entity.ContractIDWithPager
         * @instance
         */
        ContractIDWithPager.prototype.id = "";

        /**
         * ContractIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.ContractIDWithPager
         * @instance
         */
        ContractIDWithPager.prototype.pager = null;

        /**
         * Creates a new ContractIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {entity.IContractIDWithPager=} [properties] Properties to set
         * @returns {entity.ContractIDWithPager} ContractIDWithPager instance
         */
        ContractIDWithPager.create = function create(properties) {
            return new ContractIDWithPager(properties);
        };

        /**
         * Encodes the specified ContractIDWithPager message. Does not implicitly {@link entity.ContractIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {entity.IContractIDWithPager} message ContractIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContractIDWithPager message, length delimited. Does not implicitly {@link entity.ContractIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {entity.IContractIDWithPager} message ContractIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractIDWithPager} ContractIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractIDWithPager} ContractIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractIDWithPager message.
         * @function verify
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a ContractIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractIDWithPager} ContractIDWithPager
         */
        ContractIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractIDWithPager)
                return object;
            var message = new $root.entity.ContractIDWithPager();
            if (object.id != null)
                message.id = String(object.id);
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.ContractIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractIDWithPager
         * @static
         * @param {entity.ContractIDWithPager} message ContractIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.pager = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this ContractIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.ContractIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractIDWithPager;
    })();

    entity.Contract = (function() {

        /**
         * Properties of a Contract.
         * @memberof entity
         * @interface IContract
         * @property {string|null} [id] Contract id
         * @property {string|null} [companyID] Contract companyID
         * @property {string|null} [projectID] Contract projectID
         * @property {string|null} [customerID] Contract customerID
         * @property {string|null} [title] Contract title
         * @property {string|null} [description] Contract description
         * @property {number|null} [meetingNum] Contract meetingNum
         * @property {entity.Contract.Interval|null} [meetingInterval] Contract meetingInterval
         * @property {number|null} [meetingMinutes] Contract meetingMinutes
         * @property {number|null} [workingHour] Contract workingHour
         * @property {entity.Contract.Interval|null} [workingInterval] Contract workingInterval
         * @property {number|null} [feePerMonth] Contract feePerMonth
         * @property {entity.Contract.Type|null} [contractType] Contract contractType
         * @property {string|null} [startFromYM] Contract startFromYM
         * @property {string|null} [endToYM] Contract endToYM
         * @property {string|null} [gsFileURL] Contract gsFileURL
         * @property {string|null} [signedFileURL] Contract signedFileURL
         * @property {entity.Contract.Requester|null} [requester] Contract requester
         * @property {boolean|null} [isApproved] Contract isApproved
         * @property {string|null} [approvedAt] Contract approvedAt
         * @property {string|null} [createdAt] Contract createdAt
         * @property {string|null} [updatedAt] Contract updatedAt
         * @property {boolean|null} [hasSupport] Contract hasSupport
         * @property {string|null} [companyName] Contract companyName
         * @property {string|null} [projectName] Contract projectName
         * @property {string|null} [customerName] Contract customerName
         * @property {string|null} [customerCatchphrase] Contract customerCatchphrase
         * @property {string|null} [customerJobCareerCatchphrase] Contract customerJobCareerCatchphrase
         * @property {string|null} [customerSignedIconURL] Contract customerSignedIconURL
         * @property {entity.IContractOperation|null} [operation] Contract operation
         */

        /**
         * Constructs a new Contract.
         * @memberof entity
         * @classdesc Represents a Contract.
         * @implements IContract
         * @constructor
         * @param {entity.IContract=} [properties] Properties to set
         */
        function Contract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Contract id.
         * @member {string} id
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.id = "";

        /**
         * Contract companyID.
         * @member {string} companyID
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.companyID = "";

        /**
         * Contract projectID.
         * @member {string} projectID
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.projectID = "";

        /**
         * Contract customerID.
         * @member {string} customerID
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.customerID = "";

        /**
         * Contract title.
         * @member {string} title
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.title = "";

        /**
         * Contract description.
         * @member {string} description
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.description = "";

        /**
         * Contract meetingNum.
         * @member {number} meetingNum
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.meetingNum = 0;

        /**
         * Contract meetingInterval.
         * @member {entity.Contract.Interval} meetingInterval
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.meetingInterval = 0;

        /**
         * Contract meetingMinutes.
         * @member {number} meetingMinutes
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.meetingMinutes = 0;

        /**
         * Contract workingHour.
         * @member {number} workingHour
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.workingHour = 0;

        /**
         * Contract workingInterval.
         * @member {entity.Contract.Interval} workingInterval
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.workingInterval = 0;

        /**
         * Contract feePerMonth.
         * @member {number} feePerMonth
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.feePerMonth = 0;

        /**
         * Contract contractType.
         * @member {entity.Contract.Type} contractType
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.contractType = 0;

        /**
         * Contract startFromYM.
         * @member {string} startFromYM
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.startFromYM = "";

        /**
         * Contract endToYM.
         * @member {string} endToYM
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.endToYM = "";

        /**
         * Contract gsFileURL.
         * @member {string} gsFileURL
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.gsFileURL = "";

        /**
         * Contract signedFileURL.
         * @member {string} signedFileURL
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.signedFileURL = "";

        /**
         * Contract requester.
         * @member {entity.Contract.Requester} requester
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.requester = 0;

        /**
         * Contract isApproved.
         * @member {boolean} isApproved
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.isApproved = false;

        /**
         * Contract approvedAt.
         * @member {string} approvedAt
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.approvedAt = "";

        /**
         * Contract createdAt.
         * @member {string} createdAt
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.createdAt = "";

        /**
         * Contract updatedAt.
         * @member {string} updatedAt
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.updatedAt = "";

        /**
         * Contract hasSupport.
         * @member {boolean} hasSupport
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.hasSupport = false;

        /**
         * Contract companyName.
         * @member {string} companyName
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.companyName = "";

        /**
         * Contract projectName.
         * @member {string} projectName
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.projectName = "";

        /**
         * Contract customerName.
         * @member {string} customerName
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.customerName = "";

        /**
         * Contract customerCatchphrase.
         * @member {string} customerCatchphrase
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.customerCatchphrase = "";

        /**
         * Contract customerJobCareerCatchphrase.
         * @member {string} customerJobCareerCatchphrase
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.customerJobCareerCatchphrase = "";

        /**
         * Contract customerSignedIconURL.
         * @member {string} customerSignedIconURL
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.customerSignedIconURL = "";

        /**
         * Contract operation.
         * @member {entity.IContractOperation|null|undefined} operation
         * @memberof entity.Contract
         * @instance
         */
        Contract.prototype.operation = null;

        /**
         * Creates a new Contract instance using the specified properties.
         * @function create
         * @memberof entity.Contract
         * @static
         * @param {entity.IContract=} [properties] Properties to set
         * @returns {entity.Contract} Contract instance
         */
        Contract.create = function create(properties) {
            return new Contract(properties);
        };

        /**
         * Encodes the specified Contract message. Does not implicitly {@link entity.Contract.verify|verify} messages.
         * @function encode
         * @memberof entity.Contract
         * @static
         * @param {entity.IContract} message Contract message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contract.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.companyID);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerID);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
            if (message.meetingNum != null && Object.hasOwnProperty.call(message, "meetingNum"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.meetingNum);
            if (message.meetingInterval != null && Object.hasOwnProperty.call(message, "meetingInterval"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.meetingInterval);
            if (message.meetingMinutes != null && Object.hasOwnProperty.call(message, "meetingMinutes"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.meetingMinutes);
            if (message.workingHour != null && Object.hasOwnProperty.call(message, "workingHour"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workingHour);
            if (message.workingInterval != null && Object.hasOwnProperty.call(message, "workingInterval"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workingInterval);
            if (message.feePerMonth != null && Object.hasOwnProperty.call(message, "feePerMonth"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.feePerMonth);
            if (message.contractType != null && Object.hasOwnProperty.call(message, "contractType"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.contractType);
            if (message.startFromYM != null && Object.hasOwnProperty.call(message, "startFromYM"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.startFromYM);
            if (message.endToYM != null && Object.hasOwnProperty.call(message, "endToYM"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.endToYM);
            if (message.gsFileURL != null && Object.hasOwnProperty.call(message, "gsFileURL"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.gsFileURL);
            if (message.signedFileURL != null && Object.hasOwnProperty.call(message, "signedFileURL"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.signedFileURL);
            if (message.requester != null && Object.hasOwnProperty.call(message, "requester"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.requester);
            if (message.isApproved != null && Object.hasOwnProperty.call(message, "isApproved"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.isApproved);
            if (message.approvedAt != null && Object.hasOwnProperty.call(message, "approvedAt"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.approvedAt);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.updatedAt);
            if (message.hasSupport != null && Object.hasOwnProperty.call(message, "hasSupport"))
                writer.uint32(/* id 22, wireType 0 =*/176).bool(message.hasSupport);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.companyName);
            if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.projectName);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 25, wireType 2 =*/202).string(message.customerName);
            if (message.customerCatchphrase != null && Object.hasOwnProperty.call(message, "customerCatchphrase"))
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.customerCatchphrase);
            if (message.customerJobCareerCatchphrase != null && Object.hasOwnProperty.call(message, "customerJobCareerCatchphrase"))
                writer.uint32(/* id 27, wireType 2 =*/218).string(message.customerJobCareerCatchphrase);
            if (message.customerSignedIconURL != null && Object.hasOwnProperty.call(message, "customerSignedIconURL"))
                writer.uint32(/* id 28, wireType 2 =*/226).string(message.customerSignedIconURL);
            if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                $root.entity.ContractOperation.encode(message.operation, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 999, wireType 2 =*/7994).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified Contract message, length delimited. Does not implicitly {@link entity.Contract.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Contract
         * @static
         * @param {entity.IContract} message Contract message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contract.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Contract message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Contract
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Contract} Contract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contract.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Contract();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 999:
                    message.id = reader.string();
                    break;
                case 1:
                    message.companyID = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.customerID = reader.string();
                    break;
                case 4:
                    message.title = reader.string();
                    break;
                case 5:
                    message.description = reader.string();
                    break;
                case 6:
                    message.meetingNum = reader.int32();
                    break;
                case 7:
                    message.meetingInterval = reader.int32();
                    break;
                case 8:
                    message.meetingMinutes = reader.int32();
                    break;
                case 9:
                    message.workingHour = reader.int32();
                    break;
                case 10:
                    message.workingInterval = reader.int32();
                    break;
                case 11:
                    message.feePerMonth = reader.int32();
                    break;
                case 12:
                    message.contractType = reader.int32();
                    break;
                case 13:
                    message.startFromYM = reader.string();
                    break;
                case 14:
                    message.endToYM = reader.string();
                    break;
                case 15:
                    message.gsFileURL = reader.string();
                    break;
                case 16:
                    message.signedFileURL = reader.string();
                    break;
                case 17:
                    message.requester = reader.int32();
                    break;
                case 18:
                    message.isApproved = reader.bool();
                    break;
                case 19:
                    message.approvedAt = reader.string();
                    break;
                case 20:
                    message.createdAt = reader.string();
                    break;
                case 21:
                    message.updatedAt = reader.string();
                    break;
                case 22:
                    message.hasSupport = reader.bool();
                    break;
                case 23:
                    message.companyName = reader.string();
                    break;
                case 24:
                    message.projectName = reader.string();
                    break;
                case 25:
                    message.customerName = reader.string();
                    break;
                case 26:
                    message.customerCatchphrase = reader.string();
                    break;
                case 27:
                    message.customerJobCareerCatchphrase = reader.string();
                    break;
                case 28:
                    message.customerSignedIconURL = reader.string();
                    break;
                case 30:
                    message.operation = $root.entity.ContractOperation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Contract message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Contract
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Contract} Contract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contract.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Contract message.
         * @function verify
         * @memberof entity.Contract
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Contract.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                if (!$util.isInteger(message.meetingNum))
                    return "meetingNum: integer expected";
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                switch (message.meetingInterval) {
                default:
                    return "meetingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                if (!$util.isInteger(message.meetingMinutes))
                    return "meetingMinutes: integer expected";
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                if (!$util.isInteger(message.workingHour))
                    return "workingHour: integer expected";
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                switch (message.workingInterval) {
                default:
                    return "workingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                if (!$util.isInteger(message.feePerMonth))
                    return "feePerMonth: integer expected";
            if (message.contractType != null && message.hasOwnProperty("contractType"))
                switch (message.contractType) {
                default:
                    return "contractType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.startFromYM != null && message.hasOwnProperty("startFromYM"))
                if (!$util.isString(message.startFromYM))
                    return "startFromYM: string expected";
            if (message.endToYM != null && message.hasOwnProperty("endToYM"))
                if (!$util.isString(message.endToYM))
                    return "endToYM: string expected";
            if (message.gsFileURL != null && message.hasOwnProperty("gsFileURL"))
                if (!$util.isString(message.gsFileURL))
                    return "gsFileURL: string expected";
            if (message.signedFileURL != null && message.hasOwnProperty("signedFileURL"))
                if (!$util.isString(message.signedFileURL))
                    return "signedFileURL: string expected";
            if (message.requester != null && message.hasOwnProperty("requester"))
                switch (message.requester) {
                default:
                    return "requester: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.isApproved != null && message.hasOwnProperty("isApproved"))
                if (typeof message.isApproved !== "boolean")
                    return "isApproved: boolean expected";
            if (message.approvedAt != null && message.hasOwnProperty("approvedAt"))
                if (!$util.isString(message.approvedAt))
                    return "approvedAt: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            if (message.hasSupport != null && message.hasOwnProperty("hasSupport"))
                if (typeof message.hasSupport !== "boolean")
                    return "hasSupport: boolean expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                if (!$util.isString(message.projectName))
                    return "projectName: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.customerCatchphrase != null && message.hasOwnProperty("customerCatchphrase"))
                if (!$util.isString(message.customerCatchphrase))
                    return "customerCatchphrase: string expected";
            if (message.customerJobCareerCatchphrase != null && message.hasOwnProperty("customerJobCareerCatchphrase"))
                if (!$util.isString(message.customerJobCareerCatchphrase))
                    return "customerJobCareerCatchphrase: string expected";
            if (message.customerSignedIconURL != null && message.hasOwnProperty("customerSignedIconURL"))
                if (!$util.isString(message.customerSignedIconURL))
                    return "customerSignedIconURL: string expected";
            if (message.operation != null && message.hasOwnProperty("operation")) {
                var error = $root.entity.ContractOperation.verify(message.operation);
                if (error)
                    return "operation." + error;
            }
            return null;
        };

        /**
         * Creates a Contract message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Contract
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Contract} Contract
         */
        Contract.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Contract)
                return object;
            var message = new $root.entity.Contract();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.meetingNum != null)
                message.meetingNum = object.meetingNum | 0;
            switch (object.meetingInterval) {
            case "Interval_Unknown":
            case 0:
                message.meetingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.meetingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.meetingInterval = 2;
                break;
            }
            if (object.meetingMinutes != null)
                message.meetingMinutes = object.meetingMinutes | 0;
            if (object.workingHour != null)
                message.workingHour = object.workingHour | 0;
            switch (object.workingInterval) {
            case "Interval_Unknown":
            case 0:
                message.workingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.workingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.workingInterval = 2;
                break;
            }
            if (object.feePerMonth != null)
                message.feePerMonth = object.feePerMonth | 0;
            switch (object.contractType) {
            case "Type_Unknown":
            case 0:
                message.contractType = 0;
                break;
            case "Type_Delegation":
            case 1:
                message.contractType = 1;
                break;
            case "Type_Contract":
            case 2:
                message.contractType = 2;
                break;
            case "Type_Other":
            case 3:
                message.contractType = 3;
                break;
            }
            if (object.startFromYM != null)
                message.startFromYM = String(object.startFromYM);
            if (object.endToYM != null)
                message.endToYM = String(object.endToYM);
            if (object.gsFileURL != null)
                message.gsFileURL = String(object.gsFileURL);
            if (object.signedFileURL != null)
                message.signedFileURL = String(object.signedFileURL);
            switch (object.requester) {
            case "Requester_Unknown":
            case 0:
                message.requester = 0;
                break;
            case "Requester_Company":
            case 1:
                message.requester = 1;
                break;
            case "Requester_Customer":
            case 2:
                message.requester = 2;
                break;
            case "Requester_Admin":
            case 3:
                message.requester = 3;
                break;
            }
            if (object.isApproved != null)
                message.isApproved = Boolean(object.isApproved);
            if (object.approvedAt != null)
                message.approvedAt = String(object.approvedAt);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            if (object.hasSupport != null)
                message.hasSupport = Boolean(object.hasSupport);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.projectName != null)
                message.projectName = String(object.projectName);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.customerCatchphrase != null)
                message.customerCatchphrase = String(object.customerCatchphrase);
            if (object.customerJobCareerCatchphrase != null)
                message.customerJobCareerCatchphrase = String(object.customerJobCareerCatchphrase);
            if (object.customerSignedIconURL != null)
                message.customerSignedIconURL = String(object.customerSignedIconURL);
            if (object.operation != null) {
                if (typeof object.operation !== "object")
                    throw TypeError(".entity.Contract.operation: object expected");
                message.operation = $root.entity.ContractOperation.fromObject(object.operation);
            }
            return message;
        };

        /**
         * Creates a plain object from a Contract message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Contract
         * @static
         * @param {entity.Contract} message Contract
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Contract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.companyID = "";
                object.projectID = "";
                object.customerID = "";
                object.title = "";
                object.description = "";
                object.meetingNum = 0;
                object.meetingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.meetingMinutes = 0;
                object.workingHour = 0;
                object.workingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.feePerMonth = 0;
                object.contractType = options.enums === String ? "Type_Unknown" : 0;
                object.startFromYM = "";
                object.endToYM = "";
                object.gsFileURL = "";
                object.signedFileURL = "";
                object.requester = options.enums === String ? "Requester_Unknown" : 0;
                object.isApproved = false;
                object.approvedAt = "";
                object.createdAt = "";
                object.updatedAt = "";
                object.hasSupport = false;
                object.companyName = "";
                object.projectName = "";
                object.customerName = "";
                object.customerCatchphrase = "";
                object.customerJobCareerCatchphrase = "";
                object.customerSignedIconURL = "";
                object.operation = null;
                object.id = "";
            }
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                object.meetingNum = message.meetingNum;
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                object.meetingInterval = options.enums === String ? $root.entity.Contract.Interval[message.meetingInterval] : message.meetingInterval;
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                object.meetingMinutes = message.meetingMinutes;
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                object.workingHour = message.workingHour;
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                object.workingInterval = options.enums === String ? $root.entity.Contract.Interval[message.workingInterval] : message.workingInterval;
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                object.feePerMonth = message.feePerMonth;
            if (message.contractType != null && message.hasOwnProperty("contractType"))
                object.contractType = options.enums === String ? $root.entity.Contract.Type[message.contractType] : message.contractType;
            if (message.startFromYM != null && message.hasOwnProperty("startFromYM"))
                object.startFromYM = message.startFromYM;
            if (message.endToYM != null && message.hasOwnProperty("endToYM"))
                object.endToYM = message.endToYM;
            if (message.gsFileURL != null && message.hasOwnProperty("gsFileURL"))
                object.gsFileURL = message.gsFileURL;
            if (message.signedFileURL != null && message.hasOwnProperty("signedFileURL"))
                object.signedFileURL = message.signedFileURL;
            if (message.requester != null && message.hasOwnProperty("requester"))
                object.requester = options.enums === String ? $root.entity.Contract.Requester[message.requester] : message.requester;
            if (message.isApproved != null && message.hasOwnProperty("isApproved"))
                object.isApproved = message.isApproved;
            if (message.approvedAt != null && message.hasOwnProperty("approvedAt"))
                object.approvedAt = message.approvedAt;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            if (message.hasSupport != null && message.hasOwnProperty("hasSupport"))
                object.hasSupport = message.hasSupport;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                object.projectName = message.projectName;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.customerCatchphrase != null && message.hasOwnProperty("customerCatchphrase"))
                object.customerCatchphrase = message.customerCatchphrase;
            if (message.customerJobCareerCatchphrase != null && message.hasOwnProperty("customerJobCareerCatchphrase"))
                object.customerJobCareerCatchphrase = message.customerJobCareerCatchphrase;
            if (message.customerSignedIconURL != null && message.hasOwnProperty("customerSignedIconURL"))
                object.customerSignedIconURL = message.customerSignedIconURL;
            if (message.operation != null && message.hasOwnProperty("operation"))
                object.operation = $root.entity.ContractOperation.toObject(message.operation, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this Contract to JSON.
         * @function toJSON
         * @memberof entity.Contract
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Contract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Requester enum.
         * @name entity.Contract.Requester
         * @enum {number}
         * @property {number} Requester_Unknown=0 Requester_Unknown value
         * @property {number} Requester_Company=1 Requester_Company value
         * @property {number} Requester_Customer=2 Requester_Customer value
         * @property {number} Requester_Admin=3 Requester_Admin value
         */
        Contract.Requester = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Requester_Unknown"] = 0;
            values[valuesById[1] = "Requester_Company"] = 1;
            values[valuesById[2] = "Requester_Customer"] = 2;
            values[valuesById[3] = "Requester_Admin"] = 3;
            return values;
        })();

        /**
         * Interval enum.
         * @name entity.Contract.Interval
         * @enum {number}
         * @property {number} Interval_Unknown=0 Interval_Unknown value
         * @property {number} Interval_Week=1 Interval_Week value
         * @property {number} Interval_Month=2 Interval_Month value
         */
        Contract.Interval = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Interval_Unknown"] = 0;
            values[valuesById[1] = "Interval_Week"] = 1;
            values[valuesById[2] = "Interval_Month"] = 2;
            return values;
        })();

        /**
         * Type enum.
         * @name entity.Contract.Type
         * @enum {number}
         * @property {number} Type_Unknown=0 Type_Unknown value
         * @property {number} Type_Delegation=1 Type_Delegation value
         * @property {number} Type_Contract=2 Type_Contract value
         * @property {number} Type_Other=3 Type_Other value
         */
        Contract.Type = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Type_Unknown"] = 0;
            values[valuesById[1] = "Type_Delegation"] = 1;
            values[valuesById[2] = "Type_Contract"] = 2;
            values[valuesById[3] = "Type_Other"] = 3;
            return values;
        })();

        return Contract;
    })();

    entity.ContractList = (function() {

        /**
         * Properties of a ContractList.
         * @memberof entity
         * @interface IContractList
         * @property {Array.<entity.IContract>|null} [items] ContractList items
         */

        /**
         * Constructs a new ContractList.
         * @memberof entity
         * @classdesc Represents a ContractList.
         * @implements IContractList
         * @constructor
         * @param {entity.IContractList=} [properties] Properties to set
         */
        function ContractList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractList items.
         * @member {Array.<entity.IContract>} items
         * @memberof entity.ContractList
         * @instance
         */
        ContractList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ContractList instance using the specified properties.
         * @function create
         * @memberof entity.ContractList
         * @static
         * @param {entity.IContractList=} [properties] Properties to set
         * @returns {entity.ContractList} ContractList instance
         */
        ContractList.create = function create(properties) {
            return new ContractList(properties);
        };

        /**
         * Encodes the specified ContractList message. Does not implicitly {@link entity.ContractList.verify|verify} messages.
         * @function encode
         * @memberof entity.ContractList
         * @static
         * @param {entity.IContractList} message ContractList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Contract.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContractList message, length delimited. Does not implicitly {@link entity.ContractList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ContractList
         * @static
         * @param {entity.IContractList} message ContractList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContractList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContractList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ContractList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ContractList} ContractList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ContractList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Contract.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContractList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ContractList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ContractList} ContractList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContractList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContractList message.
         * @function verify
         * @memberof entity.ContractList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContractList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Contract.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ContractList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ContractList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ContractList} ContractList
         */
        ContractList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ContractList)
                return object;
            var message = new $root.entity.ContractList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ContractList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ContractList.items: object expected");
                    message.items[i] = $root.entity.Contract.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ContractList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ContractList
         * @static
         * @param {entity.ContractList} message ContractList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Contract.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ContractList to JSON.
         * @function toJSON
         * @memberof entity.ContractList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractList;
    })();

    entity.CustomerBlackList = (function() {

        /**
         * Properties of a CustomerBlackList.
         * @memberof entity
         * @interface ICustomerBlackList
         * @property {string|null} [customerID] CustomerBlackList customerID
         * @property {Array.<string>|null} [domains] CustomerBlackList domains
         */

        /**
         * Constructs a new CustomerBlackList.
         * @memberof entity
         * @classdesc Represents a CustomerBlackList.
         * @implements ICustomerBlackList
         * @constructor
         * @param {entity.ICustomerBlackList=} [properties] Properties to set
         */
        function CustomerBlackList(properties) {
            this.domains = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerBlackList customerID.
         * @member {string} customerID
         * @memberof entity.CustomerBlackList
         * @instance
         */
        CustomerBlackList.prototype.customerID = "";

        /**
         * CustomerBlackList domains.
         * @member {Array.<string>} domains
         * @memberof entity.CustomerBlackList
         * @instance
         */
        CustomerBlackList.prototype.domains = $util.emptyArray;

        /**
         * Creates a new CustomerBlackList instance using the specified properties.
         * @function create
         * @memberof entity.CustomerBlackList
         * @static
         * @param {entity.ICustomerBlackList=} [properties] Properties to set
         * @returns {entity.CustomerBlackList} CustomerBlackList instance
         */
        CustomerBlackList.create = function create(properties) {
            return new CustomerBlackList(properties);
        };

        /**
         * Encodes the specified CustomerBlackList message. Does not implicitly {@link entity.CustomerBlackList.verify|verify} messages.
         * @function encode
         * @memberof entity.CustomerBlackList
         * @static
         * @param {entity.ICustomerBlackList} message CustomerBlackList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerBlackList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customerID);
            if (message.domains != null && message.domains.length)
                for (var i = 0; i < message.domains.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.domains[i]);
            return writer;
        };

        /**
         * Encodes the specified CustomerBlackList message, length delimited. Does not implicitly {@link entity.CustomerBlackList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CustomerBlackList
         * @static
         * @param {entity.ICustomerBlackList} message CustomerBlackList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerBlackList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerBlackList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CustomerBlackList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CustomerBlackList} CustomerBlackList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerBlackList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CustomerBlackList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customerID = reader.string();
                    break;
                case 2:
                    if (!(message.domains && message.domains.length))
                        message.domains = [];
                    message.domains.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerBlackList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CustomerBlackList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CustomerBlackList} CustomerBlackList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerBlackList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerBlackList message.
         * @function verify
         * @memberof entity.CustomerBlackList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerBlackList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.domains != null && message.hasOwnProperty("domains")) {
                if (!Array.isArray(message.domains))
                    return "domains: array expected";
                for (var i = 0; i < message.domains.length; ++i)
                    if (!$util.isString(message.domains[i]))
                        return "domains: string[] expected";
            }
            return null;
        };

        /**
         * Creates a CustomerBlackList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CustomerBlackList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CustomerBlackList} CustomerBlackList
         */
        CustomerBlackList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CustomerBlackList)
                return object;
            var message = new $root.entity.CustomerBlackList();
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.domains) {
                if (!Array.isArray(object.domains))
                    throw TypeError(".entity.CustomerBlackList.domains: array expected");
                message.domains = [];
                for (var i = 0; i < object.domains.length; ++i)
                    message.domains[i] = String(object.domains[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomerBlackList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CustomerBlackList
         * @static
         * @param {entity.CustomerBlackList} message CustomerBlackList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerBlackList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.domains = [];
            if (options.defaults)
                object.customerID = "";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.domains && message.domains.length) {
                object.domains = [];
                for (var j = 0; j < message.domains.length; ++j)
                    object.domains[j] = message.domains[j];
            }
            return object;
        };

        /**
         * Converts this CustomerBlackList to JSON.
         * @function toJSON
         * @memberof entity.CustomerBlackList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerBlackList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerBlackList;
    })();

    entity.CustomerID = (function() {

        /**
         * Properties of a CustomerID.
         * @memberof entity
         * @interface ICustomerID
         * @property {string|null} [id] CustomerID id
         */

        /**
         * Constructs a new CustomerID.
         * @memberof entity
         * @classdesc Represents a CustomerID.
         * @implements ICustomerID
         * @constructor
         * @param {entity.ICustomerID=} [properties] Properties to set
         */
        function CustomerID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerID id.
         * @member {string} id
         * @memberof entity.CustomerID
         * @instance
         */
        CustomerID.prototype.id = "";

        /**
         * Creates a new CustomerID instance using the specified properties.
         * @function create
         * @memberof entity.CustomerID
         * @static
         * @param {entity.ICustomerID=} [properties] Properties to set
         * @returns {entity.CustomerID} CustomerID instance
         */
        CustomerID.create = function create(properties) {
            return new CustomerID(properties);
        };

        /**
         * Encodes the specified CustomerID message. Does not implicitly {@link entity.CustomerID.verify|verify} messages.
         * @function encode
         * @memberof entity.CustomerID
         * @static
         * @param {entity.ICustomerID} message CustomerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified CustomerID message, length delimited. Does not implicitly {@link entity.CustomerID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CustomerID
         * @static
         * @param {entity.ICustomerID} message CustomerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CustomerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CustomerID} CustomerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CustomerID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CustomerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CustomerID} CustomerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerID message.
         * @function verify
         * @memberof entity.CustomerID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a CustomerID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CustomerID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CustomerID} CustomerID
         */
        CustomerID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CustomerID)
                return object;
            var message = new $root.entity.CustomerID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a CustomerID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CustomerID
         * @static
         * @param {entity.CustomerID} message CustomerID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this CustomerID to JSON.
         * @function toJSON
         * @memberof entity.CustomerID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerID;
    })();

    entity.CustomerIDWithPager = (function() {

        /**
         * Properties of a CustomerIDWithPager.
         * @memberof entity
         * @interface ICustomerIDWithPager
         * @property {string|null} [id] CustomerIDWithPager id
         * @property {common.IPager|null} [pager] CustomerIDWithPager pager
         */

        /**
         * Constructs a new CustomerIDWithPager.
         * @memberof entity
         * @classdesc Represents a CustomerIDWithPager.
         * @implements ICustomerIDWithPager
         * @constructor
         * @param {entity.ICustomerIDWithPager=} [properties] Properties to set
         */
        function CustomerIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerIDWithPager id.
         * @member {string} id
         * @memberof entity.CustomerIDWithPager
         * @instance
         */
        CustomerIDWithPager.prototype.id = "";

        /**
         * CustomerIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.CustomerIDWithPager
         * @instance
         */
        CustomerIDWithPager.prototype.pager = null;

        /**
         * Creates a new CustomerIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {entity.ICustomerIDWithPager=} [properties] Properties to set
         * @returns {entity.CustomerIDWithPager} CustomerIDWithPager instance
         */
        CustomerIDWithPager.create = function create(properties) {
            return new CustomerIDWithPager(properties);
        };

        /**
         * Encodes the specified CustomerIDWithPager message. Does not implicitly {@link entity.CustomerIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {entity.ICustomerIDWithPager} message CustomerIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CustomerIDWithPager message, length delimited. Does not implicitly {@link entity.CustomerIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {entity.ICustomerIDWithPager} message CustomerIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CustomerIDWithPager} CustomerIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CustomerIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CustomerIDWithPager} CustomerIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerIDWithPager message.
         * @function verify
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a CustomerIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CustomerIDWithPager} CustomerIDWithPager
         */
        CustomerIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CustomerIDWithPager)
                return object;
            var message = new $root.entity.CustomerIDWithPager();
            if (object.id != null)
                message.id = String(object.id);
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.CustomerIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomerIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CustomerIDWithPager
         * @static
         * @param {entity.CustomerIDWithPager} message CustomerIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.pager = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this CustomerIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.CustomerIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerIDWithPager;
    })();

    entity.CustomerIDList = (function() {

        /**
         * Properties of a CustomerIDList.
         * @memberof entity
         * @interface ICustomerIDList
         * @property {Array.<string>|null} [ids] CustomerIDList ids
         */

        /**
         * Constructs a new CustomerIDList.
         * @memberof entity
         * @classdesc Represents a CustomerIDList.
         * @implements ICustomerIDList
         * @constructor
         * @param {entity.ICustomerIDList=} [properties] Properties to set
         */
        function CustomerIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.CustomerIDList
         * @instance
         */
        CustomerIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new CustomerIDList instance using the specified properties.
         * @function create
         * @memberof entity.CustomerIDList
         * @static
         * @param {entity.ICustomerIDList=} [properties] Properties to set
         * @returns {entity.CustomerIDList} CustomerIDList instance
         */
        CustomerIDList.create = function create(properties) {
            return new CustomerIDList(properties);
        };

        /**
         * Encodes the specified CustomerIDList message. Does not implicitly {@link entity.CustomerIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.CustomerIDList
         * @static
         * @param {entity.ICustomerIDList} message CustomerIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified CustomerIDList message, length delimited. Does not implicitly {@link entity.CustomerIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CustomerIDList
         * @static
         * @param {entity.ICustomerIDList} message CustomerIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CustomerIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CustomerIDList} CustomerIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CustomerIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CustomerIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CustomerIDList} CustomerIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerIDList message.
         * @function verify
         * @memberof entity.CustomerIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a CustomerIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CustomerIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CustomerIDList} CustomerIDList
         */
        CustomerIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CustomerIDList)
                return object;
            var message = new $root.entity.CustomerIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.CustomerIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomerIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CustomerIDList
         * @static
         * @param {entity.CustomerIDList} message CustomerIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this CustomerIDList to JSON.
         * @function toJSON
         * @memberof entity.CustomerIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerIDList;
    })();

    entity.Customer = (function() {

        /**
         * Properties of a Customer.
         * @memberof entity
         * @interface ICustomer
         * @property {string|null} [id] Customer id
         * @property {string|null} [name] Customer name
         * @property {string|null} [nameKana] Customer nameKana
         * @property {string|null} [gsIconURL] Customer gsIconURL
         * @property {string|null} [signedIconURL] Customer signedIconURL
         * @property {string|null} [birthdate] Customer birthdate
         * @property {entity.User.Gender|null} [gender] Customer gender
         * @property {string|null} [phoneNumber] Customer phoneNumber
         * @property {string|null} [email] Customer email
         * @property {string|null} [pr] Customer pr
         * @property {string|null} [address] Customer address
         * @property {Array.<string>|null} [academicBackgrounds] Customer academicBackgrounds
         * @property {Array.<string>|null} [requirements] Customer requirements
         * @property {Array.<entity.Customer.Language>|null} [languages] Customer languages
         * @property {string|null} [moreLanguage] Customer moreLanguage
         * @property {entity.Customer.SpeakingLevel|null} [speakingLevel] Customer speakingLevel
         * @property {entity.Customer.Status|null} [status] Customer status
         * @property {string|null} [resumeURL] Customer resumeURL
         * @property {string|null} [jobHistoryURL] Customer jobHistoryURL
         * @property {entity.Customer.WorkingFrequency|null} [workingFrequency] Customer workingFrequency
         * @property {entity.Customer.RequestedFee|null} [requestedFee] Customer requestedFee
         * @property {string|null} [requestedCondition] Customer requestedCondition
         * @property {string|null} [dutySummary] Customer dutySummary
         * @property {entity.Customer.WorkIntention|null} [workIntention] Customer workIntention
         * @property {entity.Customer.FullTimePossibility|null} [fullTimePossibility] Customer fullTimePossibility
         * @property {entity.Customer.BrokerageProjectPossibility|null} [brokerageProjectPossibility] Customer brokerageProjectPossibility
         * @property {string|null} [portfolioURL] Customer portfolioURL
         * @property {entity.Customer.Type|null} [type] Customer type
         * @property {Array.<entity.ISearchHighlight>|null} [highlights] Customer highlights
         * @property {string|null} [catchphrase] Customer catchphrase
         * @property {string|null} [jobCareerCatchphrase] Customer jobCareerCatchphrase
         * @property {string|null} [catchphraseUpdatedAt] Customer catchphraseUpdatedAt
         * @property {string|null} [catchphraseUpdatedUserName] Customer catchphraseUpdatedUserName
         * @property {string|null} [adminMemo] Customer adminMemo
         * @property {string|null} [adminMemoUpdatedAt] Customer adminMemoUpdatedAt
         * @property {string|null} [adminMemoUpdatedUserName] Customer adminMemoUpdatedUserName
         * @property {string|null} [adminSalesMemo] Customer adminSalesMemo
         * @property {string|null} [adminSalesMemoUpdatedAt] Customer adminSalesMemoUpdatedAt
         * @property {string|null} [adminSalesMemoUpdatedUserName] Customer adminSalesMemoUpdatedUserName
         * @property {string|null} [interviewMemo] Customer interviewMemo
         * @property {string|null} [interviewUpdatedAt] Customer interviewUpdatedAt
         * @property {string|null} [interviewUpdatedUserName] Customer interviewUpdatedUserName
         * @property {Array.<entity.ISingleSkillTag>|null} [singleSkillTags] Customer singleSkillTags
         * @property {Array.<entity.IMultiSkillTag>|null} [multiSkillTags] Customer multiSkillTags
         * @property {Array.<entity.IOccupationSkillTag>|null} [occupationSkillTags] Customer occupationSkillTags
         * @property {Array.<string>|null} [displayOccupationSkillCategories] Customer displayOccupationSkillCategories
         * @property {Array.<string>|null} [displayOccupationSkillTags] Customer displayOccupationSkillTags
         * @property {string|null} [profileUpdatedAt] Customer profileUpdatedAt
         * @property {string|null} [profileUpdatedUserName] Customer profileUpdatedUserName
         * @property {entity.Customer.Campaign|null} [campaign] Customer campaign
         * @property {string|null} [birthplace] Customer birthplace
         * @property {string|null} [routeInfo] Customer routeInfo
         * @property {string|null} [facebookURL] Customer facebookURL
         * @property {string|null} [linkedInURL] Customer linkedInURL
         * @property {string|null} [xURL] Customer xURL
         * @property {string|null} [createdAt] Customer createdAt
         */

        /**
         * Constructs a new Customer.
         * @memberof entity
         * @classdesc Represents a Customer.
         * @implements ICustomer
         * @constructor
         * @param {entity.ICustomer=} [properties] Properties to set
         */
        function Customer(properties) {
            this.academicBackgrounds = [];
            this.requirements = [];
            this.languages = [];
            this.highlights = [];
            this.singleSkillTags = [];
            this.multiSkillTags = [];
            this.occupationSkillTags = [];
            this.displayOccupationSkillCategories = [];
            this.displayOccupationSkillTags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Customer id.
         * @member {string} id
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.id = "";

        /**
         * Customer name.
         * @member {string} name
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.name = "";

        /**
         * Customer nameKana.
         * @member {string} nameKana
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.nameKana = "";

        /**
         * Customer gsIconURL.
         * @member {string} gsIconURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.gsIconURL = "";

        /**
         * Customer signedIconURL.
         * @member {string} signedIconURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.signedIconURL = "";

        /**
         * Customer birthdate.
         * @member {string} birthdate
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.birthdate = "";

        /**
         * Customer gender.
         * @member {entity.User.Gender} gender
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.gender = 0;

        /**
         * Customer phoneNumber.
         * @member {string} phoneNumber
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.phoneNumber = "";

        /**
         * Customer email.
         * @member {string} email
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.email = "";

        /**
         * Customer pr.
         * @member {string} pr
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.pr = "";

        /**
         * Customer address.
         * @member {string} address
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.address = "";

        /**
         * Customer academicBackgrounds.
         * @member {Array.<string>} academicBackgrounds
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.academicBackgrounds = $util.emptyArray;

        /**
         * Customer requirements.
         * @member {Array.<string>} requirements
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.requirements = $util.emptyArray;

        /**
         * Customer languages.
         * @member {Array.<entity.Customer.Language>} languages
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.languages = $util.emptyArray;

        /**
         * Customer moreLanguage.
         * @member {string} moreLanguage
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.moreLanguage = "";

        /**
         * Customer speakingLevel.
         * @member {entity.Customer.SpeakingLevel} speakingLevel
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.speakingLevel = 0;

        /**
         * Customer status.
         * @member {entity.Customer.Status} status
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.status = 0;

        /**
         * Customer resumeURL.
         * @member {string} resumeURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.resumeURL = "";

        /**
         * Customer jobHistoryURL.
         * @member {string} jobHistoryURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.jobHistoryURL = "";

        /**
         * Customer workingFrequency.
         * @member {entity.Customer.WorkingFrequency} workingFrequency
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.workingFrequency = 0;

        /**
         * Customer requestedFee.
         * @member {entity.Customer.RequestedFee} requestedFee
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.requestedFee = 0;

        /**
         * Customer requestedCondition.
         * @member {string} requestedCondition
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.requestedCondition = "";

        /**
         * Customer dutySummary.
         * @member {string} dutySummary
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.dutySummary = "";

        /**
         * Customer workIntention.
         * @member {entity.Customer.WorkIntention} workIntention
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.workIntention = 0;

        /**
         * Customer fullTimePossibility.
         * @member {entity.Customer.FullTimePossibility} fullTimePossibility
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.fullTimePossibility = 0;

        /**
         * Customer brokerageProjectPossibility.
         * @member {entity.Customer.BrokerageProjectPossibility} brokerageProjectPossibility
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.brokerageProjectPossibility = 0;

        /**
         * Customer portfolioURL.
         * @member {string} portfolioURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.portfolioURL = "";

        /**
         * Customer type.
         * @member {entity.Customer.Type} type
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.type = 0;

        /**
         * Customer highlights.
         * @member {Array.<entity.ISearchHighlight>} highlights
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.highlights = $util.emptyArray;

        /**
         * Customer catchphrase.
         * @member {string} catchphrase
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.catchphrase = "";

        /**
         * Customer jobCareerCatchphrase.
         * @member {string} jobCareerCatchphrase
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.jobCareerCatchphrase = "";

        /**
         * Customer catchphraseUpdatedAt.
         * @member {string} catchphraseUpdatedAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.catchphraseUpdatedAt = "";

        /**
         * Customer catchphraseUpdatedUserName.
         * @member {string} catchphraseUpdatedUserName
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.catchphraseUpdatedUserName = "";

        /**
         * Customer adminMemo.
         * @member {string} adminMemo
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminMemo = "";

        /**
         * Customer adminMemoUpdatedAt.
         * @member {string} adminMemoUpdatedAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminMemoUpdatedAt = "";

        /**
         * Customer adminMemoUpdatedUserName.
         * @member {string} adminMemoUpdatedUserName
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminMemoUpdatedUserName = "";

        /**
         * Customer adminSalesMemo.
         * @member {string} adminSalesMemo
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminSalesMemo = "";

        /**
         * Customer adminSalesMemoUpdatedAt.
         * @member {string} adminSalesMemoUpdatedAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminSalesMemoUpdatedAt = "";

        /**
         * Customer adminSalesMemoUpdatedUserName.
         * @member {string} adminSalesMemoUpdatedUserName
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.adminSalesMemoUpdatedUserName = "";

        /**
         * Customer interviewMemo.
         * @member {string} interviewMemo
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.interviewMemo = "";

        /**
         * Customer interviewUpdatedAt.
         * @member {string} interviewUpdatedAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.interviewUpdatedAt = "";

        /**
         * Customer interviewUpdatedUserName.
         * @member {string} interviewUpdatedUserName
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.interviewUpdatedUserName = "";

        /**
         * Customer singleSkillTags.
         * @member {Array.<entity.ISingleSkillTag>} singleSkillTags
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.singleSkillTags = $util.emptyArray;

        /**
         * Customer multiSkillTags.
         * @member {Array.<entity.IMultiSkillTag>} multiSkillTags
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.multiSkillTags = $util.emptyArray;

        /**
         * Customer occupationSkillTags.
         * @member {Array.<entity.IOccupationSkillTag>} occupationSkillTags
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.occupationSkillTags = $util.emptyArray;

        /**
         * Customer displayOccupationSkillCategories.
         * @member {Array.<string>} displayOccupationSkillCategories
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.displayOccupationSkillCategories = $util.emptyArray;

        /**
         * Customer displayOccupationSkillTags.
         * @member {Array.<string>} displayOccupationSkillTags
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.displayOccupationSkillTags = $util.emptyArray;

        /**
         * Customer profileUpdatedAt.
         * @member {string} profileUpdatedAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.profileUpdatedAt = "";

        /**
         * Customer profileUpdatedUserName.
         * @member {string} profileUpdatedUserName
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.profileUpdatedUserName = "";

        /**
         * Customer campaign.
         * @member {entity.Customer.Campaign} campaign
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.campaign = 0;

        /**
         * Customer birthplace.
         * @member {string} birthplace
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.birthplace = "";

        /**
         * Customer routeInfo.
         * @member {string} routeInfo
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.routeInfo = "";

        /**
         * Customer facebookURL.
         * @member {string} facebookURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.facebookURL = "";

        /**
         * Customer linkedInURL.
         * @member {string} linkedInURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.linkedInURL = "";

        /**
         * Customer xURL.
         * @member {string} xURL
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.xURL = "";

        /**
         * Customer createdAt.
         * @member {string} createdAt
         * @memberof entity.Customer
         * @instance
         */
        Customer.prototype.createdAt = "";

        /**
         * Creates a new Customer instance using the specified properties.
         * @function create
         * @memberof entity.Customer
         * @static
         * @param {entity.ICustomer=} [properties] Properties to set
         * @returns {entity.Customer} Customer instance
         */
        Customer.create = function create(properties) {
            return new Customer(properties);
        };

        /**
         * Encodes the specified Customer message. Does not implicitly {@link entity.Customer.verify|verify} messages.
         * @function encode
         * @memberof entity.Customer
         * @static
         * @param {entity.ICustomer} message Customer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Customer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nameKana);
            if (message.gsIconURL != null && Object.hasOwnProperty.call(message, "gsIconURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.gsIconURL);
            if (message.signedIconURL != null && Object.hasOwnProperty.call(message, "signedIconURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.signedIconURL);
            if (message.birthdate != null && Object.hasOwnProperty.call(message, "birthdate"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.birthdate);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.gender);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.phoneNumber);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.email);
            if (message.pr != null && Object.hasOwnProperty.call(message, "pr"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.pr);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.address);
            if (message.academicBackgrounds != null && message.academicBackgrounds.length)
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.academicBackgrounds[i]);
            if (message.requirements != null && message.requirements.length)
                for (var i = 0; i < message.requirements.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.requirements[i]);
            if (message.languages != null && message.languages.length) {
                writer.uint32(/* id 14, wireType 2 =*/114).fork();
                for (var i = 0; i < message.languages.length; ++i)
                    writer.int32(message.languages[i]);
                writer.ldelim();
            }
            if (message.moreLanguage != null && Object.hasOwnProperty.call(message, "moreLanguage"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.moreLanguage);
            if (message.speakingLevel != null && Object.hasOwnProperty.call(message, "speakingLevel"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.speakingLevel);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.status);
            if (message.resumeURL != null && Object.hasOwnProperty.call(message, "resumeURL"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.resumeURL);
            if (message.jobHistoryURL != null && Object.hasOwnProperty.call(message, "jobHistoryURL"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.jobHistoryURL);
            if (message.workingFrequency != null && Object.hasOwnProperty.call(message, "workingFrequency"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.workingFrequency);
            if (message.requestedFee != null && Object.hasOwnProperty.call(message, "requestedFee"))
                writer.uint32(/* id 21, wireType 0 =*/168).int32(message.requestedFee);
            if (message.requestedCondition != null && Object.hasOwnProperty.call(message, "requestedCondition"))
                writer.uint32(/* id 22, wireType 2 =*/178).string(message.requestedCondition);
            if (message.dutySummary != null && Object.hasOwnProperty.call(message, "dutySummary"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.dutySummary);
            if (message.workIntention != null && Object.hasOwnProperty.call(message, "workIntention"))
                writer.uint32(/* id 24, wireType 0 =*/192).int32(message.workIntention);
            if (message.fullTimePossibility != null && Object.hasOwnProperty.call(message, "fullTimePossibility"))
                writer.uint32(/* id 25, wireType 0 =*/200).int32(message.fullTimePossibility);
            if (message.brokerageProjectPossibility != null && Object.hasOwnProperty.call(message, "brokerageProjectPossibility"))
                writer.uint32(/* id 26, wireType 0 =*/208).int32(message.brokerageProjectPossibility);
            if (message.portfolioURL != null && Object.hasOwnProperty.call(message, "portfolioURL"))
                writer.uint32(/* id 27, wireType 2 =*/218).string(message.portfolioURL);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 28, wireType 0 =*/224).int32(message.type);
            if (message.highlights != null && message.highlights.length)
                for (var i = 0; i < message.highlights.length; ++i)
                    $root.entity.SearchHighlight.encode(message.highlights[i], writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.catchphrase != null && Object.hasOwnProperty.call(message, "catchphrase"))
                writer.uint32(/* id 32, wireType 2 =*/258).string(message.catchphrase);
            if (message.jobCareerCatchphrase != null && Object.hasOwnProperty.call(message, "jobCareerCatchphrase"))
                writer.uint32(/* id 33, wireType 2 =*/266).string(message.jobCareerCatchphrase);
            if (message.catchphraseUpdatedAt != null && Object.hasOwnProperty.call(message, "catchphraseUpdatedAt"))
                writer.uint32(/* id 34, wireType 2 =*/274).string(message.catchphraseUpdatedAt);
            if (message.catchphraseUpdatedUserName != null && Object.hasOwnProperty.call(message, "catchphraseUpdatedUserName"))
                writer.uint32(/* id 35, wireType 2 =*/282).string(message.catchphraseUpdatedUserName);
            if (message.adminMemo != null && Object.hasOwnProperty.call(message, "adminMemo"))
                writer.uint32(/* id 36, wireType 2 =*/290).string(message.adminMemo);
            if (message.adminMemoUpdatedAt != null && Object.hasOwnProperty.call(message, "adminMemoUpdatedAt"))
                writer.uint32(/* id 37, wireType 2 =*/298).string(message.adminMemoUpdatedAt);
            if (message.adminMemoUpdatedUserName != null && Object.hasOwnProperty.call(message, "adminMemoUpdatedUserName"))
                writer.uint32(/* id 38, wireType 2 =*/306).string(message.adminMemoUpdatedUserName);
            if (message.adminSalesMemo != null && Object.hasOwnProperty.call(message, "adminSalesMemo"))
                writer.uint32(/* id 39, wireType 2 =*/314).string(message.adminSalesMemo);
            if (message.adminSalesMemoUpdatedAt != null && Object.hasOwnProperty.call(message, "adminSalesMemoUpdatedAt"))
                writer.uint32(/* id 40, wireType 2 =*/322).string(message.adminSalesMemoUpdatedAt);
            if (message.adminSalesMemoUpdatedUserName != null && Object.hasOwnProperty.call(message, "adminSalesMemoUpdatedUserName"))
                writer.uint32(/* id 41, wireType 2 =*/330).string(message.adminSalesMemoUpdatedUserName);
            if (message.interviewMemo != null && Object.hasOwnProperty.call(message, "interviewMemo"))
                writer.uint32(/* id 42, wireType 2 =*/338).string(message.interviewMemo);
            if (message.interviewUpdatedAt != null && Object.hasOwnProperty.call(message, "interviewUpdatedAt"))
                writer.uint32(/* id 43, wireType 2 =*/346).string(message.interviewUpdatedAt);
            if (message.interviewUpdatedUserName != null && Object.hasOwnProperty.call(message, "interviewUpdatedUserName"))
                writer.uint32(/* id 44, wireType 2 =*/354).string(message.interviewUpdatedUserName);
            if (message.singleSkillTags != null && message.singleSkillTags.length)
                for (var i = 0; i < message.singleSkillTags.length; ++i)
                    $root.entity.SingleSkillTag.encode(message.singleSkillTags[i], writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.multiSkillTags != null && message.multiSkillTags.length)
                for (var i = 0; i < message.multiSkillTags.length; ++i)
                    $root.entity.MultiSkillTag.encode(message.multiSkillTags[i], writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.occupationSkillTags != null && message.occupationSkillTags.length)
                for (var i = 0; i < message.occupationSkillTags.length; ++i)
                    $root.entity.OccupationSkillTag.encode(message.occupationSkillTags[i], writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
            if (message.displayOccupationSkillCategories != null && message.displayOccupationSkillCategories.length)
                for (var i = 0; i < message.displayOccupationSkillCategories.length; ++i)
                    writer.uint32(/* id 48, wireType 2 =*/386).string(message.displayOccupationSkillCategories[i]);
            if (message.displayOccupationSkillTags != null && message.displayOccupationSkillTags.length)
                for (var i = 0; i < message.displayOccupationSkillTags.length; ++i)
                    writer.uint32(/* id 49, wireType 2 =*/394).string(message.displayOccupationSkillTags[i]);
            if (message.profileUpdatedAt != null && Object.hasOwnProperty.call(message, "profileUpdatedAt"))
                writer.uint32(/* id 50, wireType 2 =*/402).string(message.profileUpdatedAt);
            if (message.profileUpdatedUserName != null && Object.hasOwnProperty.call(message, "profileUpdatedUserName"))
                writer.uint32(/* id 51, wireType 2 =*/410).string(message.profileUpdatedUserName);
            if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                writer.uint32(/* id 52, wireType 0 =*/416).int32(message.campaign);
            if (message.birthplace != null && Object.hasOwnProperty.call(message, "birthplace"))
                writer.uint32(/* id 53, wireType 2 =*/426).string(message.birthplace);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 54, wireType 2 =*/434).string(message.routeInfo);
            if (message.facebookURL != null && Object.hasOwnProperty.call(message, "facebookURL"))
                writer.uint32(/* id 55, wireType 2 =*/442).string(message.facebookURL);
            if (message.linkedInURL != null && Object.hasOwnProperty.call(message, "linkedInURL"))
                writer.uint32(/* id 56, wireType 2 =*/450).string(message.linkedInURL);
            if (message.xURL != null && Object.hasOwnProperty.call(message, "xURL"))
                writer.uint32(/* id 57, wireType 2 =*/458).string(message.xURL);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified Customer message, length delimited. Does not implicitly {@link entity.Customer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Customer
         * @static
         * @param {entity.ICustomer} message Customer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Customer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Customer message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Customer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Customer} Customer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Customer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Customer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.nameKana = reader.string();
                    break;
                case 4:
                    message.gsIconURL = reader.string();
                    break;
                case 5:
                    message.signedIconURL = reader.string();
                    break;
                case 6:
                    message.birthdate = reader.string();
                    break;
                case 7:
                    message.gender = reader.int32();
                    break;
                case 8:
                    message.phoneNumber = reader.string();
                    break;
                case 9:
                    message.email = reader.string();
                    break;
                case 10:
                    message.pr = reader.string();
                    break;
                case 11:
                    message.address = reader.string();
                    break;
                case 12:
                    if (!(message.academicBackgrounds && message.academicBackgrounds.length))
                        message.academicBackgrounds = [];
                    message.academicBackgrounds.push(reader.string());
                    break;
                case 13:
                    if (!(message.requirements && message.requirements.length))
                        message.requirements = [];
                    message.requirements.push(reader.string());
                    break;
                case 14:
                    if (!(message.languages && message.languages.length))
                        message.languages = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.languages.push(reader.int32());
                    } else
                        message.languages.push(reader.int32());
                    break;
                case 15:
                    message.moreLanguage = reader.string();
                    break;
                case 16:
                    message.speakingLevel = reader.int32();
                    break;
                case 17:
                    message.status = reader.int32();
                    break;
                case 18:
                    message.resumeURL = reader.string();
                    break;
                case 19:
                    message.jobHistoryURL = reader.string();
                    break;
                case 20:
                    message.workingFrequency = reader.int32();
                    break;
                case 21:
                    message.requestedFee = reader.int32();
                    break;
                case 22:
                    message.requestedCondition = reader.string();
                    break;
                case 23:
                    message.dutySummary = reader.string();
                    break;
                case 24:
                    message.workIntention = reader.int32();
                    break;
                case 25:
                    message.fullTimePossibility = reader.int32();
                    break;
                case 26:
                    message.brokerageProjectPossibility = reader.int32();
                    break;
                case 27:
                    message.portfolioURL = reader.string();
                    break;
                case 28:
                    message.type = reader.int32();
                    break;
                case 29:
                    if (!(message.highlights && message.highlights.length))
                        message.highlights = [];
                    message.highlights.push($root.entity.SearchHighlight.decode(reader, reader.uint32()));
                    break;
                case 32:
                    message.catchphrase = reader.string();
                    break;
                case 33:
                    message.jobCareerCatchphrase = reader.string();
                    break;
                case 34:
                    message.catchphraseUpdatedAt = reader.string();
                    break;
                case 35:
                    message.catchphraseUpdatedUserName = reader.string();
                    break;
                case 36:
                    message.adminMemo = reader.string();
                    break;
                case 37:
                    message.adminMemoUpdatedAt = reader.string();
                    break;
                case 38:
                    message.adminMemoUpdatedUserName = reader.string();
                    break;
                case 39:
                    message.adminSalesMemo = reader.string();
                    break;
                case 40:
                    message.adminSalesMemoUpdatedAt = reader.string();
                    break;
                case 41:
                    message.adminSalesMemoUpdatedUserName = reader.string();
                    break;
                case 42:
                    message.interviewMemo = reader.string();
                    break;
                case 43:
                    message.interviewUpdatedAt = reader.string();
                    break;
                case 44:
                    message.interviewUpdatedUserName = reader.string();
                    break;
                case 45:
                    if (!(message.singleSkillTags && message.singleSkillTags.length))
                        message.singleSkillTags = [];
                    message.singleSkillTags.push($root.entity.SingleSkillTag.decode(reader, reader.uint32()));
                    break;
                case 46:
                    if (!(message.multiSkillTags && message.multiSkillTags.length))
                        message.multiSkillTags = [];
                    message.multiSkillTags.push($root.entity.MultiSkillTag.decode(reader, reader.uint32()));
                    break;
                case 47:
                    if (!(message.occupationSkillTags && message.occupationSkillTags.length))
                        message.occupationSkillTags = [];
                    message.occupationSkillTags.push($root.entity.OccupationSkillTag.decode(reader, reader.uint32()));
                    break;
                case 48:
                    if (!(message.displayOccupationSkillCategories && message.displayOccupationSkillCategories.length))
                        message.displayOccupationSkillCategories = [];
                    message.displayOccupationSkillCategories.push(reader.string());
                    break;
                case 49:
                    if (!(message.displayOccupationSkillTags && message.displayOccupationSkillTags.length))
                        message.displayOccupationSkillTags = [];
                    message.displayOccupationSkillTags.push(reader.string());
                    break;
                case 50:
                    message.profileUpdatedAt = reader.string();
                    break;
                case 51:
                    message.profileUpdatedUserName = reader.string();
                    break;
                case 52:
                    message.campaign = reader.int32();
                    break;
                case 53:
                    message.birthplace = reader.string();
                    break;
                case 54:
                    message.routeInfo = reader.string();
                    break;
                case 55:
                    message.facebookURL = reader.string();
                    break;
                case 56:
                    message.linkedInURL = reader.string();
                    break;
                case 57:
                    message.xURL = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Customer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Customer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Customer} Customer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Customer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Customer message.
         * @function verify
         * @memberof entity.Customer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Customer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                if (!$util.isString(message.gsIconURL))
                    return "gsIconURL: string expected";
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                if (!$util.isString(message.signedIconURL))
                    return "signedIconURL: string expected";
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                if (!$util.isString(message.birthdate))
                    return "birthdate: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.pr != null && message.hasOwnProperty("pr"))
                if (!$util.isString(message.pr))
                    return "pr: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.academicBackgrounds != null && message.hasOwnProperty("academicBackgrounds")) {
                if (!Array.isArray(message.academicBackgrounds))
                    return "academicBackgrounds: array expected";
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    if (!$util.isString(message.academicBackgrounds[i]))
                        return "academicBackgrounds: string[] expected";
            }
            if (message.requirements != null && message.hasOwnProperty("requirements")) {
                if (!Array.isArray(message.requirements))
                    return "requirements: array expected";
                for (var i = 0; i < message.requirements.length; ++i)
                    if (!$util.isString(message.requirements[i]))
                        return "requirements: string[] expected";
            }
            if (message.languages != null && message.hasOwnProperty("languages")) {
                if (!Array.isArray(message.languages))
                    return "languages: array expected";
                for (var i = 0; i < message.languages.length; ++i)
                    switch (message.languages[i]) {
                    default:
                        return "languages: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                if (!$util.isString(message.moreLanguage))
                    return "moreLanguage: string expected";
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                switch (message.speakingLevel) {
                default:
                    return "speakingLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                if (!$util.isString(message.resumeURL))
                    return "resumeURL: string expected";
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                if (!$util.isString(message.jobHistoryURL))
                    return "jobHistoryURL: string expected";
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                switch (message.workingFrequency) {
                default:
                    return "workingFrequency: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                switch (message.requestedFee) {
                default:
                    return "requestedFee: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                if (!$util.isString(message.requestedCondition))
                    return "requestedCondition: string expected";
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                if (!$util.isString(message.dutySummary))
                    return "dutySummary: string expected";
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                switch (message.workIntention) {
                default:
                    return "workIntention: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                switch (message.fullTimePossibility) {
                default:
                    return "fullTimePossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                switch (message.brokerageProjectPossibility) {
                default:
                    return "brokerageProjectPossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                if (!$util.isString(message.portfolioURL))
                    return "portfolioURL: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.highlights != null && message.hasOwnProperty("highlights")) {
                if (!Array.isArray(message.highlights))
                    return "highlights: array expected";
                for (var i = 0; i < message.highlights.length; ++i) {
                    var error = $root.entity.SearchHighlight.verify(message.highlights[i]);
                    if (error)
                        return "highlights." + error;
                }
            }
            if (message.catchphrase != null && message.hasOwnProperty("catchphrase"))
                if (!$util.isString(message.catchphrase))
                    return "catchphrase: string expected";
            if (message.jobCareerCatchphrase != null && message.hasOwnProperty("jobCareerCatchphrase"))
                if (!$util.isString(message.jobCareerCatchphrase))
                    return "jobCareerCatchphrase: string expected";
            if (message.catchphraseUpdatedAt != null && message.hasOwnProperty("catchphraseUpdatedAt"))
                if (!$util.isString(message.catchphraseUpdatedAt))
                    return "catchphraseUpdatedAt: string expected";
            if (message.catchphraseUpdatedUserName != null && message.hasOwnProperty("catchphraseUpdatedUserName"))
                if (!$util.isString(message.catchphraseUpdatedUserName))
                    return "catchphraseUpdatedUserName: string expected";
            if (message.adminMemo != null && message.hasOwnProperty("adminMemo"))
                if (!$util.isString(message.adminMemo))
                    return "adminMemo: string expected";
            if (message.adminMemoUpdatedAt != null && message.hasOwnProperty("adminMemoUpdatedAt"))
                if (!$util.isString(message.adminMemoUpdatedAt))
                    return "adminMemoUpdatedAt: string expected";
            if (message.adminMemoUpdatedUserName != null && message.hasOwnProperty("adminMemoUpdatedUserName"))
                if (!$util.isString(message.adminMemoUpdatedUserName))
                    return "adminMemoUpdatedUserName: string expected";
            if (message.adminSalesMemo != null && message.hasOwnProperty("adminSalesMemo"))
                if (!$util.isString(message.adminSalesMemo))
                    return "adminSalesMemo: string expected";
            if (message.adminSalesMemoUpdatedAt != null && message.hasOwnProperty("adminSalesMemoUpdatedAt"))
                if (!$util.isString(message.adminSalesMemoUpdatedAt))
                    return "adminSalesMemoUpdatedAt: string expected";
            if (message.adminSalesMemoUpdatedUserName != null && message.hasOwnProperty("adminSalesMemoUpdatedUserName"))
                if (!$util.isString(message.adminSalesMemoUpdatedUserName))
                    return "adminSalesMemoUpdatedUserName: string expected";
            if (message.interviewMemo != null && message.hasOwnProperty("interviewMemo"))
                if (!$util.isString(message.interviewMemo))
                    return "interviewMemo: string expected";
            if (message.interviewUpdatedAt != null && message.hasOwnProperty("interviewUpdatedAt"))
                if (!$util.isString(message.interviewUpdatedAt))
                    return "interviewUpdatedAt: string expected";
            if (message.interviewUpdatedUserName != null && message.hasOwnProperty("interviewUpdatedUserName"))
                if (!$util.isString(message.interviewUpdatedUserName))
                    return "interviewUpdatedUserName: string expected";
            if (message.singleSkillTags != null && message.hasOwnProperty("singleSkillTags")) {
                if (!Array.isArray(message.singleSkillTags))
                    return "singleSkillTags: array expected";
                for (var i = 0; i < message.singleSkillTags.length; ++i) {
                    var error = $root.entity.SingleSkillTag.verify(message.singleSkillTags[i]);
                    if (error)
                        return "singleSkillTags." + error;
                }
            }
            if (message.multiSkillTags != null && message.hasOwnProperty("multiSkillTags")) {
                if (!Array.isArray(message.multiSkillTags))
                    return "multiSkillTags: array expected";
                for (var i = 0; i < message.multiSkillTags.length; ++i) {
                    var error = $root.entity.MultiSkillTag.verify(message.multiSkillTags[i]);
                    if (error)
                        return "multiSkillTags." + error;
                }
            }
            if (message.occupationSkillTags != null && message.hasOwnProperty("occupationSkillTags")) {
                if (!Array.isArray(message.occupationSkillTags))
                    return "occupationSkillTags: array expected";
                for (var i = 0; i < message.occupationSkillTags.length; ++i) {
                    var error = $root.entity.OccupationSkillTag.verify(message.occupationSkillTags[i]);
                    if (error)
                        return "occupationSkillTags." + error;
                }
            }
            if (message.displayOccupationSkillCategories != null && message.hasOwnProperty("displayOccupationSkillCategories")) {
                if (!Array.isArray(message.displayOccupationSkillCategories))
                    return "displayOccupationSkillCategories: array expected";
                for (var i = 0; i < message.displayOccupationSkillCategories.length; ++i)
                    if (!$util.isString(message.displayOccupationSkillCategories[i]))
                        return "displayOccupationSkillCategories: string[] expected";
            }
            if (message.displayOccupationSkillTags != null && message.hasOwnProperty("displayOccupationSkillTags")) {
                if (!Array.isArray(message.displayOccupationSkillTags))
                    return "displayOccupationSkillTags: array expected";
                for (var i = 0; i < message.displayOccupationSkillTags.length; ++i)
                    if (!$util.isString(message.displayOccupationSkillTags[i]))
                        return "displayOccupationSkillTags: string[] expected";
            }
            if (message.profileUpdatedAt != null && message.hasOwnProperty("profileUpdatedAt"))
                if (!$util.isString(message.profileUpdatedAt))
                    return "profileUpdatedAt: string expected";
            if (message.profileUpdatedUserName != null && message.hasOwnProperty("profileUpdatedUserName"))
                if (!$util.isString(message.profileUpdatedUserName))
                    return "profileUpdatedUserName: string expected";
            if (message.campaign != null && message.hasOwnProperty("campaign"))
                switch (message.campaign) {
                default:
                    return "campaign: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                if (!$util.isString(message.birthplace))
                    return "birthplace: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                if (!$util.isString(message.facebookURL))
                    return "facebookURL: string expected";
            if (message.linkedInURL != null && message.hasOwnProperty("linkedInURL"))
                if (!$util.isString(message.linkedInURL))
                    return "linkedInURL: string expected";
            if (message.xURL != null && message.hasOwnProperty("xURL"))
                if (!$util.isString(message.xURL))
                    return "xURL: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a Customer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Customer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Customer} Customer
         */
        Customer.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Customer)
                return object;
            var message = new $root.entity.Customer();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            if (object.gsIconURL != null)
                message.gsIconURL = String(object.gsIconURL);
            if (object.signedIconURL != null)
                message.signedIconURL = String(object.signedIconURL);
            if (object.birthdate != null)
                message.birthdate = String(object.birthdate);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.email != null)
                message.email = String(object.email);
            if (object.pr != null)
                message.pr = String(object.pr);
            if (object.address != null)
                message.address = String(object.address);
            if (object.academicBackgrounds) {
                if (!Array.isArray(object.academicBackgrounds))
                    throw TypeError(".entity.Customer.academicBackgrounds: array expected");
                message.academicBackgrounds = [];
                for (var i = 0; i < object.academicBackgrounds.length; ++i)
                    message.academicBackgrounds[i] = String(object.academicBackgrounds[i]);
            }
            if (object.requirements) {
                if (!Array.isArray(object.requirements))
                    throw TypeError(".entity.Customer.requirements: array expected");
                message.requirements = [];
                for (var i = 0; i < object.requirements.length; ++i)
                    message.requirements[i] = String(object.requirements[i]);
            }
            if (object.languages) {
                if (!Array.isArray(object.languages))
                    throw TypeError(".entity.Customer.languages: array expected");
                message.languages = [];
                for (var i = 0; i < object.languages.length; ++i)
                    switch (object.languages[i]) {
                    default:
                    case "Language_Unknown":
                    case 0:
                        message.languages[i] = 0;
                        break;
                    case "Language_English":
                    case 1:
                        message.languages[i] = 1;
                        break;
                    case "Language_Korean":
                    case 2:
                        message.languages[i] = 2;
                        break;
                    case "Language_Chinese":
                    case 3:
                        message.languages[i] = 3;
                        break;
                    case "Language_Spanish":
                    case 4:
                        message.languages[i] = 4;
                        break;
                    case "Language_German":
                    case 5:
                        message.languages[i] = 5;
                        break;
                    case "Language_French":
                    case 6:
                        message.languages[i] = 6;
                        break;
                    case "Language_Other":
                    case 7:
                        message.languages[i] = 7;
                        break;
                    }
            }
            if (object.moreLanguage != null)
                message.moreLanguage = String(object.moreLanguage);
            switch (object.speakingLevel) {
            case "SpeakingLevel_Unknown":
            case 0:
                message.speakingLevel = 0;
                break;
            case "SpeakingLevel_Basic_Conversation":
            case 1:
                message.speakingLevel = 1;
                break;
            case "SpeakingLevel_Business":
            case 2:
                message.speakingLevel = 2;
                break;
            case "SpeakingLevel_Native":
            case 3:
                message.speakingLevel = 3;
                break;
            }
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Inspection":
            case 1:
                message.status = 1;
                break;
            case "Status_Denied":
            case 2:
                message.status = 2;
                break;
            case "Status_Active":
            case 3:
                message.status = 3;
                break;
            case "Status_BAN":
            case 4:
                message.status = 4;
                break;
            case "Status_Delete":
            case 5:
                message.status = 5;
                break;
            case "Status_PassedInspection":
            case 6:
                message.status = 6;
                break;
            case "Status_NonPassedInspection":
            case 7:
                message.status = 7;
                break;
            case "Status_Suspend":
            case 8:
                message.status = 8;
                break;
            case "Status_Hidden":
            case 9:
                message.status = 9;
                break;
            }
            if (object.resumeURL != null)
                message.resumeURL = String(object.resumeURL);
            if (object.jobHistoryURL != null)
                message.jobHistoryURL = String(object.jobHistoryURL);
            switch (object.workingFrequency) {
            case "WorkingFrequency_Unknown":
            case 0:
                message.workingFrequency = 0;
                break;
            case "WorkingFrequency_Under_1_Day":
            case 1:
                message.workingFrequency = 1;
                break;
            case "WorkingFrequency_1_2_Day":
            case 2:
                message.workingFrequency = 2;
                break;
            case "WorkingFrequency_2_3_Day":
            case 3:
                message.workingFrequency = 3;
                break;
            case "WorkingFrequency_Over_3_Day":
            case 4:
                message.workingFrequency = 4;
                break;
            case "WorkingFrequency_Consultation":
            case 5:
                message.workingFrequency = 5;
                break;
            }
            switch (object.requestedFee) {
            case "RequestedFee_Unknown":
            case 0:
                message.requestedFee = 0;
                break;
            case "RequestedFee_Over_400000":
            case 1:
                message.requestedFee = 1;
                break;
            case "RequestedFee_300000_400000":
            case 2:
                message.requestedFee = 2;
                break;
            case "RequestedFee_200000_300000":
            case 3:
                message.requestedFee = 3;
                break;
            case "RequestedFee_Under_200000":
            case 4:
                message.requestedFee = 4;
                break;
            }
            if (object.requestedCondition != null)
                message.requestedCondition = String(object.requestedCondition);
            if (object.dutySummary != null)
                message.dutySummary = String(object.dutySummary);
            switch (object.workIntention) {
            case "WorkIntention_Unknown":
            case 0:
                message.workIntention = 0;
                break;
            case "WorkIntention_OnlyAdvice":
            case 1:
                message.workIntention = 1;
                break;
            case "WorkIntention_WithWork":
            case 2:
                message.workIntention = 2;
                break;
            case "WorkIntention_Consultation_Required":
            case 3:
                message.workIntention = 3;
                break;
            }
            switch (object.fullTimePossibility) {
            case "FullTimePossibility_Unknown":
            case 0:
                message.fullTimePossibility = 0;
                break;
            case "FullTimePossibility_Yes":
            case 1:
                message.fullTimePossibility = 1;
                break;
            case "FullTimePossibility_No":
            case 2:
                message.fullTimePossibility = 2;
                break;
            }
            switch (object.brokerageProjectPossibility) {
            case "BrokerageProjectPossibility_Unknown":
            case 0:
                message.brokerageProjectPossibility = 0;
                break;
            case "BrokerageProjectPossibility_Yes":
            case 1:
                message.brokerageProjectPossibility = 1;
                break;
            case "BrokerageProjectPossibility_No":
            case 2:
                message.brokerageProjectPossibility = 2;
                break;
            }
            if (object.portfolioURL != null)
                message.portfolioURL = String(object.portfolioURL);
            switch (object.type) {
            case "Type_Unknown":
            case 0:
                message.type = 0;
                break;
            case "Type_Expert":
            case 1:
                message.type = 1;
                break;
            case "Type_Pro":
            case 2:
                message.type = 2;
                break;
            case "Type_Both":
            case 3:
                message.type = 3;
                break;
            }
            if (object.highlights) {
                if (!Array.isArray(object.highlights))
                    throw TypeError(".entity.Customer.highlights: array expected");
                message.highlights = [];
                for (var i = 0; i < object.highlights.length; ++i) {
                    if (typeof object.highlights[i] !== "object")
                        throw TypeError(".entity.Customer.highlights: object expected");
                    message.highlights[i] = $root.entity.SearchHighlight.fromObject(object.highlights[i]);
                }
            }
            if (object.catchphrase != null)
                message.catchphrase = String(object.catchphrase);
            if (object.jobCareerCatchphrase != null)
                message.jobCareerCatchphrase = String(object.jobCareerCatchphrase);
            if (object.catchphraseUpdatedAt != null)
                message.catchphraseUpdatedAt = String(object.catchphraseUpdatedAt);
            if (object.catchphraseUpdatedUserName != null)
                message.catchphraseUpdatedUserName = String(object.catchphraseUpdatedUserName);
            if (object.adminMemo != null)
                message.adminMemo = String(object.adminMemo);
            if (object.adminMemoUpdatedAt != null)
                message.adminMemoUpdatedAt = String(object.adminMemoUpdatedAt);
            if (object.adminMemoUpdatedUserName != null)
                message.adminMemoUpdatedUserName = String(object.adminMemoUpdatedUserName);
            if (object.adminSalesMemo != null)
                message.adminSalesMemo = String(object.adminSalesMemo);
            if (object.adminSalesMemoUpdatedAt != null)
                message.adminSalesMemoUpdatedAt = String(object.adminSalesMemoUpdatedAt);
            if (object.adminSalesMemoUpdatedUserName != null)
                message.adminSalesMemoUpdatedUserName = String(object.adminSalesMemoUpdatedUserName);
            if (object.interviewMemo != null)
                message.interviewMemo = String(object.interviewMemo);
            if (object.interviewUpdatedAt != null)
                message.interviewUpdatedAt = String(object.interviewUpdatedAt);
            if (object.interviewUpdatedUserName != null)
                message.interviewUpdatedUserName = String(object.interviewUpdatedUserName);
            if (object.singleSkillTags) {
                if (!Array.isArray(object.singleSkillTags))
                    throw TypeError(".entity.Customer.singleSkillTags: array expected");
                message.singleSkillTags = [];
                for (var i = 0; i < object.singleSkillTags.length; ++i) {
                    if (typeof object.singleSkillTags[i] !== "object")
                        throw TypeError(".entity.Customer.singleSkillTags: object expected");
                    message.singleSkillTags[i] = $root.entity.SingleSkillTag.fromObject(object.singleSkillTags[i]);
                }
            }
            if (object.multiSkillTags) {
                if (!Array.isArray(object.multiSkillTags))
                    throw TypeError(".entity.Customer.multiSkillTags: array expected");
                message.multiSkillTags = [];
                for (var i = 0; i < object.multiSkillTags.length; ++i) {
                    if (typeof object.multiSkillTags[i] !== "object")
                        throw TypeError(".entity.Customer.multiSkillTags: object expected");
                    message.multiSkillTags[i] = $root.entity.MultiSkillTag.fromObject(object.multiSkillTags[i]);
                }
            }
            if (object.occupationSkillTags) {
                if (!Array.isArray(object.occupationSkillTags))
                    throw TypeError(".entity.Customer.occupationSkillTags: array expected");
                message.occupationSkillTags = [];
                for (var i = 0; i < object.occupationSkillTags.length; ++i) {
                    if (typeof object.occupationSkillTags[i] !== "object")
                        throw TypeError(".entity.Customer.occupationSkillTags: object expected");
                    message.occupationSkillTags[i] = $root.entity.OccupationSkillTag.fromObject(object.occupationSkillTags[i]);
                }
            }
            if (object.displayOccupationSkillCategories) {
                if (!Array.isArray(object.displayOccupationSkillCategories))
                    throw TypeError(".entity.Customer.displayOccupationSkillCategories: array expected");
                message.displayOccupationSkillCategories = [];
                for (var i = 0; i < object.displayOccupationSkillCategories.length; ++i)
                    message.displayOccupationSkillCategories[i] = String(object.displayOccupationSkillCategories[i]);
            }
            if (object.displayOccupationSkillTags) {
                if (!Array.isArray(object.displayOccupationSkillTags))
                    throw TypeError(".entity.Customer.displayOccupationSkillTags: array expected");
                message.displayOccupationSkillTags = [];
                for (var i = 0; i < object.displayOccupationSkillTags.length; ++i)
                    message.displayOccupationSkillTags[i] = String(object.displayOccupationSkillTags[i]);
            }
            if (object.profileUpdatedAt != null)
                message.profileUpdatedAt = String(object.profileUpdatedAt);
            if (object.profileUpdatedUserName != null)
                message.profileUpdatedUserName = String(object.profileUpdatedUserName);
            switch (object.campaign) {
            case "Campaign_Normal":
            case 0:
                message.campaign = 0;
                break;
            case "Campaign_SuperEngineer":
            case 1:
                message.campaign = 1;
                break;
            }
            if (object.birthplace != null)
                message.birthplace = String(object.birthplace);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            if (object.facebookURL != null)
                message.facebookURL = String(object.facebookURL);
            if (object.linkedInURL != null)
                message.linkedInURL = String(object.linkedInURL);
            if (object.xURL != null)
                message.xURL = String(object.xURL);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a Customer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Customer
         * @static
         * @param {entity.Customer} message Customer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Customer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.academicBackgrounds = [];
                object.requirements = [];
                object.languages = [];
                object.highlights = [];
                object.singleSkillTags = [];
                object.multiSkillTags = [];
                object.occupationSkillTags = [];
                object.displayOccupationSkillCategories = [];
                object.displayOccupationSkillTags = [];
            }
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.nameKana = "";
                object.gsIconURL = "";
                object.signedIconURL = "";
                object.birthdate = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.phoneNumber = "";
                object.email = "";
                object.pr = "";
                object.address = "";
                object.moreLanguage = "";
                object.speakingLevel = options.enums === String ? "SpeakingLevel_Unknown" : 0;
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.resumeURL = "";
                object.jobHistoryURL = "";
                object.workingFrequency = options.enums === String ? "WorkingFrequency_Unknown" : 0;
                object.requestedFee = options.enums === String ? "RequestedFee_Unknown" : 0;
                object.requestedCondition = "";
                object.dutySummary = "";
                object.workIntention = options.enums === String ? "WorkIntention_Unknown" : 0;
                object.fullTimePossibility = options.enums === String ? "FullTimePossibility_Unknown" : 0;
                object.brokerageProjectPossibility = options.enums === String ? "BrokerageProjectPossibility_Unknown" : 0;
                object.portfolioURL = "";
                object.type = options.enums === String ? "Type_Unknown" : 0;
                object.catchphrase = "";
                object.jobCareerCatchphrase = "";
                object.catchphraseUpdatedAt = "";
                object.catchphraseUpdatedUserName = "";
                object.adminMemo = "";
                object.adminMemoUpdatedAt = "";
                object.adminMemoUpdatedUserName = "";
                object.adminSalesMemo = "";
                object.adminSalesMemoUpdatedAt = "";
                object.adminSalesMemoUpdatedUserName = "";
                object.interviewMemo = "";
                object.interviewUpdatedAt = "";
                object.interviewUpdatedUserName = "";
                object.profileUpdatedAt = "";
                object.profileUpdatedUserName = "";
                object.campaign = options.enums === String ? "Campaign_Normal" : 0;
                object.birthplace = "";
                object.routeInfo = "";
                object.facebookURL = "";
                object.linkedInURL = "";
                object.xURL = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                object.gsIconURL = message.gsIconURL;
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                object.signedIconURL = message.signedIconURL;
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                object.birthdate = message.birthdate;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.pr != null && message.hasOwnProperty("pr"))
                object.pr = message.pr;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.academicBackgrounds && message.academicBackgrounds.length) {
                object.academicBackgrounds = [];
                for (var j = 0; j < message.academicBackgrounds.length; ++j)
                    object.academicBackgrounds[j] = message.academicBackgrounds[j];
            }
            if (message.requirements && message.requirements.length) {
                object.requirements = [];
                for (var j = 0; j < message.requirements.length; ++j)
                    object.requirements[j] = message.requirements[j];
            }
            if (message.languages && message.languages.length) {
                object.languages = [];
                for (var j = 0; j < message.languages.length; ++j)
                    object.languages[j] = options.enums === String ? $root.entity.Customer.Language[message.languages[j]] : message.languages[j];
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                object.moreLanguage = message.moreLanguage;
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                object.speakingLevel = options.enums === String ? $root.entity.Customer.SpeakingLevel[message.speakingLevel] : message.speakingLevel;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.Customer.Status[message.status] : message.status;
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                object.resumeURL = message.resumeURL;
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                object.jobHistoryURL = message.jobHistoryURL;
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                object.workingFrequency = options.enums === String ? $root.entity.Customer.WorkingFrequency[message.workingFrequency] : message.workingFrequency;
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                object.requestedFee = options.enums === String ? $root.entity.Customer.RequestedFee[message.requestedFee] : message.requestedFee;
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                object.requestedCondition = message.requestedCondition;
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                object.dutySummary = message.dutySummary;
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                object.workIntention = options.enums === String ? $root.entity.Customer.WorkIntention[message.workIntention] : message.workIntention;
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                object.fullTimePossibility = options.enums === String ? $root.entity.Customer.FullTimePossibility[message.fullTimePossibility] : message.fullTimePossibility;
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                object.brokerageProjectPossibility = options.enums === String ? $root.entity.Customer.BrokerageProjectPossibility[message.brokerageProjectPossibility] : message.brokerageProjectPossibility;
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                object.portfolioURL = message.portfolioURL;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.entity.Customer.Type[message.type] : message.type;
            if (message.highlights && message.highlights.length) {
                object.highlights = [];
                for (var j = 0; j < message.highlights.length; ++j)
                    object.highlights[j] = $root.entity.SearchHighlight.toObject(message.highlights[j], options);
            }
            if (message.catchphrase != null && message.hasOwnProperty("catchphrase"))
                object.catchphrase = message.catchphrase;
            if (message.jobCareerCatchphrase != null && message.hasOwnProperty("jobCareerCatchphrase"))
                object.jobCareerCatchphrase = message.jobCareerCatchphrase;
            if (message.catchphraseUpdatedAt != null && message.hasOwnProperty("catchphraseUpdatedAt"))
                object.catchphraseUpdatedAt = message.catchphraseUpdatedAt;
            if (message.catchphraseUpdatedUserName != null && message.hasOwnProperty("catchphraseUpdatedUserName"))
                object.catchphraseUpdatedUserName = message.catchphraseUpdatedUserName;
            if (message.adminMemo != null && message.hasOwnProperty("adminMemo"))
                object.adminMemo = message.adminMemo;
            if (message.adminMemoUpdatedAt != null && message.hasOwnProperty("adminMemoUpdatedAt"))
                object.adminMemoUpdatedAt = message.adminMemoUpdatedAt;
            if (message.adminMemoUpdatedUserName != null && message.hasOwnProperty("adminMemoUpdatedUserName"))
                object.adminMemoUpdatedUserName = message.adminMemoUpdatedUserName;
            if (message.adminSalesMemo != null && message.hasOwnProperty("adminSalesMemo"))
                object.adminSalesMemo = message.adminSalesMemo;
            if (message.adminSalesMemoUpdatedAt != null && message.hasOwnProperty("adminSalesMemoUpdatedAt"))
                object.adminSalesMemoUpdatedAt = message.adminSalesMemoUpdatedAt;
            if (message.adminSalesMemoUpdatedUserName != null && message.hasOwnProperty("adminSalesMemoUpdatedUserName"))
                object.adminSalesMemoUpdatedUserName = message.adminSalesMemoUpdatedUserName;
            if (message.interviewMemo != null && message.hasOwnProperty("interviewMemo"))
                object.interviewMemo = message.interviewMemo;
            if (message.interviewUpdatedAt != null && message.hasOwnProperty("interviewUpdatedAt"))
                object.interviewUpdatedAt = message.interviewUpdatedAt;
            if (message.interviewUpdatedUserName != null && message.hasOwnProperty("interviewUpdatedUserName"))
                object.interviewUpdatedUserName = message.interviewUpdatedUserName;
            if (message.singleSkillTags && message.singleSkillTags.length) {
                object.singleSkillTags = [];
                for (var j = 0; j < message.singleSkillTags.length; ++j)
                    object.singleSkillTags[j] = $root.entity.SingleSkillTag.toObject(message.singleSkillTags[j], options);
            }
            if (message.multiSkillTags && message.multiSkillTags.length) {
                object.multiSkillTags = [];
                for (var j = 0; j < message.multiSkillTags.length; ++j)
                    object.multiSkillTags[j] = $root.entity.MultiSkillTag.toObject(message.multiSkillTags[j], options);
            }
            if (message.occupationSkillTags && message.occupationSkillTags.length) {
                object.occupationSkillTags = [];
                for (var j = 0; j < message.occupationSkillTags.length; ++j)
                    object.occupationSkillTags[j] = $root.entity.OccupationSkillTag.toObject(message.occupationSkillTags[j], options);
            }
            if (message.displayOccupationSkillCategories && message.displayOccupationSkillCategories.length) {
                object.displayOccupationSkillCategories = [];
                for (var j = 0; j < message.displayOccupationSkillCategories.length; ++j)
                    object.displayOccupationSkillCategories[j] = message.displayOccupationSkillCategories[j];
            }
            if (message.displayOccupationSkillTags && message.displayOccupationSkillTags.length) {
                object.displayOccupationSkillTags = [];
                for (var j = 0; j < message.displayOccupationSkillTags.length; ++j)
                    object.displayOccupationSkillTags[j] = message.displayOccupationSkillTags[j];
            }
            if (message.profileUpdatedAt != null && message.hasOwnProperty("profileUpdatedAt"))
                object.profileUpdatedAt = message.profileUpdatedAt;
            if (message.profileUpdatedUserName != null && message.hasOwnProperty("profileUpdatedUserName"))
                object.profileUpdatedUserName = message.profileUpdatedUserName;
            if (message.campaign != null && message.hasOwnProperty("campaign"))
                object.campaign = options.enums === String ? $root.entity.Customer.Campaign[message.campaign] : message.campaign;
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                object.birthplace = message.birthplace;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                object.facebookURL = message.facebookURL;
            if (message.linkedInURL != null && message.hasOwnProperty("linkedInURL"))
                object.linkedInURL = message.linkedInURL;
            if (message.xURL != null && message.hasOwnProperty("xURL"))
                object.xURL = message.xURL;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this Customer to JSON.
         * @function toJSON
         * @memberof entity.Customer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Customer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Type enum.
         * @name entity.Customer.Type
         * @enum {number}
         * @property {number} Type_Unknown=0 Type_Unknown value
         * @property {number} Type_Expert=1 Type_Expert value
         * @property {number} Type_Pro=2 Type_Pro value
         * @property {number} Type_Both=3 Type_Both value
         */
        Customer.Type = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Type_Unknown"] = 0;
            values[valuesById[1] = "Type_Expert"] = 1;
            values[valuesById[2] = "Type_Pro"] = 2;
            values[valuesById[3] = "Type_Both"] = 3;
            return values;
        })();

        /**
         * Campaign enum.
         * @name entity.Customer.Campaign
         * @enum {number}
         * @property {number} Campaign_Normal=0 Campaign_Normal value
         * @property {number} Campaign_SuperEngineer=1 Campaign_SuperEngineer value
         */
        Customer.Campaign = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Campaign_Normal"] = 0;
            values[valuesById[1] = "Campaign_SuperEngineer"] = 1;
            return values;
        })();

        /**
         * Language enum.
         * @name entity.Customer.Language
         * @enum {number}
         * @property {number} Language_Unknown=0 Language_Unknown value
         * @property {number} Language_English=1 Language_English value
         * @property {number} Language_Korean=2 Language_Korean value
         * @property {number} Language_Chinese=3 Language_Chinese value
         * @property {number} Language_Spanish=4 Language_Spanish value
         * @property {number} Language_German=5 Language_German value
         * @property {number} Language_French=6 Language_French value
         * @property {number} Language_Other=7 Language_Other value
         */
        Customer.Language = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Language_Unknown"] = 0;
            values[valuesById[1] = "Language_English"] = 1;
            values[valuesById[2] = "Language_Korean"] = 2;
            values[valuesById[3] = "Language_Chinese"] = 3;
            values[valuesById[4] = "Language_Spanish"] = 4;
            values[valuesById[5] = "Language_German"] = 5;
            values[valuesById[6] = "Language_French"] = 6;
            values[valuesById[7] = "Language_Other"] = 7;
            return values;
        })();

        /**
         * SpeakingLevel enum.
         * @name entity.Customer.SpeakingLevel
         * @enum {number}
         * @property {number} SpeakingLevel_Unknown=0 SpeakingLevel_Unknown value
         * @property {number} SpeakingLevel_Basic_Conversation=1 SpeakingLevel_Basic_Conversation value
         * @property {number} SpeakingLevel_Business=2 SpeakingLevel_Business value
         * @property {number} SpeakingLevel_Native=3 SpeakingLevel_Native value
         */
        Customer.SpeakingLevel = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SpeakingLevel_Unknown"] = 0;
            values[valuesById[1] = "SpeakingLevel_Basic_Conversation"] = 1;
            values[valuesById[2] = "SpeakingLevel_Business"] = 2;
            values[valuesById[3] = "SpeakingLevel_Native"] = 3;
            return values;
        })();

        /**
         * Status enum.
         * @name entity.Customer.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_Inspection=1 Status_Inspection value
         * @property {number} Status_Denied=2 Status_Denied value
         * @property {number} Status_Active=3 Status_Active value
         * @property {number} Status_BAN=4 Status_BAN value
         * @property {number} Status_Delete=5 Status_Delete value
         * @property {number} Status_PassedInspection=6 Status_PassedInspection value
         * @property {number} Status_NonPassedInspection=7 Status_NonPassedInspection value
         * @property {number} Status_Suspend=8 Status_Suspend value
         * @property {number} Status_Hidden=9 Status_Hidden value
         */
        Customer.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_Inspection"] = 1;
            values[valuesById[2] = "Status_Denied"] = 2;
            values[valuesById[3] = "Status_Active"] = 3;
            values[valuesById[4] = "Status_BAN"] = 4;
            values[valuesById[5] = "Status_Delete"] = 5;
            values[valuesById[6] = "Status_PassedInspection"] = 6;
            values[valuesById[7] = "Status_NonPassedInspection"] = 7;
            values[valuesById[8] = "Status_Suspend"] = 8;
            values[valuesById[9] = "Status_Hidden"] = 9;
            return values;
        })();

        /**
         * WorkingFrequency enum.
         * @name entity.Customer.WorkingFrequency
         * @enum {number}
         * @property {number} WorkingFrequency_Unknown=0 WorkingFrequency_Unknown value
         * @property {number} WorkingFrequency_Under_1_Day=1 WorkingFrequency_Under_1_Day value
         * @property {number} WorkingFrequency_1_2_Day=2 WorkingFrequency_1_2_Day value
         * @property {number} WorkingFrequency_2_3_Day=3 WorkingFrequency_2_3_Day value
         * @property {number} WorkingFrequency_Over_3_Day=4 WorkingFrequency_Over_3_Day value
         * @property {number} WorkingFrequency_Consultation=5 WorkingFrequency_Consultation value
         */
        Customer.WorkingFrequency = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkingFrequency_Unknown"] = 0;
            values[valuesById[1] = "WorkingFrequency_Under_1_Day"] = 1;
            values[valuesById[2] = "WorkingFrequency_1_2_Day"] = 2;
            values[valuesById[3] = "WorkingFrequency_2_3_Day"] = 3;
            values[valuesById[4] = "WorkingFrequency_Over_3_Day"] = 4;
            values[valuesById[5] = "WorkingFrequency_Consultation"] = 5;
            return values;
        })();

        /**
         * RequestedFee enum.
         * @name entity.Customer.RequestedFee
         * @enum {number}
         * @property {number} RequestedFee_Unknown=0 RequestedFee_Unknown value
         * @property {number} RequestedFee_Over_400000=1 RequestedFee_Over_400000 value
         * @property {number} RequestedFee_300000_400000=2 RequestedFee_300000_400000 value
         * @property {number} RequestedFee_200000_300000=3 RequestedFee_200000_300000 value
         * @property {number} RequestedFee_Under_200000=4 RequestedFee_Under_200000 value
         */
        Customer.RequestedFee = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RequestedFee_Unknown"] = 0;
            values[valuesById[1] = "RequestedFee_Over_400000"] = 1;
            values[valuesById[2] = "RequestedFee_300000_400000"] = 2;
            values[valuesById[3] = "RequestedFee_200000_300000"] = 3;
            values[valuesById[4] = "RequestedFee_Under_200000"] = 4;
            return values;
        })();

        /**
         * WorkIntention enum.
         * @name entity.Customer.WorkIntention
         * @enum {number}
         * @property {number} WorkIntention_Unknown=0 WorkIntention_Unknown value
         * @property {number} WorkIntention_OnlyAdvice=1 WorkIntention_OnlyAdvice value
         * @property {number} WorkIntention_WithWork=2 WorkIntention_WithWork value
         * @property {number} WorkIntention_Consultation_Required=3 WorkIntention_Consultation_Required value
         */
        Customer.WorkIntention = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkIntention_Unknown"] = 0;
            values[valuesById[1] = "WorkIntention_OnlyAdvice"] = 1;
            values[valuesById[2] = "WorkIntention_WithWork"] = 2;
            values[valuesById[3] = "WorkIntention_Consultation_Required"] = 3;
            return values;
        })();

        /**
         * FullTimePossibility enum.
         * @name entity.Customer.FullTimePossibility
         * @enum {number}
         * @property {number} FullTimePossibility_Unknown=0 FullTimePossibility_Unknown value
         * @property {number} FullTimePossibility_Yes=1 FullTimePossibility_Yes value
         * @property {number} FullTimePossibility_No=2 FullTimePossibility_No value
         */
        Customer.FullTimePossibility = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "FullTimePossibility_Unknown"] = 0;
            values[valuesById[1] = "FullTimePossibility_Yes"] = 1;
            values[valuesById[2] = "FullTimePossibility_No"] = 2;
            return values;
        })();

        /**
         * BrokerageProjectPossibility enum.
         * @name entity.Customer.BrokerageProjectPossibility
         * @enum {number}
         * @property {number} BrokerageProjectPossibility_Unknown=0 BrokerageProjectPossibility_Unknown value
         * @property {number} BrokerageProjectPossibility_Yes=1 BrokerageProjectPossibility_Yes value
         * @property {number} BrokerageProjectPossibility_No=2 BrokerageProjectPossibility_No value
         */
        Customer.BrokerageProjectPossibility = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "BrokerageProjectPossibility_Unknown"] = 0;
            values[valuesById[1] = "BrokerageProjectPossibility_Yes"] = 1;
            values[valuesById[2] = "BrokerageProjectPossibility_No"] = 2;
            return values;
        })();

        return Customer;
    })();

    entity.CustomerList = (function() {

        /**
         * Properties of a CustomerList.
         * @memberof entity
         * @interface ICustomerList
         * @property {Array.<entity.ICustomer>|null} [items] CustomerList items
         */

        /**
         * Constructs a new CustomerList.
         * @memberof entity
         * @classdesc Represents a CustomerList.
         * @implements ICustomerList
         * @constructor
         * @param {entity.ICustomerList=} [properties] Properties to set
         */
        function CustomerList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerList items.
         * @member {Array.<entity.ICustomer>} items
         * @memberof entity.CustomerList
         * @instance
         */
        CustomerList.prototype.items = $util.emptyArray;

        /**
         * Creates a new CustomerList instance using the specified properties.
         * @function create
         * @memberof entity.CustomerList
         * @static
         * @param {entity.ICustomerList=} [properties] Properties to set
         * @returns {entity.CustomerList} CustomerList instance
         */
        CustomerList.create = function create(properties) {
            return new CustomerList(properties);
        };

        /**
         * Encodes the specified CustomerList message. Does not implicitly {@link entity.CustomerList.verify|verify} messages.
         * @function encode
         * @memberof entity.CustomerList
         * @static
         * @param {entity.ICustomerList} message CustomerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Customer.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CustomerList message, length delimited. Does not implicitly {@link entity.CustomerList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.CustomerList
         * @static
         * @param {entity.ICustomerList} message CustomerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.CustomerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.CustomerList} CustomerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.CustomerList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Customer.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.CustomerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.CustomerList} CustomerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerList message.
         * @function verify
         * @memberof entity.CustomerList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Customer.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CustomerList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.CustomerList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.CustomerList} CustomerList
         */
        CustomerList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.CustomerList)
                return object;
            var message = new $root.entity.CustomerList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.CustomerList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.CustomerList.items: object expected");
                    message.items[i] = $root.entity.Customer.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomerList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.CustomerList
         * @static
         * @param {entity.CustomerList} message CustomerList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Customer.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CustomerList to JSON.
         * @function toJSON
         * @memberof entity.CustomerList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerList;
    })();

    entity.SafeCustomer = (function() {

        /**
         * Properties of a SafeCustomer.
         * @memberof entity
         * @interface ISafeCustomer
         * @property {string|null} [id] SafeCustomer id
         * @property {string|null} [name] SafeCustomer name
         * @property {string|null} [gsIconURL] SafeCustomer gsIconURL
         * @property {string|null} [signedIconURL] SafeCustomer signedIconURL
         * @property {string|null} [birthdate] SafeCustomer birthdate
         * @property {entity.User.Gender|null} [gender] SafeCustomer gender
         * @property {string|null} [pr] SafeCustomer pr
         * @property {string|null} [address] SafeCustomer address
         * @property {Array.<string>|null} [academicBackgrounds] SafeCustomer academicBackgrounds
         * @property {Array.<string>|null} [requirements] SafeCustomer requirements
         * @property {Array.<entity.Customer.Language>|null} [languages] SafeCustomer languages
         * @property {string|null} [moreLanguage] SafeCustomer moreLanguage
         * @property {entity.Customer.SpeakingLevel|null} [speakingLevel] SafeCustomer speakingLevel
         * @property {entity.Customer.Status|null} [status] SafeCustomer status
         * @property {string|null} [resumeURL] SafeCustomer resumeURL
         * @property {string|null} [jobHistoryURL] SafeCustomer jobHistoryURL
         * @property {entity.Customer.WorkingFrequency|null} [workingFrequency] SafeCustomer workingFrequency
         * @property {entity.Customer.RequestedFee|null} [requestedFee] SafeCustomer requestedFee
         * @property {string|null} [requestedCondition] SafeCustomer requestedCondition
         * @property {string|null} [dutySummary] SafeCustomer dutySummary
         * @property {entity.Customer.WorkIntention|null} [workIntention] SafeCustomer workIntention
         * @property {entity.Customer.FullTimePossibility|null} [fullTimePossibility] SafeCustomer fullTimePossibility
         * @property {entity.Customer.BrokerageProjectPossibility|null} [brokerageProjectPossibility] SafeCustomer brokerageProjectPossibility
         * @property {string|null} [portfolioURL] SafeCustomer portfolioURL
         * @property {entity.Customer.Type|null} [type] SafeCustomer type
         * @property {Array.<entity.ISearchHighlight>|null} [highlights] SafeCustomer highlights
         * @property {string|null} [catchphrase] SafeCustomer catchphrase
         * @property {string|null} [jobCareerCatchphrase] SafeCustomer jobCareerCatchphrase
         * @property {string|null} [catchphraseUpdatedAt] SafeCustomer catchphraseUpdatedAt
         * @property {string|null} [catchphraseUpdatedUserName] SafeCustomer catchphraseUpdatedUserName
         * @property {string|null} [adminMemo] SafeCustomer adminMemo
         * @property {string|null} [adminMemoUpdatedAt] SafeCustomer adminMemoUpdatedAt
         * @property {string|null} [adminMemoUpdatedUserName] SafeCustomer adminMemoUpdatedUserName
         * @property {Array.<entity.ISingleSkillTag>|null} [singleSkillTags] SafeCustomer singleSkillTags
         * @property {Array.<entity.IMultiSkillTag>|null} [multiSkillTags] SafeCustomer multiSkillTags
         * @property {Array.<entity.IOccupationSkillTag>|null} [occupationSkillTags] SafeCustomer occupationSkillTags
         * @property {Array.<string>|null} [displayOccupationSkillCategories] SafeCustomer displayOccupationSkillCategories
         * @property {Array.<string>|null} [displayOccupationSkillTags] SafeCustomer displayOccupationSkillTags
         * @property {string|null} [profileUpdatedAt] SafeCustomer profileUpdatedAt
         * @property {string|null} [profileUpdatedUserName] SafeCustomer profileUpdatedUserName
         * @property {entity.Customer.Campaign|null} [campaign] SafeCustomer campaign
         * @property {string|null} [birthplace] SafeCustomer birthplace
         * @property {string|null} [routeInfo] SafeCustomer routeInfo
         * @property {string|null} [agenticSummary] SafeCustomer agenticSummary
         * @property {string|null} [ageGroup] SafeCustomer ageGroup
         * @property {string|null} [createdAt] SafeCustomer createdAt
         */

        /**
         * Constructs a new SafeCustomer.
         * @memberof entity
         * @classdesc Represents a SafeCustomer.
         * @implements ISafeCustomer
         * @constructor
         * @param {entity.ISafeCustomer=} [properties] Properties to set
         */
        function SafeCustomer(properties) {
            this.academicBackgrounds = [];
            this.requirements = [];
            this.languages = [];
            this.highlights = [];
            this.singleSkillTags = [];
            this.multiSkillTags = [];
            this.occupationSkillTags = [];
            this.displayOccupationSkillCategories = [];
            this.displayOccupationSkillTags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SafeCustomer id.
         * @member {string} id
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.id = "";

        /**
         * SafeCustomer name.
         * @member {string} name
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.name = "";

        /**
         * SafeCustomer gsIconURL.
         * @member {string} gsIconURL
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.gsIconURL = "";

        /**
         * SafeCustomer signedIconURL.
         * @member {string} signedIconURL
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.signedIconURL = "";

        /**
         * SafeCustomer birthdate.
         * @member {string} birthdate
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.birthdate = "";

        /**
         * SafeCustomer gender.
         * @member {entity.User.Gender} gender
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.gender = 0;

        /**
         * SafeCustomer pr.
         * @member {string} pr
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.pr = "";

        /**
         * SafeCustomer address.
         * @member {string} address
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.address = "";

        /**
         * SafeCustomer academicBackgrounds.
         * @member {Array.<string>} academicBackgrounds
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.academicBackgrounds = $util.emptyArray;

        /**
         * SafeCustomer requirements.
         * @member {Array.<string>} requirements
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.requirements = $util.emptyArray;

        /**
         * SafeCustomer languages.
         * @member {Array.<entity.Customer.Language>} languages
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.languages = $util.emptyArray;

        /**
         * SafeCustomer moreLanguage.
         * @member {string} moreLanguage
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.moreLanguage = "";

        /**
         * SafeCustomer speakingLevel.
         * @member {entity.Customer.SpeakingLevel} speakingLevel
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.speakingLevel = 0;

        /**
         * SafeCustomer status.
         * @member {entity.Customer.Status} status
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.status = 0;

        /**
         * SafeCustomer resumeURL.
         * @member {string} resumeURL
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.resumeURL = "";

        /**
         * SafeCustomer jobHistoryURL.
         * @member {string} jobHistoryURL
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.jobHistoryURL = "";

        /**
         * SafeCustomer workingFrequency.
         * @member {entity.Customer.WorkingFrequency} workingFrequency
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.workingFrequency = 0;

        /**
         * SafeCustomer requestedFee.
         * @member {entity.Customer.RequestedFee} requestedFee
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.requestedFee = 0;

        /**
         * SafeCustomer requestedCondition.
         * @member {string} requestedCondition
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.requestedCondition = "";

        /**
         * SafeCustomer dutySummary.
         * @member {string} dutySummary
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.dutySummary = "";

        /**
         * SafeCustomer workIntention.
         * @member {entity.Customer.WorkIntention} workIntention
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.workIntention = 0;

        /**
         * SafeCustomer fullTimePossibility.
         * @member {entity.Customer.FullTimePossibility} fullTimePossibility
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.fullTimePossibility = 0;

        /**
         * SafeCustomer brokerageProjectPossibility.
         * @member {entity.Customer.BrokerageProjectPossibility} brokerageProjectPossibility
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.brokerageProjectPossibility = 0;

        /**
         * SafeCustomer portfolioURL.
         * @member {string} portfolioURL
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.portfolioURL = "";

        /**
         * SafeCustomer type.
         * @member {entity.Customer.Type} type
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.type = 0;

        /**
         * SafeCustomer highlights.
         * @member {Array.<entity.ISearchHighlight>} highlights
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.highlights = $util.emptyArray;

        /**
         * SafeCustomer catchphrase.
         * @member {string} catchphrase
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.catchphrase = "";

        /**
         * SafeCustomer jobCareerCatchphrase.
         * @member {string} jobCareerCatchphrase
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.jobCareerCatchphrase = "";

        /**
         * SafeCustomer catchphraseUpdatedAt.
         * @member {string} catchphraseUpdatedAt
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.catchphraseUpdatedAt = "";

        /**
         * SafeCustomer catchphraseUpdatedUserName.
         * @member {string} catchphraseUpdatedUserName
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.catchphraseUpdatedUserName = "";

        /**
         * SafeCustomer adminMemo.
         * @member {string} adminMemo
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.adminMemo = "";

        /**
         * SafeCustomer adminMemoUpdatedAt.
         * @member {string} adminMemoUpdatedAt
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.adminMemoUpdatedAt = "";

        /**
         * SafeCustomer adminMemoUpdatedUserName.
         * @member {string} adminMemoUpdatedUserName
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.adminMemoUpdatedUserName = "";

        /**
         * SafeCustomer singleSkillTags.
         * @member {Array.<entity.ISingleSkillTag>} singleSkillTags
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.singleSkillTags = $util.emptyArray;

        /**
         * SafeCustomer multiSkillTags.
         * @member {Array.<entity.IMultiSkillTag>} multiSkillTags
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.multiSkillTags = $util.emptyArray;

        /**
         * SafeCustomer occupationSkillTags.
         * @member {Array.<entity.IOccupationSkillTag>} occupationSkillTags
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.occupationSkillTags = $util.emptyArray;

        /**
         * SafeCustomer displayOccupationSkillCategories.
         * @member {Array.<string>} displayOccupationSkillCategories
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.displayOccupationSkillCategories = $util.emptyArray;

        /**
         * SafeCustomer displayOccupationSkillTags.
         * @member {Array.<string>} displayOccupationSkillTags
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.displayOccupationSkillTags = $util.emptyArray;

        /**
         * SafeCustomer profileUpdatedAt.
         * @member {string} profileUpdatedAt
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.profileUpdatedAt = "";

        /**
         * SafeCustomer profileUpdatedUserName.
         * @member {string} profileUpdatedUserName
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.profileUpdatedUserName = "";

        /**
         * SafeCustomer campaign.
         * @member {entity.Customer.Campaign} campaign
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.campaign = 0;

        /**
         * SafeCustomer birthplace.
         * @member {string} birthplace
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.birthplace = "";

        /**
         * SafeCustomer routeInfo.
         * @member {string} routeInfo
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.routeInfo = "";

        /**
         * SafeCustomer agenticSummary.
         * @member {string} agenticSummary
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.agenticSummary = "";

        /**
         * SafeCustomer ageGroup.
         * @member {string} ageGroup
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.ageGroup = "";

        /**
         * SafeCustomer createdAt.
         * @member {string} createdAt
         * @memberof entity.SafeCustomer
         * @instance
         */
        SafeCustomer.prototype.createdAt = "";

        /**
         * Creates a new SafeCustomer instance using the specified properties.
         * @function create
         * @memberof entity.SafeCustomer
         * @static
         * @param {entity.ISafeCustomer=} [properties] Properties to set
         * @returns {entity.SafeCustomer} SafeCustomer instance
         */
        SafeCustomer.create = function create(properties) {
            return new SafeCustomer(properties);
        };

        /**
         * Encodes the specified SafeCustomer message. Does not implicitly {@link entity.SafeCustomer.verify|verify} messages.
         * @function encode
         * @memberof entity.SafeCustomer
         * @static
         * @param {entity.ISafeCustomer} message SafeCustomer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SafeCustomer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.gsIconURL != null && Object.hasOwnProperty.call(message, "gsIconURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gsIconURL);
            if (message.signedIconURL != null && Object.hasOwnProperty.call(message, "signedIconURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.signedIconURL);
            if (message.birthdate != null && Object.hasOwnProperty.call(message, "birthdate"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.birthdate);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.gender);
            if (message.pr != null && Object.hasOwnProperty.call(message, "pr"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.pr);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.address);
            if (message.academicBackgrounds != null && message.academicBackgrounds.length)
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.academicBackgrounds[i]);
            if (message.requirements != null && message.requirements.length)
                for (var i = 0; i < message.requirements.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.requirements[i]);
            if (message.languages != null && message.languages.length) {
                writer.uint32(/* id 11, wireType 2 =*/90).fork();
                for (var i = 0; i < message.languages.length; ++i)
                    writer.int32(message.languages[i]);
                writer.ldelim();
            }
            if (message.moreLanguage != null && Object.hasOwnProperty.call(message, "moreLanguage"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.moreLanguage);
            if (message.speakingLevel != null && Object.hasOwnProperty.call(message, "speakingLevel"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.speakingLevel);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.status);
            if (message.resumeURL != null && Object.hasOwnProperty.call(message, "resumeURL"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.resumeURL);
            if (message.jobHistoryURL != null && Object.hasOwnProperty.call(message, "jobHistoryURL"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.jobHistoryURL);
            if (message.workingFrequency != null && Object.hasOwnProperty.call(message, "workingFrequency"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.workingFrequency);
            if (message.requestedFee != null && Object.hasOwnProperty.call(message, "requestedFee"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.requestedFee);
            if (message.requestedCondition != null && Object.hasOwnProperty.call(message, "requestedCondition"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.requestedCondition);
            if (message.dutySummary != null && Object.hasOwnProperty.call(message, "dutySummary"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.dutySummary);
            if (message.workIntention != null && Object.hasOwnProperty.call(message, "workIntention"))
                writer.uint32(/* id 21, wireType 0 =*/168).int32(message.workIntention);
            if (message.fullTimePossibility != null && Object.hasOwnProperty.call(message, "fullTimePossibility"))
                writer.uint32(/* id 22, wireType 0 =*/176).int32(message.fullTimePossibility);
            if (message.brokerageProjectPossibility != null && Object.hasOwnProperty.call(message, "brokerageProjectPossibility"))
                writer.uint32(/* id 23, wireType 0 =*/184).int32(message.brokerageProjectPossibility);
            if (message.portfolioURL != null && Object.hasOwnProperty.call(message, "portfolioURL"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.portfolioURL);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 25, wireType 0 =*/200).int32(message.type);
            if (message.highlights != null && message.highlights.length)
                for (var i = 0; i < message.highlights.length; ++i)
                    $root.entity.SearchHighlight.encode(message.highlights[i], writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.catchphrase != null && Object.hasOwnProperty.call(message, "catchphrase"))
                writer.uint32(/* id 29, wireType 2 =*/234).string(message.catchphrase);
            if (message.jobCareerCatchphrase != null && Object.hasOwnProperty.call(message, "jobCareerCatchphrase"))
                writer.uint32(/* id 30, wireType 2 =*/242).string(message.jobCareerCatchphrase);
            if (message.catchphraseUpdatedAt != null && Object.hasOwnProperty.call(message, "catchphraseUpdatedAt"))
                writer.uint32(/* id 31, wireType 2 =*/250).string(message.catchphraseUpdatedAt);
            if (message.catchphraseUpdatedUserName != null && Object.hasOwnProperty.call(message, "catchphraseUpdatedUserName"))
                writer.uint32(/* id 32, wireType 2 =*/258).string(message.catchphraseUpdatedUserName);
            if (message.adminMemo != null && Object.hasOwnProperty.call(message, "adminMemo"))
                writer.uint32(/* id 33, wireType 2 =*/266).string(message.adminMemo);
            if (message.adminMemoUpdatedAt != null && Object.hasOwnProperty.call(message, "adminMemoUpdatedAt"))
                writer.uint32(/* id 34, wireType 2 =*/274).string(message.adminMemoUpdatedAt);
            if (message.adminMemoUpdatedUserName != null && Object.hasOwnProperty.call(message, "adminMemoUpdatedUserName"))
                writer.uint32(/* id 35, wireType 2 =*/282).string(message.adminMemoUpdatedUserName);
            if (message.singleSkillTags != null && message.singleSkillTags.length)
                for (var i = 0; i < message.singleSkillTags.length; ++i)
                    $root.entity.SingleSkillTag.encode(message.singleSkillTags[i], writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
            if (message.multiSkillTags != null && message.multiSkillTags.length)
                for (var i = 0; i < message.multiSkillTags.length; ++i)
                    $root.entity.MultiSkillTag.encode(message.multiSkillTags[i], writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.occupationSkillTags != null && message.occupationSkillTags.length)
                for (var i = 0; i < message.occupationSkillTags.length; ++i)
                    $root.entity.OccupationSkillTag.encode(message.occupationSkillTags[i], writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.displayOccupationSkillCategories != null && message.displayOccupationSkillCategories.length)
                for (var i = 0; i < message.displayOccupationSkillCategories.length; ++i)
                    writer.uint32(/* id 39, wireType 2 =*/314).string(message.displayOccupationSkillCategories[i]);
            if (message.displayOccupationSkillTags != null && message.displayOccupationSkillTags.length)
                for (var i = 0; i < message.displayOccupationSkillTags.length; ++i)
                    writer.uint32(/* id 40, wireType 2 =*/322).string(message.displayOccupationSkillTags[i]);
            if (message.profileUpdatedAt != null && Object.hasOwnProperty.call(message, "profileUpdatedAt"))
                writer.uint32(/* id 41, wireType 2 =*/330).string(message.profileUpdatedAt);
            if (message.profileUpdatedUserName != null && Object.hasOwnProperty.call(message, "profileUpdatedUserName"))
                writer.uint32(/* id 42, wireType 2 =*/338).string(message.profileUpdatedUserName);
            if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                writer.uint32(/* id 43, wireType 0 =*/344).int32(message.campaign);
            if (message.birthplace != null && Object.hasOwnProperty.call(message, "birthplace"))
                writer.uint32(/* id 44, wireType 2 =*/354).string(message.birthplace);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 45, wireType 2 =*/362).string(message.routeInfo);
            if (message.agenticSummary != null && Object.hasOwnProperty.call(message, "agenticSummary"))
                writer.uint32(/* id 46, wireType 2 =*/370).string(message.agenticSummary);
            if (message.ageGroup != null && Object.hasOwnProperty.call(message, "ageGroup"))
                writer.uint32(/* id 47, wireType 2 =*/378).string(message.ageGroup);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified SafeCustomer message, length delimited. Does not implicitly {@link entity.SafeCustomer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SafeCustomer
         * @static
         * @param {entity.ISafeCustomer} message SafeCustomer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SafeCustomer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SafeCustomer message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SafeCustomer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SafeCustomer} SafeCustomer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SafeCustomer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SafeCustomer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.gsIconURL = reader.string();
                    break;
                case 4:
                    message.signedIconURL = reader.string();
                    break;
                case 5:
                    message.birthdate = reader.string();
                    break;
                case 6:
                    message.gender = reader.int32();
                    break;
                case 7:
                    message.pr = reader.string();
                    break;
                case 8:
                    message.address = reader.string();
                    break;
                case 9:
                    if (!(message.academicBackgrounds && message.academicBackgrounds.length))
                        message.academicBackgrounds = [];
                    message.academicBackgrounds.push(reader.string());
                    break;
                case 10:
                    if (!(message.requirements && message.requirements.length))
                        message.requirements = [];
                    message.requirements.push(reader.string());
                    break;
                case 11:
                    if (!(message.languages && message.languages.length))
                        message.languages = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.languages.push(reader.int32());
                    } else
                        message.languages.push(reader.int32());
                    break;
                case 12:
                    message.moreLanguage = reader.string();
                    break;
                case 13:
                    message.speakingLevel = reader.int32();
                    break;
                case 14:
                    message.status = reader.int32();
                    break;
                case 15:
                    message.resumeURL = reader.string();
                    break;
                case 16:
                    message.jobHistoryURL = reader.string();
                    break;
                case 17:
                    message.workingFrequency = reader.int32();
                    break;
                case 18:
                    message.requestedFee = reader.int32();
                    break;
                case 19:
                    message.requestedCondition = reader.string();
                    break;
                case 20:
                    message.dutySummary = reader.string();
                    break;
                case 21:
                    message.workIntention = reader.int32();
                    break;
                case 22:
                    message.fullTimePossibility = reader.int32();
                    break;
                case 23:
                    message.brokerageProjectPossibility = reader.int32();
                    break;
                case 24:
                    message.portfolioURL = reader.string();
                    break;
                case 25:
                    message.type = reader.int32();
                    break;
                case 26:
                    if (!(message.highlights && message.highlights.length))
                        message.highlights = [];
                    message.highlights.push($root.entity.SearchHighlight.decode(reader, reader.uint32()));
                    break;
                case 29:
                    message.catchphrase = reader.string();
                    break;
                case 30:
                    message.jobCareerCatchphrase = reader.string();
                    break;
                case 31:
                    message.catchphraseUpdatedAt = reader.string();
                    break;
                case 32:
                    message.catchphraseUpdatedUserName = reader.string();
                    break;
                case 33:
                    message.adminMemo = reader.string();
                    break;
                case 34:
                    message.adminMemoUpdatedAt = reader.string();
                    break;
                case 35:
                    message.adminMemoUpdatedUserName = reader.string();
                    break;
                case 36:
                    if (!(message.singleSkillTags && message.singleSkillTags.length))
                        message.singleSkillTags = [];
                    message.singleSkillTags.push($root.entity.SingleSkillTag.decode(reader, reader.uint32()));
                    break;
                case 37:
                    if (!(message.multiSkillTags && message.multiSkillTags.length))
                        message.multiSkillTags = [];
                    message.multiSkillTags.push($root.entity.MultiSkillTag.decode(reader, reader.uint32()));
                    break;
                case 38:
                    if (!(message.occupationSkillTags && message.occupationSkillTags.length))
                        message.occupationSkillTags = [];
                    message.occupationSkillTags.push($root.entity.OccupationSkillTag.decode(reader, reader.uint32()));
                    break;
                case 39:
                    if (!(message.displayOccupationSkillCategories && message.displayOccupationSkillCategories.length))
                        message.displayOccupationSkillCategories = [];
                    message.displayOccupationSkillCategories.push(reader.string());
                    break;
                case 40:
                    if (!(message.displayOccupationSkillTags && message.displayOccupationSkillTags.length))
                        message.displayOccupationSkillTags = [];
                    message.displayOccupationSkillTags.push(reader.string());
                    break;
                case 41:
                    message.profileUpdatedAt = reader.string();
                    break;
                case 42:
                    message.profileUpdatedUserName = reader.string();
                    break;
                case 43:
                    message.campaign = reader.int32();
                    break;
                case 44:
                    message.birthplace = reader.string();
                    break;
                case 45:
                    message.routeInfo = reader.string();
                    break;
                case 46:
                    message.agenticSummary = reader.string();
                    break;
                case 47:
                    message.ageGroup = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SafeCustomer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SafeCustomer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SafeCustomer} SafeCustomer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SafeCustomer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SafeCustomer message.
         * @function verify
         * @memberof entity.SafeCustomer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SafeCustomer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                if (!$util.isString(message.gsIconURL))
                    return "gsIconURL: string expected";
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                if (!$util.isString(message.signedIconURL))
                    return "signedIconURL: string expected";
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                if (!$util.isString(message.birthdate))
                    return "birthdate: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.pr != null && message.hasOwnProperty("pr"))
                if (!$util.isString(message.pr))
                    return "pr: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.academicBackgrounds != null && message.hasOwnProperty("academicBackgrounds")) {
                if (!Array.isArray(message.academicBackgrounds))
                    return "academicBackgrounds: array expected";
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    if (!$util.isString(message.academicBackgrounds[i]))
                        return "academicBackgrounds: string[] expected";
            }
            if (message.requirements != null && message.hasOwnProperty("requirements")) {
                if (!Array.isArray(message.requirements))
                    return "requirements: array expected";
                for (var i = 0; i < message.requirements.length; ++i)
                    if (!$util.isString(message.requirements[i]))
                        return "requirements: string[] expected";
            }
            if (message.languages != null && message.hasOwnProperty("languages")) {
                if (!Array.isArray(message.languages))
                    return "languages: array expected";
                for (var i = 0; i < message.languages.length; ++i)
                    switch (message.languages[i]) {
                    default:
                        return "languages: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                if (!$util.isString(message.moreLanguage))
                    return "moreLanguage: string expected";
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                switch (message.speakingLevel) {
                default:
                    return "speakingLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                if (!$util.isString(message.resumeURL))
                    return "resumeURL: string expected";
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                if (!$util.isString(message.jobHistoryURL))
                    return "jobHistoryURL: string expected";
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                switch (message.workingFrequency) {
                default:
                    return "workingFrequency: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                switch (message.requestedFee) {
                default:
                    return "requestedFee: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                if (!$util.isString(message.requestedCondition))
                    return "requestedCondition: string expected";
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                if (!$util.isString(message.dutySummary))
                    return "dutySummary: string expected";
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                switch (message.workIntention) {
                default:
                    return "workIntention: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                switch (message.fullTimePossibility) {
                default:
                    return "fullTimePossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                switch (message.brokerageProjectPossibility) {
                default:
                    return "brokerageProjectPossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                if (!$util.isString(message.portfolioURL))
                    return "portfolioURL: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.highlights != null && message.hasOwnProperty("highlights")) {
                if (!Array.isArray(message.highlights))
                    return "highlights: array expected";
                for (var i = 0; i < message.highlights.length; ++i) {
                    var error = $root.entity.SearchHighlight.verify(message.highlights[i]);
                    if (error)
                        return "highlights." + error;
                }
            }
            if (message.catchphrase != null && message.hasOwnProperty("catchphrase"))
                if (!$util.isString(message.catchphrase))
                    return "catchphrase: string expected";
            if (message.jobCareerCatchphrase != null && message.hasOwnProperty("jobCareerCatchphrase"))
                if (!$util.isString(message.jobCareerCatchphrase))
                    return "jobCareerCatchphrase: string expected";
            if (message.catchphraseUpdatedAt != null && message.hasOwnProperty("catchphraseUpdatedAt"))
                if (!$util.isString(message.catchphraseUpdatedAt))
                    return "catchphraseUpdatedAt: string expected";
            if (message.catchphraseUpdatedUserName != null && message.hasOwnProperty("catchphraseUpdatedUserName"))
                if (!$util.isString(message.catchphraseUpdatedUserName))
                    return "catchphraseUpdatedUserName: string expected";
            if (message.adminMemo != null && message.hasOwnProperty("adminMemo"))
                if (!$util.isString(message.adminMemo))
                    return "adminMemo: string expected";
            if (message.adminMemoUpdatedAt != null && message.hasOwnProperty("adminMemoUpdatedAt"))
                if (!$util.isString(message.adminMemoUpdatedAt))
                    return "adminMemoUpdatedAt: string expected";
            if (message.adminMemoUpdatedUserName != null && message.hasOwnProperty("adminMemoUpdatedUserName"))
                if (!$util.isString(message.adminMemoUpdatedUserName))
                    return "adminMemoUpdatedUserName: string expected";
            if (message.singleSkillTags != null && message.hasOwnProperty("singleSkillTags")) {
                if (!Array.isArray(message.singleSkillTags))
                    return "singleSkillTags: array expected";
                for (var i = 0; i < message.singleSkillTags.length; ++i) {
                    var error = $root.entity.SingleSkillTag.verify(message.singleSkillTags[i]);
                    if (error)
                        return "singleSkillTags." + error;
                }
            }
            if (message.multiSkillTags != null && message.hasOwnProperty("multiSkillTags")) {
                if (!Array.isArray(message.multiSkillTags))
                    return "multiSkillTags: array expected";
                for (var i = 0; i < message.multiSkillTags.length; ++i) {
                    var error = $root.entity.MultiSkillTag.verify(message.multiSkillTags[i]);
                    if (error)
                        return "multiSkillTags." + error;
                }
            }
            if (message.occupationSkillTags != null && message.hasOwnProperty("occupationSkillTags")) {
                if (!Array.isArray(message.occupationSkillTags))
                    return "occupationSkillTags: array expected";
                for (var i = 0; i < message.occupationSkillTags.length; ++i) {
                    var error = $root.entity.OccupationSkillTag.verify(message.occupationSkillTags[i]);
                    if (error)
                        return "occupationSkillTags." + error;
                }
            }
            if (message.displayOccupationSkillCategories != null && message.hasOwnProperty("displayOccupationSkillCategories")) {
                if (!Array.isArray(message.displayOccupationSkillCategories))
                    return "displayOccupationSkillCategories: array expected";
                for (var i = 0; i < message.displayOccupationSkillCategories.length; ++i)
                    if (!$util.isString(message.displayOccupationSkillCategories[i]))
                        return "displayOccupationSkillCategories: string[] expected";
            }
            if (message.displayOccupationSkillTags != null && message.hasOwnProperty("displayOccupationSkillTags")) {
                if (!Array.isArray(message.displayOccupationSkillTags))
                    return "displayOccupationSkillTags: array expected";
                for (var i = 0; i < message.displayOccupationSkillTags.length; ++i)
                    if (!$util.isString(message.displayOccupationSkillTags[i]))
                        return "displayOccupationSkillTags: string[] expected";
            }
            if (message.profileUpdatedAt != null && message.hasOwnProperty("profileUpdatedAt"))
                if (!$util.isString(message.profileUpdatedAt))
                    return "profileUpdatedAt: string expected";
            if (message.profileUpdatedUserName != null && message.hasOwnProperty("profileUpdatedUserName"))
                if (!$util.isString(message.profileUpdatedUserName))
                    return "profileUpdatedUserName: string expected";
            if (message.campaign != null && message.hasOwnProperty("campaign"))
                switch (message.campaign) {
                default:
                    return "campaign: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                if (!$util.isString(message.birthplace))
                    return "birthplace: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            if (message.agenticSummary != null && message.hasOwnProperty("agenticSummary"))
                if (!$util.isString(message.agenticSummary))
                    return "agenticSummary: string expected";
            if (message.ageGroup != null && message.hasOwnProperty("ageGroup"))
                if (!$util.isString(message.ageGroup))
                    return "ageGroup: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a SafeCustomer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SafeCustomer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SafeCustomer} SafeCustomer
         */
        SafeCustomer.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SafeCustomer)
                return object;
            var message = new $root.entity.SafeCustomer();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.gsIconURL != null)
                message.gsIconURL = String(object.gsIconURL);
            if (object.signedIconURL != null)
                message.signedIconURL = String(object.signedIconURL);
            if (object.birthdate != null)
                message.birthdate = String(object.birthdate);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.pr != null)
                message.pr = String(object.pr);
            if (object.address != null)
                message.address = String(object.address);
            if (object.academicBackgrounds) {
                if (!Array.isArray(object.academicBackgrounds))
                    throw TypeError(".entity.SafeCustomer.academicBackgrounds: array expected");
                message.academicBackgrounds = [];
                for (var i = 0; i < object.academicBackgrounds.length; ++i)
                    message.academicBackgrounds[i] = String(object.academicBackgrounds[i]);
            }
            if (object.requirements) {
                if (!Array.isArray(object.requirements))
                    throw TypeError(".entity.SafeCustomer.requirements: array expected");
                message.requirements = [];
                for (var i = 0; i < object.requirements.length; ++i)
                    message.requirements[i] = String(object.requirements[i]);
            }
            if (object.languages) {
                if (!Array.isArray(object.languages))
                    throw TypeError(".entity.SafeCustomer.languages: array expected");
                message.languages = [];
                for (var i = 0; i < object.languages.length; ++i)
                    switch (object.languages[i]) {
                    default:
                    case "Language_Unknown":
                    case 0:
                        message.languages[i] = 0;
                        break;
                    case "Language_English":
                    case 1:
                        message.languages[i] = 1;
                        break;
                    case "Language_Korean":
                    case 2:
                        message.languages[i] = 2;
                        break;
                    case "Language_Chinese":
                    case 3:
                        message.languages[i] = 3;
                        break;
                    case "Language_Spanish":
                    case 4:
                        message.languages[i] = 4;
                        break;
                    case "Language_German":
                    case 5:
                        message.languages[i] = 5;
                        break;
                    case "Language_French":
                    case 6:
                        message.languages[i] = 6;
                        break;
                    case "Language_Other":
                    case 7:
                        message.languages[i] = 7;
                        break;
                    }
            }
            if (object.moreLanguage != null)
                message.moreLanguage = String(object.moreLanguage);
            switch (object.speakingLevel) {
            case "SpeakingLevel_Unknown":
            case 0:
                message.speakingLevel = 0;
                break;
            case "SpeakingLevel_Basic_Conversation":
            case 1:
                message.speakingLevel = 1;
                break;
            case "SpeakingLevel_Business":
            case 2:
                message.speakingLevel = 2;
                break;
            case "SpeakingLevel_Native":
            case 3:
                message.speakingLevel = 3;
                break;
            }
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Inspection":
            case 1:
                message.status = 1;
                break;
            case "Status_Denied":
            case 2:
                message.status = 2;
                break;
            case "Status_Active":
            case 3:
                message.status = 3;
                break;
            case "Status_BAN":
            case 4:
                message.status = 4;
                break;
            case "Status_Delete":
            case 5:
                message.status = 5;
                break;
            case "Status_PassedInspection":
            case 6:
                message.status = 6;
                break;
            case "Status_NonPassedInspection":
            case 7:
                message.status = 7;
                break;
            case "Status_Suspend":
            case 8:
                message.status = 8;
                break;
            case "Status_Hidden":
            case 9:
                message.status = 9;
                break;
            }
            if (object.resumeURL != null)
                message.resumeURL = String(object.resumeURL);
            if (object.jobHistoryURL != null)
                message.jobHistoryURL = String(object.jobHistoryURL);
            switch (object.workingFrequency) {
            case "WorkingFrequency_Unknown":
            case 0:
                message.workingFrequency = 0;
                break;
            case "WorkingFrequency_Under_1_Day":
            case 1:
                message.workingFrequency = 1;
                break;
            case "WorkingFrequency_1_2_Day":
            case 2:
                message.workingFrequency = 2;
                break;
            case "WorkingFrequency_2_3_Day":
            case 3:
                message.workingFrequency = 3;
                break;
            case "WorkingFrequency_Over_3_Day":
            case 4:
                message.workingFrequency = 4;
                break;
            case "WorkingFrequency_Consultation":
            case 5:
                message.workingFrequency = 5;
                break;
            }
            switch (object.requestedFee) {
            case "RequestedFee_Unknown":
            case 0:
                message.requestedFee = 0;
                break;
            case "RequestedFee_Over_400000":
            case 1:
                message.requestedFee = 1;
                break;
            case "RequestedFee_300000_400000":
            case 2:
                message.requestedFee = 2;
                break;
            case "RequestedFee_200000_300000":
            case 3:
                message.requestedFee = 3;
                break;
            case "RequestedFee_Under_200000":
            case 4:
                message.requestedFee = 4;
                break;
            }
            if (object.requestedCondition != null)
                message.requestedCondition = String(object.requestedCondition);
            if (object.dutySummary != null)
                message.dutySummary = String(object.dutySummary);
            switch (object.workIntention) {
            case "WorkIntention_Unknown":
            case 0:
                message.workIntention = 0;
                break;
            case "WorkIntention_OnlyAdvice":
            case 1:
                message.workIntention = 1;
                break;
            case "WorkIntention_WithWork":
            case 2:
                message.workIntention = 2;
                break;
            case "WorkIntention_Consultation_Required":
            case 3:
                message.workIntention = 3;
                break;
            }
            switch (object.fullTimePossibility) {
            case "FullTimePossibility_Unknown":
            case 0:
                message.fullTimePossibility = 0;
                break;
            case "FullTimePossibility_Yes":
            case 1:
                message.fullTimePossibility = 1;
                break;
            case "FullTimePossibility_No":
            case 2:
                message.fullTimePossibility = 2;
                break;
            }
            switch (object.brokerageProjectPossibility) {
            case "BrokerageProjectPossibility_Unknown":
            case 0:
                message.brokerageProjectPossibility = 0;
                break;
            case "BrokerageProjectPossibility_Yes":
            case 1:
                message.brokerageProjectPossibility = 1;
                break;
            case "BrokerageProjectPossibility_No":
            case 2:
                message.brokerageProjectPossibility = 2;
                break;
            }
            if (object.portfolioURL != null)
                message.portfolioURL = String(object.portfolioURL);
            switch (object.type) {
            case "Type_Unknown":
            case 0:
                message.type = 0;
                break;
            case "Type_Expert":
            case 1:
                message.type = 1;
                break;
            case "Type_Pro":
            case 2:
                message.type = 2;
                break;
            case "Type_Both":
            case 3:
                message.type = 3;
                break;
            }
            if (object.highlights) {
                if (!Array.isArray(object.highlights))
                    throw TypeError(".entity.SafeCustomer.highlights: array expected");
                message.highlights = [];
                for (var i = 0; i < object.highlights.length; ++i) {
                    if (typeof object.highlights[i] !== "object")
                        throw TypeError(".entity.SafeCustomer.highlights: object expected");
                    message.highlights[i] = $root.entity.SearchHighlight.fromObject(object.highlights[i]);
                }
            }
            if (object.catchphrase != null)
                message.catchphrase = String(object.catchphrase);
            if (object.jobCareerCatchphrase != null)
                message.jobCareerCatchphrase = String(object.jobCareerCatchphrase);
            if (object.catchphraseUpdatedAt != null)
                message.catchphraseUpdatedAt = String(object.catchphraseUpdatedAt);
            if (object.catchphraseUpdatedUserName != null)
                message.catchphraseUpdatedUserName = String(object.catchphraseUpdatedUserName);
            if (object.adminMemo != null)
                message.adminMemo = String(object.adminMemo);
            if (object.adminMemoUpdatedAt != null)
                message.adminMemoUpdatedAt = String(object.adminMemoUpdatedAt);
            if (object.adminMemoUpdatedUserName != null)
                message.adminMemoUpdatedUserName = String(object.adminMemoUpdatedUserName);
            if (object.singleSkillTags) {
                if (!Array.isArray(object.singleSkillTags))
                    throw TypeError(".entity.SafeCustomer.singleSkillTags: array expected");
                message.singleSkillTags = [];
                for (var i = 0; i < object.singleSkillTags.length; ++i) {
                    if (typeof object.singleSkillTags[i] !== "object")
                        throw TypeError(".entity.SafeCustomer.singleSkillTags: object expected");
                    message.singleSkillTags[i] = $root.entity.SingleSkillTag.fromObject(object.singleSkillTags[i]);
                }
            }
            if (object.multiSkillTags) {
                if (!Array.isArray(object.multiSkillTags))
                    throw TypeError(".entity.SafeCustomer.multiSkillTags: array expected");
                message.multiSkillTags = [];
                for (var i = 0; i < object.multiSkillTags.length; ++i) {
                    if (typeof object.multiSkillTags[i] !== "object")
                        throw TypeError(".entity.SafeCustomer.multiSkillTags: object expected");
                    message.multiSkillTags[i] = $root.entity.MultiSkillTag.fromObject(object.multiSkillTags[i]);
                }
            }
            if (object.occupationSkillTags) {
                if (!Array.isArray(object.occupationSkillTags))
                    throw TypeError(".entity.SafeCustomer.occupationSkillTags: array expected");
                message.occupationSkillTags = [];
                for (var i = 0; i < object.occupationSkillTags.length; ++i) {
                    if (typeof object.occupationSkillTags[i] !== "object")
                        throw TypeError(".entity.SafeCustomer.occupationSkillTags: object expected");
                    message.occupationSkillTags[i] = $root.entity.OccupationSkillTag.fromObject(object.occupationSkillTags[i]);
                }
            }
            if (object.displayOccupationSkillCategories) {
                if (!Array.isArray(object.displayOccupationSkillCategories))
                    throw TypeError(".entity.SafeCustomer.displayOccupationSkillCategories: array expected");
                message.displayOccupationSkillCategories = [];
                for (var i = 0; i < object.displayOccupationSkillCategories.length; ++i)
                    message.displayOccupationSkillCategories[i] = String(object.displayOccupationSkillCategories[i]);
            }
            if (object.displayOccupationSkillTags) {
                if (!Array.isArray(object.displayOccupationSkillTags))
                    throw TypeError(".entity.SafeCustomer.displayOccupationSkillTags: array expected");
                message.displayOccupationSkillTags = [];
                for (var i = 0; i < object.displayOccupationSkillTags.length; ++i)
                    message.displayOccupationSkillTags[i] = String(object.displayOccupationSkillTags[i]);
            }
            if (object.profileUpdatedAt != null)
                message.profileUpdatedAt = String(object.profileUpdatedAt);
            if (object.profileUpdatedUserName != null)
                message.profileUpdatedUserName = String(object.profileUpdatedUserName);
            switch (object.campaign) {
            case "Campaign_Normal":
            case 0:
                message.campaign = 0;
                break;
            case "Campaign_SuperEngineer":
            case 1:
                message.campaign = 1;
                break;
            }
            if (object.birthplace != null)
                message.birthplace = String(object.birthplace);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            if (object.agenticSummary != null)
                message.agenticSummary = String(object.agenticSummary);
            if (object.ageGroup != null)
                message.ageGroup = String(object.ageGroup);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a SafeCustomer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SafeCustomer
         * @static
         * @param {entity.SafeCustomer} message SafeCustomer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SafeCustomer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.academicBackgrounds = [];
                object.requirements = [];
                object.languages = [];
                object.highlights = [];
                object.singleSkillTags = [];
                object.multiSkillTags = [];
                object.occupationSkillTags = [];
                object.displayOccupationSkillCategories = [];
                object.displayOccupationSkillTags = [];
            }
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.gsIconURL = "";
                object.signedIconURL = "";
                object.birthdate = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.pr = "";
                object.address = "";
                object.moreLanguage = "";
                object.speakingLevel = options.enums === String ? "SpeakingLevel_Unknown" : 0;
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.resumeURL = "";
                object.jobHistoryURL = "";
                object.workingFrequency = options.enums === String ? "WorkingFrequency_Unknown" : 0;
                object.requestedFee = options.enums === String ? "RequestedFee_Unknown" : 0;
                object.requestedCondition = "";
                object.dutySummary = "";
                object.workIntention = options.enums === String ? "WorkIntention_Unknown" : 0;
                object.fullTimePossibility = options.enums === String ? "FullTimePossibility_Unknown" : 0;
                object.brokerageProjectPossibility = options.enums === String ? "BrokerageProjectPossibility_Unknown" : 0;
                object.portfolioURL = "";
                object.type = options.enums === String ? "Type_Unknown" : 0;
                object.catchphrase = "";
                object.jobCareerCatchphrase = "";
                object.catchphraseUpdatedAt = "";
                object.catchphraseUpdatedUserName = "";
                object.adminMemo = "";
                object.adminMemoUpdatedAt = "";
                object.adminMemoUpdatedUserName = "";
                object.profileUpdatedAt = "";
                object.profileUpdatedUserName = "";
                object.campaign = options.enums === String ? "Campaign_Normal" : 0;
                object.birthplace = "";
                object.routeInfo = "";
                object.agenticSummary = "";
                object.ageGroup = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.gsIconURL != null && message.hasOwnProperty("gsIconURL"))
                object.gsIconURL = message.gsIconURL;
            if (message.signedIconURL != null && message.hasOwnProperty("signedIconURL"))
                object.signedIconURL = message.signedIconURL;
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                object.birthdate = message.birthdate;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.pr != null && message.hasOwnProperty("pr"))
                object.pr = message.pr;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.academicBackgrounds && message.academicBackgrounds.length) {
                object.academicBackgrounds = [];
                for (var j = 0; j < message.academicBackgrounds.length; ++j)
                    object.academicBackgrounds[j] = message.academicBackgrounds[j];
            }
            if (message.requirements && message.requirements.length) {
                object.requirements = [];
                for (var j = 0; j < message.requirements.length; ++j)
                    object.requirements[j] = message.requirements[j];
            }
            if (message.languages && message.languages.length) {
                object.languages = [];
                for (var j = 0; j < message.languages.length; ++j)
                    object.languages[j] = options.enums === String ? $root.entity.Customer.Language[message.languages[j]] : message.languages[j];
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                object.moreLanguage = message.moreLanguage;
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                object.speakingLevel = options.enums === String ? $root.entity.Customer.SpeakingLevel[message.speakingLevel] : message.speakingLevel;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.Customer.Status[message.status] : message.status;
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                object.resumeURL = message.resumeURL;
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                object.jobHistoryURL = message.jobHistoryURL;
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                object.workingFrequency = options.enums === String ? $root.entity.Customer.WorkingFrequency[message.workingFrequency] : message.workingFrequency;
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                object.requestedFee = options.enums === String ? $root.entity.Customer.RequestedFee[message.requestedFee] : message.requestedFee;
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                object.requestedCondition = message.requestedCondition;
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                object.dutySummary = message.dutySummary;
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                object.workIntention = options.enums === String ? $root.entity.Customer.WorkIntention[message.workIntention] : message.workIntention;
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                object.fullTimePossibility = options.enums === String ? $root.entity.Customer.FullTimePossibility[message.fullTimePossibility] : message.fullTimePossibility;
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                object.brokerageProjectPossibility = options.enums === String ? $root.entity.Customer.BrokerageProjectPossibility[message.brokerageProjectPossibility] : message.brokerageProjectPossibility;
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                object.portfolioURL = message.portfolioURL;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.entity.Customer.Type[message.type] : message.type;
            if (message.highlights && message.highlights.length) {
                object.highlights = [];
                for (var j = 0; j < message.highlights.length; ++j)
                    object.highlights[j] = $root.entity.SearchHighlight.toObject(message.highlights[j], options);
            }
            if (message.catchphrase != null && message.hasOwnProperty("catchphrase"))
                object.catchphrase = message.catchphrase;
            if (message.jobCareerCatchphrase != null && message.hasOwnProperty("jobCareerCatchphrase"))
                object.jobCareerCatchphrase = message.jobCareerCatchphrase;
            if (message.catchphraseUpdatedAt != null && message.hasOwnProperty("catchphraseUpdatedAt"))
                object.catchphraseUpdatedAt = message.catchphraseUpdatedAt;
            if (message.catchphraseUpdatedUserName != null && message.hasOwnProperty("catchphraseUpdatedUserName"))
                object.catchphraseUpdatedUserName = message.catchphraseUpdatedUserName;
            if (message.adminMemo != null && message.hasOwnProperty("adminMemo"))
                object.adminMemo = message.adminMemo;
            if (message.adminMemoUpdatedAt != null && message.hasOwnProperty("adminMemoUpdatedAt"))
                object.adminMemoUpdatedAt = message.adminMemoUpdatedAt;
            if (message.adminMemoUpdatedUserName != null && message.hasOwnProperty("adminMemoUpdatedUserName"))
                object.adminMemoUpdatedUserName = message.adminMemoUpdatedUserName;
            if (message.singleSkillTags && message.singleSkillTags.length) {
                object.singleSkillTags = [];
                for (var j = 0; j < message.singleSkillTags.length; ++j)
                    object.singleSkillTags[j] = $root.entity.SingleSkillTag.toObject(message.singleSkillTags[j], options);
            }
            if (message.multiSkillTags && message.multiSkillTags.length) {
                object.multiSkillTags = [];
                for (var j = 0; j < message.multiSkillTags.length; ++j)
                    object.multiSkillTags[j] = $root.entity.MultiSkillTag.toObject(message.multiSkillTags[j], options);
            }
            if (message.occupationSkillTags && message.occupationSkillTags.length) {
                object.occupationSkillTags = [];
                for (var j = 0; j < message.occupationSkillTags.length; ++j)
                    object.occupationSkillTags[j] = $root.entity.OccupationSkillTag.toObject(message.occupationSkillTags[j], options);
            }
            if (message.displayOccupationSkillCategories && message.displayOccupationSkillCategories.length) {
                object.displayOccupationSkillCategories = [];
                for (var j = 0; j < message.displayOccupationSkillCategories.length; ++j)
                    object.displayOccupationSkillCategories[j] = message.displayOccupationSkillCategories[j];
            }
            if (message.displayOccupationSkillTags && message.displayOccupationSkillTags.length) {
                object.displayOccupationSkillTags = [];
                for (var j = 0; j < message.displayOccupationSkillTags.length; ++j)
                    object.displayOccupationSkillTags[j] = message.displayOccupationSkillTags[j];
            }
            if (message.profileUpdatedAt != null && message.hasOwnProperty("profileUpdatedAt"))
                object.profileUpdatedAt = message.profileUpdatedAt;
            if (message.profileUpdatedUserName != null && message.hasOwnProperty("profileUpdatedUserName"))
                object.profileUpdatedUserName = message.profileUpdatedUserName;
            if (message.campaign != null && message.hasOwnProperty("campaign"))
                object.campaign = options.enums === String ? $root.entity.Customer.Campaign[message.campaign] : message.campaign;
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                object.birthplace = message.birthplace;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            if (message.agenticSummary != null && message.hasOwnProperty("agenticSummary"))
                object.agenticSummary = message.agenticSummary;
            if (message.ageGroup != null && message.hasOwnProperty("ageGroup"))
                object.ageGroup = message.ageGroup;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this SafeCustomer to JSON.
         * @function toJSON
         * @memberof entity.SafeCustomer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SafeCustomer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SafeCustomer;
    })();

    entity.SafeCustomerList = (function() {

        /**
         * Properties of a SafeCustomerList.
         * @memberof entity
         * @interface ISafeCustomerList
         * @property {Array.<entity.ISafeCustomer>|null} [items] SafeCustomerList items
         */

        /**
         * Constructs a new SafeCustomerList.
         * @memberof entity
         * @classdesc Represents a SafeCustomerList.
         * @implements ISafeCustomerList
         * @constructor
         * @param {entity.ISafeCustomerList=} [properties] Properties to set
         */
        function SafeCustomerList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SafeCustomerList items.
         * @member {Array.<entity.ISafeCustomer>} items
         * @memberof entity.SafeCustomerList
         * @instance
         */
        SafeCustomerList.prototype.items = $util.emptyArray;

        /**
         * Creates a new SafeCustomerList instance using the specified properties.
         * @function create
         * @memberof entity.SafeCustomerList
         * @static
         * @param {entity.ISafeCustomerList=} [properties] Properties to set
         * @returns {entity.SafeCustomerList} SafeCustomerList instance
         */
        SafeCustomerList.create = function create(properties) {
            return new SafeCustomerList(properties);
        };

        /**
         * Encodes the specified SafeCustomerList message. Does not implicitly {@link entity.SafeCustomerList.verify|verify} messages.
         * @function encode
         * @memberof entity.SafeCustomerList
         * @static
         * @param {entity.ISafeCustomerList} message SafeCustomerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SafeCustomerList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.SafeCustomer.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SafeCustomerList message, length delimited. Does not implicitly {@link entity.SafeCustomerList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SafeCustomerList
         * @static
         * @param {entity.ISafeCustomerList} message SafeCustomerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SafeCustomerList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SafeCustomerList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SafeCustomerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SafeCustomerList} SafeCustomerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SafeCustomerList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SafeCustomerList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.SafeCustomer.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SafeCustomerList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SafeCustomerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SafeCustomerList} SafeCustomerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SafeCustomerList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SafeCustomerList message.
         * @function verify
         * @memberof entity.SafeCustomerList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SafeCustomerList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.SafeCustomer.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SafeCustomerList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SafeCustomerList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SafeCustomerList} SafeCustomerList
         */
        SafeCustomerList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SafeCustomerList)
                return object;
            var message = new $root.entity.SafeCustomerList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.SafeCustomerList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.SafeCustomerList.items: object expected");
                    message.items[i] = $root.entity.SafeCustomer.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SafeCustomerList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SafeCustomerList
         * @static
         * @param {entity.SafeCustomerList} message SafeCustomerList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SafeCustomerList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.SafeCustomer.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this SafeCustomerList to JSON.
         * @function toJSON
         * @memberof entity.SafeCustomerList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SafeCustomerList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SafeCustomerList;
    })();

    entity.UserID = (function() {

        /**
         * Properties of a UserID.
         * @memberof entity
         * @interface IUserID
         * @property {string|null} [id] UserID id
         */

        /**
         * Constructs a new UserID.
         * @memberof entity
         * @classdesc Represents a UserID.
         * @implements IUserID
         * @constructor
         * @param {entity.IUserID=} [properties] Properties to set
         */
        function UserID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserID id.
         * @member {string} id
         * @memberof entity.UserID
         * @instance
         */
        UserID.prototype.id = "";

        /**
         * Creates a new UserID instance using the specified properties.
         * @function create
         * @memberof entity.UserID
         * @static
         * @param {entity.IUserID=} [properties] Properties to set
         * @returns {entity.UserID} UserID instance
         */
        UserID.create = function create(properties) {
            return new UserID(properties);
        };

        /**
         * Encodes the specified UserID message. Does not implicitly {@link entity.UserID.verify|verify} messages.
         * @function encode
         * @memberof entity.UserID
         * @static
         * @param {entity.IUserID} message UserID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified UserID message, length delimited. Does not implicitly {@link entity.UserID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.UserID
         * @static
         * @param {entity.IUserID} message UserID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.UserID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.UserID} UserID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.UserID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.UserID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.UserID} UserID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserID message.
         * @function verify
         * @memberof entity.UserID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a UserID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.UserID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.UserID} UserID
         */
        UserID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.UserID)
                return object;
            var message = new $root.entity.UserID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a UserID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.UserID
         * @static
         * @param {entity.UserID} message UserID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this UserID to JSON.
         * @function toJSON
         * @memberof entity.UserID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserID;
    })();

    entity.User = (function() {

        /**
         * Properties of a User.
         * @memberof entity
         * @interface IUser
         * @property {string|null} [id] User id
         * @property {entity.User.Role|null} [role] User role
         * @property {string|null} [email] User email
         */

        /**
         * Constructs a new User.
         * @memberof entity
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {entity.IUser=} [properties] Properties to set
         */
        function User(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User id.
         * @member {string} id
         * @memberof entity.User
         * @instance
         */
        User.prototype.id = "";

        /**
         * User role.
         * @member {entity.User.Role} role
         * @memberof entity.User
         * @instance
         */
        User.prototype.role = 0;

        /**
         * User email.
         * @member {string} email
         * @memberof entity.User
         * @instance
         */
        User.prototype.email = "";

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof entity.User
         * @static
         * @param {entity.IUser=} [properties] Properties to set
         * @returns {entity.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Encodes the specified User message. Does not implicitly {@link entity.User.verify|verify} messages.
         * @function encode
         * @memberof entity.User
         * @static
         * @param {entity.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.role);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified User message, length delimited. Does not implicitly {@link entity.User.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.User
         * @static
         * @param {entity.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User message from the specified reader or buffer.
         * @function decode
         * @memberof entity.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.User();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.role = reader.int32();
                    break;
                case 3:
                    message.email = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User message.
         * @function verify
         * @memberof entity.User
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.User)
                return object;
            var message = new $root.entity.User();
            if (object.id != null)
                message.id = String(object.id);
            switch (object.role) {
            case "Role_Unknown":
            case 0:
                message.role = 0;
                break;
            case "Role_Customer":
            case 1:
                message.role = 1;
                break;
            case "Role_Client":
            case 2:
                message.role = 2;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.User
         * @static
         * @param {entity.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.role = options.enums === String ? "Role_Unknown" : 0;
                object.email = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.entity.User.Role[message.role] : message.role;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof entity.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Role enum.
         * @name entity.User.Role
         * @enum {number}
         * @property {number} Role_Unknown=0 Role_Unknown value
         * @property {number} Role_Customer=1 Role_Customer value
         * @property {number} Role_Client=2 Role_Client value
         */
        User.Role = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Role_Unknown"] = 0;
            values[valuesById[1] = "Role_Customer"] = 1;
            values[valuesById[2] = "Role_Client"] = 2;
            return values;
        })();

        /**
         * Gender enum.
         * @name entity.User.Gender
         * @enum {number}
         * @property {number} Gender_Unknown=0 Gender_Unknown value
         * @property {number} Gender_Male=1 Gender_Male value
         * @property {number} Gender_Female=2 Gender_Female value
         */
        User.Gender = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Gender_Unknown"] = 0;
            values[valuesById[1] = "Gender_Male"] = 1;
            values[valuesById[2] = "Gender_Female"] = 2;
            return values;
        })();

        return User;
    })();

    entity.SearchHighlight = (function() {

        /**
         * Properties of a SearchHighlight.
         * @memberof entity
         * @interface ISearchHighlight
         * @property {string|null} [key] SearchHighlight key
         * @property {string|null} [val] SearchHighlight val
         * @property {string|null} [matchWord] SearchHighlight matchWord
         * @property {string|null} [linkId] SearchHighlight linkId
         */

        /**
         * Constructs a new SearchHighlight.
         * @memberof entity
         * @classdesc Represents a SearchHighlight.
         * @implements ISearchHighlight
         * @constructor
         * @param {entity.ISearchHighlight=} [properties] Properties to set
         */
        function SearchHighlight(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchHighlight key.
         * @member {string} key
         * @memberof entity.SearchHighlight
         * @instance
         */
        SearchHighlight.prototype.key = "";

        /**
         * SearchHighlight val.
         * @member {string} val
         * @memberof entity.SearchHighlight
         * @instance
         */
        SearchHighlight.prototype.val = "";

        /**
         * SearchHighlight matchWord.
         * @member {string} matchWord
         * @memberof entity.SearchHighlight
         * @instance
         */
        SearchHighlight.prototype.matchWord = "";

        /**
         * SearchHighlight linkId.
         * @member {string} linkId
         * @memberof entity.SearchHighlight
         * @instance
         */
        SearchHighlight.prototype.linkId = "";

        /**
         * Creates a new SearchHighlight instance using the specified properties.
         * @function create
         * @memberof entity.SearchHighlight
         * @static
         * @param {entity.ISearchHighlight=} [properties] Properties to set
         * @returns {entity.SearchHighlight} SearchHighlight instance
         */
        SearchHighlight.create = function create(properties) {
            return new SearchHighlight(properties);
        };

        /**
         * Encodes the specified SearchHighlight message. Does not implicitly {@link entity.SearchHighlight.verify|verify} messages.
         * @function encode
         * @memberof entity.SearchHighlight
         * @static
         * @param {entity.ISearchHighlight} message SearchHighlight message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchHighlight.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.val != null && Object.hasOwnProperty.call(message, "val"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.val);
            if (message.matchWord != null && Object.hasOwnProperty.call(message, "matchWord"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.matchWord);
            if (message.linkId != null && Object.hasOwnProperty.call(message, "linkId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.linkId);
            return writer;
        };

        /**
         * Encodes the specified SearchHighlight message, length delimited. Does not implicitly {@link entity.SearchHighlight.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SearchHighlight
         * @static
         * @param {entity.ISearchHighlight} message SearchHighlight message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchHighlight.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchHighlight message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SearchHighlight
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SearchHighlight} SearchHighlight
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchHighlight.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SearchHighlight();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.val = reader.string();
                    break;
                case 3:
                    message.matchWord = reader.string();
                    break;
                case 4:
                    message.linkId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchHighlight message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SearchHighlight
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SearchHighlight} SearchHighlight
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchHighlight.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchHighlight message.
         * @function verify
         * @memberof entity.SearchHighlight
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchHighlight.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.val != null && message.hasOwnProperty("val"))
                if (!$util.isString(message.val))
                    return "val: string expected";
            if (message.matchWord != null && message.hasOwnProperty("matchWord"))
                if (!$util.isString(message.matchWord))
                    return "matchWord: string expected";
            if (message.linkId != null && message.hasOwnProperty("linkId"))
                if (!$util.isString(message.linkId))
                    return "linkId: string expected";
            return null;
        };

        /**
         * Creates a SearchHighlight message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SearchHighlight
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SearchHighlight} SearchHighlight
         */
        SearchHighlight.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SearchHighlight)
                return object;
            var message = new $root.entity.SearchHighlight();
            if (object.key != null)
                message.key = String(object.key);
            if (object.val != null)
                message.val = String(object.val);
            if (object.matchWord != null)
                message.matchWord = String(object.matchWord);
            if (object.linkId != null)
                message.linkId = String(object.linkId);
            return message;
        };

        /**
         * Creates a plain object from a SearchHighlight message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SearchHighlight
         * @static
         * @param {entity.SearchHighlight} message SearchHighlight
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchHighlight.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.val = "";
                object.matchWord = "";
                object.linkId = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.val != null && message.hasOwnProperty("val"))
                object.val = message.val;
            if (message.matchWord != null && message.hasOwnProperty("matchWord"))
                object.matchWord = message.matchWord;
            if (message.linkId != null && message.hasOwnProperty("linkId"))
                object.linkId = message.linkId;
            return object;
        };

        /**
         * Converts this SearchHighlight to JSON.
         * @function toJSON
         * @memberof entity.SearchHighlight
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchHighlight.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchHighlight;
    })();

    entity.SingleSkillTagID = (function() {

        /**
         * Properties of a SingleSkillTagID.
         * @memberof entity
         * @interface ISingleSkillTagID
         * @property {string|null} [id] SingleSkillTagID id
         */

        /**
         * Constructs a new SingleSkillTagID.
         * @memberof entity
         * @classdesc Represents a SingleSkillTagID.
         * @implements ISingleSkillTagID
         * @constructor
         * @param {entity.ISingleSkillTagID=} [properties] Properties to set
         */
        function SingleSkillTagID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTagID id.
         * @member {string} id
         * @memberof entity.SingleSkillTagID
         * @instance
         */
        SingleSkillTagID.prototype.id = "";

        /**
         * Creates a new SingleSkillTagID instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {entity.ISingleSkillTagID=} [properties] Properties to set
         * @returns {entity.SingleSkillTagID} SingleSkillTagID instance
         */
        SingleSkillTagID.create = function create(properties) {
            return new SingleSkillTagID(properties);
        };

        /**
         * Encodes the specified SingleSkillTagID message. Does not implicitly {@link entity.SingleSkillTagID.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {entity.ISingleSkillTagID} message SingleSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTagID message, length delimited. Does not implicitly {@link entity.SingleSkillTagID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {entity.ISingleSkillTagID} message SingleSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTagID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTagID} SingleSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTagID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTagID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTagID} SingleSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTagID message.
         * @function verify
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTagID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a SingleSkillTagID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTagID} SingleSkillTagID
         */
        SingleSkillTagID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTagID)
                return object;
            var message = new $root.entity.SingleSkillTagID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTagID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTagID
         * @static
         * @param {entity.SingleSkillTagID} message SingleSkillTagID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTagID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this SingleSkillTagID to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTagID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTagID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SingleSkillTagID;
    })();

    entity.SingleSkillTagCategory = (function() {

        /**
         * Properties of a SingleSkillTagCategory.
         * @memberof entity
         * @interface ISingleSkillTagCategory
         * @property {entity.SingleSkillTag.Category|null} [category] SingleSkillTagCategory category
         */

        /**
         * Constructs a new SingleSkillTagCategory.
         * @memberof entity
         * @classdesc Represents a SingleSkillTagCategory.
         * @implements ISingleSkillTagCategory
         * @constructor
         * @param {entity.ISingleSkillTagCategory=} [properties] Properties to set
         */
        function SingleSkillTagCategory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTagCategory category.
         * @member {entity.SingleSkillTag.Category} category
         * @memberof entity.SingleSkillTagCategory
         * @instance
         */
        SingleSkillTagCategory.prototype.category = 0;

        /**
         * Creates a new SingleSkillTagCategory instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {entity.ISingleSkillTagCategory=} [properties] Properties to set
         * @returns {entity.SingleSkillTagCategory} SingleSkillTagCategory instance
         */
        SingleSkillTagCategory.create = function create(properties) {
            return new SingleSkillTagCategory(properties);
        };

        /**
         * Encodes the specified SingleSkillTagCategory message. Does not implicitly {@link entity.SingleSkillTagCategory.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {entity.ISingleSkillTagCategory} message SingleSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagCategory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTagCategory message, length delimited. Does not implicitly {@link entity.SingleSkillTagCategory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {entity.ISingleSkillTagCategory} message SingleSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagCategory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTagCategory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTagCategory} SingleSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagCategory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTagCategory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTagCategory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTagCategory} SingleSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagCategory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTagCategory message.
         * @function verify
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTagCategory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            return null;
        };

        /**
         * Creates a SingleSkillTagCategory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTagCategory} SingleSkillTagCategory
         */
        SingleSkillTagCategory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTagCategory)
                return object;
            var message = new $root.entity.SingleSkillTagCategory();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_GoodPhase":
            case 1:
                message.category = 1;
                break;
            case "Category_Fit":
            case 2:
                message.category = 2;
                break;
            case "Category_GoodServiceClassification":
            case 3:
                message.category = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTagCategory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTagCategory
         * @static
         * @param {entity.SingleSkillTagCategory} message SingleSkillTagCategory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTagCategory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.category = options.enums === String ? "Category_Unknown" : 0;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.SingleSkillTag.Category[message.category] : message.category;
            return object;
        };

        /**
         * Converts this SingleSkillTagCategory to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTagCategory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTagCategory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SingleSkillTagCategory;
    })();

    entity.SingleSkillTagCategoryWithPager = (function() {

        /**
         * Properties of a SingleSkillTagCategoryWithPager.
         * @memberof entity
         * @interface ISingleSkillTagCategoryWithPager
         * @property {entity.SingleSkillTag.Category|null} [category] SingleSkillTagCategoryWithPager category
         * @property {common.IPager|null} [pager] SingleSkillTagCategoryWithPager pager
         */

        /**
         * Constructs a new SingleSkillTagCategoryWithPager.
         * @memberof entity
         * @classdesc Represents a SingleSkillTagCategoryWithPager.
         * @implements ISingleSkillTagCategoryWithPager
         * @constructor
         * @param {entity.ISingleSkillTagCategoryWithPager=} [properties] Properties to set
         */
        function SingleSkillTagCategoryWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTagCategoryWithPager category.
         * @member {entity.SingleSkillTag.Category} category
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @instance
         */
        SingleSkillTagCategoryWithPager.prototype.category = 0;

        /**
         * SingleSkillTagCategoryWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @instance
         */
        SingleSkillTagCategoryWithPager.prototype.pager = null;

        /**
         * Creates a new SingleSkillTagCategoryWithPager instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {entity.ISingleSkillTagCategoryWithPager=} [properties] Properties to set
         * @returns {entity.SingleSkillTagCategoryWithPager} SingleSkillTagCategoryWithPager instance
         */
        SingleSkillTagCategoryWithPager.create = function create(properties) {
            return new SingleSkillTagCategoryWithPager(properties);
        };

        /**
         * Encodes the specified SingleSkillTagCategoryWithPager message. Does not implicitly {@link entity.SingleSkillTagCategoryWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {entity.ISingleSkillTagCategoryWithPager} message SingleSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagCategoryWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTagCategoryWithPager message, length delimited. Does not implicitly {@link entity.SingleSkillTagCategoryWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {entity.ISingleSkillTagCategoryWithPager} message SingleSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagCategoryWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTagCategoryWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTagCategoryWithPager} SingleSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagCategoryWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTagCategoryWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTagCategoryWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTagCategoryWithPager} SingleSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagCategoryWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTagCategoryWithPager message.
         * @function verify
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTagCategoryWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a SingleSkillTagCategoryWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTagCategoryWithPager} SingleSkillTagCategoryWithPager
         */
        SingleSkillTagCategoryWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTagCategoryWithPager)
                return object;
            var message = new $root.entity.SingleSkillTagCategoryWithPager();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_GoodPhase":
            case 1:
                message.category = 1;
                break;
            case "Category_Fit":
            case 2:
                message.category = 2;
                break;
            case "Category_GoodServiceClassification":
            case 3:
                message.category = 3;
                break;
            }
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.SingleSkillTagCategoryWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTagCategoryWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @static
         * @param {entity.SingleSkillTagCategoryWithPager} message SingleSkillTagCategoryWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTagCategoryWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.category = options.enums === String ? "Category_Unknown" : 0;
                object.pager = null;
            }
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.SingleSkillTag.Category[message.category] : message.category;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this SingleSkillTagCategoryWithPager to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTagCategoryWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTagCategoryWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SingleSkillTagCategoryWithPager;
    })();

    entity.SingleSkillTagIDList = (function() {

        /**
         * Properties of a SingleSkillTagIDList.
         * @memberof entity
         * @interface ISingleSkillTagIDList
         * @property {Array.<string>|null} [ids] SingleSkillTagIDList ids
         */

        /**
         * Constructs a new SingleSkillTagIDList.
         * @memberof entity
         * @classdesc Represents a SingleSkillTagIDList.
         * @implements ISingleSkillTagIDList
         * @constructor
         * @param {entity.ISingleSkillTagIDList=} [properties] Properties to set
         */
        function SingleSkillTagIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTagIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.SingleSkillTagIDList
         * @instance
         */
        SingleSkillTagIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new SingleSkillTagIDList instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {entity.ISingleSkillTagIDList=} [properties] Properties to set
         * @returns {entity.SingleSkillTagIDList} SingleSkillTagIDList instance
         */
        SingleSkillTagIDList.create = function create(properties) {
            return new SingleSkillTagIDList(properties);
        };

        /**
         * Encodes the specified SingleSkillTagIDList message. Does not implicitly {@link entity.SingleSkillTagIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {entity.ISingleSkillTagIDList} message SingleSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTagIDList message, length delimited. Does not implicitly {@link entity.SingleSkillTagIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {entity.ISingleSkillTagIDList} message SingleSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTagIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTagIDList} SingleSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTagIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTagIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTagIDList} SingleSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTagIDList message.
         * @function verify
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTagIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a SingleSkillTagIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTagIDList} SingleSkillTagIDList
         */
        SingleSkillTagIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTagIDList)
                return object;
            var message = new $root.entity.SingleSkillTagIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.SingleSkillTagIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTagIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTagIDList
         * @static
         * @param {entity.SingleSkillTagIDList} message SingleSkillTagIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTagIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this SingleSkillTagIDList to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTagIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTagIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SingleSkillTagIDList;
    })();

    entity.SingleSkillTag = (function() {

        /**
         * Properties of a SingleSkillTag.
         * @memberof entity
         * @interface ISingleSkillTag
         * @property {string|null} [id] SingleSkillTag id
         * @property {string|null} [name] SingleSkillTag name
         * @property {entity.SingleSkillTag.Category|null} [category] SingleSkillTag category
         * @property {number|Long|null} [customerNum] SingleSkillTag customerNum
         */

        /**
         * Constructs a new SingleSkillTag.
         * @memberof entity
         * @classdesc Represents a SingleSkillTag.
         * @implements ISingleSkillTag
         * @constructor
         * @param {entity.ISingleSkillTag=} [properties] Properties to set
         */
        function SingleSkillTag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTag id.
         * @member {string} id
         * @memberof entity.SingleSkillTag
         * @instance
         */
        SingleSkillTag.prototype.id = "";

        /**
         * SingleSkillTag name.
         * @member {string} name
         * @memberof entity.SingleSkillTag
         * @instance
         */
        SingleSkillTag.prototype.name = "";

        /**
         * SingleSkillTag category.
         * @member {entity.SingleSkillTag.Category} category
         * @memberof entity.SingleSkillTag
         * @instance
         */
        SingleSkillTag.prototype.category = 0;

        /**
         * SingleSkillTag customerNum.
         * @member {number|Long} customerNum
         * @memberof entity.SingleSkillTag
         * @instance
         */
        SingleSkillTag.prototype.customerNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SingleSkillTag instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTag
         * @static
         * @param {entity.ISingleSkillTag=} [properties] Properties to set
         * @returns {entity.SingleSkillTag} SingleSkillTag instance
         */
        SingleSkillTag.create = function create(properties) {
            return new SingleSkillTag(properties);
        };

        /**
         * Encodes the specified SingleSkillTag message. Does not implicitly {@link entity.SingleSkillTag.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTag
         * @static
         * @param {entity.ISingleSkillTag} message SingleSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.category);
            if (message.customerNum != null && Object.hasOwnProperty.call(message, "customerNum"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.customerNum);
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTag message, length delimited. Does not implicitly {@link entity.SingleSkillTag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTag
         * @static
         * @param {entity.ISingleSkillTag} message SingleSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTag message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTag} SingleSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTag();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.category = reader.int32();
                    break;
                case 4:
                    message.customerNum = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTag} SingleSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTag message.
         * @function verify
         * @memberof entity.SingleSkillTag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (!$util.isInteger(message.customerNum) && !(message.customerNum && $util.isInteger(message.customerNum.low) && $util.isInteger(message.customerNum.high)))
                    return "customerNum: integer|Long expected";
            return null;
        };

        /**
         * Creates a SingleSkillTag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTag} SingleSkillTag
         */
        SingleSkillTag.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTag)
                return object;
            var message = new $root.entity.SingleSkillTag();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_GoodPhase":
            case 1:
                message.category = 1;
                break;
            case "Category_Fit":
            case 2:
                message.category = 2;
                break;
            case "Category_GoodServiceClassification":
            case 3:
                message.category = 3;
                break;
            }
            if (object.customerNum != null)
                if ($util.Long)
                    (message.customerNum = $util.Long.fromValue(object.customerNum)).unsigned = false;
                else if (typeof object.customerNum === "string")
                    message.customerNum = parseInt(object.customerNum, 10);
                else if (typeof object.customerNum === "number")
                    message.customerNum = object.customerNum;
                else if (typeof object.customerNum === "object")
                    message.customerNum = new $util.LongBits(object.customerNum.low >>> 0, object.customerNum.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTag
         * @static
         * @param {entity.SingleSkillTag} message SingleSkillTag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.category = options.enums === String ? "Category_Unknown" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.customerNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customerNum = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.SingleSkillTag.Category[message.category] : message.category;
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (typeof message.customerNum === "number")
                    object.customerNum = options.longs === String ? String(message.customerNum) : message.customerNum;
                else
                    object.customerNum = options.longs === String ? $util.Long.prototype.toString.call(message.customerNum) : options.longs === Number ? new $util.LongBits(message.customerNum.low >>> 0, message.customerNum.high >>> 0).toNumber() : message.customerNum;
            return object;
        };

        /**
         * Converts this SingleSkillTag to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Category enum.
         * @name entity.SingleSkillTag.Category
         * @enum {number}
         * @property {number} Category_Unknown=0 Category_Unknown value
         * @property {number} Category_GoodPhase=1 Category_GoodPhase value
         * @property {number} Category_Fit=2 Category_Fit value
         * @property {number} Category_GoodServiceClassification=3 Category_GoodServiceClassification value
         */
        SingleSkillTag.Category = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Category_Unknown"] = 0;
            values[valuesById[1] = "Category_GoodPhase"] = 1;
            values[valuesById[2] = "Category_Fit"] = 2;
            values[valuesById[3] = "Category_GoodServiceClassification"] = 3;
            return values;
        })();

        return SingleSkillTag;
    })();

    entity.SingleSkillTagList = (function() {

        /**
         * Properties of a SingleSkillTagList.
         * @memberof entity
         * @interface ISingleSkillTagList
         * @property {Array.<entity.ISingleSkillTag>|null} [items] SingleSkillTagList items
         */

        /**
         * Constructs a new SingleSkillTagList.
         * @memberof entity
         * @classdesc Represents a SingleSkillTagList.
         * @implements ISingleSkillTagList
         * @constructor
         * @param {entity.ISingleSkillTagList=} [properties] Properties to set
         */
        function SingleSkillTagList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SingleSkillTagList items.
         * @member {Array.<entity.ISingleSkillTag>} items
         * @memberof entity.SingleSkillTagList
         * @instance
         */
        SingleSkillTagList.prototype.items = $util.emptyArray;

        /**
         * Creates a new SingleSkillTagList instance using the specified properties.
         * @function create
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {entity.ISingleSkillTagList=} [properties] Properties to set
         * @returns {entity.SingleSkillTagList} SingleSkillTagList instance
         */
        SingleSkillTagList.create = function create(properties) {
            return new SingleSkillTagList(properties);
        };

        /**
         * Encodes the specified SingleSkillTagList message. Does not implicitly {@link entity.SingleSkillTagList.verify|verify} messages.
         * @function encode
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {entity.ISingleSkillTagList} message SingleSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.SingleSkillTag.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SingleSkillTagList message, length delimited. Does not implicitly {@link entity.SingleSkillTagList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {entity.ISingleSkillTagList} message SingleSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SingleSkillTagList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SingleSkillTagList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.SingleSkillTagList} SingleSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.SingleSkillTagList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.SingleSkillTag.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SingleSkillTagList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.SingleSkillTagList} SingleSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SingleSkillTagList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SingleSkillTagList message.
         * @function verify
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SingleSkillTagList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.SingleSkillTag.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SingleSkillTagList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.SingleSkillTagList} SingleSkillTagList
         */
        SingleSkillTagList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.SingleSkillTagList)
                return object;
            var message = new $root.entity.SingleSkillTagList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.SingleSkillTagList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.SingleSkillTagList.items: object expected");
                    message.items[i] = $root.entity.SingleSkillTag.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SingleSkillTagList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.SingleSkillTagList
         * @static
         * @param {entity.SingleSkillTagList} message SingleSkillTagList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SingleSkillTagList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.SingleSkillTag.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this SingleSkillTagList to JSON.
         * @function toJSON
         * @memberof entity.SingleSkillTagList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SingleSkillTagList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SingleSkillTagList;
    })();

    entity.MultiSkillTagID = (function() {

        /**
         * Properties of a MultiSkillTagID.
         * @memberof entity
         * @interface IMultiSkillTagID
         * @property {string|null} [id] MultiSkillTagID id
         */

        /**
         * Constructs a new MultiSkillTagID.
         * @memberof entity
         * @classdesc Represents a MultiSkillTagID.
         * @implements IMultiSkillTagID
         * @constructor
         * @param {entity.IMultiSkillTagID=} [properties] Properties to set
         */
        function MultiSkillTagID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTagID id.
         * @member {string} id
         * @memberof entity.MultiSkillTagID
         * @instance
         */
        MultiSkillTagID.prototype.id = "";

        /**
         * Creates a new MultiSkillTagID instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {entity.IMultiSkillTagID=} [properties] Properties to set
         * @returns {entity.MultiSkillTagID} MultiSkillTagID instance
         */
        MultiSkillTagID.create = function create(properties) {
            return new MultiSkillTagID(properties);
        };

        /**
         * Encodes the specified MultiSkillTagID message. Does not implicitly {@link entity.MultiSkillTagID.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {entity.IMultiSkillTagID} message MultiSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTagID message, length delimited. Does not implicitly {@link entity.MultiSkillTagID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {entity.IMultiSkillTagID} message MultiSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTagID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTagID} MultiSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTagID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTagID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTagID} MultiSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTagID message.
         * @function verify
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTagID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a MultiSkillTagID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTagID} MultiSkillTagID
         */
        MultiSkillTagID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTagID)
                return object;
            var message = new $root.entity.MultiSkillTagID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTagID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTagID
         * @static
         * @param {entity.MultiSkillTagID} message MultiSkillTagID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTagID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this MultiSkillTagID to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTagID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTagID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiSkillTagID;
    })();

    entity.MultiSkillTagCategory = (function() {

        /**
         * Properties of a MultiSkillTagCategory.
         * @memberof entity
         * @interface IMultiSkillTagCategory
         * @property {entity.MultiSkillTag.Category|null} [category] MultiSkillTagCategory category
         */

        /**
         * Constructs a new MultiSkillTagCategory.
         * @memberof entity
         * @classdesc Represents a MultiSkillTagCategory.
         * @implements IMultiSkillTagCategory
         * @constructor
         * @param {entity.IMultiSkillTagCategory=} [properties] Properties to set
         */
        function MultiSkillTagCategory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTagCategory category.
         * @member {entity.MultiSkillTag.Category} category
         * @memberof entity.MultiSkillTagCategory
         * @instance
         */
        MultiSkillTagCategory.prototype.category = 0;

        /**
         * Creates a new MultiSkillTagCategory instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {entity.IMultiSkillTagCategory=} [properties] Properties to set
         * @returns {entity.MultiSkillTagCategory} MultiSkillTagCategory instance
         */
        MultiSkillTagCategory.create = function create(properties) {
            return new MultiSkillTagCategory(properties);
        };

        /**
         * Encodes the specified MultiSkillTagCategory message. Does not implicitly {@link entity.MultiSkillTagCategory.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {entity.IMultiSkillTagCategory} message MultiSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagCategory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTagCategory message, length delimited. Does not implicitly {@link entity.MultiSkillTagCategory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {entity.IMultiSkillTagCategory} message MultiSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagCategory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTagCategory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTagCategory} MultiSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagCategory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTagCategory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTagCategory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTagCategory} MultiSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagCategory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTagCategory message.
         * @function verify
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTagCategory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            return null;
        };

        /**
         * Creates a MultiSkillTagCategory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTagCategory} MultiSkillTagCategory
         */
        MultiSkillTagCategory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTagCategory)
                return object;
            var message = new $root.entity.MultiSkillTagCategory();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_IntroductionOperation":
            case 1:
                message.category = 1;
                break;
            case "Category_SpecialtyIndustry":
            case 2:
                message.category = 2;
                break;
            case "Category_OverseasExpansion":
            case 3:
                message.category = 3;
                break;
            case "Category_Programming":
            case 4:
                message.category = 4;
                break;
            case "Category_DevelopFramework":
            case 5:
                message.category = 5;
                break;
            case "Category_AI":
            case 6:
                message.category = 6;
                break;
            case "Category_PersonalConnections":
            case 7:
                message.category = 7;
                break;
            case "Category_Other":
            case 8:
                message.category = 8;
                break;
            case "Category_CXO":
            case 9:
                message.category = 9;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTagCategory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTagCategory
         * @static
         * @param {entity.MultiSkillTagCategory} message MultiSkillTagCategory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTagCategory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.category = options.enums === String ? "Category_Unknown" : 0;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.MultiSkillTag.Category[message.category] : message.category;
            return object;
        };

        /**
         * Converts this MultiSkillTagCategory to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTagCategory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTagCategory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiSkillTagCategory;
    })();

    entity.MultiSkillTagCategoryWithPager = (function() {

        /**
         * Properties of a MultiSkillTagCategoryWithPager.
         * @memberof entity
         * @interface IMultiSkillTagCategoryWithPager
         * @property {entity.MultiSkillTag.Category|null} [category] MultiSkillTagCategoryWithPager category
         * @property {common.IPager|null} [pager] MultiSkillTagCategoryWithPager pager
         */

        /**
         * Constructs a new MultiSkillTagCategoryWithPager.
         * @memberof entity
         * @classdesc Represents a MultiSkillTagCategoryWithPager.
         * @implements IMultiSkillTagCategoryWithPager
         * @constructor
         * @param {entity.IMultiSkillTagCategoryWithPager=} [properties] Properties to set
         */
        function MultiSkillTagCategoryWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTagCategoryWithPager category.
         * @member {entity.MultiSkillTag.Category} category
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @instance
         */
        MultiSkillTagCategoryWithPager.prototype.category = 0;

        /**
         * MultiSkillTagCategoryWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @instance
         */
        MultiSkillTagCategoryWithPager.prototype.pager = null;

        /**
         * Creates a new MultiSkillTagCategoryWithPager instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {entity.IMultiSkillTagCategoryWithPager=} [properties] Properties to set
         * @returns {entity.MultiSkillTagCategoryWithPager} MultiSkillTagCategoryWithPager instance
         */
        MultiSkillTagCategoryWithPager.create = function create(properties) {
            return new MultiSkillTagCategoryWithPager(properties);
        };

        /**
         * Encodes the specified MultiSkillTagCategoryWithPager message. Does not implicitly {@link entity.MultiSkillTagCategoryWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {entity.IMultiSkillTagCategoryWithPager} message MultiSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagCategoryWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTagCategoryWithPager message, length delimited. Does not implicitly {@link entity.MultiSkillTagCategoryWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {entity.IMultiSkillTagCategoryWithPager} message MultiSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagCategoryWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTagCategoryWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTagCategoryWithPager} MultiSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagCategoryWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTagCategoryWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTagCategoryWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTagCategoryWithPager} MultiSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagCategoryWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTagCategoryWithPager message.
         * @function verify
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTagCategoryWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a MultiSkillTagCategoryWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTagCategoryWithPager} MultiSkillTagCategoryWithPager
         */
        MultiSkillTagCategoryWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTagCategoryWithPager)
                return object;
            var message = new $root.entity.MultiSkillTagCategoryWithPager();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_IntroductionOperation":
            case 1:
                message.category = 1;
                break;
            case "Category_SpecialtyIndustry":
            case 2:
                message.category = 2;
                break;
            case "Category_OverseasExpansion":
            case 3:
                message.category = 3;
                break;
            case "Category_Programming":
            case 4:
                message.category = 4;
                break;
            case "Category_DevelopFramework":
            case 5:
                message.category = 5;
                break;
            case "Category_AI":
            case 6:
                message.category = 6;
                break;
            case "Category_PersonalConnections":
            case 7:
                message.category = 7;
                break;
            case "Category_Other":
            case 8:
                message.category = 8;
                break;
            case "Category_CXO":
            case 9:
                message.category = 9;
                break;
            }
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.MultiSkillTagCategoryWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTagCategoryWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @static
         * @param {entity.MultiSkillTagCategoryWithPager} message MultiSkillTagCategoryWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTagCategoryWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.category = options.enums === String ? "Category_Unknown" : 0;
                object.pager = null;
            }
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.MultiSkillTag.Category[message.category] : message.category;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this MultiSkillTagCategoryWithPager to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTagCategoryWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTagCategoryWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiSkillTagCategoryWithPager;
    })();

    entity.MultiSkillTagIDList = (function() {

        /**
         * Properties of a MultiSkillTagIDList.
         * @memberof entity
         * @interface IMultiSkillTagIDList
         * @property {Array.<string>|null} [ids] MultiSkillTagIDList ids
         */

        /**
         * Constructs a new MultiSkillTagIDList.
         * @memberof entity
         * @classdesc Represents a MultiSkillTagIDList.
         * @implements IMultiSkillTagIDList
         * @constructor
         * @param {entity.IMultiSkillTagIDList=} [properties] Properties to set
         */
        function MultiSkillTagIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTagIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.MultiSkillTagIDList
         * @instance
         */
        MultiSkillTagIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new MultiSkillTagIDList instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {entity.IMultiSkillTagIDList=} [properties] Properties to set
         * @returns {entity.MultiSkillTagIDList} MultiSkillTagIDList instance
         */
        MultiSkillTagIDList.create = function create(properties) {
            return new MultiSkillTagIDList(properties);
        };

        /**
         * Encodes the specified MultiSkillTagIDList message. Does not implicitly {@link entity.MultiSkillTagIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {entity.IMultiSkillTagIDList} message MultiSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTagIDList message, length delimited. Does not implicitly {@link entity.MultiSkillTagIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {entity.IMultiSkillTagIDList} message MultiSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTagIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTagIDList} MultiSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTagIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTagIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTagIDList} MultiSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTagIDList message.
         * @function verify
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTagIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a MultiSkillTagIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTagIDList} MultiSkillTagIDList
         */
        MultiSkillTagIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTagIDList)
                return object;
            var message = new $root.entity.MultiSkillTagIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.MultiSkillTagIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTagIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTagIDList
         * @static
         * @param {entity.MultiSkillTagIDList} message MultiSkillTagIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTagIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this MultiSkillTagIDList to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTagIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTagIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiSkillTagIDList;
    })();

    entity.MultiSkillTag = (function() {

        /**
         * Properties of a MultiSkillTag.
         * @memberof entity
         * @interface IMultiSkillTag
         * @property {string|null} [id] MultiSkillTag id
         * @property {string|null} [name] MultiSkillTag name
         * @property {entity.MultiSkillTag.Category|null} [category] MultiSkillTag category
         * @property {number|Long|null} [customerNum] MultiSkillTag customerNum
         */

        /**
         * Constructs a new MultiSkillTag.
         * @memberof entity
         * @classdesc Represents a MultiSkillTag.
         * @implements IMultiSkillTag
         * @constructor
         * @param {entity.IMultiSkillTag=} [properties] Properties to set
         */
        function MultiSkillTag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTag id.
         * @member {string} id
         * @memberof entity.MultiSkillTag
         * @instance
         */
        MultiSkillTag.prototype.id = "";

        /**
         * MultiSkillTag name.
         * @member {string} name
         * @memberof entity.MultiSkillTag
         * @instance
         */
        MultiSkillTag.prototype.name = "";

        /**
         * MultiSkillTag category.
         * @member {entity.MultiSkillTag.Category} category
         * @memberof entity.MultiSkillTag
         * @instance
         */
        MultiSkillTag.prototype.category = 0;

        /**
         * MultiSkillTag customerNum.
         * @member {number|Long} customerNum
         * @memberof entity.MultiSkillTag
         * @instance
         */
        MultiSkillTag.prototype.customerNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new MultiSkillTag instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTag
         * @static
         * @param {entity.IMultiSkillTag=} [properties] Properties to set
         * @returns {entity.MultiSkillTag} MultiSkillTag instance
         */
        MultiSkillTag.create = function create(properties) {
            return new MultiSkillTag(properties);
        };

        /**
         * Encodes the specified MultiSkillTag message. Does not implicitly {@link entity.MultiSkillTag.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTag
         * @static
         * @param {entity.IMultiSkillTag} message MultiSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.category);
            if (message.customerNum != null && Object.hasOwnProperty.call(message, "customerNum"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.customerNum);
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTag message, length delimited. Does not implicitly {@link entity.MultiSkillTag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTag
         * @static
         * @param {entity.IMultiSkillTag} message MultiSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTag message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTag} MultiSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTag();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.category = reader.int32();
                    break;
                case 4:
                    message.customerNum = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTag} MultiSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTag message.
         * @function verify
         * @memberof entity.MultiSkillTag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    break;
                }
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (!$util.isInteger(message.customerNum) && !(message.customerNum && $util.isInteger(message.customerNum.low) && $util.isInteger(message.customerNum.high)))
                    return "customerNum: integer|Long expected";
            return null;
        };

        /**
         * Creates a MultiSkillTag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTag} MultiSkillTag
         */
        MultiSkillTag.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTag)
                return object;
            var message = new $root.entity.MultiSkillTag();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_IntroductionOperation":
            case 1:
                message.category = 1;
                break;
            case "Category_SpecialtyIndustry":
            case 2:
                message.category = 2;
                break;
            case "Category_OverseasExpansion":
            case 3:
                message.category = 3;
                break;
            case "Category_Programming":
            case 4:
                message.category = 4;
                break;
            case "Category_DevelopFramework":
            case 5:
                message.category = 5;
                break;
            case "Category_AI":
            case 6:
                message.category = 6;
                break;
            case "Category_PersonalConnections":
            case 7:
                message.category = 7;
                break;
            case "Category_Other":
            case 8:
                message.category = 8;
                break;
            case "Category_CXO":
            case 9:
                message.category = 9;
                break;
            }
            if (object.customerNum != null)
                if ($util.Long)
                    (message.customerNum = $util.Long.fromValue(object.customerNum)).unsigned = false;
                else if (typeof object.customerNum === "string")
                    message.customerNum = parseInt(object.customerNum, 10);
                else if (typeof object.customerNum === "number")
                    message.customerNum = object.customerNum;
                else if (typeof object.customerNum === "object")
                    message.customerNum = new $util.LongBits(object.customerNum.low >>> 0, object.customerNum.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTag
         * @static
         * @param {entity.MultiSkillTag} message MultiSkillTag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.category = options.enums === String ? "Category_Unknown" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.customerNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customerNum = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.MultiSkillTag.Category[message.category] : message.category;
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (typeof message.customerNum === "number")
                    object.customerNum = options.longs === String ? String(message.customerNum) : message.customerNum;
                else
                    object.customerNum = options.longs === String ? $util.Long.prototype.toString.call(message.customerNum) : options.longs === Number ? new $util.LongBits(message.customerNum.low >>> 0, message.customerNum.high >>> 0).toNumber() : message.customerNum;
            return object;
        };

        /**
         * Converts this MultiSkillTag to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Category enum.
         * @name entity.MultiSkillTag.Category
         * @enum {number}
         * @property {number} Category_Unknown=0 Category_Unknown value
         * @property {number} Category_IntroductionOperation=1 Category_IntroductionOperation value
         * @property {number} Category_SpecialtyIndustry=2 Category_SpecialtyIndustry value
         * @property {number} Category_OverseasExpansion=3 Category_OverseasExpansion value
         * @property {number} Category_Programming=4 Category_Programming value
         * @property {number} Category_DevelopFramework=5 Category_DevelopFramework value
         * @property {number} Category_AI=6 Category_AI value
         * @property {number} Category_PersonalConnections=7 Category_PersonalConnections value
         * @property {number} Category_Other=8 Category_Other value
         * @property {number} Category_CXO=9 Category_CXO value
         */
        MultiSkillTag.Category = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Category_Unknown"] = 0;
            values[valuesById[1] = "Category_IntroductionOperation"] = 1;
            values[valuesById[2] = "Category_SpecialtyIndustry"] = 2;
            values[valuesById[3] = "Category_OverseasExpansion"] = 3;
            values[valuesById[4] = "Category_Programming"] = 4;
            values[valuesById[5] = "Category_DevelopFramework"] = 5;
            values[valuesById[6] = "Category_AI"] = 6;
            values[valuesById[7] = "Category_PersonalConnections"] = 7;
            values[valuesById[8] = "Category_Other"] = 8;
            values[valuesById[9] = "Category_CXO"] = 9;
            return values;
        })();

        return MultiSkillTag;
    })();

    entity.MultiSkillTagList = (function() {

        /**
         * Properties of a MultiSkillTagList.
         * @memberof entity
         * @interface IMultiSkillTagList
         * @property {Array.<entity.IMultiSkillTag>|null} [items] MultiSkillTagList items
         */

        /**
         * Constructs a new MultiSkillTagList.
         * @memberof entity
         * @classdesc Represents a MultiSkillTagList.
         * @implements IMultiSkillTagList
         * @constructor
         * @param {entity.IMultiSkillTagList=} [properties] Properties to set
         */
        function MultiSkillTagList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiSkillTagList items.
         * @member {Array.<entity.IMultiSkillTag>} items
         * @memberof entity.MultiSkillTagList
         * @instance
         */
        MultiSkillTagList.prototype.items = $util.emptyArray;

        /**
         * Creates a new MultiSkillTagList instance using the specified properties.
         * @function create
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {entity.IMultiSkillTagList=} [properties] Properties to set
         * @returns {entity.MultiSkillTagList} MultiSkillTagList instance
         */
        MultiSkillTagList.create = function create(properties) {
            return new MultiSkillTagList(properties);
        };

        /**
         * Encodes the specified MultiSkillTagList message. Does not implicitly {@link entity.MultiSkillTagList.verify|verify} messages.
         * @function encode
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {entity.IMultiSkillTagList} message MultiSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.MultiSkillTag.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MultiSkillTagList message, length delimited. Does not implicitly {@link entity.MultiSkillTagList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {entity.IMultiSkillTagList} message MultiSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MultiSkillTagList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MultiSkillTagList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MultiSkillTagList} MultiSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MultiSkillTagList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.MultiSkillTag.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MultiSkillTagList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MultiSkillTagList} MultiSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MultiSkillTagList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MultiSkillTagList message.
         * @function verify
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MultiSkillTagList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.MultiSkillTag.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MultiSkillTagList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MultiSkillTagList} MultiSkillTagList
         */
        MultiSkillTagList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MultiSkillTagList)
                return object;
            var message = new $root.entity.MultiSkillTagList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.MultiSkillTagList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.MultiSkillTagList.items: object expected");
                    message.items[i] = $root.entity.MultiSkillTag.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiSkillTagList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MultiSkillTagList
         * @static
         * @param {entity.MultiSkillTagList} message MultiSkillTagList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiSkillTagList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.MultiSkillTag.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this MultiSkillTagList to JSON.
         * @function toJSON
         * @memberof entity.MultiSkillTagList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiSkillTagList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiSkillTagList;
    })();

    entity.OccupationSkillTagID = (function() {

        /**
         * Properties of an OccupationSkillTagID.
         * @memberof entity
         * @interface IOccupationSkillTagID
         * @property {string|null} [id] OccupationSkillTagID id
         */

        /**
         * Constructs a new OccupationSkillTagID.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagID.
         * @implements IOccupationSkillTagID
         * @constructor
         * @param {entity.IOccupationSkillTagID=} [properties] Properties to set
         */
        function OccupationSkillTagID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagID id.
         * @member {string} id
         * @memberof entity.OccupationSkillTagID
         * @instance
         */
        OccupationSkillTagID.prototype.id = "";

        /**
         * Creates a new OccupationSkillTagID instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {entity.IOccupationSkillTagID=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagID} OccupationSkillTagID instance
         */
        OccupationSkillTagID.create = function create(properties) {
            return new OccupationSkillTagID(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagID message. Does not implicitly {@link entity.OccupationSkillTagID.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {entity.IOccupationSkillTagID} message OccupationSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagID message, length delimited. Does not implicitly {@link entity.OccupationSkillTagID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {entity.IOccupationSkillTagID} message OccupationSkillTagID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagID} OccupationSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagID} OccupationSkillTagID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagID message.
         * @function verify
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates an OccupationSkillTagID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagID} OccupationSkillTagID
         */
        OccupationSkillTagID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagID)
                return object;
            var message = new $root.entity.OccupationSkillTagID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagID
         * @static
         * @param {entity.OccupationSkillTagID} message OccupationSkillTagID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this OccupationSkillTagID to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagID;
    })();

    entity.OccupationSkillTagIDWithPager = (function() {

        /**
         * Properties of an OccupationSkillTagIDWithPager.
         * @memberof entity
         * @interface IOccupationSkillTagIDWithPager
         * @property {string|null} [id] OccupationSkillTagIDWithPager id
         * @property {common.IPager|null} [pager] OccupationSkillTagIDWithPager pager
         */

        /**
         * Constructs a new OccupationSkillTagIDWithPager.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagIDWithPager.
         * @implements IOccupationSkillTagIDWithPager
         * @constructor
         * @param {entity.IOccupationSkillTagIDWithPager=} [properties] Properties to set
         */
        function OccupationSkillTagIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagIDWithPager id.
         * @member {string} id
         * @memberof entity.OccupationSkillTagIDWithPager
         * @instance
         */
        OccupationSkillTagIDWithPager.prototype.id = "";

        /**
         * OccupationSkillTagIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.OccupationSkillTagIDWithPager
         * @instance
         */
        OccupationSkillTagIDWithPager.prototype.pager = null;

        /**
         * Creates a new OccupationSkillTagIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {entity.IOccupationSkillTagIDWithPager=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagIDWithPager} OccupationSkillTagIDWithPager instance
         */
        OccupationSkillTagIDWithPager.create = function create(properties) {
            return new OccupationSkillTagIDWithPager(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagIDWithPager message. Does not implicitly {@link entity.OccupationSkillTagIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {entity.IOccupationSkillTagIDWithPager} message OccupationSkillTagIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagIDWithPager message, length delimited. Does not implicitly {@link entity.OccupationSkillTagIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {entity.IOccupationSkillTagIDWithPager} message OccupationSkillTagIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagIDWithPager} OccupationSkillTagIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagIDWithPager} OccupationSkillTagIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagIDWithPager message.
         * @function verify
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTagIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagIDWithPager} OccupationSkillTagIDWithPager
         */
        OccupationSkillTagIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagIDWithPager)
                return object;
            var message = new $root.entity.OccupationSkillTagIDWithPager();
            if (object.id != null)
                message.id = String(object.id);
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.OccupationSkillTagIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagIDWithPager
         * @static
         * @param {entity.OccupationSkillTagIDWithPager} message OccupationSkillTagIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.pager = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this OccupationSkillTagIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagIDWithPager;
    })();

    entity.OccupationSkillTagCategory = (function() {

        /**
         * Properties of an OccupationSkillTagCategory.
         * @memberof entity
         * @interface IOccupationSkillTagCategory
         * @property {entity.OccupationSkillTag.Category|null} [category] OccupationSkillTagCategory category
         */

        /**
         * Constructs a new OccupationSkillTagCategory.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagCategory.
         * @implements IOccupationSkillTagCategory
         * @constructor
         * @param {entity.IOccupationSkillTagCategory=} [properties] Properties to set
         */
        function OccupationSkillTagCategory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagCategory category.
         * @member {entity.OccupationSkillTag.Category} category
         * @memberof entity.OccupationSkillTagCategory
         * @instance
         */
        OccupationSkillTagCategory.prototype.category = 0;

        /**
         * Creates a new OccupationSkillTagCategory instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {entity.IOccupationSkillTagCategory=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagCategory} OccupationSkillTagCategory instance
         */
        OccupationSkillTagCategory.create = function create(properties) {
            return new OccupationSkillTagCategory(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagCategory message. Does not implicitly {@link entity.OccupationSkillTagCategory.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {entity.IOccupationSkillTagCategory} message OccupationSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagCategory message, length delimited. Does not implicitly {@link entity.OccupationSkillTagCategory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {entity.IOccupationSkillTagCategory} message OccupationSkillTagCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagCategory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagCategory} OccupationSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagCategory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagCategory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagCategory} OccupationSkillTagCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagCategory message.
         * @function verify
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagCategory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            return null;
        };

        /**
         * Creates an OccupationSkillTagCategory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagCategory} OccupationSkillTagCategory
         */
        OccupationSkillTagCategory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagCategory)
                return object;
            var message = new $root.entity.OccupationSkillTagCategory();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_Sales":
            case 1:
                message.category = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.category = 2;
                break;
            case "Category_PR":
            case 3:
                message.category = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.category = 4;
                break;
            case "Category_Finance":
            case 5:
                message.category = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.category = 6;
                break;
            case "Category_IR":
            case 7:
                message.category = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.category = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.category = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.category = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.category = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.category = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.category = 13;
                break;
            case "Category_Bank":
            case 14:
                message.category = 14;
                break;
            case "Category_Technical":
            case 15:
                message.category = 15;
                break;
            case "Category_IPO":
            case 16:
                message.category = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.category = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.category = 18;
                break;
            case "Category_RandD":
            case 19:
                message.category = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.category = 20;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagCategory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagCategory
         * @static
         * @param {entity.OccupationSkillTagCategory} message OccupationSkillTagCategory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagCategory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.category = options.enums === String ? "Category_Unknown" : 0;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.category] : message.category;
            return object;
        };

        /**
         * Converts this OccupationSkillTagCategory to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagCategory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagCategory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagCategory;
    })();

    entity.OccupationSkillTagCategoryWithPager = (function() {

        /**
         * Properties of an OccupationSkillTagCategoryWithPager.
         * @memberof entity
         * @interface IOccupationSkillTagCategoryWithPager
         * @property {entity.OccupationSkillTag.Category|null} [category] OccupationSkillTagCategoryWithPager category
         * @property {common.IPager|null} [pager] OccupationSkillTagCategoryWithPager pager
         */

        /**
         * Constructs a new OccupationSkillTagCategoryWithPager.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagCategoryWithPager.
         * @implements IOccupationSkillTagCategoryWithPager
         * @constructor
         * @param {entity.IOccupationSkillTagCategoryWithPager=} [properties] Properties to set
         */
        function OccupationSkillTagCategoryWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagCategoryWithPager category.
         * @member {entity.OccupationSkillTag.Category} category
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @instance
         */
        OccupationSkillTagCategoryWithPager.prototype.category = 0;

        /**
         * OccupationSkillTagCategoryWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @instance
         */
        OccupationSkillTagCategoryWithPager.prototype.pager = null;

        /**
         * Creates a new OccupationSkillTagCategoryWithPager instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {entity.IOccupationSkillTagCategoryWithPager=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagCategoryWithPager} OccupationSkillTagCategoryWithPager instance
         */
        OccupationSkillTagCategoryWithPager.create = function create(properties) {
            return new OccupationSkillTagCategoryWithPager(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryWithPager message. Does not implicitly {@link entity.OccupationSkillTagCategoryWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {entity.IOccupationSkillTagCategoryWithPager} message OccupationSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryWithPager message, length delimited. Does not implicitly {@link entity.OccupationSkillTagCategoryWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {entity.IOccupationSkillTagCategoryWithPager} message OccupationSkillTagCategoryWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagCategoryWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagCategoryWithPager} OccupationSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagCategoryWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagCategoryWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagCategoryWithPager} OccupationSkillTagCategoryWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagCategoryWithPager message.
         * @function verify
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagCategoryWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTagCategoryWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagCategoryWithPager} OccupationSkillTagCategoryWithPager
         */
        OccupationSkillTagCategoryWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagCategoryWithPager)
                return object;
            var message = new $root.entity.OccupationSkillTagCategoryWithPager();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_Sales":
            case 1:
                message.category = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.category = 2;
                break;
            case "Category_PR":
            case 3:
                message.category = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.category = 4;
                break;
            case "Category_Finance":
            case 5:
                message.category = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.category = 6;
                break;
            case "Category_IR":
            case 7:
                message.category = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.category = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.category = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.category = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.category = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.category = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.category = 13;
                break;
            case "Category_Bank":
            case 14:
                message.category = 14;
                break;
            case "Category_Technical":
            case 15:
                message.category = 15;
                break;
            case "Category_IPO":
            case 16:
                message.category = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.category = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.category = 18;
                break;
            case "Category_RandD":
            case 19:
                message.category = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.category = 20;
                break;
            }
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.OccupationSkillTagCategoryWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagCategoryWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @static
         * @param {entity.OccupationSkillTagCategoryWithPager} message OccupationSkillTagCategoryWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagCategoryWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.category = options.enums === String ? "Category_Unknown" : 0;
                object.pager = null;
            }
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.category] : message.category;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this OccupationSkillTagCategoryWithPager to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagCategoryWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagCategoryWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagCategoryWithPager;
    })();

    entity.OccupationSkillTagIDList = (function() {

        /**
         * Properties of an OccupationSkillTagIDList.
         * @memberof entity
         * @interface IOccupationSkillTagIDList
         * @property {Array.<string>|null} [ids] OccupationSkillTagIDList ids
         */

        /**
         * Constructs a new OccupationSkillTagIDList.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagIDList.
         * @implements IOccupationSkillTagIDList
         * @constructor
         * @param {entity.IOccupationSkillTagIDList=} [properties] Properties to set
         */
        function OccupationSkillTagIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.OccupationSkillTagIDList
         * @instance
         */
        OccupationSkillTagIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new OccupationSkillTagIDList instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {entity.IOccupationSkillTagIDList=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagIDList} OccupationSkillTagIDList instance
         */
        OccupationSkillTagIDList.create = function create(properties) {
            return new OccupationSkillTagIDList(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagIDList message. Does not implicitly {@link entity.OccupationSkillTagIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {entity.IOccupationSkillTagIDList} message OccupationSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagIDList message, length delimited. Does not implicitly {@link entity.OccupationSkillTagIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {entity.IOccupationSkillTagIDList} message OccupationSkillTagIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagIDList} OccupationSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagIDList} OccupationSkillTagIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagIDList message.
         * @function verify
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTagIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagIDList} OccupationSkillTagIDList
         */
        OccupationSkillTagIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagIDList)
                return object;
            var message = new $root.entity.OccupationSkillTagIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.OccupationSkillTagIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagIDList
         * @static
         * @param {entity.OccupationSkillTagIDList} message OccupationSkillTagIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this OccupationSkillTagIDList to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagIDList;
    })();

    entity.OccupationSkillTag = (function() {

        /**
         * Properties of an OccupationSkillTag.
         * @memberof entity
         * @interface IOccupationSkillTag
         * @property {string|null} [id] OccupationSkillTag id
         * @property {string|null} [parentID] OccupationSkillTag parentID
         * @property {string|null} [name] OccupationSkillTag name
         * @property {entity.OccupationSkillTag.Category|null} [category] OccupationSkillTag category
         * @property {number|Long|null} [customerNum] OccupationSkillTag customerNum
         * @property {Array.<entity.IOccupationSkillTag>|null} [children] OccupationSkillTag children
         */

        /**
         * Constructs a new OccupationSkillTag.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTag.
         * @implements IOccupationSkillTag
         * @constructor
         * @param {entity.IOccupationSkillTag=} [properties] Properties to set
         */
        function OccupationSkillTag(properties) {
            this.children = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTag id.
         * @member {string} id
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.id = "";

        /**
         * OccupationSkillTag parentID.
         * @member {string} parentID
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.parentID = "";

        /**
         * OccupationSkillTag name.
         * @member {string} name
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.name = "";

        /**
         * OccupationSkillTag category.
         * @member {entity.OccupationSkillTag.Category} category
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.category = 0;

        /**
         * OccupationSkillTag customerNum.
         * @member {number|Long} customerNum
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.customerNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * OccupationSkillTag children.
         * @member {Array.<entity.IOccupationSkillTag>} children
         * @memberof entity.OccupationSkillTag
         * @instance
         */
        OccupationSkillTag.prototype.children = $util.emptyArray;

        /**
         * Creates a new OccupationSkillTag instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {entity.IOccupationSkillTag=} [properties] Properties to set
         * @returns {entity.OccupationSkillTag} OccupationSkillTag instance
         */
        OccupationSkillTag.create = function create(properties) {
            return new OccupationSkillTag(properties);
        };

        /**
         * Encodes the specified OccupationSkillTag message. Does not implicitly {@link entity.OccupationSkillTag.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {entity.IOccupationSkillTag} message OccupationSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.parentID != null && Object.hasOwnProperty.call(message, "parentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentID);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.category);
            if (message.customerNum != null && Object.hasOwnProperty.call(message, "customerNum"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.customerNum);
            if (message.children != null && message.children.length)
                for (var i = 0; i < message.children.length; ++i)
                    $root.entity.OccupationSkillTag.encode(message.children[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTag message, length delimited. Does not implicitly {@link entity.OccupationSkillTag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {entity.IOccupationSkillTag} message OccupationSkillTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTag message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTag} OccupationSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTag();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.parentID = reader.string();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                case 4:
                    message.category = reader.int32();
                    break;
                case 5:
                    message.customerNum = reader.int64();
                    break;
                case 6:
                    if (!(message.children && message.children.length))
                        message.children = [];
                    message.children.push($root.entity.OccupationSkillTag.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTag} OccupationSkillTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTag message.
         * @function verify
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.parentID != null && message.hasOwnProperty("parentID"))
                if (!$util.isString(message.parentID))
                    return "parentID: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (!$util.isInteger(message.customerNum) && !(message.customerNum && $util.isInteger(message.customerNum.low) && $util.isInteger(message.customerNum.high)))
                    return "customerNum: integer|Long expected";
            if (message.children != null && message.hasOwnProperty("children")) {
                if (!Array.isArray(message.children))
                    return "children: array expected";
                for (var i = 0; i < message.children.length; ++i) {
                    var error = $root.entity.OccupationSkillTag.verify(message.children[i]);
                    if (error)
                        return "children." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTag} OccupationSkillTag
         */
        OccupationSkillTag.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTag)
                return object;
            var message = new $root.entity.OccupationSkillTag();
            if (object.id != null)
                message.id = String(object.id);
            if (object.parentID != null)
                message.parentID = String(object.parentID);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_Sales":
            case 1:
                message.category = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.category = 2;
                break;
            case "Category_PR":
            case 3:
                message.category = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.category = 4;
                break;
            case "Category_Finance":
            case 5:
                message.category = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.category = 6;
                break;
            case "Category_IR":
            case 7:
                message.category = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.category = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.category = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.category = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.category = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.category = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.category = 13;
                break;
            case "Category_Bank":
            case 14:
                message.category = 14;
                break;
            case "Category_Technical":
            case 15:
                message.category = 15;
                break;
            case "Category_IPO":
            case 16:
                message.category = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.category = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.category = 18;
                break;
            case "Category_RandD":
            case 19:
                message.category = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.category = 20;
                break;
            }
            if (object.customerNum != null)
                if ($util.Long)
                    (message.customerNum = $util.Long.fromValue(object.customerNum)).unsigned = false;
                else if (typeof object.customerNum === "string")
                    message.customerNum = parseInt(object.customerNum, 10);
                else if (typeof object.customerNum === "number")
                    message.customerNum = object.customerNum;
                else if (typeof object.customerNum === "object")
                    message.customerNum = new $util.LongBits(object.customerNum.low >>> 0, object.customerNum.high >>> 0).toNumber();
            if (object.children) {
                if (!Array.isArray(object.children))
                    throw TypeError(".entity.OccupationSkillTag.children: array expected");
                message.children = [];
                for (var i = 0; i < object.children.length; ++i) {
                    if (typeof object.children[i] !== "object")
                        throw TypeError(".entity.OccupationSkillTag.children: object expected");
                    message.children[i] = $root.entity.OccupationSkillTag.fromObject(object.children[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTag
         * @static
         * @param {entity.OccupationSkillTag} message OccupationSkillTag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.children = [];
            if (options.defaults) {
                object.id = "";
                object.parentID = "";
                object.name = "";
                object.category = options.enums === String ? "Category_Unknown" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.customerNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customerNum = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.parentID != null && message.hasOwnProperty("parentID"))
                object.parentID = message.parentID;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.category] : message.category;
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (typeof message.customerNum === "number")
                    object.customerNum = options.longs === String ? String(message.customerNum) : message.customerNum;
                else
                    object.customerNum = options.longs === String ? $util.Long.prototype.toString.call(message.customerNum) : options.longs === Number ? new $util.LongBits(message.customerNum.low >>> 0, message.customerNum.high >>> 0).toNumber() : message.customerNum;
            if (message.children && message.children.length) {
                object.children = [];
                for (var j = 0; j < message.children.length; ++j)
                    object.children[j] = $root.entity.OccupationSkillTag.toObject(message.children[j], options);
            }
            return object;
        };

        /**
         * Converts this OccupationSkillTag to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Category enum.
         * @name entity.OccupationSkillTag.Category
         * @enum {number}
         * @property {number} Category_Unknown=0 Category_Unknown value
         * @property {number} Category_Sales=1 Category_Sales value
         * @property {number} Category_BusinessDevelopment=2 Category_BusinessDevelopment value
         * @property {number} Category_PR=3 Category_PR value
         * @property {number} Category_PublicRelations=4 Category_PublicRelations value
         * @property {number} Category_Finance=5 Category_Finance value
         * @property {number} Category_GroupManagement=6 Category_GroupManagement value
         * @property {number} Category_IR=7 Category_IR value
         * @property {number} Category_Accounting=8 Category_Accounting value
         * @property {number} Category_OfficeWork_Assistant=9 Category_OfficeWork_Assistant value
         * @property {number} Category_SaleService=10 Category_SaleService value
         * @property {number} Category_HumanResource=11 Category_HumanResource value
         * @property {number} Category_Consultant=12 Category_Consultant value
         * @property {number} Category_Administrative=13 Category_Administrative value
         * @property {number} Category_Bank=14 Category_Bank value
         * @property {number} Category_Technical=15 Category_Technical value
         * @property {number} Category_IPO=16 Category_IPO value
         * @property {number} Category_CompanyManagement=17 Category_CompanyManagement value
         * @property {number} Category_Marketing=18 Category_Marketing value
         * @property {number} Category_RandD=19 Category_RandD value
         * @property {number} Category_LegalCompliance=20 Category_LegalCompliance value
         */
        OccupationSkillTag.Category = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Category_Unknown"] = 0;
            values[valuesById[1] = "Category_Sales"] = 1;
            values[valuesById[2] = "Category_BusinessDevelopment"] = 2;
            values[valuesById[3] = "Category_PR"] = 3;
            values[valuesById[4] = "Category_PublicRelations"] = 4;
            values[valuesById[5] = "Category_Finance"] = 5;
            values[valuesById[6] = "Category_GroupManagement"] = 6;
            values[valuesById[7] = "Category_IR"] = 7;
            values[valuesById[8] = "Category_Accounting"] = 8;
            values[valuesById[9] = "Category_OfficeWork_Assistant"] = 9;
            values[valuesById[10] = "Category_SaleService"] = 10;
            values[valuesById[11] = "Category_HumanResource"] = 11;
            values[valuesById[12] = "Category_Consultant"] = 12;
            values[valuesById[13] = "Category_Administrative"] = 13;
            values[valuesById[14] = "Category_Bank"] = 14;
            values[valuesById[15] = "Category_Technical"] = 15;
            values[valuesById[16] = "Category_IPO"] = 16;
            values[valuesById[17] = "Category_CompanyManagement"] = 17;
            values[valuesById[18] = "Category_Marketing"] = 18;
            values[valuesById[19] = "Category_RandD"] = 19;
            values[valuesById[20] = "Category_LegalCompliance"] = 20;
            return values;
        })();

        return OccupationSkillTag;
    })();

    entity.OccupationSkillTagList = (function() {

        /**
         * Properties of an OccupationSkillTagList.
         * @memberof entity
         * @interface IOccupationSkillTagList
         * @property {Array.<entity.IOccupationSkillTag>|null} [items] OccupationSkillTagList items
         */

        /**
         * Constructs a new OccupationSkillTagList.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagList.
         * @implements IOccupationSkillTagList
         * @constructor
         * @param {entity.IOccupationSkillTagList=} [properties] Properties to set
         */
        function OccupationSkillTagList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagList items.
         * @member {Array.<entity.IOccupationSkillTag>} items
         * @memberof entity.OccupationSkillTagList
         * @instance
         */
        OccupationSkillTagList.prototype.items = $util.emptyArray;

        /**
         * Creates a new OccupationSkillTagList instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {entity.IOccupationSkillTagList=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagList} OccupationSkillTagList instance
         */
        OccupationSkillTagList.create = function create(properties) {
            return new OccupationSkillTagList(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagList message. Does not implicitly {@link entity.OccupationSkillTagList.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {entity.IOccupationSkillTagList} message OccupationSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.OccupationSkillTag.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagList message, length delimited. Does not implicitly {@link entity.OccupationSkillTagList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {entity.IOccupationSkillTagList} message OccupationSkillTagList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagList} OccupationSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.OccupationSkillTag.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagList} OccupationSkillTagList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagList message.
         * @function verify
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.OccupationSkillTag.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTagList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagList} OccupationSkillTagList
         */
        OccupationSkillTagList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagList)
                return object;
            var message = new $root.entity.OccupationSkillTagList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.OccupationSkillTagList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.OccupationSkillTagList.items: object expected");
                    message.items[i] = $root.entity.OccupationSkillTag.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagList
         * @static
         * @param {entity.OccupationSkillTagList} message OccupationSkillTagList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.OccupationSkillTag.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this OccupationSkillTagList to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagList;
    })();

    entity.OccupationSkillTagCategoryList = (function() {

        /**
         * Properties of an OccupationSkillTagCategoryList.
         * @memberof entity
         * @interface IOccupationSkillTagCategoryList
         * @property {Array.<entity.IOccupationSkillTagCategoryItem>|null} [items] OccupationSkillTagCategoryList items
         */

        /**
         * Constructs a new OccupationSkillTagCategoryList.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagCategoryList.
         * @implements IOccupationSkillTagCategoryList
         * @constructor
         * @param {entity.IOccupationSkillTagCategoryList=} [properties] Properties to set
         */
        function OccupationSkillTagCategoryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagCategoryList items.
         * @member {Array.<entity.IOccupationSkillTagCategoryItem>} items
         * @memberof entity.OccupationSkillTagCategoryList
         * @instance
         */
        OccupationSkillTagCategoryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new OccupationSkillTagCategoryList instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {entity.IOccupationSkillTagCategoryList=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagCategoryList} OccupationSkillTagCategoryList instance
         */
        OccupationSkillTagCategoryList.create = function create(properties) {
            return new OccupationSkillTagCategoryList(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryList message. Does not implicitly {@link entity.OccupationSkillTagCategoryList.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {entity.IOccupationSkillTagCategoryList} message OccupationSkillTagCategoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.OccupationSkillTagCategoryItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryList message, length delimited. Does not implicitly {@link entity.OccupationSkillTagCategoryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {entity.IOccupationSkillTagCategoryList} message OccupationSkillTagCategoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagCategoryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagCategoryList} OccupationSkillTagCategoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagCategoryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.OccupationSkillTagCategoryItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagCategoryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagCategoryList} OccupationSkillTagCategoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagCategoryList message.
         * @function verify
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagCategoryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.OccupationSkillTagCategoryItem.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OccupationSkillTagCategoryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagCategoryList} OccupationSkillTagCategoryList
         */
        OccupationSkillTagCategoryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagCategoryList)
                return object;
            var message = new $root.entity.OccupationSkillTagCategoryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.OccupationSkillTagCategoryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.OccupationSkillTagCategoryList.items: object expected");
                    message.items[i] = $root.entity.OccupationSkillTagCategoryItem.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagCategoryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagCategoryList
         * @static
         * @param {entity.OccupationSkillTagCategoryList} message OccupationSkillTagCategoryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagCategoryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.OccupationSkillTagCategoryItem.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this OccupationSkillTagCategoryList to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagCategoryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagCategoryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagCategoryList;
    })();

    entity.OccupationSkillTagCategoryItem = (function() {

        /**
         * Properties of an OccupationSkillTagCategoryItem.
         * @memberof entity
         * @interface IOccupationSkillTagCategoryItem
         * @property {entity.OccupationSkillTag.Category|null} [category] OccupationSkillTagCategoryItem category
         * @property {string|null} [name] OccupationSkillTagCategoryItem name
         * @property {number|Long|null} [customerNum] OccupationSkillTagCategoryItem customerNum
         */

        /**
         * Constructs a new OccupationSkillTagCategoryItem.
         * @memberof entity
         * @classdesc Represents an OccupationSkillTagCategoryItem.
         * @implements IOccupationSkillTagCategoryItem
         * @constructor
         * @param {entity.IOccupationSkillTagCategoryItem=} [properties] Properties to set
         */
        function OccupationSkillTagCategoryItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupationSkillTagCategoryItem category.
         * @member {entity.OccupationSkillTag.Category} category
         * @memberof entity.OccupationSkillTagCategoryItem
         * @instance
         */
        OccupationSkillTagCategoryItem.prototype.category = 0;

        /**
         * OccupationSkillTagCategoryItem name.
         * @member {string} name
         * @memberof entity.OccupationSkillTagCategoryItem
         * @instance
         */
        OccupationSkillTagCategoryItem.prototype.name = "";

        /**
         * OccupationSkillTagCategoryItem customerNum.
         * @member {number|Long} customerNum
         * @memberof entity.OccupationSkillTagCategoryItem
         * @instance
         */
        OccupationSkillTagCategoryItem.prototype.customerNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new OccupationSkillTagCategoryItem instance using the specified properties.
         * @function create
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {entity.IOccupationSkillTagCategoryItem=} [properties] Properties to set
         * @returns {entity.OccupationSkillTagCategoryItem} OccupationSkillTagCategoryItem instance
         */
        OccupationSkillTagCategoryItem.create = function create(properties) {
            return new OccupationSkillTagCategoryItem(properties);
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryItem message. Does not implicitly {@link entity.OccupationSkillTagCategoryItem.verify|verify} messages.
         * @function encode
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {entity.IOccupationSkillTagCategoryItem} message OccupationSkillTagCategoryItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.customerNum != null && Object.hasOwnProperty.call(message, "customerNum"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.customerNum);
            return writer;
        };

        /**
         * Encodes the specified OccupationSkillTagCategoryItem message, length delimited. Does not implicitly {@link entity.OccupationSkillTagCategoryItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {entity.IOccupationSkillTagCategoryItem} message OccupationSkillTagCategoryItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupationSkillTagCategoryItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupationSkillTagCategoryItem message from the specified reader or buffer.
         * @function decode
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.OccupationSkillTagCategoryItem} OccupationSkillTagCategoryItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.OccupationSkillTagCategoryItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.category = reader.int32();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.customerNum = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupationSkillTagCategoryItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.OccupationSkillTagCategoryItem} OccupationSkillTagCategoryItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupationSkillTagCategoryItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupationSkillTagCategoryItem message.
         * @function verify
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupationSkillTagCategoryItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.category != null && message.hasOwnProperty("category"))
                switch (message.category) {
                default:
                    return "category: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (!$util.isInteger(message.customerNum) && !(message.customerNum && $util.isInteger(message.customerNum.low) && $util.isInteger(message.customerNum.high)))
                    return "customerNum: integer|Long expected";
            return null;
        };

        /**
         * Creates an OccupationSkillTagCategoryItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.OccupationSkillTagCategoryItem} OccupationSkillTagCategoryItem
         */
        OccupationSkillTagCategoryItem.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.OccupationSkillTagCategoryItem)
                return object;
            var message = new $root.entity.OccupationSkillTagCategoryItem();
            switch (object.category) {
            case "Category_Unknown":
            case 0:
                message.category = 0;
                break;
            case "Category_Sales":
            case 1:
                message.category = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.category = 2;
                break;
            case "Category_PR":
            case 3:
                message.category = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.category = 4;
                break;
            case "Category_Finance":
            case 5:
                message.category = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.category = 6;
                break;
            case "Category_IR":
            case 7:
                message.category = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.category = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.category = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.category = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.category = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.category = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.category = 13;
                break;
            case "Category_Bank":
            case 14:
                message.category = 14;
                break;
            case "Category_Technical":
            case 15:
                message.category = 15;
                break;
            case "Category_IPO":
            case 16:
                message.category = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.category = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.category = 18;
                break;
            case "Category_RandD":
            case 19:
                message.category = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.category = 20;
                break;
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.customerNum != null)
                if ($util.Long)
                    (message.customerNum = $util.Long.fromValue(object.customerNum)).unsigned = false;
                else if (typeof object.customerNum === "string")
                    message.customerNum = parseInt(object.customerNum, 10);
                else if (typeof object.customerNum === "number")
                    message.customerNum = object.customerNum;
                else if (typeof object.customerNum === "object")
                    message.customerNum = new $util.LongBits(object.customerNum.low >>> 0, object.customerNum.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an OccupationSkillTagCategoryItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.OccupationSkillTagCategoryItem
         * @static
         * @param {entity.OccupationSkillTagCategoryItem} message OccupationSkillTagCategoryItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupationSkillTagCategoryItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.category = options.enums === String ? "Category_Unknown" : 0;
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.customerNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customerNum = options.longs === String ? "0" : 0;
            }
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.category] : message.category;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.customerNum != null && message.hasOwnProperty("customerNum"))
                if (typeof message.customerNum === "number")
                    object.customerNum = options.longs === String ? String(message.customerNum) : message.customerNum;
                else
                    object.customerNum = options.longs === String ? $util.Long.prototype.toString.call(message.customerNum) : options.longs === Number ? new $util.LongBits(message.customerNum.low >>> 0, message.customerNum.high >>> 0).toNumber() : message.customerNum;
            return object;
        };

        /**
         * Converts this OccupationSkillTagCategoryItem to JSON.
         * @function toJSON
         * @memberof entity.OccupationSkillTagCategoryItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupationSkillTagCategoryItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupationSkillTagCategoryItem;
    })();

    entity.EntryScoutHistory = (function() {

        /**
         * Properties of an EntryScoutHistory.
         * @memberof entity
         * @interface IEntryScoutHistory
         * @property {string|null} [id] EntryScoutHistory id
         * @property {string|null} [projectID] EntryScoutHistory projectID
         * @property {string|null} [customerID] EntryScoutHistory customerID
         * @property {string|null} [companyID] EntryScoutHistory companyID
         * @property {boolean|null} [isScout] EntryScoutHistory isScout
         * @property {boolean|null} [isArchive] EntryScoutHistory isArchive
         * @property {string|null} [projectName] EntryScoutHistory projectName
         * @property {string|null} [customerSignedIconURL] EntryScoutHistory customerSignedIconURL
         * @property {string|null} [customerCatchphrase] EntryScoutHistory customerCatchphrase
         * @property {string|null} [customerJobCareerCatchphrase] EntryScoutHistory customerJobCareerCatchphrase
         * @property {number|Long|null} [messageCount] EntryScoutHistory messageCount
         * @property {boolean|null} [hasContract] EntryScoutHistory hasContract
         * @property {string|null} [createdAt] EntryScoutHistory createdAt
         */

        /**
         * Constructs a new EntryScoutHistory.
         * @memberof entity
         * @classdesc Represents an EntryScoutHistory.
         * @implements IEntryScoutHistory
         * @constructor
         * @param {entity.IEntryScoutHistory=} [properties] Properties to set
         */
        function EntryScoutHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryScoutHistory id.
         * @member {string} id
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.id = "";

        /**
         * EntryScoutHistory projectID.
         * @member {string} projectID
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.projectID = "";

        /**
         * EntryScoutHistory customerID.
         * @member {string} customerID
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.customerID = "";

        /**
         * EntryScoutHistory companyID.
         * @member {string} companyID
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.companyID = "";

        /**
         * EntryScoutHistory isScout.
         * @member {boolean} isScout
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.isScout = false;

        /**
         * EntryScoutHistory isArchive.
         * @member {boolean} isArchive
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.isArchive = false;

        /**
         * EntryScoutHistory projectName.
         * @member {string} projectName
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.projectName = "";

        /**
         * EntryScoutHistory customerSignedIconURL.
         * @member {string} customerSignedIconURL
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.customerSignedIconURL = "";

        /**
         * EntryScoutHistory customerCatchphrase.
         * @member {string} customerCatchphrase
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.customerCatchphrase = "";

        /**
         * EntryScoutHistory customerJobCareerCatchphrase.
         * @member {string} customerJobCareerCatchphrase
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.customerJobCareerCatchphrase = "";

        /**
         * EntryScoutHistory messageCount.
         * @member {number|Long} messageCount
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.messageCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * EntryScoutHistory hasContract.
         * @member {boolean} hasContract
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.hasContract = false;

        /**
         * EntryScoutHistory createdAt.
         * @member {string} createdAt
         * @memberof entity.EntryScoutHistory
         * @instance
         */
        EntryScoutHistory.prototype.createdAt = "";

        /**
         * Creates a new EntryScoutHistory instance using the specified properties.
         * @function create
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {entity.IEntryScoutHistory=} [properties] Properties to set
         * @returns {entity.EntryScoutHistory} EntryScoutHistory instance
         */
        EntryScoutHistory.create = function create(properties) {
            return new EntryScoutHistory(properties);
        };

        /**
         * Encodes the specified EntryScoutHistory message. Does not implicitly {@link entity.EntryScoutHistory.verify|verify} messages.
         * @function encode
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {entity.IEntryScoutHistory} message EntryScoutHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerID);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.companyID);
            if (message.isScout != null && Object.hasOwnProperty.call(message, "isScout"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isScout);
            if (message.isArchive != null && Object.hasOwnProperty.call(message, "isArchive"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isArchive);
            if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.projectName);
            if (message.customerSignedIconURL != null && Object.hasOwnProperty.call(message, "customerSignedIconURL"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.customerSignedIconURL);
            if (message.customerCatchphrase != null && Object.hasOwnProperty.call(message, "customerCatchphrase"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.customerCatchphrase);
            if (message.customerJobCareerCatchphrase != null && Object.hasOwnProperty.call(message, "customerJobCareerCatchphrase"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.customerJobCareerCatchphrase);
            if (message.messageCount != null && Object.hasOwnProperty.call(message, "messageCount"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.messageCount);
            if (message.hasContract != null && Object.hasOwnProperty.call(message, "hasContract"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.hasContract);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 999, wireType 2 =*/7994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified EntryScoutHistory message, length delimited. Does not implicitly {@link entity.EntryScoutHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {entity.IEntryScoutHistory} message EntryScoutHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryScoutHistory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.EntryScoutHistory} EntryScoutHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.EntryScoutHistory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.customerID = reader.string();
                    break;
                case 4:
                    message.companyID = reader.string();
                    break;
                case 5:
                    message.isScout = reader.bool();
                    break;
                case 6:
                    message.isArchive = reader.bool();
                    break;
                case 7:
                    message.projectName = reader.string();
                    break;
                case 8:
                    message.customerSignedIconURL = reader.string();
                    break;
                case 9:
                    message.customerCatchphrase = reader.string();
                    break;
                case 10:
                    message.customerJobCareerCatchphrase = reader.string();
                    break;
                case 11:
                    message.messageCount = reader.int64();
                    break;
                case 12:
                    message.hasContract = reader.bool();
                    break;
                case 999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryScoutHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.EntryScoutHistory} EntryScoutHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryScoutHistory message.
         * @function verify
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryScoutHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.isScout != null && message.hasOwnProperty("isScout"))
                if (typeof message.isScout !== "boolean")
                    return "isScout: boolean expected";
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                if (typeof message.isArchive !== "boolean")
                    return "isArchive: boolean expected";
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                if (!$util.isString(message.projectName))
                    return "projectName: string expected";
            if (message.customerSignedIconURL != null && message.hasOwnProperty("customerSignedIconURL"))
                if (!$util.isString(message.customerSignedIconURL))
                    return "customerSignedIconURL: string expected";
            if (message.customerCatchphrase != null && message.hasOwnProperty("customerCatchphrase"))
                if (!$util.isString(message.customerCatchphrase))
                    return "customerCatchphrase: string expected";
            if (message.customerJobCareerCatchphrase != null && message.hasOwnProperty("customerJobCareerCatchphrase"))
                if (!$util.isString(message.customerJobCareerCatchphrase))
                    return "customerJobCareerCatchphrase: string expected";
            if (message.messageCount != null && message.hasOwnProperty("messageCount"))
                if (!$util.isInteger(message.messageCount) && !(message.messageCount && $util.isInteger(message.messageCount.low) && $util.isInteger(message.messageCount.high)))
                    return "messageCount: integer|Long expected";
            if (message.hasContract != null && message.hasOwnProperty("hasContract"))
                if (typeof message.hasContract !== "boolean")
                    return "hasContract: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates an EntryScoutHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.EntryScoutHistory} EntryScoutHistory
         */
        EntryScoutHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.EntryScoutHistory)
                return object;
            var message = new $root.entity.EntryScoutHistory();
            if (object.id != null)
                message.id = String(object.id);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.isScout != null)
                message.isScout = Boolean(object.isScout);
            if (object.isArchive != null)
                message.isArchive = Boolean(object.isArchive);
            if (object.projectName != null)
                message.projectName = String(object.projectName);
            if (object.customerSignedIconURL != null)
                message.customerSignedIconURL = String(object.customerSignedIconURL);
            if (object.customerCatchphrase != null)
                message.customerCatchphrase = String(object.customerCatchphrase);
            if (object.customerJobCareerCatchphrase != null)
                message.customerJobCareerCatchphrase = String(object.customerJobCareerCatchphrase);
            if (object.messageCount != null)
                if ($util.Long)
                    (message.messageCount = $util.Long.fromValue(object.messageCount)).unsigned = false;
                else if (typeof object.messageCount === "string")
                    message.messageCount = parseInt(object.messageCount, 10);
                else if (typeof object.messageCount === "number")
                    message.messageCount = object.messageCount;
                else if (typeof object.messageCount === "object")
                    message.messageCount = new $util.LongBits(object.messageCount.low >>> 0, object.messageCount.high >>> 0).toNumber();
            if (object.hasContract != null)
                message.hasContract = Boolean(object.hasContract);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from an EntryScoutHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.EntryScoutHistory
         * @static
         * @param {entity.EntryScoutHistory} message EntryScoutHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryScoutHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.projectID = "";
                object.customerID = "";
                object.companyID = "";
                object.isScout = false;
                object.isArchive = false;
                object.projectName = "";
                object.customerSignedIconURL = "";
                object.customerCatchphrase = "";
                object.customerJobCareerCatchphrase = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.messageCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageCount = options.longs === String ? "0" : 0;
                object.hasContract = false;
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.isScout != null && message.hasOwnProperty("isScout"))
                object.isScout = message.isScout;
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                object.isArchive = message.isArchive;
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                object.projectName = message.projectName;
            if (message.customerSignedIconURL != null && message.hasOwnProperty("customerSignedIconURL"))
                object.customerSignedIconURL = message.customerSignedIconURL;
            if (message.customerCatchphrase != null && message.hasOwnProperty("customerCatchphrase"))
                object.customerCatchphrase = message.customerCatchphrase;
            if (message.customerJobCareerCatchphrase != null && message.hasOwnProperty("customerJobCareerCatchphrase"))
                object.customerJobCareerCatchphrase = message.customerJobCareerCatchphrase;
            if (message.messageCount != null && message.hasOwnProperty("messageCount"))
                if (typeof message.messageCount === "number")
                    object.messageCount = options.longs === String ? String(message.messageCount) : message.messageCount;
                else
                    object.messageCount = options.longs === String ? $util.Long.prototype.toString.call(message.messageCount) : options.longs === Number ? new $util.LongBits(message.messageCount.low >>> 0, message.messageCount.high >>> 0).toNumber() : message.messageCount;
            if (message.hasContract != null && message.hasOwnProperty("hasContract"))
                object.hasContract = message.hasContract;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this EntryScoutHistory to JSON.
         * @function toJSON
         * @memberof entity.EntryScoutHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryScoutHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryScoutHistory;
    })();

    entity.EntryScoutHistoryID = (function() {

        /**
         * Properties of an EntryScoutHistoryID.
         * @memberof entity
         * @interface IEntryScoutHistoryID
         * @property {string|null} [id] EntryScoutHistoryID id
         */

        /**
         * Constructs a new EntryScoutHistoryID.
         * @memberof entity
         * @classdesc Represents an EntryScoutHistoryID.
         * @implements IEntryScoutHistoryID
         * @constructor
         * @param {entity.IEntryScoutHistoryID=} [properties] Properties to set
         */
        function EntryScoutHistoryID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryScoutHistoryID id.
         * @member {string} id
         * @memberof entity.EntryScoutHistoryID
         * @instance
         */
        EntryScoutHistoryID.prototype.id = "";

        /**
         * Creates a new EntryScoutHistoryID instance using the specified properties.
         * @function create
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {entity.IEntryScoutHistoryID=} [properties] Properties to set
         * @returns {entity.EntryScoutHistoryID} EntryScoutHistoryID instance
         */
        EntryScoutHistoryID.create = function create(properties) {
            return new EntryScoutHistoryID(properties);
        };

        /**
         * Encodes the specified EntryScoutHistoryID message. Does not implicitly {@link entity.EntryScoutHistoryID.verify|verify} messages.
         * @function encode
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {entity.IEntryScoutHistoryID} message EntryScoutHistoryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified EntryScoutHistoryID message, length delimited. Does not implicitly {@link entity.EntryScoutHistoryID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {entity.IEntryScoutHistoryID} message EntryScoutHistoryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryScoutHistoryID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.EntryScoutHistoryID} EntryScoutHistoryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.EntryScoutHistoryID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryScoutHistoryID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.EntryScoutHistoryID} EntryScoutHistoryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryScoutHistoryID message.
         * @function verify
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryScoutHistoryID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates an EntryScoutHistoryID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.EntryScoutHistoryID} EntryScoutHistoryID
         */
        EntryScoutHistoryID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.EntryScoutHistoryID)
                return object;
            var message = new $root.entity.EntryScoutHistoryID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from an EntryScoutHistoryID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.EntryScoutHistoryID
         * @static
         * @param {entity.EntryScoutHistoryID} message EntryScoutHistoryID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryScoutHistoryID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this EntryScoutHistoryID to JSON.
         * @function toJSON
         * @memberof entity.EntryScoutHistoryID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryScoutHistoryID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryScoutHistoryID;
    })();

    entity.EntryScoutHistoryList = (function() {

        /**
         * Properties of an EntryScoutHistoryList.
         * @memberof entity
         * @interface IEntryScoutHistoryList
         * @property {Array.<entity.IEntryScoutHistory>|null} [items] EntryScoutHistoryList items
         */

        /**
         * Constructs a new EntryScoutHistoryList.
         * @memberof entity
         * @classdesc Represents an EntryScoutHistoryList.
         * @implements IEntryScoutHistoryList
         * @constructor
         * @param {entity.IEntryScoutHistoryList=} [properties] Properties to set
         */
        function EntryScoutHistoryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryScoutHistoryList items.
         * @member {Array.<entity.IEntryScoutHistory>} items
         * @memberof entity.EntryScoutHistoryList
         * @instance
         */
        EntryScoutHistoryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new EntryScoutHistoryList instance using the specified properties.
         * @function create
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {entity.IEntryScoutHistoryList=} [properties] Properties to set
         * @returns {entity.EntryScoutHistoryList} EntryScoutHistoryList instance
         */
        EntryScoutHistoryList.create = function create(properties) {
            return new EntryScoutHistoryList(properties);
        };

        /**
         * Encodes the specified EntryScoutHistoryList message. Does not implicitly {@link entity.EntryScoutHistoryList.verify|verify} messages.
         * @function encode
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {entity.IEntryScoutHistoryList} message EntryScoutHistoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.EntryScoutHistory.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EntryScoutHistoryList message, length delimited. Does not implicitly {@link entity.EntryScoutHistoryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {entity.IEntryScoutHistoryList} message EntryScoutHistoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryScoutHistoryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.EntryScoutHistoryList} EntryScoutHistoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.EntryScoutHistoryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.EntryScoutHistory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryScoutHistoryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.EntryScoutHistoryList} EntryScoutHistoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryScoutHistoryList message.
         * @function verify
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryScoutHistoryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.EntryScoutHistory.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EntryScoutHistoryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.EntryScoutHistoryList} EntryScoutHistoryList
         */
        EntryScoutHistoryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.EntryScoutHistoryList)
                return object;
            var message = new $root.entity.EntryScoutHistoryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.EntryScoutHistoryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.EntryScoutHistoryList.items: object expected");
                    message.items[i] = $root.entity.EntryScoutHistory.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EntryScoutHistoryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.EntryScoutHistoryList
         * @static
         * @param {entity.EntryScoutHistoryList} message EntryScoutHistoryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryScoutHistoryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.EntryScoutHistory.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this EntryScoutHistoryList to JSON.
         * @function toJSON
         * @memberof entity.EntryScoutHistoryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryScoutHistoryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryScoutHistoryList;
    })();

    entity.Entry = (function() {

        /**
         * Properties of an Entry.
         * @memberof entity
         * @interface IEntry
         * @property {string|null} [id] Entry id
         * @property {string|null} [customerID] Entry customerID
         * @property {string|null} [projectID] Entry projectID
         * @property {string|null} [createdAt] Entry createdAt
         * @property {string|null} [companyName] Entry companyName
         * @property {string|null} [customerName] Entry customerName
         * @property {string|null} [projectName] Entry projectName
         */

        /**
         * Constructs a new Entry.
         * @memberof entity
         * @classdesc Represents an Entry.
         * @implements IEntry
         * @constructor
         * @param {entity.IEntry=} [properties] Properties to set
         */
        function Entry(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Entry id.
         * @member {string} id
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.id = "";

        /**
         * Entry customerID.
         * @member {string} customerID
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.customerID = "";

        /**
         * Entry projectID.
         * @member {string} projectID
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.projectID = "";

        /**
         * Entry createdAt.
         * @member {string} createdAt
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.createdAt = "";

        /**
         * Entry companyName.
         * @member {string} companyName
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.companyName = "";

        /**
         * Entry customerName.
         * @member {string} customerName
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.customerName = "";

        /**
         * Entry projectName.
         * @member {string} projectName
         * @memberof entity.Entry
         * @instance
         */
        Entry.prototype.projectName = "";

        /**
         * Creates a new Entry instance using the specified properties.
         * @function create
         * @memberof entity.Entry
         * @static
         * @param {entity.IEntry=} [properties] Properties to set
         * @returns {entity.Entry} Entry instance
         */
        Entry.create = function create(properties) {
            return new Entry(properties);
        };

        /**
         * Encodes the specified Entry message. Does not implicitly {@link entity.Entry.verify|verify} messages.
         * @function encode
         * @memberof entity.Entry
         * @static
         * @param {entity.IEntry} message Entry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Entry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customerID);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.createdAt);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.companyName);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.customerName);
            if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.projectName);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified Entry message, length delimited. Does not implicitly {@link entity.Entry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Entry
         * @static
         * @param {entity.IEntry} message Entry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Entry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Entry message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Entry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Entry} Entry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Entry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Entry();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 9999:
                    message.id = reader.string();
                    break;
                case 1:
                    message.customerID = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.createdAt = reader.string();
                    break;
                case 4:
                    message.companyName = reader.string();
                    break;
                case 5:
                    message.customerName = reader.string();
                    break;
                case 6:
                    message.projectName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Entry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Entry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Entry} Entry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Entry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Entry message.
         * @function verify
         * @memberof entity.Entry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Entry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                if (!$util.isString(message.projectName))
                    return "projectName: string expected";
            return null;
        };

        /**
         * Creates an Entry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Entry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Entry} Entry
         */
        Entry.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Entry)
                return object;
            var message = new $root.entity.Entry();
            if (object.id != null)
                message.id = String(object.id);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.projectName != null)
                message.projectName = String(object.projectName);
            return message;
        };

        /**
         * Creates a plain object from an Entry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Entry
         * @static
         * @param {entity.Entry} message Entry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Entry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.customerID = "";
                object.projectID = "";
                object.createdAt = "";
                object.companyName = "";
                object.customerName = "";
                object.projectName = "";
                object.id = "";
            }
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                object.projectName = message.projectName;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this Entry to JSON.
         * @function toJSON
         * @memberof entity.Entry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Entry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Entry;
    })();

    entity.EntryID = (function() {

        /**
         * Properties of an EntryID.
         * @memberof entity
         * @interface IEntryID
         * @property {string|null} [customerID] EntryID customerID
         * @property {string|null} [projectID] EntryID projectID
         */

        /**
         * Constructs a new EntryID.
         * @memberof entity
         * @classdesc Represents an EntryID.
         * @implements IEntryID
         * @constructor
         * @param {entity.IEntryID=} [properties] Properties to set
         */
        function EntryID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryID customerID.
         * @member {string} customerID
         * @memberof entity.EntryID
         * @instance
         */
        EntryID.prototype.customerID = "";

        /**
         * EntryID projectID.
         * @member {string} projectID
         * @memberof entity.EntryID
         * @instance
         */
        EntryID.prototype.projectID = "";

        /**
         * Creates a new EntryID instance using the specified properties.
         * @function create
         * @memberof entity.EntryID
         * @static
         * @param {entity.IEntryID=} [properties] Properties to set
         * @returns {entity.EntryID} EntryID instance
         */
        EntryID.create = function create(properties) {
            return new EntryID(properties);
        };

        /**
         * Encodes the specified EntryID message. Does not implicitly {@link entity.EntryID.verify|verify} messages.
         * @function encode
         * @memberof entity.EntryID
         * @static
         * @param {entity.IEntryID} message EntryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customerID);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            return writer;
        };

        /**
         * Encodes the specified EntryID message, length delimited. Does not implicitly {@link entity.EntryID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.EntryID
         * @static
         * @param {entity.IEntryID} message EntryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.EntryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.EntryID} EntryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.EntryID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customerID = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.EntryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.EntryID} EntryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryID message.
         * @function verify
         * @memberof entity.EntryID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            return null;
        };

        /**
         * Creates an EntryID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.EntryID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.EntryID} EntryID
         */
        EntryID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.EntryID)
                return object;
            var message = new $root.entity.EntryID();
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            return message;
        };

        /**
         * Creates a plain object from an EntryID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.EntryID
         * @static
         * @param {entity.EntryID} message EntryID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.customerID = "";
                object.projectID = "";
            }
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            return object;
        };

        /**
         * Converts this EntryID to JSON.
         * @function toJSON
         * @memberof entity.EntryID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryID;
    })();

    entity.EntryList = (function() {

        /**
         * Properties of an EntryList.
         * @memberof entity
         * @interface IEntryList
         * @property {Array.<entity.IEntry>|null} [items] EntryList items
         */

        /**
         * Constructs a new EntryList.
         * @memberof entity
         * @classdesc Represents an EntryList.
         * @implements IEntryList
         * @constructor
         * @param {entity.IEntryList=} [properties] Properties to set
         */
        function EntryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryList items.
         * @member {Array.<entity.IEntry>} items
         * @memberof entity.EntryList
         * @instance
         */
        EntryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new EntryList instance using the specified properties.
         * @function create
         * @memberof entity.EntryList
         * @static
         * @param {entity.IEntryList=} [properties] Properties to set
         * @returns {entity.EntryList} EntryList instance
         */
        EntryList.create = function create(properties) {
            return new EntryList(properties);
        };

        /**
         * Encodes the specified EntryList message. Does not implicitly {@link entity.EntryList.verify|verify} messages.
         * @function encode
         * @memberof entity.EntryList
         * @static
         * @param {entity.IEntryList} message EntryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Entry.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EntryList message, length delimited. Does not implicitly {@link entity.EntryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.EntryList
         * @static
         * @param {entity.IEntryList} message EntryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.EntryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.EntryList} EntryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.EntryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Entry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.EntryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.EntryList} EntryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryList message.
         * @function verify
         * @memberof entity.EntryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Entry.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EntryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.EntryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.EntryList} EntryList
         */
        EntryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.EntryList)
                return object;
            var message = new $root.entity.EntryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.EntryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.EntryList.items: object expected");
                    message.items[i] = $root.entity.Entry.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EntryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.EntryList
         * @static
         * @param {entity.EntryList} message EntryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Entry.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this EntryList to JSON.
         * @function toJSON
         * @memberof entity.EntryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryList;
    })();

    entity.JobCareerID = (function() {

        /**
         * Properties of a JobCareerID.
         * @memberof entity
         * @interface IJobCareerID
         * @property {string|null} [id] JobCareerID id
         */

        /**
         * Constructs a new JobCareerID.
         * @memberof entity
         * @classdesc Represents a JobCareerID.
         * @implements IJobCareerID
         * @constructor
         * @param {entity.IJobCareerID=} [properties] Properties to set
         */
        function JobCareerID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCareerID id.
         * @member {string} id
         * @memberof entity.JobCareerID
         * @instance
         */
        JobCareerID.prototype.id = "";

        /**
         * Creates a new JobCareerID instance using the specified properties.
         * @function create
         * @memberof entity.JobCareerID
         * @static
         * @param {entity.IJobCareerID=} [properties] Properties to set
         * @returns {entity.JobCareerID} JobCareerID instance
         */
        JobCareerID.create = function create(properties) {
            return new JobCareerID(properties);
        };

        /**
         * Encodes the specified JobCareerID message. Does not implicitly {@link entity.JobCareerID.verify|verify} messages.
         * @function encode
         * @memberof entity.JobCareerID
         * @static
         * @param {entity.IJobCareerID} message JobCareerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified JobCareerID message, length delimited. Does not implicitly {@link entity.JobCareerID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.JobCareerID
         * @static
         * @param {entity.IJobCareerID} message JobCareerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCareerID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.JobCareerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.JobCareerID} JobCareerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.JobCareerID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JobCareerID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.JobCareerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.JobCareerID} JobCareerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCareerID message.
         * @function verify
         * @memberof entity.JobCareerID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCareerID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a JobCareerID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.JobCareerID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.JobCareerID} JobCareerID
         */
        JobCareerID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.JobCareerID)
                return object;
            var message = new $root.entity.JobCareerID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a JobCareerID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.JobCareerID
         * @static
         * @param {entity.JobCareerID} message JobCareerID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCareerID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this JobCareerID to JSON.
         * @function toJSON
         * @memberof entity.JobCareerID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCareerID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobCareerID;
    })();

    entity.JobCareer = (function() {

        /**
         * Properties of a JobCareer.
         * @memberof entity
         * @interface IJobCareer
         * @property {string|null} [id] JobCareer id
         * @property {string|null} [customerID] JobCareer customerID
         * @property {string|null} [companyName] JobCareer companyName
         * @property {string|null} [description] JobCareer description
         * @property {Array.<entity.Project.Occupation>|null} [occupations] JobCareer occupations
         * @property {number|null} [startedAtYear] JobCareer startedAtYear
         * @property {number|null} [startedAtMonth] JobCareer startedAtMonth
         * @property {number|null} [startedAtDay] JobCareer startedAtDay
         * @property {number|null} [endedAtYear] JobCareer endedAtYear
         * @property {number|null} [endedAtMonth] JobCareer endedAtMonth
         * @property {number|null} [endedAtDay] JobCareer endedAtDay
         * @property {string|null} [post] JobCareer post
         * @property {entity.JobCareer.EmploymentStatus|null} [employmentStatus] JobCareer employmentStatus
         */

        /**
         * Constructs a new JobCareer.
         * @memberof entity
         * @classdesc Represents a JobCareer.
         * @implements IJobCareer
         * @constructor
         * @param {entity.IJobCareer=} [properties] Properties to set
         */
        function JobCareer(properties) {
            this.occupations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCareer id.
         * @member {string} id
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.id = "";

        /**
         * JobCareer customerID.
         * @member {string} customerID
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.customerID = "";

        /**
         * JobCareer companyName.
         * @member {string} companyName
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.companyName = "";

        /**
         * JobCareer description.
         * @member {string} description
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.description = "";

        /**
         * JobCareer occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.occupations = $util.emptyArray;

        /**
         * JobCareer startedAtYear.
         * @member {number} startedAtYear
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.startedAtYear = 0;

        /**
         * JobCareer startedAtMonth.
         * @member {number} startedAtMonth
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.startedAtMonth = 0;

        /**
         * JobCareer startedAtDay.
         * @member {number} startedAtDay
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.startedAtDay = 0;

        /**
         * JobCareer endedAtYear.
         * @member {number} endedAtYear
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.endedAtYear = 0;

        /**
         * JobCareer endedAtMonth.
         * @member {number} endedAtMonth
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.endedAtMonth = 0;

        /**
         * JobCareer endedAtDay.
         * @member {number} endedAtDay
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.endedAtDay = 0;

        /**
         * JobCareer post.
         * @member {string} post
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.post = "";

        /**
         * JobCareer employmentStatus.
         * @member {entity.JobCareer.EmploymentStatus} employmentStatus
         * @memberof entity.JobCareer
         * @instance
         */
        JobCareer.prototype.employmentStatus = 0;

        /**
         * Creates a new JobCareer instance using the specified properties.
         * @function create
         * @memberof entity.JobCareer
         * @static
         * @param {entity.IJobCareer=} [properties] Properties to set
         * @returns {entity.JobCareer} JobCareer instance
         */
        JobCareer.create = function create(properties) {
            return new JobCareer(properties);
        };

        /**
         * Encodes the specified JobCareer message. Does not implicitly {@link entity.JobCareer.verify|verify} messages.
         * @function encode
         * @memberof entity.JobCareer
         * @static
         * @param {entity.IJobCareer} message JobCareer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyName);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.startedAtYear != null && Object.hasOwnProperty.call(message, "startedAtYear"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.startedAtYear);
            if (message.startedAtMonth != null && Object.hasOwnProperty.call(message, "startedAtMonth"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.startedAtMonth);
            if (message.startedAtDay != null && Object.hasOwnProperty.call(message, "startedAtDay"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.startedAtDay);
            if (message.endedAtYear != null && Object.hasOwnProperty.call(message, "endedAtYear"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.endedAtYear);
            if (message.endedAtMonth != null && Object.hasOwnProperty.call(message, "endedAtMonth"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.endedAtMonth);
            if (message.endedAtDay != null && Object.hasOwnProperty.call(message, "endedAtDay"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.endedAtDay);
            if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.post);
            if (message.employmentStatus != null && Object.hasOwnProperty.call(message, "employmentStatus"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.employmentStatus);
            return writer;
        };

        /**
         * Encodes the specified JobCareer message, length delimited. Does not implicitly {@link entity.JobCareer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.JobCareer
         * @static
         * @param {entity.IJobCareer} message JobCareer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCareer message from the specified reader or buffer.
         * @function decode
         * @memberof entity.JobCareer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.JobCareer} JobCareer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.JobCareer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.companyName = reader.string();
                    break;
                case 4:
                    message.description = reader.string();
                    break;
                case 5:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 6:
                    message.startedAtYear = reader.uint32();
                    break;
                case 7:
                    message.startedAtMonth = reader.uint32();
                    break;
                case 8:
                    message.startedAtDay = reader.uint32();
                    break;
                case 9:
                    message.endedAtYear = reader.uint32();
                    break;
                case 10:
                    message.endedAtMonth = reader.uint32();
                    break;
                case 11:
                    message.endedAtDay = reader.uint32();
                    break;
                case 12:
                    message.post = reader.string();
                    break;
                case 13:
                    message.employmentStatus = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JobCareer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.JobCareer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.JobCareer} JobCareer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCareer message.
         * @function verify
         * @memberof entity.JobCareer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCareer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                if (!$util.isInteger(message.startedAtYear))
                    return "startedAtYear: integer expected";
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                if (!$util.isInteger(message.startedAtMonth))
                    return "startedAtMonth: integer expected";
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                if (!$util.isInteger(message.startedAtDay))
                    return "startedAtDay: integer expected";
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                if (!$util.isInteger(message.endedAtYear))
                    return "endedAtYear: integer expected";
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                if (!$util.isInteger(message.endedAtMonth))
                    return "endedAtMonth: integer expected";
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                if (!$util.isInteger(message.endedAtDay))
                    return "endedAtDay: integer expected";
            if (message.post != null && message.hasOwnProperty("post"))
                if (!$util.isString(message.post))
                    return "post: string expected";
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                switch (message.employmentStatus) {
                default:
                    return "employmentStatus: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            return null;
        };

        /**
         * Creates a JobCareer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.JobCareer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.JobCareer} JobCareer
         */
        JobCareer.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.JobCareer)
                return object;
            var message = new $root.entity.JobCareer();
            if (object.id != null)
                message.id = String(object.id);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.description != null)
                message.description = String(object.description);
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".entity.JobCareer.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            if (object.startedAtYear != null)
                message.startedAtYear = object.startedAtYear >>> 0;
            if (object.startedAtMonth != null)
                message.startedAtMonth = object.startedAtMonth >>> 0;
            if (object.startedAtDay != null)
                message.startedAtDay = object.startedAtDay >>> 0;
            if (object.endedAtYear != null)
                message.endedAtYear = object.endedAtYear >>> 0;
            if (object.endedAtMonth != null)
                message.endedAtMonth = object.endedAtMonth >>> 0;
            if (object.endedAtDay != null)
                message.endedAtDay = object.endedAtDay >>> 0;
            if (object.post != null)
                message.post = String(object.post);
            switch (object.employmentStatus) {
            case "EmploymentStatus_Unknown":
            case 0:
                message.employmentStatus = 0;
                break;
            case "EmploymentStatus_FullTime":
            case 1:
                message.employmentStatus = 1;
                break;
            case "EmploymentStatus_Subcontracting":
            case 2:
                message.employmentStatus = 2;
                break;
            case "EmploymentStatus_Other":
            case 3:
                message.employmentStatus = 3;
                break;
            case "EmploymentStatus_BoardMember":
            case 4:
                message.employmentStatus = 4;
                break;
            case "EmploymentStatus_SoleProprietorship":
            case 5:
                message.employmentStatus = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a JobCareer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.JobCareer
         * @static
         * @param {entity.JobCareer} message JobCareer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCareer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.occupations = [];
            if (options.defaults) {
                object.id = "";
                object.customerID = "";
                object.companyName = "";
                object.description = "";
                object.startedAtYear = 0;
                object.startedAtMonth = 0;
                object.startedAtDay = 0;
                object.endedAtYear = 0;
                object.endedAtMonth = 0;
                object.endedAtDay = 0;
                object.post = "";
                object.employmentStatus = options.enums === String ? "EmploymentStatus_Unknown" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                object.startedAtYear = message.startedAtYear;
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                object.startedAtMonth = message.startedAtMonth;
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                object.startedAtDay = message.startedAtDay;
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                object.endedAtYear = message.endedAtYear;
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                object.endedAtMonth = message.endedAtMonth;
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                object.endedAtDay = message.endedAtDay;
            if (message.post != null && message.hasOwnProperty("post"))
                object.post = message.post;
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                object.employmentStatus = options.enums === String ? $root.entity.JobCareer.EmploymentStatus[message.employmentStatus] : message.employmentStatus;
            return object;
        };

        /**
         * Converts this JobCareer to JSON.
         * @function toJSON
         * @memberof entity.JobCareer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCareer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * EmploymentStatus enum.
         * @name entity.JobCareer.EmploymentStatus
         * @enum {number}
         * @property {number} EmploymentStatus_Unknown=0 EmploymentStatus_Unknown value
         * @property {number} EmploymentStatus_FullTime=1 EmploymentStatus_FullTime value
         * @property {number} EmploymentStatus_Subcontracting=2 EmploymentStatus_Subcontracting value
         * @property {number} EmploymentStatus_Other=3 EmploymentStatus_Other value
         * @property {number} EmploymentStatus_BoardMember=4 EmploymentStatus_BoardMember value
         * @property {number} EmploymentStatus_SoleProprietorship=5 EmploymentStatus_SoleProprietorship value
         */
        JobCareer.EmploymentStatus = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EmploymentStatus_Unknown"] = 0;
            values[valuesById[1] = "EmploymentStatus_FullTime"] = 1;
            values[valuesById[2] = "EmploymentStatus_Subcontracting"] = 2;
            values[valuesById[3] = "EmploymentStatus_Other"] = 3;
            values[valuesById[4] = "EmploymentStatus_BoardMember"] = 4;
            values[valuesById[5] = "EmploymentStatus_SoleProprietorship"] = 5;
            return values;
        })();

        return JobCareer;
    })();

    entity.JobCareerList = (function() {

        /**
         * Properties of a JobCareerList.
         * @memberof entity
         * @interface IJobCareerList
         * @property {Array.<entity.IJobCareer>|null} [items] JobCareerList items
         */

        /**
         * Constructs a new JobCareerList.
         * @memberof entity
         * @classdesc Represents a JobCareerList.
         * @implements IJobCareerList
         * @constructor
         * @param {entity.IJobCareerList=} [properties] Properties to set
         */
        function JobCareerList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCareerList items.
         * @member {Array.<entity.IJobCareer>} items
         * @memberof entity.JobCareerList
         * @instance
         */
        JobCareerList.prototype.items = $util.emptyArray;

        /**
         * Creates a new JobCareerList instance using the specified properties.
         * @function create
         * @memberof entity.JobCareerList
         * @static
         * @param {entity.IJobCareerList=} [properties] Properties to set
         * @returns {entity.JobCareerList} JobCareerList instance
         */
        JobCareerList.create = function create(properties) {
            return new JobCareerList(properties);
        };

        /**
         * Encodes the specified JobCareerList message. Does not implicitly {@link entity.JobCareerList.verify|verify} messages.
         * @function encode
         * @memberof entity.JobCareerList
         * @static
         * @param {entity.IJobCareerList} message JobCareerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.JobCareer.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified JobCareerList message, length delimited. Does not implicitly {@link entity.JobCareerList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.JobCareerList
         * @static
         * @param {entity.IJobCareerList} message JobCareerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCareerList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.JobCareerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.JobCareerList} JobCareerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.JobCareerList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.JobCareer.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JobCareerList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.JobCareerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.JobCareerList} JobCareerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCareerList message.
         * @function verify
         * @memberof entity.JobCareerList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCareerList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.JobCareer.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a JobCareerList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.JobCareerList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.JobCareerList} JobCareerList
         */
        JobCareerList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.JobCareerList)
                return object;
            var message = new $root.entity.JobCareerList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.JobCareerList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.JobCareerList.items: object expected");
                    message.items[i] = $root.entity.JobCareer.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a JobCareerList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.JobCareerList
         * @static
         * @param {entity.JobCareerList} message JobCareerList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCareerList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.JobCareer.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this JobCareerList to JSON.
         * @function toJSON
         * @memberof entity.JobCareerList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCareerList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobCareerList;
    })();

    entity.JobCareerWithCustomerID = (function() {

        /**
         * Properties of a JobCareerWithCustomerID.
         * @memberof entity
         * @interface IJobCareerWithCustomerID
         * @property {Array.<entity.IJobCareer>|null} [jobCareers] JobCareerWithCustomerID jobCareers
         * @property {string|null} [customerID] JobCareerWithCustomerID customerID
         */

        /**
         * Constructs a new JobCareerWithCustomerID.
         * @memberof entity
         * @classdesc Represents a JobCareerWithCustomerID.
         * @implements IJobCareerWithCustomerID
         * @constructor
         * @param {entity.IJobCareerWithCustomerID=} [properties] Properties to set
         */
        function JobCareerWithCustomerID(properties) {
            this.jobCareers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCareerWithCustomerID jobCareers.
         * @member {Array.<entity.IJobCareer>} jobCareers
         * @memberof entity.JobCareerWithCustomerID
         * @instance
         */
        JobCareerWithCustomerID.prototype.jobCareers = $util.emptyArray;

        /**
         * JobCareerWithCustomerID customerID.
         * @member {string} customerID
         * @memberof entity.JobCareerWithCustomerID
         * @instance
         */
        JobCareerWithCustomerID.prototype.customerID = "";

        /**
         * Creates a new JobCareerWithCustomerID instance using the specified properties.
         * @function create
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {entity.IJobCareerWithCustomerID=} [properties] Properties to set
         * @returns {entity.JobCareerWithCustomerID} JobCareerWithCustomerID instance
         */
        JobCareerWithCustomerID.create = function create(properties) {
            return new JobCareerWithCustomerID(properties);
        };

        /**
         * Encodes the specified JobCareerWithCustomerID message. Does not implicitly {@link entity.JobCareerWithCustomerID.verify|verify} messages.
         * @function encode
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {entity.IJobCareerWithCustomerID} message JobCareerWithCustomerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerWithCustomerID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.jobCareers != null && message.jobCareers.length)
                for (var i = 0; i < message.jobCareers.length; ++i)
                    $root.entity.JobCareer.encode(message.jobCareers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            return writer;
        };

        /**
         * Encodes the specified JobCareerWithCustomerID message, length delimited. Does not implicitly {@link entity.JobCareerWithCustomerID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {entity.IJobCareerWithCustomerID} message JobCareerWithCustomerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerWithCustomerID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCareerWithCustomerID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.JobCareerWithCustomerID} JobCareerWithCustomerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerWithCustomerID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.JobCareerWithCustomerID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.jobCareers && message.jobCareers.length))
                        message.jobCareers = [];
                    message.jobCareers.push($root.entity.JobCareer.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JobCareerWithCustomerID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.JobCareerWithCustomerID} JobCareerWithCustomerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerWithCustomerID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCareerWithCustomerID message.
         * @function verify
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCareerWithCustomerID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.jobCareers != null && message.hasOwnProperty("jobCareers")) {
                if (!Array.isArray(message.jobCareers))
                    return "jobCareers: array expected";
                for (var i = 0; i < message.jobCareers.length; ++i) {
                    var error = $root.entity.JobCareer.verify(message.jobCareers[i]);
                    if (error)
                        return "jobCareers." + error;
                }
            }
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            return null;
        };

        /**
         * Creates a JobCareerWithCustomerID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.JobCareerWithCustomerID} JobCareerWithCustomerID
         */
        JobCareerWithCustomerID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.JobCareerWithCustomerID)
                return object;
            var message = new $root.entity.JobCareerWithCustomerID();
            if (object.jobCareers) {
                if (!Array.isArray(object.jobCareers))
                    throw TypeError(".entity.JobCareerWithCustomerID.jobCareers: array expected");
                message.jobCareers = [];
                for (var i = 0; i < object.jobCareers.length; ++i) {
                    if (typeof object.jobCareers[i] !== "object")
                        throw TypeError(".entity.JobCareerWithCustomerID.jobCareers: object expected");
                    message.jobCareers[i] = $root.entity.JobCareer.fromObject(object.jobCareers[i]);
                }
            }
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            return message;
        };

        /**
         * Creates a plain object from a JobCareerWithCustomerID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.JobCareerWithCustomerID
         * @static
         * @param {entity.JobCareerWithCustomerID} message JobCareerWithCustomerID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCareerWithCustomerID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.jobCareers = [];
            if (options.defaults)
                object.customerID = "";
            if (message.jobCareers && message.jobCareers.length) {
                object.jobCareers = [];
                for (var j = 0; j < message.jobCareers.length; ++j)
                    object.jobCareers[j] = $root.entity.JobCareer.toObject(message.jobCareers[j], options);
            }
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            return object;
        };

        /**
         * Converts this JobCareerWithCustomerID to JSON.
         * @function toJSON
         * @memberof entity.JobCareerWithCustomerID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCareerWithCustomerID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobCareerWithCustomerID;
    })();

    entity.JobCareerWithCustomerIDList = (function() {

        /**
         * Properties of a JobCareerWithCustomerIDList.
         * @memberof entity
         * @interface IJobCareerWithCustomerIDList
         * @property {Array.<entity.IJobCareerWithCustomerID>|null} [items] JobCareerWithCustomerIDList items
         */

        /**
         * Constructs a new JobCareerWithCustomerIDList.
         * @memberof entity
         * @classdesc Represents a JobCareerWithCustomerIDList.
         * @implements IJobCareerWithCustomerIDList
         * @constructor
         * @param {entity.IJobCareerWithCustomerIDList=} [properties] Properties to set
         */
        function JobCareerWithCustomerIDList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCareerWithCustomerIDList items.
         * @member {Array.<entity.IJobCareerWithCustomerID>} items
         * @memberof entity.JobCareerWithCustomerIDList
         * @instance
         */
        JobCareerWithCustomerIDList.prototype.items = $util.emptyArray;

        /**
         * Creates a new JobCareerWithCustomerIDList instance using the specified properties.
         * @function create
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {entity.IJobCareerWithCustomerIDList=} [properties] Properties to set
         * @returns {entity.JobCareerWithCustomerIDList} JobCareerWithCustomerIDList instance
         */
        JobCareerWithCustomerIDList.create = function create(properties) {
            return new JobCareerWithCustomerIDList(properties);
        };

        /**
         * Encodes the specified JobCareerWithCustomerIDList message. Does not implicitly {@link entity.JobCareerWithCustomerIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {entity.IJobCareerWithCustomerIDList} message JobCareerWithCustomerIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerWithCustomerIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.JobCareerWithCustomerID.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified JobCareerWithCustomerIDList message, length delimited. Does not implicitly {@link entity.JobCareerWithCustomerIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {entity.IJobCareerWithCustomerIDList} message JobCareerWithCustomerIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCareerWithCustomerIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCareerWithCustomerIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.JobCareerWithCustomerIDList} JobCareerWithCustomerIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerWithCustomerIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.JobCareerWithCustomerIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.JobCareerWithCustomerID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JobCareerWithCustomerIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.JobCareerWithCustomerIDList} JobCareerWithCustomerIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCareerWithCustomerIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCareerWithCustomerIDList message.
         * @function verify
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCareerWithCustomerIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.JobCareerWithCustomerID.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a JobCareerWithCustomerIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.JobCareerWithCustomerIDList} JobCareerWithCustomerIDList
         */
        JobCareerWithCustomerIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.JobCareerWithCustomerIDList)
                return object;
            var message = new $root.entity.JobCareerWithCustomerIDList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.JobCareerWithCustomerIDList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.JobCareerWithCustomerIDList.items: object expected");
                    message.items[i] = $root.entity.JobCareerWithCustomerID.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a JobCareerWithCustomerIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.JobCareerWithCustomerIDList
         * @static
         * @param {entity.JobCareerWithCustomerIDList} message JobCareerWithCustomerIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCareerWithCustomerIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.JobCareerWithCustomerID.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this JobCareerWithCustomerIDList to JSON.
         * @function toJSON
         * @memberof entity.JobCareerWithCustomerIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCareerWithCustomerIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobCareerWithCustomerIDList;
    })();

    entity.ProjectID = (function() {

        /**
         * Properties of a ProjectID.
         * @memberof entity
         * @interface IProjectID
         * @property {string|null} [id] ProjectID id
         */

        /**
         * Constructs a new ProjectID.
         * @memberof entity
         * @classdesc Represents a ProjectID.
         * @implements IProjectID
         * @constructor
         * @param {entity.IProjectID=} [properties] Properties to set
         */
        function ProjectID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProjectID id.
         * @member {string} id
         * @memberof entity.ProjectID
         * @instance
         */
        ProjectID.prototype.id = "";

        /**
         * Creates a new ProjectID instance using the specified properties.
         * @function create
         * @memberof entity.ProjectID
         * @static
         * @param {entity.IProjectID=} [properties] Properties to set
         * @returns {entity.ProjectID} ProjectID instance
         */
        ProjectID.create = function create(properties) {
            return new ProjectID(properties);
        };

        /**
         * Encodes the specified ProjectID message. Does not implicitly {@link entity.ProjectID.verify|verify} messages.
         * @function encode
         * @memberof entity.ProjectID
         * @static
         * @param {entity.IProjectID} message ProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ProjectID message, length delimited. Does not implicitly {@link entity.ProjectID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ProjectID
         * @static
         * @param {entity.IProjectID} message ProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProjectID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ProjectID} ProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ProjectID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProjectID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ProjectID} ProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProjectID message.
         * @function verify
         * @memberof entity.ProjectID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProjectID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ProjectID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ProjectID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ProjectID} ProjectID
         */
        ProjectID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ProjectID)
                return object;
            var message = new $root.entity.ProjectID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ProjectID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ProjectID
         * @static
         * @param {entity.ProjectID} message ProjectID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProjectID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ProjectID to JSON.
         * @function toJSON
         * @memberof entity.ProjectID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProjectID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProjectID;
    })();

    entity.ProjectIDList = (function() {

        /**
         * Properties of a ProjectIDList.
         * @memberof entity
         * @interface IProjectIDList
         * @property {Array.<string>|null} [ids] ProjectIDList ids
         */

        /**
         * Constructs a new ProjectIDList.
         * @memberof entity
         * @classdesc Represents a ProjectIDList.
         * @implements IProjectIDList
         * @constructor
         * @param {entity.IProjectIDList=} [properties] Properties to set
         */
        function ProjectIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProjectIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.ProjectIDList
         * @instance
         */
        ProjectIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new ProjectIDList instance using the specified properties.
         * @function create
         * @memberof entity.ProjectIDList
         * @static
         * @param {entity.IProjectIDList=} [properties] Properties to set
         * @returns {entity.ProjectIDList} ProjectIDList instance
         */
        ProjectIDList.create = function create(properties) {
            return new ProjectIDList(properties);
        };

        /**
         * Encodes the specified ProjectIDList message. Does not implicitly {@link entity.ProjectIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.ProjectIDList
         * @static
         * @param {entity.IProjectIDList} message ProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified ProjectIDList message, length delimited. Does not implicitly {@link entity.ProjectIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ProjectIDList
         * @static
         * @param {entity.IProjectIDList} message ProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProjectIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ProjectIDList} ProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ProjectIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProjectIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ProjectIDList} ProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProjectIDList message.
         * @function verify
         * @memberof entity.ProjectIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProjectIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ProjectIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ProjectIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ProjectIDList} ProjectIDList
         */
        ProjectIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ProjectIDList)
                return object;
            var message = new $root.entity.ProjectIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.ProjectIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ProjectIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ProjectIDList
         * @static
         * @param {entity.ProjectIDList} message ProjectIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProjectIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this ProjectIDList to JSON.
         * @function toJSON
         * @memberof entity.ProjectIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProjectIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProjectIDList;
    })();

    entity.ProjectIDWithPager = (function() {

        /**
         * Properties of a ProjectIDWithPager.
         * @memberof entity
         * @interface IProjectIDWithPager
         * @property {string|null} [id] ProjectIDWithPager id
         * @property {common.IPager|null} [pager] ProjectIDWithPager pager
         */

        /**
         * Constructs a new ProjectIDWithPager.
         * @memberof entity
         * @classdesc Represents a ProjectIDWithPager.
         * @implements IProjectIDWithPager
         * @constructor
         * @param {entity.IProjectIDWithPager=} [properties] Properties to set
         */
        function ProjectIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProjectIDWithPager id.
         * @member {string} id
         * @memberof entity.ProjectIDWithPager
         * @instance
         */
        ProjectIDWithPager.prototype.id = "";

        /**
         * ProjectIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.ProjectIDWithPager
         * @instance
         */
        ProjectIDWithPager.prototype.pager = null;

        /**
         * Creates a new ProjectIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {entity.IProjectIDWithPager=} [properties] Properties to set
         * @returns {entity.ProjectIDWithPager} ProjectIDWithPager instance
         */
        ProjectIDWithPager.create = function create(properties) {
            return new ProjectIDWithPager(properties);
        };

        /**
         * Encodes the specified ProjectIDWithPager message. Does not implicitly {@link entity.ProjectIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {entity.IProjectIDWithPager} message ProjectIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ProjectIDWithPager message, length delimited. Does not implicitly {@link entity.ProjectIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {entity.IProjectIDWithPager} message ProjectIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProjectIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ProjectIDWithPager} ProjectIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ProjectIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProjectIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ProjectIDWithPager} ProjectIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProjectIDWithPager message.
         * @function verify
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProjectIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            return null;
        };

        /**
         * Creates a ProjectIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ProjectIDWithPager} ProjectIDWithPager
         */
        ProjectIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ProjectIDWithPager)
                return object;
            var message = new $root.entity.ProjectIDWithPager();
            if (object.id != null)
                message.id = String(object.id);
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.ProjectIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            return message;
        };

        /**
         * Creates a plain object from a ProjectIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ProjectIDWithPager
         * @static
         * @param {entity.ProjectIDWithPager} message ProjectIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProjectIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.pager = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            return object;
        };

        /**
         * Converts this ProjectIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.ProjectIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProjectIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProjectIDWithPager;
    })();

    entity.Project = (function() {

        /**
         * Properties of a Project.
         * @memberof entity
         * @interface IProject
         * @property {string|null} [id] Project id
         * @property {string|null} [companyID] Project companyID
         * @property {string|null} [name] Project name
         * @property {string|null} [description] Project description
         * @property {string|null} [background] Project background
         * @property {string|null} [preferentialExperience] Project preferentialExperience
         * @property {string|null} [gsThumbnailURL] Project gsThumbnailURL
         * @property {string|null} [signedThumbnailURL] Project signedThumbnailURL
         * @property {entity.Project.Place|null} [place] Project place
         * @property {entity.Project.WorkingHourRange|null} [workingHourRange] Project workingHourRange
         * @property {entity.Project.PaymentRange|null} [paymentRange] Project paymentRange
         * @property {entity.Project.WorkingDuration|null} [workingDuration] Project workingDuration
         * @property {Array.<entity.Project.Occupation>|null} [occupations] Project occupations
         * @property {entity.Project.Status|null} [status] Project status
         * @property {string|null} [operatingDate] Project operatingDate
         * @property {boolean|null} [isHideCompany] Project isHideCompany
         * @property {string|null} [createdAt] Project createdAt
         * @property {Array.<entity.ISearchHighlight>|null} [highlights] Project highlights
         * @property {boolean|null} [shouldShowByContract] Project shouldShowByContract
         * @property {boolean|null} [shouldShowByScout] Project shouldShowByScout
         * @property {number|Long|null} [messageRoomNum] Project messageRoomNum
         */

        /**
         * Constructs a new Project.
         * @memberof entity
         * @classdesc Represents a Project.
         * @implements IProject
         * @constructor
         * @param {entity.IProject=} [properties] Properties to set
         */
        function Project(properties) {
            this.occupations = [];
            this.highlights = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Project id.
         * @member {string} id
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.id = "";

        /**
         * Project companyID.
         * @member {string} companyID
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.companyID = "";

        /**
         * Project name.
         * @member {string} name
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.name = "";

        /**
         * Project description.
         * @member {string} description
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.description = "";

        /**
         * Project background.
         * @member {string} background
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.background = "";

        /**
         * Project preferentialExperience.
         * @member {string} preferentialExperience
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.preferentialExperience = "";

        /**
         * Project gsThumbnailURL.
         * @member {string} gsThumbnailURL
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.gsThumbnailURL = "";

        /**
         * Project signedThumbnailURL.
         * @member {string} signedThumbnailURL
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.signedThumbnailURL = "";

        /**
         * Project place.
         * @member {entity.Project.Place} place
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.place = 0;

        /**
         * Project workingHourRange.
         * @member {entity.Project.WorkingHourRange} workingHourRange
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.workingHourRange = 0;

        /**
         * Project paymentRange.
         * @member {entity.Project.PaymentRange} paymentRange
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.paymentRange = 0;

        /**
         * Project workingDuration.
         * @member {entity.Project.WorkingDuration} workingDuration
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.workingDuration = 0;

        /**
         * Project occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.occupations = $util.emptyArray;

        /**
         * Project status.
         * @member {entity.Project.Status} status
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.status = 0;

        /**
         * Project operatingDate.
         * @member {string} operatingDate
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.operatingDate = "";

        /**
         * Project isHideCompany.
         * @member {boolean} isHideCompany
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.isHideCompany = false;

        /**
         * Project createdAt.
         * @member {string} createdAt
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.createdAt = "";

        /**
         * Project highlights.
         * @member {Array.<entity.ISearchHighlight>} highlights
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.highlights = $util.emptyArray;

        /**
         * Project shouldShowByContract.
         * @member {boolean} shouldShowByContract
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.shouldShowByContract = false;

        /**
         * Project shouldShowByScout.
         * @member {boolean} shouldShowByScout
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.shouldShowByScout = false;

        /**
         * Project messageRoomNum.
         * @member {number|Long} messageRoomNum
         * @memberof entity.Project
         * @instance
         */
        Project.prototype.messageRoomNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Project instance using the specified properties.
         * @function create
         * @memberof entity.Project
         * @static
         * @param {entity.IProject=} [properties] Properties to set
         * @returns {entity.Project} Project instance
         */
        Project.create = function create(properties) {
            return new Project(properties);
        };

        /**
         * Encodes the specified Project message. Does not implicitly {@link entity.Project.verify|verify} messages.
         * @function encode
         * @memberof entity.Project
         * @static
         * @param {entity.IProject} message Project message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Project.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyID);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
            if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.background);
            if (message.preferentialExperience != null && Object.hasOwnProperty.call(message, "preferentialExperience"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.preferentialExperience);
            if (message.gsThumbnailURL != null && Object.hasOwnProperty.call(message, "gsThumbnailURL"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.gsThumbnailURL);
            if (message.signedThumbnailURL != null && Object.hasOwnProperty.call(message, "signedThumbnailURL"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.signedThumbnailURL);
            if (message.place != null && Object.hasOwnProperty.call(message, "place"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.place);
            if (message.workingHourRange != null && Object.hasOwnProperty.call(message, "workingHourRange"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workingHourRange);
            if (message.paymentRange != null && Object.hasOwnProperty.call(message, "paymentRange"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.paymentRange);
            if (message.workingDuration != null && Object.hasOwnProperty.call(message, "workingDuration"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.workingDuration);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 13, wireType 2 =*/106).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.status);
            if (message.operatingDate != null && Object.hasOwnProperty.call(message, "operatingDate"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.operatingDate);
            if (message.isHideCompany != null && Object.hasOwnProperty.call(message, "isHideCompany"))
                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.isHideCompany);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.createdAt);
            if (message.highlights != null && message.highlights.length)
                for (var i = 0; i < message.highlights.length; ++i)
                    $root.entity.SearchHighlight.encode(message.highlights[i], writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.shouldShowByContract != null && Object.hasOwnProperty.call(message, "shouldShowByContract"))
                writer.uint32(/* id 19, wireType 0 =*/152).bool(message.shouldShowByContract);
            if (message.shouldShowByScout != null && Object.hasOwnProperty.call(message, "shouldShowByScout"))
                writer.uint32(/* id 20, wireType 0 =*/160).bool(message.shouldShowByScout);
            if (message.messageRoomNum != null && Object.hasOwnProperty.call(message, "messageRoomNum"))
                writer.uint32(/* id 21, wireType 0 =*/168).int64(message.messageRoomNum);
            return writer;
        };

        /**
         * Encodes the specified Project message, length delimited. Does not implicitly {@link entity.Project.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Project
         * @static
         * @param {entity.IProject} message Project message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Project.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Project message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Project
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Project} Project
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Project.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Project();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyID = reader.string();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                case 4:
                    message.description = reader.string();
                    break;
                case 5:
                    message.background = reader.string();
                    break;
                case 6:
                    message.preferentialExperience = reader.string();
                    break;
                case 7:
                    message.gsThumbnailURL = reader.string();
                    break;
                case 8:
                    message.signedThumbnailURL = reader.string();
                    break;
                case 9:
                    message.place = reader.int32();
                    break;
                case 10:
                    message.workingHourRange = reader.int32();
                    break;
                case 11:
                    message.paymentRange = reader.int32();
                    break;
                case 12:
                    message.workingDuration = reader.int32();
                    break;
                case 13:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 14:
                    message.status = reader.int32();
                    break;
                case 15:
                    message.operatingDate = reader.string();
                    break;
                case 16:
                    message.isHideCompany = reader.bool();
                    break;
                case 17:
                    message.createdAt = reader.string();
                    break;
                case 18:
                    if (!(message.highlights && message.highlights.length))
                        message.highlights = [];
                    message.highlights.push($root.entity.SearchHighlight.decode(reader, reader.uint32()));
                    break;
                case 19:
                    message.shouldShowByContract = reader.bool();
                    break;
                case 20:
                    message.shouldShowByScout = reader.bool();
                    break;
                case 21:
                    message.messageRoomNum = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Project message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Project
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Project} Project
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Project.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Project message.
         * @function verify
         * @memberof entity.Project
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Project.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.background != null && message.hasOwnProperty("background"))
                if (!$util.isString(message.background))
                    return "background: string expected";
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                if (!$util.isString(message.preferentialExperience))
                    return "preferentialExperience: string expected";
            if (message.gsThumbnailURL != null && message.hasOwnProperty("gsThumbnailURL"))
                if (!$util.isString(message.gsThumbnailURL))
                    return "gsThumbnailURL: string expected";
            if (message.signedThumbnailURL != null && message.hasOwnProperty("signedThumbnailURL"))
                if (!$util.isString(message.signedThumbnailURL))
                    return "signedThumbnailURL: string expected";
            if (message.place != null && message.hasOwnProperty("place"))
                switch (message.place) {
                default:
                    return "place: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                switch (message.workingHourRange) {
                default:
                    return "workingHourRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                switch (message.paymentRange) {
                default:
                    return "paymentRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                switch (message.workingDuration) {
                default:
                    return "workingDuration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                if (!$util.isString(message.operatingDate))
                    return "operatingDate: string expected";
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                if (typeof message.isHideCompany !== "boolean")
                    return "isHideCompany: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.highlights != null && message.hasOwnProperty("highlights")) {
                if (!Array.isArray(message.highlights))
                    return "highlights: array expected";
                for (var i = 0; i < message.highlights.length; ++i) {
                    var error = $root.entity.SearchHighlight.verify(message.highlights[i]);
                    if (error)
                        return "highlights." + error;
                }
            }
            if (message.shouldShowByContract != null && message.hasOwnProperty("shouldShowByContract"))
                if (typeof message.shouldShowByContract !== "boolean")
                    return "shouldShowByContract: boolean expected";
            if (message.shouldShowByScout != null && message.hasOwnProperty("shouldShowByScout"))
                if (typeof message.shouldShowByScout !== "boolean")
                    return "shouldShowByScout: boolean expected";
            if (message.messageRoomNum != null && message.hasOwnProperty("messageRoomNum"))
                if (!$util.isInteger(message.messageRoomNum) && !(message.messageRoomNum && $util.isInteger(message.messageRoomNum.low) && $util.isInteger(message.messageRoomNum.high)))
                    return "messageRoomNum: integer|Long expected";
            return null;
        };

        /**
         * Creates a Project message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Project
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Project} Project
         */
        Project.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Project)
                return object;
            var message = new $root.entity.Project();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.background != null)
                message.background = String(object.background);
            if (object.preferentialExperience != null)
                message.preferentialExperience = String(object.preferentialExperience);
            if (object.gsThumbnailURL != null)
                message.gsThumbnailURL = String(object.gsThumbnailURL);
            if (object.signedThumbnailURL != null)
                message.signedThumbnailURL = String(object.signedThumbnailURL);
            switch (object.place) {
            case "Place_Unknown":
            case 0:
                message.place = 0;
                break;
            case "Place_InHouse":
            case 1:
                message.place = 1;
                break;
            case "Place_Remote":
            case 2:
                message.place = 2;
                break;
            case "Place_Other":
            case 3:
                message.place = 3;
                break;
            }
            switch (object.workingHourRange) {
            case "WorkingHourRange_Unknown":
            case 0:
                message.workingHourRange = 0;
                break;
            case "WorkingHourRange_20_40_Hour":
            case 1:
                message.workingHourRange = 1;
                break;
            case "WorkingHourRange_40_80_Hour":
            case 2:
                message.workingHourRange = 2;
                break;
            case "WorkingHourRange_80_120_Hour":
            case 3:
                message.workingHourRange = 3;
                break;
            case "WorkingHourRange_Over_120_Hour":
            case 4:
                message.workingHourRange = 4;
                break;
            case "WorkingHourRange_Other":
            case 5:
                message.workingHourRange = 5;
                break;
            }
            switch (object.paymentRange) {
            case "PaymentRange_Unknown":
            case 0:
                message.paymentRange = 0;
                break;
            case "PaymentRange_Under_100000_Yen":
            case 1:
                message.paymentRange = 1;
                break;
            case "PaymentRange_100000_300000_Yen":
            case 2:
                message.paymentRange = 2;
                break;
            case "PaymentRange_300000_500000_Yen":
            case 3:
                message.paymentRange = 3;
                break;
            case "PaymentRange_500000_1000000_Yen":
            case 4:
                message.paymentRange = 4;
                break;
            case "PaymentRange_Over_1000000_Yen":
            case 5:
                message.paymentRange = 5;
                break;
            }
            switch (object.workingDuration) {
            case "WorkingDuration_Unknown":
            case 0:
                message.workingDuration = 0;
                break;
            case "WorkingDuration_Under_1_Month":
            case 1:
                message.workingDuration = 1;
                break;
            case "WorkingDuration_1_3_Month":
            case 2:
                message.workingDuration = 2;
                break;
            case "WorkingDuration_3_6_Month":
            case 3:
                message.workingDuration = 3;
                break;
            case "WorkingDuration_6_12_Month":
            case 4:
                message.workingDuration = 4;
                break;
            case "WorkingDuration_Over_12_Month":
            case 5:
                message.workingDuration = 5;
                break;
            }
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".entity.Project.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Open":
            case 1:
                message.status = 1;
                break;
            case "Status_Draft":
            case 2:
                message.status = 2;
                break;
            case "Status_Close":
            case 3:
                message.status = 3;
                break;
            case "Status_Contracted":
            case 4:
                message.status = 4;
                break;
            case "Status_OnlyScout":
            case 5:
                message.status = 5;
                break;
            }
            if (object.operatingDate != null)
                message.operatingDate = String(object.operatingDate);
            if (object.isHideCompany != null)
                message.isHideCompany = Boolean(object.isHideCompany);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.highlights) {
                if (!Array.isArray(object.highlights))
                    throw TypeError(".entity.Project.highlights: array expected");
                message.highlights = [];
                for (var i = 0; i < object.highlights.length; ++i) {
                    if (typeof object.highlights[i] !== "object")
                        throw TypeError(".entity.Project.highlights: object expected");
                    message.highlights[i] = $root.entity.SearchHighlight.fromObject(object.highlights[i]);
                }
            }
            if (object.shouldShowByContract != null)
                message.shouldShowByContract = Boolean(object.shouldShowByContract);
            if (object.shouldShowByScout != null)
                message.shouldShowByScout = Boolean(object.shouldShowByScout);
            if (object.messageRoomNum != null)
                if ($util.Long)
                    (message.messageRoomNum = $util.Long.fromValue(object.messageRoomNum)).unsigned = false;
                else if (typeof object.messageRoomNum === "string")
                    message.messageRoomNum = parseInt(object.messageRoomNum, 10);
                else if (typeof object.messageRoomNum === "number")
                    message.messageRoomNum = object.messageRoomNum;
                else if (typeof object.messageRoomNum === "object")
                    message.messageRoomNum = new $util.LongBits(object.messageRoomNum.low >>> 0, object.messageRoomNum.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Project message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Project
         * @static
         * @param {entity.Project} message Project
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Project.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.occupations = [];
                object.highlights = [];
            }
            if (options.defaults) {
                object.id = "";
                object.companyID = "";
                object.name = "";
                object.description = "";
                object.background = "";
                object.preferentialExperience = "";
                object.gsThumbnailURL = "";
                object.signedThumbnailURL = "";
                object.place = options.enums === String ? "Place_Unknown" : 0;
                object.workingHourRange = options.enums === String ? "WorkingHourRange_Unknown" : 0;
                object.paymentRange = options.enums === String ? "PaymentRange_Unknown" : 0;
                object.workingDuration = options.enums === String ? "WorkingDuration_Unknown" : 0;
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.operatingDate = "";
                object.isHideCompany = false;
                object.createdAt = "";
                object.shouldShowByContract = false;
                object.shouldShowByScout = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.messageRoomNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageRoomNum = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.background != null && message.hasOwnProperty("background"))
                object.background = message.background;
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                object.preferentialExperience = message.preferentialExperience;
            if (message.gsThumbnailURL != null && message.hasOwnProperty("gsThumbnailURL"))
                object.gsThumbnailURL = message.gsThumbnailURL;
            if (message.signedThumbnailURL != null && message.hasOwnProperty("signedThumbnailURL"))
                object.signedThumbnailURL = message.signedThumbnailURL;
            if (message.place != null && message.hasOwnProperty("place"))
                object.place = options.enums === String ? $root.entity.Project.Place[message.place] : message.place;
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                object.workingHourRange = options.enums === String ? $root.entity.Project.WorkingHourRange[message.workingHourRange] : message.workingHourRange;
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                object.paymentRange = options.enums === String ? $root.entity.Project.PaymentRange[message.paymentRange] : message.paymentRange;
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                object.workingDuration = options.enums === String ? $root.entity.Project.WorkingDuration[message.workingDuration] : message.workingDuration;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.Project.Status[message.status] : message.status;
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                object.operatingDate = message.operatingDate;
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                object.isHideCompany = message.isHideCompany;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.highlights && message.highlights.length) {
                object.highlights = [];
                for (var j = 0; j < message.highlights.length; ++j)
                    object.highlights[j] = $root.entity.SearchHighlight.toObject(message.highlights[j], options);
            }
            if (message.shouldShowByContract != null && message.hasOwnProperty("shouldShowByContract"))
                object.shouldShowByContract = message.shouldShowByContract;
            if (message.shouldShowByScout != null && message.hasOwnProperty("shouldShowByScout"))
                object.shouldShowByScout = message.shouldShowByScout;
            if (message.messageRoomNum != null && message.hasOwnProperty("messageRoomNum"))
                if (typeof message.messageRoomNum === "number")
                    object.messageRoomNum = options.longs === String ? String(message.messageRoomNum) : message.messageRoomNum;
                else
                    object.messageRoomNum = options.longs === String ? $util.Long.prototype.toString.call(message.messageRoomNum) : options.longs === Number ? new $util.LongBits(message.messageRoomNum.low >>> 0, message.messageRoomNum.high >>> 0).toNumber() : message.messageRoomNum;
            return object;
        };

        /**
         * Converts this Project to JSON.
         * @function toJSON
         * @memberof entity.Project
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Project.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Place enum.
         * @name entity.Project.Place
         * @enum {number}
         * @property {number} Place_Unknown=0 Place_Unknown value
         * @property {number} Place_InHouse=1 Place_InHouse value
         * @property {number} Place_Remote=2 Place_Remote value
         * @property {number} Place_Other=3 Place_Other value
         */
        Project.Place = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Place_Unknown"] = 0;
            values[valuesById[1] = "Place_InHouse"] = 1;
            values[valuesById[2] = "Place_Remote"] = 2;
            values[valuesById[3] = "Place_Other"] = 3;
            return values;
        })();

        /**
         * Occupation enum.
         * @name entity.Project.Occupation
         * @enum {number}
         * @property {number} Occupation_Unknown=0 Occupation_Unknown value
         * @property {number} Occupation_CorporateBusinessPlanning=1 Occupation_CorporateBusinessPlanning value
         * @property {number} Occupation_BusinessDevelopment=2 Occupation_BusinessDevelopment value
         * @property {number} Occupation_Sales=3 Occupation_Sales value
         * @property {number} Occupation_PublicRelations=4 Occupation_PublicRelations value
         * @property {number} Occupation_IPO=5 Occupation_IPO value
         * @property {number} Occupation_WebMarketing=6 Occupation_WebMarketing value
         * @property {number} Occupation_HumanResource=7 Occupation_HumanResource value
         * @property {number} Occupation_HumanResource_Deprecate_1=8 Occupation_HumanResource_Deprecate_1 value
         * @property {number} Occupation_HumanResource_Deprecate_2=9 Occupation_HumanResource_Deprecate_2 value
         * @property {number} Occupation_HumanResource_Deprecate_3=10 Occupation_HumanResource_Deprecate_3 value
         * @property {number} Occupation_IPO_Deprecate_1=11 Occupation_IPO_Deprecate_1 value
         * @property {number} Occupation_Finance=12 Occupation_Finance value
         * @property {number} Occupation_Finance_Deprecate_1=13 Occupation_Finance_Deprecate_1 value
         * @property {number} Occupation_Finance_Deprecate_2=14 Occupation_Finance_Deprecate_2 value
         * @property {number} Occupation_MinistryOfJustice=15 Occupation_MinistryOfJustice value
         * @property {number} Occupation_Engineer=16 Occupation_Engineer value
         * @property {number} Occupation_Designer=17 Occupation_Designer value
         * @property {number} Occupation_Other=18 Occupation_Other value
         * @property {number} Occupation_InformationSystem=19 Occupation_InformationSystem value
         * @property {number} Occupation_Professor=20 Occupation_Professor value
         * @property {number} Occupation_Marketing=21 Occupation_Marketing value
         */
        Project.Occupation = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Occupation_Unknown"] = 0;
            values[valuesById[1] = "Occupation_CorporateBusinessPlanning"] = 1;
            values[valuesById[2] = "Occupation_BusinessDevelopment"] = 2;
            values[valuesById[3] = "Occupation_Sales"] = 3;
            values[valuesById[4] = "Occupation_PublicRelations"] = 4;
            values[valuesById[5] = "Occupation_IPO"] = 5;
            values[valuesById[6] = "Occupation_WebMarketing"] = 6;
            values[valuesById[7] = "Occupation_HumanResource"] = 7;
            values[valuesById[8] = "Occupation_HumanResource_Deprecate_1"] = 8;
            values[valuesById[9] = "Occupation_HumanResource_Deprecate_2"] = 9;
            values[valuesById[10] = "Occupation_HumanResource_Deprecate_3"] = 10;
            values[valuesById[11] = "Occupation_IPO_Deprecate_1"] = 11;
            values[valuesById[12] = "Occupation_Finance"] = 12;
            values[valuesById[13] = "Occupation_Finance_Deprecate_1"] = 13;
            values[valuesById[14] = "Occupation_Finance_Deprecate_2"] = 14;
            values[valuesById[15] = "Occupation_MinistryOfJustice"] = 15;
            values[valuesById[16] = "Occupation_Engineer"] = 16;
            values[valuesById[17] = "Occupation_Designer"] = 17;
            values[valuesById[18] = "Occupation_Other"] = 18;
            values[valuesById[19] = "Occupation_InformationSystem"] = 19;
            values[valuesById[20] = "Occupation_Professor"] = 20;
            values[valuesById[21] = "Occupation_Marketing"] = 21;
            return values;
        })();

        /**
         * WorkingHourRange enum.
         * @name entity.Project.WorkingHourRange
         * @enum {number}
         * @property {number} WorkingHourRange_Unknown=0 WorkingHourRange_Unknown value
         * @property {number} WorkingHourRange_20_40_Hour=1 WorkingHourRange_20_40_Hour value
         * @property {number} WorkingHourRange_40_80_Hour=2 WorkingHourRange_40_80_Hour value
         * @property {number} WorkingHourRange_80_120_Hour=3 WorkingHourRange_80_120_Hour value
         * @property {number} WorkingHourRange_Over_120_Hour=4 WorkingHourRange_Over_120_Hour value
         * @property {number} WorkingHourRange_Other=5 WorkingHourRange_Other value
         */
        Project.WorkingHourRange = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkingHourRange_Unknown"] = 0;
            values[valuesById[1] = "WorkingHourRange_20_40_Hour"] = 1;
            values[valuesById[2] = "WorkingHourRange_40_80_Hour"] = 2;
            values[valuesById[3] = "WorkingHourRange_80_120_Hour"] = 3;
            values[valuesById[4] = "WorkingHourRange_Over_120_Hour"] = 4;
            values[valuesById[5] = "WorkingHourRange_Other"] = 5;
            return values;
        })();

        /**
         * PaymentRange enum.
         * @name entity.Project.PaymentRange
         * @enum {number}
         * @property {number} PaymentRange_Unknown=0 PaymentRange_Unknown value
         * @property {number} PaymentRange_Under_100000_Yen=1 PaymentRange_Under_100000_Yen value
         * @property {number} PaymentRange_100000_300000_Yen=2 PaymentRange_100000_300000_Yen value
         * @property {number} PaymentRange_300000_500000_Yen=3 PaymentRange_300000_500000_Yen value
         * @property {number} PaymentRange_500000_1000000_Yen=4 PaymentRange_500000_1000000_Yen value
         * @property {number} PaymentRange_Over_1000000_Yen=5 PaymentRange_Over_1000000_Yen value
         */
        Project.PaymentRange = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PaymentRange_Unknown"] = 0;
            values[valuesById[1] = "PaymentRange_Under_100000_Yen"] = 1;
            values[valuesById[2] = "PaymentRange_100000_300000_Yen"] = 2;
            values[valuesById[3] = "PaymentRange_300000_500000_Yen"] = 3;
            values[valuesById[4] = "PaymentRange_500000_1000000_Yen"] = 4;
            values[valuesById[5] = "PaymentRange_Over_1000000_Yen"] = 5;
            return values;
        })();

        /**
         * WorkingDuration enum.
         * @name entity.Project.WorkingDuration
         * @enum {number}
         * @property {number} WorkingDuration_Unknown=0 WorkingDuration_Unknown value
         * @property {number} WorkingDuration_Under_1_Month=1 WorkingDuration_Under_1_Month value
         * @property {number} WorkingDuration_1_3_Month=2 WorkingDuration_1_3_Month value
         * @property {number} WorkingDuration_3_6_Month=3 WorkingDuration_3_6_Month value
         * @property {number} WorkingDuration_6_12_Month=4 WorkingDuration_6_12_Month value
         * @property {number} WorkingDuration_Over_12_Month=5 WorkingDuration_Over_12_Month value
         */
        Project.WorkingDuration = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkingDuration_Unknown"] = 0;
            values[valuesById[1] = "WorkingDuration_Under_1_Month"] = 1;
            values[valuesById[2] = "WorkingDuration_1_3_Month"] = 2;
            values[valuesById[3] = "WorkingDuration_3_6_Month"] = 3;
            values[valuesById[4] = "WorkingDuration_6_12_Month"] = 4;
            values[valuesById[5] = "WorkingDuration_Over_12_Month"] = 5;
            return values;
        })();

        /**
         * Status enum.
         * @name entity.Project.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_Open=1 Status_Open value
         * @property {number} Status_Draft=2 Status_Draft value
         * @property {number} Status_Close=3 Status_Close value
         * @property {number} Status_Contracted=4 Status_Contracted value
         * @property {number} Status_OnlyScout=5 Status_OnlyScout value
         */
        Project.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_Open"] = 1;
            values[valuesById[2] = "Status_Draft"] = 2;
            values[valuesById[3] = "Status_Close"] = 3;
            values[valuesById[4] = "Status_Contracted"] = 4;
            values[valuesById[5] = "Status_OnlyScout"] = 5;
            return values;
        })();

        return Project;
    })();

    entity.ProjectList = (function() {

        /**
         * Properties of a ProjectList.
         * @memberof entity
         * @interface IProjectList
         * @property {Array.<entity.IProject>|null} [items] ProjectList items
         */

        /**
         * Constructs a new ProjectList.
         * @memberof entity
         * @classdesc Represents a ProjectList.
         * @implements IProjectList
         * @constructor
         * @param {entity.IProjectList=} [properties] Properties to set
         */
        function ProjectList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProjectList items.
         * @member {Array.<entity.IProject>} items
         * @memberof entity.ProjectList
         * @instance
         */
        ProjectList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ProjectList instance using the specified properties.
         * @function create
         * @memberof entity.ProjectList
         * @static
         * @param {entity.IProjectList=} [properties] Properties to set
         * @returns {entity.ProjectList} ProjectList instance
         */
        ProjectList.create = function create(properties) {
            return new ProjectList(properties);
        };

        /**
         * Encodes the specified ProjectList message. Does not implicitly {@link entity.ProjectList.verify|verify} messages.
         * @function encode
         * @memberof entity.ProjectList
         * @static
         * @param {entity.IProjectList} message ProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Project.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ProjectList message, length delimited. Does not implicitly {@link entity.ProjectList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ProjectList
         * @static
         * @param {entity.IProjectList} message ProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProjectList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProjectList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ProjectList} ProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ProjectList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Project.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProjectList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ProjectList} ProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProjectList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProjectList message.
         * @function verify
         * @memberof entity.ProjectList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProjectList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Project.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ProjectList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ProjectList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ProjectList} ProjectList
         */
        ProjectList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ProjectList)
                return object;
            var message = new $root.entity.ProjectList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ProjectList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ProjectList.items: object expected");
                    message.items[i] = $root.entity.Project.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ProjectList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ProjectList
         * @static
         * @param {entity.ProjectList} message ProjectList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProjectList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Project.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ProjectList to JSON.
         * @function toJSON
         * @memberof entity.ProjectList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProjectList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProjectList;
    })();

    entity.MessageRoomID = (function() {

        /**
         * Properties of a MessageRoomID.
         * @memberof entity
         * @interface IMessageRoomID
         * @property {string|null} [id] MessageRoomID id
         */

        /**
         * Constructs a new MessageRoomID.
         * @memberof entity
         * @classdesc Represents a MessageRoomID.
         * @implements IMessageRoomID
         * @constructor
         * @param {entity.IMessageRoomID=} [properties] Properties to set
         */
        function MessageRoomID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomID id.
         * @member {string} id
         * @memberof entity.MessageRoomID
         * @instance
         */
        MessageRoomID.prototype.id = "";

        /**
         * Creates a new MessageRoomID instance using the specified properties.
         * @function create
         * @memberof entity.MessageRoomID
         * @static
         * @param {entity.IMessageRoomID=} [properties] Properties to set
         * @returns {entity.MessageRoomID} MessageRoomID instance
         */
        MessageRoomID.create = function create(properties) {
            return new MessageRoomID(properties);
        };

        /**
         * Encodes the specified MessageRoomID message. Does not implicitly {@link entity.MessageRoomID.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageRoomID
         * @static
         * @param {entity.IMessageRoomID} message MessageRoomID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified MessageRoomID message, length delimited. Does not implicitly {@link entity.MessageRoomID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageRoomID
         * @static
         * @param {entity.IMessageRoomID} message MessageRoomID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageRoomID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageRoomID} MessageRoomID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageRoomID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageRoomID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageRoomID} MessageRoomID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomID message.
         * @function verify
         * @memberof entity.MessageRoomID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a MessageRoomID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageRoomID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageRoomID} MessageRoomID
         */
        MessageRoomID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageRoomID)
                return object;
            var message = new $root.entity.MessageRoomID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageRoomID
         * @static
         * @param {entity.MessageRoomID} message MessageRoomID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this MessageRoomID to JSON.
         * @function toJSON
         * @memberof entity.MessageRoomID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomID;
    })();

    entity.MessageRoomIDList = (function() {

        /**
         * Properties of a MessageRoomIDList.
         * @memberof entity
         * @interface IMessageRoomIDList
         * @property {Array.<string>|null} [ids] MessageRoomIDList ids
         */

        /**
         * Constructs a new MessageRoomIDList.
         * @memberof entity
         * @classdesc Represents a MessageRoomIDList.
         * @implements IMessageRoomIDList
         * @constructor
         * @param {entity.IMessageRoomIDList=} [properties] Properties to set
         */
        function MessageRoomIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.MessageRoomIDList
         * @instance
         */
        MessageRoomIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new MessageRoomIDList instance using the specified properties.
         * @function create
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {entity.IMessageRoomIDList=} [properties] Properties to set
         * @returns {entity.MessageRoomIDList} MessageRoomIDList instance
         */
        MessageRoomIDList.create = function create(properties) {
            return new MessageRoomIDList(properties);
        };

        /**
         * Encodes the specified MessageRoomIDList message. Does not implicitly {@link entity.MessageRoomIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {entity.IMessageRoomIDList} message MessageRoomIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified MessageRoomIDList message, length delimited. Does not implicitly {@link entity.MessageRoomIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {entity.IMessageRoomIDList} message MessageRoomIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageRoomIDList} MessageRoomIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageRoomIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageRoomIDList} MessageRoomIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomIDList message.
         * @function verify
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a MessageRoomIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageRoomIDList} MessageRoomIDList
         */
        MessageRoomIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageRoomIDList)
                return object;
            var message = new $root.entity.MessageRoomIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.MessageRoomIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageRoomIDList
         * @static
         * @param {entity.MessageRoomIDList} message MessageRoomIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this MessageRoomIDList to JSON.
         * @function toJSON
         * @memberof entity.MessageRoomIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomIDList;
    })();

    entity.MessageRoom = (function() {

        /**
         * Properties of a MessageRoom.
         * @memberof entity
         * @interface IMessageRoom
         * @property {string|null} [id] MessageRoom id
         * @property {string|null} [projectID] MessageRoom projectID
         * @property {string|null} [customerID] MessageRoom customerID
         * @property {string|null} [companyID] MessageRoom companyID
         * @property {boolean|null} [customerUnRead] MessageRoom customerUnRead
         * @property {number|Long|null} [customerUnReadCount] MessageRoom customerUnReadCount
         * @property {boolean|null} [companyUnRead] MessageRoom companyUnRead
         * @property {number|Long|null} [companyUnReadCount] MessageRoom companyUnReadCount
         * @property {boolean|null} [isScout] MessageRoom isScout
         * @property {string|null} [createdAt] MessageRoom createdAt
         * @property {string|null} [updatedAt] MessageRoom updatedAt
         * @property {boolean|null} [hasContract] MessageRoom hasContract
         * @property {string|null} [companyName] MessageRoom companyName
         * @property {string|null} [customerName] MessageRoom customerName
         * @property {string|null} [projectName] MessageRoom projectName
         */

        /**
         * Constructs a new MessageRoom.
         * @memberof entity
         * @classdesc Represents a MessageRoom.
         * @implements IMessageRoom
         * @constructor
         * @param {entity.IMessageRoom=} [properties] Properties to set
         */
        function MessageRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoom id.
         * @member {string} id
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.id = "";

        /**
         * MessageRoom projectID.
         * @member {string} projectID
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.projectID = "";

        /**
         * MessageRoom customerID.
         * @member {string} customerID
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.customerID = "";

        /**
         * MessageRoom companyID.
         * @member {string} companyID
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.companyID = "";

        /**
         * MessageRoom customerUnRead.
         * @member {boolean} customerUnRead
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.customerUnRead = false;

        /**
         * MessageRoom customerUnReadCount.
         * @member {number|Long} customerUnReadCount
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.customerUnReadCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessageRoom companyUnRead.
         * @member {boolean} companyUnRead
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.companyUnRead = false;

        /**
         * MessageRoom companyUnReadCount.
         * @member {number|Long} companyUnReadCount
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.companyUnReadCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessageRoom isScout.
         * @member {boolean} isScout
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.isScout = false;

        /**
         * MessageRoom createdAt.
         * @member {string} createdAt
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.createdAt = "";

        /**
         * MessageRoom updatedAt.
         * @member {string} updatedAt
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.updatedAt = "";

        /**
         * MessageRoom hasContract.
         * @member {boolean} hasContract
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.hasContract = false;

        /**
         * MessageRoom companyName.
         * @member {string} companyName
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.companyName = "";

        /**
         * MessageRoom customerName.
         * @member {string} customerName
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.customerName = "";

        /**
         * MessageRoom projectName.
         * @member {string} projectName
         * @memberof entity.MessageRoom
         * @instance
         */
        MessageRoom.prototype.projectName = "";

        /**
         * Creates a new MessageRoom instance using the specified properties.
         * @function create
         * @memberof entity.MessageRoom
         * @static
         * @param {entity.IMessageRoom=} [properties] Properties to set
         * @returns {entity.MessageRoom} MessageRoom instance
         */
        MessageRoom.create = function create(properties) {
            return new MessageRoom(properties);
        };

        /**
         * Encodes the specified MessageRoom message. Does not implicitly {@link entity.MessageRoom.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageRoom
         * @static
         * @param {entity.IMessageRoom} message MessageRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerID);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.companyID);
            if (message.customerUnRead != null && Object.hasOwnProperty.call(message, "customerUnRead"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.customerUnRead);
            if (message.customerUnReadCount != null && Object.hasOwnProperty.call(message, "customerUnReadCount"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.customerUnReadCount);
            if (message.companyUnRead != null && Object.hasOwnProperty.call(message, "companyUnRead"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.companyUnRead);
            if (message.companyUnReadCount != null && Object.hasOwnProperty.call(message, "companyUnReadCount"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.companyUnReadCount);
            if (message.isScout != null && Object.hasOwnProperty.call(message, "isScout"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isScout);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.updatedAt);
            if (message.hasContract != null && Object.hasOwnProperty.call(message, "hasContract"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.hasContract);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.companyName);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.customerName);
            if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.projectName);
            return writer;
        };

        /**
         * Encodes the specified MessageRoom message, length delimited. Does not implicitly {@link entity.MessageRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageRoom
         * @static
         * @param {entity.IMessageRoom} message MessageRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoom message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageRoom} MessageRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.customerID = reader.string();
                    break;
                case 4:
                    message.companyID = reader.string();
                    break;
                case 5:
                    message.customerUnRead = reader.bool();
                    break;
                case 6:
                    message.customerUnReadCount = reader.int64();
                    break;
                case 7:
                    message.companyUnRead = reader.bool();
                    break;
                case 8:
                    message.companyUnReadCount = reader.int64();
                    break;
                case 9:
                    message.isScout = reader.bool();
                    break;
                case 10:
                    message.createdAt = reader.string();
                    break;
                case 11:
                    message.updatedAt = reader.string();
                    break;
                case 12:
                    message.hasContract = reader.bool();
                    break;
                case 13:
                    message.companyName = reader.string();
                    break;
                case 14:
                    message.customerName = reader.string();
                    break;
                case 15:
                    message.projectName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageRoom} MessageRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoom message.
         * @function verify
         * @memberof entity.MessageRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.customerUnRead != null && message.hasOwnProperty("customerUnRead"))
                if (typeof message.customerUnRead !== "boolean")
                    return "customerUnRead: boolean expected";
            if (message.customerUnReadCount != null && message.hasOwnProperty("customerUnReadCount"))
                if (!$util.isInteger(message.customerUnReadCount) && !(message.customerUnReadCount && $util.isInteger(message.customerUnReadCount.low) && $util.isInteger(message.customerUnReadCount.high)))
                    return "customerUnReadCount: integer|Long expected";
            if (message.companyUnRead != null && message.hasOwnProperty("companyUnRead"))
                if (typeof message.companyUnRead !== "boolean")
                    return "companyUnRead: boolean expected";
            if (message.companyUnReadCount != null && message.hasOwnProperty("companyUnReadCount"))
                if (!$util.isInteger(message.companyUnReadCount) && !(message.companyUnReadCount && $util.isInteger(message.companyUnReadCount.low) && $util.isInteger(message.companyUnReadCount.high)))
                    return "companyUnReadCount: integer|Long expected";
            if (message.isScout != null && message.hasOwnProperty("isScout"))
                if (typeof message.isScout !== "boolean")
                    return "isScout: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            if (message.hasContract != null && message.hasOwnProperty("hasContract"))
                if (typeof message.hasContract !== "boolean")
                    return "hasContract: boolean expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                if (!$util.isString(message.projectName))
                    return "projectName: string expected";
            return null;
        };

        /**
         * Creates a MessageRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageRoom} MessageRoom
         */
        MessageRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageRoom)
                return object;
            var message = new $root.entity.MessageRoom();
            if (object.id != null)
                message.id = String(object.id);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.customerUnRead != null)
                message.customerUnRead = Boolean(object.customerUnRead);
            if (object.customerUnReadCount != null)
                if ($util.Long)
                    (message.customerUnReadCount = $util.Long.fromValue(object.customerUnReadCount)).unsigned = false;
                else if (typeof object.customerUnReadCount === "string")
                    message.customerUnReadCount = parseInt(object.customerUnReadCount, 10);
                else if (typeof object.customerUnReadCount === "number")
                    message.customerUnReadCount = object.customerUnReadCount;
                else if (typeof object.customerUnReadCount === "object")
                    message.customerUnReadCount = new $util.LongBits(object.customerUnReadCount.low >>> 0, object.customerUnReadCount.high >>> 0).toNumber();
            if (object.companyUnRead != null)
                message.companyUnRead = Boolean(object.companyUnRead);
            if (object.companyUnReadCount != null)
                if ($util.Long)
                    (message.companyUnReadCount = $util.Long.fromValue(object.companyUnReadCount)).unsigned = false;
                else if (typeof object.companyUnReadCount === "string")
                    message.companyUnReadCount = parseInt(object.companyUnReadCount, 10);
                else if (typeof object.companyUnReadCount === "number")
                    message.companyUnReadCount = object.companyUnReadCount;
                else if (typeof object.companyUnReadCount === "object")
                    message.companyUnReadCount = new $util.LongBits(object.companyUnReadCount.low >>> 0, object.companyUnReadCount.high >>> 0).toNumber();
            if (object.isScout != null)
                message.isScout = Boolean(object.isScout);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            if (object.hasContract != null)
                message.hasContract = Boolean(object.hasContract);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.projectName != null)
                message.projectName = String(object.projectName);
            return message;
        };

        /**
         * Creates a plain object from a MessageRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageRoom
         * @static
         * @param {entity.MessageRoom} message MessageRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.projectID = "";
                object.customerID = "";
                object.companyID = "";
                object.customerUnRead = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.customerUnReadCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customerUnReadCount = options.longs === String ? "0" : 0;
                object.companyUnRead = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.companyUnReadCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.companyUnReadCount = options.longs === String ? "0" : 0;
                object.isScout = false;
                object.createdAt = "";
                object.updatedAt = "";
                object.hasContract = false;
                object.companyName = "";
                object.customerName = "";
                object.projectName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.customerUnRead != null && message.hasOwnProperty("customerUnRead"))
                object.customerUnRead = message.customerUnRead;
            if (message.customerUnReadCount != null && message.hasOwnProperty("customerUnReadCount"))
                if (typeof message.customerUnReadCount === "number")
                    object.customerUnReadCount = options.longs === String ? String(message.customerUnReadCount) : message.customerUnReadCount;
                else
                    object.customerUnReadCount = options.longs === String ? $util.Long.prototype.toString.call(message.customerUnReadCount) : options.longs === Number ? new $util.LongBits(message.customerUnReadCount.low >>> 0, message.customerUnReadCount.high >>> 0).toNumber() : message.customerUnReadCount;
            if (message.companyUnRead != null && message.hasOwnProperty("companyUnRead"))
                object.companyUnRead = message.companyUnRead;
            if (message.companyUnReadCount != null && message.hasOwnProperty("companyUnReadCount"))
                if (typeof message.companyUnReadCount === "number")
                    object.companyUnReadCount = options.longs === String ? String(message.companyUnReadCount) : message.companyUnReadCount;
                else
                    object.companyUnReadCount = options.longs === String ? $util.Long.prototype.toString.call(message.companyUnReadCount) : options.longs === Number ? new $util.LongBits(message.companyUnReadCount.low >>> 0, message.companyUnReadCount.high >>> 0).toNumber() : message.companyUnReadCount;
            if (message.isScout != null && message.hasOwnProperty("isScout"))
                object.isScout = message.isScout;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            if (message.hasContract != null && message.hasOwnProperty("hasContract"))
                object.hasContract = message.hasContract;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.projectName != null && message.hasOwnProperty("projectName"))
                object.projectName = message.projectName;
            return object;
        };

        /**
         * Converts this MessageRoom to JSON.
         * @function toJSON
         * @memberof entity.MessageRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * FilterByScout enum.
         * @name entity.MessageRoom.FilterByScout
         * @enum {number}
         * @property {number} FilterByScout_None=0 FilterByScout_None value
         * @property {number} FilterByScout_On=1 FilterByScout_On value
         * @property {number} FilterByScout_Off=2 FilterByScout_Off value
         */
        MessageRoom.FilterByScout = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "FilterByScout_None"] = 0;
            values[valuesById[1] = "FilterByScout_On"] = 1;
            values[valuesById[2] = "FilterByScout_Off"] = 2;
            return values;
        })();

        return MessageRoom;
    })();

    entity.MessageRoomList = (function() {

        /**
         * Properties of a MessageRoomList.
         * @memberof entity
         * @interface IMessageRoomList
         * @property {Array.<entity.IMessageRoom>|null} [items] MessageRoomList items
         */

        /**
         * Constructs a new MessageRoomList.
         * @memberof entity
         * @classdesc Represents a MessageRoomList.
         * @implements IMessageRoomList
         * @constructor
         * @param {entity.IMessageRoomList=} [properties] Properties to set
         */
        function MessageRoomList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomList items.
         * @member {Array.<entity.IMessageRoom>} items
         * @memberof entity.MessageRoomList
         * @instance
         */
        MessageRoomList.prototype.items = $util.emptyArray;

        /**
         * Creates a new MessageRoomList instance using the specified properties.
         * @function create
         * @memberof entity.MessageRoomList
         * @static
         * @param {entity.IMessageRoomList=} [properties] Properties to set
         * @returns {entity.MessageRoomList} MessageRoomList instance
         */
        MessageRoomList.create = function create(properties) {
            return new MessageRoomList(properties);
        };

        /**
         * Encodes the specified MessageRoomList message. Does not implicitly {@link entity.MessageRoomList.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageRoomList
         * @static
         * @param {entity.IMessageRoomList} message MessageRoomList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.MessageRoom.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MessageRoomList message, length delimited. Does not implicitly {@link entity.MessageRoomList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageRoomList
         * @static
         * @param {entity.IMessageRoomList} message MessageRoomList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageRoomList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageRoomList} MessageRoomList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageRoomList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.MessageRoom.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageRoomList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageRoomList} MessageRoomList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomList message.
         * @function verify
         * @memberof entity.MessageRoomList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.MessageRoom.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MessageRoomList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageRoomList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageRoomList} MessageRoomList
         */
        MessageRoomList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageRoomList)
                return object;
            var message = new $root.entity.MessageRoomList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.MessageRoomList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.MessageRoomList.items: object expected");
                    message.items[i] = $root.entity.MessageRoom.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageRoomList
         * @static
         * @param {entity.MessageRoomList} message MessageRoomList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.MessageRoom.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this MessageRoomList to JSON.
         * @function toJSON
         * @memberof entity.MessageRoomList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomList;
    })();

    entity.MessageRoomIDWithPager = (function() {

        /**
         * Properties of a MessageRoomIDWithPager.
         * @memberof entity
         * @interface IMessageRoomIDWithPager
         * @property {common.IPager|null} [pager] MessageRoomIDWithPager pager
         * @property {string|null} [id] MessageRoomIDWithPager id
         */

        /**
         * Constructs a new MessageRoomIDWithPager.
         * @memberof entity
         * @classdesc Represents a MessageRoomIDWithPager.
         * @implements IMessageRoomIDWithPager
         * @constructor
         * @param {entity.IMessageRoomIDWithPager=} [properties] Properties to set
         */
        function MessageRoomIDWithPager(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomIDWithPager pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof entity.MessageRoomIDWithPager
         * @instance
         */
        MessageRoomIDWithPager.prototype.pager = null;

        /**
         * MessageRoomIDWithPager id.
         * @member {string} id
         * @memberof entity.MessageRoomIDWithPager
         * @instance
         */
        MessageRoomIDWithPager.prototype.id = "";

        /**
         * Creates a new MessageRoomIDWithPager instance using the specified properties.
         * @function create
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {entity.IMessageRoomIDWithPager=} [properties] Properties to set
         * @returns {entity.MessageRoomIDWithPager} MessageRoomIDWithPager instance
         */
        MessageRoomIDWithPager.create = function create(properties) {
            return new MessageRoomIDWithPager(properties);
        };

        /**
         * Encodes the specified MessageRoomIDWithPager message. Does not implicitly {@link entity.MessageRoomIDWithPager.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {entity.IMessageRoomIDWithPager} message MessageRoomIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomIDWithPager.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified MessageRoomIDWithPager message, length delimited. Does not implicitly {@link entity.MessageRoomIDWithPager.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {entity.IMessageRoomIDWithPager} message MessageRoomIDWithPager message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomIDWithPager.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomIDWithPager message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageRoomIDWithPager} MessageRoomIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomIDWithPager.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageRoomIDWithPager();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomIDWithPager message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageRoomIDWithPager} MessageRoomIDWithPager
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomIDWithPager.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomIDWithPager message.
         * @function verify
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomIDWithPager.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a MessageRoomIDWithPager message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageRoomIDWithPager} MessageRoomIDWithPager
         */
        MessageRoomIDWithPager.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageRoomIDWithPager)
                return object;
            var message = new $root.entity.MessageRoomIDWithPager();
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".entity.MessageRoomIDWithPager.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomIDWithPager message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageRoomIDWithPager
         * @static
         * @param {entity.MessageRoomIDWithPager} message MessageRoomIDWithPager
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomIDWithPager.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pager = null;
                object.id = "";
            }
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this MessageRoomIDWithPager to JSON.
         * @function toJSON
         * @memberof entity.MessageRoomIDWithPager
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomIDWithPager.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomIDWithPager;
    })();

    entity.MessageID = (function() {

        /**
         * Properties of a MessageID.
         * @memberof entity
         * @interface IMessageID
         * @property {string|null} [id] MessageID id
         */

        /**
         * Constructs a new MessageID.
         * @memberof entity
         * @classdesc Represents a MessageID.
         * @implements IMessageID
         * @constructor
         * @param {entity.IMessageID=} [properties] Properties to set
         */
        function MessageID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageID id.
         * @member {string} id
         * @memberof entity.MessageID
         * @instance
         */
        MessageID.prototype.id = "";

        /**
         * Creates a new MessageID instance using the specified properties.
         * @function create
         * @memberof entity.MessageID
         * @static
         * @param {entity.IMessageID=} [properties] Properties to set
         * @returns {entity.MessageID} MessageID instance
         */
        MessageID.create = function create(properties) {
            return new MessageID(properties);
        };

        /**
         * Encodes the specified MessageID message. Does not implicitly {@link entity.MessageID.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageID
         * @static
         * @param {entity.IMessageID} message MessageID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified MessageID message, length delimited. Does not implicitly {@link entity.MessageID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageID
         * @static
         * @param {entity.IMessageID} message MessageID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageID} MessageID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageID} MessageID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageID message.
         * @function verify
         * @memberof entity.MessageID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a MessageID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageID} MessageID
         */
        MessageID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageID)
                return object;
            var message = new $root.entity.MessageID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a MessageID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageID
         * @static
         * @param {entity.MessageID} message MessageID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this MessageID to JSON.
         * @function toJSON
         * @memberof entity.MessageID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageID;
    })();

    entity.MessageIDList = (function() {

        /**
         * Properties of a MessageIDList.
         * @memberof entity
         * @interface IMessageIDList
         * @property {Array.<string>|null} [ids] MessageIDList ids
         */

        /**
         * Constructs a new MessageIDList.
         * @memberof entity
         * @classdesc Represents a MessageIDList.
         * @implements IMessageIDList
         * @constructor
         * @param {entity.IMessageIDList=} [properties] Properties to set
         */
        function MessageIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.MessageIDList
         * @instance
         */
        MessageIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new MessageIDList instance using the specified properties.
         * @function create
         * @memberof entity.MessageIDList
         * @static
         * @param {entity.IMessageIDList=} [properties] Properties to set
         * @returns {entity.MessageIDList} MessageIDList instance
         */
        MessageIDList.create = function create(properties) {
            return new MessageIDList(properties);
        };

        /**
         * Encodes the specified MessageIDList message. Does not implicitly {@link entity.MessageIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageIDList
         * @static
         * @param {entity.IMessageIDList} message MessageIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified MessageIDList message, length delimited. Does not implicitly {@link entity.MessageIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageIDList
         * @static
         * @param {entity.IMessageIDList} message MessageIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageIDList} MessageIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageIDList} MessageIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageIDList message.
         * @function verify
         * @memberof entity.MessageIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a MessageIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageIDList} MessageIDList
         */
        MessageIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageIDList)
                return object;
            var message = new $root.entity.MessageIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.MessageIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageIDList
         * @static
         * @param {entity.MessageIDList} message MessageIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this MessageIDList to JSON.
         * @function toJSON
         * @memberof entity.MessageIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageIDList;
    })();

    entity.Message = (function() {

        /**
         * Properties of a Message.
         * @memberof entity
         * @interface IMessage
         * @property {string|null} [id] Message id
         * @property {string|null} [roomID] Message roomID
         * @property {string|null} [fromID] Message fromID
         * @property {string|null} [toID] Message toID
         * @property {boolean|null} [fromCompany] Message fromCompany
         * @property {string|null} [text] Message text
         * @property {string|null} [gsImageURL] Message gsImageURL
         * @property {string|null} [signedImageURL] Message signedImageURL
         * @property {string|null} [gsFileURL] Message gsFileURL
         * @property {string|null} [signedFileURL] Message signedFileURL
         * @property {string|null} [createdAt] Message createdAt
         * @property {string|null} [fromName] Message fromName
         * @property {string|null} [fromSignedIconURL] Message fromSignedIconURL
         * @property {string|null} [toName] Message toName
         * @property {string|null} [toSignedIconURL] Message toSignedIconURL
         */

        /**
         * Constructs a new Message.
         * @memberof entity
         * @classdesc Represents a Message.
         * @implements IMessage
         * @constructor
         * @param {entity.IMessage=} [properties] Properties to set
         */
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Message id.
         * @member {string} id
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.id = "";

        /**
         * Message roomID.
         * @member {string} roomID
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.roomID = "";

        /**
         * Message fromID.
         * @member {string} fromID
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.fromID = "";

        /**
         * Message toID.
         * @member {string} toID
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.toID = "";

        /**
         * Message fromCompany.
         * @member {boolean} fromCompany
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.fromCompany = false;

        /**
         * Message text.
         * @member {string} text
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.text = "";

        /**
         * Message gsImageURL.
         * @member {string} gsImageURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.gsImageURL = "";

        /**
         * Message signedImageURL.
         * @member {string} signedImageURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.signedImageURL = "";

        /**
         * Message gsFileURL.
         * @member {string} gsFileURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.gsFileURL = "";

        /**
         * Message signedFileURL.
         * @member {string} signedFileURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.signedFileURL = "";

        /**
         * Message createdAt.
         * @member {string} createdAt
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.createdAt = "";

        /**
         * Message fromName.
         * @member {string} fromName
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.fromName = "";

        /**
         * Message fromSignedIconURL.
         * @member {string} fromSignedIconURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.fromSignedIconURL = "";

        /**
         * Message toName.
         * @member {string} toName
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.toName = "";

        /**
         * Message toSignedIconURL.
         * @member {string} toSignedIconURL
         * @memberof entity.Message
         * @instance
         */
        Message.prototype.toSignedIconURL = "";

        /**
         * Creates a new Message instance using the specified properties.
         * @function create
         * @memberof entity.Message
         * @static
         * @param {entity.IMessage=} [properties] Properties to set
         * @returns {entity.Message} Message instance
         */
        Message.create = function create(properties) {
            return new Message(properties);
        };

        /**
         * Encodes the specified Message message. Does not implicitly {@link entity.Message.verify|verify} messages.
         * @function encode
         * @memberof entity.Message
         * @static
         * @param {entity.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.roomID != null && Object.hasOwnProperty.call(message, "roomID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomID);
            if (message.fromID != null && Object.hasOwnProperty.call(message, "fromID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromID);
            if (message.toID != null && Object.hasOwnProperty.call(message, "toID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.toID);
            if (message.fromCompany != null && Object.hasOwnProperty.call(message, "fromCompany"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.fromCompany);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.text);
            if (message.gsImageURL != null && Object.hasOwnProperty.call(message, "gsImageURL"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.gsImageURL);
            if (message.signedImageURL != null && Object.hasOwnProperty.call(message, "signedImageURL"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.signedImageURL);
            if (message.gsFileURL != null && Object.hasOwnProperty.call(message, "gsFileURL"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.gsFileURL);
            if (message.signedFileURL != null && Object.hasOwnProperty.call(message, "signedFileURL"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.signedFileURL);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.createdAt);
            if (message.fromName != null && Object.hasOwnProperty.call(message, "fromName"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.fromName);
            if (message.fromSignedIconURL != null && Object.hasOwnProperty.call(message, "fromSignedIconURL"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.fromSignedIconURL);
            if (message.toName != null && Object.hasOwnProperty.call(message, "toName"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.toName);
            if (message.toSignedIconURL != null && Object.hasOwnProperty.call(message, "toSignedIconURL"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.toSignedIconURL);
            return writer;
        };

        /**
         * Encodes the specified Message message, length delimited. Does not implicitly {@link entity.Message.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Message
         * @static
         * @param {entity.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Message message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.roomID = reader.string();
                    break;
                case 3:
                    message.fromID = reader.string();
                    break;
                case 4:
                    message.toID = reader.string();
                    break;
                case 5:
                    message.fromCompany = reader.bool();
                    break;
                case 6:
                    message.text = reader.string();
                    break;
                case 7:
                    message.gsImageURL = reader.string();
                    break;
                case 8:
                    message.signedImageURL = reader.string();
                    break;
                case 9:
                    message.gsFileURL = reader.string();
                    break;
                case 10:
                    message.signedFileURL = reader.string();
                    break;
                case 11:
                    message.createdAt = reader.string();
                    break;
                case 12:
                    message.fromName = reader.string();
                    break;
                case 13:
                    message.fromSignedIconURL = reader.string();
                    break;
                case 14:
                    message.toName = reader.string();
                    break;
                case 15:
                    message.toSignedIconURL = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Message message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Message message.
         * @function verify
         * @memberof entity.Message
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Message.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.roomID != null && message.hasOwnProperty("roomID"))
                if (!$util.isString(message.roomID))
                    return "roomID: string expected";
            if (message.fromID != null && message.hasOwnProperty("fromID"))
                if (!$util.isString(message.fromID))
                    return "fromID: string expected";
            if (message.toID != null && message.hasOwnProperty("toID"))
                if (!$util.isString(message.toID))
                    return "toID: string expected";
            if (message.fromCompany != null && message.hasOwnProperty("fromCompany"))
                if (typeof message.fromCompany !== "boolean")
                    return "fromCompany: boolean expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.gsImageURL != null && message.hasOwnProperty("gsImageURL"))
                if (!$util.isString(message.gsImageURL))
                    return "gsImageURL: string expected";
            if (message.signedImageURL != null && message.hasOwnProperty("signedImageURL"))
                if (!$util.isString(message.signedImageURL))
                    return "signedImageURL: string expected";
            if (message.gsFileURL != null && message.hasOwnProperty("gsFileURL"))
                if (!$util.isString(message.gsFileURL))
                    return "gsFileURL: string expected";
            if (message.signedFileURL != null && message.hasOwnProperty("signedFileURL"))
                if (!$util.isString(message.signedFileURL))
                    return "signedFileURL: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.fromName != null && message.hasOwnProperty("fromName"))
                if (!$util.isString(message.fromName))
                    return "fromName: string expected";
            if (message.fromSignedIconURL != null && message.hasOwnProperty("fromSignedIconURL"))
                if (!$util.isString(message.fromSignedIconURL))
                    return "fromSignedIconURL: string expected";
            if (message.toName != null && message.hasOwnProperty("toName"))
                if (!$util.isString(message.toName))
                    return "toName: string expected";
            if (message.toSignedIconURL != null && message.hasOwnProperty("toSignedIconURL"))
                if (!$util.isString(message.toSignedIconURL))
                    return "toSignedIconURL: string expected";
            return null;
        };

        /**
         * Creates a Message message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Message
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Message} Message
         */
        Message.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Message)
                return object;
            var message = new $root.entity.Message();
            if (object.id != null)
                message.id = String(object.id);
            if (object.roomID != null)
                message.roomID = String(object.roomID);
            if (object.fromID != null)
                message.fromID = String(object.fromID);
            if (object.toID != null)
                message.toID = String(object.toID);
            if (object.fromCompany != null)
                message.fromCompany = Boolean(object.fromCompany);
            if (object.text != null)
                message.text = String(object.text);
            if (object.gsImageURL != null)
                message.gsImageURL = String(object.gsImageURL);
            if (object.signedImageURL != null)
                message.signedImageURL = String(object.signedImageURL);
            if (object.gsFileURL != null)
                message.gsFileURL = String(object.gsFileURL);
            if (object.signedFileURL != null)
                message.signedFileURL = String(object.signedFileURL);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.fromName != null)
                message.fromName = String(object.fromName);
            if (object.fromSignedIconURL != null)
                message.fromSignedIconURL = String(object.fromSignedIconURL);
            if (object.toName != null)
                message.toName = String(object.toName);
            if (object.toSignedIconURL != null)
                message.toSignedIconURL = String(object.toSignedIconURL);
            return message;
        };

        /**
         * Creates a plain object from a Message message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Message
         * @static
         * @param {entity.Message} message Message
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Message.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.roomID = "";
                object.fromID = "";
                object.toID = "";
                object.fromCompany = false;
                object.text = "";
                object.gsImageURL = "";
                object.signedImageURL = "";
                object.gsFileURL = "";
                object.signedFileURL = "";
                object.createdAt = "";
                object.fromName = "";
                object.fromSignedIconURL = "";
                object.toName = "";
                object.toSignedIconURL = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.roomID != null && message.hasOwnProperty("roomID"))
                object.roomID = message.roomID;
            if (message.fromID != null && message.hasOwnProperty("fromID"))
                object.fromID = message.fromID;
            if (message.toID != null && message.hasOwnProperty("toID"))
                object.toID = message.toID;
            if (message.fromCompany != null && message.hasOwnProperty("fromCompany"))
                object.fromCompany = message.fromCompany;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.gsImageURL != null && message.hasOwnProperty("gsImageURL"))
                object.gsImageURL = message.gsImageURL;
            if (message.signedImageURL != null && message.hasOwnProperty("signedImageURL"))
                object.signedImageURL = message.signedImageURL;
            if (message.gsFileURL != null && message.hasOwnProperty("gsFileURL"))
                object.gsFileURL = message.gsFileURL;
            if (message.signedFileURL != null && message.hasOwnProperty("signedFileURL"))
                object.signedFileURL = message.signedFileURL;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.fromName != null && message.hasOwnProperty("fromName"))
                object.fromName = message.fromName;
            if (message.fromSignedIconURL != null && message.hasOwnProperty("fromSignedIconURL"))
                object.fromSignedIconURL = message.fromSignedIconURL;
            if (message.toName != null && message.hasOwnProperty("toName"))
                object.toName = message.toName;
            if (message.toSignedIconURL != null && message.hasOwnProperty("toSignedIconURL"))
                object.toSignedIconURL = message.toSignedIconURL;
            return object;
        };

        /**
         * Converts this Message to JSON.
         * @function toJSON
         * @memberof entity.Message
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Message.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Message;
    })();

    entity.MessageList = (function() {

        /**
         * Properties of a MessageList.
         * @memberof entity
         * @interface IMessageList
         * @property {Array.<entity.IMessage>|null} [items] MessageList items
         */

        /**
         * Constructs a new MessageList.
         * @memberof entity
         * @classdesc Represents a MessageList.
         * @implements IMessageList
         * @constructor
         * @param {entity.IMessageList=} [properties] Properties to set
         */
        function MessageList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageList items.
         * @member {Array.<entity.IMessage>} items
         * @memberof entity.MessageList
         * @instance
         */
        MessageList.prototype.items = $util.emptyArray;

        /**
         * Creates a new MessageList instance using the specified properties.
         * @function create
         * @memberof entity.MessageList
         * @static
         * @param {entity.IMessageList=} [properties] Properties to set
         * @returns {entity.MessageList} MessageList instance
         */
        MessageList.create = function create(properties) {
            return new MessageList(properties);
        };

        /**
         * Encodes the specified MessageList message. Does not implicitly {@link entity.MessageList.verify|verify} messages.
         * @function encode
         * @memberof entity.MessageList
         * @static
         * @param {entity.IMessageList} message MessageList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Message.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MessageList message, length delimited. Does not implicitly {@link entity.MessageList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.MessageList
         * @static
         * @param {entity.IMessageList} message MessageList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.MessageList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.MessageList} MessageList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.MessageList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Message.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.MessageList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.MessageList} MessageList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageList message.
         * @function verify
         * @memberof entity.MessageList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Message.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MessageList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.MessageList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.MessageList} MessageList
         */
        MessageList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.MessageList)
                return object;
            var message = new $root.entity.MessageList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.MessageList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.MessageList.items: object expected");
                    message.items[i] = $root.entity.Message.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.MessageList
         * @static
         * @param {entity.MessageList} message MessageList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Message.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this MessageList to JSON.
         * @function toJSON
         * @memberof entity.MessageList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageList;
    })();

    entity.NotificationID = (function() {

        /**
         * Properties of a NotificationID.
         * @memberof entity
         * @interface INotificationID
         * @property {string|null} [id] NotificationID id
         */

        /**
         * Constructs a new NotificationID.
         * @memberof entity
         * @classdesc Represents a NotificationID.
         * @implements INotificationID
         * @constructor
         * @param {entity.INotificationID=} [properties] Properties to set
         */
        function NotificationID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationID id.
         * @member {string} id
         * @memberof entity.NotificationID
         * @instance
         */
        NotificationID.prototype.id = "";

        /**
         * Creates a new NotificationID instance using the specified properties.
         * @function create
         * @memberof entity.NotificationID
         * @static
         * @param {entity.INotificationID=} [properties] Properties to set
         * @returns {entity.NotificationID} NotificationID instance
         */
        NotificationID.create = function create(properties) {
            return new NotificationID(properties);
        };

        /**
         * Encodes the specified NotificationID message. Does not implicitly {@link entity.NotificationID.verify|verify} messages.
         * @function encode
         * @memberof entity.NotificationID
         * @static
         * @param {entity.INotificationID} message NotificationID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified NotificationID message, length delimited. Does not implicitly {@link entity.NotificationID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.NotificationID
         * @static
         * @param {entity.INotificationID} message NotificationID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NotificationID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.NotificationID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.NotificationID} NotificationID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.NotificationID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NotificationID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.NotificationID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.NotificationID} NotificationID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NotificationID message.
         * @function verify
         * @memberof entity.NotificationID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NotificationID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a NotificationID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.NotificationID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.NotificationID} NotificationID
         */
        NotificationID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.NotificationID)
                return object;
            var message = new $root.entity.NotificationID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a NotificationID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.NotificationID
         * @static
         * @param {entity.NotificationID} message NotificationID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this NotificationID to JSON.
         * @function toJSON
         * @memberof entity.NotificationID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationID;
    })();

    entity.NotificationIDList = (function() {

        /**
         * Properties of a NotificationIDList.
         * @memberof entity
         * @interface INotificationIDList
         * @property {Array.<string>|null} [ids] NotificationIDList ids
         */

        /**
         * Constructs a new NotificationIDList.
         * @memberof entity
         * @classdesc Represents a NotificationIDList.
         * @implements INotificationIDList
         * @constructor
         * @param {entity.INotificationIDList=} [properties] Properties to set
         */
        function NotificationIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationIDList ids.
         * @member {Array.<string>} ids
         * @memberof entity.NotificationIDList
         * @instance
         */
        NotificationIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new NotificationIDList instance using the specified properties.
         * @function create
         * @memberof entity.NotificationIDList
         * @static
         * @param {entity.INotificationIDList=} [properties] Properties to set
         * @returns {entity.NotificationIDList} NotificationIDList instance
         */
        NotificationIDList.create = function create(properties) {
            return new NotificationIDList(properties);
        };

        /**
         * Encodes the specified NotificationIDList message. Does not implicitly {@link entity.NotificationIDList.verify|verify} messages.
         * @function encode
         * @memberof entity.NotificationIDList
         * @static
         * @param {entity.INotificationIDList} message NotificationIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.ids[i]);
            return writer;
        };

        /**
         * Encodes the specified NotificationIDList message, length delimited. Does not implicitly {@link entity.NotificationIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.NotificationIDList
         * @static
         * @param {entity.INotificationIDList} message NotificationIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NotificationIDList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.NotificationIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.NotificationIDList} NotificationIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.NotificationIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NotificationIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.NotificationIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.NotificationIDList} NotificationIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NotificationIDList message.
         * @function verify
         * @memberof entity.NotificationIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NotificationIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i)
                    if (!$util.isString(message.ids[i]))
                        return "ids: string[] expected";
            }
            return null;
        };

        /**
         * Creates a NotificationIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.NotificationIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.NotificationIDList} NotificationIDList
         */
        NotificationIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.NotificationIDList)
                return object;
            var message = new $root.entity.NotificationIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".entity.NotificationIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a NotificationIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.NotificationIDList
         * @static
         * @param {entity.NotificationIDList} message NotificationIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
            }
            return object;
        };

        /**
         * Converts this NotificationIDList to JSON.
         * @function toJSON
         * @memberof entity.NotificationIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationIDList;
    })();

    entity.Notification = (function() {

        /**
         * Properties of a Notification.
         * @memberof entity
         * @interface INotification
         * @property {string|null} [id] Notification id
         * @property {string|null} [title] Notification title
         * @property {string|null} [body] Notification body
         * @property {string|null} [linkURL] Notification linkURL
         * @property {string|null} [linkTitle] Notification linkTitle
         * @property {boolean|null} [shouldMail] Notification shouldMail
         * @property {boolean|null} [isRead] Notification isRead
         * @property {string|null} [createdAt] Notification createdAt
         * @property {entity.Notification.SendTo|null} [sendTo] Notification sendTo
         */

        /**
         * Constructs a new Notification.
         * @memberof entity
         * @classdesc Represents a Notification.
         * @implements INotification
         * @constructor
         * @param {entity.INotification=} [properties] Properties to set
         */
        function Notification(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notification id.
         * @member {string} id
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.id = "";

        /**
         * Notification title.
         * @member {string} title
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.title = "";

        /**
         * Notification body.
         * @member {string} body
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.body = "";

        /**
         * Notification linkURL.
         * @member {string} linkURL
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.linkURL = "";

        /**
         * Notification linkTitle.
         * @member {string} linkTitle
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.linkTitle = "";

        /**
         * Notification shouldMail.
         * @member {boolean} shouldMail
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.shouldMail = false;

        /**
         * Notification isRead.
         * @member {boolean} isRead
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.isRead = false;

        /**
         * Notification createdAt.
         * @member {string} createdAt
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.createdAt = "";

        /**
         * Notification sendTo.
         * @member {entity.Notification.SendTo} sendTo
         * @memberof entity.Notification
         * @instance
         */
        Notification.prototype.sendTo = 0;

        /**
         * Creates a new Notification instance using the specified properties.
         * @function create
         * @memberof entity.Notification
         * @static
         * @param {entity.INotification=} [properties] Properties to set
         * @returns {entity.Notification} Notification instance
         */
        Notification.create = function create(properties) {
            return new Notification(properties);
        };

        /**
         * Encodes the specified Notification message. Does not implicitly {@link entity.Notification.verify|verify} messages.
         * @function encode
         * @memberof entity.Notification
         * @static
         * @param {entity.INotification} message Notification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.body);
            if (message.linkURL != null && Object.hasOwnProperty.call(message, "linkURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.linkURL);
            if (message.linkTitle != null && Object.hasOwnProperty.call(message, "linkTitle"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.linkTitle);
            if (message.shouldMail != null && Object.hasOwnProperty.call(message, "shouldMail"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.shouldMail);
            if (message.isRead != null && Object.hasOwnProperty.call(message, "isRead"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isRead);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.createdAt);
            if (message.sendTo != null && Object.hasOwnProperty.call(message, "sendTo"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.sendTo);
            return writer;
        };

        /**
         * Encodes the specified Notification message, length delimited. Does not implicitly {@link entity.Notification.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Notification
         * @static
         * @param {entity.INotification} message Notification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Notification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Notification message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Notification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Notification} Notification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Notification();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 3:
                    message.body = reader.string();
                    break;
                case 4:
                    message.linkURL = reader.string();
                    break;
                case 5:
                    message.linkTitle = reader.string();
                    break;
                case 6:
                    message.shouldMail = reader.bool();
                    break;
                case 7:
                    message.isRead = reader.bool();
                    break;
                case 8:
                    message.createdAt = reader.string();
                    break;
                case 9:
                    message.sendTo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Notification message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Notification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Notification} Notification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Notification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Notification message.
         * @function verify
         * @memberof entity.Notification
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Notification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.body != null && message.hasOwnProperty("body"))
                if (!$util.isString(message.body))
                    return "body: string expected";
            if (message.linkURL != null && message.hasOwnProperty("linkURL"))
                if (!$util.isString(message.linkURL))
                    return "linkURL: string expected";
            if (message.linkTitle != null && message.hasOwnProperty("linkTitle"))
                if (!$util.isString(message.linkTitle))
                    return "linkTitle: string expected";
            if (message.shouldMail != null && message.hasOwnProperty("shouldMail"))
                if (typeof message.shouldMail !== "boolean")
                    return "shouldMail: boolean expected";
            if (message.isRead != null && message.hasOwnProperty("isRead"))
                if (typeof message.isRead !== "boolean")
                    return "isRead: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.sendTo != null && message.hasOwnProperty("sendTo"))
                switch (message.sendTo) {
                default:
                    return "sendTo: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a Notification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Notification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Notification} Notification
         */
        Notification.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Notification)
                return object;
            var message = new $root.entity.Notification();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.body != null)
                message.body = String(object.body);
            if (object.linkURL != null)
                message.linkURL = String(object.linkURL);
            if (object.linkTitle != null)
                message.linkTitle = String(object.linkTitle);
            if (object.shouldMail != null)
                message.shouldMail = Boolean(object.shouldMail);
            if (object.isRead != null)
                message.isRead = Boolean(object.isRead);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            switch (object.sendTo) {
            case "SendTo_Unknown":
            case 0:
                message.sendTo = 0;
                break;
            case "SendTo_Customer":
            case 1:
                message.sendTo = 1;
                break;
            case "SendTo_Client":
            case 2:
                message.sendTo = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Notification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Notification
         * @static
         * @param {entity.Notification} message Notification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.body = "";
                object.linkURL = "";
                object.linkTitle = "";
                object.shouldMail = false;
                object.isRead = false;
                object.createdAt = "";
                object.sendTo = options.enums === String ? "SendTo_Unknown" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = message.body;
            if (message.linkURL != null && message.hasOwnProperty("linkURL"))
                object.linkURL = message.linkURL;
            if (message.linkTitle != null && message.hasOwnProperty("linkTitle"))
                object.linkTitle = message.linkTitle;
            if (message.shouldMail != null && message.hasOwnProperty("shouldMail"))
                object.shouldMail = message.shouldMail;
            if (message.isRead != null && message.hasOwnProperty("isRead"))
                object.isRead = message.isRead;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.sendTo != null && message.hasOwnProperty("sendTo"))
                object.sendTo = options.enums === String ? $root.entity.Notification.SendTo[message.sendTo] : message.sendTo;
            return object;
        };

        /**
         * Converts this Notification to JSON.
         * @function toJSON
         * @memberof entity.Notification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * SendTo enum.
         * @name entity.Notification.SendTo
         * @enum {number}
         * @property {number} SendTo_Unknown=0 SendTo_Unknown value
         * @property {number} SendTo_Customer=1 SendTo_Customer value
         * @property {number} SendTo_Client=2 SendTo_Client value
         */
        Notification.SendTo = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SendTo_Unknown"] = 0;
            values[valuesById[1] = "SendTo_Customer"] = 1;
            values[valuesById[2] = "SendTo_Client"] = 2;
            return values;
        })();

        return Notification;
    })();

    entity.NotificationList = (function() {

        /**
         * Properties of a NotificationList.
         * @memberof entity
         * @interface INotificationList
         * @property {Array.<entity.INotification>|null} [items] NotificationList items
         */

        /**
         * Constructs a new NotificationList.
         * @memberof entity
         * @classdesc Represents a NotificationList.
         * @implements INotificationList
         * @constructor
         * @param {entity.INotificationList=} [properties] Properties to set
         */
        function NotificationList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationList items.
         * @member {Array.<entity.INotification>} items
         * @memberof entity.NotificationList
         * @instance
         */
        NotificationList.prototype.items = $util.emptyArray;

        /**
         * Creates a new NotificationList instance using the specified properties.
         * @function create
         * @memberof entity.NotificationList
         * @static
         * @param {entity.INotificationList=} [properties] Properties to set
         * @returns {entity.NotificationList} NotificationList instance
         */
        NotificationList.create = function create(properties) {
            return new NotificationList(properties);
        };

        /**
         * Encodes the specified NotificationList message. Does not implicitly {@link entity.NotificationList.verify|verify} messages.
         * @function encode
         * @memberof entity.NotificationList
         * @static
         * @param {entity.INotificationList} message NotificationList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Notification.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NotificationList message, length delimited. Does not implicitly {@link entity.NotificationList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.NotificationList
         * @static
         * @param {entity.INotificationList} message NotificationList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NotificationList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NotificationList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.NotificationList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.NotificationList} NotificationList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.NotificationList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Notification.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NotificationList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.NotificationList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.NotificationList} NotificationList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NotificationList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NotificationList message.
         * @function verify
         * @memberof entity.NotificationList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NotificationList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Notification.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NotificationList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.NotificationList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.NotificationList} NotificationList
         */
        NotificationList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.NotificationList)
                return object;
            var message = new $root.entity.NotificationList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.NotificationList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.NotificationList.items: object expected");
                    message.items[i] = $root.entity.Notification.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NotificationList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.NotificationList
         * @static
         * @param {entity.NotificationList} message NotificationList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Notification.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this NotificationList to JSON.
         * @function toJSON
         * @memberof entity.NotificationList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationList;
    })();

    entity.PartnerCategoryID = (function() {

        /**
         * Properties of a PartnerCategoryID.
         * @memberof entity
         * @interface IPartnerCategoryID
         * @property {string|null} [id] PartnerCategoryID id
         */

        /**
         * Constructs a new PartnerCategoryID.
         * @memberof entity
         * @classdesc Represents a PartnerCategoryID.
         * @implements IPartnerCategoryID
         * @constructor
         * @param {entity.IPartnerCategoryID=} [properties] Properties to set
         */
        function PartnerCategoryID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerCategoryID id.
         * @member {string} id
         * @memberof entity.PartnerCategoryID
         * @instance
         */
        PartnerCategoryID.prototype.id = "";

        /**
         * Creates a new PartnerCategoryID instance using the specified properties.
         * @function create
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {entity.IPartnerCategoryID=} [properties] Properties to set
         * @returns {entity.PartnerCategoryID} PartnerCategoryID instance
         */
        PartnerCategoryID.create = function create(properties) {
            return new PartnerCategoryID(properties);
        };

        /**
         * Encodes the specified PartnerCategoryID message. Does not implicitly {@link entity.PartnerCategoryID.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {entity.IPartnerCategoryID} message PartnerCategoryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategoryID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified PartnerCategoryID message, length delimited. Does not implicitly {@link entity.PartnerCategoryID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {entity.IPartnerCategoryID} message PartnerCategoryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategoryID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerCategoryID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerCategoryID} PartnerCategoryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategoryID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerCategoryID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerCategoryID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerCategoryID} PartnerCategoryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategoryID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerCategoryID message.
         * @function verify
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerCategoryID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a PartnerCategoryID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerCategoryID} PartnerCategoryID
         */
        PartnerCategoryID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerCategoryID)
                return object;
            var message = new $root.entity.PartnerCategoryID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a PartnerCategoryID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerCategoryID
         * @static
         * @param {entity.PartnerCategoryID} message PartnerCategoryID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerCategoryID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this PartnerCategoryID to JSON.
         * @function toJSON
         * @memberof entity.PartnerCategoryID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerCategoryID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerCategoryID;
    })();

    entity.PartnerCategory = (function() {

        /**
         * Properties of a PartnerCategory.
         * @memberof entity
         * @interface IPartnerCategory
         * @property {string|null} [id] PartnerCategory id
         * @property {string|null} [name] PartnerCategory name
         * @property {string|null} [createdAt] PartnerCategory createdAt
         * @property {string|null} [updatedAt] PartnerCategory updatedAt
         */

        /**
         * Constructs a new PartnerCategory.
         * @memberof entity
         * @classdesc Represents a PartnerCategory.
         * @implements IPartnerCategory
         * @constructor
         * @param {entity.IPartnerCategory=} [properties] Properties to set
         */
        function PartnerCategory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerCategory id.
         * @member {string} id
         * @memberof entity.PartnerCategory
         * @instance
         */
        PartnerCategory.prototype.id = "";

        /**
         * PartnerCategory name.
         * @member {string} name
         * @memberof entity.PartnerCategory
         * @instance
         */
        PartnerCategory.prototype.name = "";

        /**
         * PartnerCategory createdAt.
         * @member {string} createdAt
         * @memberof entity.PartnerCategory
         * @instance
         */
        PartnerCategory.prototype.createdAt = "";

        /**
         * PartnerCategory updatedAt.
         * @member {string} updatedAt
         * @memberof entity.PartnerCategory
         * @instance
         */
        PartnerCategory.prototype.updatedAt = "";

        /**
         * Creates a new PartnerCategory instance using the specified properties.
         * @function create
         * @memberof entity.PartnerCategory
         * @static
         * @param {entity.IPartnerCategory=} [properties] Properties to set
         * @returns {entity.PartnerCategory} PartnerCategory instance
         */
        PartnerCategory.create = function create(properties) {
            return new PartnerCategory(properties);
        };

        /**
         * Encodes the specified PartnerCategory message. Does not implicitly {@link entity.PartnerCategory.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerCategory
         * @static
         * @param {entity.IPartnerCategory} message PartnerCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 10000, wireType 2 =*/80002).string(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified PartnerCategory message, length delimited. Does not implicitly {@link entity.PartnerCategory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerCategory
         * @static
         * @param {entity.IPartnerCategory} message PartnerCategory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerCategory message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerCategory} PartnerCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerCategory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                case 10000:
                    message.updatedAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerCategory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerCategory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerCategory} PartnerCategory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerCategory message.
         * @function verify
         * @memberof entity.PartnerCategory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerCategory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            return null;
        };

        /**
         * Creates a PartnerCategory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerCategory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerCategory} PartnerCategory
         */
        PartnerCategory.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerCategory)
                return object;
            var message = new $root.entity.PartnerCategory();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            return message;
        };

        /**
         * Creates a plain object from a PartnerCategory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerCategory
         * @static
         * @param {entity.PartnerCategory} message PartnerCategory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerCategory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.createdAt = "";
                object.updatedAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            return object;
        };

        /**
         * Converts this PartnerCategory to JSON.
         * @function toJSON
         * @memberof entity.PartnerCategory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerCategory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerCategory;
    })();

    entity.PartnerCategoryList = (function() {

        /**
         * Properties of a PartnerCategoryList.
         * @memberof entity
         * @interface IPartnerCategoryList
         * @property {Array.<entity.IPartnerCategory>|null} [items] PartnerCategoryList items
         */

        /**
         * Constructs a new PartnerCategoryList.
         * @memberof entity
         * @classdesc Represents a PartnerCategoryList.
         * @implements IPartnerCategoryList
         * @constructor
         * @param {entity.IPartnerCategoryList=} [properties] Properties to set
         */
        function PartnerCategoryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerCategoryList items.
         * @member {Array.<entity.IPartnerCategory>} items
         * @memberof entity.PartnerCategoryList
         * @instance
         */
        PartnerCategoryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new PartnerCategoryList instance using the specified properties.
         * @function create
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {entity.IPartnerCategoryList=} [properties] Properties to set
         * @returns {entity.PartnerCategoryList} PartnerCategoryList instance
         */
        PartnerCategoryList.create = function create(properties) {
            return new PartnerCategoryList(properties);
        };

        /**
         * Encodes the specified PartnerCategoryList message. Does not implicitly {@link entity.PartnerCategoryList.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {entity.IPartnerCategoryList} message PartnerCategoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategoryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.PartnerCategory.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PartnerCategoryList message, length delimited. Does not implicitly {@link entity.PartnerCategoryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {entity.IPartnerCategoryList} message PartnerCategoryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerCategoryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerCategoryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerCategoryList} PartnerCategoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategoryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerCategoryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.PartnerCategory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerCategoryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerCategoryList} PartnerCategoryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerCategoryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerCategoryList message.
         * @function verify
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerCategoryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.PartnerCategory.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PartnerCategoryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerCategoryList} PartnerCategoryList
         */
        PartnerCategoryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerCategoryList)
                return object;
            var message = new $root.entity.PartnerCategoryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.PartnerCategoryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.PartnerCategoryList.items: object expected");
                    message.items[i] = $root.entity.PartnerCategory.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PartnerCategoryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerCategoryList
         * @static
         * @param {entity.PartnerCategoryList} message PartnerCategoryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerCategoryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.PartnerCategory.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this PartnerCategoryList to JSON.
         * @function toJSON
         * @memberof entity.PartnerCategoryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerCategoryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerCategoryList;
    })();

    entity.PartnerStoreEntryID = (function() {

        /**
         * Properties of a PartnerStoreEntryID.
         * @memberof entity
         * @interface IPartnerStoreEntryID
         * @property {string|null} [id] PartnerStoreEntryID id
         */

        /**
         * Constructs a new PartnerStoreEntryID.
         * @memberof entity
         * @classdesc Represents a PartnerStoreEntryID.
         * @implements IPartnerStoreEntryID
         * @constructor
         * @param {entity.IPartnerStoreEntryID=} [properties] Properties to set
         */
        function PartnerStoreEntryID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerStoreEntryID id.
         * @member {string} id
         * @memberof entity.PartnerStoreEntryID
         * @instance
         */
        PartnerStoreEntryID.prototype.id = "";

        /**
         * Creates a new PartnerStoreEntryID instance using the specified properties.
         * @function create
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {entity.IPartnerStoreEntryID=} [properties] Properties to set
         * @returns {entity.PartnerStoreEntryID} PartnerStoreEntryID instance
         */
        PartnerStoreEntryID.create = function create(properties) {
            return new PartnerStoreEntryID(properties);
        };

        /**
         * Encodes the specified PartnerStoreEntryID message. Does not implicitly {@link entity.PartnerStoreEntryID.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {entity.IPartnerStoreEntryID} message PartnerStoreEntryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntryID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified PartnerStoreEntryID message, length delimited. Does not implicitly {@link entity.PartnerStoreEntryID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {entity.IPartnerStoreEntryID} message PartnerStoreEntryID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntryID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerStoreEntryID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerStoreEntryID} PartnerStoreEntryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntryID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerStoreEntryID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerStoreEntryID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerStoreEntryID} PartnerStoreEntryID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntryID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerStoreEntryID message.
         * @function verify
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerStoreEntryID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a PartnerStoreEntryID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerStoreEntryID} PartnerStoreEntryID
         */
        PartnerStoreEntryID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerStoreEntryID)
                return object;
            var message = new $root.entity.PartnerStoreEntryID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a PartnerStoreEntryID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerStoreEntryID
         * @static
         * @param {entity.PartnerStoreEntryID} message PartnerStoreEntryID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerStoreEntryID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this PartnerStoreEntryID to JSON.
         * @function toJSON
         * @memberof entity.PartnerStoreEntryID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerStoreEntryID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerStoreEntryID;
    })();

    entity.PartnerStoreEntry = (function() {

        /**
         * Properties of a PartnerStoreEntry.
         * @memberof entity
         * @interface IPartnerStoreEntry
         * @property {string|null} [id] PartnerStoreEntry id
         * @property {entity.PartnerStoreEntry.Status|null} [status] PartnerStoreEntry status
         * @property {string|null} [partnerID] PartnerStoreEntry partnerID
         * @property {string|null} [customerID] PartnerStoreEntry customerID
         * @property {string|null} [customerName] PartnerStoreEntry customerName
         * @property {string|null} [customerEmail] PartnerStoreEntry customerEmail
         * @property {string|null} [customerPhoneNumber] PartnerStoreEntry customerPhoneNumber
         * @property {string|null} [referralCompanyName] PartnerStoreEntry referralCompanyName
         * @property {string|null} [referralCompanyURL] PartnerStoreEntry referralCompanyURL
         * @property {string|null} [referralCompanyAddress] PartnerStoreEntry referralCompanyAddress
         * @property {string|null} [inChargeUserName] PartnerStoreEntry inChargeUserName
         * @property {string|null} [inChargeUserDepartment] PartnerStoreEntry inChargeUserDepartment
         * @property {string|null} [inChargeUserPosition] PartnerStoreEntry inChargeUserPosition
         * @property {string|null} [inChargeUserEmail] PartnerStoreEntry inChargeUserEmail
         * @property {string|null} [inChargeUserPhoneNumber] PartnerStoreEntry inChargeUserPhoneNumber
         * @property {entity.PartnerStoreEntry.DesiredIntroductionPeriod|null} [desiredIntroductionPeriod] PartnerStoreEntry desiredIntroductionPeriod
         * @property {entity.IPartner|null} [partner] PartnerStoreEntry partner
         * @property {string|null} [createdAt] PartnerStoreEntry createdAt
         * @property {string|null} [updatedAt] PartnerStoreEntry updatedAt
         */

        /**
         * Constructs a new PartnerStoreEntry.
         * @memberof entity
         * @classdesc Represents a PartnerStoreEntry.
         * @implements IPartnerStoreEntry
         * @constructor
         * @param {entity.IPartnerStoreEntry=} [properties] Properties to set
         */
        function PartnerStoreEntry(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerStoreEntry id.
         * @member {string} id
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.id = "";

        /**
         * PartnerStoreEntry status.
         * @member {entity.PartnerStoreEntry.Status} status
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.status = 0;

        /**
         * PartnerStoreEntry partnerID.
         * @member {string} partnerID
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.partnerID = "";

        /**
         * PartnerStoreEntry customerID.
         * @member {string} customerID
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.customerID = "";

        /**
         * PartnerStoreEntry customerName.
         * @member {string} customerName
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.customerName = "";

        /**
         * PartnerStoreEntry customerEmail.
         * @member {string} customerEmail
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.customerEmail = "";

        /**
         * PartnerStoreEntry customerPhoneNumber.
         * @member {string} customerPhoneNumber
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.customerPhoneNumber = "";

        /**
         * PartnerStoreEntry referralCompanyName.
         * @member {string} referralCompanyName
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.referralCompanyName = "";

        /**
         * PartnerStoreEntry referralCompanyURL.
         * @member {string} referralCompanyURL
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.referralCompanyURL = "";

        /**
         * PartnerStoreEntry referralCompanyAddress.
         * @member {string} referralCompanyAddress
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.referralCompanyAddress = "";

        /**
         * PartnerStoreEntry inChargeUserName.
         * @member {string} inChargeUserName
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.inChargeUserName = "";

        /**
         * PartnerStoreEntry inChargeUserDepartment.
         * @member {string} inChargeUserDepartment
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.inChargeUserDepartment = "";

        /**
         * PartnerStoreEntry inChargeUserPosition.
         * @member {string} inChargeUserPosition
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.inChargeUserPosition = "";

        /**
         * PartnerStoreEntry inChargeUserEmail.
         * @member {string} inChargeUserEmail
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.inChargeUserEmail = "";

        /**
         * PartnerStoreEntry inChargeUserPhoneNumber.
         * @member {string} inChargeUserPhoneNumber
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.inChargeUserPhoneNumber = "";

        /**
         * PartnerStoreEntry desiredIntroductionPeriod.
         * @member {entity.PartnerStoreEntry.DesiredIntroductionPeriod} desiredIntroductionPeriod
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.desiredIntroductionPeriod = 0;

        /**
         * PartnerStoreEntry partner.
         * @member {entity.IPartner|null|undefined} partner
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.partner = null;

        /**
         * PartnerStoreEntry createdAt.
         * @member {string} createdAt
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.createdAt = "";

        /**
         * PartnerStoreEntry updatedAt.
         * @member {string} updatedAt
         * @memberof entity.PartnerStoreEntry
         * @instance
         */
        PartnerStoreEntry.prototype.updatedAt = "";

        /**
         * Creates a new PartnerStoreEntry instance using the specified properties.
         * @function create
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {entity.IPartnerStoreEntry=} [properties] Properties to set
         * @returns {entity.PartnerStoreEntry} PartnerStoreEntry instance
         */
        PartnerStoreEntry.create = function create(properties) {
            return new PartnerStoreEntry(properties);
        };

        /**
         * Encodes the specified PartnerStoreEntry message. Does not implicitly {@link entity.PartnerStoreEntry.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {entity.IPartnerStoreEntry} message PartnerStoreEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.partnerID != null && Object.hasOwnProperty.call(message, "partnerID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.partnerID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.customerID);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.customerName);
            if (message.customerEmail != null && Object.hasOwnProperty.call(message, "customerEmail"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.customerEmail);
            if (message.customerPhoneNumber != null && Object.hasOwnProperty.call(message, "customerPhoneNumber"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.customerPhoneNumber);
            if (message.referralCompanyName != null && Object.hasOwnProperty.call(message, "referralCompanyName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.referralCompanyName);
            if (message.referralCompanyURL != null && Object.hasOwnProperty.call(message, "referralCompanyURL"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.referralCompanyURL);
            if (message.referralCompanyAddress != null && Object.hasOwnProperty.call(message, "referralCompanyAddress"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.referralCompanyAddress);
            if (message.inChargeUserName != null && Object.hasOwnProperty.call(message, "inChargeUserName"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.inChargeUserName);
            if (message.inChargeUserDepartment != null && Object.hasOwnProperty.call(message, "inChargeUserDepartment"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.inChargeUserDepartment);
            if (message.inChargeUserPosition != null && Object.hasOwnProperty.call(message, "inChargeUserPosition"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.inChargeUserPosition);
            if (message.inChargeUserEmail != null && Object.hasOwnProperty.call(message, "inChargeUserEmail"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.inChargeUserEmail);
            if (message.inChargeUserPhoneNumber != null && Object.hasOwnProperty.call(message, "inChargeUserPhoneNumber"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.inChargeUserPhoneNumber);
            if (message.desiredIntroductionPeriod != null && Object.hasOwnProperty.call(message, "desiredIntroductionPeriod"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.desiredIntroductionPeriod);
            if (message.partner != null && Object.hasOwnProperty.call(message, "partner"))
                $root.entity.Partner.encode(message.partner, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 10000, wireType 2 =*/80002).string(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified PartnerStoreEntry message, length delimited. Does not implicitly {@link entity.PartnerStoreEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {entity.IPartnerStoreEntry} message PartnerStoreEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerStoreEntry message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerStoreEntry} PartnerStoreEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerStoreEntry();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                case 3:
                    message.partnerID = reader.string();
                    break;
                case 4:
                    message.customerID = reader.string();
                    break;
                case 5:
                    message.customerName = reader.string();
                    break;
                case 6:
                    message.customerEmail = reader.string();
                    break;
                case 7:
                    message.customerPhoneNumber = reader.string();
                    break;
                case 8:
                    message.referralCompanyName = reader.string();
                    break;
                case 9:
                    message.referralCompanyURL = reader.string();
                    break;
                case 10:
                    message.referralCompanyAddress = reader.string();
                    break;
                case 11:
                    message.inChargeUserName = reader.string();
                    break;
                case 12:
                    message.inChargeUserDepartment = reader.string();
                    break;
                case 13:
                    message.inChargeUserPosition = reader.string();
                    break;
                case 14:
                    message.inChargeUserEmail = reader.string();
                    break;
                case 15:
                    message.inChargeUserPhoneNumber = reader.string();
                    break;
                case 16:
                    message.desiredIntroductionPeriod = reader.int32();
                    break;
                case 17:
                    message.partner = $root.entity.Partner.decode(reader, reader.uint32());
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                case 10000:
                    message.updatedAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerStoreEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerStoreEntry} PartnerStoreEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerStoreEntry message.
         * @function verify
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerStoreEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.partnerID != null && message.hasOwnProperty("partnerID"))
                if (!$util.isString(message.partnerID))
                    return "partnerID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                if (!$util.isString(message.customerEmail))
                    return "customerEmail: string expected";
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                if (!$util.isString(message.customerPhoneNumber))
                    return "customerPhoneNumber: string expected";
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                if (!$util.isString(message.referralCompanyName))
                    return "referralCompanyName: string expected";
            if (message.referralCompanyURL != null && message.hasOwnProperty("referralCompanyURL"))
                if (!$util.isString(message.referralCompanyURL))
                    return "referralCompanyURL: string expected";
            if (message.referralCompanyAddress != null && message.hasOwnProperty("referralCompanyAddress"))
                if (!$util.isString(message.referralCompanyAddress))
                    return "referralCompanyAddress: string expected";
            if (message.inChargeUserName != null && message.hasOwnProperty("inChargeUserName"))
                if (!$util.isString(message.inChargeUserName))
                    return "inChargeUserName: string expected";
            if (message.inChargeUserDepartment != null && message.hasOwnProperty("inChargeUserDepartment"))
                if (!$util.isString(message.inChargeUserDepartment))
                    return "inChargeUserDepartment: string expected";
            if (message.inChargeUserPosition != null && message.hasOwnProperty("inChargeUserPosition"))
                if (!$util.isString(message.inChargeUserPosition))
                    return "inChargeUserPosition: string expected";
            if (message.inChargeUserEmail != null && message.hasOwnProperty("inChargeUserEmail"))
                if (!$util.isString(message.inChargeUserEmail))
                    return "inChargeUserEmail: string expected";
            if (message.inChargeUserPhoneNumber != null && message.hasOwnProperty("inChargeUserPhoneNumber"))
                if (!$util.isString(message.inChargeUserPhoneNumber))
                    return "inChargeUserPhoneNumber: string expected";
            if (message.desiredIntroductionPeriod != null && message.hasOwnProperty("desiredIntroductionPeriod"))
                switch (message.desiredIntroductionPeriod) {
                default:
                    return "desiredIntroductionPeriod: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.partner != null && message.hasOwnProperty("partner")) {
                var error = $root.entity.Partner.verify(message.partner);
                if (error)
                    return "partner." + error;
            }
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            return null;
        };

        /**
         * Creates a PartnerStoreEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerStoreEntry} PartnerStoreEntry
         */
        PartnerStoreEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerStoreEntry)
                return object;
            var message = new $root.entity.PartnerStoreEntry();
            if (object.id != null)
                message.id = String(object.id);
            switch (object.status) {
            case "Status_Unknown":
            case 0:
                message.status = 0;
                break;
            case "Status_Outstanding":
            case 1:
                message.status = 1;
                break;
            case "Status_InProgress":
            case 2:
                message.status = 2;
                break;
            case "Status_Contracted":
            case 3:
                message.status = 3;
                break;
            case "Status_Failed":
            case 4:
                message.status = 4;
                break;
            case "Status_OnHold":
            case 5:
                message.status = 5;
                break;
            }
            if (object.partnerID != null)
                message.partnerID = String(object.partnerID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.customerEmail != null)
                message.customerEmail = String(object.customerEmail);
            if (object.customerPhoneNumber != null)
                message.customerPhoneNumber = String(object.customerPhoneNumber);
            if (object.referralCompanyName != null)
                message.referralCompanyName = String(object.referralCompanyName);
            if (object.referralCompanyURL != null)
                message.referralCompanyURL = String(object.referralCompanyURL);
            if (object.referralCompanyAddress != null)
                message.referralCompanyAddress = String(object.referralCompanyAddress);
            if (object.inChargeUserName != null)
                message.inChargeUserName = String(object.inChargeUserName);
            if (object.inChargeUserDepartment != null)
                message.inChargeUserDepartment = String(object.inChargeUserDepartment);
            if (object.inChargeUserPosition != null)
                message.inChargeUserPosition = String(object.inChargeUserPosition);
            if (object.inChargeUserEmail != null)
                message.inChargeUserEmail = String(object.inChargeUserEmail);
            if (object.inChargeUserPhoneNumber != null)
                message.inChargeUserPhoneNumber = String(object.inChargeUserPhoneNumber);
            switch (object.desiredIntroductionPeriod) {
            case "DesiredIntroductionPeriod_Unknown":
            case 0:
                message.desiredIntroductionPeriod = 0;
                break;
            case "DesiredIntroductionPeriod_1_3_Month":
            case 1:
                message.desiredIntroductionPeriod = 1;
                break;
            case "DesiredIntroductionPeriod_3_6_Month":
            case 2:
                message.desiredIntroductionPeriod = 2;
                break;
            case "DesiredIntroductionPeriod_Over_6_Month":
            case 3:
                message.desiredIntroductionPeriod = 3;
                break;
            case "DesiredIntroductionPeriod_Undecided":
            case 4:
                message.desiredIntroductionPeriod = 4;
                break;
            }
            if (object.partner != null) {
                if (typeof object.partner !== "object")
                    throw TypeError(".entity.PartnerStoreEntry.partner: object expected");
                message.partner = $root.entity.Partner.fromObject(object.partner);
            }
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            return message;
        };

        /**
         * Creates a plain object from a PartnerStoreEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerStoreEntry
         * @static
         * @param {entity.PartnerStoreEntry} message PartnerStoreEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerStoreEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.status = options.enums === String ? "Status_Unknown" : 0;
                object.partnerID = "";
                object.customerID = "";
                object.customerName = "";
                object.customerEmail = "";
                object.customerPhoneNumber = "";
                object.referralCompanyName = "";
                object.referralCompanyURL = "";
                object.referralCompanyAddress = "";
                object.inChargeUserName = "";
                object.inChargeUserDepartment = "";
                object.inChargeUserPosition = "";
                object.inChargeUserEmail = "";
                object.inChargeUserPhoneNumber = "";
                object.desiredIntroductionPeriod = options.enums === String ? "DesiredIntroductionPeriod_Unknown" : 0;
                object.partner = null;
                object.createdAt = "";
                object.updatedAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.entity.PartnerStoreEntry.Status[message.status] : message.status;
            if (message.partnerID != null && message.hasOwnProperty("partnerID"))
                object.partnerID = message.partnerID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                object.customerEmail = message.customerEmail;
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                object.customerPhoneNumber = message.customerPhoneNumber;
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                object.referralCompanyName = message.referralCompanyName;
            if (message.referralCompanyURL != null && message.hasOwnProperty("referralCompanyURL"))
                object.referralCompanyURL = message.referralCompanyURL;
            if (message.referralCompanyAddress != null && message.hasOwnProperty("referralCompanyAddress"))
                object.referralCompanyAddress = message.referralCompanyAddress;
            if (message.inChargeUserName != null && message.hasOwnProperty("inChargeUserName"))
                object.inChargeUserName = message.inChargeUserName;
            if (message.inChargeUserDepartment != null && message.hasOwnProperty("inChargeUserDepartment"))
                object.inChargeUserDepartment = message.inChargeUserDepartment;
            if (message.inChargeUserPosition != null && message.hasOwnProperty("inChargeUserPosition"))
                object.inChargeUserPosition = message.inChargeUserPosition;
            if (message.inChargeUserEmail != null && message.hasOwnProperty("inChargeUserEmail"))
                object.inChargeUserEmail = message.inChargeUserEmail;
            if (message.inChargeUserPhoneNumber != null && message.hasOwnProperty("inChargeUserPhoneNumber"))
                object.inChargeUserPhoneNumber = message.inChargeUserPhoneNumber;
            if (message.desiredIntroductionPeriod != null && message.hasOwnProperty("desiredIntroductionPeriod"))
                object.desiredIntroductionPeriod = options.enums === String ? $root.entity.PartnerStoreEntry.DesiredIntroductionPeriod[message.desiredIntroductionPeriod] : message.desiredIntroductionPeriod;
            if (message.partner != null && message.hasOwnProperty("partner"))
                object.partner = $root.entity.Partner.toObject(message.partner, options);
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            return object;
        };

        /**
         * Converts this PartnerStoreEntry to JSON.
         * @function toJSON
         * @memberof entity.PartnerStoreEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerStoreEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Status enum.
         * @name entity.PartnerStoreEntry.Status
         * @enum {number}
         * @property {number} Status_Unknown=0 Status_Unknown value
         * @property {number} Status_Outstanding=1 Status_Outstanding value
         * @property {number} Status_InProgress=2 Status_InProgress value
         * @property {number} Status_Contracted=3 Status_Contracted value
         * @property {number} Status_Failed=4 Status_Failed value
         * @property {number} Status_OnHold=5 Status_OnHold value
         */
        PartnerStoreEntry.Status = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Status_Unknown"] = 0;
            values[valuesById[1] = "Status_Outstanding"] = 1;
            values[valuesById[2] = "Status_InProgress"] = 2;
            values[valuesById[3] = "Status_Contracted"] = 3;
            values[valuesById[4] = "Status_Failed"] = 4;
            values[valuesById[5] = "Status_OnHold"] = 5;
            return values;
        })();

        /**
         * DesiredIntroductionPeriod enum.
         * @name entity.PartnerStoreEntry.DesiredIntroductionPeriod
         * @enum {number}
         * @property {number} DesiredIntroductionPeriod_Unknown=0 DesiredIntroductionPeriod_Unknown value
         * @property {number} DesiredIntroductionPeriod_1_3_Month=1 DesiredIntroductionPeriod_1_3_Month value
         * @property {number} DesiredIntroductionPeriod_3_6_Month=2 DesiredIntroductionPeriod_3_6_Month value
         * @property {number} DesiredIntroductionPeriod_Over_6_Month=3 DesiredIntroductionPeriod_Over_6_Month value
         * @property {number} DesiredIntroductionPeriod_Undecided=4 DesiredIntroductionPeriod_Undecided value
         */
        PartnerStoreEntry.DesiredIntroductionPeriod = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "DesiredIntroductionPeriod_Unknown"] = 0;
            values[valuesById[1] = "DesiredIntroductionPeriod_1_3_Month"] = 1;
            values[valuesById[2] = "DesiredIntroductionPeriod_3_6_Month"] = 2;
            values[valuesById[3] = "DesiredIntroductionPeriod_Over_6_Month"] = 3;
            values[valuesById[4] = "DesiredIntroductionPeriod_Undecided"] = 4;
            return values;
        })();

        return PartnerStoreEntry;
    })();

    entity.PartnerStoreEntryList = (function() {

        /**
         * Properties of a PartnerStoreEntryList.
         * @memberof entity
         * @interface IPartnerStoreEntryList
         * @property {Array.<entity.IPartnerStoreEntry>|null} [items] PartnerStoreEntryList items
         */

        /**
         * Constructs a new PartnerStoreEntryList.
         * @memberof entity
         * @classdesc Represents a PartnerStoreEntryList.
         * @implements IPartnerStoreEntryList
         * @constructor
         * @param {entity.IPartnerStoreEntryList=} [properties] Properties to set
         */
        function PartnerStoreEntryList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerStoreEntryList items.
         * @member {Array.<entity.IPartnerStoreEntry>} items
         * @memberof entity.PartnerStoreEntryList
         * @instance
         */
        PartnerStoreEntryList.prototype.items = $util.emptyArray;

        /**
         * Creates a new PartnerStoreEntryList instance using the specified properties.
         * @function create
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {entity.IPartnerStoreEntryList=} [properties] Properties to set
         * @returns {entity.PartnerStoreEntryList} PartnerStoreEntryList instance
         */
        PartnerStoreEntryList.create = function create(properties) {
            return new PartnerStoreEntryList(properties);
        };

        /**
         * Encodes the specified PartnerStoreEntryList message. Does not implicitly {@link entity.PartnerStoreEntryList.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {entity.IPartnerStoreEntryList} message PartnerStoreEntryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntryList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.PartnerStoreEntry.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PartnerStoreEntryList message, length delimited. Does not implicitly {@link entity.PartnerStoreEntryList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {entity.IPartnerStoreEntryList} message PartnerStoreEntryList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerStoreEntryList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerStoreEntryList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerStoreEntryList} PartnerStoreEntryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntryList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerStoreEntryList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.PartnerStoreEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerStoreEntryList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerStoreEntryList} PartnerStoreEntryList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerStoreEntryList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerStoreEntryList message.
         * @function verify
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerStoreEntryList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.PartnerStoreEntry.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PartnerStoreEntryList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerStoreEntryList} PartnerStoreEntryList
         */
        PartnerStoreEntryList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerStoreEntryList)
                return object;
            var message = new $root.entity.PartnerStoreEntryList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.PartnerStoreEntryList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.PartnerStoreEntryList.items: object expected");
                    message.items[i] = $root.entity.PartnerStoreEntry.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PartnerStoreEntryList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerStoreEntryList
         * @static
         * @param {entity.PartnerStoreEntryList} message PartnerStoreEntryList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerStoreEntryList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.PartnerStoreEntry.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this PartnerStoreEntryList to JSON.
         * @function toJSON
         * @memberof entity.PartnerStoreEntryList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerStoreEntryList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerStoreEntryList;
    })();

    entity.PartnerID = (function() {

        /**
         * Properties of a PartnerID.
         * @memberof entity
         * @interface IPartnerID
         * @property {string|null} [id] PartnerID id
         */

        /**
         * Constructs a new PartnerID.
         * @memberof entity
         * @classdesc Represents a PartnerID.
         * @implements IPartnerID
         * @constructor
         * @param {entity.IPartnerID=} [properties] Properties to set
         */
        function PartnerID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerID id.
         * @member {string} id
         * @memberof entity.PartnerID
         * @instance
         */
        PartnerID.prototype.id = "";

        /**
         * Creates a new PartnerID instance using the specified properties.
         * @function create
         * @memberof entity.PartnerID
         * @static
         * @param {entity.IPartnerID=} [properties] Properties to set
         * @returns {entity.PartnerID} PartnerID instance
         */
        PartnerID.create = function create(properties) {
            return new PartnerID(properties);
        };

        /**
         * Encodes the specified PartnerID message. Does not implicitly {@link entity.PartnerID.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerID
         * @static
         * @param {entity.IPartnerID} message PartnerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified PartnerID message, length delimited. Does not implicitly {@link entity.PartnerID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerID
         * @static
         * @param {entity.IPartnerID} message PartnerID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerID} PartnerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerID} PartnerID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerID message.
         * @function verify
         * @memberof entity.PartnerID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a PartnerID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerID} PartnerID
         */
        PartnerID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerID)
                return object;
            var message = new $root.entity.PartnerID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a PartnerID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerID
         * @static
         * @param {entity.PartnerID} message PartnerID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this PartnerID to JSON.
         * @function toJSON
         * @memberof entity.PartnerID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerID;
    })();

    entity.Partner = (function() {

        /**
         * Properties of a Partner.
         * @memberof entity
         * @interface IPartner
         * @property {string|null} [id] Partner id
         * @property {string|null} [companyName] Partner companyName
         * @property {string|null} [serviceName] Partner serviceName
         * @property {string|null} [serviceURL] Partner serviceURL
         * @property {string|null} [serviceDocumentURL] Partner serviceDocumentURL
         * @property {string|null} [signedServiceDocumentURL] Partner signedServiceDocumentURL
         * @property {string|null} [thumbnailURL] Partner thumbnailURL
         * @property {string|null} [signedThumbnailURL] Partner signedThumbnailURL
         * @property {string|null} [serviceIntroduction] Partner serviceIntroduction
         * @property {string|null} [customerIncentive] Partner customerIncentive
         * @property {string|null} [companyIncentive] Partner companyIncentive
         * @property {string|null} [liberaIncentive] Partner liberaIncentive
         * @property {Array.<entity.Partner.IInChargeUser>|null} [inChargeUsers] Partner inChargeUsers
         * @property {entity.Partner.ICategory|null} [category] Partner category
         * @property {string|null} [createdAt] Partner createdAt
         * @property {string|null} [updatedAt] Partner updatedAt
         */

        /**
         * Constructs a new Partner.
         * @memberof entity
         * @classdesc Represents a Partner.
         * @implements IPartner
         * @constructor
         * @param {entity.IPartner=} [properties] Properties to set
         */
        function Partner(properties) {
            this.inChargeUsers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Partner id.
         * @member {string} id
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.id = "";

        /**
         * Partner companyName.
         * @member {string} companyName
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.companyName = "";

        /**
         * Partner serviceName.
         * @member {string} serviceName
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.serviceName = "";

        /**
         * Partner serviceURL.
         * @member {string} serviceURL
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.serviceURL = "";

        /**
         * Partner serviceDocumentURL.
         * @member {string} serviceDocumentURL
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.serviceDocumentURL = "";

        /**
         * Partner signedServiceDocumentURL.
         * @member {string} signedServiceDocumentURL
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.signedServiceDocumentURL = "";

        /**
         * Partner thumbnailURL.
         * @member {string} thumbnailURL
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.thumbnailURL = "";

        /**
         * Partner signedThumbnailURL.
         * @member {string} signedThumbnailURL
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.signedThumbnailURL = "";

        /**
         * Partner serviceIntroduction.
         * @member {string} serviceIntroduction
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.serviceIntroduction = "";

        /**
         * Partner customerIncentive.
         * @member {string} customerIncentive
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.customerIncentive = "";

        /**
         * Partner companyIncentive.
         * @member {string} companyIncentive
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.companyIncentive = "";

        /**
         * Partner liberaIncentive.
         * @member {string} liberaIncentive
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.liberaIncentive = "";

        /**
         * Partner inChargeUsers.
         * @member {Array.<entity.Partner.IInChargeUser>} inChargeUsers
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.inChargeUsers = $util.emptyArray;

        /**
         * Partner category.
         * @member {entity.Partner.ICategory|null|undefined} category
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.category = null;

        /**
         * Partner createdAt.
         * @member {string} createdAt
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.createdAt = "";

        /**
         * Partner updatedAt.
         * @member {string} updatedAt
         * @memberof entity.Partner
         * @instance
         */
        Partner.prototype.updatedAt = "";

        /**
         * Creates a new Partner instance using the specified properties.
         * @function create
         * @memberof entity.Partner
         * @static
         * @param {entity.IPartner=} [properties] Properties to set
         * @returns {entity.Partner} Partner instance
         */
        Partner.create = function create(properties) {
            return new Partner(properties);
        };

        /**
         * Encodes the specified Partner message. Does not implicitly {@link entity.Partner.verify|verify} messages.
         * @function encode
         * @memberof entity.Partner
         * @static
         * @param {entity.IPartner} message Partner message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Partner.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyName);
            if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.serviceName);
            if (message.serviceURL != null && Object.hasOwnProperty.call(message, "serviceURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.serviceURL);
            if (message.serviceDocumentURL != null && Object.hasOwnProperty.call(message, "serviceDocumentURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.serviceDocumentURL);
            if (message.signedServiceDocumentURL != null && Object.hasOwnProperty.call(message, "signedServiceDocumentURL"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.signedServiceDocumentURL);
            if (message.thumbnailURL != null && Object.hasOwnProperty.call(message, "thumbnailURL"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.thumbnailURL);
            if (message.signedThumbnailURL != null && Object.hasOwnProperty.call(message, "signedThumbnailURL"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.signedThumbnailURL);
            if (message.serviceIntroduction != null && Object.hasOwnProperty.call(message, "serviceIntroduction"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.serviceIntroduction);
            if (message.customerIncentive != null && Object.hasOwnProperty.call(message, "customerIncentive"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.customerIncentive);
            if (message.companyIncentive != null && Object.hasOwnProperty.call(message, "companyIncentive"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.companyIncentive);
            if (message.liberaIncentive != null && Object.hasOwnProperty.call(message, "liberaIncentive"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.liberaIncentive);
            if (message.inChargeUsers != null && message.inChargeUsers.length)
                for (var i = 0; i < message.inChargeUsers.length; ++i)
                    $root.entity.Partner.InChargeUser.encode(message.inChargeUsers[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                $root.entity.Partner.Category.encode(message.category, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 10000, wireType 2 =*/80002).string(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified Partner message, length delimited. Does not implicitly {@link entity.Partner.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Partner
         * @static
         * @param {entity.IPartner} message Partner message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Partner.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Partner message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Partner
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Partner} Partner
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Partner.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Partner();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyName = reader.string();
                    break;
                case 3:
                    message.serviceName = reader.string();
                    break;
                case 4:
                    message.serviceURL = reader.string();
                    break;
                case 5:
                    message.serviceDocumentURL = reader.string();
                    break;
                case 6:
                    message.signedServiceDocumentURL = reader.string();
                    break;
                case 7:
                    message.thumbnailURL = reader.string();
                    break;
                case 8:
                    message.signedThumbnailURL = reader.string();
                    break;
                case 9:
                    message.serviceIntroduction = reader.string();
                    break;
                case 10:
                    message.customerIncentive = reader.string();
                    break;
                case 11:
                    message.companyIncentive = reader.string();
                    break;
                case 12:
                    message.liberaIncentive = reader.string();
                    break;
                case 13:
                    if (!(message.inChargeUsers && message.inChargeUsers.length))
                        message.inChargeUsers = [];
                    message.inChargeUsers.push($root.entity.Partner.InChargeUser.decode(reader, reader.uint32()));
                    break;
                case 14:
                    message.category = $root.entity.Partner.Category.decode(reader, reader.uint32());
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                case 10000:
                    message.updatedAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Partner message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Partner
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Partner} Partner
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Partner.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Partner message.
         * @function verify
         * @memberof entity.Partner
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Partner.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                if (!$util.isString(message.serviceName))
                    return "serviceName: string expected";
            if (message.serviceURL != null && message.hasOwnProperty("serviceURL"))
                if (!$util.isString(message.serviceURL))
                    return "serviceURL: string expected";
            if (message.serviceDocumentURL != null && message.hasOwnProperty("serviceDocumentURL"))
                if (!$util.isString(message.serviceDocumentURL))
                    return "serviceDocumentURL: string expected";
            if (message.signedServiceDocumentURL != null && message.hasOwnProperty("signedServiceDocumentURL"))
                if (!$util.isString(message.signedServiceDocumentURL))
                    return "signedServiceDocumentURL: string expected";
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                if (!$util.isString(message.thumbnailURL))
                    return "thumbnailURL: string expected";
            if (message.signedThumbnailURL != null && message.hasOwnProperty("signedThumbnailURL"))
                if (!$util.isString(message.signedThumbnailURL))
                    return "signedThumbnailURL: string expected";
            if (message.serviceIntroduction != null && message.hasOwnProperty("serviceIntroduction"))
                if (!$util.isString(message.serviceIntroduction))
                    return "serviceIntroduction: string expected";
            if (message.customerIncentive != null && message.hasOwnProperty("customerIncentive"))
                if (!$util.isString(message.customerIncentive))
                    return "customerIncentive: string expected";
            if (message.companyIncentive != null && message.hasOwnProperty("companyIncentive"))
                if (!$util.isString(message.companyIncentive))
                    return "companyIncentive: string expected";
            if (message.liberaIncentive != null && message.hasOwnProperty("liberaIncentive"))
                if (!$util.isString(message.liberaIncentive))
                    return "liberaIncentive: string expected";
            if (message.inChargeUsers != null && message.hasOwnProperty("inChargeUsers")) {
                if (!Array.isArray(message.inChargeUsers))
                    return "inChargeUsers: array expected";
                for (var i = 0; i < message.inChargeUsers.length; ++i) {
                    var error = $root.entity.Partner.InChargeUser.verify(message.inChargeUsers[i]);
                    if (error)
                        return "inChargeUsers." + error;
                }
            }
            if (message.category != null && message.hasOwnProperty("category")) {
                var error = $root.entity.Partner.Category.verify(message.category);
                if (error)
                    return "category." + error;
            }
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            return null;
        };

        /**
         * Creates a Partner message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Partner
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Partner} Partner
         */
        Partner.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Partner)
                return object;
            var message = new $root.entity.Partner();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.serviceName != null)
                message.serviceName = String(object.serviceName);
            if (object.serviceURL != null)
                message.serviceURL = String(object.serviceURL);
            if (object.serviceDocumentURL != null)
                message.serviceDocumentURL = String(object.serviceDocumentURL);
            if (object.signedServiceDocumentURL != null)
                message.signedServiceDocumentURL = String(object.signedServiceDocumentURL);
            if (object.thumbnailURL != null)
                message.thumbnailURL = String(object.thumbnailURL);
            if (object.signedThumbnailURL != null)
                message.signedThumbnailURL = String(object.signedThumbnailURL);
            if (object.serviceIntroduction != null)
                message.serviceIntroduction = String(object.serviceIntroduction);
            if (object.customerIncentive != null)
                message.customerIncentive = String(object.customerIncentive);
            if (object.companyIncentive != null)
                message.companyIncentive = String(object.companyIncentive);
            if (object.liberaIncentive != null)
                message.liberaIncentive = String(object.liberaIncentive);
            if (object.inChargeUsers) {
                if (!Array.isArray(object.inChargeUsers))
                    throw TypeError(".entity.Partner.inChargeUsers: array expected");
                message.inChargeUsers = [];
                for (var i = 0; i < object.inChargeUsers.length; ++i) {
                    if (typeof object.inChargeUsers[i] !== "object")
                        throw TypeError(".entity.Partner.inChargeUsers: object expected");
                    message.inChargeUsers[i] = $root.entity.Partner.InChargeUser.fromObject(object.inChargeUsers[i]);
                }
            }
            if (object.category != null) {
                if (typeof object.category !== "object")
                    throw TypeError(".entity.Partner.category: object expected");
                message.category = $root.entity.Partner.Category.fromObject(object.category);
            }
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            return message;
        };

        /**
         * Creates a plain object from a Partner message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Partner
         * @static
         * @param {entity.Partner} message Partner
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Partner.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.inChargeUsers = [];
            if (options.defaults) {
                object.id = "";
                object.companyName = "";
                object.serviceName = "";
                object.serviceURL = "";
                object.serviceDocumentURL = "";
                object.signedServiceDocumentURL = "";
                object.thumbnailURL = "";
                object.signedThumbnailURL = "";
                object.serviceIntroduction = "";
                object.customerIncentive = "";
                object.companyIncentive = "";
                object.liberaIncentive = "";
                object.category = null;
                object.createdAt = "";
                object.updatedAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                object.serviceName = message.serviceName;
            if (message.serviceURL != null && message.hasOwnProperty("serviceURL"))
                object.serviceURL = message.serviceURL;
            if (message.serviceDocumentURL != null && message.hasOwnProperty("serviceDocumentURL"))
                object.serviceDocumentURL = message.serviceDocumentURL;
            if (message.signedServiceDocumentURL != null && message.hasOwnProperty("signedServiceDocumentURL"))
                object.signedServiceDocumentURL = message.signedServiceDocumentURL;
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                object.thumbnailURL = message.thumbnailURL;
            if (message.signedThumbnailURL != null && message.hasOwnProperty("signedThumbnailURL"))
                object.signedThumbnailURL = message.signedThumbnailURL;
            if (message.serviceIntroduction != null && message.hasOwnProperty("serviceIntroduction"))
                object.serviceIntroduction = message.serviceIntroduction;
            if (message.customerIncentive != null && message.hasOwnProperty("customerIncentive"))
                object.customerIncentive = message.customerIncentive;
            if (message.companyIncentive != null && message.hasOwnProperty("companyIncentive"))
                object.companyIncentive = message.companyIncentive;
            if (message.liberaIncentive != null && message.hasOwnProperty("liberaIncentive"))
                object.liberaIncentive = message.liberaIncentive;
            if (message.inChargeUsers && message.inChargeUsers.length) {
                object.inChargeUsers = [];
                for (var j = 0; j < message.inChargeUsers.length; ++j)
                    object.inChargeUsers[j] = $root.entity.Partner.InChargeUser.toObject(message.inChargeUsers[j], options);
            }
            if (message.category != null && message.hasOwnProperty("category"))
                object.category = $root.entity.Partner.Category.toObject(message.category, options);
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            return object;
        };

        /**
         * Converts this Partner to JSON.
         * @function toJSON
         * @memberof entity.Partner
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Partner.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Partner.InChargeUser = (function() {

            /**
             * Properties of an InChargeUser.
             * @memberof entity.Partner
             * @interface IInChargeUser
             * @property {string|null} [name] InChargeUser name
             * @property {string|null} [email] InChargeUser email
             * @property {string|null} [phoneNumber] InChargeUser phoneNumber
             */

            /**
             * Constructs a new InChargeUser.
             * @memberof entity.Partner
             * @classdesc Represents an InChargeUser.
             * @implements IInChargeUser
             * @constructor
             * @param {entity.Partner.IInChargeUser=} [properties] Properties to set
             */
            function InChargeUser(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * InChargeUser name.
             * @member {string} name
             * @memberof entity.Partner.InChargeUser
             * @instance
             */
            InChargeUser.prototype.name = "";

            /**
             * InChargeUser email.
             * @member {string} email
             * @memberof entity.Partner.InChargeUser
             * @instance
             */
            InChargeUser.prototype.email = "";

            /**
             * InChargeUser phoneNumber.
             * @member {string} phoneNumber
             * @memberof entity.Partner.InChargeUser
             * @instance
             */
            InChargeUser.prototype.phoneNumber = "";

            /**
             * Creates a new InChargeUser instance using the specified properties.
             * @function create
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {entity.Partner.IInChargeUser=} [properties] Properties to set
             * @returns {entity.Partner.InChargeUser} InChargeUser instance
             */
            InChargeUser.create = function create(properties) {
                return new InChargeUser(properties);
            };

            /**
             * Encodes the specified InChargeUser message. Does not implicitly {@link entity.Partner.InChargeUser.verify|verify} messages.
             * @function encode
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {entity.Partner.IInChargeUser} message InChargeUser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InChargeUser.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
                if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.phoneNumber);
                return writer;
            };

            /**
             * Encodes the specified InChargeUser message, length delimited. Does not implicitly {@link entity.Partner.InChargeUser.verify|verify} messages.
             * @function encodeDelimited
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {entity.Partner.IInChargeUser} message InChargeUser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InChargeUser.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InChargeUser message from the specified reader or buffer.
             * @function decode
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {entity.Partner.InChargeUser} InChargeUser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InChargeUser.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Partner.InChargeUser();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.email = reader.string();
                        break;
                    case 3:
                        message.phoneNumber = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InChargeUser message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {entity.Partner.InChargeUser} InChargeUser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InChargeUser.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InChargeUser message.
             * @function verify
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InChargeUser.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.email != null && message.hasOwnProperty("email"))
                    if (!$util.isString(message.email))
                        return "email: string expected";
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    if (!$util.isString(message.phoneNumber))
                        return "phoneNumber: string expected";
                return null;
            };

            /**
             * Creates an InChargeUser message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {entity.Partner.InChargeUser} InChargeUser
             */
            InChargeUser.fromObject = function fromObject(object) {
                if (object instanceof $root.entity.Partner.InChargeUser)
                    return object;
                var message = new $root.entity.Partner.InChargeUser();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.email != null)
                    message.email = String(object.email);
                if (object.phoneNumber != null)
                    message.phoneNumber = String(object.phoneNumber);
                return message;
            };

            /**
             * Creates a plain object from an InChargeUser message. Also converts values to other types if specified.
             * @function toObject
             * @memberof entity.Partner.InChargeUser
             * @static
             * @param {entity.Partner.InChargeUser} message InChargeUser
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InChargeUser.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.email = "";
                    object.phoneNumber = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.email != null && message.hasOwnProperty("email"))
                    object.email = message.email;
                if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                    object.phoneNumber = message.phoneNumber;
                return object;
            };

            /**
             * Converts this InChargeUser to JSON.
             * @function toJSON
             * @memberof entity.Partner.InChargeUser
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InChargeUser.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return InChargeUser;
        })();

        Partner.Category = (function() {

            /**
             * Properties of a Category.
             * @memberof entity.Partner
             * @interface ICategory
             * @property {string|null} [id] Category id
             * @property {string|null} [name] Category name
             */

            /**
             * Constructs a new Category.
             * @memberof entity.Partner
             * @classdesc Represents a Category.
             * @implements ICategory
             * @constructor
             * @param {entity.Partner.ICategory=} [properties] Properties to set
             */
            function Category(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Category id.
             * @member {string} id
             * @memberof entity.Partner.Category
             * @instance
             */
            Category.prototype.id = "";

            /**
             * Category name.
             * @member {string} name
             * @memberof entity.Partner.Category
             * @instance
             */
            Category.prototype.name = "";

            /**
             * Creates a new Category instance using the specified properties.
             * @function create
             * @memberof entity.Partner.Category
             * @static
             * @param {entity.Partner.ICategory=} [properties] Properties to set
             * @returns {entity.Partner.Category} Category instance
             */
            Category.create = function create(properties) {
                return new Category(properties);
            };

            /**
             * Encodes the specified Category message. Does not implicitly {@link entity.Partner.Category.verify|verify} messages.
             * @function encode
             * @memberof entity.Partner.Category
             * @static
             * @param {entity.Partner.ICategory} message Category message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Category.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                return writer;
            };

            /**
             * Encodes the specified Category message, length delimited. Does not implicitly {@link entity.Partner.Category.verify|verify} messages.
             * @function encodeDelimited
             * @memberof entity.Partner.Category
             * @static
             * @param {entity.Partner.ICategory} message Category message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Category.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Category message from the specified reader or buffer.
             * @function decode
             * @memberof entity.Partner.Category
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {entity.Partner.Category} Category
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Category.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Partner.Category();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Category message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof entity.Partner.Category
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {entity.Partner.Category} Category
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Category.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Category message.
             * @function verify
             * @memberof entity.Partner.Category
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Category.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                return null;
            };

            /**
             * Creates a Category message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof entity.Partner.Category
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {entity.Partner.Category} Category
             */
            Category.fromObject = function fromObject(object) {
                if (object instanceof $root.entity.Partner.Category)
                    return object;
                var message = new $root.entity.Partner.Category();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                return message;
            };

            /**
             * Creates a plain object from a Category message. Also converts values to other types if specified.
             * @function toObject
             * @memberof entity.Partner.Category
             * @static
             * @param {entity.Partner.Category} message Category
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Category.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                return object;
            };

            /**
             * Converts this Category to JSON.
             * @function toJSON
             * @memberof entity.Partner.Category
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Category.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Category;
        })();

        return Partner;
    })();

    entity.PartnerList = (function() {

        /**
         * Properties of a PartnerList.
         * @memberof entity
         * @interface IPartnerList
         * @property {Array.<entity.IPartner>|null} [items] PartnerList items
         */

        /**
         * Constructs a new PartnerList.
         * @memberof entity
         * @classdesc Represents a PartnerList.
         * @implements IPartnerList
         * @constructor
         * @param {entity.IPartnerList=} [properties] Properties to set
         */
        function PartnerList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartnerList items.
         * @member {Array.<entity.IPartner>} items
         * @memberof entity.PartnerList
         * @instance
         */
        PartnerList.prototype.items = $util.emptyArray;

        /**
         * Creates a new PartnerList instance using the specified properties.
         * @function create
         * @memberof entity.PartnerList
         * @static
         * @param {entity.IPartnerList=} [properties] Properties to set
         * @returns {entity.PartnerList} PartnerList instance
         */
        PartnerList.create = function create(properties) {
            return new PartnerList(properties);
        };

        /**
         * Encodes the specified PartnerList message. Does not implicitly {@link entity.PartnerList.verify|verify} messages.
         * @function encode
         * @memberof entity.PartnerList
         * @static
         * @param {entity.IPartnerList} message PartnerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Partner.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PartnerList message, length delimited. Does not implicitly {@link entity.PartnerList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PartnerList
         * @static
         * @param {entity.IPartnerList} message PartnerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartnerList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartnerList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PartnerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PartnerList} PartnerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PartnerList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Partner.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartnerList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PartnerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PartnerList} PartnerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartnerList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartnerList message.
         * @function verify
         * @memberof entity.PartnerList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartnerList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Partner.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PartnerList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PartnerList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PartnerList} PartnerList
         */
        PartnerList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PartnerList)
                return object;
            var message = new $root.entity.PartnerList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.PartnerList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.PartnerList.items: object expected");
                    message.items[i] = $root.entity.Partner.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PartnerList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PartnerList
         * @static
         * @param {entity.PartnerList} message PartnerList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartnerList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Partner.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this PartnerList to JSON.
         * @function toJSON
         * @memberof entity.PartnerList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartnerList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartnerList;
    })();

    entity.PastCaseProjectID = (function() {

        /**
         * Properties of a PastCaseProjectID.
         * @memberof entity
         * @interface IPastCaseProjectID
         * @property {string|null} [id] PastCaseProjectID id
         */

        /**
         * Constructs a new PastCaseProjectID.
         * @memberof entity
         * @classdesc Represents a PastCaseProjectID.
         * @implements IPastCaseProjectID
         * @constructor
         * @param {entity.IPastCaseProjectID=} [properties] Properties to set
         */
        function PastCaseProjectID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PastCaseProjectID id.
         * @member {string} id
         * @memberof entity.PastCaseProjectID
         * @instance
         */
        PastCaseProjectID.prototype.id = "";

        /**
         * Creates a new PastCaseProjectID instance using the specified properties.
         * @function create
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {entity.IPastCaseProjectID=} [properties] Properties to set
         * @returns {entity.PastCaseProjectID} PastCaseProjectID instance
         */
        PastCaseProjectID.create = function create(properties) {
            return new PastCaseProjectID(properties);
        };

        /**
         * Encodes the specified PastCaseProjectID message. Does not implicitly {@link entity.PastCaseProjectID.verify|verify} messages.
         * @function encode
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {entity.IPastCaseProjectID} message PastCaseProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProjectID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified PastCaseProjectID message, length delimited. Does not implicitly {@link entity.PastCaseProjectID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {entity.IPastCaseProjectID} message PastCaseProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProjectID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PastCaseProjectID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PastCaseProjectID} PastCaseProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProjectID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PastCaseProjectID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PastCaseProjectID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PastCaseProjectID} PastCaseProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProjectID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PastCaseProjectID message.
         * @function verify
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PastCaseProjectID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a PastCaseProjectID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PastCaseProjectID} PastCaseProjectID
         */
        PastCaseProjectID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PastCaseProjectID)
                return object;
            var message = new $root.entity.PastCaseProjectID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a PastCaseProjectID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PastCaseProjectID
         * @static
         * @param {entity.PastCaseProjectID} message PastCaseProjectID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PastCaseProjectID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this PastCaseProjectID to JSON.
         * @function toJSON
         * @memberof entity.PastCaseProjectID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PastCaseProjectID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PastCaseProjectID;
    })();

    entity.PastCaseProject = (function() {

        /**
         * Properties of a PastCaseProject.
         * @memberof entity
         * @interface IPastCaseProject
         * @property {string|null} [id] PastCaseProject id
         * @property {string|null} [title] PastCaseProject title
         * @property {number|null} [meetingNum] PastCaseProject meetingNum
         * @property {entity.PastCaseProject.Interval|null} [meetingInterval] PastCaseProject meetingInterval
         * @property {number|null} [meetingMinutes] PastCaseProject meetingMinutes
         * @property {number|null} [workingHour] PastCaseProject workingHour
         * @property {entity.PastCaseProject.Interval|null} [workingInterval] PastCaseProject workingInterval
         * @property {number|null} [feePerMonth] PastCaseProject feePerMonth
         * @property {entity.PastCaseProject.WorkLocation|null} [workLocation] PastCaseProject workLocation
         * @property {entity.PastCaseProject.WorkCommunication|null} [workCommunication] PastCaseProject workCommunication
         * @property {entity.PastCaseProject.WorkDetail|null} [workDetail] PastCaseProject workDetail
         * @property {string|null} [achievementReward] PastCaseProject achievementReward
         * @property {string|null} [createdAt] PastCaseProject createdAt
         * @property {string|null} [updatedAt] PastCaseProject updatedAt
         */

        /**
         * Constructs a new PastCaseProject.
         * @memberof entity
         * @classdesc Represents a PastCaseProject.
         * @implements IPastCaseProject
         * @constructor
         * @param {entity.IPastCaseProject=} [properties] Properties to set
         */
        function PastCaseProject(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PastCaseProject id.
         * @member {string} id
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.id = "";

        /**
         * PastCaseProject title.
         * @member {string} title
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.title = "";

        /**
         * PastCaseProject meetingNum.
         * @member {number} meetingNum
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.meetingNum = 0;

        /**
         * PastCaseProject meetingInterval.
         * @member {entity.PastCaseProject.Interval} meetingInterval
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.meetingInterval = 0;

        /**
         * PastCaseProject meetingMinutes.
         * @member {number} meetingMinutes
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.meetingMinutes = 0;

        /**
         * PastCaseProject workingHour.
         * @member {number} workingHour
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.workingHour = 0;

        /**
         * PastCaseProject workingInterval.
         * @member {entity.PastCaseProject.Interval} workingInterval
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.workingInterval = 0;

        /**
         * PastCaseProject feePerMonth.
         * @member {number} feePerMonth
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.feePerMonth = 0;

        /**
         * PastCaseProject workLocation.
         * @member {entity.PastCaseProject.WorkLocation} workLocation
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.workLocation = 0;

        /**
         * PastCaseProject workCommunication.
         * @member {entity.PastCaseProject.WorkCommunication} workCommunication
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.workCommunication = 0;

        /**
         * PastCaseProject workDetail.
         * @member {entity.PastCaseProject.WorkDetail} workDetail
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.workDetail = 0;

        /**
         * PastCaseProject achievementReward.
         * @member {string} achievementReward
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.achievementReward = "";

        /**
         * PastCaseProject createdAt.
         * @member {string} createdAt
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.createdAt = "";

        /**
         * PastCaseProject updatedAt.
         * @member {string} updatedAt
         * @memberof entity.PastCaseProject
         * @instance
         */
        PastCaseProject.prototype.updatedAt = "";

        /**
         * Creates a new PastCaseProject instance using the specified properties.
         * @function create
         * @memberof entity.PastCaseProject
         * @static
         * @param {entity.IPastCaseProject=} [properties] Properties to set
         * @returns {entity.PastCaseProject} PastCaseProject instance
         */
        PastCaseProject.create = function create(properties) {
            return new PastCaseProject(properties);
        };

        /**
         * Encodes the specified PastCaseProject message. Does not implicitly {@link entity.PastCaseProject.verify|verify} messages.
         * @function encode
         * @memberof entity.PastCaseProject
         * @static
         * @param {entity.IPastCaseProject} message PastCaseProject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProject.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.meetingNum != null && Object.hasOwnProperty.call(message, "meetingNum"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.meetingNum);
            if (message.meetingInterval != null && Object.hasOwnProperty.call(message, "meetingInterval"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.meetingInterval);
            if (message.meetingMinutes != null && Object.hasOwnProperty.call(message, "meetingMinutes"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.meetingMinutes);
            if (message.workingHour != null && Object.hasOwnProperty.call(message, "workingHour"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.workingHour);
            if (message.workingInterval != null && Object.hasOwnProperty.call(message, "workingInterval"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.workingInterval);
            if (message.feePerMonth != null && Object.hasOwnProperty.call(message, "feePerMonth"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.feePerMonth);
            if (message.workLocation != null && Object.hasOwnProperty.call(message, "workLocation"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workLocation);
            if (message.workCommunication != null && Object.hasOwnProperty.call(message, "workCommunication"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workCommunication);
            if (message.workDetail != null && Object.hasOwnProperty.call(message, "workDetail"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.workDetail);
            if (message.achievementReward != null && Object.hasOwnProperty.call(message, "achievementReward"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.achievementReward);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified PastCaseProject message, length delimited. Does not implicitly {@link entity.PastCaseProject.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PastCaseProject
         * @static
         * @param {entity.IPastCaseProject} message PastCaseProject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProject.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PastCaseProject message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PastCaseProject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PastCaseProject} PastCaseProject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProject.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PastCaseProject();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 3:
                    message.meetingNum = reader.int32();
                    break;
                case 4:
                    message.meetingInterval = reader.int32();
                    break;
                case 5:
                    message.meetingMinutes = reader.int32();
                    break;
                case 6:
                    message.workingHour = reader.int32();
                    break;
                case 7:
                    message.workingInterval = reader.int32();
                    break;
                case 8:
                    message.feePerMonth = reader.int32();
                    break;
                case 9:
                    message.workLocation = reader.int32();
                    break;
                case 10:
                    message.workCommunication = reader.int32();
                    break;
                case 11:
                    message.workDetail = reader.int32();
                    break;
                case 12:
                    message.achievementReward = reader.string();
                    break;
                case 13:
                    message.createdAt = reader.string();
                    break;
                case 14:
                    message.updatedAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PastCaseProject message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PastCaseProject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PastCaseProject} PastCaseProject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProject.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PastCaseProject message.
         * @function verify
         * @memberof entity.PastCaseProject
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PastCaseProject.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                if (!$util.isInteger(message.meetingNum))
                    return "meetingNum: integer expected";
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                switch (message.meetingInterval) {
                default:
                    return "meetingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                if (!$util.isInteger(message.meetingMinutes))
                    return "meetingMinutes: integer expected";
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                if (!$util.isInteger(message.workingHour))
                    return "workingHour: integer expected";
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                switch (message.workingInterval) {
                default:
                    return "workingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                if (!$util.isInteger(message.feePerMonth))
                    return "feePerMonth: integer expected";
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                switch (message.workLocation) {
                default:
                    return "workLocation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                switch (message.workCommunication) {
                default:
                    return "workCommunication: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                switch (message.workDetail) {
                default:
                    return "workDetail: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                if (!$util.isString(message.achievementReward))
                    return "achievementReward: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isString(message.updatedAt))
                    return "updatedAt: string expected";
            return null;
        };

        /**
         * Creates a PastCaseProject message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PastCaseProject
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PastCaseProject} PastCaseProject
         */
        PastCaseProject.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PastCaseProject)
                return object;
            var message = new $root.entity.PastCaseProject();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.meetingNum != null)
                message.meetingNum = object.meetingNum | 0;
            switch (object.meetingInterval) {
            case "Interval_Unknown":
            case 0:
                message.meetingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.meetingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.meetingInterval = 2;
                break;
            }
            if (object.meetingMinutes != null)
                message.meetingMinutes = object.meetingMinutes | 0;
            if (object.workingHour != null)
                message.workingHour = object.workingHour | 0;
            switch (object.workingInterval) {
            case "Interval_Unknown":
            case 0:
                message.workingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.workingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.workingInterval = 2;
                break;
            }
            if (object.feePerMonth != null)
                message.feePerMonth = object.feePerMonth | 0;
            switch (object.workLocation) {
            case "WorkLocation_UnKnown":
            case 0:
                message.workLocation = 0;
                break;
            case "WorkLocation_Remote":
            case 1:
                message.workLocation = 1;
                break;
            case "WorkLocation_Attendance":
            case 2:
                message.workLocation = 2;
                break;
            case "WorkLocation_Both":
            case 3:
                message.workLocation = 3;
                break;
            }
            switch (object.workCommunication) {
            case "WorkCommunication_Unknown":
            case 0:
                message.workCommunication = 0;
                break;
            case "WorkCommunication_Chat":
            case 1:
                message.workCommunication = 1;
                break;
            case "WorkCommunication_Mail":
            case 2:
                message.workCommunication = 2;
                break;
            case "WorkCommunication_Other":
            case 3:
                message.workCommunication = 3;
                break;
            }
            switch (object.workDetail) {
            case "WorkDetail_Unknown":
            case 0:
                message.workDetail = 0;
                break;
            case "WorkDetail_OnlyMtg":
            case 1:
                message.workDetail = 1;
                break;
            case "WorkDetail_Mtg_ActualWorking":
            case 2:
                message.workDetail = 2;
                break;
            }
            if (object.achievementReward != null)
                message.achievementReward = String(object.achievementReward);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            if (object.updatedAt != null)
                message.updatedAt = String(object.updatedAt);
            return message;
        };

        /**
         * Creates a plain object from a PastCaseProject message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PastCaseProject
         * @static
         * @param {entity.PastCaseProject} message PastCaseProject
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PastCaseProject.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.meetingNum = 0;
                object.meetingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.meetingMinutes = 0;
                object.workingHour = 0;
                object.workingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.feePerMonth = 0;
                object.workLocation = options.enums === String ? "WorkLocation_UnKnown" : 0;
                object.workCommunication = options.enums === String ? "WorkCommunication_Unknown" : 0;
                object.workDetail = options.enums === String ? "WorkDetail_Unknown" : 0;
                object.achievementReward = "";
                object.createdAt = "";
                object.updatedAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                object.meetingNum = message.meetingNum;
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                object.meetingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.meetingInterval] : message.meetingInterval;
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                object.meetingMinutes = message.meetingMinutes;
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                object.workingHour = message.workingHour;
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                object.workingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.workingInterval] : message.workingInterval;
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                object.feePerMonth = message.feePerMonth;
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                object.workLocation = options.enums === String ? $root.entity.PastCaseProject.WorkLocation[message.workLocation] : message.workLocation;
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                object.workCommunication = options.enums === String ? $root.entity.PastCaseProject.WorkCommunication[message.workCommunication] : message.workCommunication;
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                object.workDetail = options.enums === String ? $root.entity.PastCaseProject.WorkDetail[message.workDetail] : message.workDetail;
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                object.achievementReward = message.achievementReward;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                object.updatedAt = message.updatedAt;
            return object;
        };

        /**
         * Converts this PastCaseProject to JSON.
         * @function toJSON
         * @memberof entity.PastCaseProject
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PastCaseProject.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * WorkLocation enum.
         * @name entity.PastCaseProject.WorkLocation
         * @enum {number}
         * @property {number} WorkLocation_UnKnown=0 WorkLocation_UnKnown value
         * @property {number} WorkLocation_Remote=1 WorkLocation_Remote value
         * @property {number} WorkLocation_Attendance=2 WorkLocation_Attendance value
         * @property {number} WorkLocation_Both=3 WorkLocation_Both value
         */
        PastCaseProject.WorkLocation = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkLocation_UnKnown"] = 0;
            values[valuesById[1] = "WorkLocation_Remote"] = 1;
            values[valuesById[2] = "WorkLocation_Attendance"] = 2;
            values[valuesById[3] = "WorkLocation_Both"] = 3;
            return values;
        })();

        /**
         * WorkCommunication enum.
         * @name entity.PastCaseProject.WorkCommunication
         * @enum {number}
         * @property {number} WorkCommunication_Unknown=0 WorkCommunication_Unknown value
         * @property {number} WorkCommunication_Chat=1 WorkCommunication_Chat value
         * @property {number} WorkCommunication_Mail=2 WorkCommunication_Mail value
         * @property {number} WorkCommunication_Other=3 WorkCommunication_Other value
         */
        PastCaseProject.WorkCommunication = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkCommunication_Unknown"] = 0;
            values[valuesById[1] = "WorkCommunication_Chat"] = 1;
            values[valuesById[2] = "WorkCommunication_Mail"] = 2;
            values[valuesById[3] = "WorkCommunication_Other"] = 3;
            return values;
        })();

        /**
         * WorkDetail enum.
         * @name entity.PastCaseProject.WorkDetail
         * @enum {number}
         * @property {number} WorkDetail_Unknown=0 WorkDetail_Unknown value
         * @property {number} WorkDetail_OnlyMtg=1 WorkDetail_OnlyMtg value
         * @property {number} WorkDetail_Mtg_ActualWorking=2 WorkDetail_Mtg_ActualWorking value
         */
        PastCaseProject.WorkDetail = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "WorkDetail_Unknown"] = 0;
            values[valuesById[1] = "WorkDetail_OnlyMtg"] = 1;
            values[valuesById[2] = "WorkDetail_Mtg_ActualWorking"] = 2;
            return values;
        })();

        /**
         * Interval enum.
         * @name entity.PastCaseProject.Interval
         * @enum {number}
         * @property {number} Interval_Unknown=0 Interval_Unknown value
         * @property {number} Interval_Week=1 Interval_Week value
         * @property {number} Interval_Month=2 Interval_Month value
         */
        PastCaseProject.Interval = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Interval_Unknown"] = 0;
            values[valuesById[1] = "Interval_Week"] = 1;
            values[valuesById[2] = "Interval_Month"] = 2;
            return values;
        })();

        return PastCaseProject;
    })();

    entity.PastCaseProjectList = (function() {

        /**
         * Properties of a PastCaseProjectList.
         * @memberof entity
         * @interface IPastCaseProjectList
         * @property {Array.<entity.IPastCaseProject>|null} [items] PastCaseProjectList items
         */

        /**
         * Constructs a new PastCaseProjectList.
         * @memberof entity
         * @classdesc Represents a PastCaseProjectList.
         * @implements IPastCaseProjectList
         * @constructor
         * @param {entity.IPastCaseProjectList=} [properties] Properties to set
         */
        function PastCaseProjectList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PastCaseProjectList items.
         * @member {Array.<entity.IPastCaseProject>} items
         * @memberof entity.PastCaseProjectList
         * @instance
         */
        PastCaseProjectList.prototype.items = $util.emptyArray;

        /**
         * Creates a new PastCaseProjectList instance using the specified properties.
         * @function create
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {entity.IPastCaseProjectList=} [properties] Properties to set
         * @returns {entity.PastCaseProjectList} PastCaseProjectList instance
         */
        PastCaseProjectList.create = function create(properties) {
            return new PastCaseProjectList(properties);
        };

        /**
         * Encodes the specified PastCaseProjectList message. Does not implicitly {@link entity.PastCaseProjectList.verify|verify} messages.
         * @function encode
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {entity.IPastCaseProjectList} message PastCaseProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProjectList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.PastCaseProject.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PastCaseProjectList message, length delimited. Does not implicitly {@link entity.PastCaseProjectList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {entity.IPastCaseProjectList} message PastCaseProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PastCaseProjectList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PastCaseProjectList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.PastCaseProjectList} PastCaseProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProjectList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.PastCaseProjectList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.PastCaseProject.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PastCaseProjectList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.PastCaseProjectList} PastCaseProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PastCaseProjectList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PastCaseProjectList message.
         * @function verify
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PastCaseProjectList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.PastCaseProject.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PastCaseProjectList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.PastCaseProjectList} PastCaseProjectList
         */
        PastCaseProjectList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.PastCaseProjectList)
                return object;
            var message = new $root.entity.PastCaseProjectList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.PastCaseProjectList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.PastCaseProjectList.items: object expected");
                    message.items[i] = $root.entity.PastCaseProject.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PastCaseProjectList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.PastCaseProjectList
         * @static
         * @param {entity.PastCaseProjectList} message PastCaseProjectList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PastCaseProjectList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.PastCaseProject.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this PastCaseProjectList to JSON.
         * @function toJSON
         * @memberof entity.PastCaseProjectList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PastCaseProjectList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PastCaseProjectList;
    })();

    entity.ReviewID = (function() {

        /**
         * Properties of a ReviewID.
         * @memberof entity
         * @interface IReviewID
         * @property {string|null} [id] ReviewID id
         */

        /**
         * Constructs a new ReviewID.
         * @memberof entity
         * @classdesc Represents a ReviewID.
         * @implements IReviewID
         * @constructor
         * @param {entity.IReviewID=} [properties] Properties to set
         */
        function ReviewID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewID id.
         * @member {string} id
         * @memberof entity.ReviewID
         * @instance
         */
        ReviewID.prototype.id = "";

        /**
         * Creates a new ReviewID instance using the specified properties.
         * @function create
         * @memberof entity.ReviewID
         * @static
         * @param {entity.IReviewID=} [properties] Properties to set
         * @returns {entity.ReviewID} ReviewID instance
         */
        ReviewID.create = function create(properties) {
            return new ReviewID(properties);
        };

        /**
         * Encodes the specified ReviewID message. Does not implicitly {@link entity.ReviewID.verify|verify} messages.
         * @function encode
         * @memberof entity.ReviewID
         * @static
         * @param {entity.IReviewID} message ReviewID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified ReviewID message, length delimited. Does not implicitly {@link entity.ReviewID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ReviewID
         * @static
         * @param {entity.IReviewID} message ReviewID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ReviewID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ReviewID} ReviewID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ReviewID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ReviewID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ReviewID} ReviewID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewID message.
         * @function verify
         * @memberof entity.ReviewID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a ReviewID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ReviewID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ReviewID} ReviewID
         */
        ReviewID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ReviewID)
                return object;
            var message = new $root.entity.ReviewID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a ReviewID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ReviewID
         * @static
         * @param {entity.ReviewID} message ReviewID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this ReviewID to JSON.
         * @function toJSON
         * @memberof entity.ReviewID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReviewID;
    })();

    entity.Review = (function() {

        /**
         * Properties of a Review.
         * @memberof entity
         * @interface IReview
         * @property {string|null} [id] Review id
         * @property {string|null} [customerID] Review customerID
         * @property {string|null} [companyName] Review companyName
         * @property {string|null} [companyPosition] Review companyPosition
         * @property {number|null} [point] Review point
         * @property {string|null} [title] Review title
         * @property {string|null} [text] Review text
         * @property {string|null} [createdAt] Review createdAt
         */

        /**
         * Constructs a new Review.
         * @memberof entity
         * @classdesc Represents a Review.
         * @implements IReview
         * @constructor
         * @param {entity.IReview=} [properties] Properties to set
         */
        function Review(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Review id.
         * @member {string} id
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.id = "";

        /**
         * Review customerID.
         * @member {string} customerID
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.customerID = "";

        /**
         * Review companyName.
         * @member {string} companyName
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.companyName = "";

        /**
         * Review companyPosition.
         * @member {string} companyPosition
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.companyPosition = "";

        /**
         * Review point.
         * @member {number} point
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.point = 0;

        /**
         * Review title.
         * @member {string} title
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.title = "";

        /**
         * Review text.
         * @member {string} text
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.text = "";

        /**
         * Review createdAt.
         * @member {string} createdAt
         * @memberof entity.Review
         * @instance
         */
        Review.prototype.createdAt = "";

        /**
         * Creates a new Review instance using the specified properties.
         * @function create
         * @memberof entity.Review
         * @static
         * @param {entity.IReview=} [properties] Properties to set
         * @returns {entity.Review} Review instance
         */
        Review.create = function create(properties) {
            return new Review(properties);
        };

        /**
         * Encodes the specified Review message. Does not implicitly {@link entity.Review.verify|verify} messages.
         * @function encode
         * @memberof entity.Review
         * @static
         * @param {entity.IReview} message Review message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Review.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyName);
            if (message.companyPosition != null && Object.hasOwnProperty.call(message, "companyPosition"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.companyPosition);
            if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.point);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.title);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.text);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified Review message, length delimited. Does not implicitly {@link entity.Review.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.Review
         * @static
         * @param {entity.IReview} message Review message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Review.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Review message from the specified reader or buffer.
         * @function decode
         * @memberof entity.Review
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.Review} Review
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Review.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.Review();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.companyName = reader.string();
                    break;
                case 4:
                    message.companyPosition = reader.string();
                    break;
                case 5:
                    message.point = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.text = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Review message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.Review
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.Review} Review
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Review.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Review message.
         * @function verify
         * @memberof entity.Review
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Review.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.companyPosition != null && message.hasOwnProperty("companyPosition"))
                if (!$util.isString(message.companyPosition))
                    return "companyPosition: string expected";
            if (message.point != null && message.hasOwnProperty("point"))
                if (!$util.isInteger(message.point))
                    return "point: integer expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a Review message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.Review
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.Review} Review
         */
        Review.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.Review)
                return object;
            var message = new $root.entity.Review();
            if (object.id != null)
                message.id = String(object.id);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.companyPosition != null)
                message.companyPosition = String(object.companyPosition);
            if (object.point != null)
                message.point = object.point | 0;
            if (object.title != null)
                message.title = String(object.title);
            if (object.text != null)
                message.text = String(object.text);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a Review message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.Review
         * @static
         * @param {entity.Review} message Review
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Review.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.customerID = "";
                object.companyName = "";
                object.companyPosition = "";
                object.point = 0;
                object.title = "";
                object.text = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.companyPosition != null && message.hasOwnProperty("companyPosition"))
                object.companyPosition = message.companyPosition;
            if (message.point != null && message.hasOwnProperty("point"))
                object.point = message.point;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this Review to JSON.
         * @function toJSON
         * @memberof entity.Review
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Review.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Review;
    })();

    entity.ReviewList = (function() {

        /**
         * Properties of a ReviewList.
         * @memberof entity
         * @interface IReviewList
         * @property {Array.<entity.IReview>|null} [items] ReviewList items
         */

        /**
         * Constructs a new ReviewList.
         * @memberof entity
         * @classdesc Represents a ReviewList.
         * @implements IReviewList
         * @constructor
         * @param {entity.IReviewList=} [properties] Properties to set
         */
        function ReviewList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReviewList items.
         * @member {Array.<entity.IReview>} items
         * @memberof entity.ReviewList
         * @instance
         */
        ReviewList.prototype.items = $util.emptyArray;

        /**
         * Creates a new ReviewList instance using the specified properties.
         * @function create
         * @memberof entity.ReviewList
         * @static
         * @param {entity.IReviewList=} [properties] Properties to set
         * @returns {entity.ReviewList} ReviewList instance
         */
        ReviewList.create = function create(properties) {
            return new ReviewList(properties);
        };

        /**
         * Encodes the specified ReviewList message. Does not implicitly {@link entity.ReviewList.verify|verify} messages.
         * @function encode
         * @memberof entity.ReviewList
         * @static
         * @param {entity.IReviewList} message ReviewList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.Review.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ReviewList message, length delimited. Does not implicitly {@link entity.ReviewList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.ReviewList
         * @static
         * @param {entity.IReviewList} message ReviewList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReviewList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReviewList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.ReviewList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.ReviewList} ReviewList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.ReviewList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.Review.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReviewList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.ReviewList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.ReviewList} ReviewList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReviewList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReviewList message.
         * @function verify
         * @memberof entity.ReviewList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReviewList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.Review.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ReviewList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.ReviewList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.ReviewList} ReviewList
         */
        ReviewList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.ReviewList)
                return object;
            var message = new $root.entity.ReviewList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.ReviewList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.ReviewList.items: object expected");
                    message.items[i] = $root.entity.Review.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ReviewList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.ReviewList
         * @static
         * @param {entity.ReviewList} message ReviewList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReviewList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.Review.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this ReviewList to JSON.
         * @function toJSON
         * @memberof entity.ReviewList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReviewList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReviewList;
    })();

    entity.TicketContractID = (function() {

        /**
         * Properties of a TicketContractID.
         * @memberof entity
         * @interface ITicketContractID
         * @property {string|null} [id] TicketContractID id
         */

        /**
         * Constructs a new TicketContractID.
         * @memberof entity
         * @classdesc Represents a TicketContractID.
         * @implements ITicketContractID
         * @constructor
         * @param {entity.ITicketContractID=} [properties] Properties to set
         */
        function TicketContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TicketContractID id.
         * @member {string} id
         * @memberof entity.TicketContractID
         * @instance
         */
        TicketContractID.prototype.id = "";

        /**
         * Creates a new TicketContractID instance using the specified properties.
         * @function create
         * @memberof entity.TicketContractID
         * @static
         * @param {entity.ITicketContractID=} [properties] Properties to set
         * @returns {entity.TicketContractID} TicketContractID instance
         */
        TicketContractID.create = function create(properties) {
            return new TicketContractID(properties);
        };

        /**
         * Encodes the specified TicketContractID message. Does not implicitly {@link entity.TicketContractID.verify|verify} messages.
         * @function encode
         * @memberof entity.TicketContractID
         * @static
         * @param {entity.ITicketContractID} message TicketContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified TicketContractID message, length delimited. Does not implicitly {@link entity.TicketContractID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.TicketContractID
         * @static
         * @param {entity.ITicketContractID} message TicketContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TicketContractID message from the specified reader or buffer.
         * @function decode
         * @memberof entity.TicketContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.TicketContractID} TicketContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.TicketContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TicketContractID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.TicketContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.TicketContractID} TicketContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TicketContractID message.
         * @function verify
         * @memberof entity.TicketContractID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TicketContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a TicketContractID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.TicketContractID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.TicketContractID} TicketContractID
         */
        TicketContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.TicketContractID)
                return object;
            var message = new $root.entity.TicketContractID();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a TicketContractID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.TicketContractID
         * @static
         * @param {entity.TicketContractID} message TicketContractID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TicketContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this TicketContractID to JSON.
         * @function toJSON
         * @memberof entity.TicketContractID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TicketContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TicketContractID;
    })();

    entity.TicketContract = (function() {

        /**
         * Properties of a TicketContract.
         * @memberof entity
         * @interface ITicketContract
         * @property {string|null} [id] TicketContract id
         * @property {string|null} [companyID] TicketContract companyID
         * @property {string|null} [companyName] TicketContract companyName
         * @property {entity.TicketContract.Type|null} [ticketType] TicketContract ticketType
         * @property {number|null} [num] TicketContract num
         * @property {string|null} [purpose] TicketContract purpose
         * @property {string|null} [expiredAt] TicketContract expiredAt
         * @property {string|null} [createdAt] TicketContract createdAt
         */

        /**
         * Constructs a new TicketContract.
         * @memberof entity
         * @classdesc Represents a TicketContract.
         * @implements ITicketContract
         * @constructor
         * @param {entity.ITicketContract=} [properties] Properties to set
         */
        function TicketContract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TicketContract id.
         * @member {string} id
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.id = "";

        /**
         * TicketContract companyID.
         * @member {string} companyID
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.companyID = "";

        /**
         * TicketContract companyName.
         * @member {string} companyName
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.companyName = "";

        /**
         * TicketContract ticketType.
         * @member {entity.TicketContract.Type} ticketType
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.ticketType = 0;

        /**
         * TicketContract num.
         * @member {number} num
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.num = 0;

        /**
         * TicketContract purpose.
         * @member {string} purpose
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.purpose = "";

        /**
         * TicketContract expiredAt.
         * @member {string} expiredAt
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.expiredAt = "";

        /**
         * TicketContract createdAt.
         * @member {string} createdAt
         * @memberof entity.TicketContract
         * @instance
         */
        TicketContract.prototype.createdAt = "";

        /**
         * Creates a new TicketContract instance using the specified properties.
         * @function create
         * @memberof entity.TicketContract
         * @static
         * @param {entity.ITicketContract=} [properties] Properties to set
         * @returns {entity.TicketContract} TicketContract instance
         */
        TicketContract.create = function create(properties) {
            return new TicketContract(properties);
        };

        /**
         * Encodes the specified TicketContract message. Does not implicitly {@link entity.TicketContract.verify|verify} messages.
         * @function encode
         * @memberof entity.TicketContract
         * @static
         * @param {entity.ITicketContract} message TicketContract message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContract.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyID);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyName);
            if (message.ticketType != null && Object.hasOwnProperty.call(message, "ticketType"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ticketType);
            if (message.num != null && Object.hasOwnProperty.call(message, "num"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.num);
            if (message.purpose != null && Object.hasOwnProperty.call(message, "purpose"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.purpose);
            if (message.expiredAt != null && Object.hasOwnProperty.call(message, "expiredAt"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.expiredAt);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9999, wireType 2 =*/79994).string(message.createdAt);
            return writer;
        };

        /**
         * Encodes the specified TicketContract message, length delimited. Does not implicitly {@link entity.TicketContract.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.TicketContract
         * @static
         * @param {entity.ITicketContract} message TicketContract message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContract.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TicketContract message from the specified reader or buffer.
         * @function decode
         * @memberof entity.TicketContract
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.TicketContract} TicketContract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContract.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.TicketContract();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyID = reader.string();
                    break;
                case 3:
                    message.companyName = reader.string();
                    break;
                case 4:
                    message.ticketType = reader.int32();
                    break;
                case 5:
                    message.num = reader.int32();
                    break;
                case 6:
                    message.purpose = reader.string();
                    break;
                case 7:
                    message.expiredAt = reader.string();
                    break;
                case 9999:
                    message.createdAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TicketContract message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.TicketContract
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.TicketContract} TicketContract
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContract.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TicketContract message.
         * @function verify
         * @memberof entity.TicketContract
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TicketContract.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.ticketType != null && message.hasOwnProperty("ticketType"))
                switch (message.ticketType) {
                default:
                    return "ticketType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.num != null && message.hasOwnProperty("num"))
                if (!$util.isInteger(message.num))
                    return "num: integer expected";
            if (message.purpose != null && message.hasOwnProperty("purpose"))
                if (!$util.isString(message.purpose))
                    return "purpose: string expected";
            if (message.expiredAt != null && message.hasOwnProperty("expiredAt"))
                if (!$util.isString(message.expiredAt))
                    return "expiredAt: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isString(message.createdAt))
                    return "createdAt: string expected";
            return null;
        };

        /**
         * Creates a TicketContract message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.TicketContract
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.TicketContract} TicketContract
         */
        TicketContract.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.TicketContract)
                return object;
            var message = new $root.entity.TicketContract();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            switch (object.ticketType) {
            case "Type_Unknown":
            case 0:
                message.ticketType = 0;
                break;
            case "Type_1_Pieces":
            case 1:
                message.ticketType = 1;
                break;
            case "Type_10_Pieces":
            case 2:
                message.ticketType = 2;
                break;
            }
            if (object.num != null)
                message.num = object.num | 0;
            if (object.purpose != null)
                message.purpose = String(object.purpose);
            if (object.expiredAt != null)
                message.expiredAt = String(object.expiredAt);
            if (object.createdAt != null)
                message.createdAt = String(object.createdAt);
            return message;
        };

        /**
         * Creates a plain object from a TicketContract message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.TicketContract
         * @static
         * @param {entity.TicketContract} message TicketContract
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TicketContract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.companyID = "";
                object.companyName = "";
                object.ticketType = options.enums === String ? "Type_Unknown" : 0;
                object.num = 0;
                object.purpose = "";
                object.expiredAt = "";
                object.createdAt = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.ticketType != null && message.hasOwnProperty("ticketType"))
                object.ticketType = options.enums === String ? $root.entity.TicketContract.Type[message.ticketType] : message.ticketType;
            if (message.num != null && message.hasOwnProperty("num"))
                object.num = message.num;
            if (message.purpose != null && message.hasOwnProperty("purpose"))
                object.purpose = message.purpose;
            if (message.expiredAt != null && message.hasOwnProperty("expiredAt"))
                object.expiredAt = message.expiredAt;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                object.createdAt = message.createdAt;
            return object;
        };

        /**
         * Converts this TicketContract to JSON.
         * @function toJSON
         * @memberof entity.TicketContract
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TicketContract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Type enum.
         * @name entity.TicketContract.Type
         * @enum {number}
         * @property {number} Type_Unknown=0 Type_Unknown value
         * @property {number} Type_1_Pieces=1 Type_1_Pieces value
         * @property {number} Type_10_Pieces=2 Type_10_Pieces value
         */
        TicketContract.Type = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Type_Unknown"] = 0;
            values[valuesById[1] = "Type_1_Pieces"] = 1;
            values[valuesById[2] = "Type_10_Pieces"] = 2;
            return values;
        })();

        return TicketContract;
    })();

    entity.TicketContractList = (function() {

        /**
         * Properties of a TicketContractList.
         * @memberof entity
         * @interface ITicketContractList
         * @property {Array.<entity.ITicketContract>|null} [items] TicketContractList items
         */

        /**
         * Constructs a new TicketContractList.
         * @memberof entity
         * @classdesc Represents a TicketContractList.
         * @implements ITicketContractList
         * @constructor
         * @param {entity.ITicketContractList=} [properties] Properties to set
         */
        function TicketContractList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TicketContractList items.
         * @member {Array.<entity.ITicketContract>} items
         * @memberof entity.TicketContractList
         * @instance
         */
        TicketContractList.prototype.items = $util.emptyArray;

        /**
         * Creates a new TicketContractList instance using the specified properties.
         * @function create
         * @memberof entity.TicketContractList
         * @static
         * @param {entity.ITicketContractList=} [properties] Properties to set
         * @returns {entity.TicketContractList} TicketContractList instance
         */
        TicketContractList.create = function create(properties) {
            return new TicketContractList(properties);
        };

        /**
         * Encodes the specified TicketContractList message. Does not implicitly {@link entity.TicketContractList.verify|verify} messages.
         * @function encode
         * @memberof entity.TicketContractList
         * @static
         * @param {entity.ITicketContractList} message TicketContractList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContractList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.entity.TicketContract.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TicketContractList message, length delimited. Does not implicitly {@link entity.TicketContractList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof entity.TicketContractList
         * @static
         * @param {entity.ITicketContractList} message TicketContractList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TicketContractList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TicketContractList message from the specified reader or buffer.
         * @function decode
         * @memberof entity.TicketContractList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {entity.TicketContractList} TicketContractList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContractList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.entity.TicketContractList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.entity.TicketContract.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TicketContractList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof entity.TicketContractList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {entity.TicketContractList} TicketContractList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TicketContractList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TicketContractList message.
         * @function verify
         * @memberof entity.TicketContractList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TicketContractList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.entity.TicketContract.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TicketContractList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof entity.TicketContractList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {entity.TicketContractList} TicketContractList
         */
        TicketContractList.fromObject = function fromObject(object) {
            if (object instanceof $root.entity.TicketContractList)
                return object;
            var message = new $root.entity.TicketContractList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".entity.TicketContractList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".entity.TicketContractList.items: object expected");
                    message.items[i] = $root.entity.TicketContract.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TicketContractList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof entity.TicketContractList
         * @static
         * @param {entity.TicketContractList} message TicketContractList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TicketContractList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.entity.TicketContract.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this TicketContractList to JSON.
         * @function toJSON
         * @memberof entity.TicketContractList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TicketContractList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TicketContractList;
    })();

    return entity;
})();

$root.api = (function() {

    /**
     * Namespace api.
     * @exports api
     * @namespace
     */
    var api = {};

    api.ApplyClientService = (function() {

        /**
         * Constructs a new ApplyClientService service.
         * @memberof api
         * @classdesc Represents an ApplyClientService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ApplyClientService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ApplyClientService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ApplyClientService;

        /**
         * Creates new ApplyClientService service using the specified rpc implementation.
         * @function create
         * @memberof api.ApplyClientService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ApplyClientService} RPC service. Useful where requests and/or responses are streamed.
         */
        ApplyClientService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ApplyClientService#register}.
         * @memberof api.ApplyClientService
         * @typedef RegisterCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Register.
         * @function register
         * @memberof api.ApplyClientService
         * @instance
         * @param {api.IRegisterClientRequest} request RegisterClientRequest message or plain object
         * @param {api.ApplyClientService.RegisterCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ApplyClientService.prototype.register = function register(request, callback) {
            return this.rpcCall(register, $root.api.RegisterClientRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Register" });

        /**
         * Calls Register.
         * @function register
         * @memberof api.ApplyClientService
         * @instance
         * @param {api.IRegisterClientRequest} request RegisterClientRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ApplyClientService;
    })();

    api.RegisterClientRequest = (function() {

        /**
         * Properties of a RegisterClientRequest.
         * @memberof api
         * @interface IRegisterClientRequest
         * @property {string|null} [email] RegisterClientRequest email
         * @property {string|null} [phoneNumber] RegisterClientRequest phoneNumber
         * @property {string|null} [companyName] RegisterClientRequest companyName
         * @property {string|null} [webURL] RegisterClientRequest webURL
         * @property {string|null} [accountName] RegisterClientRequest accountName
         * @property {string|null} [accountNameKana] RegisterClientRequest accountNameKana
         * @property {string|null} [position] RegisterClientRequest position
         * @property {entity.ApplyClient.Source|null} [source] RegisterClientRequest source
         * @property {boolean|null} [isDemo] RegisterClientRequest isDemo
         * @property {string|null} [demoPassword] RegisterClientRequest demoPassword
         * @property {string|null} [department] RegisterClientRequest department
         * @property {string|null} [routeInfo] RegisterClientRequest routeInfo
         */

        /**
         * Constructs a new RegisterClientRequest.
         * @memberof api
         * @classdesc Represents a RegisterClientRequest.
         * @implements IRegisterClientRequest
         * @constructor
         * @param {api.IRegisterClientRequest=} [properties] Properties to set
         */
        function RegisterClientRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RegisterClientRequest email.
         * @member {string} email
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.email = "";

        /**
         * RegisterClientRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.phoneNumber = "";

        /**
         * RegisterClientRequest companyName.
         * @member {string} companyName
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.companyName = "";

        /**
         * RegisterClientRequest webURL.
         * @member {string} webURL
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.webURL = "";

        /**
         * RegisterClientRequest accountName.
         * @member {string} accountName
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.accountName = "";

        /**
         * RegisterClientRequest accountNameKana.
         * @member {string} accountNameKana
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.accountNameKana = "";

        /**
         * RegisterClientRequest position.
         * @member {string} position
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.position = "";

        /**
         * RegisterClientRequest source.
         * @member {entity.ApplyClient.Source} source
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.source = 0;

        /**
         * RegisterClientRequest isDemo.
         * @member {boolean} isDemo
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.isDemo = false;

        /**
         * RegisterClientRequest demoPassword.
         * @member {string} demoPassword
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.demoPassword = "";

        /**
         * RegisterClientRequest department.
         * @member {string} department
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.department = "";

        /**
         * RegisterClientRequest routeInfo.
         * @member {string} routeInfo
         * @memberof api.RegisterClientRequest
         * @instance
         */
        RegisterClientRequest.prototype.routeInfo = "";

        /**
         * Creates a new RegisterClientRequest instance using the specified properties.
         * @function create
         * @memberof api.RegisterClientRequest
         * @static
         * @param {api.IRegisterClientRequest=} [properties] Properties to set
         * @returns {api.RegisterClientRequest} RegisterClientRequest instance
         */
        RegisterClientRequest.create = function create(properties) {
            return new RegisterClientRequest(properties);
        };

        /**
         * Encodes the specified RegisterClientRequest message. Does not implicitly {@link api.RegisterClientRequest.verify|verify} messages.
         * @function encode
         * @memberof api.RegisterClientRequest
         * @static
         * @param {api.IRegisterClientRequest} message RegisterClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RegisterClientRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.phoneNumber);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyName);
            if (message.webURL != null && Object.hasOwnProperty.call(message, "webURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.webURL);
            if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.accountName);
            if (message.accountNameKana != null && Object.hasOwnProperty.call(message, "accountNameKana"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.accountNameKana);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.position);
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.source);
            if (message.isDemo != null && Object.hasOwnProperty.call(message, "isDemo"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isDemo);
            if (message.demoPassword != null && Object.hasOwnProperty.call(message, "demoPassword"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.demoPassword);
            if (message.department != null && Object.hasOwnProperty.call(message, "department"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.department);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.routeInfo);
            return writer;
        };

        /**
         * Encodes the specified RegisterClientRequest message, length delimited. Does not implicitly {@link api.RegisterClientRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.RegisterClientRequest
         * @static
         * @param {api.IRegisterClientRequest} message RegisterClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RegisterClientRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RegisterClientRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.RegisterClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.RegisterClientRequest} RegisterClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RegisterClientRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.RegisterClientRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                case 2:
                    message.phoneNumber = reader.string();
                    break;
                case 3:
                    message.companyName = reader.string();
                    break;
                case 4:
                    message.webURL = reader.string();
                    break;
                case 5:
                    message.accountName = reader.string();
                    break;
                case 6:
                    message.accountNameKana = reader.string();
                    break;
                case 7:
                    message.position = reader.string();
                    break;
                case 8:
                    message.source = reader.int32();
                    break;
                case 9:
                    message.isDemo = reader.bool();
                    break;
                case 10:
                    message.demoPassword = reader.string();
                    break;
                case 11:
                    message.department = reader.string();
                    break;
                case 12:
                    message.routeInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RegisterClientRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.RegisterClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.RegisterClientRequest} RegisterClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RegisterClientRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RegisterClientRequest message.
         * @function verify
         * @memberof api.RegisterClientRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RegisterClientRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                if (!$util.isString(message.webURL))
                    return "webURL: string expected";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                if (!$util.isString(message.accountName))
                    return "accountName: string expected";
            if (message.accountNameKana != null && message.hasOwnProperty("accountNameKana"))
                if (!$util.isString(message.accountNameKana))
                    return "accountNameKana: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.source != null && message.hasOwnProperty("source"))
                switch (message.source) {
                default:
                    return "source: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.isDemo != null && message.hasOwnProperty("isDemo"))
                if (typeof message.isDemo !== "boolean")
                    return "isDemo: boolean expected";
            if (message.demoPassword != null && message.hasOwnProperty("demoPassword"))
                if (!$util.isString(message.demoPassword))
                    return "demoPassword: string expected";
            if (message.department != null && message.hasOwnProperty("department"))
                if (!$util.isString(message.department))
                    return "department: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            return null;
        };

        /**
         * Creates a RegisterClientRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.RegisterClientRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.RegisterClientRequest} RegisterClientRequest
         */
        RegisterClientRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.RegisterClientRequest)
                return object;
            var message = new $root.api.RegisterClientRequest();
            if (object.email != null)
                message.email = String(object.email);
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.webURL != null)
                message.webURL = String(object.webURL);
            if (object.accountName != null)
                message.accountName = String(object.accountName);
            if (object.accountNameKana != null)
                message.accountNameKana = String(object.accountNameKana);
            if (object.position != null)
                message.position = String(object.position);
            switch (object.source) {
            case "Source_Unknown":
            case 0:
                message.source = 0;
                break;
            case "Source_Internal":
            case 1:
                message.source = 1;
                break;
            case "Source_Lafool":
            case 2:
                message.source = 2;
                break;
            case "Source_LafoolMedical":
            case 3:
                message.source = 3;
                break;
            }
            if (object.isDemo != null)
                message.isDemo = Boolean(object.isDemo);
            if (object.demoPassword != null)
                message.demoPassword = String(object.demoPassword);
            if (object.department != null)
                message.department = String(object.department);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            return message;
        };

        /**
         * Creates a plain object from a RegisterClientRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.RegisterClientRequest
         * @static
         * @param {api.RegisterClientRequest} message RegisterClientRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RegisterClientRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.email = "";
                object.phoneNumber = "";
                object.companyName = "";
                object.webURL = "";
                object.accountName = "";
                object.accountNameKana = "";
                object.position = "";
                object.source = options.enums === String ? "Source_Unknown" : 0;
                object.isDemo = false;
                object.demoPassword = "";
                object.department = "";
                object.routeInfo = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                object.webURL = message.webURL;
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                object.accountName = message.accountName;
            if (message.accountNameKana != null && message.hasOwnProperty("accountNameKana"))
                object.accountNameKana = message.accountNameKana;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.enums === String ? $root.entity.ApplyClient.Source[message.source] : message.source;
            if (message.isDemo != null && message.hasOwnProperty("isDemo"))
                object.isDemo = message.isDemo;
            if (message.demoPassword != null && message.hasOwnProperty("demoPassword"))
                object.demoPassword = message.demoPassword;
            if (message.department != null && message.hasOwnProperty("department"))
                object.department = message.department;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            return object;
        };

        /**
         * Converts this RegisterClientRequest to JSON.
         * @function toJSON
         * @memberof api.RegisterClientRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RegisterClientRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RegisterClientRequest;
    })();

    api.ClientBookmarkService = (function() {

        /**
         * Constructs a new ClientBookmarkService service.
         * @memberof api
         * @classdesc Represents a ClientBookmarkService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ClientBookmarkService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ClientBookmarkService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ClientBookmarkService;

        /**
         * Creates new ClientBookmarkService service using the specified rpc implementation.
         * @function create
         * @memberof api.ClientBookmarkService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ClientBookmarkService} RPC service. Useful where requests and/or responses are streamed.
         */
        ClientBookmarkService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ClientBookmarkService#getAll}.
         * @memberof api.ClientBookmarkService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ClientBookmarkList} [response] ClientBookmarkList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ClientBookmarkService.GetAllCallback} callback Node-style callback called with the error, if any, and ClientBookmarkList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBookmarkService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Empty, $root.entity.ClientBookmarkList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.ClientBookmarkList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientBookmarkService#create}.
         * @memberof api.ClientBookmarkService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.ClientBookmarkService.CreateCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBookmarkService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.entity.CustomerID, $root.common.Empty, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientBookmarkService#delete_}.
         * @memberof api.ClientBookmarkService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.ClientBookmarkService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBookmarkService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.CustomerID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ClientBookmarkService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ClientBookmarkService;
    })();

    api.ClientBrowsingHistoryService = (function() {

        /**
         * Constructs a new ClientBrowsingHistoryService service.
         * @memberof api
         * @classdesc Represents a ClientBrowsingHistoryService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ClientBrowsingHistoryService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ClientBrowsingHistoryService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ClientBrowsingHistoryService;

        /**
         * Creates new ClientBrowsingHistoryService service using the specified rpc implementation.
         * @function create
         * @memberof api.ClientBrowsingHistoryService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ClientBrowsingHistoryService} RPC service. Useful where requests and/or responses are streamed.
         */
        ClientBrowsingHistoryService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ClientBrowsingHistoryService#getAll}.
         * @memberof api.ClientBrowsingHistoryService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ClientBrowsingHistoryList} [response] ClientBrowsingHistoryList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ClientBrowsingHistoryService.GetAllCallback} callback Node-style callback called with the error, if any, and ClientBrowsingHistoryList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBrowsingHistoryService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.ClientBrowsingHistoryList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ClientBrowsingHistoryList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientBrowsingHistoryService#getCount}.
         * @memberof api.ClientBrowsingHistoryService
         * @typedef GetCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ClientBrowsingHistoryService.GetCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBrowsingHistoryService.prototype.getCount = function getCount(request, callback) {
            return this.rpcCall(getCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCount" });

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientBrowsingHistoryService#create}.
         * @memberof api.ClientBrowsingHistoryService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.ClientBrowsingHistoryService.CreateCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientBrowsingHistoryService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.entity.CustomerID, $root.common.Empty, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientBrowsingHistoryService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ClientBrowsingHistoryService;
    })();

    api.ClientConsultationService = (function() {

        /**
         * Constructs a new ClientConsultationService service.
         * @memberof api
         * @classdesc Represents a ClientConsultationService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ClientConsultationService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ClientConsultationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ClientConsultationService;

        /**
         * Creates new ClientConsultationService service using the specified rpc implementation.
         * @function create
         * @memberof api.ClientConsultationService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ClientConsultationService} RPC service. Useful where requests and/or responses are streamed.
         */
        ClientConsultationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ClientConsultationService#send}.
         * @memberof api.ClientConsultationService
         * @typedef SendCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Send.
         * @function send
         * @memberof api.ClientConsultationService
         * @instance
         * @param {api.ISendConsultationRequest} request SendConsultationRequest message or plain object
         * @param {api.ClientConsultationService.SendCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientConsultationService.prototype.send = function send(request, callback) {
            return this.rpcCall(send, $root.api.SendConsultationRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Send" });

        /**
         * Calls Send.
         * @function send
         * @memberof api.ClientConsultationService
         * @instance
         * @param {api.ISendConsultationRequest} request SendConsultationRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ClientConsultationService;
    })();

    api.SendConsultationRequest = (function() {

        /**
         * Properties of a SendConsultationRequest.
         * @memberof api
         * @interface ISendConsultationRequest
         * @property {string|null} [title] SendConsultationRequest title
         * @property {Array.<api.SendConsultationRequest.IItem>|null} [items] SendConsultationRequest items
         */

        /**
         * Constructs a new SendConsultationRequest.
         * @memberof api
         * @classdesc Represents a SendConsultationRequest.
         * @implements ISendConsultationRequest
         * @constructor
         * @param {api.ISendConsultationRequest=} [properties] Properties to set
         */
        function SendConsultationRequest(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendConsultationRequest title.
         * @member {string} title
         * @memberof api.SendConsultationRequest
         * @instance
         */
        SendConsultationRequest.prototype.title = "";

        /**
         * SendConsultationRequest items.
         * @member {Array.<api.SendConsultationRequest.IItem>} items
         * @memberof api.SendConsultationRequest
         * @instance
         */
        SendConsultationRequest.prototype.items = $util.emptyArray;

        /**
         * Creates a new SendConsultationRequest instance using the specified properties.
         * @function create
         * @memberof api.SendConsultationRequest
         * @static
         * @param {api.ISendConsultationRequest=} [properties] Properties to set
         * @returns {api.SendConsultationRequest} SendConsultationRequest instance
         */
        SendConsultationRequest.create = function create(properties) {
            return new SendConsultationRequest(properties);
        };

        /**
         * Encodes the specified SendConsultationRequest message. Does not implicitly {@link api.SendConsultationRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SendConsultationRequest
         * @static
         * @param {api.ISendConsultationRequest} message SendConsultationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendConsultationRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.api.SendConsultationRequest.Item.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SendConsultationRequest message, length delimited. Does not implicitly {@link api.SendConsultationRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SendConsultationRequest
         * @static
         * @param {api.ISendConsultationRequest} message SendConsultationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendConsultationRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendConsultationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SendConsultationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SendConsultationRequest} SendConsultationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendConsultationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SendConsultationRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.api.SendConsultationRequest.Item.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendConsultationRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SendConsultationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SendConsultationRequest} SendConsultationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendConsultationRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendConsultationRequest message.
         * @function verify
         * @memberof api.SendConsultationRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendConsultationRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.api.SendConsultationRequest.Item.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SendConsultationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SendConsultationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SendConsultationRequest} SendConsultationRequest
         */
        SendConsultationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SendConsultationRequest)
                return object;
            var message = new $root.api.SendConsultationRequest();
            if (object.title != null)
                message.title = String(object.title);
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".api.SendConsultationRequest.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".api.SendConsultationRequest.items: object expected");
                    message.items[i] = $root.api.SendConsultationRequest.Item.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SendConsultationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SendConsultationRequest
         * @static
         * @param {api.SendConsultationRequest} message SendConsultationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendConsultationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (options.defaults)
                object.title = "";
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.api.SendConsultationRequest.Item.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this SendConsultationRequest to JSON.
         * @function toJSON
         * @memberof api.SendConsultationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendConsultationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SendConsultationRequest.Item = (function() {

            /**
             * Properties of an Item.
             * @memberof api.SendConsultationRequest
             * @interface IItem
             * @property {string|null} [key] Item key
             * @property {string|null} [value] Item value
             */

            /**
             * Constructs a new Item.
             * @memberof api.SendConsultationRequest
             * @classdesc Represents an Item.
             * @implements IItem
             * @constructor
             * @param {api.SendConsultationRequest.IItem=} [properties] Properties to set
             */
            function Item(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Item key.
             * @member {string} key
             * @memberof api.SendConsultationRequest.Item
             * @instance
             */
            Item.prototype.key = "";

            /**
             * Item value.
             * @member {string} value
             * @memberof api.SendConsultationRequest.Item
             * @instance
             */
            Item.prototype.value = "";

            /**
             * Creates a new Item instance using the specified properties.
             * @function create
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {api.SendConsultationRequest.IItem=} [properties] Properties to set
             * @returns {api.SendConsultationRequest.Item} Item instance
             */
            Item.create = function create(properties) {
                return new Item(properties);
            };

            /**
             * Encodes the specified Item message. Does not implicitly {@link api.SendConsultationRequest.Item.verify|verify} messages.
             * @function encode
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {api.SendConsultationRequest.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                return writer;
            };

            /**
             * Encodes the specified Item message, length delimited. Does not implicitly {@link api.SendConsultationRequest.Item.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {api.SendConsultationRequest.IItem} message Item message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Item.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Item message from the specified reader or buffer.
             * @function decode
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.SendConsultationRequest.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SendConsultationRequest.Item();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.key = reader.string();
                        break;
                    case 2:
                        message.value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Item message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.SendConsultationRequest.Item} Item
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Item.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Item message.
             * @function verify
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Item.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.key != null && message.hasOwnProperty("key"))
                    if (!$util.isString(message.key))
                        return "key: string expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                return null;
            };

            /**
             * Creates an Item message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.SendConsultationRequest.Item} Item
             */
            Item.fromObject = function fromObject(object) {
                if (object instanceof $root.api.SendConsultationRequest.Item)
                    return object;
                var message = new $root.api.SendConsultationRequest.Item();
                if (object.key != null)
                    message.key = String(object.key);
                if (object.value != null)
                    message.value = String(object.value);
                return message;
            };

            /**
             * Creates a plain object from an Item message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.SendConsultationRequest.Item
             * @static
             * @param {api.SendConsultationRequest.Item} message Item
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Item.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.key = "";
                    object.value = "";
                }
                if (message.key != null && message.hasOwnProperty("key"))
                    object.key = message.key;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this Item to JSON.
             * @function toJSON
             * @memberof api.SendConsultationRequest.Item
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Item.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Item;
        })();

        return SendConsultationRequest;
    })();

    api.ClientService = (function() {

        /**
         * Constructs a new ClientService service.
         * @memberof api
         * @classdesc Represents a ClientService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ClientService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ClientService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ClientService;

        /**
         * Creates new ClientService service using the specified rpc implementation.
         * @function create
         * @memberof api.ClientService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ClientService} RPC service. Useful where requests and/or responses are streamed.
         */
        ClientService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ClientService#getAll}.
         * @memberof api.ClientService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ClientList} [response] ClientList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ClientService.GetAllCallback} callback Node-style callback called with the error, if any, and ClientList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.ClientList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ClientService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ClientList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#getAllByIDs}.
         * @memberof api.ClientService
         * @typedef GetAllByIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ClientList} [response] ClientList
         */

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientIDList} request ClientIDList message or plain object
         * @param {api.ClientService.GetAllByIDsCallback} callback Node-style callback called with the error, if any, and ClientList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.getAllByIDs = function getAllByIDs(request, callback) {
            return this.rpcCall(getAllByIDs, $root.entity.ClientIDList, $root.entity.ClientList, request, callback);
        }, "name", { value: "GetAllByIDs" });

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientIDList} request ClientIDList message or plain object
         * @returns {Promise<entity.ClientList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#get}.
         * @memberof api.ClientService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Client} [response] Client
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientID} request ClientID message or plain object
         * @param {api.ClientService.GetCallback} callback Node-style callback called with the error, if any, and Client
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.ClientID, $root.entity.Client, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientID} request ClientID message or plain object
         * @returns {Promise<entity.Client>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#create}.
         * @memberof api.ClientService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Client} [response] Client
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientService
         * @instance
         * @param {api.ICreateClientRequest} request CreateClientRequest message or plain object
         * @param {api.ClientService.CreateCallback} callback Node-style callback called with the error, if any, and Client
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateClientRequest, $root.entity.Client, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ClientService
         * @instance
         * @param {api.ICreateClientRequest} request CreateClientRequest message or plain object
         * @returns {Promise<entity.Client>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#update}.
         * @memberof api.ClientService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Client} [response] Client
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.ClientService
         * @instance
         * @param {api.IUpdateClientRequest} request UpdateClientRequest message or plain object
         * @param {api.ClientService.UpdateCallback} callback Node-style callback called with the error, if any, and Client
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateClientRequest, $root.entity.Client, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.ClientService
         * @instance
         * @param {api.IUpdateClientRequest} request UpdateClientRequest message or plain object
         * @returns {Promise<entity.Client>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#updateRole}.
         * @memberof api.ClientService
         * @typedef UpdateRoleCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls UpdateRole.
         * @function updateRole
         * @memberof api.ClientService
         * @instance
         * @param {api.IUpdateClientRoleRequest} request UpdateClientRoleRequest message or plain object
         * @param {api.ClientService.UpdateRoleCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype.updateRole = function updateRole(request, callback) {
            return this.rpcCall(updateRole, $root.api.UpdateClientRoleRequest, $root.common.Empty, request, callback);
        }, "name", { value: "UpdateRole" });

        /**
         * Calls UpdateRole.
         * @function updateRole
         * @memberof api.ClientService
         * @instance
         * @param {api.IUpdateClientRoleRequest} request UpdateClientRoleRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ClientService#delete_}.
         * @memberof api.ClientService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientID} request ClientID message or plain object
         * @param {api.ClientService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ClientService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.ClientID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ClientService
         * @instance
         * @param {entity.IClientID} request ClientID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ClientService;
    })();

    api.CreateClientRequest = (function() {

        /**
         * Properties of a CreateClientRequest.
         * @memberof api
         * @interface ICreateClientRequest
         * @property {string|null} [name] CreateClientRequest name
         * @property {string|null} [nameKana] CreateClientRequest nameKana
         * @property {string|null} [phoneNumber] CreateClientRequest phoneNumber
         * @property {string|null} [position] CreateClientRequest position
         * @property {string|null} [email] CreateClientRequest email
         * @property {string|null} [password] CreateClientRequest password
         * @property {entity.Client.Role|null} [role] CreateClientRequest role
         * @property {string|null} [department] CreateClientRequest department
         */

        /**
         * Constructs a new CreateClientRequest.
         * @memberof api
         * @classdesc Represents a CreateClientRequest.
         * @implements ICreateClientRequest
         * @constructor
         * @param {api.ICreateClientRequest=} [properties] Properties to set
         */
        function CreateClientRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateClientRequest name.
         * @member {string} name
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.name = "";

        /**
         * CreateClientRequest nameKana.
         * @member {string} nameKana
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.nameKana = "";

        /**
         * CreateClientRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.phoneNumber = "";

        /**
         * CreateClientRequest position.
         * @member {string} position
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.position = "";

        /**
         * CreateClientRequest email.
         * @member {string} email
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.email = "";

        /**
         * CreateClientRequest password.
         * @member {string} password
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.password = "";

        /**
         * CreateClientRequest role.
         * @member {entity.Client.Role} role
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.role = 0;

        /**
         * CreateClientRequest department.
         * @member {string} department
         * @memberof api.CreateClientRequest
         * @instance
         */
        CreateClientRequest.prototype.department = "";

        /**
         * Creates a new CreateClientRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateClientRequest
         * @static
         * @param {api.ICreateClientRequest=} [properties] Properties to set
         * @returns {api.CreateClientRequest} CreateClientRequest instance
         */
        CreateClientRequest.create = function create(properties) {
            return new CreateClientRequest(properties);
        };

        /**
         * Encodes the specified CreateClientRequest message. Does not implicitly {@link api.CreateClientRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateClientRequest
         * @static
         * @param {api.ICreateClientRequest} message CreateClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateClientRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.position);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.password);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.role);
            if (message.department != null && Object.hasOwnProperty.call(message, "department"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.department);
            return writer;
        };

        /**
         * Encodes the specified CreateClientRequest message, length delimited. Does not implicitly {@link api.CreateClientRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateClientRequest
         * @static
         * @param {api.ICreateClientRequest} message CreateClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateClientRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateClientRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateClientRequest} CreateClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateClientRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateClientRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 4:
                    message.phoneNumber = reader.string();
                    break;
                case 5:
                    message.position = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.password = reader.string();
                    break;
                case 8:
                    message.role = reader.int32();
                    break;
                case 9:
                    message.department = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateClientRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateClientRequest} CreateClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateClientRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateClientRequest message.
         * @function verify
         * @memberof api.CreateClientRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateClientRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.department != null && message.hasOwnProperty("department"))
                if (!$util.isString(message.department))
                    return "department: string expected";
            return null;
        };

        /**
         * Creates a CreateClientRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateClientRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateClientRequest} CreateClientRequest
         */
        CreateClientRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateClientRequest)
                return object;
            var message = new $root.api.CreateClientRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.position != null)
                message.position = String(object.position);
            if (object.email != null)
                message.email = String(object.email);
            if (object.password != null)
                message.password = String(object.password);
            switch (object.role) {
            case "Role_Unknown":
            case 0:
                message.role = 0;
                break;
            case "Role_Admin":
            case 1:
                message.role = 1;
                break;
            case "Role_Member":
            case 2:
                message.role = 2;
                break;
            }
            if (object.department != null)
                message.department = String(object.department);
            return message;
        };

        /**
         * Creates a plain object from a CreateClientRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateClientRequest
         * @static
         * @param {api.CreateClientRequest} message CreateClientRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateClientRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.phoneNumber = "";
                object.position = "";
                object.email = "";
                object.password = "";
                object.role = options.enums === String ? "Role_Unknown" : 0;
                object.department = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.entity.Client.Role[message.role] : message.role;
            if (message.department != null && message.hasOwnProperty("department"))
                object.department = message.department;
            return object;
        };

        /**
         * Converts this CreateClientRequest to JSON.
         * @function toJSON
         * @memberof api.CreateClientRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateClientRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateClientRequest;
    })();

    api.UpdateClientRequest = (function() {

        /**
         * Properties of an UpdateClientRequest.
         * @memberof api
         * @interface IUpdateClientRequest
         * @property {string|null} [name] UpdateClientRequest name
         * @property {string|null} [nameKana] UpdateClientRequest nameKana
         * @property {string|null} [iconURL] UpdateClientRequest iconURL
         * @property {string|null} [phoneNumber] UpdateClientRequest phoneNumber
         * @property {string|null} [position] UpdateClientRequest position
         * @property {string|null} [department] UpdateClientRequest department
         */

        /**
         * Constructs a new UpdateClientRequest.
         * @memberof api
         * @classdesc Represents an UpdateClientRequest.
         * @implements IUpdateClientRequest
         * @constructor
         * @param {api.IUpdateClientRequest=} [properties] Properties to set
         */
        function UpdateClientRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateClientRequest name.
         * @member {string} name
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.name = "";

        /**
         * UpdateClientRequest nameKana.
         * @member {string} nameKana
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.nameKana = "";

        /**
         * UpdateClientRequest iconURL.
         * @member {string} iconURL
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.iconURL = "";

        /**
         * UpdateClientRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.phoneNumber = "";

        /**
         * UpdateClientRequest position.
         * @member {string} position
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.position = "";

        /**
         * UpdateClientRequest department.
         * @member {string} department
         * @memberof api.UpdateClientRequest
         * @instance
         */
        UpdateClientRequest.prototype.department = "";

        /**
         * Creates a new UpdateClientRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateClientRequest
         * @static
         * @param {api.IUpdateClientRequest=} [properties] Properties to set
         * @returns {api.UpdateClientRequest} UpdateClientRequest instance
         */
        UpdateClientRequest.create = function create(properties) {
            return new UpdateClientRequest(properties);
        };

        /**
         * Encodes the specified UpdateClientRequest message. Does not implicitly {@link api.UpdateClientRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateClientRequest
         * @static
         * @param {api.IUpdateClientRequest} message UpdateClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateClientRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.iconURL != null && Object.hasOwnProperty.call(message, "iconURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.iconURL);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.position);
            if (message.department != null && Object.hasOwnProperty.call(message, "department"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.department);
            return writer;
        };

        /**
         * Encodes the specified UpdateClientRequest message, length delimited. Does not implicitly {@link api.UpdateClientRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateClientRequest
         * @static
         * @param {api.IUpdateClientRequest} message UpdateClientRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateClientRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateClientRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateClientRequest} UpdateClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateClientRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateClientRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 3:
                    message.iconURL = reader.string();
                    break;
                case 4:
                    message.phoneNumber = reader.string();
                    break;
                case 5:
                    message.position = reader.string();
                    break;
                case 6:
                    message.department = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateClientRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateClientRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateClientRequest} UpdateClientRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateClientRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateClientRequest message.
         * @function verify
         * @memberof api.UpdateClientRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateClientRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.iconURL != null && message.hasOwnProperty("iconURL"))
                if (!$util.isString(message.iconURL))
                    return "iconURL: string expected";
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.department != null && message.hasOwnProperty("department"))
                if (!$util.isString(message.department))
                    return "department: string expected";
            return null;
        };

        /**
         * Creates an UpdateClientRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateClientRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateClientRequest} UpdateClientRequest
         */
        UpdateClientRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateClientRequest)
                return object;
            var message = new $root.api.UpdateClientRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            if (object.iconURL != null)
                message.iconURL = String(object.iconURL);
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.position != null)
                message.position = String(object.position);
            if (object.department != null)
                message.department = String(object.department);
            return message;
        };

        /**
         * Creates a plain object from an UpdateClientRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateClientRequest
         * @static
         * @param {api.UpdateClientRequest} message UpdateClientRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateClientRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.iconURL = "";
                object.phoneNumber = "";
                object.position = "";
                object.department = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.iconURL != null && message.hasOwnProperty("iconURL"))
                object.iconURL = message.iconURL;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.department != null && message.hasOwnProperty("department"))
                object.department = message.department;
            return object;
        };

        /**
         * Converts this UpdateClientRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateClientRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateClientRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateClientRequest;
    })();

    api.UpdateClientRoleRequest = (function() {

        /**
         * Properties of an UpdateClientRoleRequest.
         * @memberof api
         * @interface IUpdateClientRoleRequest
         * @property {string|null} [clientID] UpdateClientRoleRequest clientID
         * @property {entity.Client.Role|null} [role] UpdateClientRoleRequest role
         */

        /**
         * Constructs a new UpdateClientRoleRequest.
         * @memberof api
         * @classdesc Represents an UpdateClientRoleRequest.
         * @implements IUpdateClientRoleRequest
         * @constructor
         * @param {api.IUpdateClientRoleRequest=} [properties] Properties to set
         */
        function UpdateClientRoleRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateClientRoleRequest clientID.
         * @member {string} clientID
         * @memberof api.UpdateClientRoleRequest
         * @instance
         */
        UpdateClientRoleRequest.prototype.clientID = "";

        /**
         * UpdateClientRoleRequest role.
         * @member {entity.Client.Role} role
         * @memberof api.UpdateClientRoleRequest
         * @instance
         */
        UpdateClientRoleRequest.prototype.role = 0;

        /**
         * Creates a new UpdateClientRoleRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {api.IUpdateClientRoleRequest=} [properties] Properties to set
         * @returns {api.UpdateClientRoleRequest} UpdateClientRoleRequest instance
         */
        UpdateClientRoleRequest.create = function create(properties) {
            return new UpdateClientRoleRequest(properties);
        };

        /**
         * Encodes the specified UpdateClientRoleRequest message. Does not implicitly {@link api.UpdateClientRoleRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {api.IUpdateClientRoleRequest} message UpdateClientRoleRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateClientRoleRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.clientID != null && Object.hasOwnProperty.call(message, "clientID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientID);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.role);
            return writer;
        };

        /**
         * Encodes the specified UpdateClientRoleRequest message, length delimited. Does not implicitly {@link api.UpdateClientRoleRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {api.IUpdateClientRoleRequest} message UpdateClientRoleRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateClientRoleRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateClientRoleRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateClientRoleRequest} UpdateClientRoleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateClientRoleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateClientRoleRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.clientID = reader.string();
                    break;
                case 2:
                    message.role = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateClientRoleRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateClientRoleRequest} UpdateClientRoleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateClientRoleRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateClientRoleRequest message.
         * @function verify
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateClientRoleRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                if (!$util.isString(message.clientID))
                    return "clientID: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates an UpdateClientRoleRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateClientRoleRequest} UpdateClientRoleRequest
         */
        UpdateClientRoleRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateClientRoleRequest)
                return object;
            var message = new $root.api.UpdateClientRoleRequest();
            if (object.clientID != null)
                message.clientID = String(object.clientID);
            switch (object.role) {
            case "Role_Unknown":
            case 0:
                message.role = 0;
                break;
            case "Role_Admin":
            case 1:
                message.role = 1;
                break;
            case "Role_Member":
            case 2:
                message.role = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateClientRoleRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateClientRoleRequest
         * @static
         * @param {api.UpdateClientRoleRequest} message UpdateClientRoleRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateClientRoleRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.clientID = "";
                object.role = options.enums === String ? "Role_Unknown" : 0;
            }
            if (message.clientID != null && message.hasOwnProperty("clientID"))
                object.clientID = message.clientID;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.entity.Client.Role[message.role] : message.role;
            return object;
        };

        /**
         * Converts this UpdateClientRoleRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateClientRoleRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateClientRoleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateClientRoleRequest;
    })();

    api.CompanyService = (function() {

        /**
         * Constructs a new CompanyService service.
         * @memberof api
         * @classdesc Represents a CompanyService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CompanyService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CompanyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CompanyService;

        /**
         * Creates new CompanyService service using the specified rpc implementation.
         * @function create
         * @memberof api.CompanyService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CompanyService} RPC service. Useful where requests and/or responses are streamed.
         */
        CompanyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.CompanyService#getAllByIDs}.
         * @memberof api.CompanyService
         * @typedef GetAllByIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.CompanyList} [response] CompanyList
         */

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.CompanyService
         * @instance
         * @param {entity.ICompanyIDList} request CompanyIDList message or plain object
         * @param {api.CompanyService.GetAllByIDsCallback} callback Node-style callback called with the error, if any, and CompanyList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CompanyService.prototype.getAllByIDs = function getAllByIDs(request, callback) {
            return this.rpcCall(getAllByIDs, $root.entity.CompanyIDList, $root.entity.CompanyList, request, callback);
        }, "name", { value: "GetAllByIDs" });

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.CompanyService
         * @instance
         * @param {entity.ICompanyIDList} request CompanyIDList message or plain object
         * @returns {Promise<entity.CompanyList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CompanyService#getAllByIDsWithMask}.
         * @memberof api.CompanyService
         * @typedef GetAllByIDsWithMaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {api.CompanyWithProjectIDList} [response] CompanyWithProjectIDList
         */

        /**
         * Calls GetAllByIDsWithMask.
         * @function getAllByIDsWithMask
         * @memberof api.CompanyService
         * @instance
         * @param {api.ICompanyIDWithProjectIDList} request CompanyIDWithProjectIDList message or plain object
         * @param {api.CompanyService.GetAllByIDsWithMaskCallback} callback Node-style callback called with the error, if any, and CompanyWithProjectIDList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CompanyService.prototype.getAllByIDsWithMask = function getAllByIDsWithMask(request, callback) {
            return this.rpcCall(getAllByIDsWithMask, $root.api.CompanyIDWithProjectIDList, $root.api.CompanyWithProjectIDList, request, callback);
        }, "name", { value: "GetAllByIDsWithMask" });

        /**
         * Calls GetAllByIDsWithMask.
         * @function getAllByIDsWithMask
         * @memberof api.CompanyService
         * @instance
         * @param {api.ICompanyIDWithProjectIDList} request CompanyIDWithProjectIDList message or plain object
         * @returns {Promise<api.CompanyWithProjectIDList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CompanyService#get}.
         * @memberof api.CompanyService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Company} [response] Company
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.CompanyService
         * @instance
         * @param {entity.ICompanyID} request CompanyID message or plain object
         * @param {api.CompanyService.GetCallback} callback Node-style callback called with the error, if any, and Company
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CompanyService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.CompanyID, $root.entity.Company, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.CompanyService
         * @instance
         * @param {entity.ICompanyID} request CompanyID message or plain object
         * @returns {Promise<entity.Company>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CompanyService#getWithMask}.
         * @memberof api.CompanyService
         * @typedef GetWithMaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Company} [response] Company
         */

        /**
         * Calls GetWithMask.
         * @function getWithMask
         * @memberof api.CompanyService
         * @instance
         * @param {api.ICompanyIDWithProjectID} request CompanyIDWithProjectID message or plain object
         * @param {api.CompanyService.GetWithMaskCallback} callback Node-style callback called with the error, if any, and Company
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CompanyService.prototype.getWithMask = function getWithMask(request, callback) {
            return this.rpcCall(getWithMask, $root.api.CompanyIDWithProjectID, $root.entity.Company, request, callback);
        }, "name", { value: "GetWithMask" });

        /**
         * Calls GetWithMask.
         * @function getWithMask
         * @memberof api.CompanyService
         * @instance
         * @param {api.ICompanyIDWithProjectID} request CompanyIDWithProjectID message or plain object
         * @returns {Promise<entity.Company>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CompanyService#update}.
         * @memberof api.CompanyService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Company} [response] Company
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.CompanyService
         * @instance
         * @param {api.IUpdateCompanyRequest} request UpdateCompanyRequest message or plain object
         * @param {api.CompanyService.UpdateCallback} callback Node-style callback called with the error, if any, and Company
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CompanyService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateCompanyRequest, $root.entity.Company, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.CompanyService
         * @instance
         * @param {api.IUpdateCompanyRequest} request UpdateCompanyRequest message or plain object
         * @returns {Promise<entity.Company>} Promise
         * @variation 2
         */

        return CompanyService;
    })();

    api.CompanyIDWithProjectID = (function() {

        /**
         * Properties of a CompanyIDWithProjectID.
         * @memberof api
         * @interface ICompanyIDWithProjectID
         * @property {string|null} [companyID] CompanyIDWithProjectID companyID
         * @property {string|null} [projectID] CompanyIDWithProjectID projectID
         */

        /**
         * Constructs a new CompanyIDWithProjectID.
         * @memberof api
         * @classdesc Represents a CompanyIDWithProjectID.
         * @implements ICompanyIDWithProjectID
         * @constructor
         * @param {api.ICompanyIDWithProjectID=} [properties] Properties to set
         */
        function CompanyIDWithProjectID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyIDWithProjectID companyID.
         * @member {string} companyID
         * @memberof api.CompanyIDWithProjectID
         * @instance
         */
        CompanyIDWithProjectID.prototype.companyID = "";

        /**
         * CompanyIDWithProjectID projectID.
         * @member {string} projectID
         * @memberof api.CompanyIDWithProjectID
         * @instance
         */
        CompanyIDWithProjectID.prototype.projectID = "";

        /**
         * Creates a new CompanyIDWithProjectID instance using the specified properties.
         * @function create
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {api.ICompanyIDWithProjectID=} [properties] Properties to set
         * @returns {api.CompanyIDWithProjectID} CompanyIDWithProjectID instance
         */
        CompanyIDWithProjectID.create = function create(properties) {
            return new CompanyIDWithProjectID(properties);
        };

        /**
         * Encodes the specified CompanyIDWithProjectID message. Does not implicitly {@link api.CompanyIDWithProjectID.verify|verify} messages.
         * @function encode
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {api.ICompanyIDWithProjectID} message CompanyIDWithProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithProjectID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.companyID != null && Object.hasOwnProperty.call(message, "companyID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.companyID);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            return writer;
        };

        /**
         * Encodes the specified CompanyIDWithProjectID message, length delimited. Does not implicitly {@link api.CompanyIDWithProjectID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {api.ICompanyIDWithProjectID} message CompanyIDWithProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithProjectID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyIDWithProjectID message from the specified reader or buffer.
         * @function decode
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CompanyIDWithProjectID} CompanyIDWithProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithProjectID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CompanyIDWithProjectID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.companyID = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyIDWithProjectID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CompanyIDWithProjectID} CompanyIDWithProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithProjectID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyIDWithProjectID message.
         * @function verify
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyIDWithProjectID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                if (!$util.isString(message.companyID))
                    return "companyID: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            return null;
        };

        /**
         * Creates a CompanyIDWithProjectID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CompanyIDWithProjectID} CompanyIDWithProjectID
         */
        CompanyIDWithProjectID.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CompanyIDWithProjectID)
                return object;
            var message = new $root.api.CompanyIDWithProjectID();
            if (object.companyID != null)
                message.companyID = String(object.companyID);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            return message;
        };

        /**
         * Creates a plain object from a CompanyIDWithProjectID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CompanyIDWithProjectID
         * @static
         * @param {api.CompanyIDWithProjectID} message CompanyIDWithProjectID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyIDWithProjectID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.companyID = "";
                object.projectID = "";
            }
            if (message.companyID != null && message.hasOwnProperty("companyID"))
                object.companyID = message.companyID;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            return object;
        };

        /**
         * Converts this CompanyIDWithProjectID to JSON.
         * @function toJSON
         * @memberof api.CompanyIDWithProjectID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyIDWithProjectID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyIDWithProjectID;
    })();

    api.CompanyIDWithProjectIDList = (function() {

        /**
         * Properties of a CompanyIDWithProjectIDList.
         * @memberof api
         * @interface ICompanyIDWithProjectIDList
         * @property {Array.<api.ICompanyIDWithProjectID>|null} [items] CompanyIDWithProjectIDList items
         */

        /**
         * Constructs a new CompanyIDWithProjectIDList.
         * @memberof api
         * @classdesc Represents a CompanyIDWithProjectIDList.
         * @implements ICompanyIDWithProjectIDList
         * @constructor
         * @param {api.ICompanyIDWithProjectIDList=} [properties] Properties to set
         */
        function CompanyIDWithProjectIDList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyIDWithProjectIDList items.
         * @member {Array.<api.ICompanyIDWithProjectID>} items
         * @memberof api.CompanyIDWithProjectIDList
         * @instance
         */
        CompanyIDWithProjectIDList.prototype.items = $util.emptyArray;

        /**
         * Creates a new CompanyIDWithProjectIDList instance using the specified properties.
         * @function create
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {api.ICompanyIDWithProjectIDList=} [properties] Properties to set
         * @returns {api.CompanyIDWithProjectIDList} CompanyIDWithProjectIDList instance
         */
        CompanyIDWithProjectIDList.create = function create(properties) {
            return new CompanyIDWithProjectIDList(properties);
        };

        /**
         * Encodes the specified CompanyIDWithProjectIDList message. Does not implicitly {@link api.CompanyIDWithProjectIDList.verify|verify} messages.
         * @function encode
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {api.ICompanyIDWithProjectIDList} message CompanyIDWithProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithProjectIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.api.CompanyIDWithProjectID.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompanyIDWithProjectIDList message, length delimited. Does not implicitly {@link api.CompanyIDWithProjectIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {api.ICompanyIDWithProjectIDList} message CompanyIDWithProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyIDWithProjectIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyIDWithProjectIDList message from the specified reader or buffer.
         * @function decode
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CompanyIDWithProjectIDList} CompanyIDWithProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithProjectIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CompanyIDWithProjectIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.api.CompanyIDWithProjectID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyIDWithProjectIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CompanyIDWithProjectIDList} CompanyIDWithProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyIDWithProjectIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyIDWithProjectIDList message.
         * @function verify
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyIDWithProjectIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.api.CompanyIDWithProjectID.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompanyIDWithProjectIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CompanyIDWithProjectIDList} CompanyIDWithProjectIDList
         */
        CompanyIDWithProjectIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CompanyIDWithProjectIDList)
                return object;
            var message = new $root.api.CompanyIDWithProjectIDList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".api.CompanyIDWithProjectIDList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".api.CompanyIDWithProjectIDList.items: object expected");
                    message.items[i] = $root.api.CompanyIDWithProjectID.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyIDWithProjectIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CompanyIDWithProjectIDList
         * @static
         * @param {api.CompanyIDWithProjectIDList} message CompanyIDWithProjectIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyIDWithProjectIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.api.CompanyIDWithProjectID.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CompanyIDWithProjectIDList to JSON.
         * @function toJSON
         * @memberof api.CompanyIDWithProjectIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyIDWithProjectIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyIDWithProjectIDList;
    })();

    api.UpdateCompanyRequest = (function() {

        /**
         * Properties of an UpdateCompanyRequest.
         * @memberof api
         * @interface IUpdateCompanyRequest
         * @property {string|null} [name] UpdateCompanyRequest name
         * @property {string|null} [logoURL] UpdateCompanyRequest logoURL
         * @property {string|null} [webURL] UpdateCompanyRequest webURL
         * @property {string|null} [establishedAt] UpdateCompanyRequest establishedAt
         * @property {string|null} [postalCode] UpdateCompanyRequest postalCode
         * @property {string|null} [place] UpdateCompanyRequest place
         * @property {Array.<entity.Company.Business>|null} [businesses] UpdateCompanyRequest businesses
         * @property {string|null} [representativeName] UpdateCompanyRequest representativeName
         * @property {string|null} [capitalStock] UpdateCompanyRequest capitalStock
         * @property {entity.Company.EmployeeScale|null} [employeeScale] UpdateCompanyRequest employeeScale
         * @property {string|null} [introduction] UpdateCompanyRequest introduction
         * @property {string|null} [accordingCompanyName] UpdateCompanyRequest accordingCompanyName
         * @property {string|null} [accordingCompanyPostalCode] UpdateCompanyRequest accordingCompanyPostalCode
         * @property {string|null} [accordingCompanyAddress] UpdateCompanyRequest accordingCompanyAddress
         * @property {string|null} [invoiceDepartmentName] UpdateCompanyRequest invoiceDepartmentName
         */

        /**
         * Constructs a new UpdateCompanyRequest.
         * @memberof api
         * @classdesc Represents an UpdateCompanyRequest.
         * @implements IUpdateCompanyRequest
         * @constructor
         * @param {api.IUpdateCompanyRequest=} [properties] Properties to set
         */
        function UpdateCompanyRequest(properties) {
            this.businesses = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateCompanyRequest name.
         * @member {string} name
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.name = "";

        /**
         * UpdateCompanyRequest logoURL.
         * @member {string} logoURL
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.logoURL = "";

        /**
         * UpdateCompanyRequest webURL.
         * @member {string} webURL
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.webURL = "";

        /**
         * UpdateCompanyRequest establishedAt.
         * @member {string} establishedAt
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.establishedAt = "";

        /**
         * UpdateCompanyRequest postalCode.
         * @member {string} postalCode
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.postalCode = "";

        /**
         * UpdateCompanyRequest place.
         * @member {string} place
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.place = "";

        /**
         * UpdateCompanyRequest businesses.
         * @member {Array.<entity.Company.Business>} businesses
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.businesses = $util.emptyArray;

        /**
         * UpdateCompanyRequest representativeName.
         * @member {string} representativeName
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.representativeName = "";

        /**
         * UpdateCompanyRequest capitalStock.
         * @member {string} capitalStock
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.capitalStock = "";

        /**
         * UpdateCompanyRequest employeeScale.
         * @member {entity.Company.EmployeeScale} employeeScale
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.employeeScale = 0;

        /**
         * UpdateCompanyRequest introduction.
         * @member {string} introduction
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.introduction = "";

        /**
         * UpdateCompanyRequest accordingCompanyName.
         * @member {string} accordingCompanyName
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.accordingCompanyName = "";

        /**
         * UpdateCompanyRequest accordingCompanyPostalCode.
         * @member {string} accordingCompanyPostalCode
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.accordingCompanyPostalCode = "";

        /**
         * UpdateCompanyRequest accordingCompanyAddress.
         * @member {string} accordingCompanyAddress
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.accordingCompanyAddress = "";

        /**
         * UpdateCompanyRequest invoiceDepartmentName.
         * @member {string} invoiceDepartmentName
         * @memberof api.UpdateCompanyRequest
         * @instance
         */
        UpdateCompanyRequest.prototype.invoiceDepartmentName = "";

        /**
         * Creates a new UpdateCompanyRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {api.IUpdateCompanyRequest=} [properties] Properties to set
         * @returns {api.UpdateCompanyRequest} UpdateCompanyRequest instance
         */
        UpdateCompanyRequest.create = function create(properties) {
            return new UpdateCompanyRequest(properties);
        };

        /**
         * Encodes the specified UpdateCompanyRequest message. Does not implicitly {@link api.UpdateCompanyRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {api.IUpdateCompanyRequest} message UpdateCompanyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCompanyRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.logoURL != null && Object.hasOwnProperty.call(message, "logoURL"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.logoURL);
            if (message.webURL != null && Object.hasOwnProperty.call(message, "webURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.webURL);
            if (message.establishedAt != null && Object.hasOwnProperty.call(message, "establishedAt"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.establishedAt);
            if (message.postalCode != null && Object.hasOwnProperty.call(message, "postalCode"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.postalCode);
            if (message.place != null && Object.hasOwnProperty.call(message, "place"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.place);
            if (message.businesses != null && message.businesses.length) {
                writer.uint32(/* id 7, wireType 2 =*/58).fork();
                for (var i = 0; i < message.businesses.length; ++i)
                    writer.int32(message.businesses[i]);
                writer.ldelim();
            }
            if (message.representativeName != null && Object.hasOwnProperty.call(message, "representativeName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.representativeName);
            if (message.capitalStock != null && Object.hasOwnProperty.call(message, "capitalStock"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.capitalStock);
            if (message.employeeScale != null && Object.hasOwnProperty.call(message, "employeeScale"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.employeeScale);
            if (message.introduction != null && Object.hasOwnProperty.call(message, "introduction"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.introduction);
            if (message.accordingCompanyName != null && Object.hasOwnProperty.call(message, "accordingCompanyName"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.accordingCompanyName);
            if (message.accordingCompanyPostalCode != null && Object.hasOwnProperty.call(message, "accordingCompanyPostalCode"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.accordingCompanyPostalCode);
            if (message.accordingCompanyAddress != null && Object.hasOwnProperty.call(message, "accordingCompanyAddress"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.accordingCompanyAddress);
            if (message.invoiceDepartmentName != null && Object.hasOwnProperty.call(message, "invoiceDepartmentName"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.invoiceDepartmentName);
            return writer;
        };

        /**
         * Encodes the specified UpdateCompanyRequest message, length delimited. Does not implicitly {@link api.UpdateCompanyRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {api.IUpdateCompanyRequest} message UpdateCompanyRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCompanyRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateCompanyRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateCompanyRequest} UpdateCompanyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCompanyRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateCompanyRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.logoURL = reader.string();
                    break;
                case 3:
                    message.webURL = reader.string();
                    break;
                case 4:
                    message.establishedAt = reader.string();
                    break;
                case 5:
                    message.postalCode = reader.string();
                    break;
                case 6:
                    message.place = reader.string();
                    break;
                case 7:
                    if (!(message.businesses && message.businesses.length))
                        message.businesses = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.businesses.push(reader.int32());
                    } else
                        message.businesses.push(reader.int32());
                    break;
                case 8:
                    message.representativeName = reader.string();
                    break;
                case 9:
                    message.capitalStock = reader.string();
                    break;
                case 10:
                    message.employeeScale = reader.int32();
                    break;
                case 11:
                    message.introduction = reader.string();
                    break;
                case 12:
                    message.accordingCompanyName = reader.string();
                    break;
                case 13:
                    message.accordingCompanyPostalCode = reader.string();
                    break;
                case 14:
                    message.accordingCompanyAddress = reader.string();
                    break;
                case 15:
                    message.invoiceDepartmentName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateCompanyRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateCompanyRequest} UpdateCompanyRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCompanyRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateCompanyRequest message.
         * @function verify
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateCompanyRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.logoURL != null && message.hasOwnProperty("logoURL"))
                if (!$util.isString(message.logoURL))
                    return "logoURL: string expected";
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                if (!$util.isString(message.webURL))
                    return "webURL: string expected";
            if (message.establishedAt != null && message.hasOwnProperty("establishedAt"))
                if (!$util.isString(message.establishedAt))
                    return "establishedAt: string expected";
            if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                if (!$util.isString(message.postalCode))
                    return "postalCode: string expected";
            if (message.place != null && message.hasOwnProperty("place"))
                if (!$util.isString(message.place))
                    return "place: string expected";
            if (message.businesses != null && message.hasOwnProperty("businesses")) {
                if (!Array.isArray(message.businesses))
                    return "businesses: array expected";
                for (var i = 0; i < message.businesses.length; ++i)
                    switch (message.businesses[i]) {
                    default:
                        return "businesses: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                        break;
                    }
            }
            if (message.representativeName != null && message.hasOwnProperty("representativeName"))
                if (!$util.isString(message.representativeName))
                    return "representativeName: string expected";
            if (message.capitalStock != null && message.hasOwnProperty("capitalStock"))
                if (!$util.isString(message.capitalStock))
                    return "capitalStock: string expected";
            if (message.employeeScale != null && message.hasOwnProperty("employeeScale"))
                switch (message.employeeScale) {
                default:
                    return "employeeScale: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.introduction != null && message.hasOwnProperty("introduction"))
                if (!$util.isString(message.introduction))
                    return "introduction: string expected";
            if (message.accordingCompanyName != null && message.hasOwnProperty("accordingCompanyName"))
                if (!$util.isString(message.accordingCompanyName))
                    return "accordingCompanyName: string expected";
            if (message.accordingCompanyPostalCode != null && message.hasOwnProperty("accordingCompanyPostalCode"))
                if (!$util.isString(message.accordingCompanyPostalCode))
                    return "accordingCompanyPostalCode: string expected";
            if (message.accordingCompanyAddress != null && message.hasOwnProperty("accordingCompanyAddress"))
                if (!$util.isString(message.accordingCompanyAddress))
                    return "accordingCompanyAddress: string expected";
            if (message.invoiceDepartmentName != null && message.hasOwnProperty("invoiceDepartmentName"))
                if (!$util.isString(message.invoiceDepartmentName))
                    return "invoiceDepartmentName: string expected";
            return null;
        };

        /**
         * Creates an UpdateCompanyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateCompanyRequest} UpdateCompanyRequest
         */
        UpdateCompanyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateCompanyRequest)
                return object;
            var message = new $root.api.UpdateCompanyRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.logoURL != null)
                message.logoURL = String(object.logoURL);
            if (object.webURL != null)
                message.webURL = String(object.webURL);
            if (object.establishedAt != null)
                message.establishedAt = String(object.establishedAt);
            if (object.postalCode != null)
                message.postalCode = String(object.postalCode);
            if (object.place != null)
                message.place = String(object.place);
            if (object.businesses) {
                if (!Array.isArray(object.businesses))
                    throw TypeError(".api.UpdateCompanyRequest.businesses: array expected");
                message.businesses = [];
                for (var i = 0; i < object.businesses.length; ++i)
                    switch (object.businesses[i]) {
                    default:
                    case "Business_Unknown":
                    case 0:
                        message.businesses[i] = 0;
                        break;
                    case "Business_AgricultureForestryAndFisheries":
                    case 1:
                        message.businesses[i] = 1;
                        break;
                    case "Business_MiningIndustry":
                    case 2:
                        message.businesses[i] = 2;
                        break;
                    case "Business_ConstructionIndustry":
                    case 3:
                        message.businesses[i] = 3;
                        break;
                    case "Business_ManufacturingIndustry":
                    case 4:
                        message.businesses[i] = 4;
                        break;
                    case "Business_ElectricPowerAndGas":
                    case 5:
                        message.businesses[i] = 5;
                        break;
                    case "Business_InformationAndCommunicationIndustry":
                    case 6:
                        message.businesses[i] = 6;
                        break;
                    case "Business_TransportationIndustry":
                    case 7:
                        message.businesses[i] = 7;
                        break;
                    case "Business_WholesaleAndRetailTrade":
                    case 8:
                        message.businesses[i] = 8;
                        break;
                    case "Business_RestaurantBusiness":
                    case 9:
                        message.businesses[i] = 9;
                        break;
                    case "Business_FinanceAndInsurance":
                    case 10:
                        message.businesses[i] = 10;
                        break;
                    case "Business_RealEstateBusiness":
                    case 11:
                        message.businesses[i] = 11;
                        break;
                    case "Business_ServiceIndustry":
                    case 12:
                        message.businesses[i] = 12;
                        break;
                    case "Business_LodgingIndustry":
                    case 13:
                        message.businesses[i] = 13;
                        break;
                    case "Business_EducationBusiness":
                    case 14:
                        message.businesses[i] = 14;
                        break;
                    case "Business_MedicalAndWelfare":
                    case 15:
                        message.businesses[i] = 15;
                        break;
                    case "Business_AcademicAndResearch":
                    case 16:
                        message.businesses[i] = 16;
                        break;
                    case "Business_OfficialBusiness":
                    case 17:
                        message.businesses[i] = 17;
                        break;
                    case "Business_PoliticalEconomy":
                    case 18:
                        message.businesses[i] = 18;
                        break;
                    case "Business_OtherBusiness":
                    case 19:
                        message.businesses[i] = 19;
                        break;
                    }
            }
            if (object.representativeName != null)
                message.representativeName = String(object.representativeName);
            if (object.capitalStock != null)
                message.capitalStock = String(object.capitalStock);
            switch (object.employeeScale) {
            case "EmployeeScale_Unknown":
            case 0:
                message.employeeScale = 0;
                break;
            case "EmployeeScale_Under_10_People":
            case 1:
                message.employeeScale = 1;
                break;
            case "EmployeeScale_10_100_People":
            case 2:
                message.employeeScale = 2;
                break;
            case "EmployeeScale_100_1000_People":
            case 3:
                message.employeeScale = 3;
                break;
            case "EmployeeScale_Over_1000_People":
            case 4:
                message.employeeScale = 4;
                break;
            }
            if (object.introduction != null)
                message.introduction = String(object.introduction);
            if (object.accordingCompanyName != null)
                message.accordingCompanyName = String(object.accordingCompanyName);
            if (object.accordingCompanyPostalCode != null)
                message.accordingCompanyPostalCode = String(object.accordingCompanyPostalCode);
            if (object.accordingCompanyAddress != null)
                message.accordingCompanyAddress = String(object.accordingCompanyAddress);
            if (object.invoiceDepartmentName != null)
                message.invoiceDepartmentName = String(object.invoiceDepartmentName);
            return message;
        };

        /**
         * Creates a plain object from an UpdateCompanyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateCompanyRequest
         * @static
         * @param {api.UpdateCompanyRequest} message UpdateCompanyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCompanyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.businesses = [];
            if (options.defaults) {
                object.name = "";
                object.logoURL = "";
                object.webURL = "";
                object.establishedAt = "";
                object.postalCode = "";
                object.place = "";
                object.representativeName = "";
                object.capitalStock = "";
                object.employeeScale = options.enums === String ? "EmployeeScale_Unknown" : 0;
                object.introduction = "";
                object.accordingCompanyName = "";
                object.accordingCompanyPostalCode = "";
                object.accordingCompanyAddress = "";
                object.invoiceDepartmentName = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.logoURL != null && message.hasOwnProperty("logoURL"))
                object.logoURL = message.logoURL;
            if (message.webURL != null && message.hasOwnProperty("webURL"))
                object.webURL = message.webURL;
            if (message.establishedAt != null && message.hasOwnProperty("establishedAt"))
                object.establishedAt = message.establishedAt;
            if (message.postalCode != null && message.hasOwnProperty("postalCode"))
                object.postalCode = message.postalCode;
            if (message.place != null && message.hasOwnProperty("place"))
                object.place = message.place;
            if (message.businesses && message.businesses.length) {
                object.businesses = [];
                for (var j = 0; j < message.businesses.length; ++j)
                    object.businesses[j] = options.enums === String ? $root.entity.Company.Business[message.businesses[j]] : message.businesses[j];
            }
            if (message.representativeName != null && message.hasOwnProperty("representativeName"))
                object.representativeName = message.representativeName;
            if (message.capitalStock != null && message.hasOwnProperty("capitalStock"))
                object.capitalStock = message.capitalStock;
            if (message.employeeScale != null && message.hasOwnProperty("employeeScale"))
                object.employeeScale = options.enums === String ? $root.entity.Company.EmployeeScale[message.employeeScale] : message.employeeScale;
            if (message.introduction != null && message.hasOwnProperty("introduction"))
                object.introduction = message.introduction;
            if (message.accordingCompanyName != null && message.hasOwnProperty("accordingCompanyName"))
                object.accordingCompanyName = message.accordingCompanyName;
            if (message.accordingCompanyPostalCode != null && message.hasOwnProperty("accordingCompanyPostalCode"))
                object.accordingCompanyPostalCode = message.accordingCompanyPostalCode;
            if (message.accordingCompanyAddress != null && message.hasOwnProperty("accordingCompanyAddress"))
                object.accordingCompanyAddress = message.accordingCompanyAddress;
            if (message.invoiceDepartmentName != null && message.hasOwnProperty("invoiceDepartmentName"))
                object.invoiceDepartmentName = message.invoiceDepartmentName;
            return object;
        };

        /**
         * Converts this UpdateCompanyRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateCompanyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCompanyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCompanyRequest;
    })();

    api.CompanyWithProjectID = (function() {

        /**
         * Properties of a CompanyWithProjectID.
         * @memberof api
         * @interface ICompanyWithProjectID
         * @property {entity.ICompany|null} [company] CompanyWithProjectID company
         * @property {string|null} [projectID] CompanyWithProjectID projectID
         */

        /**
         * Constructs a new CompanyWithProjectID.
         * @memberof api
         * @classdesc Represents a CompanyWithProjectID.
         * @implements ICompanyWithProjectID
         * @constructor
         * @param {api.ICompanyWithProjectID=} [properties] Properties to set
         */
        function CompanyWithProjectID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyWithProjectID company.
         * @member {entity.ICompany|null|undefined} company
         * @memberof api.CompanyWithProjectID
         * @instance
         */
        CompanyWithProjectID.prototype.company = null;

        /**
         * CompanyWithProjectID projectID.
         * @member {string} projectID
         * @memberof api.CompanyWithProjectID
         * @instance
         */
        CompanyWithProjectID.prototype.projectID = "";

        /**
         * Creates a new CompanyWithProjectID instance using the specified properties.
         * @function create
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {api.ICompanyWithProjectID=} [properties] Properties to set
         * @returns {api.CompanyWithProjectID} CompanyWithProjectID instance
         */
        CompanyWithProjectID.create = function create(properties) {
            return new CompanyWithProjectID(properties);
        };

        /**
         * Encodes the specified CompanyWithProjectID message. Does not implicitly {@link api.CompanyWithProjectID.verify|verify} messages.
         * @function encode
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {api.ICompanyWithProjectID} message CompanyWithProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyWithProjectID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.company != null && Object.hasOwnProperty.call(message, "company"))
                $root.entity.Company.encode(message.company, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            return writer;
        };

        /**
         * Encodes the specified CompanyWithProjectID message, length delimited. Does not implicitly {@link api.CompanyWithProjectID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {api.ICompanyWithProjectID} message CompanyWithProjectID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyWithProjectID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyWithProjectID message from the specified reader or buffer.
         * @function decode
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CompanyWithProjectID} CompanyWithProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyWithProjectID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CompanyWithProjectID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.company = $root.entity.Company.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyWithProjectID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CompanyWithProjectID} CompanyWithProjectID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyWithProjectID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyWithProjectID message.
         * @function verify
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyWithProjectID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.company != null && message.hasOwnProperty("company")) {
                var error = $root.entity.Company.verify(message.company);
                if (error)
                    return "company." + error;
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            return null;
        };

        /**
         * Creates a CompanyWithProjectID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CompanyWithProjectID} CompanyWithProjectID
         */
        CompanyWithProjectID.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CompanyWithProjectID)
                return object;
            var message = new $root.api.CompanyWithProjectID();
            if (object.company != null) {
                if (typeof object.company !== "object")
                    throw TypeError(".api.CompanyWithProjectID.company: object expected");
                message.company = $root.entity.Company.fromObject(object.company);
            }
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            return message;
        };

        /**
         * Creates a plain object from a CompanyWithProjectID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CompanyWithProjectID
         * @static
         * @param {api.CompanyWithProjectID} message CompanyWithProjectID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyWithProjectID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.company = null;
                object.projectID = "";
            }
            if (message.company != null && message.hasOwnProperty("company"))
                object.company = $root.entity.Company.toObject(message.company, options);
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            return object;
        };

        /**
         * Converts this CompanyWithProjectID to JSON.
         * @function toJSON
         * @memberof api.CompanyWithProjectID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyWithProjectID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyWithProjectID;
    })();

    api.CompanyWithProjectIDList = (function() {

        /**
         * Properties of a CompanyWithProjectIDList.
         * @memberof api
         * @interface ICompanyWithProjectIDList
         * @property {Array.<api.ICompanyWithProjectID>|null} [items] CompanyWithProjectIDList items
         */

        /**
         * Constructs a new CompanyWithProjectIDList.
         * @memberof api
         * @classdesc Represents a CompanyWithProjectIDList.
         * @implements ICompanyWithProjectIDList
         * @constructor
         * @param {api.ICompanyWithProjectIDList=} [properties] Properties to set
         */
        function CompanyWithProjectIDList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyWithProjectIDList items.
         * @member {Array.<api.ICompanyWithProjectID>} items
         * @memberof api.CompanyWithProjectIDList
         * @instance
         */
        CompanyWithProjectIDList.prototype.items = $util.emptyArray;

        /**
         * Creates a new CompanyWithProjectIDList instance using the specified properties.
         * @function create
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {api.ICompanyWithProjectIDList=} [properties] Properties to set
         * @returns {api.CompanyWithProjectIDList} CompanyWithProjectIDList instance
         */
        CompanyWithProjectIDList.create = function create(properties) {
            return new CompanyWithProjectIDList(properties);
        };

        /**
         * Encodes the specified CompanyWithProjectIDList message. Does not implicitly {@link api.CompanyWithProjectIDList.verify|verify} messages.
         * @function encode
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {api.ICompanyWithProjectIDList} message CompanyWithProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyWithProjectIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.api.CompanyWithProjectID.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompanyWithProjectIDList message, length delimited. Does not implicitly {@link api.CompanyWithProjectIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {api.ICompanyWithProjectIDList} message CompanyWithProjectIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyWithProjectIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyWithProjectIDList message from the specified reader or buffer.
         * @function decode
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CompanyWithProjectIDList} CompanyWithProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyWithProjectIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CompanyWithProjectIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.api.CompanyWithProjectID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyWithProjectIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CompanyWithProjectIDList} CompanyWithProjectIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyWithProjectIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyWithProjectIDList message.
         * @function verify
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyWithProjectIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.api.CompanyWithProjectID.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompanyWithProjectIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CompanyWithProjectIDList} CompanyWithProjectIDList
         */
        CompanyWithProjectIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CompanyWithProjectIDList)
                return object;
            var message = new $root.api.CompanyWithProjectIDList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".api.CompanyWithProjectIDList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".api.CompanyWithProjectIDList.items: object expected");
                    message.items[i] = $root.api.CompanyWithProjectID.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompanyWithProjectIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CompanyWithProjectIDList
         * @static
         * @param {api.CompanyWithProjectIDList} message CompanyWithProjectIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyWithProjectIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.api.CompanyWithProjectID.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this CompanyWithProjectIDList to JSON.
         * @function toJSON
         * @memberof api.CompanyWithProjectIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyWithProjectIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyWithProjectIDList;
    })();

    api.ContractCustomerReportService = (function() {

        /**
         * Constructs a new ContractCustomerReportService service.
         * @memberof api
         * @classdesc Represents a ContractCustomerReportService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractCustomerReportService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractCustomerReportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractCustomerReportService;

        /**
         * Creates new ContractCustomerReportService service using the specified rpc implementation.
         * @function create
         * @memberof api.ContractCustomerReportService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractCustomerReportService} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractCustomerReportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ContractCustomerReportService#getAllByContract}.
         * @memberof api.ContractCustomerReportService
         * @typedef GetAllByContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractCustomerReportList} [response] ContractCustomerReportList
         */

        /**
         * Calls GetAllByContract.
         * @function getAllByContract
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @param {api.ContractCustomerReportService.GetAllByContractCallback} callback Node-style callback called with the error, if any, and ContractCustomerReportList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCustomerReportService.prototype.getAllByContract = function getAllByContract(request, callback) {
            return this.rpcCall(getAllByContract, $root.entity.ContractID, $root.entity.ContractCustomerReportList, request, callback);
        }, "name", { value: "GetAllByContract" });

        /**
         * Calls GetAllByContract.
         * @function getAllByContract
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @returns {Promise<entity.ContractCustomerReportList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractCustomerReportService#get}.
         * @memberof api.ContractCustomerReportService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractCustomerReport} [response] ContractCustomerReport
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {entity.IContractCustomerReportID} request ContractCustomerReportID message or plain object
         * @param {api.ContractCustomerReportService.GetCallback} callback Node-style callback called with the error, if any, and ContractCustomerReport
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCustomerReportService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.ContractCustomerReportID, $root.entity.ContractCustomerReport, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {entity.IContractCustomerReportID} request ContractCustomerReportID message or plain object
         * @returns {Promise<entity.ContractCustomerReport>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractCustomerReportService#create}.
         * @memberof api.ContractCustomerReportService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractCustomerReport} [response] ContractCustomerReport
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {api.ICreateContractCustomerReportRequest} request CreateContractCustomerReportRequest message or plain object
         * @param {api.ContractCustomerReportService.CreateCallback} callback Node-style callback called with the error, if any, and ContractCustomerReport
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractCustomerReportService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateContractCustomerReportRequest, $root.entity.ContractCustomerReport, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractCustomerReportService
         * @instance
         * @param {api.ICreateContractCustomerReportRequest} request CreateContractCustomerReportRequest message or plain object
         * @returns {Promise<entity.ContractCustomerReport>} Promise
         * @variation 2
         */

        return ContractCustomerReportService;
    })();

    api.CreateContractCustomerReportRequest = (function() {

        /**
         * Properties of a CreateContractCustomerReportRequest.
         * @memberof api
         * @interface ICreateContractCustomerReportRequest
         * @property {string|null} [contractID] CreateContractCustomerReportRequest contractID
         * @property {string|null} [targetYM] CreateContractCustomerReportRequest targetYM
         * @property {string|null} [detail] CreateContractCustomerReportRequest detail
         * @property {entity.ContractOperationReport.SatisfactionLevel|null} [satisfactionLevel] CreateContractCustomerReportRequest satisfactionLevel
         * @property {entity.ContractOperationReport.ContinuationLevel|null} [continuationLevel] CreateContractCustomerReportRequest continuationLevel
         * @property {string|null} [supportRequest] CreateContractCustomerReportRequest supportRequest
         * @property {string|null} [otherRequest] CreateContractCustomerReportRequest otherRequest
         * @property {string|null} [endScheduledYM] CreateContractCustomerReportRequest endScheduledYM
         */

        /**
         * Constructs a new CreateContractCustomerReportRequest.
         * @memberof api
         * @classdesc Represents a CreateContractCustomerReportRequest.
         * @implements ICreateContractCustomerReportRequest
         * @constructor
         * @param {api.ICreateContractCustomerReportRequest=} [properties] Properties to set
         */
        function CreateContractCustomerReportRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateContractCustomerReportRequest contractID.
         * @member {string} contractID
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.contractID = "";

        /**
         * CreateContractCustomerReportRequest targetYM.
         * @member {string} targetYM
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.targetYM = "";

        /**
         * CreateContractCustomerReportRequest detail.
         * @member {string} detail
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.detail = "";

        /**
         * CreateContractCustomerReportRequest satisfactionLevel.
         * @member {entity.ContractOperationReport.SatisfactionLevel} satisfactionLevel
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.satisfactionLevel = 0;

        /**
         * CreateContractCustomerReportRequest continuationLevel.
         * @member {entity.ContractOperationReport.ContinuationLevel} continuationLevel
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.continuationLevel = 0;

        /**
         * CreateContractCustomerReportRequest supportRequest.
         * @member {string} supportRequest
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.supportRequest = "";

        /**
         * CreateContractCustomerReportRequest otherRequest.
         * @member {string} otherRequest
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.otherRequest = "";

        /**
         * CreateContractCustomerReportRequest endScheduledYM.
         * @member {string} endScheduledYM
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         */
        CreateContractCustomerReportRequest.prototype.endScheduledYM = "";

        /**
         * Creates a new CreateContractCustomerReportRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {api.ICreateContractCustomerReportRequest=} [properties] Properties to set
         * @returns {api.CreateContractCustomerReportRequest} CreateContractCustomerReportRequest instance
         */
        CreateContractCustomerReportRequest.create = function create(properties) {
            return new CreateContractCustomerReportRequest(properties);
        };

        /**
         * Encodes the specified CreateContractCustomerReportRequest message. Does not implicitly {@link api.CreateContractCustomerReportRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {api.ICreateContractCustomerReportRequest} message CreateContractCustomerReportRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractCustomerReportRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.contractID != null && Object.hasOwnProperty.call(message, "contractID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.contractID);
            if (message.targetYM != null && Object.hasOwnProperty.call(message, "targetYM"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.targetYM);
            if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.detail);
            if (message.satisfactionLevel != null && Object.hasOwnProperty.call(message, "satisfactionLevel"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.satisfactionLevel);
            if (message.continuationLevel != null && Object.hasOwnProperty.call(message, "continuationLevel"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.continuationLevel);
            if (message.supportRequest != null && Object.hasOwnProperty.call(message, "supportRequest"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.supportRequest);
            if (message.otherRequest != null && Object.hasOwnProperty.call(message, "otherRequest"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.otherRequest);
            if (message.endScheduledYM != null && Object.hasOwnProperty.call(message, "endScheduledYM"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.endScheduledYM);
            return writer;
        };

        /**
         * Encodes the specified CreateContractCustomerReportRequest message, length delimited. Does not implicitly {@link api.CreateContractCustomerReportRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {api.ICreateContractCustomerReportRequest} message CreateContractCustomerReportRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractCustomerReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateContractCustomerReportRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateContractCustomerReportRequest} CreateContractCustomerReportRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractCustomerReportRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateContractCustomerReportRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.contractID = reader.string();
                    break;
                case 2:
                    message.targetYM = reader.string();
                    break;
                case 3:
                    message.detail = reader.string();
                    break;
                case 4:
                    message.satisfactionLevel = reader.int32();
                    break;
                case 5:
                    message.continuationLevel = reader.int32();
                    break;
                case 6:
                    message.supportRequest = reader.string();
                    break;
                case 7:
                    message.otherRequest = reader.string();
                    break;
                case 8:
                    message.endScheduledYM = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateContractCustomerReportRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateContractCustomerReportRequest} CreateContractCustomerReportRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractCustomerReportRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateContractCustomerReportRequest message.
         * @function verify
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateContractCustomerReportRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                if (!$util.isString(message.contractID))
                    return "contractID: string expected";
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                if (!$util.isString(message.targetYM))
                    return "targetYM: string expected";
            if (message.detail != null && message.hasOwnProperty("detail"))
                if (!$util.isString(message.detail))
                    return "detail: string expected";
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                switch (message.satisfactionLevel) {
                default:
                    return "satisfactionLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                switch (message.continuationLevel) {
                default:
                    return "continuationLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                if (!$util.isString(message.supportRequest))
                    return "supportRequest: string expected";
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                if (!$util.isString(message.otherRequest))
                    return "otherRequest: string expected";
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                if (!$util.isString(message.endScheduledYM))
                    return "endScheduledYM: string expected";
            return null;
        };

        /**
         * Creates a CreateContractCustomerReportRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateContractCustomerReportRequest} CreateContractCustomerReportRequest
         */
        CreateContractCustomerReportRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateContractCustomerReportRequest)
                return object;
            var message = new $root.api.CreateContractCustomerReportRequest();
            if (object.contractID != null)
                message.contractID = String(object.contractID);
            if (object.targetYM != null)
                message.targetYM = String(object.targetYM);
            if (object.detail != null)
                message.detail = String(object.detail);
            switch (object.satisfactionLevel) {
            case "SatisfactionLevel_Unknown":
            case 0:
                message.satisfactionLevel = 0;
                break;
            case "SatisfactionLevel_Good":
            case 1:
                message.satisfactionLevel = 1;
                break;
            case "SatisfactionLevel_Normal":
            case 2:
                message.satisfactionLevel = 2;
                break;
            case "SatisfactionLevel_Bad":
            case 3:
                message.satisfactionLevel = 3;
                break;
            }
            switch (object.continuationLevel) {
            case "ContinuationLevel_Unknown":
            case 0:
                message.continuationLevel = 0;
                break;
            case "ContinuationLevel_Continue":
            case 1:
                message.continuationLevel = 1;
                break;
            case "ContinuationLevel_Consider":
            case 2:
                message.continuationLevel = 2;
                break;
            case "ContinuationLevel_Stop":
            case 3:
                message.continuationLevel = 3;
                break;
            }
            if (object.supportRequest != null)
                message.supportRequest = String(object.supportRequest);
            if (object.otherRequest != null)
                message.otherRequest = String(object.otherRequest);
            if (object.endScheduledYM != null)
                message.endScheduledYM = String(object.endScheduledYM);
            return message;
        };

        /**
         * Creates a plain object from a CreateContractCustomerReportRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateContractCustomerReportRequest
         * @static
         * @param {api.CreateContractCustomerReportRequest} message CreateContractCustomerReportRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateContractCustomerReportRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.contractID = "";
                object.targetYM = "";
                object.detail = "";
                object.satisfactionLevel = options.enums === String ? "SatisfactionLevel_Unknown" : 0;
                object.continuationLevel = options.enums === String ? "ContinuationLevel_Unknown" : 0;
                object.supportRequest = "";
                object.otherRequest = "";
                object.endScheduledYM = "";
            }
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                object.contractID = message.contractID;
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                object.targetYM = message.targetYM;
            if (message.detail != null && message.hasOwnProperty("detail"))
                object.detail = message.detail;
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                object.satisfactionLevel = options.enums === String ? $root.entity.ContractOperationReport.SatisfactionLevel[message.satisfactionLevel] : message.satisfactionLevel;
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                object.continuationLevel = options.enums === String ? $root.entity.ContractOperationReport.ContinuationLevel[message.continuationLevel] : message.continuationLevel;
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                object.supportRequest = message.supportRequest;
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                object.otherRequest = message.otherRequest;
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                object.endScheduledYM = message.endScheduledYM;
            return object;
        };

        /**
         * Converts this CreateContractCustomerReportRequest to JSON.
         * @function toJSON
         * @memberof api.CreateContractCustomerReportRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateContractCustomerReportRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateContractCustomerReportRequest;
    })();

    api.ContractOperationReportService = (function() {

        /**
         * Constructs a new ContractOperationReportService service.
         * @memberof api
         * @classdesc Represents a ContractOperationReportService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractOperationReportService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractOperationReportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractOperationReportService;

        /**
         * Creates new ContractOperationReportService service using the specified rpc implementation.
         * @function create
         * @memberof api.ContractOperationReportService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractOperationReportService} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractOperationReportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ContractOperationReportService#getAllByContract}.
         * @memberof api.ContractOperationReportService
         * @typedef GetAllByContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractOperationReportList} [response] ContractOperationReportList
         */

        /**
         * Calls GetAllByContract.
         * @function getAllByContract
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @param {api.ContractOperationReportService.GetAllByContractCallback} callback Node-style callback called with the error, if any, and ContractOperationReportList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractOperationReportService.prototype.getAllByContract = function getAllByContract(request, callback) {
            return this.rpcCall(getAllByContract, $root.entity.ContractID, $root.entity.ContractOperationReportList, request, callback);
        }, "name", { value: "GetAllByContract" });

        /**
         * Calls GetAllByContract.
         * @function getAllByContract
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @returns {Promise<entity.ContractOperationReportList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractOperationReportService#get}.
         * @memberof api.ContractOperationReportService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractOperationReport} [response] ContractOperationReport
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {entity.IContractOperationReportID} request ContractOperationReportID message or plain object
         * @param {api.ContractOperationReportService.GetCallback} callback Node-style callback called with the error, if any, and ContractOperationReport
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractOperationReportService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.ContractOperationReportID, $root.entity.ContractOperationReport, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {entity.IContractOperationReportID} request ContractOperationReportID message or plain object
         * @returns {Promise<entity.ContractOperationReport>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractOperationReportService#create}.
         * @memberof api.ContractOperationReportService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractOperationReport} [response] ContractOperationReport
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {api.ICreateContractOperationReportRequest} request CreateContractOperationReportRequest message or plain object
         * @param {api.ContractOperationReportService.CreateCallback} callback Node-style callback called with the error, if any, and ContractOperationReport
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractOperationReportService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateContractOperationReportRequest, $root.entity.ContractOperationReport, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractOperationReportService
         * @instance
         * @param {api.ICreateContractOperationReportRequest} request CreateContractOperationReportRequest message or plain object
         * @returns {Promise<entity.ContractOperationReport>} Promise
         * @variation 2
         */

        return ContractOperationReportService;
    })();

    api.CreateContractOperationReportRequest = (function() {

        /**
         * Properties of a CreateContractOperationReportRequest.
         * @memberof api
         * @interface ICreateContractOperationReportRequest
         * @property {string|null} [contractID] CreateContractOperationReportRequest contractID
         * @property {string|null} [targetYM] CreateContractOperationReportRequest targetYM
         * @property {string|null} [detail] CreateContractOperationReportRequest detail
         * @property {entity.ContractOperationReport.SatisfactionLevel|null} [satisfactionLevel] CreateContractOperationReportRequest satisfactionLevel
         * @property {entity.ContractOperationReport.ContinuationLevel|null} [continuationLevel] CreateContractOperationReportRequest continuationLevel
         * @property {string|null} [supportRequest] CreateContractOperationReportRequest supportRequest
         * @property {string|null} [otherRequest] CreateContractOperationReportRequest otherRequest
         * @property {string|null} [endScheduledYM] CreateContractOperationReportRequest endScheduledYM
         */

        /**
         * Constructs a new CreateContractOperationReportRequest.
         * @memberof api
         * @classdesc Represents a CreateContractOperationReportRequest.
         * @implements ICreateContractOperationReportRequest
         * @constructor
         * @param {api.ICreateContractOperationReportRequest=} [properties] Properties to set
         */
        function CreateContractOperationReportRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateContractOperationReportRequest contractID.
         * @member {string} contractID
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.contractID = "";

        /**
         * CreateContractOperationReportRequest targetYM.
         * @member {string} targetYM
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.targetYM = "";

        /**
         * CreateContractOperationReportRequest detail.
         * @member {string} detail
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.detail = "";

        /**
         * CreateContractOperationReportRequest satisfactionLevel.
         * @member {entity.ContractOperationReport.SatisfactionLevel} satisfactionLevel
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.satisfactionLevel = 0;

        /**
         * CreateContractOperationReportRequest continuationLevel.
         * @member {entity.ContractOperationReport.ContinuationLevel} continuationLevel
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.continuationLevel = 0;

        /**
         * CreateContractOperationReportRequest supportRequest.
         * @member {string} supportRequest
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.supportRequest = "";

        /**
         * CreateContractOperationReportRequest otherRequest.
         * @member {string} otherRequest
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.otherRequest = "";

        /**
         * CreateContractOperationReportRequest endScheduledYM.
         * @member {string} endScheduledYM
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         */
        CreateContractOperationReportRequest.prototype.endScheduledYM = "";

        /**
         * Creates a new CreateContractOperationReportRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {api.ICreateContractOperationReportRequest=} [properties] Properties to set
         * @returns {api.CreateContractOperationReportRequest} CreateContractOperationReportRequest instance
         */
        CreateContractOperationReportRequest.create = function create(properties) {
            return new CreateContractOperationReportRequest(properties);
        };

        /**
         * Encodes the specified CreateContractOperationReportRequest message. Does not implicitly {@link api.CreateContractOperationReportRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {api.ICreateContractOperationReportRequest} message CreateContractOperationReportRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractOperationReportRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.contractID != null && Object.hasOwnProperty.call(message, "contractID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.contractID);
            if (message.targetYM != null && Object.hasOwnProperty.call(message, "targetYM"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.targetYM);
            if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.detail);
            if (message.satisfactionLevel != null && Object.hasOwnProperty.call(message, "satisfactionLevel"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.satisfactionLevel);
            if (message.continuationLevel != null && Object.hasOwnProperty.call(message, "continuationLevel"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.continuationLevel);
            if (message.supportRequest != null && Object.hasOwnProperty.call(message, "supportRequest"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.supportRequest);
            if (message.otherRequest != null && Object.hasOwnProperty.call(message, "otherRequest"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.otherRequest);
            if (message.endScheduledYM != null && Object.hasOwnProperty.call(message, "endScheduledYM"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.endScheduledYM);
            return writer;
        };

        /**
         * Encodes the specified CreateContractOperationReportRequest message, length delimited. Does not implicitly {@link api.CreateContractOperationReportRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {api.ICreateContractOperationReportRequest} message CreateContractOperationReportRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContractOperationReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateContractOperationReportRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateContractOperationReportRequest} CreateContractOperationReportRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractOperationReportRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateContractOperationReportRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.contractID = reader.string();
                    break;
                case 2:
                    message.targetYM = reader.string();
                    break;
                case 3:
                    message.detail = reader.string();
                    break;
                case 4:
                    message.satisfactionLevel = reader.int32();
                    break;
                case 5:
                    message.continuationLevel = reader.int32();
                    break;
                case 6:
                    message.supportRequest = reader.string();
                    break;
                case 7:
                    message.otherRequest = reader.string();
                    break;
                case 8:
                    message.endScheduledYM = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateContractOperationReportRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateContractOperationReportRequest} CreateContractOperationReportRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContractOperationReportRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateContractOperationReportRequest message.
         * @function verify
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateContractOperationReportRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                if (!$util.isString(message.contractID))
                    return "contractID: string expected";
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                if (!$util.isString(message.targetYM))
                    return "targetYM: string expected";
            if (message.detail != null && message.hasOwnProperty("detail"))
                if (!$util.isString(message.detail))
                    return "detail: string expected";
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                switch (message.satisfactionLevel) {
                default:
                    return "satisfactionLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                switch (message.continuationLevel) {
                default:
                    return "continuationLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                if (!$util.isString(message.supportRequest))
                    return "supportRequest: string expected";
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                if (!$util.isString(message.otherRequest))
                    return "otherRequest: string expected";
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                if (!$util.isString(message.endScheduledYM))
                    return "endScheduledYM: string expected";
            return null;
        };

        /**
         * Creates a CreateContractOperationReportRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateContractOperationReportRequest} CreateContractOperationReportRequest
         */
        CreateContractOperationReportRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateContractOperationReportRequest)
                return object;
            var message = new $root.api.CreateContractOperationReportRequest();
            if (object.contractID != null)
                message.contractID = String(object.contractID);
            if (object.targetYM != null)
                message.targetYM = String(object.targetYM);
            if (object.detail != null)
                message.detail = String(object.detail);
            switch (object.satisfactionLevel) {
            case "SatisfactionLevel_Unknown":
            case 0:
                message.satisfactionLevel = 0;
                break;
            case "SatisfactionLevel_Good":
            case 1:
                message.satisfactionLevel = 1;
                break;
            case "SatisfactionLevel_Normal":
            case 2:
                message.satisfactionLevel = 2;
                break;
            case "SatisfactionLevel_Bad":
            case 3:
                message.satisfactionLevel = 3;
                break;
            }
            switch (object.continuationLevel) {
            case "ContinuationLevel_Unknown":
            case 0:
                message.continuationLevel = 0;
                break;
            case "ContinuationLevel_Continue":
            case 1:
                message.continuationLevel = 1;
                break;
            case "ContinuationLevel_Consider":
            case 2:
                message.continuationLevel = 2;
                break;
            case "ContinuationLevel_Stop":
            case 3:
                message.continuationLevel = 3;
                break;
            }
            if (object.supportRequest != null)
                message.supportRequest = String(object.supportRequest);
            if (object.otherRequest != null)
                message.otherRequest = String(object.otherRequest);
            if (object.endScheduledYM != null)
                message.endScheduledYM = String(object.endScheduledYM);
            return message;
        };

        /**
         * Creates a plain object from a CreateContractOperationReportRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateContractOperationReportRequest
         * @static
         * @param {api.CreateContractOperationReportRequest} message CreateContractOperationReportRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateContractOperationReportRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.contractID = "";
                object.targetYM = "";
                object.detail = "";
                object.satisfactionLevel = options.enums === String ? "SatisfactionLevel_Unknown" : 0;
                object.continuationLevel = options.enums === String ? "ContinuationLevel_Unknown" : 0;
                object.supportRequest = "";
                object.otherRequest = "";
                object.endScheduledYM = "";
            }
            if (message.contractID != null && message.hasOwnProperty("contractID"))
                object.contractID = message.contractID;
            if (message.targetYM != null && message.hasOwnProperty("targetYM"))
                object.targetYM = message.targetYM;
            if (message.detail != null && message.hasOwnProperty("detail"))
                object.detail = message.detail;
            if (message.satisfactionLevel != null && message.hasOwnProperty("satisfactionLevel"))
                object.satisfactionLevel = options.enums === String ? $root.entity.ContractOperationReport.SatisfactionLevel[message.satisfactionLevel] : message.satisfactionLevel;
            if (message.continuationLevel != null && message.hasOwnProperty("continuationLevel"))
                object.continuationLevel = options.enums === String ? $root.entity.ContractOperationReport.ContinuationLevel[message.continuationLevel] : message.continuationLevel;
            if (message.supportRequest != null && message.hasOwnProperty("supportRequest"))
                object.supportRequest = message.supportRequest;
            if (message.otherRequest != null && message.hasOwnProperty("otherRequest"))
                object.otherRequest = message.otherRequest;
            if (message.endScheduledYM != null && message.hasOwnProperty("endScheduledYM"))
                object.endScheduledYM = message.endScheduledYM;
            return object;
        };

        /**
         * Converts this CreateContractOperationReportRequest to JSON.
         * @function toJSON
         * @memberof api.CreateContractOperationReportRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateContractOperationReportRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateContractOperationReportRequest;
    })();

    api.ContractService = (function() {

        /**
         * Constructs a new ContractService service.
         * @memberof api
         * @classdesc Represents a ContractService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ContractService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ContractService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ContractService;

        /**
         * Creates new ContractService service using the specified rpc implementation.
         * @function create
         * @memberof api.ContractService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ContractService} RPC service. Useful where requests and/or responses are streamed.
         */
        ContractService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ContractService#getAll}.
         * @memberof api.ContractService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractList} [response] ContractList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ContractService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ContractService.GetAllCallback} callback Node-style callback called with the error, if any, and ContractList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.ContractList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ContractService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ContractList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#getAllOperation}.
         * @memberof api.ContractService
         * @typedef GetAllOperationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractList} [response] ContractList
         */

        /**
         * Calls GetAllOperation.
         * @function getAllOperation
         * @memberof api.ContractService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ContractService.GetAllOperationCallback} callback Node-style callback called with the error, if any, and ContractList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.getAllOperation = function getAllOperation(request, callback) {
            return this.rpcCall(getAllOperation, $root.common.Pager, $root.entity.ContractList, request, callback);
        }, "name", { value: "GetAllOperation" });

        /**
         * Calls GetAllOperation.
         * @function getAllOperation
         * @memberof api.ContractService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ContractList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#getMulti}.
         * @memberof api.ContractService
         * @typedef GetMultiCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ContractList} [response] ContractList
         */

        /**
         * Calls GetMulti.
         * @function getMulti
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractIDList} request PartialContractIDList message or plain object
         * @param {api.ContractService.GetMultiCallback} callback Node-style callback called with the error, if any, and ContractList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.getMulti = function getMulti(request, callback) {
            return this.rpcCall(getMulti, $root.api.PartialContractIDList, $root.entity.ContractList, request, callback);
        }, "name", { value: "GetMulti" });

        /**
         * Calls GetMulti.
         * @function getMulti
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractIDList} request PartialContractIDList message or plain object
         * @returns {Promise<entity.ContractList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#get}.
         * @memberof api.ContractService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Contract} [response] Contract
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @param {api.ContractService.GetCallback} callback Node-style callback called with the error, if any, and Contract
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.api.PartialContractID, $root.entity.Contract, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @returns {Promise<entity.Contract>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#getOperation}.
         * @memberof api.ContractService
         * @typedef GetOperationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Contract} [response] Contract
         */

        /**
         * Calls GetOperation.
         * @function getOperation
         * @memberof api.ContractService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @param {api.ContractService.GetOperationCallback} callback Node-style callback called with the error, if any, and Contract
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.getOperation = function getOperation(request, callback) {
            return this.rpcCall(getOperation, $root.entity.ContractID, $root.entity.Contract, request, callback);
        }, "name", { value: "GetOperation" });

        /**
         * Calls GetOperation.
         * @function getOperation
         * @memberof api.ContractService
         * @instance
         * @param {entity.IContractID} request ContractID message or plain object
         * @returns {Promise<entity.Contract>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#getCount}.
         * @memberof api.ContractService
         * @typedef GetCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ContractService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ContractService.GetCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.getCount = function getCount(request, callback) {
            return this.rpcCall(getCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCount" });

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ContractService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#create}.
         * @memberof api.ContractService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Contract} [response] Contract
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractService
         * @instance
         * @param {api.ISaveContractRequest} request SaveContractRequest message or plain object
         * @param {api.ContractService.CreateCallback} callback Node-style callback called with the error, if any, and Contract
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.SaveContractRequest, $root.entity.Contract, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ContractService
         * @instance
         * @param {api.ISaveContractRequest} request SaveContractRequest message or plain object
         * @returns {Promise<entity.Contract>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#update}.
         * @memberof api.ContractService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Contract} [response] Contract
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.ContractService
         * @instance
         * @param {api.ISaveContractRequest} request SaveContractRequest message or plain object
         * @param {api.ContractService.UpdateCallback} callback Node-style callback called with the error, if any, and Contract
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.SaveContractRequest, $root.entity.Contract, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.ContractService
         * @instance
         * @param {api.ISaveContractRequest} request SaveContractRequest message or plain object
         * @returns {Promise<entity.Contract>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#approve}.
         * @memberof api.ContractService
         * @typedef ApproveCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Approve.
         * @function approve
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @param {api.ContractService.ApproveCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype.approve = function approve(request, callback) {
            return this.rpcCall(approve, $root.api.PartialContractID, $root.common.Empty, request, callback);
        }, "name", { value: "Approve" });

        /**
         * Calls Approve.
         * @function approve
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ContractService#delete_}.
         * @memberof api.ContractService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @param {api.ContractService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ContractService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.api.PartialContractID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ContractService
         * @instance
         * @param {api.IPartialContractID} request PartialContractID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ContractService;
    })();

    api.SaveContractRequest = (function() {

        /**
         * Properties of a SaveContractRequest.
         * @memberof api
         * @interface ISaveContractRequest
         * @property {string|null} [projectID] SaveContractRequest projectID
         * @property {string|null} [customerID] SaveContractRequest customerID
         * @property {string|null} [fileURL] SaveContractRequest fileURL
         * @property {string|null} [title] SaveContractRequest title
         * @property {string|null} [description] SaveContractRequest description
         * @property {number|null} [meetingNum] SaveContractRequest meetingNum
         * @property {entity.Contract.Interval|null} [meetingInterval] SaveContractRequest meetingInterval
         * @property {number|null} [meetingMinutes] SaveContractRequest meetingMinutes
         * @property {number|null} [workingHour] SaveContractRequest workingHour
         * @property {entity.Contract.Interval|null} [workingInterval] SaveContractRequest workingInterval
         * @property {number|null} [feePerMonth] SaveContractRequest feePerMonth
         * @property {entity.Contract.Type|null} [contractType] SaveContractRequest contractType
         * @property {string|null} [startFromYM] SaveContractRequest startFromYM
         * @property {string|null} [endToYM] SaveContractRequest endToYM
         */

        /**
         * Constructs a new SaveContractRequest.
         * @memberof api
         * @classdesc Represents a SaveContractRequest.
         * @implements ISaveContractRequest
         * @constructor
         * @param {api.ISaveContractRequest=} [properties] Properties to set
         */
        function SaveContractRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SaveContractRequest projectID.
         * @member {string} projectID
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.projectID = "";

        /**
         * SaveContractRequest customerID.
         * @member {string} customerID
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.customerID = "";

        /**
         * SaveContractRequest fileURL.
         * @member {string} fileURL
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.fileURL = "";

        /**
         * SaveContractRequest title.
         * @member {string} title
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.title = "";

        /**
         * SaveContractRequest description.
         * @member {string} description
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.description = "";

        /**
         * SaveContractRequest meetingNum.
         * @member {number} meetingNum
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.meetingNum = 0;

        /**
         * SaveContractRequest meetingInterval.
         * @member {entity.Contract.Interval} meetingInterval
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.meetingInterval = 0;

        /**
         * SaveContractRequest meetingMinutes.
         * @member {number} meetingMinutes
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.meetingMinutes = 0;

        /**
         * SaveContractRequest workingHour.
         * @member {number} workingHour
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.workingHour = 0;

        /**
         * SaveContractRequest workingInterval.
         * @member {entity.Contract.Interval} workingInterval
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.workingInterval = 0;

        /**
         * SaveContractRequest feePerMonth.
         * @member {number} feePerMonth
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.feePerMonth = 0;

        /**
         * SaveContractRequest contractType.
         * @member {entity.Contract.Type} contractType
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.contractType = 0;

        /**
         * SaveContractRequest startFromYM.
         * @member {string} startFromYM
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.startFromYM = "";

        /**
         * SaveContractRequest endToYM.
         * @member {string} endToYM
         * @memberof api.SaveContractRequest
         * @instance
         */
        SaveContractRequest.prototype.endToYM = "";

        /**
         * Creates a new SaveContractRequest instance using the specified properties.
         * @function create
         * @memberof api.SaveContractRequest
         * @static
         * @param {api.ISaveContractRequest=} [properties] Properties to set
         * @returns {api.SaveContractRequest} SaveContractRequest instance
         */
        SaveContractRequest.create = function create(properties) {
            return new SaveContractRequest(properties);
        };

        /**
         * Encodes the specified SaveContractRequest message. Does not implicitly {@link api.SaveContractRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SaveContractRequest
         * @static
         * @param {api.ISaveContractRequest} message SaveContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveContractRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.fileURL != null && Object.hasOwnProperty.call(message, "fileURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileURL);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
            if (message.meetingNum != null && Object.hasOwnProperty.call(message, "meetingNum"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.meetingNum);
            if (message.meetingInterval != null && Object.hasOwnProperty.call(message, "meetingInterval"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.meetingInterval);
            if (message.meetingMinutes != null && Object.hasOwnProperty.call(message, "meetingMinutes"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.meetingMinutes);
            if (message.workingHour != null && Object.hasOwnProperty.call(message, "workingHour"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workingHour);
            if (message.workingInterval != null && Object.hasOwnProperty.call(message, "workingInterval"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workingInterval);
            if (message.feePerMonth != null && Object.hasOwnProperty.call(message, "feePerMonth"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.feePerMonth);
            if (message.contractType != null && Object.hasOwnProperty.call(message, "contractType"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.contractType);
            if (message.startFromYM != null && Object.hasOwnProperty.call(message, "startFromYM"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.startFromYM);
            if (message.endToYM != null && Object.hasOwnProperty.call(message, "endToYM"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.endToYM);
            return writer;
        };

        /**
         * Encodes the specified SaveContractRequest message, length delimited. Does not implicitly {@link api.SaveContractRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SaveContractRequest
         * @static
         * @param {api.ISaveContractRequest} message SaveContractRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveContractRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SaveContractRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SaveContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SaveContractRequest} SaveContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveContractRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SaveContractRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.fileURL = reader.string();
                    break;
                case 4:
                    message.title = reader.string();
                    break;
                case 5:
                    message.description = reader.string();
                    break;
                case 6:
                    message.meetingNum = reader.int32();
                    break;
                case 7:
                    message.meetingInterval = reader.int32();
                    break;
                case 8:
                    message.meetingMinutes = reader.int32();
                    break;
                case 9:
                    message.workingHour = reader.int32();
                    break;
                case 10:
                    message.workingInterval = reader.int32();
                    break;
                case 11:
                    message.feePerMonth = reader.int32();
                    break;
                case 12:
                    message.contractType = reader.int32();
                    break;
                case 13:
                    message.startFromYM = reader.string();
                    break;
                case 14:
                    message.endToYM = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SaveContractRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SaveContractRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SaveContractRequest} SaveContractRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveContractRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SaveContractRequest message.
         * @function verify
         * @memberof api.SaveContractRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SaveContractRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.fileURL != null && message.hasOwnProperty("fileURL"))
                if (!$util.isString(message.fileURL))
                    return "fileURL: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                if (!$util.isInteger(message.meetingNum))
                    return "meetingNum: integer expected";
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                switch (message.meetingInterval) {
                default:
                    return "meetingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                if (!$util.isInteger(message.meetingMinutes))
                    return "meetingMinutes: integer expected";
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                if (!$util.isInteger(message.workingHour))
                    return "workingHour: integer expected";
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                switch (message.workingInterval) {
                default:
                    return "workingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                if (!$util.isInteger(message.feePerMonth))
                    return "feePerMonth: integer expected";
            if (message.contractType != null && message.hasOwnProperty("contractType"))
                switch (message.contractType) {
                default:
                    return "contractType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.startFromYM != null && message.hasOwnProperty("startFromYM"))
                if (!$util.isString(message.startFromYM))
                    return "startFromYM: string expected";
            if (message.endToYM != null && message.hasOwnProperty("endToYM"))
                if (!$util.isString(message.endToYM))
                    return "endToYM: string expected";
            return null;
        };

        /**
         * Creates a SaveContractRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SaveContractRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SaveContractRequest} SaveContractRequest
         */
        SaveContractRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SaveContractRequest)
                return object;
            var message = new $root.api.SaveContractRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.fileURL != null)
                message.fileURL = String(object.fileURL);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.meetingNum != null)
                message.meetingNum = object.meetingNum | 0;
            switch (object.meetingInterval) {
            case "Interval_Unknown":
            case 0:
                message.meetingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.meetingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.meetingInterval = 2;
                break;
            }
            if (object.meetingMinutes != null)
                message.meetingMinutes = object.meetingMinutes | 0;
            if (object.workingHour != null)
                message.workingHour = object.workingHour | 0;
            switch (object.workingInterval) {
            case "Interval_Unknown":
            case 0:
                message.workingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.workingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.workingInterval = 2;
                break;
            }
            if (object.feePerMonth != null)
                message.feePerMonth = object.feePerMonth | 0;
            switch (object.contractType) {
            case "Type_Unknown":
            case 0:
                message.contractType = 0;
                break;
            case "Type_Delegation":
            case 1:
                message.contractType = 1;
                break;
            case "Type_Contract":
            case 2:
                message.contractType = 2;
                break;
            case "Type_Other":
            case 3:
                message.contractType = 3;
                break;
            }
            if (object.startFromYM != null)
                message.startFromYM = String(object.startFromYM);
            if (object.endToYM != null)
                message.endToYM = String(object.endToYM);
            return message;
        };

        /**
         * Creates a plain object from a SaveContractRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SaveContractRequest
         * @static
         * @param {api.SaveContractRequest} message SaveContractRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SaveContractRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.customerID = "";
                object.fileURL = "";
                object.title = "";
                object.description = "";
                object.meetingNum = 0;
                object.meetingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.meetingMinutes = 0;
                object.workingHour = 0;
                object.workingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.feePerMonth = 0;
                object.contractType = options.enums === String ? "Type_Unknown" : 0;
                object.startFromYM = "";
                object.endToYM = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.fileURL != null && message.hasOwnProperty("fileURL"))
                object.fileURL = message.fileURL;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                object.meetingNum = message.meetingNum;
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                object.meetingInterval = options.enums === String ? $root.entity.Contract.Interval[message.meetingInterval] : message.meetingInterval;
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                object.meetingMinutes = message.meetingMinutes;
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                object.workingHour = message.workingHour;
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                object.workingInterval = options.enums === String ? $root.entity.Contract.Interval[message.workingInterval] : message.workingInterval;
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                object.feePerMonth = message.feePerMonth;
            if (message.contractType != null && message.hasOwnProperty("contractType"))
                object.contractType = options.enums === String ? $root.entity.Contract.Type[message.contractType] : message.contractType;
            if (message.startFromYM != null && message.hasOwnProperty("startFromYM"))
                object.startFromYM = message.startFromYM;
            if (message.endToYM != null && message.hasOwnProperty("endToYM"))
                object.endToYM = message.endToYM;
            return object;
        };

        /**
         * Converts this SaveContractRequest to JSON.
         * @function toJSON
         * @memberof api.SaveContractRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SaveContractRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SaveContractRequest;
    })();

    api.PartialContractID = (function() {

        /**
         * Properties of a PartialContractID.
         * @memberof api
         * @interface IPartialContractID
         * @property {string|null} [projectID] PartialContractID projectID
         * @property {string|null} [customerID] PartialContractID customerID
         */

        /**
         * Constructs a new PartialContractID.
         * @memberof api
         * @classdesc Represents a PartialContractID.
         * @implements IPartialContractID
         * @constructor
         * @param {api.IPartialContractID=} [properties] Properties to set
         */
        function PartialContractID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartialContractID projectID.
         * @member {string} projectID
         * @memberof api.PartialContractID
         * @instance
         */
        PartialContractID.prototype.projectID = "";

        /**
         * PartialContractID customerID.
         * @member {string} customerID
         * @memberof api.PartialContractID
         * @instance
         */
        PartialContractID.prototype.customerID = "";

        /**
         * Creates a new PartialContractID instance using the specified properties.
         * @function create
         * @memberof api.PartialContractID
         * @static
         * @param {api.IPartialContractID=} [properties] Properties to set
         * @returns {api.PartialContractID} PartialContractID instance
         */
        PartialContractID.create = function create(properties) {
            return new PartialContractID(properties);
        };

        /**
         * Encodes the specified PartialContractID message. Does not implicitly {@link api.PartialContractID.verify|verify} messages.
         * @function encode
         * @memberof api.PartialContractID
         * @static
         * @param {api.IPartialContractID} message PartialContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartialContractID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerID);
            return writer;
        };

        /**
         * Encodes the specified PartialContractID message, length delimited. Does not implicitly {@link api.PartialContractID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.PartialContractID
         * @static
         * @param {api.IPartialContractID} message PartialContractID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartialContractID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartialContractID message from the specified reader or buffer.
         * @function decode
         * @memberof api.PartialContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.PartialContractID} PartialContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartialContractID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.PartialContractID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.customerID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartialContractID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.PartialContractID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.PartialContractID} PartialContractID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartialContractID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartialContractID message.
         * @function verify
         * @memberof api.PartialContractID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartialContractID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            return null;
        };

        /**
         * Creates a PartialContractID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.PartialContractID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.PartialContractID} PartialContractID
         */
        PartialContractID.fromObject = function fromObject(object) {
            if (object instanceof $root.api.PartialContractID)
                return object;
            var message = new $root.api.PartialContractID();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            return message;
        };

        /**
         * Creates a plain object from a PartialContractID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.PartialContractID
         * @static
         * @param {api.PartialContractID} message PartialContractID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartialContractID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.customerID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            return object;
        };

        /**
         * Converts this PartialContractID to JSON.
         * @function toJSON
         * @memberof api.PartialContractID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartialContractID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartialContractID;
    })();

    api.PartialContractIDList = (function() {

        /**
         * Properties of a PartialContractIDList.
         * @memberof api
         * @interface IPartialContractIDList
         * @property {Array.<api.IPartialContractID>|null} [ids] PartialContractIDList ids
         */

        /**
         * Constructs a new PartialContractIDList.
         * @memberof api
         * @classdesc Represents a PartialContractIDList.
         * @implements IPartialContractIDList
         * @constructor
         * @param {api.IPartialContractIDList=} [properties] Properties to set
         */
        function PartialContractIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PartialContractIDList ids.
         * @member {Array.<api.IPartialContractID>} ids
         * @memberof api.PartialContractIDList
         * @instance
         */
        PartialContractIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new PartialContractIDList instance using the specified properties.
         * @function create
         * @memberof api.PartialContractIDList
         * @static
         * @param {api.IPartialContractIDList=} [properties] Properties to set
         * @returns {api.PartialContractIDList} PartialContractIDList instance
         */
        PartialContractIDList.create = function create(properties) {
            return new PartialContractIDList(properties);
        };

        /**
         * Encodes the specified PartialContractIDList message. Does not implicitly {@link api.PartialContractIDList.verify|verify} messages.
         * @function encode
         * @memberof api.PartialContractIDList
         * @static
         * @param {api.IPartialContractIDList} message PartialContractIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartialContractIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    $root.api.PartialContractID.encode(message.ids[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PartialContractIDList message, length delimited. Does not implicitly {@link api.PartialContractIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.PartialContractIDList
         * @static
         * @param {api.IPartialContractIDList} message PartialContractIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartialContractIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartialContractIDList message from the specified reader or buffer.
         * @function decode
         * @memberof api.PartialContractIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.PartialContractIDList} PartialContractIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartialContractIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.PartialContractIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push($root.api.PartialContractID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PartialContractIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.PartialContractIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.PartialContractIDList} PartialContractIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartialContractIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PartialContractIDList message.
         * @function verify
         * @memberof api.PartialContractIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PartialContractIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i) {
                    var error = $root.api.PartialContractID.verify(message.ids[i]);
                    if (error)
                        return "ids." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PartialContractIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.PartialContractIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.PartialContractIDList} PartialContractIDList
         */
        PartialContractIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.api.PartialContractIDList)
                return object;
            var message = new $root.api.PartialContractIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".api.PartialContractIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i) {
                    if (typeof object.ids[i] !== "object")
                        throw TypeError(".api.PartialContractIDList.ids: object expected");
                    message.ids[i] = $root.api.PartialContractID.fromObject(object.ids[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a PartialContractIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.PartialContractIDList
         * @static
         * @param {api.PartialContractIDList} message PartialContractIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PartialContractIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = $root.api.PartialContractID.toObject(message.ids[j], options);
            }
            return object;
        };

        /**
         * Converts this PartialContractIDList to JSON.
         * @function toJSON
         * @memberof api.PartialContractIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PartialContractIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PartialContractIDList;
    })();

    api.CustomerBlackListService = (function() {

        /**
         * Constructs a new CustomerBlackListService service.
         * @memberof api
         * @classdesc Represents a CustomerBlackListService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CustomerBlackListService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CustomerBlackListService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CustomerBlackListService;

        /**
         * Creates new CustomerBlackListService service using the specified rpc implementation.
         * @function create
         * @memberof api.CustomerBlackListService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CustomerBlackListService} RPC service. Useful where requests and/or responses are streamed.
         */
        CustomerBlackListService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.CustomerBlackListService#get}.
         * @memberof api.CustomerBlackListService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.CustomerBlackList} [response] CustomerBlackList
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.CustomerBlackListService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.CustomerBlackListService.GetCallback} callback Node-style callback called with the error, if any, and CustomerBlackList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerBlackListService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.CustomerID, $root.entity.CustomerBlackList, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.CustomerBlackListService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.CustomerBlackList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerBlackListService#update}.
         * @memberof api.CustomerBlackListService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.CustomerBlackListService
         * @instance
         * @param {api.IUpdateCustomerBlackListRequest} request UpdateCustomerBlackListRequest message or plain object
         * @param {api.CustomerBlackListService.UpdateCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerBlackListService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateCustomerBlackListRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.CustomerBlackListService
         * @instance
         * @param {api.IUpdateCustomerBlackListRequest} request UpdateCustomerBlackListRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return CustomerBlackListService;
    })();

    api.UpdateCustomerBlackListRequest = (function() {

        /**
         * Properties of an UpdateCustomerBlackListRequest.
         * @memberof api
         * @interface IUpdateCustomerBlackListRequest
         * @property {Array.<string>|null} [domains] UpdateCustomerBlackListRequest domains
         */

        /**
         * Constructs a new UpdateCustomerBlackListRequest.
         * @memberof api
         * @classdesc Represents an UpdateCustomerBlackListRequest.
         * @implements IUpdateCustomerBlackListRequest
         * @constructor
         * @param {api.IUpdateCustomerBlackListRequest=} [properties] Properties to set
         */
        function UpdateCustomerBlackListRequest(properties) {
            this.domains = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateCustomerBlackListRequest domains.
         * @member {Array.<string>} domains
         * @memberof api.UpdateCustomerBlackListRequest
         * @instance
         */
        UpdateCustomerBlackListRequest.prototype.domains = $util.emptyArray;

        /**
         * Creates a new UpdateCustomerBlackListRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {api.IUpdateCustomerBlackListRequest=} [properties] Properties to set
         * @returns {api.UpdateCustomerBlackListRequest} UpdateCustomerBlackListRequest instance
         */
        UpdateCustomerBlackListRequest.create = function create(properties) {
            return new UpdateCustomerBlackListRequest(properties);
        };

        /**
         * Encodes the specified UpdateCustomerBlackListRequest message. Does not implicitly {@link api.UpdateCustomerBlackListRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {api.IUpdateCustomerBlackListRequest} message UpdateCustomerBlackListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerBlackListRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.domains != null && message.domains.length)
                for (var i = 0; i < message.domains.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.domains[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdateCustomerBlackListRequest message, length delimited. Does not implicitly {@link api.UpdateCustomerBlackListRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {api.IUpdateCustomerBlackListRequest} message UpdateCustomerBlackListRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerBlackListRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateCustomerBlackListRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateCustomerBlackListRequest} UpdateCustomerBlackListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerBlackListRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateCustomerBlackListRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.domains && message.domains.length))
                        message.domains = [];
                    message.domains.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateCustomerBlackListRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateCustomerBlackListRequest} UpdateCustomerBlackListRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerBlackListRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateCustomerBlackListRequest message.
         * @function verify
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateCustomerBlackListRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.domains != null && message.hasOwnProperty("domains")) {
                if (!Array.isArray(message.domains))
                    return "domains: array expected";
                for (var i = 0; i < message.domains.length; ++i)
                    if (!$util.isString(message.domains[i]))
                        return "domains: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdateCustomerBlackListRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateCustomerBlackListRequest} UpdateCustomerBlackListRequest
         */
        UpdateCustomerBlackListRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateCustomerBlackListRequest)
                return object;
            var message = new $root.api.UpdateCustomerBlackListRequest();
            if (object.domains) {
                if (!Array.isArray(object.domains))
                    throw TypeError(".api.UpdateCustomerBlackListRequest.domains: array expected");
                message.domains = [];
                for (var i = 0; i < object.domains.length; ++i)
                    message.domains[i] = String(object.domains[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateCustomerBlackListRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateCustomerBlackListRequest
         * @static
         * @param {api.UpdateCustomerBlackListRequest} message UpdateCustomerBlackListRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCustomerBlackListRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.domains = [];
            if (message.domains && message.domains.length) {
                object.domains = [];
                for (var j = 0; j < message.domains.length; ++j)
                    object.domains[j] = message.domains[j];
            }
            return object;
        };

        /**
         * Converts this UpdateCustomerBlackListRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateCustomerBlackListRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCustomerBlackListRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCustomerBlackListRequest;
    })();

    api.CustomerService = (function() {

        /**
         * Constructs a new CustomerService service.
         * @memberof api
         * @classdesc Represents a CustomerService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function CustomerService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (CustomerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CustomerService;

        /**
         * Creates new CustomerService service using the specified rpc implementation.
         * @function create
         * @memberof api.CustomerService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {CustomerService} RPC service. Useful where requests and/or responses are streamed.
         */
        CustomerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.CustomerService#getAll}.
         * @memberof api.CustomerService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.CustomerService.GetAllCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Empty, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getAllByIDs}.
         * @memberof api.CustomerService
         * @typedef GetAllByIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @param {api.CustomerService.GetAllByIDsCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getAllByIDs = function getAllByIDs(request, callback) {
            return this.rpcCall(getAllByIDs, $root.entity.CustomerIDList, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetAllByIDs" });

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getAllBySearch}.
         * @memberof api.CustomerService
         * @typedef GetAllBySearchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetAllBySearch.
         * @function getAllBySearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.ISearchCustomerRequest} request SearchCustomerRequest message or plain object
         * @param {api.CustomerService.GetAllBySearchCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getAllBySearch = function getAllBySearch(request, callback) {
            return this.rpcCall(getAllBySearch, $root.api.SearchCustomerRequest, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetAllBySearch" });

        /**
         * Calls GetAllBySearch.
         * @function getAllBySearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.ISearchCustomerRequest} request SearchCustomerRequest message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getRecommendByMatch}.
         * @memberof api.CustomerService
         * @typedef GetRecommendByMatchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetRecommendByMatch.
         * @function getRecommendByMatch
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.CustomerService.GetRecommendByMatchCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getRecommendByMatch = function getRecommendByMatch(request, callback) {
            return this.rpcCall(getRecommendByMatch, $root.entity.CustomerID, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetRecommendByMatch" });

        /**
         * Calls GetRecommendByMatch.
         * @function getRecommendByMatch
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getRecommendByTrend}.
         * @memberof api.CustomerService
         * @typedef GetRecommendByTrendCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetRecommendByTrend.
         * @function getRecommendByTrend
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.CustomerService.GetRecommendByTrendCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getRecommendByTrend = function getRecommendByTrend(request, callback) {
            return this.rpcCall(getRecommendByTrend, $root.entity.CustomerID, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetRecommendByTrend" });

        /**
         * Calls GetRecommendByTrend.
         * @function getRecommendByTrend
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#get}.
         * @memberof api.CustomerService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomer} [response] SafeCustomer
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.CustomerService.GetCallback} callback Node-style callback called with the error, if any, and SafeCustomer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.CustomerID, $root.entity.SafeCustomer, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getForScout}.
         * @memberof api.CustomerService
         * @typedef GetForScoutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomer} [response] SafeCustomer
         */

        /**
         * Calls GetForScout.
         * @function getForScout
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.CustomerService.GetForScoutCallback} callback Node-style callback called with the error, if any, and SafeCustomer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getForScout = function getForScout(request, callback) {
            return this.rpcCall(getForScout, $root.entity.CustomerID, $root.entity.SafeCustomer, request, callback);
        }, "name", { value: "GetForScout" });

        /**
         * Calls GetForScout.
         * @function getForScout
         * @memberof api.CustomerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getCountBySearch}.
         * @memberof api.CustomerService
         * @typedef GetCountBySearchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountBySearch.
         * @function getCountBySearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.ISearchCustomerCountRequest} request SearchCustomerCountRequest message or plain object
         * @param {api.CustomerService.GetCountBySearchCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getCountBySearch = function getCountBySearch(request, callback) {
            return this.rpcCall(getCountBySearch, $root.api.SearchCustomerCountRequest, $root.common.Count, request, callback);
        }, "name", { value: "GetCountBySearch" });

        /**
         * Calls GetCountBySearch.
         * @function getCountBySearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.ISearchCustomerCountRequest} request SearchCustomerCountRequest message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#getCountByOccupation}.
         * @memberof api.CustomerService
         * @typedef GetCountByOccupationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountByOccupation.
         * @function getCountByOccupation
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICustomerCountByOccupationRequest} request CustomerCountByOccupationRequest message or plain object
         * @param {api.CustomerService.GetCountByOccupationCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.getCountByOccupation = function getCountByOccupation(request, callback) {
            return this.rpcCall(getCountByOccupation, $root.api.CustomerCountByOccupationRequest, $root.common.Count, request, callback);
        }, "name", { value: "GetCountByOccupation" });

        /**
         * Calls GetCountByOccupation.
         * @function getCountByOccupation
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICustomerCountByOccupationRequest} request CustomerCountByOccupationRequest message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#create}.
         * @memberof api.CustomerService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Customer} [response] Customer
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateCustomerRequest} request CreateCustomerRequest message or plain object
         * @param {api.CustomerService.CreateCallback} callback Node-style callback called with the error, if any, and Customer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateCustomerRequest, $root.entity.Customer, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateCustomerRequest} request CreateCustomerRequest message or plain object
         * @returns {Promise<entity.Customer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#createSuperEngineer}.
         * @memberof api.CustomerService
         * @typedef CreateSuperEngineerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Customer} [response] Customer
         */

        /**
         * Calls CreateSuperEngineer.
         * @function createSuperEngineer
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateSuperEngineerRequest} request CreateSuperEngineerRequest message or plain object
         * @param {api.CustomerService.CreateSuperEngineerCallback} callback Node-style callback called with the error, if any, and Customer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.createSuperEngineer = function createSuperEngineer(request, callback) {
            return this.rpcCall(createSuperEngineer, $root.api.CreateSuperEngineerRequest, $root.entity.Customer, request, callback);
        }, "name", { value: "CreateSuperEngineer" });

        /**
         * Calls CreateSuperEngineer.
         * @function createSuperEngineer
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateSuperEngineerRequest} request CreateSuperEngineerRequest message or plain object
         * @returns {Promise<entity.Customer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#createPro}.
         * @memberof api.CustomerService
         * @typedef CreateProCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Customer} [response] Customer
         */

        /**
         * Calls CreatePro.
         * @function createPro
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateProRequest} request CreateProRequest message or plain object
         * @param {api.CustomerService.CreateProCallback} callback Node-style callback called with the error, if any, and Customer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.createPro = function createPro(request, callback) {
            return this.rpcCall(createPro, $root.api.CreateProRequest, $root.entity.Customer, request, callback);
        }, "name", { value: "CreatePro" });

        /**
         * Calls CreatePro.
         * @function createPro
         * @memberof api.CustomerService
         * @instance
         * @param {api.ICreateProRequest} request CreateProRequest message or plain object
         * @returns {Promise<entity.Customer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#update}.
         * @memberof api.CustomerService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Customer} [response] Customer
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.CustomerService
         * @instance
         * @param {api.IUpdateCustomerRequest} request UpdateCustomerRequest message or plain object
         * @param {api.CustomerService.UpdateCallback} callback Node-style callback called with the error, if any, and Customer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateCustomerRequest, $root.entity.Customer, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.CustomerService
         * @instance
         * @param {api.IUpdateCustomerRequest} request UpdateCustomerRequest message or plain object
         * @returns {Promise<entity.Customer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#updateMultiSkillTag}.
         * @memberof api.CustomerService
         * @typedef UpdateMultiSkillTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls UpdateMultiSkillTag.
         * @function updateMultiSkillTag
         * @memberof api.CustomerService
         * @instance
         * @param {api.IUpdateCustomerMultiSkillTagRequest} request UpdateCustomerMultiSkillTagRequest message or plain object
         * @param {api.CustomerService.UpdateMultiSkillTagCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.updateMultiSkillTag = function updateMultiSkillTag(request, callback) {
            return this.rpcCall(updateMultiSkillTag, $root.api.UpdateCustomerMultiSkillTagRequest, $root.common.Empty, request, callback);
        }, "name", { value: "UpdateMultiSkillTag" });

        /**
         * Calls UpdateMultiSkillTag.
         * @function updateMultiSkillTag
         * @memberof api.CustomerService
         * @instance
         * @param {api.IUpdateCustomerMultiSkillTagRequest} request UpdateCustomerMultiSkillTagRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#generatePR}.
         * @memberof api.CustomerService
         * @typedef GeneratePRCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.TextResult} [response] TextResult
         */

        /**
         * Calls GeneratePR.
         * @function generatePR
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.CustomerService.GeneratePRCallback} callback Node-style callback called with the error, if any, and TextResult
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.generatePR = function generatePR(request, callback) {
            return this.rpcCall(generatePR, $root.common.Empty, $root.common.TextResult, request, callback);
        }, "name", { value: "GeneratePR" });

        /**
         * Calls GeneratePR.
         * @function generatePR
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.TextResult>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#generateDutySummary}.
         * @memberof api.CustomerService
         * @typedef GenerateDutySummaryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.TextResult} [response] TextResult
         */

        /**
         * Calls GenerateDutySummary.
         * @function generateDutySummary
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.CustomerService.GenerateDutySummaryCallback} callback Node-style callback called with the error, if any, and TextResult
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.generateDutySummary = function generateDutySummary(request, callback) {
            return this.rpcCall(generateDutySummary, $root.common.Empty, $root.common.TextResult, request, callback);
        }, "name", { value: "GenerateDutySummary" });

        /**
         * Calls GenerateDutySummary.
         * @function generateDutySummary
         * @memberof api.CustomerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.TextResult>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.CustomerService#agenticSearch}.
         * @memberof api.CustomerService
         * @typedef AgenticSearchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls AgenticSearch.
         * @function agenticSearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.IAgenticSearchRequest} request AgenticSearchRequest message or plain object
         * @param {api.CustomerService.AgenticSearchCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(CustomerService.prototype.agenticSearch = function agenticSearch(request, callback) {
            return this.rpcCall(agenticSearch, $root.api.AgenticSearchRequest, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "AgenticSearch" });

        /**
         * Calls AgenticSearch.
         * @function agenticSearch
         * @memberof api.CustomerService
         * @instance
         * @param {api.IAgenticSearchRequest} request AgenticSearchRequest message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        return CustomerService;
    })();

    api.AgenticSearchRequest = (function() {

        /**
         * Properties of an AgenticSearchRequest.
         * @memberof api
         * @interface IAgenticSearchRequest
         * @property {string|null} [query] AgenticSearchRequest query
         */

        /**
         * Constructs a new AgenticSearchRequest.
         * @memberof api
         * @classdesc Represents an AgenticSearchRequest.
         * @implements IAgenticSearchRequest
         * @constructor
         * @param {api.IAgenticSearchRequest=} [properties] Properties to set
         */
        function AgenticSearchRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AgenticSearchRequest query.
         * @member {string} query
         * @memberof api.AgenticSearchRequest
         * @instance
         */
        AgenticSearchRequest.prototype.query = "";

        /**
         * Creates a new AgenticSearchRequest instance using the specified properties.
         * @function create
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {api.IAgenticSearchRequest=} [properties] Properties to set
         * @returns {api.AgenticSearchRequest} AgenticSearchRequest instance
         */
        AgenticSearchRequest.create = function create(properties) {
            return new AgenticSearchRequest(properties);
        };

        /**
         * Encodes the specified AgenticSearchRequest message. Does not implicitly {@link api.AgenticSearchRequest.verify|verify} messages.
         * @function encode
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {api.IAgenticSearchRequest} message AgenticSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgenticSearchRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.query);
            return writer;
        };

        /**
         * Encodes the specified AgenticSearchRequest message, length delimited. Does not implicitly {@link api.AgenticSearchRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {api.IAgenticSearchRequest} message AgenticSearchRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgenticSearchRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AgenticSearchRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.AgenticSearchRequest} AgenticSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgenticSearchRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.AgenticSearchRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.query = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AgenticSearchRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.AgenticSearchRequest} AgenticSearchRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgenticSearchRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AgenticSearchRequest message.
         * @function verify
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AgenticSearchRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            return null;
        };

        /**
         * Creates an AgenticSearchRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.AgenticSearchRequest} AgenticSearchRequest
         */
        AgenticSearchRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.AgenticSearchRequest)
                return object;
            var message = new $root.api.AgenticSearchRequest();
            if (object.query != null)
                message.query = String(object.query);
            return message;
        };

        /**
         * Creates a plain object from an AgenticSearchRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.AgenticSearchRequest
         * @static
         * @param {api.AgenticSearchRequest} message AgenticSearchRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AgenticSearchRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.query = "";
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            return object;
        };

        /**
         * Converts this AgenticSearchRequest to JSON.
         * @function toJSON
         * @memberof api.AgenticSearchRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AgenticSearchRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AgenticSearchRequest;
    })();

    api.SearchCustomerRequest = (function() {

        /**
         * Properties of a SearchCustomerRequest.
         * @memberof api
         * @interface ISearchCustomerRequest
         * @property {common.IPager|null} [pager] SearchCustomerRequest pager
         * @property {string|null} [query] SearchCustomerRequest query
         * @property {Array.<string>|null} [singleSkillTagIDs] SearchCustomerRequest singleSkillTagIDs
         * @property {entity.OccupationSkillTag.Category|null} [occupationSkillTagCategory] SearchCustomerRequest occupationSkillTagCategory
         * @property {string|null} [occupationSkillTagID] SearchCustomerRequest occupationSkillTagID
         * @property {Array.<string>|null} [multiSkillTagIDs] SearchCustomerRequest multiSkillTagIDs
         * @property {entity.User.Gender|null} [gender] SearchCustomerRequest gender
         * @property {api.CustomerAgeSearchType|null} [age] SearchCustomerRequest age
         * @property {entity.Customer.WorkIntention|null} [workIntention] SearchCustomerRequest workIntention
         * @property {entity.Customer.FullTimePossibility|null} [fullTimePossibility] SearchCustomerRequest fullTimePossibility
         */

        /**
         * Constructs a new SearchCustomerRequest.
         * @memberof api
         * @classdesc Represents a SearchCustomerRequest.
         * @implements ISearchCustomerRequest
         * @constructor
         * @param {api.ISearchCustomerRequest=} [properties] Properties to set
         */
        function SearchCustomerRequest(properties) {
            this.singleSkillTagIDs = [];
            this.multiSkillTagIDs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchCustomerRequest pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.pager = null;

        /**
         * SearchCustomerRequest query.
         * @member {string} query
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.query = "";

        /**
         * SearchCustomerRequest singleSkillTagIDs.
         * @member {Array.<string>} singleSkillTagIDs
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.singleSkillTagIDs = $util.emptyArray;

        /**
         * SearchCustomerRequest occupationSkillTagCategory.
         * @member {entity.OccupationSkillTag.Category} occupationSkillTagCategory
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.occupationSkillTagCategory = 0;

        /**
         * SearchCustomerRequest occupationSkillTagID.
         * @member {string} occupationSkillTagID
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.occupationSkillTagID = "";

        /**
         * SearchCustomerRequest multiSkillTagIDs.
         * @member {Array.<string>} multiSkillTagIDs
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.multiSkillTagIDs = $util.emptyArray;

        /**
         * SearchCustomerRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.gender = 0;

        /**
         * SearchCustomerRequest age.
         * @member {api.CustomerAgeSearchType} age
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.age = 0;

        /**
         * SearchCustomerRequest workIntention.
         * @member {entity.Customer.WorkIntention} workIntention
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.workIntention = 0;

        /**
         * SearchCustomerRequest fullTimePossibility.
         * @member {entity.Customer.FullTimePossibility} fullTimePossibility
         * @memberof api.SearchCustomerRequest
         * @instance
         */
        SearchCustomerRequest.prototype.fullTimePossibility = 0;

        /**
         * Creates a new SearchCustomerRequest instance using the specified properties.
         * @function create
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {api.ISearchCustomerRequest=} [properties] Properties to set
         * @returns {api.SearchCustomerRequest} SearchCustomerRequest instance
         */
        SearchCustomerRequest.create = function create(properties) {
            return new SearchCustomerRequest(properties);
        };

        /**
         * Encodes the specified SearchCustomerRequest message. Does not implicitly {@link api.SearchCustomerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {api.ISearchCustomerRequest} message SearchCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchCustomerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.query);
            if (message.singleSkillTagIDs != null && message.singleSkillTagIDs.length)
                for (var i = 0; i < message.singleSkillTagIDs.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.singleSkillTagIDs[i]);
            if (message.occupationSkillTagCategory != null && Object.hasOwnProperty.call(message, "occupationSkillTagCategory"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.occupationSkillTagCategory);
            if (message.occupationSkillTagID != null && Object.hasOwnProperty.call(message, "occupationSkillTagID"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.occupationSkillTagID);
            if (message.multiSkillTagIDs != null && message.multiSkillTagIDs.length)
                for (var i = 0; i < message.multiSkillTagIDs.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.multiSkillTagIDs[i]);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.gender);
            if (message.age != null && Object.hasOwnProperty.call(message, "age"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.age);
            if (message.workIntention != null && Object.hasOwnProperty.call(message, "workIntention"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workIntention);
            if (message.fullTimePossibility != null && Object.hasOwnProperty.call(message, "fullTimePossibility"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.fullTimePossibility);
            return writer;
        };

        /**
         * Encodes the specified SearchCustomerRequest message, length delimited. Does not implicitly {@link api.SearchCustomerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {api.ISearchCustomerRequest} message SearchCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchCustomerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchCustomerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SearchCustomerRequest} SearchCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchCustomerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SearchCustomerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.query = reader.string();
                    break;
                case 3:
                    if (!(message.singleSkillTagIDs && message.singleSkillTagIDs.length))
                        message.singleSkillTagIDs = [];
                    message.singleSkillTagIDs.push(reader.string());
                    break;
                case 4:
                    message.occupationSkillTagCategory = reader.int32();
                    break;
                case 5:
                    message.occupationSkillTagID = reader.string();
                    break;
                case 6:
                    if (!(message.multiSkillTagIDs && message.multiSkillTagIDs.length))
                        message.multiSkillTagIDs = [];
                    message.multiSkillTagIDs.push(reader.string());
                    break;
                case 7:
                    message.gender = reader.int32();
                    break;
                case 8:
                    message.age = reader.int32();
                    break;
                case 9:
                    message.workIntention = reader.int32();
                    break;
                case 10:
                    message.fullTimePossibility = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchCustomerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SearchCustomerRequest} SearchCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchCustomerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchCustomerRequest message.
         * @function verify
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchCustomerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.singleSkillTagIDs != null && message.hasOwnProperty("singleSkillTagIDs")) {
                if (!Array.isArray(message.singleSkillTagIDs))
                    return "singleSkillTagIDs: array expected";
                for (var i = 0; i < message.singleSkillTagIDs.length; ++i)
                    if (!$util.isString(message.singleSkillTagIDs[i]))
                        return "singleSkillTagIDs: string[] expected";
            }
            if (message.occupationSkillTagCategory != null && message.hasOwnProperty("occupationSkillTagCategory"))
                switch (message.occupationSkillTagCategory) {
                default:
                    return "occupationSkillTagCategory: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.occupationSkillTagID != null && message.hasOwnProperty("occupationSkillTagID"))
                if (!$util.isString(message.occupationSkillTagID))
                    return "occupationSkillTagID: string expected";
            if (message.multiSkillTagIDs != null && message.hasOwnProperty("multiSkillTagIDs")) {
                if (!Array.isArray(message.multiSkillTagIDs))
                    return "multiSkillTagIDs: array expected";
                for (var i = 0; i < message.multiSkillTagIDs.length; ++i)
                    if (!$util.isString(message.multiSkillTagIDs[i]))
                        return "multiSkillTagIDs: string[] expected";
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.age != null && message.hasOwnProperty("age"))
                switch (message.age) {
                default:
                    return "age: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                switch (message.workIntention) {
                default:
                    return "workIntention: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                switch (message.fullTimePossibility) {
                default:
                    return "fullTimePossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a SearchCustomerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SearchCustomerRequest} SearchCustomerRequest
         */
        SearchCustomerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SearchCustomerRequest)
                return object;
            var message = new $root.api.SearchCustomerRequest();
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".api.SearchCustomerRequest.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            if (object.query != null)
                message.query = String(object.query);
            if (object.singleSkillTagIDs) {
                if (!Array.isArray(object.singleSkillTagIDs))
                    throw TypeError(".api.SearchCustomerRequest.singleSkillTagIDs: array expected");
                message.singleSkillTagIDs = [];
                for (var i = 0; i < object.singleSkillTagIDs.length; ++i)
                    message.singleSkillTagIDs[i] = String(object.singleSkillTagIDs[i]);
            }
            switch (object.occupationSkillTagCategory) {
            case "Category_Unknown":
            case 0:
                message.occupationSkillTagCategory = 0;
                break;
            case "Category_Sales":
            case 1:
                message.occupationSkillTagCategory = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.occupationSkillTagCategory = 2;
                break;
            case "Category_PR":
            case 3:
                message.occupationSkillTagCategory = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.occupationSkillTagCategory = 4;
                break;
            case "Category_Finance":
            case 5:
                message.occupationSkillTagCategory = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.occupationSkillTagCategory = 6;
                break;
            case "Category_IR":
            case 7:
                message.occupationSkillTagCategory = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.occupationSkillTagCategory = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.occupationSkillTagCategory = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.occupationSkillTagCategory = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.occupationSkillTagCategory = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.occupationSkillTagCategory = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.occupationSkillTagCategory = 13;
                break;
            case "Category_Bank":
            case 14:
                message.occupationSkillTagCategory = 14;
                break;
            case "Category_Technical":
            case 15:
                message.occupationSkillTagCategory = 15;
                break;
            case "Category_IPO":
            case 16:
                message.occupationSkillTagCategory = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.occupationSkillTagCategory = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.occupationSkillTagCategory = 18;
                break;
            case "Category_RandD":
            case 19:
                message.occupationSkillTagCategory = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.occupationSkillTagCategory = 20;
                break;
            }
            if (object.occupationSkillTagID != null)
                message.occupationSkillTagID = String(object.occupationSkillTagID);
            if (object.multiSkillTagIDs) {
                if (!Array.isArray(object.multiSkillTagIDs))
                    throw TypeError(".api.SearchCustomerRequest.multiSkillTagIDs: array expected");
                message.multiSkillTagIDs = [];
                for (var i = 0; i < object.multiSkillTagIDs.length; ++i)
                    message.multiSkillTagIDs[i] = String(object.multiSkillTagIDs[i]);
            }
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            switch (object.age) {
            case "Unknown":
            case 0:
                message.age = 0;
                break;
            case "Under30":
            case 1:
                message.age = 1;
                break;
            case "From30To40":
            case 2:
                message.age = 2;
                break;
            case "From40To50":
            case 3:
                message.age = 3;
                break;
            case "From50To60":
            case 4:
                message.age = 4;
                break;
            case "Over60":
            case 5:
                message.age = 5;
                break;
            }
            switch (object.workIntention) {
            case "WorkIntention_Unknown":
            case 0:
                message.workIntention = 0;
                break;
            case "WorkIntention_OnlyAdvice":
            case 1:
                message.workIntention = 1;
                break;
            case "WorkIntention_WithWork":
            case 2:
                message.workIntention = 2;
                break;
            case "WorkIntention_Consultation_Required":
            case 3:
                message.workIntention = 3;
                break;
            }
            switch (object.fullTimePossibility) {
            case "FullTimePossibility_Unknown":
            case 0:
                message.fullTimePossibility = 0;
                break;
            case "FullTimePossibility_Yes":
            case 1:
                message.fullTimePossibility = 1;
                break;
            case "FullTimePossibility_No":
            case 2:
                message.fullTimePossibility = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchCustomerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SearchCustomerRequest
         * @static
         * @param {api.SearchCustomerRequest} message SearchCustomerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchCustomerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.singleSkillTagIDs = [];
                object.multiSkillTagIDs = [];
            }
            if (options.defaults) {
                object.pager = null;
                object.query = "";
                object.occupationSkillTagCategory = options.enums === String ? "Category_Unknown" : 0;
                object.occupationSkillTagID = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.age = options.enums === String ? "Unknown" : 0;
                object.workIntention = options.enums === String ? "WorkIntention_Unknown" : 0;
                object.fullTimePossibility = options.enums === String ? "FullTimePossibility_Unknown" : 0;
            }
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.singleSkillTagIDs && message.singleSkillTagIDs.length) {
                object.singleSkillTagIDs = [];
                for (var j = 0; j < message.singleSkillTagIDs.length; ++j)
                    object.singleSkillTagIDs[j] = message.singleSkillTagIDs[j];
            }
            if (message.occupationSkillTagCategory != null && message.hasOwnProperty("occupationSkillTagCategory"))
                object.occupationSkillTagCategory = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.occupationSkillTagCategory] : message.occupationSkillTagCategory;
            if (message.occupationSkillTagID != null && message.hasOwnProperty("occupationSkillTagID"))
                object.occupationSkillTagID = message.occupationSkillTagID;
            if (message.multiSkillTagIDs && message.multiSkillTagIDs.length) {
                object.multiSkillTagIDs = [];
                for (var j = 0; j < message.multiSkillTagIDs.length; ++j)
                    object.multiSkillTagIDs[j] = message.multiSkillTagIDs[j];
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.age != null && message.hasOwnProperty("age"))
                object.age = options.enums === String ? $root.api.CustomerAgeSearchType[message.age] : message.age;
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                object.workIntention = options.enums === String ? $root.entity.Customer.WorkIntention[message.workIntention] : message.workIntention;
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                object.fullTimePossibility = options.enums === String ? $root.entity.Customer.FullTimePossibility[message.fullTimePossibility] : message.fullTimePossibility;
            return object;
        };

        /**
         * Converts this SearchCustomerRequest to JSON.
         * @function toJSON
         * @memberof api.SearchCustomerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchCustomerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchCustomerRequest;
    })();

    api.SearchCustomerCountRequest = (function() {

        /**
         * Properties of a SearchCustomerCountRequest.
         * @memberof api
         * @interface ISearchCustomerCountRequest
         * @property {string|null} [query] SearchCustomerCountRequest query
         * @property {Array.<string>|null} [singleSkillTagIDs] SearchCustomerCountRequest singleSkillTagIDs
         * @property {entity.OccupationSkillTag.Category|null} [occupationSkillTagCategory] SearchCustomerCountRequest occupationSkillTagCategory
         * @property {string|null} [occupationSkillTagID] SearchCustomerCountRequest occupationSkillTagID
         * @property {Array.<string>|null} [multiSkillTagIDs] SearchCustomerCountRequest multiSkillTagIDs
         * @property {entity.User.Gender|null} [gender] SearchCustomerCountRequest gender
         * @property {api.CustomerAgeSearchType|null} [age] SearchCustomerCountRequest age
         * @property {entity.Customer.WorkIntention|null} [workIntention] SearchCustomerCountRequest workIntention
         * @property {entity.Customer.FullTimePossibility|null} [fullTimePossibility] SearchCustomerCountRequest fullTimePossibility
         */

        /**
         * Constructs a new SearchCustomerCountRequest.
         * @memberof api
         * @classdesc Represents a SearchCustomerCountRequest.
         * @implements ISearchCustomerCountRequest
         * @constructor
         * @param {api.ISearchCustomerCountRequest=} [properties] Properties to set
         */
        function SearchCustomerCountRequest(properties) {
            this.singleSkillTagIDs = [];
            this.multiSkillTagIDs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchCustomerCountRequest query.
         * @member {string} query
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.query = "";

        /**
         * SearchCustomerCountRequest singleSkillTagIDs.
         * @member {Array.<string>} singleSkillTagIDs
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.singleSkillTagIDs = $util.emptyArray;

        /**
         * SearchCustomerCountRequest occupationSkillTagCategory.
         * @member {entity.OccupationSkillTag.Category} occupationSkillTagCategory
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.occupationSkillTagCategory = 0;

        /**
         * SearchCustomerCountRequest occupationSkillTagID.
         * @member {string} occupationSkillTagID
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.occupationSkillTagID = "";

        /**
         * SearchCustomerCountRequest multiSkillTagIDs.
         * @member {Array.<string>} multiSkillTagIDs
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.multiSkillTagIDs = $util.emptyArray;

        /**
         * SearchCustomerCountRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.gender = 0;

        /**
         * SearchCustomerCountRequest age.
         * @member {api.CustomerAgeSearchType} age
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.age = 0;

        /**
         * SearchCustomerCountRequest workIntention.
         * @member {entity.Customer.WorkIntention} workIntention
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.workIntention = 0;

        /**
         * SearchCustomerCountRequest fullTimePossibility.
         * @member {entity.Customer.FullTimePossibility} fullTimePossibility
         * @memberof api.SearchCustomerCountRequest
         * @instance
         */
        SearchCustomerCountRequest.prototype.fullTimePossibility = 0;

        /**
         * Creates a new SearchCustomerCountRequest instance using the specified properties.
         * @function create
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {api.ISearchCustomerCountRequest=} [properties] Properties to set
         * @returns {api.SearchCustomerCountRequest} SearchCustomerCountRequest instance
         */
        SearchCustomerCountRequest.create = function create(properties) {
            return new SearchCustomerCountRequest(properties);
        };

        /**
         * Encodes the specified SearchCustomerCountRequest message. Does not implicitly {@link api.SearchCustomerCountRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {api.ISearchCustomerCountRequest} message SearchCustomerCountRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchCustomerCountRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.query);
            if (message.singleSkillTagIDs != null && message.singleSkillTagIDs.length)
                for (var i = 0; i < message.singleSkillTagIDs.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.singleSkillTagIDs[i]);
            if (message.occupationSkillTagCategory != null && Object.hasOwnProperty.call(message, "occupationSkillTagCategory"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.occupationSkillTagCategory);
            if (message.occupationSkillTagID != null && Object.hasOwnProperty.call(message, "occupationSkillTagID"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.occupationSkillTagID);
            if (message.multiSkillTagIDs != null && message.multiSkillTagIDs.length)
                for (var i = 0; i < message.multiSkillTagIDs.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.multiSkillTagIDs[i]);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.gender);
            if (message.age != null && Object.hasOwnProperty.call(message, "age"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.age);
            if (message.workIntention != null && Object.hasOwnProperty.call(message, "workIntention"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.workIntention);
            if (message.fullTimePossibility != null && Object.hasOwnProperty.call(message, "fullTimePossibility"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.fullTimePossibility);
            return writer;
        };

        /**
         * Encodes the specified SearchCustomerCountRequest message, length delimited. Does not implicitly {@link api.SearchCustomerCountRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {api.ISearchCustomerCountRequest} message SearchCustomerCountRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchCustomerCountRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchCustomerCountRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SearchCustomerCountRequest} SearchCustomerCountRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchCustomerCountRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SearchCustomerCountRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.query = reader.string();
                    break;
                case 2:
                    if (!(message.singleSkillTagIDs && message.singleSkillTagIDs.length))
                        message.singleSkillTagIDs = [];
                    message.singleSkillTagIDs.push(reader.string());
                    break;
                case 3:
                    message.occupationSkillTagCategory = reader.int32();
                    break;
                case 4:
                    message.occupationSkillTagID = reader.string();
                    break;
                case 5:
                    if (!(message.multiSkillTagIDs && message.multiSkillTagIDs.length))
                        message.multiSkillTagIDs = [];
                    message.multiSkillTagIDs.push(reader.string());
                    break;
                case 6:
                    message.gender = reader.int32();
                    break;
                case 7:
                    message.age = reader.int32();
                    break;
                case 8:
                    message.workIntention = reader.int32();
                    break;
                case 9:
                    message.fullTimePossibility = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchCustomerCountRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SearchCustomerCountRequest} SearchCustomerCountRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchCustomerCountRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchCustomerCountRequest message.
         * @function verify
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchCustomerCountRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.query != null && message.hasOwnProperty("query"))
                if (!$util.isString(message.query))
                    return "query: string expected";
            if (message.singleSkillTagIDs != null && message.hasOwnProperty("singleSkillTagIDs")) {
                if (!Array.isArray(message.singleSkillTagIDs))
                    return "singleSkillTagIDs: array expected";
                for (var i = 0; i < message.singleSkillTagIDs.length; ++i)
                    if (!$util.isString(message.singleSkillTagIDs[i]))
                        return "singleSkillTagIDs: string[] expected";
            }
            if (message.occupationSkillTagCategory != null && message.hasOwnProperty("occupationSkillTagCategory"))
                switch (message.occupationSkillTagCategory) {
                default:
                    return "occupationSkillTagCategory: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                    break;
                }
            if (message.occupationSkillTagID != null && message.hasOwnProperty("occupationSkillTagID"))
                if (!$util.isString(message.occupationSkillTagID))
                    return "occupationSkillTagID: string expected";
            if (message.multiSkillTagIDs != null && message.hasOwnProperty("multiSkillTagIDs")) {
                if (!Array.isArray(message.multiSkillTagIDs))
                    return "multiSkillTagIDs: array expected";
                for (var i = 0; i < message.multiSkillTagIDs.length; ++i)
                    if (!$util.isString(message.multiSkillTagIDs[i]))
                        return "multiSkillTagIDs: string[] expected";
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.age != null && message.hasOwnProperty("age"))
                switch (message.age) {
                default:
                    return "age: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                switch (message.workIntention) {
                default:
                    return "workIntention: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                switch (message.fullTimePossibility) {
                default:
                    return "fullTimePossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a SearchCustomerCountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SearchCustomerCountRequest} SearchCustomerCountRequest
         */
        SearchCustomerCountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SearchCustomerCountRequest)
                return object;
            var message = new $root.api.SearchCustomerCountRequest();
            if (object.query != null)
                message.query = String(object.query);
            if (object.singleSkillTagIDs) {
                if (!Array.isArray(object.singleSkillTagIDs))
                    throw TypeError(".api.SearchCustomerCountRequest.singleSkillTagIDs: array expected");
                message.singleSkillTagIDs = [];
                for (var i = 0; i < object.singleSkillTagIDs.length; ++i)
                    message.singleSkillTagIDs[i] = String(object.singleSkillTagIDs[i]);
            }
            switch (object.occupationSkillTagCategory) {
            case "Category_Unknown":
            case 0:
                message.occupationSkillTagCategory = 0;
                break;
            case "Category_Sales":
            case 1:
                message.occupationSkillTagCategory = 1;
                break;
            case "Category_BusinessDevelopment":
            case 2:
                message.occupationSkillTagCategory = 2;
                break;
            case "Category_PR":
            case 3:
                message.occupationSkillTagCategory = 3;
                break;
            case "Category_PublicRelations":
            case 4:
                message.occupationSkillTagCategory = 4;
                break;
            case "Category_Finance":
            case 5:
                message.occupationSkillTagCategory = 5;
                break;
            case "Category_GroupManagement":
            case 6:
                message.occupationSkillTagCategory = 6;
                break;
            case "Category_IR":
            case 7:
                message.occupationSkillTagCategory = 7;
                break;
            case "Category_Accounting":
            case 8:
                message.occupationSkillTagCategory = 8;
                break;
            case "Category_OfficeWork_Assistant":
            case 9:
                message.occupationSkillTagCategory = 9;
                break;
            case "Category_SaleService":
            case 10:
                message.occupationSkillTagCategory = 10;
                break;
            case "Category_HumanResource":
            case 11:
                message.occupationSkillTagCategory = 11;
                break;
            case "Category_Consultant":
            case 12:
                message.occupationSkillTagCategory = 12;
                break;
            case "Category_Administrative":
            case 13:
                message.occupationSkillTagCategory = 13;
                break;
            case "Category_Bank":
            case 14:
                message.occupationSkillTagCategory = 14;
                break;
            case "Category_Technical":
            case 15:
                message.occupationSkillTagCategory = 15;
                break;
            case "Category_IPO":
            case 16:
                message.occupationSkillTagCategory = 16;
                break;
            case "Category_CompanyManagement":
            case 17:
                message.occupationSkillTagCategory = 17;
                break;
            case "Category_Marketing":
            case 18:
                message.occupationSkillTagCategory = 18;
                break;
            case "Category_RandD":
            case 19:
                message.occupationSkillTagCategory = 19;
                break;
            case "Category_LegalCompliance":
            case 20:
                message.occupationSkillTagCategory = 20;
                break;
            }
            if (object.occupationSkillTagID != null)
                message.occupationSkillTagID = String(object.occupationSkillTagID);
            if (object.multiSkillTagIDs) {
                if (!Array.isArray(object.multiSkillTagIDs))
                    throw TypeError(".api.SearchCustomerCountRequest.multiSkillTagIDs: array expected");
                message.multiSkillTagIDs = [];
                for (var i = 0; i < object.multiSkillTagIDs.length; ++i)
                    message.multiSkillTagIDs[i] = String(object.multiSkillTagIDs[i]);
            }
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            switch (object.age) {
            case "Unknown":
            case 0:
                message.age = 0;
                break;
            case "Under30":
            case 1:
                message.age = 1;
                break;
            case "From30To40":
            case 2:
                message.age = 2;
                break;
            case "From40To50":
            case 3:
                message.age = 3;
                break;
            case "From50To60":
            case 4:
                message.age = 4;
                break;
            case "Over60":
            case 5:
                message.age = 5;
                break;
            }
            switch (object.workIntention) {
            case "WorkIntention_Unknown":
            case 0:
                message.workIntention = 0;
                break;
            case "WorkIntention_OnlyAdvice":
            case 1:
                message.workIntention = 1;
                break;
            case "WorkIntention_WithWork":
            case 2:
                message.workIntention = 2;
                break;
            case "WorkIntention_Consultation_Required":
            case 3:
                message.workIntention = 3;
                break;
            }
            switch (object.fullTimePossibility) {
            case "FullTimePossibility_Unknown":
            case 0:
                message.fullTimePossibility = 0;
                break;
            case "FullTimePossibility_Yes":
            case 1:
                message.fullTimePossibility = 1;
                break;
            case "FullTimePossibility_No":
            case 2:
                message.fullTimePossibility = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SearchCustomerCountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SearchCustomerCountRequest
         * @static
         * @param {api.SearchCustomerCountRequest} message SearchCustomerCountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchCustomerCountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.singleSkillTagIDs = [];
                object.multiSkillTagIDs = [];
            }
            if (options.defaults) {
                object.query = "";
                object.occupationSkillTagCategory = options.enums === String ? "Category_Unknown" : 0;
                object.occupationSkillTagID = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.age = options.enums === String ? "Unknown" : 0;
                object.workIntention = options.enums === String ? "WorkIntention_Unknown" : 0;
                object.fullTimePossibility = options.enums === String ? "FullTimePossibility_Unknown" : 0;
            }
            if (message.query != null && message.hasOwnProperty("query"))
                object.query = message.query;
            if (message.singleSkillTagIDs && message.singleSkillTagIDs.length) {
                object.singleSkillTagIDs = [];
                for (var j = 0; j < message.singleSkillTagIDs.length; ++j)
                    object.singleSkillTagIDs[j] = message.singleSkillTagIDs[j];
            }
            if (message.occupationSkillTagCategory != null && message.hasOwnProperty("occupationSkillTagCategory"))
                object.occupationSkillTagCategory = options.enums === String ? $root.entity.OccupationSkillTag.Category[message.occupationSkillTagCategory] : message.occupationSkillTagCategory;
            if (message.occupationSkillTagID != null && message.hasOwnProperty("occupationSkillTagID"))
                object.occupationSkillTagID = message.occupationSkillTagID;
            if (message.multiSkillTagIDs && message.multiSkillTagIDs.length) {
                object.multiSkillTagIDs = [];
                for (var j = 0; j < message.multiSkillTagIDs.length; ++j)
                    object.multiSkillTagIDs[j] = message.multiSkillTagIDs[j];
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.age != null && message.hasOwnProperty("age"))
                object.age = options.enums === String ? $root.api.CustomerAgeSearchType[message.age] : message.age;
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                object.workIntention = options.enums === String ? $root.entity.Customer.WorkIntention[message.workIntention] : message.workIntention;
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                object.fullTimePossibility = options.enums === String ? $root.entity.Customer.FullTimePossibility[message.fullTimePossibility] : message.fullTimePossibility;
            return object;
        };

        /**
         * Converts this SearchCustomerCountRequest to JSON.
         * @function toJSON
         * @memberof api.SearchCustomerCountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchCustomerCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchCustomerCountRequest;
    })();

    api.CustomerCountByOccupationRequest = (function() {

        /**
         * Properties of a CustomerCountByOccupationRequest.
         * @memberof api
         * @interface ICustomerCountByOccupationRequest
         * @property {entity.Project.Occupation|null} [occupation] CustomerCountByOccupationRequest occupation
         */

        /**
         * Constructs a new CustomerCountByOccupationRequest.
         * @memberof api
         * @classdesc Represents a CustomerCountByOccupationRequest.
         * @implements ICustomerCountByOccupationRequest
         * @constructor
         * @param {api.ICustomerCountByOccupationRequest=} [properties] Properties to set
         */
        function CustomerCountByOccupationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomerCountByOccupationRequest occupation.
         * @member {entity.Project.Occupation} occupation
         * @memberof api.CustomerCountByOccupationRequest
         * @instance
         */
        CustomerCountByOccupationRequest.prototype.occupation = 0;

        /**
         * Creates a new CustomerCountByOccupationRequest instance using the specified properties.
         * @function create
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {api.ICustomerCountByOccupationRequest=} [properties] Properties to set
         * @returns {api.CustomerCountByOccupationRequest} CustomerCountByOccupationRequest instance
         */
        CustomerCountByOccupationRequest.create = function create(properties) {
            return new CustomerCountByOccupationRequest(properties);
        };

        /**
         * Encodes the specified CustomerCountByOccupationRequest message. Does not implicitly {@link api.CustomerCountByOccupationRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {api.ICustomerCountByOccupationRequest} message CustomerCountByOccupationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerCountByOccupationRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.occupation != null && Object.hasOwnProperty.call(message, "occupation"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.occupation);
            return writer;
        };

        /**
         * Encodes the specified CustomerCountByOccupationRequest message, length delimited. Does not implicitly {@link api.CustomerCountByOccupationRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {api.ICustomerCountByOccupationRequest} message CustomerCountByOccupationRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerCountByOccupationRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerCountByOccupationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CustomerCountByOccupationRequest} CustomerCountByOccupationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerCountByOccupationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CustomerCountByOccupationRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.occupation = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomerCountByOccupationRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CustomerCountByOccupationRequest} CustomerCountByOccupationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerCountByOccupationRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomerCountByOccupationRequest message.
         * @function verify
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomerCountByOccupationRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                switch (message.occupation) {
                default:
                    return "occupation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                    break;
                }
            return null;
        };

        /**
         * Creates a CustomerCountByOccupationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CustomerCountByOccupationRequest} CustomerCountByOccupationRequest
         */
        CustomerCountByOccupationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CustomerCountByOccupationRequest)
                return object;
            var message = new $root.api.CustomerCountByOccupationRequest();
            switch (object.occupation) {
            case "Occupation_Unknown":
            case 0:
                message.occupation = 0;
                break;
            case "Occupation_CorporateBusinessPlanning":
            case 1:
                message.occupation = 1;
                break;
            case "Occupation_BusinessDevelopment":
            case 2:
                message.occupation = 2;
                break;
            case "Occupation_Sales":
            case 3:
                message.occupation = 3;
                break;
            case "Occupation_PublicRelations":
            case 4:
                message.occupation = 4;
                break;
            case "Occupation_IPO":
            case 5:
                message.occupation = 5;
                break;
            case "Occupation_WebMarketing":
            case 6:
                message.occupation = 6;
                break;
            case "Occupation_HumanResource":
            case 7:
                message.occupation = 7;
                break;
            case "Occupation_HumanResource_Deprecate_1":
            case 8:
                message.occupation = 8;
                break;
            case "Occupation_HumanResource_Deprecate_2":
            case 9:
                message.occupation = 9;
                break;
            case "Occupation_HumanResource_Deprecate_3":
            case 10:
                message.occupation = 10;
                break;
            case "Occupation_IPO_Deprecate_1":
            case 11:
                message.occupation = 11;
                break;
            case "Occupation_Finance":
            case 12:
                message.occupation = 12;
                break;
            case "Occupation_Finance_Deprecate_1":
            case 13:
                message.occupation = 13;
                break;
            case "Occupation_Finance_Deprecate_2":
            case 14:
                message.occupation = 14;
                break;
            case "Occupation_MinistryOfJustice":
            case 15:
                message.occupation = 15;
                break;
            case "Occupation_Engineer":
            case 16:
                message.occupation = 16;
                break;
            case "Occupation_Designer":
            case 17:
                message.occupation = 17;
                break;
            case "Occupation_Other":
            case 18:
                message.occupation = 18;
                break;
            case "Occupation_InformationSystem":
            case 19:
                message.occupation = 19;
                break;
            case "Occupation_Professor":
            case 20:
                message.occupation = 20;
                break;
            case "Occupation_Marketing":
            case 21:
                message.occupation = 21;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomerCountByOccupationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CustomerCountByOccupationRequest
         * @static
         * @param {api.CustomerCountByOccupationRequest} message CustomerCountByOccupationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomerCountByOccupationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.occupation = options.enums === String ? "Occupation_Unknown" : 0;
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                object.occupation = options.enums === String ? $root.entity.Project.Occupation[message.occupation] : message.occupation;
            return object;
        };

        /**
         * Converts this CustomerCountByOccupationRequest to JSON.
         * @function toJSON
         * @memberof api.CustomerCountByOccupationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomerCountByOccupationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomerCountByOccupationRequest;
    })();

    api.CreateCustomerRequest = (function() {

        /**
         * Properties of a CreateCustomerRequest.
         * @memberof api
         * @interface ICreateCustomerRequest
         * @property {string|null} [name] CreateCustomerRequest name
         * @property {string|null} [nameKana] CreateCustomerRequest nameKana
         * @property {entity.User.Gender|null} [gender] CreateCustomerRequest gender
         * @property {string|null} [phoneNumber] CreateCustomerRequest phoneNumber
         * @property {string|null} [birthdate] CreateCustomerRequest birthdate
         * @property {string|null} [routeInfo] CreateCustomerRequest routeInfo
         * @property {string|null} [facebookURL] CreateCustomerRequest facebookURL
         */

        /**
         * Constructs a new CreateCustomerRequest.
         * @memberof api
         * @classdesc Represents a CreateCustomerRequest.
         * @implements ICreateCustomerRequest
         * @constructor
         * @param {api.ICreateCustomerRequest=} [properties] Properties to set
         */
        function CreateCustomerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateCustomerRequest name.
         * @member {string} name
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.name = "";

        /**
         * CreateCustomerRequest nameKana.
         * @member {string} nameKana
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.nameKana = "";

        /**
         * CreateCustomerRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.gender = 0;

        /**
         * CreateCustomerRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.phoneNumber = "";

        /**
         * CreateCustomerRequest birthdate.
         * @member {string} birthdate
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.birthdate = "";

        /**
         * CreateCustomerRequest routeInfo.
         * @member {string} routeInfo
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.routeInfo = "";

        /**
         * CreateCustomerRequest facebookURL.
         * @member {string} facebookURL
         * @memberof api.CreateCustomerRequest
         * @instance
         */
        CreateCustomerRequest.prototype.facebookURL = "";

        /**
         * Creates a new CreateCustomerRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {api.ICreateCustomerRequest=} [properties] Properties to set
         * @returns {api.CreateCustomerRequest} CreateCustomerRequest instance
         */
        CreateCustomerRequest.create = function create(properties) {
            return new CreateCustomerRequest(properties);
        };

        /**
         * Encodes the specified CreateCustomerRequest message. Does not implicitly {@link api.CreateCustomerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {api.ICreateCustomerRequest} message CreateCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCustomerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.gender);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
            if (message.birthdate != null && Object.hasOwnProperty.call(message, "birthdate"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.birthdate);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.routeInfo);
            if (message.facebookURL != null && Object.hasOwnProperty.call(message, "facebookURL"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.facebookURL);
            return writer;
        };

        /**
         * Encodes the specified CreateCustomerRequest message, length delimited. Does not implicitly {@link api.CreateCustomerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {api.ICreateCustomerRequest} message CreateCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateCustomerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateCustomerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateCustomerRequest} CreateCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCustomerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateCustomerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 3:
                    message.gender = reader.int32();
                    break;
                case 4:
                    message.phoneNumber = reader.string();
                    break;
                case 5:
                    message.birthdate = reader.string();
                    break;
                case 6:
                    message.routeInfo = reader.string();
                    break;
                case 7:
                    message.facebookURL = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateCustomerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateCustomerRequest} CreateCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateCustomerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateCustomerRequest message.
         * @function verify
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateCustomerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                if (!$util.isString(message.birthdate))
                    return "birthdate: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                if (!$util.isString(message.facebookURL))
                    return "facebookURL: string expected";
            return null;
        };

        /**
         * Creates a CreateCustomerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateCustomerRequest} CreateCustomerRequest
         */
        CreateCustomerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateCustomerRequest)
                return object;
            var message = new $root.api.CreateCustomerRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.birthdate != null)
                message.birthdate = String(object.birthdate);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            if (object.facebookURL != null)
                message.facebookURL = String(object.facebookURL);
            return message;
        };

        /**
         * Creates a plain object from a CreateCustomerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateCustomerRequest
         * @static
         * @param {api.CreateCustomerRequest} message CreateCustomerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateCustomerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.phoneNumber = "";
                object.birthdate = "";
                object.routeInfo = "";
                object.facebookURL = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                object.birthdate = message.birthdate;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                object.facebookURL = message.facebookURL;
            return object;
        };

        /**
         * Converts this CreateCustomerRequest to JSON.
         * @function toJSON
         * @memberof api.CreateCustomerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateCustomerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateCustomerRequest;
    })();

    api.CreateSuperEngineerRequest = (function() {

        /**
         * Properties of a CreateSuperEngineerRequest.
         * @memberof api
         * @interface ICreateSuperEngineerRequest
         * @property {string|null} [name] CreateSuperEngineerRequest name
         * @property {string|null} [nameKana] CreateSuperEngineerRequest nameKana
         * @property {entity.User.Gender|null} [gender] CreateSuperEngineerRequest gender
         * @property {string|null} [phoneNumber] CreateSuperEngineerRequest phoneNumber
         * @property {string|null} [portfolioURL] CreateSuperEngineerRequest portfolioURL
         * @property {string|null} [routeInfo] CreateSuperEngineerRequest routeInfo
         */

        /**
         * Constructs a new CreateSuperEngineerRequest.
         * @memberof api
         * @classdesc Represents a CreateSuperEngineerRequest.
         * @implements ICreateSuperEngineerRequest
         * @constructor
         * @param {api.ICreateSuperEngineerRequest=} [properties] Properties to set
         */
        function CreateSuperEngineerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateSuperEngineerRequest name.
         * @member {string} name
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.name = "";

        /**
         * CreateSuperEngineerRequest nameKana.
         * @member {string} nameKana
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.nameKana = "";

        /**
         * CreateSuperEngineerRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.gender = 0;

        /**
         * CreateSuperEngineerRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.phoneNumber = "";

        /**
         * CreateSuperEngineerRequest portfolioURL.
         * @member {string} portfolioURL
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.portfolioURL = "";

        /**
         * CreateSuperEngineerRequest routeInfo.
         * @member {string} routeInfo
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         */
        CreateSuperEngineerRequest.prototype.routeInfo = "";

        /**
         * Creates a new CreateSuperEngineerRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {api.ICreateSuperEngineerRequest=} [properties] Properties to set
         * @returns {api.CreateSuperEngineerRequest} CreateSuperEngineerRequest instance
         */
        CreateSuperEngineerRequest.create = function create(properties) {
            return new CreateSuperEngineerRequest(properties);
        };

        /**
         * Encodes the specified CreateSuperEngineerRequest message. Does not implicitly {@link api.CreateSuperEngineerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {api.ICreateSuperEngineerRequest} message CreateSuperEngineerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSuperEngineerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.gender);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
            if (message.portfolioURL != null && Object.hasOwnProperty.call(message, "portfolioURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.portfolioURL);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.routeInfo);
            return writer;
        };

        /**
         * Encodes the specified CreateSuperEngineerRequest message, length delimited. Does not implicitly {@link api.CreateSuperEngineerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {api.ICreateSuperEngineerRequest} message CreateSuperEngineerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSuperEngineerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateSuperEngineerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateSuperEngineerRequest} CreateSuperEngineerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSuperEngineerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateSuperEngineerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 3:
                    message.gender = reader.int32();
                    break;
                case 4:
                    message.phoneNumber = reader.string();
                    break;
                case 5:
                    message.portfolioURL = reader.string();
                    break;
                case 6:
                    message.routeInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateSuperEngineerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateSuperEngineerRequest} CreateSuperEngineerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSuperEngineerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateSuperEngineerRequest message.
         * @function verify
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateSuperEngineerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                if (!$util.isString(message.portfolioURL))
                    return "portfolioURL: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            return null;
        };

        /**
         * Creates a CreateSuperEngineerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateSuperEngineerRequest} CreateSuperEngineerRequest
         */
        CreateSuperEngineerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateSuperEngineerRequest)
                return object;
            var message = new $root.api.CreateSuperEngineerRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.portfolioURL != null)
                message.portfolioURL = String(object.portfolioURL);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            return message;
        };

        /**
         * Creates a plain object from a CreateSuperEngineerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateSuperEngineerRequest
         * @static
         * @param {api.CreateSuperEngineerRequest} message CreateSuperEngineerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateSuperEngineerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.phoneNumber = "";
                object.portfolioURL = "";
                object.routeInfo = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                object.portfolioURL = message.portfolioURL;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            return object;
        };

        /**
         * Converts this CreateSuperEngineerRequest to JSON.
         * @function toJSON
         * @memberof api.CreateSuperEngineerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateSuperEngineerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateSuperEngineerRequest;
    })();

    api.CreateProRequest = (function() {

        /**
         * Properties of a CreateProRequest.
         * @memberof api
         * @interface ICreateProRequest
         * @property {string|null} [name] CreateProRequest name
         * @property {string|null} [nameKana] CreateProRequest nameKana
         * @property {entity.User.Gender|null} [gender] CreateProRequest gender
         * @property {string|null} [phoneNumber] CreateProRequest phoneNumber
         * @property {string|null} [portfolioURL] CreateProRequest portfolioURL
         * @property {string|null} [routeInfo] CreateProRequest routeInfo
         */

        /**
         * Constructs a new CreateProRequest.
         * @memberof api
         * @classdesc Represents a CreateProRequest.
         * @implements ICreateProRequest
         * @constructor
         * @param {api.ICreateProRequest=} [properties] Properties to set
         */
        function CreateProRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateProRequest name.
         * @member {string} name
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.name = "";

        /**
         * CreateProRequest nameKana.
         * @member {string} nameKana
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.nameKana = "";

        /**
         * CreateProRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.gender = 0;

        /**
         * CreateProRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.phoneNumber = "";

        /**
         * CreateProRequest portfolioURL.
         * @member {string} portfolioURL
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.portfolioURL = "";

        /**
         * CreateProRequest routeInfo.
         * @member {string} routeInfo
         * @memberof api.CreateProRequest
         * @instance
         */
        CreateProRequest.prototype.routeInfo = "";

        /**
         * Creates a new CreateProRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateProRequest
         * @static
         * @param {api.ICreateProRequest=} [properties] Properties to set
         * @returns {api.CreateProRequest} CreateProRequest instance
         */
        CreateProRequest.create = function create(properties) {
            return new CreateProRequest(properties);
        };

        /**
         * Encodes the specified CreateProRequest message. Does not implicitly {@link api.CreateProRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateProRequest
         * @static
         * @param {api.ICreateProRequest} message CreateProRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.gender);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
            if (message.portfolioURL != null && Object.hasOwnProperty.call(message, "portfolioURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.portfolioURL);
            if (message.routeInfo != null && Object.hasOwnProperty.call(message, "routeInfo"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.routeInfo);
            return writer;
        };

        /**
         * Encodes the specified CreateProRequest message, length delimited. Does not implicitly {@link api.CreateProRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateProRequest
         * @static
         * @param {api.ICreateProRequest} message CreateProRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateProRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateProRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateProRequest} CreateProRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateProRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 3:
                    message.gender = reader.int32();
                    break;
                case 4:
                    message.phoneNumber = reader.string();
                    break;
                case 5:
                    message.portfolioURL = reader.string();
                    break;
                case 6:
                    message.routeInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateProRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateProRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateProRequest} CreateProRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateProRequest message.
         * @function verify
         * @memberof api.CreateProRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateProRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                if (!$util.isString(message.portfolioURL))
                    return "portfolioURL: string expected";
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                if (!$util.isString(message.routeInfo))
                    return "routeInfo: string expected";
            return null;
        };

        /**
         * Creates a CreateProRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateProRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateProRequest} CreateProRequest
         */
        CreateProRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateProRequest)
                return object;
            var message = new $root.api.CreateProRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.portfolioURL != null)
                message.portfolioURL = String(object.portfolioURL);
            if (object.routeInfo != null)
                message.routeInfo = String(object.routeInfo);
            return message;
        };

        /**
         * Creates a plain object from a CreateProRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateProRequest
         * @static
         * @param {api.CreateProRequest} message CreateProRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateProRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.phoneNumber = "";
                object.portfolioURL = "";
                object.routeInfo = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                object.portfolioURL = message.portfolioURL;
            if (message.routeInfo != null && message.hasOwnProperty("routeInfo"))
                object.routeInfo = message.routeInfo;
            return object;
        };

        /**
         * Converts this CreateProRequest to JSON.
         * @function toJSON
         * @memberof api.CreateProRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateProRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateProRequest;
    })();

    api.UpdateCustomerRequest = (function() {

        /**
         * Properties of an UpdateCustomerRequest.
         * @memberof api
         * @interface IUpdateCustomerRequest
         * @property {string|null} [name] UpdateCustomerRequest name
         * @property {string|null} [nameKana] UpdateCustomerRequest nameKana
         * @property {string|null} [iconURL] UpdateCustomerRequest iconURL
         * @property {string|null} [birthdate] UpdateCustomerRequest birthdate
         * @property {entity.User.Gender|null} [gender] UpdateCustomerRequest gender
         * @property {string|null} [phoneNumber] UpdateCustomerRequest phoneNumber
         * @property {string|null} [pr] UpdateCustomerRequest pr
         * @property {string|null} [address] UpdateCustomerRequest address
         * @property {Array.<string>|null} [academicBackgrounds] UpdateCustomerRequest academicBackgrounds
         * @property {Array.<string>|null} [requirements] UpdateCustomerRequest requirements
         * @property {Array.<entity.Customer.Language>|null} [languages] UpdateCustomerRequest languages
         * @property {string|null} [moreLanguage] UpdateCustomerRequest moreLanguage
         * @property {entity.Customer.SpeakingLevel|null} [speakingLevel] UpdateCustomerRequest speakingLevel
         * @property {string|null} [resumeURL] UpdateCustomerRequest resumeURL
         * @property {string|null} [jobHistoryURL] UpdateCustomerRequest jobHistoryURL
         * @property {entity.Customer.WorkingFrequency|null} [workingFrequency] UpdateCustomerRequest workingFrequency
         * @property {entity.Customer.RequestedFee|null} [requestedFee] UpdateCustomerRequest requestedFee
         * @property {string|null} [requestedCondition] UpdateCustomerRequest requestedCondition
         * @property {string|null} [dutySummary] UpdateCustomerRequest dutySummary
         * @property {entity.Customer.WorkIntention|null} [workIntention] UpdateCustomerRequest workIntention
         * @property {entity.Customer.FullTimePossibility|null} [fullTimePossibility] UpdateCustomerRequest fullTimePossibility
         * @property {entity.Customer.BrokerageProjectPossibility|null} [brokerageProjectPossibility] UpdateCustomerRequest brokerageProjectPossibility
         * @property {string|null} [portfolioURL] UpdateCustomerRequest portfolioURL
         * @property {string|null} [birthplace] UpdateCustomerRequest birthplace
         * @property {string|null} [facebookURL] UpdateCustomerRequest facebookURL
         * @property {string|null} [linkedInURL] UpdateCustomerRequest linkedInURL
         * @property {string|null} [xURL] UpdateCustomerRequest xURL
         */

        /**
         * Constructs a new UpdateCustomerRequest.
         * @memberof api
         * @classdesc Represents an UpdateCustomerRequest.
         * @implements IUpdateCustomerRequest
         * @constructor
         * @param {api.IUpdateCustomerRequest=} [properties] Properties to set
         */
        function UpdateCustomerRequest(properties) {
            this.academicBackgrounds = [];
            this.requirements = [];
            this.languages = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateCustomerRequest name.
         * @member {string} name
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.name = "";

        /**
         * UpdateCustomerRequest nameKana.
         * @member {string} nameKana
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.nameKana = "";

        /**
         * UpdateCustomerRequest iconURL.
         * @member {string} iconURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.iconURL = "";

        /**
         * UpdateCustomerRequest birthdate.
         * @member {string} birthdate
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.birthdate = "";

        /**
         * UpdateCustomerRequest gender.
         * @member {entity.User.Gender} gender
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.gender = 0;

        /**
         * UpdateCustomerRequest phoneNumber.
         * @member {string} phoneNumber
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.phoneNumber = "";

        /**
         * UpdateCustomerRequest pr.
         * @member {string} pr
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.pr = "";

        /**
         * UpdateCustomerRequest address.
         * @member {string} address
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.address = "";

        /**
         * UpdateCustomerRequest academicBackgrounds.
         * @member {Array.<string>} academicBackgrounds
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.academicBackgrounds = $util.emptyArray;

        /**
         * UpdateCustomerRequest requirements.
         * @member {Array.<string>} requirements
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.requirements = $util.emptyArray;

        /**
         * UpdateCustomerRequest languages.
         * @member {Array.<entity.Customer.Language>} languages
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.languages = $util.emptyArray;

        /**
         * UpdateCustomerRequest moreLanguage.
         * @member {string} moreLanguage
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.moreLanguage = "";

        /**
         * UpdateCustomerRequest speakingLevel.
         * @member {entity.Customer.SpeakingLevel} speakingLevel
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.speakingLevel = 0;

        /**
         * UpdateCustomerRequest resumeURL.
         * @member {string} resumeURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.resumeURL = "";

        /**
         * UpdateCustomerRequest jobHistoryURL.
         * @member {string} jobHistoryURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.jobHistoryURL = "";

        /**
         * UpdateCustomerRequest workingFrequency.
         * @member {entity.Customer.WorkingFrequency} workingFrequency
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.workingFrequency = 0;

        /**
         * UpdateCustomerRequest requestedFee.
         * @member {entity.Customer.RequestedFee} requestedFee
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.requestedFee = 0;

        /**
         * UpdateCustomerRequest requestedCondition.
         * @member {string} requestedCondition
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.requestedCondition = "";

        /**
         * UpdateCustomerRequest dutySummary.
         * @member {string} dutySummary
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.dutySummary = "";

        /**
         * UpdateCustomerRequest workIntention.
         * @member {entity.Customer.WorkIntention} workIntention
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.workIntention = 0;

        /**
         * UpdateCustomerRequest fullTimePossibility.
         * @member {entity.Customer.FullTimePossibility} fullTimePossibility
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.fullTimePossibility = 0;

        /**
         * UpdateCustomerRequest brokerageProjectPossibility.
         * @member {entity.Customer.BrokerageProjectPossibility} brokerageProjectPossibility
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.brokerageProjectPossibility = 0;

        /**
         * UpdateCustomerRequest portfolioURL.
         * @member {string} portfolioURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.portfolioURL = "";

        /**
         * UpdateCustomerRequest birthplace.
         * @member {string} birthplace
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.birthplace = "";

        /**
         * UpdateCustomerRequest facebookURL.
         * @member {string} facebookURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.facebookURL = "";

        /**
         * UpdateCustomerRequest linkedInURL.
         * @member {string} linkedInURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.linkedInURL = "";

        /**
         * UpdateCustomerRequest xURL.
         * @member {string} xURL
         * @memberof api.UpdateCustomerRequest
         * @instance
         */
        UpdateCustomerRequest.prototype.xURL = "";

        /**
         * Creates a new UpdateCustomerRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {api.IUpdateCustomerRequest=} [properties] Properties to set
         * @returns {api.UpdateCustomerRequest} UpdateCustomerRequest instance
         */
        UpdateCustomerRequest.create = function create(properties) {
            return new UpdateCustomerRequest(properties);
        };

        /**
         * Encodes the specified UpdateCustomerRequest message. Does not implicitly {@link api.UpdateCustomerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {api.IUpdateCustomerRequest} message UpdateCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.nameKana != null && Object.hasOwnProperty.call(message, "nameKana"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameKana);
            if (message.iconURL != null && Object.hasOwnProperty.call(message, "iconURL"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.iconURL);
            if (message.birthdate != null && Object.hasOwnProperty.call(message, "birthdate"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.birthdate);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.gender);
            if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.phoneNumber);
            if (message.pr != null && Object.hasOwnProperty.call(message, "pr"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.pr);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.address);
            if (message.academicBackgrounds != null && message.academicBackgrounds.length)
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.academicBackgrounds[i]);
            if (message.requirements != null && message.requirements.length)
                for (var i = 0; i < message.requirements.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.requirements[i]);
            if (message.languages != null && message.languages.length) {
                writer.uint32(/* id 11, wireType 2 =*/90).fork();
                for (var i = 0; i < message.languages.length; ++i)
                    writer.int32(message.languages[i]);
                writer.ldelim();
            }
            if (message.moreLanguage != null && Object.hasOwnProperty.call(message, "moreLanguage"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.moreLanguage);
            if (message.speakingLevel != null && Object.hasOwnProperty.call(message, "speakingLevel"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.speakingLevel);
            if (message.resumeURL != null && Object.hasOwnProperty.call(message, "resumeURL"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.resumeURL);
            if (message.jobHistoryURL != null && Object.hasOwnProperty.call(message, "jobHistoryURL"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.jobHistoryURL);
            if (message.workingFrequency != null && Object.hasOwnProperty.call(message, "workingFrequency"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.workingFrequency);
            if (message.requestedFee != null && Object.hasOwnProperty.call(message, "requestedFee"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.requestedFee);
            if (message.requestedCondition != null && Object.hasOwnProperty.call(message, "requestedCondition"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.requestedCondition);
            if (message.dutySummary != null && Object.hasOwnProperty.call(message, "dutySummary"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.dutySummary);
            if (message.workIntention != null && Object.hasOwnProperty.call(message, "workIntention"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.workIntention);
            if (message.fullTimePossibility != null && Object.hasOwnProperty.call(message, "fullTimePossibility"))
                writer.uint32(/* id 21, wireType 0 =*/168).int32(message.fullTimePossibility);
            if (message.brokerageProjectPossibility != null && Object.hasOwnProperty.call(message, "brokerageProjectPossibility"))
                writer.uint32(/* id 22, wireType 0 =*/176).int32(message.brokerageProjectPossibility);
            if (message.portfolioURL != null && Object.hasOwnProperty.call(message, "portfolioURL"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.portfolioURL);
            if (message.birthplace != null && Object.hasOwnProperty.call(message, "birthplace"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.birthplace);
            if (message.facebookURL != null && Object.hasOwnProperty.call(message, "facebookURL"))
                writer.uint32(/* id 25, wireType 2 =*/202).string(message.facebookURL);
            if (message.linkedInURL != null && Object.hasOwnProperty.call(message, "linkedInURL"))
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.linkedInURL);
            if (message.xURL != null && Object.hasOwnProperty.call(message, "xURL"))
                writer.uint32(/* id 27, wireType 2 =*/218).string(message.xURL);
            return writer;
        };

        /**
         * Encodes the specified UpdateCustomerRequest message, length delimited. Does not implicitly {@link api.UpdateCustomerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {api.IUpdateCustomerRequest} message UpdateCustomerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateCustomerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateCustomerRequest} UpdateCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateCustomerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.nameKana = reader.string();
                    break;
                case 3:
                    message.iconURL = reader.string();
                    break;
                case 4:
                    message.birthdate = reader.string();
                    break;
                case 5:
                    message.gender = reader.int32();
                    break;
                case 6:
                    message.phoneNumber = reader.string();
                    break;
                case 7:
                    message.pr = reader.string();
                    break;
                case 8:
                    message.address = reader.string();
                    break;
                case 9:
                    if (!(message.academicBackgrounds && message.academicBackgrounds.length))
                        message.academicBackgrounds = [];
                    message.academicBackgrounds.push(reader.string());
                    break;
                case 10:
                    if (!(message.requirements && message.requirements.length))
                        message.requirements = [];
                    message.requirements.push(reader.string());
                    break;
                case 11:
                    if (!(message.languages && message.languages.length))
                        message.languages = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.languages.push(reader.int32());
                    } else
                        message.languages.push(reader.int32());
                    break;
                case 12:
                    message.moreLanguage = reader.string();
                    break;
                case 13:
                    message.speakingLevel = reader.int32();
                    break;
                case 14:
                    message.resumeURL = reader.string();
                    break;
                case 15:
                    message.jobHistoryURL = reader.string();
                    break;
                case 16:
                    message.workingFrequency = reader.int32();
                    break;
                case 17:
                    message.requestedFee = reader.int32();
                    break;
                case 18:
                    message.requestedCondition = reader.string();
                    break;
                case 19:
                    message.dutySummary = reader.string();
                    break;
                case 20:
                    message.workIntention = reader.int32();
                    break;
                case 21:
                    message.fullTimePossibility = reader.int32();
                    break;
                case 22:
                    message.brokerageProjectPossibility = reader.int32();
                    break;
                case 23:
                    message.portfolioURL = reader.string();
                    break;
                case 24:
                    message.birthplace = reader.string();
                    break;
                case 25:
                    message.facebookURL = reader.string();
                    break;
                case 26:
                    message.linkedInURL = reader.string();
                    break;
                case 27:
                    message.xURL = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateCustomerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateCustomerRequest} UpdateCustomerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateCustomerRequest message.
         * @function verify
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateCustomerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                if (!$util.isString(message.nameKana))
                    return "nameKana: string expected";
            if (message.iconURL != null && message.hasOwnProperty("iconURL"))
                if (!$util.isString(message.iconURL))
                    return "iconURL: string expected";
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                if (!$util.isString(message.birthdate))
                    return "birthdate: string expected";
            if (message.gender != null && message.hasOwnProperty("gender"))
                switch (message.gender) {
                default:
                    return "gender: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                if (!$util.isString(message.phoneNumber))
                    return "phoneNumber: string expected";
            if (message.pr != null && message.hasOwnProperty("pr"))
                if (!$util.isString(message.pr))
                    return "pr: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.academicBackgrounds != null && message.hasOwnProperty("academicBackgrounds")) {
                if (!Array.isArray(message.academicBackgrounds))
                    return "academicBackgrounds: array expected";
                for (var i = 0; i < message.academicBackgrounds.length; ++i)
                    if (!$util.isString(message.academicBackgrounds[i]))
                        return "academicBackgrounds: string[] expected";
            }
            if (message.requirements != null && message.hasOwnProperty("requirements")) {
                if (!Array.isArray(message.requirements))
                    return "requirements: array expected";
                for (var i = 0; i < message.requirements.length; ++i)
                    if (!$util.isString(message.requirements[i]))
                        return "requirements: string[] expected";
            }
            if (message.languages != null && message.hasOwnProperty("languages")) {
                if (!Array.isArray(message.languages))
                    return "languages: array expected";
                for (var i = 0; i < message.languages.length; ++i)
                    switch (message.languages[i]) {
                    default:
                        return "languages: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        break;
                    }
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                if (!$util.isString(message.moreLanguage))
                    return "moreLanguage: string expected";
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                switch (message.speakingLevel) {
                default:
                    return "speakingLevel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                if (!$util.isString(message.resumeURL))
                    return "resumeURL: string expected";
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                if (!$util.isString(message.jobHistoryURL))
                    return "jobHistoryURL: string expected";
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                switch (message.workingFrequency) {
                default:
                    return "workingFrequency: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                switch (message.requestedFee) {
                default:
                    return "requestedFee: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                if (!$util.isString(message.requestedCondition))
                    return "requestedCondition: string expected";
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                if (!$util.isString(message.dutySummary))
                    return "dutySummary: string expected";
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                switch (message.workIntention) {
                default:
                    return "workIntention: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                switch (message.fullTimePossibility) {
                default:
                    return "fullTimePossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                switch (message.brokerageProjectPossibility) {
                default:
                    return "brokerageProjectPossibility: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                if (!$util.isString(message.portfolioURL))
                    return "portfolioURL: string expected";
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                if (!$util.isString(message.birthplace))
                    return "birthplace: string expected";
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                if (!$util.isString(message.facebookURL))
                    return "facebookURL: string expected";
            if (message.linkedInURL != null && message.hasOwnProperty("linkedInURL"))
                if (!$util.isString(message.linkedInURL))
                    return "linkedInURL: string expected";
            if (message.xURL != null && message.hasOwnProperty("xURL"))
                if (!$util.isString(message.xURL))
                    return "xURL: string expected";
            return null;
        };

        /**
         * Creates an UpdateCustomerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateCustomerRequest} UpdateCustomerRequest
         */
        UpdateCustomerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateCustomerRequest)
                return object;
            var message = new $root.api.UpdateCustomerRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nameKana != null)
                message.nameKana = String(object.nameKana);
            if (object.iconURL != null)
                message.iconURL = String(object.iconURL);
            if (object.birthdate != null)
                message.birthdate = String(object.birthdate);
            switch (object.gender) {
            case "Gender_Unknown":
            case 0:
                message.gender = 0;
                break;
            case "Gender_Male":
            case 1:
                message.gender = 1;
                break;
            case "Gender_Female":
            case 2:
                message.gender = 2;
                break;
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.pr != null)
                message.pr = String(object.pr);
            if (object.address != null)
                message.address = String(object.address);
            if (object.academicBackgrounds) {
                if (!Array.isArray(object.academicBackgrounds))
                    throw TypeError(".api.UpdateCustomerRequest.academicBackgrounds: array expected");
                message.academicBackgrounds = [];
                for (var i = 0; i < object.academicBackgrounds.length; ++i)
                    message.academicBackgrounds[i] = String(object.academicBackgrounds[i]);
            }
            if (object.requirements) {
                if (!Array.isArray(object.requirements))
                    throw TypeError(".api.UpdateCustomerRequest.requirements: array expected");
                message.requirements = [];
                for (var i = 0; i < object.requirements.length; ++i)
                    message.requirements[i] = String(object.requirements[i]);
            }
            if (object.languages) {
                if (!Array.isArray(object.languages))
                    throw TypeError(".api.UpdateCustomerRequest.languages: array expected");
                message.languages = [];
                for (var i = 0; i < object.languages.length; ++i)
                    switch (object.languages[i]) {
                    default:
                    case "Language_Unknown":
                    case 0:
                        message.languages[i] = 0;
                        break;
                    case "Language_English":
                    case 1:
                        message.languages[i] = 1;
                        break;
                    case "Language_Korean":
                    case 2:
                        message.languages[i] = 2;
                        break;
                    case "Language_Chinese":
                    case 3:
                        message.languages[i] = 3;
                        break;
                    case "Language_Spanish":
                    case 4:
                        message.languages[i] = 4;
                        break;
                    case "Language_German":
                    case 5:
                        message.languages[i] = 5;
                        break;
                    case "Language_French":
                    case 6:
                        message.languages[i] = 6;
                        break;
                    case "Language_Other":
                    case 7:
                        message.languages[i] = 7;
                        break;
                    }
            }
            if (object.moreLanguage != null)
                message.moreLanguage = String(object.moreLanguage);
            switch (object.speakingLevel) {
            case "SpeakingLevel_Unknown":
            case 0:
                message.speakingLevel = 0;
                break;
            case "SpeakingLevel_Basic_Conversation":
            case 1:
                message.speakingLevel = 1;
                break;
            case "SpeakingLevel_Business":
            case 2:
                message.speakingLevel = 2;
                break;
            case "SpeakingLevel_Native":
            case 3:
                message.speakingLevel = 3;
                break;
            }
            if (object.resumeURL != null)
                message.resumeURL = String(object.resumeURL);
            if (object.jobHistoryURL != null)
                message.jobHistoryURL = String(object.jobHistoryURL);
            switch (object.workingFrequency) {
            case "WorkingFrequency_Unknown":
            case 0:
                message.workingFrequency = 0;
                break;
            case "WorkingFrequency_Under_1_Day":
            case 1:
                message.workingFrequency = 1;
                break;
            case "WorkingFrequency_1_2_Day":
            case 2:
                message.workingFrequency = 2;
                break;
            case "WorkingFrequency_2_3_Day":
            case 3:
                message.workingFrequency = 3;
                break;
            case "WorkingFrequency_Over_3_Day":
            case 4:
                message.workingFrequency = 4;
                break;
            case "WorkingFrequency_Consultation":
            case 5:
                message.workingFrequency = 5;
                break;
            }
            switch (object.requestedFee) {
            case "RequestedFee_Unknown":
            case 0:
                message.requestedFee = 0;
                break;
            case "RequestedFee_Over_400000":
            case 1:
                message.requestedFee = 1;
                break;
            case "RequestedFee_300000_400000":
            case 2:
                message.requestedFee = 2;
                break;
            case "RequestedFee_200000_300000":
            case 3:
                message.requestedFee = 3;
                break;
            case "RequestedFee_Under_200000":
            case 4:
                message.requestedFee = 4;
                break;
            }
            if (object.requestedCondition != null)
                message.requestedCondition = String(object.requestedCondition);
            if (object.dutySummary != null)
                message.dutySummary = String(object.dutySummary);
            switch (object.workIntention) {
            case "WorkIntention_Unknown":
            case 0:
                message.workIntention = 0;
                break;
            case "WorkIntention_OnlyAdvice":
            case 1:
                message.workIntention = 1;
                break;
            case "WorkIntention_WithWork":
            case 2:
                message.workIntention = 2;
                break;
            case "WorkIntention_Consultation_Required":
            case 3:
                message.workIntention = 3;
                break;
            }
            switch (object.fullTimePossibility) {
            case "FullTimePossibility_Unknown":
            case 0:
                message.fullTimePossibility = 0;
                break;
            case "FullTimePossibility_Yes":
            case 1:
                message.fullTimePossibility = 1;
                break;
            case "FullTimePossibility_No":
            case 2:
                message.fullTimePossibility = 2;
                break;
            }
            switch (object.brokerageProjectPossibility) {
            case "BrokerageProjectPossibility_Unknown":
            case 0:
                message.brokerageProjectPossibility = 0;
                break;
            case "BrokerageProjectPossibility_Yes":
            case 1:
                message.brokerageProjectPossibility = 1;
                break;
            case "BrokerageProjectPossibility_No":
            case 2:
                message.brokerageProjectPossibility = 2;
                break;
            }
            if (object.portfolioURL != null)
                message.portfolioURL = String(object.portfolioURL);
            if (object.birthplace != null)
                message.birthplace = String(object.birthplace);
            if (object.facebookURL != null)
                message.facebookURL = String(object.facebookURL);
            if (object.linkedInURL != null)
                message.linkedInURL = String(object.linkedInURL);
            if (object.xURL != null)
                message.xURL = String(object.xURL);
            return message;
        };

        /**
         * Creates a plain object from an UpdateCustomerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateCustomerRequest
         * @static
         * @param {api.UpdateCustomerRequest} message UpdateCustomerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCustomerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.academicBackgrounds = [];
                object.requirements = [];
                object.languages = [];
            }
            if (options.defaults) {
                object.name = "";
                object.nameKana = "";
                object.iconURL = "";
                object.birthdate = "";
                object.gender = options.enums === String ? "Gender_Unknown" : 0;
                object.phoneNumber = "";
                object.pr = "";
                object.address = "";
                object.moreLanguage = "";
                object.speakingLevel = options.enums === String ? "SpeakingLevel_Unknown" : 0;
                object.resumeURL = "";
                object.jobHistoryURL = "";
                object.workingFrequency = options.enums === String ? "WorkingFrequency_Unknown" : 0;
                object.requestedFee = options.enums === String ? "RequestedFee_Unknown" : 0;
                object.requestedCondition = "";
                object.dutySummary = "";
                object.workIntention = options.enums === String ? "WorkIntention_Unknown" : 0;
                object.fullTimePossibility = options.enums === String ? "FullTimePossibility_Unknown" : 0;
                object.brokerageProjectPossibility = options.enums === String ? "BrokerageProjectPossibility_Unknown" : 0;
                object.portfolioURL = "";
                object.birthplace = "";
                object.facebookURL = "";
                object.linkedInURL = "";
                object.xURL = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nameKana != null && message.hasOwnProperty("nameKana"))
                object.nameKana = message.nameKana;
            if (message.iconURL != null && message.hasOwnProperty("iconURL"))
                object.iconURL = message.iconURL;
            if (message.birthdate != null && message.hasOwnProperty("birthdate"))
                object.birthdate = message.birthdate;
            if (message.gender != null && message.hasOwnProperty("gender"))
                object.gender = options.enums === String ? $root.entity.User.Gender[message.gender] : message.gender;
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.pr != null && message.hasOwnProperty("pr"))
                object.pr = message.pr;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.academicBackgrounds && message.academicBackgrounds.length) {
                object.academicBackgrounds = [];
                for (var j = 0; j < message.academicBackgrounds.length; ++j)
                    object.academicBackgrounds[j] = message.academicBackgrounds[j];
            }
            if (message.requirements && message.requirements.length) {
                object.requirements = [];
                for (var j = 0; j < message.requirements.length; ++j)
                    object.requirements[j] = message.requirements[j];
            }
            if (message.languages && message.languages.length) {
                object.languages = [];
                for (var j = 0; j < message.languages.length; ++j)
                    object.languages[j] = options.enums === String ? $root.entity.Customer.Language[message.languages[j]] : message.languages[j];
            }
            if (message.moreLanguage != null && message.hasOwnProperty("moreLanguage"))
                object.moreLanguage = message.moreLanguage;
            if (message.speakingLevel != null && message.hasOwnProperty("speakingLevel"))
                object.speakingLevel = options.enums === String ? $root.entity.Customer.SpeakingLevel[message.speakingLevel] : message.speakingLevel;
            if (message.resumeURL != null && message.hasOwnProperty("resumeURL"))
                object.resumeURL = message.resumeURL;
            if (message.jobHistoryURL != null && message.hasOwnProperty("jobHistoryURL"))
                object.jobHistoryURL = message.jobHistoryURL;
            if (message.workingFrequency != null && message.hasOwnProperty("workingFrequency"))
                object.workingFrequency = options.enums === String ? $root.entity.Customer.WorkingFrequency[message.workingFrequency] : message.workingFrequency;
            if (message.requestedFee != null && message.hasOwnProperty("requestedFee"))
                object.requestedFee = options.enums === String ? $root.entity.Customer.RequestedFee[message.requestedFee] : message.requestedFee;
            if (message.requestedCondition != null && message.hasOwnProperty("requestedCondition"))
                object.requestedCondition = message.requestedCondition;
            if (message.dutySummary != null && message.hasOwnProperty("dutySummary"))
                object.dutySummary = message.dutySummary;
            if (message.workIntention != null && message.hasOwnProperty("workIntention"))
                object.workIntention = options.enums === String ? $root.entity.Customer.WorkIntention[message.workIntention] : message.workIntention;
            if (message.fullTimePossibility != null && message.hasOwnProperty("fullTimePossibility"))
                object.fullTimePossibility = options.enums === String ? $root.entity.Customer.FullTimePossibility[message.fullTimePossibility] : message.fullTimePossibility;
            if (message.brokerageProjectPossibility != null && message.hasOwnProperty("brokerageProjectPossibility"))
                object.brokerageProjectPossibility = options.enums === String ? $root.entity.Customer.BrokerageProjectPossibility[message.brokerageProjectPossibility] : message.brokerageProjectPossibility;
            if (message.portfolioURL != null && message.hasOwnProperty("portfolioURL"))
                object.portfolioURL = message.portfolioURL;
            if (message.birthplace != null && message.hasOwnProperty("birthplace"))
                object.birthplace = message.birthplace;
            if (message.facebookURL != null && message.hasOwnProperty("facebookURL"))
                object.facebookURL = message.facebookURL;
            if (message.linkedInURL != null && message.hasOwnProperty("linkedInURL"))
                object.linkedInURL = message.linkedInURL;
            if (message.xURL != null && message.hasOwnProperty("xURL"))
                object.xURL = message.xURL;
            return object;
        };

        /**
         * Converts this UpdateCustomerRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateCustomerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCustomerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCustomerRequest;
    })();

    api.UpdateCustomerMultiSkillTagRequest = (function() {

        /**
         * Properties of an UpdateCustomerMultiSkillTagRequest.
         * @memberof api
         * @interface IUpdateCustomerMultiSkillTagRequest
         * @property {Array.<string>|null} [tagIDs] UpdateCustomerMultiSkillTagRequest tagIDs
         */

        /**
         * Constructs a new UpdateCustomerMultiSkillTagRequest.
         * @memberof api
         * @classdesc Represents an UpdateCustomerMultiSkillTagRequest.
         * @implements IUpdateCustomerMultiSkillTagRequest
         * @constructor
         * @param {api.IUpdateCustomerMultiSkillTagRequest=} [properties] Properties to set
         */
        function UpdateCustomerMultiSkillTagRequest(properties) {
            this.tagIDs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateCustomerMultiSkillTagRequest tagIDs.
         * @member {Array.<string>} tagIDs
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @instance
         */
        UpdateCustomerMultiSkillTagRequest.prototype.tagIDs = $util.emptyArray;

        /**
         * Creates a new UpdateCustomerMultiSkillTagRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {api.IUpdateCustomerMultiSkillTagRequest=} [properties] Properties to set
         * @returns {api.UpdateCustomerMultiSkillTagRequest} UpdateCustomerMultiSkillTagRequest instance
         */
        UpdateCustomerMultiSkillTagRequest.create = function create(properties) {
            return new UpdateCustomerMultiSkillTagRequest(properties);
        };

        /**
         * Encodes the specified UpdateCustomerMultiSkillTagRequest message. Does not implicitly {@link api.UpdateCustomerMultiSkillTagRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {api.IUpdateCustomerMultiSkillTagRequest} message UpdateCustomerMultiSkillTagRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerMultiSkillTagRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tagIDs != null && message.tagIDs.length)
                for (var i = 0; i < message.tagIDs.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tagIDs[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdateCustomerMultiSkillTagRequest message, length delimited. Does not implicitly {@link api.UpdateCustomerMultiSkillTagRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {api.IUpdateCustomerMultiSkillTagRequest} message UpdateCustomerMultiSkillTagRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateCustomerMultiSkillTagRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateCustomerMultiSkillTagRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateCustomerMultiSkillTagRequest} UpdateCustomerMultiSkillTagRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerMultiSkillTagRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateCustomerMultiSkillTagRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.tagIDs && message.tagIDs.length))
                        message.tagIDs = [];
                    message.tagIDs.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateCustomerMultiSkillTagRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateCustomerMultiSkillTagRequest} UpdateCustomerMultiSkillTagRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateCustomerMultiSkillTagRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateCustomerMultiSkillTagRequest message.
         * @function verify
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateCustomerMultiSkillTagRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tagIDs != null && message.hasOwnProperty("tagIDs")) {
                if (!Array.isArray(message.tagIDs))
                    return "tagIDs: array expected";
                for (var i = 0; i < message.tagIDs.length; ++i)
                    if (!$util.isString(message.tagIDs[i]))
                        return "tagIDs: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdateCustomerMultiSkillTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateCustomerMultiSkillTagRequest} UpdateCustomerMultiSkillTagRequest
         */
        UpdateCustomerMultiSkillTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateCustomerMultiSkillTagRequest)
                return object;
            var message = new $root.api.UpdateCustomerMultiSkillTagRequest();
            if (object.tagIDs) {
                if (!Array.isArray(object.tagIDs))
                    throw TypeError(".api.UpdateCustomerMultiSkillTagRequest.tagIDs: array expected");
                message.tagIDs = [];
                for (var i = 0; i < object.tagIDs.length; ++i)
                    message.tagIDs[i] = String(object.tagIDs[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateCustomerMultiSkillTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @static
         * @param {api.UpdateCustomerMultiSkillTagRequest} message UpdateCustomerMultiSkillTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCustomerMultiSkillTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tagIDs = [];
            if (message.tagIDs && message.tagIDs.length) {
                object.tagIDs = [];
                for (var j = 0; j < message.tagIDs.length; ++j)
                    object.tagIDs[j] = message.tagIDs[j];
            }
            return object;
        };

        /**
         * Converts this UpdateCustomerMultiSkillTagRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateCustomerMultiSkillTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCustomerMultiSkillTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCustomerMultiSkillTagRequest;
    })();

    /**
     * CustomerAgeSearchType enum.
     * @name api.CustomerAgeSearchType
     * @enum {number}
     * @property {number} Unknown=0 Unknown value
     * @property {number} Under30=1 Under30 value
     * @property {number} From30To40=2 From30To40 value
     * @property {number} From40To50=3 From40To50 value
     * @property {number} From50To60=4 From50To60 value
     * @property {number} Over60=5 Over60 value
     */
    api.CustomerAgeSearchType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unknown"] = 0;
        values[valuesById[1] = "Under30"] = 1;
        values[valuesById[2] = "From30To40"] = 2;
        values[valuesById[3] = "From40To50"] = 3;
        values[valuesById[4] = "From50To60"] = 4;
        values[valuesById[5] = "Over60"] = 5;
        return values;
    })();

    api.EntryScoutHistoryService = (function() {

        /**
         * Constructs a new EntryScoutHistoryService service.
         * @memberof api
         * @classdesc Represents an EntryScoutHistoryService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function EntryScoutHistoryService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (EntryScoutHistoryService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = EntryScoutHistoryService;

        /**
         * Creates new EntryScoutHistoryService service using the specified rpc implementation.
         * @function create
         * @memberof api.EntryScoutHistoryService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {EntryScoutHistoryService} RPC service. Useful where requests and/or responses are streamed.
         */
        EntryScoutHistoryService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.EntryScoutHistoryService#getAll}.
         * @memberof api.EntryScoutHistoryService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.EntryScoutHistoryList} [response] EntryScoutHistoryList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.EntryScoutHistoryService
         * @instance
         * @param {api.IEntryScoutHistoryGetAllRequest} request EntryScoutHistoryGetAllRequest message or plain object
         * @param {api.EntryScoutHistoryService.GetAllCallback} callback Node-style callback called with the error, if any, and EntryScoutHistoryList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryScoutHistoryService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.api.EntryScoutHistoryGetAllRequest, $root.entity.EntryScoutHistoryList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.EntryScoutHistoryService
         * @instance
         * @param {api.IEntryScoutHistoryGetAllRequest} request EntryScoutHistoryGetAllRequest message or plain object
         * @returns {Promise<entity.EntryScoutHistoryList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.EntryScoutHistoryService#toggleArchive}.
         * @memberof api.EntryScoutHistoryService
         * @typedef ToggleArchiveCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls ToggleArchive.
         * @function toggleArchive
         * @memberof api.EntryScoutHistoryService
         * @instance
         * @param {api.IEntryScoutHistoryToggleArchiveRequest} request EntryScoutHistoryToggleArchiveRequest message or plain object
         * @param {api.EntryScoutHistoryService.ToggleArchiveCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryScoutHistoryService.prototype.toggleArchive = function toggleArchive(request, callback) {
            return this.rpcCall(toggleArchive, $root.api.EntryScoutHistoryToggleArchiveRequest, $root.common.Empty, request, callback);
        }, "name", { value: "ToggleArchive" });

        /**
         * Calls ToggleArchive.
         * @function toggleArchive
         * @memberof api.EntryScoutHistoryService
         * @instance
         * @param {api.IEntryScoutHistoryToggleArchiveRequest} request EntryScoutHistoryToggleArchiveRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return EntryScoutHistoryService;
    })();

    api.EntryScoutHistoryGetAllRequest = (function() {

        /**
         * Properties of an EntryScoutHistoryGetAllRequest.
         * @memberof api
         * @interface IEntryScoutHistoryGetAllRequest
         * @property {common.IPager|null} [pager] EntryScoutHistoryGetAllRequest pager
         * @property {boolean|null} [isArchive] EntryScoutHistoryGetAllRequest isArchive
         */

        /**
         * Constructs a new EntryScoutHistoryGetAllRequest.
         * @memberof api
         * @classdesc Represents an EntryScoutHistoryGetAllRequest.
         * @implements IEntryScoutHistoryGetAllRequest
         * @constructor
         * @param {api.IEntryScoutHistoryGetAllRequest=} [properties] Properties to set
         */
        function EntryScoutHistoryGetAllRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryScoutHistoryGetAllRequest pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @instance
         */
        EntryScoutHistoryGetAllRequest.prototype.pager = null;

        /**
         * EntryScoutHistoryGetAllRequest isArchive.
         * @member {boolean} isArchive
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @instance
         */
        EntryScoutHistoryGetAllRequest.prototype.isArchive = false;

        /**
         * Creates a new EntryScoutHistoryGetAllRequest instance using the specified properties.
         * @function create
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {api.IEntryScoutHistoryGetAllRequest=} [properties] Properties to set
         * @returns {api.EntryScoutHistoryGetAllRequest} EntryScoutHistoryGetAllRequest instance
         */
        EntryScoutHistoryGetAllRequest.create = function create(properties) {
            return new EntryScoutHistoryGetAllRequest(properties);
        };

        /**
         * Encodes the specified EntryScoutHistoryGetAllRequest message. Does not implicitly {@link api.EntryScoutHistoryGetAllRequest.verify|verify} messages.
         * @function encode
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {api.IEntryScoutHistoryGetAllRequest} message EntryScoutHistoryGetAllRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryGetAllRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.isArchive != null && Object.hasOwnProperty.call(message, "isArchive"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isArchive);
            return writer;
        };

        /**
         * Encodes the specified EntryScoutHistoryGetAllRequest message, length delimited. Does not implicitly {@link api.EntryScoutHistoryGetAllRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {api.IEntryScoutHistoryGetAllRequest} message EntryScoutHistoryGetAllRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryGetAllRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryScoutHistoryGetAllRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.EntryScoutHistoryGetAllRequest} EntryScoutHistoryGetAllRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryGetAllRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.EntryScoutHistoryGetAllRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.isArchive = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryScoutHistoryGetAllRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.EntryScoutHistoryGetAllRequest} EntryScoutHistoryGetAllRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryGetAllRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryScoutHistoryGetAllRequest message.
         * @function verify
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryScoutHistoryGetAllRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                if (typeof message.isArchive !== "boolean")
                    return "isArchive: boolean expected";
            return null;
        };

        /**
         * Creates an EntryScoutHistoryGetAllRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.EntryScoutHistoryGetAllRequest} EntryScoutHistoryGetAllRequest
         */
        EntryScoutHistoryGetAllRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.EntryScoutHistoryGetAllRequest)
                return object;
            var message = new $root.api.EntryScoutHistoryGetAllRequest();
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".api.EntryScoutHistoryGetAllRequest.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            if (object.isArchive != null)
                message.isArchive = Boolean(object.isArchive);
            return message;
        };

        /**
         * Creates a plain object from an EntryScoutHistoryGetAllRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @static
         * @param {api.EntryScoutHistoryGetAllRequest} message EntryScoutHistoryGetAllRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryScoutHistoryGetAllRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pager = null;
                object.isArchive = false;
            }
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                object.isArchive = message.isArchive;
            return object;
        };

        /**
         * Converts this EntryScoutHistoryGetAllRequest to JSON.
         * @function toJSON
         * @memberof api.EntryScoutHistoryGetAllRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryScoutHistoryGetAllRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryScoutHistoryGetAllRequest;
    })();

    api.EntryScoutHistoryToggleArchiveRequest = (function() {

        /**
         * Properties of an EntryScoutHistoryToggleArchiveRequest.
         * @memberof api
         * @interface IEntryScoutHistoryToggleArchiveRequest
         * @property {string|null} [projectID] EntryScoutHistoryToggleArchiveRequest projectID
         * @property {string|null} [customerID] EntryScoutHistoryToggleArchiveRequest customerID
         * @property {boolean|null} [isArchive] EntryScoutHistoryToggleArchiveRequest isArchive
         */

        /**
         * Constructs a new EntryScoutHistoryToggleArchiveRequest.
         * @memberof api
         * @classdesc Represents an EntryScoutHistoryToggleArchiveRequest.
         * @implements IEntryScoutHistoryToggleArchiveRequest
         * @constructor
         * @param {api.IEntryScoutHistoryToggleArchiveRequest=} [properties] Properties to set
         */
        function EntryScoutHistoryToggleArchiveRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryScoutHistoryToggleArchiveRequest projectID.
         * @member {string} projectID
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @instance
         */
        EntryScoutHistoryToggleArchiveRequest.prototype.projectID = "";

        /**
         * EntryScoutHistoryToggleArchiveRequest customerID.
         * @member {string} customerID
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @instance
         */
        EntryScoutHistoryToggleArchiveRequest.prototype.customerID = "";

        /**
         * EntryScoutHistoryToggleArchiveRequest isArchive.
         * @member {boolean} isArchive
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @instance
         */
        EntryScoutHistoryToggleArchiveRequest.prototype.isArchive = false;

        /**
         * Creates a new EntryScoutHistoryToggleArchiveRequest instance using the specified properties.
         * @function create
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {api.IEntryScoutHistoryToggleArchiveRequest=} [properties] Properties to set
         * @returns {api.EntryScoutHistoryToggleArchiveRequest} EntryScoutHistoryToggleArchiveRequest instance
         */
        EntryScoutHistoryToggleArchiveRequest.create = function create(properties) {
            return new EntryScoutHistoryToggleArchiveRequest(properties);
        };

        /**
         * Encodes the specified EntryScoutHistoryToggleArchiveRequest message. Does not implicitly {@link api.EntryScoutHistoryToggleArchiveRequest.verify|verify} messages.
         * @function encode
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {api.IEntryScoutHistoryToggleArchiveRequest} message EntryScoutHistoryToggleArchiveRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryToggleArchiveRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerID);
            if (message.isArchive != null && Object.hasOwnProperty.call(message, "isArchive"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isArchive);
            return writer;
        };

        /**
         * Encodes the specified EntryScoutHistoryToggleArchiveRequest message, length delimited. Does not implicitly {@link api.EntryScoutHistoryToggleArchiveRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {api.IEntryScoutHistoryToggleArchiveRequest} message EntryScoutHistoryToggleArchiveRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryScoutHistoryToggleArchiveRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryScoutHistoryToggleArchiveRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.EntryScoutHistoryToggleArchiveRequest} EntryScoutHistoryToggleArchiveRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryToggleArchiveRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.EntryScoutHistoryToggleArchiveRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.customerID = reader.string();
                    break;
                case 3:
                    message.isArchive = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryScoutHistoryToggleArchiveRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.EntryScoutHistoryToggleArchiveRequest} EntryScoutHistoryToggleArchiveRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryScoutHistoryToggleArchiveRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryScoutHistoryToggleArchiveRequest message.
         * @function verify
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryScoutHistoryToggleArchiveRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                if (typeof message.isArchive !== "boolean")
                    return "isArchive: boolean expected";
            return null;
        };

        /**
         * Creates an EntryScoutHistoryToggleArchiveRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.EntryScoutHistoryToggleArchiveRequest} EntryScoutHistoryToggleArchiveRequest
         */
        EntryScoutHistoryToggleArchiveRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.EntryScoutHistoryToggleArchiveRequest)
                return object;
            var message = new $root.api.EntryScoutHistoryToggleArchiveRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.isArchive != null)
                message.isArchive = Boolean(object.isArchive);
            return message;
        };

        /**
         * Creates a plain object from an EntryScoutHistoryToggleArchiveRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @static
         * @param {api.EntryScoutHistoryToggleArchiveRequest} message EntryScoutHistoryToggleArchiveRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryScoutHistoryToggleArchiveRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.customerID = "";
                object.isArchive = false;
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.isArchive != null && message.hasOwnProperty("isArchive"))
                object.isArchive = message.isArchive;
            return object;
        };

        /**
         * Converts this EntryScoutHistoryToggleArchiveRequest to JSON.
         * @function toJSON
         * @memberof api.EntryScoutHistoryToggleArchiveRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryScoutHistoryToggleArchiveRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryScoutHistoryToggleArchiveRequest;
    })();

    api.EntryService = (function() {

        /**
         * Constructs a new EntryService service.
         * @memberof api
         * @classdesc Represents an EntryService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function EntryService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (EntryService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = EntryService;

        /**
         * Creates new EntryService service using the specified rpc implementation.
         * @function create
         * @memberof api.EntryService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {EntryService} RPC service. Useful where requests and/or responses are streamed.
         */
        EntryService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.EntryService#getAllByProject}.
         * @memberof api.EntryService
         * @typedef GetAllByProjectCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.EntryList} [response] EntryList
         */

        /**
         * Calls GetAllByProject.
         * @function getAllByProject
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.EntryService.GetAllByProjectCallback} callback Node-style callback called with the error, if any, and EntryList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryService.prototype.getAllByProject = function getAllByProject(request, callback) {
            return this.rpcCall(getAllByProject, $root.entity.ProjectID, $root.entity.EntryList, request, callback);
        }, "name", { value: "GetAllByProject" });

        /**
         * Calls GetAllByProject.
         * @function getAllByProject
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<entity.EntryList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.EntryService#getCountByProjects}.
         * @memberof api.EntryService
         * @typedef GetCountByProjectsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {api.EntryCountByProjectList} [response] EntryCountByProjectList
         */

        /**
         * Calls GetCountByProjects.
         * @function getCountByProjects
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectIDList} request ProjectIDList message or plain object
         * @param {api.EntryService.GetCountByProjectsCallback} callback Node-style callback called with the error, if any, and EntryCountByProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryService.prototype.getCountByProjects = function getCountByProjects(request, callback) {
            return this.rpcCall(getCountByProjects, $root.entity.ProjectIDList, $root.api.EntryCountByProjectList, request, callback);
        }, "name", { value: "GetCountByProjects" });

        /**
         * Calls GetCountByProjects.
         * @function getCountByProjects
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectIDList} request ProjectIDList message or plain object
         * @returns {Promise<api.EntryCountByProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.EntryService#getCountByProject}.
         * @memberof api.EntryService
         * @typedef GetCountByProjectCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountByProject.
         * @function getCountByProject
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.EntryService.GetCountByProjectCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryService.prototype.getCountByProject = function getCountByProject(request, callback) {
            return this.rpcCall(getCountByProject, $root.entity.ProjectID, $root.common.Count, request, callback);
        }, "name", { value: "GetCountByProject" });

        /**
         * Calls GetCountByProject.
         * @function getCountByProject
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.EntryService#create}.
         * @memberof api.EntryService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.EntryService.CreateCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.EntryService#delete_}.
         * @memberof api.EntryService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.EntryService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(EntryService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.EntryService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return EntryService;
    })();

    api.EntryCountByProjectList = (function() {

        /**
         * Properties of an EntryCountByProjectList.
         * @memberof api
         * @interface IEntryCountByProjectList
         * @property {Array.<api.IEntryCountByProject>|null} [items] EntryCountByProjectList items
         */

        /**
         * Constructs a new EntryCountByProjectList.
         * @memberof api
         * @classdesc Represents an EntryCountByProjectList.
         * @implements IEntryCountByProjectList
         * @constructor
         * @param {api.IEntryCountByProjectList=} [properties] Properties to set
         */
        function EntryCountByProjectList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryCountByProjectList items.
         * @member {Array.<api.IEntryCountByProject>} items
         * @memberof api.EntryCountByProjectList
         * @instance
         */
        EntryCountByProjectList.prototype.items = $util.emptyArray;

        /**
         * Creates a new EntryCountByProjectList instance using the specified properties.
         * @function create
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {api.IEntryCountByProjectList=} [properties] Properties to set
         * @returns {api.EntryCountByProjectList} EntryCountByProjectList instance
         */
        EntryCountByProjectList.create = function create(properties) {
            return new EntryCountByProjectList(properties);
        };

        /**
         * Encodes the specified EntryCountByProjectList message. Does not implicitly {@link api.EntryCountByProjectList.verify|verify} messages.
         * @function encode
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {api.IEntryCountByProjectList} message EntryCountByProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryCountByProjectList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.api.EntryCountByProject.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EntryCountByProjectList message, length delimited. Does not implicitly {@link api.EntryCountByProjectList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {api.IEntryCountByProjectList} message EntryCountByProjectList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryCountByProjectList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryCountByProjectList message from the specified reader or buffer.
         * @function decode
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.EntryCountByProjectList} EntryCountByProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryCountByProjectList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.EntryCountByProjectList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.api.EntryCountByProject.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryCountByProjectList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.EntryCountByProjectList} EntryCountByProjectList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryCountByProjectList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryCountByProjectList message.
         * @function verify
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryCountByProjectList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.api.EntryCountByProject.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EntryCountByProjectList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.EntryCountByProjectList} EntryCountByProjectList
         */
        EntryCountByProjectList.fromObject = function fromObject(object) {
            if (object instanceof $root.api.EntryCountByProjectList)
                return object;
            var message = new $root.api.EntryCountByProjectList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".api.EntryCountByProjectList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".api.EntryCountByProjectList.items: object expected");
                    message.items[i] = $root.api.EntryCountByProject.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EntryCountByProjectList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.EntryCountByProjectList
         * @static
         * @param {api.EntryCountByProjectList} message EntryCountByProjectList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryCountByProjectList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.api.EntryCountByProject.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this EntryCountByProjectList to JSON.
         * @function toJSON
         * @memberof api.EntryCountByProjectList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryCountByProjectList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryCountByProjectList;
    })();

    api.EntryCountByProject = (function() {

        /**
         * Properties of an EntryCountByProject.
         * @memberof api
         * @interface IEntryCountByProject
         * @property {string|null} [projectID] EntryCountByProject projectID
         * @property {number|Long|null} [count] EntryCountByProject count
         */

        /**
         * Constructs a new EntryCountByProject.
         * @memberof api
         * @classdesc Represents an EntryCountByProject.
         * @implements IEntryCountByProject
         * @constructor
         * @param {api.IEntryCountByProject=} [properties] Properties to set
         */
        function EntryCountByProject(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntryCountByProject projectID.
         * @member {string} projectID
         * @memberof api.EntryCountByProject
         * @instance
         */
        EntryCountByProject.prototype.projectID = "";

        /**
         * EntryCountByProject count.
         * @member {number|Long} count
         * @memberof api.EntryCountByProject
         * @instance
         */
        EntryCountByProject.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new EntryCountByProject instance using the specified properties.
         * @function create
         * @memberof api.EntryCountByProject
         * @static
         * @param {api.IEntryCountByProject=} [properties] Properties to set
         * @returns {api.EntryCountByProject} EntryCountByProject instance
         */
        EntryCountByProject.create = function create(properties) {
            return new EntryCountByProject(properties);
        };

        /**
         * Encodes the specified EntryCountByProject message. Does not implicitly {@link api.EntryCountByProject.verify|verify} messages.
         * @function encode
         * @memberof api.EntryCountByProject
         * @static
         * @param {api.IEntryCountByProject} message EntryCountByProject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryCountByProject.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.count);
            return writer;
        };

        /**
         * Encodes the specified EntryCountByProject message, length delimited. Does not implicitly {@link api.EntryCountByProject.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.EntryCountByProject
         * @static
         * @param {api.IEntryCountByProject} message EntryCountByProject message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntryCountByProject.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntryCountByProject message from the specified reader or buffer.
         * @function decode
         * @memberof api.EntryCountByProject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.EntryCountByProject} EntryCountByProject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryCountByProject.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.EntryCountByProject();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.count = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntryCountByProject message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.EntryCountByProject
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.EntryCountByProject} EntryCountByProject
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntryCountByProject.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntryCountByProject message.
         * @function verify
         * @memberof api.EntryCountByProject
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntryCountByProject.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.count != null && message.hasOwnProperty("count"))
                if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                    return "count: integer|Long expected";
            return null;
        };

        /**
         * Creates an EntryCountByProject message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.EntryCountByProject
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.EntryCountByProject} EntryCountByProject
         */
        EntryCountByProject.fromObject = function fromObject(object) {
            if (object instanceof $root.api.EntryCountByProject)
                return object;
            var message = new $root.api.EntryCountByProject();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.count != null)
                if ($util.Long)
                    (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                else if (typeof object.count === "string")
                    message.count = parseInt(object.count, 10);
                else if (typeof object.count === "number")
                    message.count = object.count;
                else if (typeof object.count === "object")
                    message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an EntryCountByProject message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.EntryCountByProject
         * @static
         * @param {api.EntryCountByProject} message EntryCountByProject
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntryCountByProject.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.count = options.longs === String ? "0" : 0;
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.count != null && message.hasOwnProperty("count"))
                if (typeof message.count === "number")
                    object.count = options.longs === String ? String(message.count) : message.count;
                else
                    object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
            return object;
        };

        /**
         * Converts this EntryCountByProject to JSON.
         * @function toJSON
         * @memberof api.EntryCountByProject
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntryCountByProject.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntryCountByProject;
    })();

    api.JobCareerService = (function() {

        /**
         * Constructs a new JobCareerService service.
         * @memberof api
         * @classdesc Represents a JobCareerService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function JobCareerService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (JobCareerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = JobCareerService;

        /**
         * Creates new JobCareerService service using the specified rpc implementation.
         * @function create
         * @memberof api.JobCareerService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {JobCareerService} RPC service. Useful where requests and/or responses are streamed.
         */
        JobCareerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.JobCareerService#getAll}.
         * @memberof api.JobCareerService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareerList} [response] JobCareerList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.JobCareerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.JobCareerService.GetAllCallback} callback Node-style callback called with the error, if any, and JobCareerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Empty, $root.entity.JobCareerList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.JobCareerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.JobCareerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#getAllByCustomer}.
         * @memberof api.JobCareerService
         * @typedef GetAllByCustomerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareerList} [response] JobCareerList
         */

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.JobCareerService.GetAllByCustomerCallback} callback Node-style callback called with the error, if any, and JobCareerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.getAllByCustomer = function getAllByCustomer(request, callback) {
            return this.rpcCall(getAllByCustomer, $root.entity.CustomerID, $root.entity.JobCareerList, request, callback);
        }, "name", { value: "GetAllByCustomer" });

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.JobCareerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#getAllByCustomerIDsForScout}.
         * @memberof api.JobCareerService
         * @typedef GetAllByCustomerIDsForScoutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareerWithCustomerIDList} [response] JobCareerWithCustomerIDList
         */

        /**
         * Calls GetAllByCustomerIDsForScout.
         * @function getAllByCustomerIDsForScout
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @param {api.JobCareerService.GetAllByCustomerIDsForScoutCallback} callback Node-style callback called with the error, if any, and JobCareerWithCustomerIDList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.getAllByCustomerIDsForScout = function getAllByCustomerIDsForScout(request, callback) {
            return this.rpcCall(getAllByCustomerIDsForScout, $root.entity.CustomerIDList, $root.entity.JobCareerWithCustomerIDList, request, callback);
        }, "name", { value: "GetAllByCustomerIDsForScout" });

        /**
         * Calls GetAllByCustomerIDsForScout.
         * @function getAllByCustomerIDsForScout
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @returns {Promise<entity.JobCareerWithCustomerIDList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#getAllByCustomerForScout}.
         * @memberof api.JobCareerService
         * @typedef GetAllByCustomerForScoutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareerList} [response] JobCareerList
         */

        /**
         * Calls GetAllByCustomerForScout.
         * @function getAllByCustomerForScout
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.JobCareerService.GetAllByCustomerForScoutCallback} callback Node-style callback called with the error, if any, and JobCareerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.getAllByCustomerForScout = function getAllByCustomerForScout(request, callback) {
            return this.rpcCall(getAllByCustomerForScout, $root.entity.CustomerID, $root.entity.JobCareerList, request, callback);
        }, "name", { value: "GetAllByCustomerForScout" });

        /**
         * Calls GetAllByCustomerForScout.
         * @function getAllByCustomerForScout
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.JobCareerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#create}.
         * @memberof api.JobCareerService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareer} [response] JobCareer
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.JobCareerService
         * @instance
         * @param {api.ICreateJobCareerRequest} request CreateJobCareerRequest message or plain object
         * @param {api.JobCareerService.CreateCallback} callback Node-style callback called with the error, if any, and JobCareer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateJobCareerRequest, $root.entity.JobCareer, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.JobCareerService
         * @instance
         * @param {api.ICreateJobCareerRequest} request CreateJobCareerRequest message or plain object
         * @returns {Promise<entity.JobCareer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#update}.
         * @memberof api.JobCareerService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareer} [response] JobCareer
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.JobCareerService
         * @instance
         * @param {api.IUpdateJobCareerRequest} request UpdateJobCareerRequest message or plain object
         * @param {api.JobCareerService.UpdateCallback} callback Node-style callback called with the error, if any, and JobCareer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateJobCareerRequest, $root.entity.JobCareer, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.JobCareerService
         * @instance
         * @param {api.IUpdateJobCareerRequest} request UpdateJobCareerRequest message or plain object
         * @returns {Promise<entity.JobCareer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#delete_}.
         * @memberof api.JobCareerService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.IJobCareerID} request JobCareerID message or plain object
         * @param {api.JobCareerService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.JobCareerID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.JobCareerService
         * @instance
         * @param {entity.IJobCareerID} request JobCareerID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.JobCareerService#deleteAll}.
         * @memberof api.JobCareerService
         * @typedef DeleteAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls DeleteAll.
         * @function deleteAll
         * @memberof api.JobCareerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.JobCareerService.DeleteAllCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(JobCareerService.prototype.deleteAll = function deleteAll(request, callback) {
            return this.rpcCall(deleteAll, $root.common.Empty, $root.common.Empty, request, callback);
        }, "name", { value: "DeleteAll" });

        /**
         * Calls DeleteAll.
         * @function deleteAll
         * @memberof api.JobCareerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return JobCareerService;
    })();

    api.CreateJobCareerRequest = (function() {

        /**
         * Properties of a CreateJobCareerRequest.
         * @memberof api
         * @interface ICreateJobCareerRequest
         * @property {string|null} [companyName] CreateJobCareerRequest companyName
         * @property {string|null} [description] CreateJobCareerRequest description
         * @property {Array.<entity.Project.Occupation>|null} [occupations] CreateJobCareerRequest occupations
         * @property {number|null} [startedAtYear] CreateJobCareerRequest startedAtYear
         * @property {number|null} [startedAtMonth] CreateJobCareerRequest startedAtMonth
         * @property {number|null} [startedAtDay] CreateJobCareerRequest startedAtDay
         * @property {number|null} [endedAtYear] CreateJobCareerRequest endedAtYear
         * @property {number|null} [endedAtMonth] CreateJobCareerRequest endedAtMonth
         * @property {number|null} [endedAtDay] CreateJobCareerRequest endedAtDay
         * @property {string|null} [post] CreateJobCareerRequest post
         * @property {entity.JobCareer.EmploymentStatus|null} [employmentStatus] CreateJobCareerRequest employmentStatus
         */

        /**
         * Constructs a new CreateJobCareerRequest.
         * @memberof api
         * @classdesc Represents a CreateJobCareerRequest.
         * @implements ICreateJobCareerRequest
         * @constructor
         * @param {api.ICreateJobCareerRequest=} [properties] Properties to set
         */
        function CreateJobCareerRequest(properties) {
            this.occupations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateJobCareerRequest companyName.
         * @member {string} companyName
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.companyName = "";

        /**
         * CreateJobCareerRequest description.
         * @member {string} description
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.description = "";

        /**
         * CreateJobCareerRequest occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.occupations = $util.emptyArray;

        /**
         * CreateJobCareerRequest startedAtYear.
         * @member {number} startedAtYear
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.startedAtYear = 0;

        /**
         * CreateJobCareerRequest startedAtMonth.
         * @member {number} startedAtMonth
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.startedAtMonth = 0;

        /**
         * CreateJobCareerRequest startedAtDay.
         * @member {number} startedAtDay
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.startedAtDay = 0;

        /**
         * CreateJobCareerRequest endedAtYear.
         * @member {number} endedAtYear
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.endedAtYear = 0;

        /**
         * CreateJobCareerRequest endedAtMonth.
         * @member {number} endedAtMonth
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.endedAtMonth = 0;

        /**
         * CreateJobCareerRequest endedAtDay.
         * @member {number} endedAtDay
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.endedAtDay = 0;

        /**
         * CreateJobCareerRequest post.
         * @member {string} post
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.post = "";

        /**
         * CreateJobCareerRequest employmentStatus.
         * @member {entity.JobCareer.EmploymentStatus} employmentStatus
         * @memberof api.CreateJobCareerRequest
         * @instance
         */
        CreateJobCareerRequest.prototype.employmentStatus = 0;

        /**
         * Creates a new CreateJobCareerRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {api.ICreateJobCareerRequest=} [properties] Properties to set
         * @returns {api.CreateJobCareerRequest} CreateJobCareerRequest instance
         */
        CreateJobCareerRequest.create = function create(properties) {
            return new CreateJobCareerRequest(properties);
        };

        /**
         * Encodes the specified CreateJobCareerRequest message. Does not implicitly {@link api.CreateJobCareerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {api.ICreateJobCareerRequest} message CreateJobCareerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateJobCareerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.companyName);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.startedAtYear != null && Object.hasOwnProperty.call(message, "startedAtYear"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.startedAtYear);
            if (message.startedAtMonth != null && Object.hasOwnProperty.call(message, "startedAtMonth"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.startedAtMonth);
            if (message.startedAtDay != null && Object.hasOwnProperty.call(message, "startedAtDay"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.startedAtDay);
            if (message.endedAtYear != null && Object.hasOwnProperty.call(message, "endedAtYear"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.endedAtYear);
            if (message.endedAtMonth != null && Object.hasOwnProperty.call(message, "endedAtMonth"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.endedAtMonth);
            if (message.endedAtDay != null && Object.hasOwnProperty.call(message, "endedAtDay"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.endedAtDay);
            if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.post);
            if (message.employmentStatus != null && Object.hasOwnProperty.call(message, "employmentStatus"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.employmentStatus);
            return writer;
        };

        /**
         * Encodes the specified CreateJobCareerRequest message, length delimited. Does not implicitly {@link api.CreateJobCareerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {api.ICreateJobCareerRequest} message CreateJobCareerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateJobCareerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateJobCareerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateJobCareerRequest} CreateJobCareerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateJobCareerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateJobCareerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.companyName = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 4:
                    message.startedAtYear = reader.uint32();
                    break;
                case 5:
                    message.startedAtMonth = reader.uint32();
                    break;
                case 6:
                    message.startedAtDay = reader.uint32();
                    break;
                case 7:
                    message.endedAtYear = reader.uint32();
                    break;
                case 8:
                    message.endedAtMonth = reader.uint32();
                    break;
                case 9:
                    message.endedAtDay = reader.uint32();
                    break;
                case 10:
                    message.post = reader.string();
                    break;
                case 11:
                    message.employmentStatus = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateJobCareerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateJobCareerRequest} CreateJobCareerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateJobCareerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateJobCareerRequest message.
         * @function verify
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateJobCareerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                if (!$util.isInteger(message.startedAtYear))
                    return "startedAtYear: integer expected";
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                if (!$util.isInteger(message.startedAtMonth))
                    return "startedAtMonth: integer expected";
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                if (!$util.isInteger(message.startedAtDay))
                    return "startedAtDay: integer expected";
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                if (!$util.isInteger(message.endedAtYear))
                    return "endedAtYear: integer expected";
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                if (!$util.isInteger(message.endedAtMonth))
                    return "endedAtMonth: integer expected";
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                if (!$util.isInteger(message.endedAtDay))
                    return "endedAtDay: integer expected";
            if (message.post != null && message.hasOwnProperty("post"))
                if (!$util.isString(message.post))
                    return "post: string expected";
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                switch (message.employmentStatus) {
                default:
                    return "employmentStatus: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            return null;
        };

        /**
         * Creates a CreateJobCareerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateJobCareerRequest} CreateJobCareerRequest
         */
        CreateJobCareerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateJobCareerRequest)
                return object;
            var message = new $root.api.CreateJobCareerRequest();
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.description != null)
                message.description = String(object.description);
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".api.CreateJobCareerRequest.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            if (object.startedAtYear != null)
                message.startedAtYear = object.startedAtYear >>> 0;
            if (object.startedAtMonth != null)
                message.startedAtMonth = object.startedAtMonth >>> 0;
            if (object.startedAtDay != null)
                message.startedAtDay = object.startedAtDay >>> 0;
            if (object.endedAtYear != null)
                message.endedAtYear = object.endedAtYear >>> 0;
            if (object.endedAtMonth != null)
                message.endedAtMonth = object.endedAtMonth >>> 0;
            if (object.endedAtDay != null)
                message.endedAtDay = object.endedAtDay >>> 0;
            if (object.post != null)
                message.post = String(object.post);
            switch (object.employmentStatus) {
            case "EmploymentStatus_Unknown":
            case 0:
                message.employmentStatus = 0;
                break;
            case "EmploymentStatus_FullTime":
            case 1:
                message.employmentStatus = 1;
                break;
            case "EmploymentStatus_Subcontracting":
            case 2:
                message.employmentStatus = 2;
                break;
            case "EmploymentStatus_Other":
            case 3:
                message.employmentStatus = 3;
                break;
            case "EmploymentStatus_BoardMember":
            case 4:
                message.employmentStatus = 4;
                break;
            case "EmploymentStatus_SoleProprietorship":
            case 5:
                message.employmentStatus = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateJobCareerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateJobCareerRequest
         * @static
         * @param {api.CreateJobCareerRequest} message CreateJobCareerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateJobCareerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.occupations = [];
            if (options.defaults) {
                object.companyName = "";
                object.description = "";
                object.startedAtYear = 0;
                object.startedAtMonth = 0;
                object.startedAtDay = 0;
                object.endedAtYear = 0;
                object.endedAtMonth = 0;
                object.endedAtDay = 0;
                object.post = "";
                object.employmentStatus = options.enums === String ? "EmploymentStatus_Unknown" : 0;
            }
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                object.startedAtYear = message.startedAtYear;
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                object.startedAtMonth = message.startedAtMonth;
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                object.startedAtDay = message.startedAtDay;
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                object.endedAtYear = message.endedAtYear;
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                object.endedAtMonth = message.endedAtMonth;
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                object.endedAtDay = message.endedAtDay;
            if (message.post != null && message.hasOwnProperty("post"))
                object.post = message.post;
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                object.employmentStatus = options.enums === String ? $root.entity.JobCareer.EmploymentStatus[message.employmentStatus] : message.employmentStatus;
            return object;
        };

        /**
         * Converts this CreateJobCareerRequest to JSON.
         * @function toJSON
         * @memberof api.CreateJobCareerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateJobCareerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateJobCareerRequest;
    })();

    api.UpdateJobCareerRequest = (function() {

        /**
         * Properties of an UpdateJobCareerRequest.
         * @memberof api
         * @interface IUpdateJobCareerRequest
         * @property {string|null} [id] UpdateJobCareerRequest id
         * @property {string|null} [companyName] UpdateJobCareerRequest companyName
         * @property {string|null} [description] UpdateJobCareerRequest description
         * @property {Array.<entity.Project.Occupation>|null} [occupations] UpdateJobCareerRequest occupations
         * @property {number|null} [startedAtYear] UpdateJobCareerRequest startedAtYear
         * @property {number|null} [startedAtMonth] UpdateJobCareerRequest startedAtMonth
         * @property {number|null} [startedAtDay] UpdateJobCareerRequest startedAtDay
         * @property {number|null} [endedAtYear] UpdateJobCareerRequest endedAtYear
         * @property {number|null} [endedAtMonth] UpdateJobCareerRequest endedAtMonth
         * @property {number|null} [endedAtDay] UpdateJobCareerRequest endedAtDay
         * @property {string|null} [post] UpdateJobCareerRequest post
         * @property {entity.JobCareer.EmploymentStatus|null} [employmentStatus] UpdateJobCareerRequest employmentStatus
         */

        /**
         * Constructs a new UpdateJobCareerRequest.
         * @memberof api
         * @classdesc Represents an UpdateJobCareerRequest.
         * @implements IUpdateJobCareerRequest
         * @constructor
         * @param {api.IUpdateJobCareerRequest=} [properties] Properties to set
         */
        function UpdateJobCareerRequest(properties) {
            this.occupations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateJobCareerRequest id.
         * @member {string} id
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.id = "";

        /**
         * UpdateJobCareerRequest companyName.
         * @member {string} companyName
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.companyName = "";

        /**
         * UpdateJobCareerRequest description.
         * @member {string} description
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.description = "";

        /**
         * UpdateJobCareerRequest occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.occupations = $util.emptyArray;

        /**
         * UpdateJobCareerRequest startedAtYear.
         * @member {number} startedAtYear
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.startedAtYear = 0;

        /**
         * UpdateJobCareerRequest startedAtMonth.
         * @member {number} startedAtMonth
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.startedAtMonth = 0;

        /**
         * UpdateJobCareerRequest startedAtDay.
         * @member {number} startedAtDay
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.startedAtDay = 0;

        /**
         * UpdateJobCareerRequest endedAtYear.
         * @member {number} endedAtYear
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.endedAtYear = 0;

        /**
         * UpdateJobCareerRequest endedAtMonth.
         * @member {number} endedAtMonth
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.endedAtMonth = 0;

        /**
         * UpdateJobCareerRequest endedAtDay.
         * @member {number} endedAtDay
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.endedAtDay = 0;

        /**
         * UpdateJobCareerRequest post.
         * @member {string} post
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.post = "";

        /**
         * UpdateJobCareerRequest employmentStatus.
         * @member {entity.JobCareer.EmploymentStatus} employmentStatus
         * @memberof api.UpdateJobCareerRequest
         * @instance
         */
        UpdateJobCareerRequest.prototype.employmentStatus = 0;

        /**
         * Creates a new UpdateJobCareerRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {api.IUpdateJobCareerRequest=} [properties] Properties to set
         * @returns {api.UpdateJobCareerRequest} UpdateJobCareerRequest instance
         */
        UpdateJobCareerRequest.create = function create(properties) {
            return new UpdateJobCareerRequest(properties);
        };

        /**
         * Encodes the specified UpdateJobCareerRequest message. Does not implicitly {@link api.UpdateJobCareerRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {api.IUpdateJobCareerRequest} message UpdateJobCareerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateJobCareerRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyName);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.startedAtYear != null && Object.hasOwnProperty.call(message, "startedAtYear"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.startedAtYear);
            if (message.startedAtMonth != null && Object.hasOwnProperty.call(message, "startedAtMonth"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.startedAtMonth);
            if (message.startedAtDay != null && Object.hasOwnProperty.call(message, "startedAtDay"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.startedAtDay);
            if (message.endedAtYear != null && Object.hasOwnProperty.call(message, "endedAtYear"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.endedAtYear);
            if (message.endedAtMonth != null && Object.hasOwnProperty.call(message, "endedAtMonth"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.endedAtMonth);
            if (message.endedAtDay != null && Object.hasOwnProperty.call(message, "endedAtDay"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.endedAtDay);
            if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.post);
            if (message.employmentStatus != null && Object.hasOwnProperty.call(message, "employmentStatus"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.employmentStatus);
            return writer;
        };

        /**
         * Encodes the specified UpdateJobCareerRequest message, length delimited. Does not implicitly {@link api.UpdateJobCareerRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {api.IUpdateJobCareerRequest} message UpdateJobCareerRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateJobCareerRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateJobCareerRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateJobCareerRequest} UpdateJobCareerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateJobCareerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateJobCareerRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.companyName = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 5:
                    message.startedAtYear = reader.uint32();
                    break;
                case 6:
                    message.startedAtMonth = reader.uint32();
                    break;
                case 7:
                    message.startedAtDay = reader.uint32();
                    break;
                case 8:
                    message.endedAtYear = reader.uint32();
                    break;
                case 9:
                    message.endedAtMonth = reader.uint32();
                    break;
                case 10:
                    message.endedAtDay = reader.uint32();
                    break;
                case 11:
                    message.post = reader.string();
                    break;
                case 12:
                    message.employmentStatus = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateJobCareerRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateJobCareerRequest} UpdateJobCareerRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateJobCareerRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateJobCareerRequest message.
         * @function verify
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateJobCareerRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                if (!$util.isString(message.companyName))
                    return "companyName: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                if (!$util.isInteger(message.startedAtYear))
                    return "startedAtYear: integer expected";
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                if (!$util.isInteger(message.startedAtMonth))
                    return "startedAtMonth: integer expected";
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                if (!$util.isInteger(message.startedAtDay))
                    return "startedAtDay: integer expected";
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                if (!$util.isInteger(message.endedAtYear))
                    return "endedAtYear: integer expected";
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                if (!$util.isInteger(message.endedAtMonth))
                    return "endedAtMonth: integer expected";
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                if (!$util.isInteger(message.endedAtDay))
                    return "endedAtDay: integer expected";
            if (message.post != null && message.hasOwnProperty("post"))
                if (!$util.isString(message.post))
                    return "post: string expected";
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                switch (message.employmentStatus) {
                default:
                    return "employmentStatus: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            return null;
        };

        /**
         * Creates an UpdateJobCareerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateJobCareerRequest} UpdateJobCareerRequest
         */
        UpdateJobCareerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateJobCareerRequest)
                return object;
            var message = new $root.api.UpdateJobCareerRequest();
            if (object.id != null)
                message.id = String(object.id);
            if (object.companyName != null)
                message.companyName = String(object.companyName);
            if (object.description != null)
                message.description = String(object.description);
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".api.UpdateJobCareerRequest.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            if (object.startedAtYear != null)
                message.startedAtYear = object.startedAtYear >>> 0;
            if (object.startedAtMonth != null)
                message.startedAtMonth = object.startedAtMonth >>> 0;
            if (object.startedAtDay != null)
                message.startedAtDay = object.startedAtDay >>> 0;
            if (object.endedAtYear != null)
                message.endedAtYear = object.endedAtYear >>> 0;
            if (object.endedAtMonth != null)
                message.endedAtMonth = object.endedAtMonth >>> 0;
            if (object.endedAtDay != null)
                message.endedAtDay = object.endedAtDay >>> 0;
            if (object.post != null)
                message.post = String(object.post);
            switch (object.employmentStatus) {
            case "EmploymentStatus_Unknown":
            case 0:
                message.employmentStatus = 0;
                break;
            case "EmploymentStatus_FullTime":
            case 1:
                message.employmentStatus = 1;
                break;
            case "EmploymentStatus_Subcontracting":
            case 2:
                message.employmentStatus = 2;
                break;
            case "EmploymentStatus_Other":
            case 3:
                message.employmentStatus = 3;
                break;
            case "EmploymentStatus_BoardMember":
            case 4:
                message.employmentStatus = 4;
                break;
            case "EmploymentStatus_SoleProprietorship":
            case 5:
                message.employmentStatus = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateJobCareerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateJobCareerRequest
         * @static
         * @param {api.UpdateJobCareerRequest} message UpdateJobCareerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateJobCareerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.occupations = [];
            if (options.defaults) {
                object.id = "";
                object.companyName = "";
                object.description = "";
                object.startedAtYear = 0;
                object.startedAtMonth = 0;
                object.startedAtDay = 0;
                object.endedAtYear = 0;
                object.endedAtMonth = 0;
                object.endedAtDay = 0;
                object.post = "";
                object.employmentStatus = options.enums === String ? "EmploymentStatus_Unknown" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.companyName != null && message.hasOwnProperty("companyName"))
                object.companyName = message.companyName;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.startedAtYear != null && message.hasOwnProperty("startedAtYear"))
                object.startedAtYear = message.startedAtYear;
            if (message.startedAtMonth != null && message.hasOwnProperty("startedAtMonth"))
                object.startedAtMonth = message.startedAtMonth;
            if (message.startedAtDay != null && message.hasOwnProperty("startedAtDay"))
                object.startedAtDay = message.startedAtDay;
            if (message.endedAtYear != null && message.hasOwnProperty("endedAtYear"))
                object.endedAtYear = message.endedAtYear;
            if (message.endedAtMonth != null && message.hasOwnProperty("endedAtMonth"))
                object.endedAtMonth = message.endedAtMonth;
            if (message.endedAtDay != null && message.hasOwnProperty("endedAtDay"))
                object.endedAtDay = message.endedAtDay;
            if (message.post != null && message.hasOwnProperty("post"))
                object.post = message.post;
            if (message.employmentStatus != null && message.hasOwnProperty("employmentStatus"))
                object.employmentStatus = options.enums === String ? $root.entity.JobCareer.EmploymentStatus[message.employmentStatus] : message.employmentStatus;
            return object;
        };

        /**
         * Converts this UpdateJobCareerRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateJobCareerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateJobCareerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateJobCareerRequest;
    })();

    api.MessageRoomService = (function() {

        /**
         * Constructs a new MessageRoomService service.
         * @memberof api
         * @classdesc Represents a MessageRoomService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function MessageRoomService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (MessageRoomService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MessageRoomService;

        /**
         * Creates new MessageRoomService service using the specified rpc implementation.
         * @function create
         * @memberof api.MessageRoomService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {MessageRoomService} RPC service. Useful where requests and/or responses are streamed.
         */
        MessageRoomService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.MessageRoomService#getAll}.
         * @memberof api.MessageRoomService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MessageRoomList} [response] MessageRoomList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.MessageRoomService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.MessageRoomService.GetAllCallback} callback Node-style callback called with the error, if any, and MessageRoomList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageRoomService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.MessageRoomList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.MessageRoomService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.MessageRoomList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MessageRoomService#get}.
         * @memberof api.MessageRoomService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MessageRoom} [response] MessageRoom
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IGetMessageRoomRequest} request GetMessageRoomRequest message or plain object
         * @param {api.MessageRoomService.GetCallback} callback Node-style callback called with the error, if any, and MessageRoom
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageRoomService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.api.GetMessageRoomRequest, $root.entity.MessageRoom, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IGetMessageRoomRequest} request GetMessageRoomRequest message or plain object
         * @returns {Promise<entity.MessageRoom>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MessageRoomService#read}.
         * @memberof api.MessageRoomService
         * @typedef ReadCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Read.
         * @function read
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IReadMessageRoomRequest} request ReadMessageRoomRequest message or plain object
         * @param {api.MessageRoomService.ReadCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageRoomService.prototype.read = function read(request, callback) {
            return this.rpcCall(read, $root.api.ReadMessageRoomRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Read" });

        /**
         * Calls Read.
         * @function read
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IReadMessageRoomRequest} request ReadMessageRoomRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MessageRoomService#delete_}.
         * @memberof api.MessageRoomService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IDeleteMessageRoomRequest} request DeleteMessageRoomRequest message or plain object
         * @param {api.MessageRoomService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageRoomService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.api.DeleteMessageRoomRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.MessageRoomService
         * @instance
         * @param {api.IDeleteMessageRoomRequest} request DeleteMessageRoomRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return MessageRoomService;
    })();

    api.ReadMessageRoomRequest = (function() {

        /**
         * Properties of a ReadMessageRoomRequest.
         * @memberof api
         * @interface IReadMessageRoomRequest
         * @property {string|null} [projectID] ReadMessageRoomRequest projectID
         * @property {string|null} [opponentID] ReadMessageRoomRequest opponentID
         */

        /**
         * Constructs a new ReadMessageRoomRequest.
         * @memberof api
         * @classdesc Represents a ReadMessageRoomRequest.
         * @implements IReadMessageRoomRequest
         * @constructor
         * @param {api.IReadMessageRoomRequest=} [properties] Properties to set
         */
        function ReadMessageRoomRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadMessageRoomRequest projectID.
         * @member {string} projectID
         * @memberof api.ReadMessageRoomRequest
         * @instance
         */
        ReadMessageRoomRequest.prototype.projectID = "";

        /**
         * ReadMessageRoomRequest opponentID.
         * @member {string} opponentID
         * @memberof api.ReadMessageRoomRequest
         * @instance
         */
        ReadMessageRoomRequest.prototype.opponentID = "";

        /**
         * Creates a new ReadMessageRoomRequest instance using the specified properties.
         * @function create
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {api.IReadMessageRoomRequest=} [properties] Properties to set
         * @returns {api.ReadMessageRoomRequest} ReadMessageRoomRequest instance
         */
        ReadMessageRoomRequest.create = function create(properties) {
            return new ReadMessageRoomRequest(properties);
        };

        /**
         * Encodes the specified ReadMessageRoomRequest message. Does not implicitly {@link api.ReadMessageRoomRequest.verify|verify} messages.
         * @function encode
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {api.IReadMessageRoomRequest} message ReadMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadMessageRoomRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified ReadMessageRoomRequest message, length delimited. Does not implicitly {@link api.ReadMessageRoomRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {api.IReadMessageRoomRequest} message ReadMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadMessageRoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadMessageRoomRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.ReadMessageRoomRequest} ReadMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadMessageRoomRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.ReadMessageRoomRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadMessageRoomRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.ReadMessageRoomRequest} ReadMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadMessageRoomRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadMessageRoomRequest message.
         * @function verify
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadMessageRoomRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a ReadMessageRoomRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.ReadMessageRoomRequest} ReadMessageRoomRequest
         */
        ReadMessageRoomRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.ReadMessageRoomRequest)
                return object;
            var message = new $root.api.ReadMessageRoomRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a ReadMessageRoomRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.ReadMessageRoomRequest
         * @static
         * @param {api.ReadMessageRoomRequest} message ReadMessageRoomRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadMessageRoomRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this ReadMessageRoomRequest to JSON.
         * @function toJSON
         * @memberof api.ReadMessageRoomRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadMessageRoomRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReadMessageRoomRequest;
    })();

    api.GetMessageRoomRequest = (function() {

        /**
         * Properties of a GetMessageRoomRequest.
         * @memberof api
         * @interface IGetMessageRoomRequest
         * @property {string|null} [projectID] GetMessageRoomRequest projectID
         * @property {string|null} [opponentID] GetMessageRoomRequest opponentID
         */

        /**
         * Constructs a new GetMessageRoomRequest.
         * @memberof api
         * @classdesc Represents a GetMessageRoomRequest.
         * @implements IGetMessageRoomRequest
         * @constructor
         * @param {api.IGetMessageRoomRequest=} [properties] Properties to set
         */
        function GetMessageRoomRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMessageRoomRequest projectID.
         * @member {string} projectID
         * @memberof api.GetMessageRoomRequest
         * @instance
         */
        GetMessageRoomRequest.prototype.projectID = "";

        /**
         * GetMessageRoomRequest opponentID.
         * @member {string} opponentID
         * @memberof api.GetMessageRoomRequest
         * @instance
         */
        GetMessageRoomRequest.prototype.opponentID = "";

        /**
         * Creates a new GetMessageRoomRequest instance using the specified properties.
         * @function create
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {api.IGetMessageRoomRequest=} [properties] Properties to set
         * @returns {api.GetMessageRoomRequest} GetMessageRoomRequest instance
         */
        GetMessageRoomRequest.create = function create(properties) {
            return new GetMessageRoomRequest(properties);
        };

        /**
         * Encodes the specified GetMessageRoomRequest message. Does not implicitly {@link api.GetMessageRoomRequest.verify|verify} messages.
         * @function encode
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {api.IGetMessageRoomRequest} message GetMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMessageRoomRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified GetMessageRoomRequest message, length delimited. Does not implicitly {@link api.GetMessageRoomRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {api.IGetMessageRoomRequest} message GetMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMessageRoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMessageRoomRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.GetMessageRoomRequest} GetMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMessageRoomRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.GetMessageRoomRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMessageRoomRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.GetMessageRoomRequest} GetMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMessageRoomRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMessageRoomRequest message.
         * @function verify
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMessageRoomRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a GetMessageRoomRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.GetMessageRoomRequest} GetMessageRoomRequest
         */
        GetMessageRoomRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.GetMessageRoomRequest)
                return object;
            var message = new $root.api.GetMessageRoomRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a GetMessageRoomRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.GetMessageRoomRequest
         * @static
         * @param {api.GetMessageRoomRequest} message GetMessageRoomRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMessageRoomRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this GetMessageRoomRequest to JSON.
         * @function toJSON
         * @memberof api.GetMessageRoomRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMessageRoomRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMessageRoomRequest;
    })();

    api.CreateMessageRoomRequest = (function() {

        /**
         * Properties of a CreateMessageRoomRequest.
         * @memberof api
         * @interface ICreateMessageRoomRequest
         * @property {string|null} [projectID] CreateMessageRoomRequest projectID
         * @property {string|null} [opponentID] CreateMessageRoomRequest opponentID
         */

        /**
         * Constructs a new CreateMessageRoomRequest.
         * @memberof api
         * @classdesc Represents a CreateMessageRoomRequest.
         * @implements ICreateMessageRoomRequest
         * @constructor
         * @param {api.ICreateMessageRoomRequest=} [properties] Properties to set
         */
        function CreateMessageRoomRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateMessageRoomRequest projectID.
         * @member {string} projectID
         * @memberof api.CreateMessageRoomRequest
         * @instance
         */
        CreateMessageRoomRequest.prototype.projectID = "";

        /**
         * CreateMessageRoomRequest opponentID.
         * @member {string} opponentID
         * @memberof api.CreateMessageRoomRequest
         * @instance
         */
        CreateMessageRoomRequest.prototype.opponentID = "";

        /**
         * Creates a new CreateMessageRoomRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {api.ICreateMessageRoomRequest=} [properties] Properties to set
         * @returns {api.CreateMessageRoomRequest} CreateMessageRoomRequest instance
         */
        CreateMessageRoomRequest.create = function create(properties) {
            return new CreateMessageRoomRequest(properties);
        };

        /**
         * Encodes the specified CreateMessageRoomRequest message. Does not implicitly {@link api.CreateMessageRoomRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {api.ICreateMessageRoomRequest} message CreateMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMessageRoomRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified CreateMessageRoomRequest message, length delimited. Does not implicitly {@link api.CreateMessageRoomRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {api.ICreateMessageRoomRequest} message CreateMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMessageRoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateMessageRoomRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateMessageRoomRequest} CreateMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMessageRoomRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateMessageRoomRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateMessageRoomRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateMessageRoomRequest} CreateMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMessageRoomRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateMessageRoomRequest message.
         * @function verify
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateMessageRoomRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a CreateMessageRoomRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateMessageRoomRequest} CreateMessageRoomRequest
         */
        CreateMessageRoomRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateMessageRoomRequest)
                return object;
            var message = new $root.api.CreateMessageRoomRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a CreateMessageRoomRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateMessageRoomRequest
         * @static
         * @param {api.CreateMessageRoomRequest} message CreateMessageRoomRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateMessageRoomRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this CreateMessageRoomRequest to JSON.
         * @function toJSON
         * @memberof api.CreateMessageRoomRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateMessageRoomRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateMessageRoomRequest;
    })();

    api.DeleteMessageRoomRequest = (function() {

        /**
         * Properties of a DeleteMessageRoomRequest.
         * @memberof api
         * @interface IDeleteMessageRoomRequest
         * @property {string|null} [projectID] DeleteMessageRoomRequest projectID
         * @property {string|null} [opponentID] DeleteMessageRoomRequest opponentID
         */

        /**
         * Constructs a new DeleteMessageRoomRequest.
         * @memberof api
         * @classdesc Represents a DeleteMessageRoomRequest.
         * @implements IDeleteMessageRoomRequest
         * @constructor
         * @param {api.IDeleteMessageRoomRequest=} [properties] Properties to set
         */
        function DeleteMessageRoomRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteMessageRoomRequest projectID.
         * @member {string} projectID
         * @memberof api.DeleteMessageRoomRequest
         * @instance
         */
        DeleteMessageRoomRequest.prototype.projectID = "";

        /**
         * DeleteMessageRoomRequest opponentID.
         * @member {string} opponentID
         * @memberof api.DeleteMessageRoomRequest
         * @instance
         */
        DeleteMessageRoomRequest.prototype.opponentID = "";

        /**
         * Creates a new DeleteMessageRoomRequest instance using the specified properties.
         * @function create
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {api.IDeleteMessageRoomRequest=} [properties] Properties to set
         * @returns {api.DeleteMessageRoomRequest} DeleteMessageRoomRequest instance
         */
        DeleteMessageRoomRequest.create = function create(properties) {
            return new DeleteMessageRoomRequest(properties);
        };

        /**
         * Encodes the specified DeleteMessageRoomRequest message. Does not implicitly {@link api.DeleteMessageRoomRequest.verify|verify} messages.
         * @function encode
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {api.IDeleteMessageRoomRequest} message DeleteMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteMessageRoomRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified DeleteMessageRoomRequest message, length delimited. Does not implicitly {@link api.DeleteMessageRoomRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {api.IDeleteMessageRoomRequest} message DeleteMessageRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteMessageRoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteMessageRoomRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.DeleteMessageRoomRequest} DeleteMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteMessageRoomRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.DeleteMessageRoomRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteMessageRoomRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.DeleteMessageRoomRequest} DeleteMessageRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteMessageRoomRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteMessageRoomRequest message.
         * @function verify
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteMessageRoomRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a DeleteMessageRoomRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.DeleteMessageRoomRequest} DeleteMessageRoomRequest
         */
        DeleteMessageRoomRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.DeleteMessageRoomRequest)
                return object;
            var message = new $root.api.DeleteMessageRoomRequest();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a DeleteMessageRoomRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.DeleteMessageRoomRequest
         * @static
         * @param {api.DeleteMessageRoomRequest} message DeleteMessageRoomRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteMessageRoomRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this DeleteMessageRoomRequest to JSON.
         * @function toJSON
         * @memberof api.DeleteMessageRoomRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteMessageRoomRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeleteMessageRoomRequest;
    })();

    api.MessageService = (function() {

        /**
         * Constructs a new MessageService service.
         * @memberof api
         * @classdesc Represents a MessageService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function MessageService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (MessageService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MessageService;

        /**
         * Creates new MessageService service using the specified rpc implementation.
         * @function create
         * @memberof api.MessageService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {MessageService} RPC service. Useful where requests and/or responses are streamed.
         */
        MessageService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.MessageService#getAllByRoom}.
         * @memberof api.MessageService
         * @typedef GetAllByRoomCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MessageList} [response] MessageList
         */

        /**
         * Calls GetAllByRoom.
         * @function getAllByRoom
         * @memberof api.MessageService
         * @instance
         * @param {api.IGetAllMessageByRoomRequest} request GetAllMessageByRoomRequest message or plain object
         * @param {api.MessageService.GetAllByRoomCallback} callback Node-style callback called with the error, if any, and MessageList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageService.prototype.getAllByRoom = function getAllByRoom(request, callback) {
            return this.rpcCall(getAllByRoom, $root.api.GetAllMessageByRoomRequest, $root.entity.MessageList, request, callback);
        }, "name", { value: "GetAllByRoom" });

        /**
         * Calls GetAllByRoom.
         * @function getAllByRoom
         * @memberof api.MessageService
         * @instance
         * @param {api.IGetAllMessageByRoomRequest} request GetAllMessageByRoomRequest message or plain object
         * @returns {Promise<entity.MessageList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MessageService#getAllNewestByRooms}.
         * @memberof api.MessageService
         * @typedef GetAllNewestByRoomsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MessageList} [response] MessageList
         */

        /**
         * Calls GetAllNewestByRooms.
         * @function getAllNewestByRooms
         * @memberof api.MessageService
         * @instance
         * @param {api.IMessageRoomPartialIDList} request MessageRoomPartialIDList message or plain object
         * @param {api.MessageService.GetAllNewestByRoomsCallback} callback Node-style callback called with the error, if any, and MessageList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MessageService.prototype.getAllNewestByRooms = function getAllNewestByRooms(request, callback) {
            return this.rpcCall(getAllNewestByRooms, $root.api.MessageRoomPartialIDList, $root.entity.MessageList, request, callback);
        }, "name", { value: "GetAllNewestByRooms" });

        /**
         * Calls GetAllNewestByRooms.
         * @function getAllNewestByRooms
         * @memberof api.MessageService
         * @instance
         * @param {api.IMessageRoomPartialIDList} request MessageRoomPartialIDList message or plain object
         * @returns {Promise<entity.MessageList>} Promise
         * @variation 2
         */

        return MessageService;
    })();

    api.GetAllMessageByRoomRequest = (function() {

        /**
         * Properties of a GetAllMessageByRoomRequest.
         * @memberof api
         * @interface IGetAllMessageByRoomRequest
         * @property {common.IPager|null} [pager] GetAllMessageByRoomRequest pager
         * @property {string|null} [projectID] GetAllMessageByRoomRequest projectID
         * @property {string|null} [opponentID] GetAllMessageByRoomRequest opponentID
         */

        /**
         * Constructs a new GetAllMessageByRoomRequest.
         * @memberof api
         * @classdesc Represents a GetAllMessageByRoomRequest.
         * @implements IGetAllMessageByRoomRequest
         * @constructor
         * @param {api.IGetAllMessageByRoomRequest=} [properties] Properties to set
         */
        function GetAllMessageByRoomRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAllMessageByRoomRequest pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof api.GetAllMessageByRoomRequest
         * @instance
         */
        GetAllMessageByRoomRequest.prototype.pager = null;

        /**
         * GetAllMessageByRoomRequest projectID.
         * @member {string} projectID
         * @memberof api.GetAllMessageByRoomRequest
         * @instance
         */
        GetAllMessageByRoomRequest.prototype.projectID = "";

        /**
         * GetAllMessageByRoomRequest opponentID.
         * @member {string} opponentID
         * @memberof api.GetAllMessageByRoomRequest
         * @instance
         */
        GetAllMessageByRoomRequest.prototype.opponentID = "";

        /**
         * Creates a new GetAllMessageByRoomRequest instance using the specified properties.
         * @function create
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {api.IGetAllMessageByRoomRequest=} [properties] Properties to set
         * @returns {api.GetAllMessageByRoomRequest} GetAllMessageByRoomRequest instance
         */
        GetAllMessageByRoomRequest.create = function create(properties) {
            return new GetAllMessageByRoomRequest(properties);
        };

        /**
         * Encodes the specified GetAllMessageByRoomRequest message. Does not implicitly {@link api.GetAllMessageByRoomRequest.verify|verify} messages.
         * @function encode
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {api.IGetAllMessageByRoomRequest} message GetAllMessageByRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllMessageByRoomRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified GetAllMessageByRoomRequest message, length delimited. Does not implicitly {@link api.GetAllMessageByRoomRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {api.IGetAllMessageByRoomRequest} message GetAllMessageByRoomRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllMessageByRoomRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAllMessageByRoomRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.GetAllMessageByRoomRequest} GetAllMessageByRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllMessageByRoomRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.GetAllMessageByRoomRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAllMessageByRoomRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.GetAllMessageByRoomRequest} GetAllMessageByRoomRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllMessageByRoomRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAllMessageByRoomRequest message.
         * @function verify
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAllMessageByRoomRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a GetAllMessageByRoomRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.GetAllMessageByRoomRequest} GetAllMessageByRoomRequest
         */
        GetAllMessageByRoomRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.GetAllMessageByRoomRequest)
                return object;
            var message = new $root.api.GetAllMessageByRoomRequest();
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".api.GetAllMessageByRoomRequest.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a GetAllMessageByRoomRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.GetAllMessageByRoomRequest
         * @static
         * @param {api.GetAllMessageByRoomRequest} message GetAllMessageByRoomRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAllMessageByRoomRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pager = null;
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this GetAllMessageByRoomRequest to JSON.
         * @function toJSON
         * @memberof api.GetAllMessageByRoomRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAllMessageByRoomRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetAllMessageByRoomRequest;
    })();

    api.MessageRoomPartialID = (function() {

        /**
         * Properties of a MessageRoomPartialID.
         * @memberof api
         * @interface IMessageRoomPartialID
         * @property {string|null} [projectID] MessageRoomPartialID projectID
         * @property {string|null} [opponentID] MessageRoomPartialID opponentID
         */

        /**
         * Constructs a new MessageRoomPartialID.
         * @memberof api
         * @classdesc Represents a MessageRoomPartialID.
         * @implements IMessageRoomPartialID
         * @constructor
         * @param {api.IMessageRoomPartialID=} [properties] Properties to set
         */
        function MessageRoomPartialID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomPartialID projectID.
         * @member {string} projectID
         * @memberof api.MessageRoomPartialID
         * @instance
         */
        MessageRoomPartialID.prototype.projectID = "";

        /**
         * MessageRoomPartialID opponentID.
         * @member {string} opponentID
         * @memberof api.MessageRoomPartialID
         * @instance
         */
        MessageRoomPartialID.prototype.opponentID = "";

        /**
         * Creates a new MessageRoomPartialID instance using the specified properties.
         * @function create
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {api.IMessageRoomPartialID=} [properties] Properties to set
         * @returns {api.MessageRoomPartialID} MessageRoomPartialID instance
         */
        MessageRoomPartialID.create = function create(properties) {
            return new MessageRoomPartialID(properties);
        };

        /**
         * Encodes the specified MessageRoomPartialID message. Does not implicitly {@link api.MessageRoomPartialID.verify|verify} messages.
         * @function encode
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {api.IMessageRoomPartialID} message MessageRoomPartialID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomPartialID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectID);
            if (message.opponentID != null && Object.hasOwnProperty.call(message, "opponentID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.opponentID);
            return writer;
        };

        /**
         * Encodes the specified MessageRoomPartialID message, length delimited. Does not implicitly {@link api.MessageRoomPartialID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {api.IMessageRoomPartialID} message MessageRoomPartialID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomPartialID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomPartialID message from the specified reader or buffer.
         * @function decode
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.MessageRoomPartialID} MessageRoomPartialID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomPartialID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.MessageRoomPartialID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.projectID = reader.string();
                    break;
                case 2:
                    message.opponentID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomPartialID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.MessageRoomPartialID} MessageRoomPartialID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomPartialID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomPartialID message.
         * @function verify
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomPartialID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                if (!$util.isString(message.opponentID))
                    return "opponentID: string expected";
            return null;
        };

        /**
         * Creates a MessageRoomPartialID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.MessageRoomPartialID} MessageRoomPartialID
         */
        MessageRoomPartialID.fromObject = function fromObject(object) {
            if (object instanceof $root.api.MessageRoomPartialID)
                return object;
            var message = new $root.api.MessageRoomPartialID();
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.opponentID != null)
                message.opponentID = String(object.opponentID);
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomPartialID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.MessageRoomPartialID
         * @static
         * @param {api.MessageRoomPartialID} message MessageRoomPartialID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomPartialID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.projectID = "";
                object.opponentID = "";
            }
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.opponentID != null && message.hasOwnProperty("opponentID"))
                object.opponentID = message.opponentID;
            return object;
        };

        /**
         * Converts this MessageRoomPartialID to JSON.
         * @function toJSON
         * @memberof api.MessageRoomPartialID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomPartialID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomPartialID;
    })();

    api.MessageRoomPartialIDList = (function() {

        /**
         * Properties of a MessageRoomPartialIDList.
         * @memberof api
         * @interface IMessageRoomPartialIDList
         * @property {Array.<api.IMessageRoomPartialID>|null} [ids] MessageRoomPartialIDList ids
         */

        /**
         * Constructs a new MessageRoomPartialIDList.
         * @memberof api
         * @classdesc Represents a MessageRoomPartialIDList.
         * @implements IMessageRoomPartialIDList
         * @constructor
         * @param {api.IMessageRoomPartialIDList=} [properties] Properties to set
         */
        function MessageRoomPartialIDList(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageRoomPartialIDList ids.
         * @member {Array.<api.IMessageRoomPartialID>} ids
         * @memberof api.MessageRoomPartialIDList
         * @instance
         */
        MessageRoomPartialIDList.prototype.ids = $util.emptyArray;

        /**
         * Creates a new MessageRoomPartialIDList instance using the specified properties.
         * @function create
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {api.IMessageRoomPartialIDList=} [properties] Properties to set
         * @returns {api.MessageRoomPartialIDList} MessageRoomPartialIDList instance
         */
        MessageRoomPartialIDList.create = function create(properties) {
            return new MessageRoomPartialIDList(properties);
        };

        /**
         * Encodes the specified MessageRoomPartialIDList message. Does not implicitly {@link api.MessageRoomPartialIDList.verify|verify} messages.
         * @function encode
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {api.IMessageRoomPartialIDList} message MessageRoomPartialIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomPartialIDList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length)
                for (var i = 0; i < message.ids.length; ++i)
                    $root.api.MessageRoomPartialID.encode(message.ids[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MessageRoomPartialIDList message, length delimited. Does not implicitly {@link api.MessageRoomPartialIDList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {api.IMessageRoomPartialIDList} message MessageRoomPartialIDList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageRoomPartialIDList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageRoomPartialIDList message from the specified reader or buffer.
         * @function decode
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.MessageRoomPartialIDList} MessageRoomPartialIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomPartialIDList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.MessageRoomPartialIDList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push($root.api.MessageRoomPartialID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessageRoomPartialIDList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.MessageRoomPartialIDList} MessageRoomPartialIDList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageRoomPartialIDList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageRoomPartialIDList message.
         * @function verify
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageRoomPartialIDList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ids != null && message.hasOwnProperty("ids")) {
                if (!Array.isArray(message.ids))
                    return "ids: array expected";
                for (var i = 0; i < message.ids.length; ++i) {
                    var error = $root.api.MessageRoomPartialID.verify(message.ids[i]);
                    if (error)
                        return "ids." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MessageRoomPartialIDList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.MessageRoomPartialIDList} MessageRoomPartialIDList
         */
        MessageRoomPartialIDList.fromObject = function fromObject(object) {
            if (object instanceof $root.api.MessageRoomPartialIDList)
                return object;
            var message = new $root.api.MessageRoomPartialIDList();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".api.MessageRoomPartialIDList.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i) {
                    if (typeof object.ids[i] !== "object")
                        throw TypeError(".api.MessageRoomPartialIDList.ids: object expected");
                    message.ids[i] = $root.api.MessageRoomPartialID.fromObject(object.ids[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MessageRoomPartialIDList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.MessageRoomPartialIDList
         * @static
         * @param {api.MessageRoomPartialIDList} message MessageRoomPartialIDList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageRoomPartialIDList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = $root.api.MessageRoomPartialID.toObject(message.ids[j], options);
            }
            return object;
        };

        /**
         * Converts this MessageRoomPartialIDList to JSON.
         * @function toJSON
         * @memberof api.MessageRoomPartialIDList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageRoomPartialIDList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageRoomPartialIDList;
    })();

    api.NotificationService = (function() {

        /**
         * Constructs a new NotificationService service.
         * @memberof api
         * @classdesc Represents a NotificationService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function NotificationService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (NotificationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NotificationService;

        /**
         * Creates new NotificationService service using the specified rpc implementation.
         * @function create
         * @memberof api.NotificationService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {NotificationService} RPC service. Useful where requests and/or responses are streamed.
         */
        NotificationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.NotificationService#getAll}.
         * @memberof api.NotificationService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.NotificationList} [response] NotificationList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.NotificationService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.NotificationService.GetAllCallback} callback Node-style callback called with the error, if any, and NotificationList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(NotificationService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.NotificationList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.NotificationService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.NotificationList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.NotificationService#get}.
         * @memberof api.NotificationService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Notification} [response] Notification
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.NotificationService
         * @instance
         * @param {entity.INotificationID} request NotificationID message or plain object
         * @param {api.NotificationService.GetCallback} callback Node-style callback called with the error, if any, and Notification
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(NotificationService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.NotificationID, $root.entity.Notification, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.NotificationService
         * @instance
         * @param {entity.INotificationID} request NotificationID message or plain object
         * @returns {Promise<entity.Notification>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.NotificationService#getCount}.
         * @memberof api.NotificationService
         * @typedef GetCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.NotificationService.GetCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(NotificationService.prototype.getCount = function getCount(request, callback) {
            return this.rpcCall(getCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCount" });

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.NotificationService#getUnReadCount}.
         * @memberof api.NotificationService
         * @typedef GetUnReadCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetUnReadCount.
         * @function getUnReadCount
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.NotificationService.GetUnReadCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(NotificationService.prototype.getUnReadCount = function getUnReadCount(request, callback) {
            return this.rpcCall(getUnReadCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetUnReadCount" });

        /**
         * Calls GetUnReadCount.
         * @function getUnReadCount
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.NotificationService#read}.
         * @memberof api.NotificationService
         * @typedef ReadCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Read.
         * @function read
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.NotificationService.ReadCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(NotificationService.prototype.read = function read(request, callback) {
            return this.rpcCall(read, $root.common.Empty, $root.common.Empty, request, callback);
        }, "name", { value: "Read" });

        /**
         * Calls Read.
         * @function read
         * @memberof api.NotificationService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return NotificationService;
    })();

    api.PartnerStoreEntryService = (function() {

        /**
         * Constructs a new PartnerStoreEntryService service.
         * @memberof api
         * @classdesc Represents a PartnerStoreEntryService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PartnerStoreEntryService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PartnerStoreEntryService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PartnerStoreEntryService;

        /**
         * Creates new PartnerStoreEntryService service using the specified rpc implementation.
         * @function create
         * @memberof api.PartnerStoreEntryService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PartnerStoreEntryService} RPC service. Useful where requests and/or responses are streamed.
         */
        PartnerStoreEntryService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.PartnerStoreEntryService#create}.
         * @memberof api.PartnerStoreEntryService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PartnerStoreEntry} [response] PartnerStoreEntry
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.PartnerStoreEntryService
         * @instance
         * @param {api.ICreatePartnerStoreEntryRequest} request CreatePartnerStoreEntryRequest message or plain object
         * @param {api.PartnerStoreEntryService.CreateCallback} callback Node-style callback called with the error, if any, and PartnerStoreEntry
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PartnerStoreEntryService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreatePartnerStoreEntryRequest, $root.entity.PartnerStoreEntry, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.PartnerStoreEntryService
         * @instance
         * @param {api.ICreatePartnerStoreEntryRequest} request CreatePartnerStoreEntryRequest message or plain object
         * @returns {Promise<entity.PartnerStoreEntry>} Promise
         * @variation 2
         */

        return PartnerStoreEntryService;
    })();

    api.CreatePartnerStoreEntryRequest = (function() {

        /**
         * Properties of a CreatePartnerStoreEntryRequest.
         * @memberof api
         * @interface ICreatePartnerStoreEntryRequest
         * @property {string|null} [partnerID] CreatePartnerStoreEntryRequest partnerID
         * @property {string|null} [customerName] CreatePartnerStoreEntryRequest customerName
         * @property {string|null} [customerEmail] CreatePartnerStoreEntryRequest customerEmail
         * @property {string|null} [customerPhoneNumber] CreatePartnerStoreEntryRequest customerPhoneNumber
         * @property {string|null} [referralCompanyName] CreatePartnerStoreEntryRequest referralCompanyName
         * @property {string|null} [referralCompanyURL] CreatePartnerStoreEntryRequest referralCompanyURL
         * @property {string|null} [referralCompanyAddress] CreatePartnerStoreEntryRequest referralCompanyAddress
         * @property {string|null} [inChargeUserName] CreatePartnerStoreEntryRequest inChargeUserName
         * @property {string|null} [inChargeUserDepartment] CreatePartnerStoreEntryRequest inChargeUserDepartment
         * @property {string|null} [inChargeUserPosition] CreatePartnerStoreEntryRequest inChargeUserPosition
         * @property {string|null} [inChargeUserEmail] CreatePartnerStoreEntryRequest inChargeUserEmail
         * @property {string|null} [inChargeUserPhoneNumber] CreatePartnerStoreEntryRequest inChargeUserPhoneNumber
         * @property {entity.PartnerStoreEntry.DesiredIntroductionPeriod|null} [desiredIntroductionPeriod] CreatePartnerStoreEntryRequest desiredIntroductionPeriod
         */

        /**
         * Constructs a new CreatePartnerStoreEntryRequest.
         * @memberof api
         * @classdesc Represents a CreatePartnerStoreEntryRequest.
         * @implements ICreatePartnerStoreEntryRequest
         * @constructor
         * @param {api.ICreatePartnerStoreEntryRequest=} [properties] Properties to set
         */
        function CreatePartnerStoreEntryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreatePartnerStoreEntryRequest partnerID.
         * @member {string} partnerID
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.partnerID = "";

        /**
         * CreatePartnerStoreEntryRequest customerName.
         * @member {string} customerName
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.customerName = "";

        /**
         * CreatePartnerStoreEntryRequest customerEmail.
         * @member {string} customerEmail
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.customerEmail = "";

        /**
         * CreatePartnerStoreEntryRequest customerPhoneNumber.
         * @member {string} customerPhoneNumber
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.customerPhoneNumber = "";

        /**
         * CreatePartnerStoreEntryRequest referralCompanyName.
         * @member {string} referralCompanyName
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.referralCompanyName = "";

        /**
         * CreatePartnerStoreEntryRequest referralCompanyURL.
         * @member {string} referralCompanyURL
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.referralCompanyURL = "";

        /**
         * CreatePartnerStoreEntryRequest referralCompanyAddress.
         * @member {string} referralCompanyAddress
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.referralCompanyAddress = "";

        /**
         * CreatePartnerStoreEntryRequest inChargeUserName.
         * @member {string} inChargeUserName
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.inChargeUserName = "";

        /**
         * CreatePartnerStoreEntryRequest inChargeUserDepartment.
         * @member {string} inChargeUserDepartment
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.inChargeUserDepartment = "";

        /**
         * CreatePartnerStoreEntryRequest inChargeUserPosition.
         * @member {string} inChargeUserPosition
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.inChargeUserPosition = "";

        /**
         * CreatePartnerStoreEntryRequest inChargeUserEmail.
         * @member {string} inChargeUserEmail
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.inChargeUserEmail = "";

        /**
         * CreatePartnerStoreEntryRequest inChargeUserPhoneNumber.
         * @member {string} inChargeUserPhoneNumber
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.inChargeUserPhoneNumber = "";

        /**
         * CreatePartnerStoreEntryRequest desiredIntroductionPeriod.
         * @member {entity.PartnerStoreEntry.DesiredIntroductionPeriod} desiredIntroductionPeriod
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         */
        CreatePartnerStoreEntryRequest.prototype.desiredIntroductionPeriod = 0;

        /**
         * Creates a new CreatePartnerStoreEntryRequest instance using the specified properties.
         * @function create
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {api.ICreatePartnerStoreEntryRequest=} [properties] Properties to set
         * @returns {api.CreatePartnerStoreEntryRequest} CreatePartnerStoreEntryRequest instance
         */
        CreatePartnerStoreEntryRequest.create = function create(properties) {
            return new CreatePartnerStoreEntryRequest(properties);
        };

        /**
         * Encodes the specified CreatePartnerStoreEntryRequest message. Does not implicitly {@link api.CreatePartnerStoreEntryRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {api.ICreatePartnerStoreEntryRequest} message CreatePartnerStoreEntryRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePartnerStoreEntryRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.partnerID != null && Object.hasOwnProperty.call(message, "partnerID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.partnerID);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerName);
            if (message.customerEmail != null && Object.hasOwnProperty.call(message, "customerEmail"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerEmail);
            if (message.customerPhoneNumber != null && Object.hasOwnProperty.call(message, "customerPhoneNumber"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.customerPhoneNumber);
            if (message.referralCompanyName != null && Object.hasOwnProperty.call(message, "referralCompanyName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.referralCompanyName);
            if (message.referralCompanyURL != null && Object.hasOwnProperty.call(message, "referralCompanyURL"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.referralCompanyURL);
            if (message.referralCompanyAddress != null && Object.hasOwnProperty.call(message, "referralCompanyAddress"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.referralCompanyAddress);
            if (message.inChargeUserName != null && Object.hasOwnProperty.call(message, "inChargeUserName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.inChargeUserName);
            if (message.inChargeUserDepartment != null && Object.hasOwnProperty.call(message, "inChargeUserDepartment"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.inChargeUserDepartment);
            if (message.inChargeUserPosition != null && Object.hasOwnProperty.call(message, "inChargeUserPosition"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.inChargeUserPosition);
            if (message.inChargeUserEmail != null && Object.hasOwnProperty.call(message, "inChargeUserEmail"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.inChargeUserEmail);
            if (message.inChargeUserPhoneNumber != null && Object.hasOwnProperty.call(message, "inChargeUserPhoneNumber"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.inChargeUserPhoneNumber);
            if (message.desiredIntroductionPeriod != null && Object.hasOwnProperty.call(message, "desiredIntroductionPeriod"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.desiredIntroductionPeriod);
            return writer;
        };

        /**
         * Encodes the specified CreatePartnerStoreEntryRequest message, length delimited. Does not implicitly {@link api.CreatePartnerStoreEntryRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {api.ICreatePartnerStoreEntryRequest} message CreatePartnerStoreEntryRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePartnerStoreEntryRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreatePartnerStoreEntryRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreatePartnerStoreEntryRequest} CreatePartnerStoreEntryRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePartnerStoreEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreatePartnerStoreEntryRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.partnerID = reader.string();
                    break;
                case 2:
                    message.customerName = reader.string();
                    break;
                case 3:
                    message.customerEmail = reader.string();
                    break;
                case 4:
                    message.customerPhoneNumber = reader.string();
                    break;
                case 5:
                    message.referralCompanyName = reader.string();
                    break;
                case 6:
                    message.referralCompanyURL = reader.string();
                    break;
                case 7:
                    message.referralCompanyAddress = reader.string();
                    break;
                case 8:
                    message.inChargeUserName = reader.string();
                    break;
                case 9:
                    message.inChargeUserDepartment = reader.string();
                    break;
                case 10:
                    message.inChargeUserPosition = reader.string();
                    break;
                case 11:
                    message.inChargeUserEmail = reader.string();
                    break;
                case 12:
                    message.inChargeUserPhoneNumber = reader.string();
                    break;
                case 13:
                    message.desiredIntroductionPeriod = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreatePartnerStoreEntryRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreatePartnerStoreEntryRequest} CreatePartnerStoreEntryRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePartnerStoreEntryRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreatePartnerStoreEntryRequest message.
         * @function verify
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreatePartnerStoreEntryRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.partnerID != null && message.hasOwnProperty("partnerID"))
                if (!$util.isString(message.partnerID))
                    return "partnerID: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                if (!$util.isString(message.customerEmail))
                    return "customerEmail: string expected";
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                if (!$util.isString(message.customerPhoneNumber))
                    return "customerPhoneNumber: string expected";
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                if (!$util.isString(message.referralCompanyName))
                    return "referralCompanyName: string expected";
            if (message.referralCompanyURL != null && message.hasOwnProperty("referralCompanyURL"))
                if (!$util.isString(message.referralCompanyURL))
                    return "referralCompanyURL: string expected";
            if (message.referralCompanyAddress != null && message.hasOwnProperty("referralCompanyAddress"))
                if (!$util.isString(message.referralCompanyAddress))
                    return "referralCompanyAddress: string expected";
            if (message.inChargeUserName != null && message.hasOwnProperty("inChargeUserName"))
                if (!$util.isString(message.inChargeUserName))
                    return "inChargeUserName: string expected";
            if (message.inChargeUserDepartment != null && message.hasOwnProperty("inChargeUserDepartment"))
                if (!$util.isString(message.inChargeUserDepartment))
                    return "inChargeUserDepartment: string expected";
            if (message.inChargeUserPosition != null && message.hasOwnProperty("inChargeUserPosition"))
                if (!$util.isString(message.inChargeUserPosition))
                    return "inChargeUserPosition: string expected";
            if (message.inChargeUserEmail != null && message.hasOwnProperty("inChargeUserEmail"))
                if (!$util.isString(message.inChargeUserEmail))
                    return "inChargeUserEmail: string expected";
            if (message.inChargeUserPhoneNumber != null && message.hasOwnProperty("inChargeUserPhoneNumber"))
                if (!$util.isString(message.inChargeUserPhoneNumber))
                    return "inChargeUserPhoneNumber: string expected";
            if (message.desiredIntroductionPeriod != null && message.hasOwnProperty("desiredIntroductionPeriod"))
                switch (message.desiredIntroductionPeriod) {
                default:
                    return "desiredIntroductionPeriod: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a CreatePartnerStoreEntryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreatePartnerStoreEntryRequest} CreatePartnerStoreEntryRequest
         */
        CreatePartnerStoreEntryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreatePartnerStoreEntryRequest)
                return object;
            var message = new $root.api.CreatePartnerStoreEntryRequest();
            if (object.partnerID != null)
                message.partnerID = String(object.partnerID);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.customerEmail != null)
                message.customerEmail = String(object.customerEmail);
            if (object.customerPhoneNumber != null)
                message.customerPhoneNumber = String(object.customerPhoneNumber);
            if (object.referralCompanyName != null)
                message.referralCompanyName = String(object.referralCompanyName);
            if (object.referralCompanyURL != null)
                message.referralCompanyURL = String(object.referralCompanyURL);
            if (object.referralCompanyAddress != null)
                message.referralCompanyAddress = String(object.referralCompanyAddress);
            if (object.inChargeUserName != null)
                message.inChargeUserName = String(object.inChargeUserName);
            if (object.inChargeUserDepartment != null)
                message.inChargeUserDepartment = String(object.inChargeUserDepartment);
            if (object.inChargeUserPosition != null)
                message.inChargeUserPosition = String(object.inChargeUserPosition);
            if (object.inChargeUserEmail != null)
                message.inChargeUserEmail = String(object.inChargeUserEmail);
            if (object.inChargeUserPhoneNumber != null)
                message.inChargeUserPhoneNumber = String(object.inChargeUserPhoneNumber);
            switch (object.desiredIntroductionPeriod) {
            case "DesiredIntroductionPeriod_Unknown":
            case 0:
                message.desiredIntroductionPeriod = 0;
                break;
            case "DesiredIntroductionPeriod_1_3_Month":
            case 1:
                message.desiredIntroductionPeriod = 1;
                break;
            case "DesiredIntroductionPeriod_3_6_Month":
            case 2:
                message.desiredIntroductionPeriod = 2;
                break;
            case "DesiredIntroductionPeriod_Over_6_Month":
            case 3:
                message.desiredIntroductionPeriod = 3;
                break;
            case "DesiredIntroductionPeriod_Undecided":
            case 4:
                message.desiredIntroductionPeriod = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CreatePartnerStoreEntryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreatePartnerStoreEntryRequest
         * @static
         * @param {api.CreatePartnerStoreEntryRequest} message CreatePartnerStoreEntryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreatePartnerStoreEntryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.partnerID = "";
                object.customerName = "";
                object.customerEmail = "";
                object.customerPhoneNumber = "";
                object.referralCompanyName = "";
                object.referralCompanyURL = "";
                object.referralCompanyAddress = "";
                object.inChargeUserName = "";
                object.inChargeUserDepartment = "";
                object.inChargeUserPosition = "";
                object.inChargeUserEmail = "";
                object.inChargeUserPhoneNumber = "";
                object.desiredIntroductionPeriod = options.enums === String ? "DesiredIntroductionPeriod_Unknown" : 0;
            }
            if (message.partnerID != null && message.hasOwnProperty("partnerID"))
                object.partnerID = message.partnerID;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                object.customerEmail = message.customerEmail;
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                object.customerPhoneNumber = message.customerPhoneNumber;
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                object.referralCompanyName = message.referralCompanyName;
            if (message.referralCompanyURL != null && message.hasOwnProperty("referralCompanyURL"))
                object.referralCompanyURL = message.referralCompanyURL;
            if (message.referralCompanyAddress != null && message.hasOwnProperty("referralCompanyAddress"))
                object.referralCompanyAddress = message.referralCompanyAddress;
            if (message.inChargeUserName != null && message.hasOwnProperty("inChargeUserName"))
                object.inChargeUserName = message.inChargeUserName;
            if (message.inChargeUserDepartment != null && message.hasOwnProperty("inChargeUserDepartment"))
                object.inChargeUserDepartment = message.inChargeUserDepartment;
            if (message.inChargeUserPosition != null && message.hasOwnProperty("inChargeUserPosition"))
                object.inChargeUserPosition = message.inChargeUserPosition;
            if (message.inChargeUserEmail != null && message.hasOwnProperty("inChargeUserEmail"))
                object.inChargeUserEmail = message.inChargeUserEmail;
            if (message.inChargeUserPhoneNumber != null && message.hasOwnProperty("inChargeUserPhoneNumber"))
                object.inChargeUserPhoneNumber = message.inChargeUserPhoneNumber;
            if (message.desiredIntroductionPeriod != null && message.hasOwnProperty("desiredIntroductionPeriod"))
                object.desiredIntroductionPeriod = options.enums === String ? $root.entity.PartnerStoreEntry.DesiredIntroductionPeriod[message.desiredIntroductionPeriod] : message.desiredIntroductionPeriod;
            return object;
        };

        /**
         * Converts this CreatePartnerStoreEntryRequest to JSON.
         * @function toJSON
         * @memberof api.CreatePartnerStoreEntryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreatePartnerStoreEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreatePartnerStoreEntryRequest;
    })();

    api.PartnerService = (function() {

        /**
         * Constructs a new PartnerService service.
         * @memberof api
         * @classdesc Represents a PartnerService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PartnerService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PartnerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PartnerService;

        /**
         * Creates new PartnerService service using the specified rpc implementation.
         * @function create
         * @memberof api.PartnerService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PartnerService} RPC service. Useful where requests and/or responses are streamed.
         */
        PartnerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.PartnerService#getAll}.
         * @memberof api.PartnerService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PartnerList} [response] PartnerList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.PartnerService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.PartnerService.GetAllCallback} callback Node-style callback called with the error, if any, and PartnerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PartnerService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.PartnerList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.PartnerService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.PartnerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PartnerService#get}.
         * @memberof api.PartnerService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Partner} [response] Partner
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.PartnerService
         * @instance
         * @param {entity.IPartnerID} request PartnerID message or plain object
         * @param {api.PartnerService.GetCallback} callback Node-style callback called with the error, if any, and Partner
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PartnerService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.PartnerID, $root.entity.Partner, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.PartnerService
         * @instance
         * @param {entity.IPartnerID} request PartnerID message or plain object
         * @returns {Promise<entity.Partner>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PartnerService#getCount}.
         * @memberof api.PartnerService
         * @typedef GetCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.PartnerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.PartnerService.GetCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PartnerService.prototype.getCount = function getCount(request, callback) {
            return this.rpcCall(getCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCount" });

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.PartnerService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        return PartnerService;
    })();

    api.PastCaseProjectService = (function() {

        /**
         * Constructs a new PastCaseProjectService service.
         * @memberof api
         * @classdesc Represents a PastCaseProjectService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PastCaseProjectService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PastCaseProjectService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PastCaseProjectService;

        /**
         * Creates new PastCaseProjectService service using the specified rpc implementation.
         * @function create
         * @memberof api.PastCaseProjectService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PastCaseProjectService} RPC service. Useful where requests and/or responses are streamed.
         */
        PastCaseProjectService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.PastCaseProjectService#getAll}.
         * @memberof api.PastCaseProjectService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PastCaseProjectList} [response] PastCaseProjectList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.PastCaseProjectService.GetAllCallback} callback Node-style callback called with the error, if any, and PastCaseProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PastCaseProjectService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Empty, $root.entity.PastCaseProjectList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.PastCaseProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PastCaseProjectService#getAllByCustomer}.
         * @memberof api.PastCaseProjectService
         * @typedef GetAllByCustomerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PastCaseProjectList} [response] PastCaseProjectList
         */

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.PastCaseProjectService.GetAllByCustomerCallback} callback Node-style callback called with the error, if any, and PastCaseProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PastCaseProjectService.prototype.getAllByCustomer = function getAllByCustomer(request, callback) {
            return this.rpcCall(getAllByCustomer, $root.entity.CustomerID, $root.entity.PastCaseProjectList, request, callback);
        }, "name", { value: "GetAllByCustomer" });

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.PastCaseProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PastCaseProjectService#create}.
         * @memberof api.PastCaseProjectService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PastCaseProject} [response] PastCaseProject
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {api.ICreatePastCaseProjectRequest} request CreatePastCaseProjectRequest message or plain object
         * @param {api.PastCaseProjectService.CreateCallback} callback Node-style callback called with the error, if any, and PastCaseProject
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PastCaseProjectService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreatePastCaseProjectRequest, $root.entity.PastCaseProject, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {api.ICreatePastCaseProjectRequest} request CreatePastCaseProjectRequest message or plain object
         * @returns {Promise<entity.PastCaseProject>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PastCaseProjectService#update}.
         * @memberof api.PastCaseProjectService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PastCaseProject} [response] PastCaseProject
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {api.IUpdatePastCaseProjectRequest} request UpdatePastCaseProjectRequest message or plain object
         * @param {api.PastCaseProjectService.UpdateCallback} callback Node-style callback called with the error, if any, and PastCaseProject
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PastCaseProjectService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdatePastCaseProjectRequest, $root.entity.PastCaseProject, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {api.IUpdatePastCaseProjectRequest} request UpdatePastCaseProjectRequest message or plain object
         * @returns {Promise<entity.PastCaseProject>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PastCaseProjectService#delete_}.
         * @memberof api.PastCaseProjectService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {entity.IPastCaseProjectID} request PastCaseProjectID message or plain object
         * @param {api.PastCaseProjectService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PastCaseProjectService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.PastCaseProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.PastCaseProjectService
         * @instance
         * @param {entity.IPastCaseProjectID} request PastCaseProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return PastCaseProjectService;
    })();

    api.CreatePastCaseProjectRequest = (function() {

        /**
         * Properties of a CreatePastCaseProjectRequest.
         * @memberof api
         * @interface ICreatePastCaseProjectRequest
         * @property {string|null} [title] CreatePastCaseProjectRequest title
         * @property {number|null} [meetingNum] CreatePastCaseProjectRequest meetingNum
         * @property {entity.PastCaseProject.Interval|null} [meetingInterval] CreatePastCaseProjectRequest meetingInterval
         * @property {number|null} [meetingMinutes] CreatePastCaseProjectRequest meetingMinutes
         * @property {number|null} [workingHour] CreatePastCaseProjectRequest workingHour
         * @property {entity.PastCaseProject.Interval|null} [workingInterval] CreatePastCaseProjectRequest workingInterval
         * @property {number|null} [feePerMonth] CreatePastCaseProjectRequest feePerMonth
         * @property {entity.PastCaseProject.WorkLocation|null} [workLocation] CreatePastCaseProjectRequest workLocation
         * @property {entity.PastCaseProject.WorkCommunication|null} [workCommunication] CreatePastCaseProjectRequest workCommunication
         * @property {entity.PastCaseProject.WorkDetail|null} [workDetail] CreatePastCaseProjectRequest workDetail
         * @property {string|null} [achievementReward] CreatePastCaseProjectRequest achievementReward
         */

        /**
         * Constructs a new CreatePastCaseProjectRequest.
         * @memberof api
         * @classdesc Represents a CreatePastCaseProjectRequest.
         * @implements ICreatePastCaseProjectRequest
         * @constructor
         * @param {api.ICreatePastCaseProjectRequest=} [properties] Properties to set
         */
        function CreatePastCaseProjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreatePastCaseProjectRequest title.
         * @member {string} title
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.title = "";

        /**
         * CreatePastCaseProjectRequest meetingNum.
         * @member {number} meetingNum
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.meetingNum = 0;

        /**
         * CreatePastCaseProjectRequest meetingInterval.
         * @member {entity.PastCaseProject.Interval} meetingInterval
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.meetingInterval = 0;

        /**
         * CreatePastCaseProjectRequest meetingMinutes.
         * @member {number} meetingMinutes
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.meetingMinutes = 0;

        /**
         * CreatePastCaseProjectRequest workingHour.
         * @member {number} workingHour
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.workingHour = 0;

        /**
         * CreatePastCaseProjectRequest workingInterval.
         * @member {entity.PastCaseProject.Interval} workingInterval
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.workingInterval = 0;

        /**
         * CreatePastCaseProjectRequest feePerMonth.
         * @member {number} feePerMonth
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.feePerMonth = 0;

        /**
         * CreatePastCaseProjectRequest workLocation.
         * @member {entity.PastCaseProject.WorkLocation} workLocation
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.workLocation = 0;

        /**
         * CreatePastCaseProjectRequest workCommunication.
         * @member {entity.PastCaseProject.WorkCommunication} workCommunication
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.workCommunication = 0;

        /**
         * CreatePastCaseProjectRequest workDetail.
         * @member {entity.PastCaseProject.WorkDetail} workDetail
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.workDetail = 0;

        /**
         * CreatePastCaseProjectRequest achievementReward.
         * @member {string} achievementReward
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         */
        CreatePastCaseProjectRequest.prototype.achievementReward = "";

        /**
         * Creates a new CreatePastCaseProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {api.ICreatePastCaseProjectRequest=} [properties] Properties to set
         * @returns {api.CreatePastCaseProjectRequest} CreatePastCaseProjectRequest instance
         */
        CreatePastCaseProjectRequest.create = function create(properties) {
            return new CreatePastCaseProjectRequest(properties);
        };

        /**
         * Encodes the specified CreatePastCaseProjectRequest message. Does not implicitly {@link api.CreatePastCaseProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {api.ICreatePastCaseProjectRequest} message CreatePastCaseProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePastCaseProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.meetingNum != null && Object.hasOwnProperty.call(message, "meetingNum"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.meetingNum);
            if (message.meetingInterval != null && Object.hasOwnProperty.call(message, "meetingInterval"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.meetingInterval);
            if (message.meetingMinutes != null && Object.hasOwnProperty.call(message, "meetingMinutes"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.meetingMinutes);
            if (message.workingHour != null && Object.hasOwnProperty.call(message, "workingHour"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.workingHour);
            if (message.workingInterval != null && Object.hasOwnProperty.call(message, "workingInterval"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.workingInterval);
            if (message.feePerMonth != null && Object.hasOwnProperty.call(message, "feePerMonth"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.feePerMonth);
            if (message.workLocation != null && Object.hasOwnProperty.call(message, "workLocation"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.workLocation);
            if (message.workCommunication != null && Object.hasOwnProperty.call(message, "workCommunication"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workCommunication);
            if (message.workDetail != null && Object.hasOwnProperty.call(message, "workDetail"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workDetail);
            if (message.achievementReward != null && Object.hasOwnProperty.call(message, "achievementReward"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.achievementReward);
            return writer;
        };

        /**
         * Encodes the specified CreatePastCaseProjectRequest message, length delimited. Does not implicitly {@link api.CreatePastCaseProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {api.ICreatePastCaseProjectRequest} message CreatePastCaseProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreatePastCaseProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreatePastCaseProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreatePastCaseProjectRequest} CreatePastCaseProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePastCaseProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreatePastCaseProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.meetingNum = reader.int32();
                    break;
                case 3:
                    message.meetingInterval = reader.int32();
                    break;
                case 4:
                    message.meetingMinutes = reader.int32();
                    break;
                case 5:
                    message.workingHour = reader.int32();
                    break;
                case 6:
                    message.workingInterval = reader.int32();
                    break;
                case 7:
                    message.feePerMonth = reader.int32();
                    break;
                case 8:
                    message.workLocation = reader.int32();
                    break;
                case 9:
                    message.workCommunication = reader.int32();
                    break;
                case 10:
                    message.workDetail = reader.int32();
                    break;
                case 11:
                    message.achievementReward = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreatePastCaseProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreatePastCaseProjectRequest} CreatePastCaseProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreatePastCaseProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreatePastCaseProjectRequest message.
         * @function verify
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreatePastCaseProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                if (!$util.isInteger(message.meetingNum))
                    return "meetingNum: integer expected";
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                switch (message.meetingInterval) {
                default:
                    return "meetingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                if (!$util.isInteger(message.meetingMinutes))
                    return "meetingMinutes: integer expected";
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                if (!$util.isInteger(message.workingHour))
                    return "workingHour: integer expected";
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                switch (message.workingInterval) {
                default:
                    return "workingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                if (!$util.isInteger(message.feePerMonth))
                    return "feePerMonth: integer expected";
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                switch (message.workLocation) {
                default:
                    return "workLocation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                switch (message.workCommunication) {
                default:
                    return "workCommunication: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                switch (message.workDetail) {
                default:
                    return "workDetail: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                if (!$util.isString(message.achievementReward))
                    return "achievementReward: string expected";
            return null;
        };

        /**
         * Creates a CreatePastCaseProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreatePastCaseProjectRequest} CreatePastCaseProjectRequest
         */
        CreatePastCaseProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreatePastCaseProjectRequest)
                return object;
            var message = new $root.api.CreatePastCaseProjectRequest();
            if (object.title != null)
                message.title = String(object.title);
            if (object.meetingNum != null)
                message.meetingNum = object.meetingNum | 0;
            switch (object.meetingInterval) {
            case "Interval_Unknown":
            case 0:
                message.meetingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.meetingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.meetingInterval = 2;
                break;
            }
            if (object.meetingMinutes != null)
                message.meetingMinutes = object.meetingMinutes | 0;
            if (object.workingHour != null)
                message.workingHour = object.workingHour | 0;
            switch (object.workingInterval) {
            case "Interval_Unknown":
            case 0:
                message.workingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.workingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.workingInterval = 2;
                break;
            }
            if (object.feePerMonth != null)
                message.feePerMonth = object.feePerMonth | 0;
            switch (object.workLocation) {
            case "WorkLocation_UnKnown":
            case 0:
                message.workLocation = 0;
                break;
            case "WorkLocation_Remote":
            case 1:
                message.workLocation = 1;
                break;
            case "WorkLocation_Attendance":
            case 2:
                message.workLocation = 2;
                break;
            case "WorkLocation_Both":
            case 3:
                message.workLocation = 3;
                break;
            }
            switch (object.workCommunication) {
            case "WorkCommunication_Unknown":
            case 0:
                message.workCommunication = 0;
                break;
            case "WorkCommunication_Chat":
            case 1:
                message.workCommunication = 1;
                break;
            case "WorkCommunication_Mail":
            case 2:
                message.workCommunication = 2;
                break;
            case "WorkCommunication_Other":
            case 3:
                message.workCommunication = 3;
                break;
            }
            switch (object.workDetail) {
            case "WorkDetail_Unknown":
            case 0:
                message.workDetail = 0;
                break;
            case "WorkDetail_OnlyMtg":
            case 1:
                message.workDetail = 1;
                break;
            case "WorkDetail_Mtg_ActualWorking":
            case 2:
                message.workDetail = 2;
                break;
            }
            if (object.achievementReward != null)
                message.achievementReward = String(object.achievementReward);
            return message;
        };

        /**
         * Creates a plain object from a CreatePastCaseProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreatePastCaseProjectRequest
         * @static
         * @param {api.CreatePastCaseProjectRequest} message CreatePastCaseProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreatePastCaseProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.title = "";
                object.meetingNum = 0;
                object.meetingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.meetingMinutes = 0;
                object.workingHour = 0;
                object.workingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.feePerMonth = 0;
                object.workLocation = options.enums === String ? "WorkLocation_UnKnown" : 0;
                object.workCommunication = options.enums === String ? "WorkCommunication_Unknown" : 0;
                object.workDetail = options.enums === String ? "WorkDetail_Unknown" : 0;
                object.achievementReward = "";
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                object.meetingNum = message.meetingNum;
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                object.meetingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.meetingInterval] : message.meetingInterval;
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                object.meetingMinutes = message.meetingMinutes;
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                object.workingHour = message.workingHour;
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                object.workingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.workingInterval] : message.workingInterval;
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                object.feePerMonth = message.feePerMonth;
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                object.workLocation = options.enums === String ? $root.entity.PastCaseProject.WorkLocation[message.workLocation] : message.workLocation;
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                object.workCommunication = options.enums === String ? $root.entity.PastCaseProject.WorkCommunication[message.workCommunication] : message.workCommunication;
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                object.workDetail = options.enums === String ? $root.entity.PastCaseProject.WorkDetail[message.workDetail] : message.workDetail;
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                object.achievementReward = message.achievementReward;
            return object;
        };

        /**
         * Converts this CreatePastCaseProjectRequest to JSON.
         * @function toJSON
         * @memberof api.CreatePastCaseProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreatePastCaseProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreatePastCaseProjectRequest;
    })();

    api.UpdatePastCaseProjectRequest = (function() {

        /**
         * Properties of an UpdatePastCaseProjectRequest.
         * @memberof api
         * @interface IUpdatePastCaseProjectRequest
         * @property {string|null} [id] UpdatePastCaseProjectRequest id
         * @property {string|null} [title] UpdatePastCaseProjectRequest title
         * @property {number|null} [meetingNum] UpdatePastCaseProjectRequest meetingNum
         * @property {entity.PastCaseProject.Interval|null} [meetingInterval] UpdatePastCaseProjectRequest meetingInterval
         * @property {number|null} [meetingMinutes] UpdatePastCaseProjectRequest meetingMinutes
         * @property {number|null} [workingHour] UpdatePastCaseProjectRequest workingHour
         * @property {entity.PastCaseProject.Interval|null} [workingInterval] UpdatePastCaseProjectRequest workingInterval
         * @property {number|null} [feePerMonth] UpdatePastCaseProjectRequest feePerMonth
         * @property {entity.PastCaseProject.WorkLocation|null} [workLocation] UpdatePastCaseProjectRequest workLocation
         * @property {entity.PastCaseProject.WorkCommunication|null} [workCommunication] UpdatePastCaseProjectRequest workCommunication
         * @property {entity.PastCaseProject.WorkDetail|null} [workDetail] UpdatePastCaseProjectRequest workDetail
         * @property {string|null} [achievementReward] UpdatePastCaseProjectRequest achievementReward
         */

        /**
         * Constructs a new UpdatePastCaseProjectRequest.
         * @memberof api
         * @classdesc Represents an UpdatePastCaseProjectRequest.
         * @implements IUpdatePastCaseProjectRequest
         * @constructor
         * @param {api.IUpdatePastCaseProjectRequest=} [properties] Properties to set
         */
        function UpdatePastCaseProjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePastCaseProjectRequest id.
         * @member {string} id
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.id = "";

        /**
         * UpdatePastCaseProjectRequest title.
         * @member {string} title
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.title = "";

        /**
         * UpdatePastCaseProjectRequest meetingNum.
         * @member {number} meetingNum
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.meetingNum = 0;

        /**
         * UpdatePastCaseProjectRequest meetingInterval.
         * @member {entity.PastCaseProject.Interval} meetingInterval
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.meetingInterval = 0;

        /**
         * UpdatePastCaseProjectRequest meetingMinutes.
         * @member {number} meetingMinutes
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.meetingMinutes = 0;

        /**
         * UpdatePastCaseProjectRequest workingHour.
         * @member {number} workingHour
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.workingHour = 0;

        /**
         * UpdatePastCaseProjectRequest workingInterval.
         * @member {entity.PastCaseProject.Interval} workingInterval
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.workingInterval = 0;

        /**
         * UpdatePastCaseProjectRequest feePerMonth.
         * @member {number} feePerMonth
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.feePerMonth = 0;

        /**
         * UpdatePastCaseProjectRequest workLocation.
         * @member {entity.PastCaseProject.WorkLocation} workLocation
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.workLocation = 0;

        /**
         * UpdatePastCaseProjectRequest workCommunication.
         * @member {entity.PastCaseProject.WorkCommunication} workCommunication
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.workCommunication = 0;

        /**
         * UpdatePastCaseProjectRequest workDetail.
         * @member {entity.PastCaseProject.WorkDetail} workDetail
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.workDetail = 0;

        /**
         * UpdatePastCaseProjectRequest achievementReward.
         * @member {string} achievementReward
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         */
        UpdatePastCaseProjectRequest.prototype.achievementReward = "";

        /**
         * Creates a new UpdatePastCaseProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {api.IUpdatePastCaseProjectRequest=} [properties] Properties to set
         * @returns {api.UpdatePastCaseProjectRequest} UpdatePastCaseProjectRequest instance
         */
        UpdatePastCaseProjectRequest.create = function create(properties) {
            return new UpdatePastCaseProjectRequest(properties);
        };

        /**
         * Encodes the specified UpdatePastCaseProjectRequest message. Does not implicitly {@link api.UpdatePastCaseProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {api.IUpdatePastCaseProjectRequest} message UpdatePastCaseProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePastCaseProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.meetingNum != null && Object.hasOwnProperty.call(message, "meetingNum"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.meetingNum);
            if (message.meetingInterval != null && Object.hasOwnProperty.call(message, "meetingInterval"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.meetingInterval);
            if (message.meetingMinutes != null && Object.hasOwnProperty.call(message, "meetingMinutes"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.meetingMinutes);
            if (message.workingHour != null && Object.hasOwnProperty.call(message, "workingHour"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.workingHour);
            if (message.workingInterval != null && Object.hasOwnProperty.call(message, "workingInterval"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.workingInterval);
            if (message.feePerMonth != null && Object.hasOwnProperty.call(message, "feePerMonth"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.feePerMonth);
            if (message.workLocation != null && Object.hasOwnProperty.call(message, "workLocation"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workLocation);
            if (message.workCommunication != null && Object.hasOwnProperty.call(message, "workCommunication"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workCommunication);
            if (message.workDetail != null && Object.hasOwnProperty.call(message, "workDetail"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.workDetail);
            if (message.achievementReward != null && Object.hasOwnProperty.call(message, "achievementReward"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.achievementReward);
            return writer;
        };

        /**
         * Encodes the specified UpdatePastCaseProjectRequest message, length delimited. Does not implicitly {@link api.UpdatePastCaseProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {api.IUpdatePastCaseProjectRequest} message UpdatePastCaseProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePastCaseProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdatePastCaseProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdatePastCaseProjectRequest} UpdatePastCaseProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePastCaseProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdatePastCaseProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 3:
                    message.meetingNum = reader.int32();
                    break;
                case 4:
                    message.meetingInterval = reader.int32();
                    break;
                case 5:
                    message.meetingMinutes = reader.int32();
                    break;
                case 6:
                    message.workingHour = reader.int32();
                    break;
                case 7:
                    message.workingInterval = reader.int32();
                    break;
                case 8:
                    message.feePerMonth = reader.int32();
                    break;
                case 9:
                    message.workLocation = reader.int32();
                    break;
                case 10:
                    message.workCommunication = reader.int32();
                    break;
                case 11:
                    message.workDetail = reader.int32();
                    break;
                case 12:
                    message.achievementReward = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdatePastCaseProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdatePastCaseProjectRequest} UpdatePastCaseProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePastCaseProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdatePastCaseProjectRequest message.
         * @function verify
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdatePastCaseProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                if (!$util.isInteger(message.meetingNum))
                    return "meetingNum: integer expected";
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                switch (message.meetingInterval) {
                default:
                    return "meetingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                if (!$util.isInteger(message.meetingMinutes))
                    return "meetingMinutes: integer expected";
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                if (!$util.isInteger(message.workingHour))
                    return "workingHour: integer expected";
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                switch (message.workingInterval) {
                default:
                    return "workingInterval: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                if (!$util.isInteger(message.feePerMonth))
                    return "feePerMonth: integer expected";
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                switch (message.workLocation) {
                default:
                    return "workLocation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                switch (message.workCommunication) {
                default:
                    return "workCommunication: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                switch (message.workDetail) {
                default:
                    return "workDetail: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                if (!$util.isString(message.achievementReward))
                    return "achievementReward: string expected";
            return null;
        };

        /**
         * Creates an UpdatePastCaseProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdatePastCaseProjectRequest} UpdatePastCaseProjectRequest
         */
        UpdatePastCaseProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdatePastCaseProjectRequest)
                return object;
            var message = new $root.api.UpdatePastCaseProjectRequest();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.meetingNum != null)
                message.meetingNum = object.meetingNum | 0;
            switch (object.meetingInterval) {
            case "Interval_Unknown":
            case 0:
                message.meetingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.meetingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.meetingInterval = 2;
                break;
            }
            if (object.meetingMinutes != null)
                message.meetingMinutes = object.meetingMinutes | 0;
            if (object.workingHour != null)
                message.workingHour = object.workingHour | 0;
            switch (object.workingInterval) {
            case "Interval_Unknown":
            case 0:
                message.workingInterval = 0;
                break;
            case "Interval_Week":
            case 1:
                message.workingInterval = 1;
                break;
            case "Interval_Month":
            case 2:
                message.workingInterval = 2;
                break;
            }
            if (object.feePerMonth != null)
                message.feePerMonth = object.feePerMonth | 0;
            switch (object.workLocation) {
            case "WorkLocation_UnKnown":
            case 0:
                message.workLocation = 0;
                break;
            case "WorkLocation_Remote":
            case 1:
                message.workLocation = 1;
                break;
            case "WorkLocation_Attendance":
            case 2:
                message.workLocation = 2;
                break;
            case "WorkLocation_Both":
            case 3:
                message.workLocation = 3;
                break;
            }
            switch (object.workCommunication) {
            case "WorkCommunication_Unknown":
            case 0:
                message.workCommunication = 0;
                break;
            case "WorkCommunication_Chat":
            case 1:
                message.workCommunication = 1;
                break;
            case "WorkCommunication_Mail":
            case 2:
                message.workCommunication = 2;
                break;
            case "WorkCommunication_Other":
            case 3:
                message.workCommunication = 3;
                break;
            }
            switch (object.workDetail) {
            case "WorkDetail_Unknown":
            case 0:
                message.workDetail = 0;
                break;
            case "WorkDetail_OnlyMtg":
            case 1:
                message.workDetail = 1;
                break;
            case "WorkDetail_Mtg_ActualWorking":
            case 2:
                message.workDetail = 2;
                break;
            }
            if (object.achievementReward != null)
                message.achievementReward = String(object.achievementReward);
            return message;
        };

        /**
         * Creates a plain object from an UpdatePastCaseProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdatePastCaseProjectRequest
         * @static
         * @param {api.UpdatePastCaseProjectRequest} message UpdatePastCaseProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePastCaseProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.meetingNum = 0;
                object.meetingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.meetingMinutes = 0;
                object.workingHour = 0;
                object.workingInterval = options.enums === String ? "Interval_Unknown" : 0;
                object.feePerMonth = 0;
                object.workLocation = options.enums === String ? "WorkLocation_UnKnown" : 0;
                object.workCommunication = options.enums === String ? "WorkCommunication_Unknown" : 0;
                object.workDetail = options.enums === String ? "WorkDetail_Unknown" : 0;
                object.achievementReward = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.meetingNum != null && message.hasOwnProperty("meetingNum"))
                object.meetingNum = message.meetingNum;
            if (message.meetingInterval != null && message.hasOwnProperty("meetingInterval"))
                object.meetingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.meetingInterval] : message.meetingInterval;
            if (message.meetingMinutes != null && message.hasOwnProperty("meetingMinutes"))
                object.meetingMinutes = message.meetingMinutes;
            if (message.workingHour != null && message.hasOwnProperty("workingHour"))
                object.workingHour = message.workingHour;
            if (message.workingInterval != null && message.hasOwnProperty("workingInterval"))
                object.workingInterval = options.enums === String ? $root.entity.PastCaseProject.Interval[message.workingInterval] : message.workingInterval;
            if (message.feePerMonth != null && message.hasOwnProperty("feePerMonth"))
                object.feePerMonth = message.feePerMonth;
            if (message.workLocation != null && message.hasOwnProperty("workLocation"))
                object.workLocation = options.enums === String ? $root.entity.PastCaseProject.WorkLocation[message.workLocation] : message.workLocation;
            if (message.workCommunication != null && message.hasOwnProperty("workCommunication"))
                object.workCommunication = options.enums === String ? $root.entity.PastCaseProject.WorkCommunication[message.workCommunication] : message.workCommunication;
            if (message.workDetail != null && message.hasOwnProperty("workDetail"))
                object.workDetail = options.enums === String ? $root.entity.PastCaseProject.WorkDetail[message.workDetail] : message.workDetail;
            if (message.achievementReward != null && message.hasOwnProperty("achievementReward"))
                object.achievementReward = message.achievementReward;
            return object;
        };

        /**
         * Converts this UpdatePastCaseProjectRequest to JSON.
         * @function toJSON
         * @memberof api.UpdatePastCaseProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePastCaseProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdatePastCaseProjectRequest;
    })();

    api.ProjectService = (function() {

        /**
         * Constructs a new ProjectService service.
         * @memberof api
         * @classdesc Represents a ProjectService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ProjectService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ProjectService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ProjectService;

        /**
         * Creates new ProjectService service using the specified rpc implementation.
         * @function create
         * @memberof api.ProjectService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ProjectService} RPC service. Useful where requests and/or responses are streamed.
         */
        ProjectService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ProjectService#getAll}.
         * @memberof api.ProjectService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ProjectService.GetAllCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllByIDs}.
         * @memberof api.ProjectService
         * @typedef GetAllByIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectIDList} request ProjectIDList message or plain object
         * @param {api.ProjectService.GetAllByIDsCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllByIDs = function getAllByIDs(request, callback) {
            return this.rpcCall(getAllByIDs, $root.entity.ProjectIDList, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllByIDs" });

        /**
         * Calls GetAllByIDs.
         * @function getAllByIDs
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectIDList} request ProjectIDList message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllByNewlyArrived}.
         * @memberof api.ProjectService
         * @typedef GetAllByNewlyArrivedCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllByNewlyArrived.
         * @function getAllByNewlyArrived
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ProjectService.GetAllByNewlyArrivedCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllByNewlyArrived = function getAllByNewlyArrived(request, callback) {
            return this.rpcCall(getAllByNewlyArrived, $root.common.Pager, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllByNewlyArrived" });

        /**
         * Calls GetAllByNewlyArrived.
         * @function getAllByNewlyArrived
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllByRecommend}.
         * @memberof api.ProjectService
         * @typedef GetAllByRecommendCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllByRecommend.
         * @function getAllByRecommend
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ProjectService.GetAllByRecommendCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllByRecommend = function getAllByRecommend(request, callback) {
            return this.rpcCall(getAllByRecommend, $root.common.Empty, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllByRecommend" });

        /**
         * Calls GetAllByRecommend.
         * @function getAllByRecommend
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllBySearch}.
         * @memberof api.ProjectService
         * @typedef GetAllBySearchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllBySearch.
         * @function getAllBySearch
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISearchProjectRequest} request SearchProjectRequest message or plain object
         * @param {api.ProjectService.GetAllBySearchCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllBySearch = function getAllBySearch(request, callback) {
            return this.rpcCall(getAllBySearch, $root.api.SearchProjectRequest, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllBySearch" });

        /**
         * Calls GetAllBySearch.
         * @function getAllBySearch
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISearchProjectRequest} request SearchProjectRequest message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllExcludeAlreadyEntry}.
         * @memberof api.ProjectService
         * @typedef GetAllExcludeAlreadyEntryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllExcludeAlreadyEntry.
         * @function getAllExcludeAlreadyEntry
         * @memberof api.ProjectService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.ProjectService.GetAllExcludeAlreadyEntryCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllExcludeAlreadyEntry = function getAllExcludeAlreadyEntry(request, callback) {
            return this.rpcCall(getAllExcludeAlreadyEntry, $root.entity.CustomerID, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllExcludeAlreadyEntry" });

        /**
         * Calls GetAllExcludeAlreadyEntry.
         * @function getAllExcludeAlreadyEntry
         * @memberof api.ProjectService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllByEntry}.
         * @memberof api.ProjectService
         * @typedef GetAllByEntryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllByEntry.
         * @function getAllByEntry
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ProjectService.GetAllByEntryCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllByEntry = function getAllByEntry(request, callback) {
            return this.rpcCall(getAllByEntry, $root.common.Pager, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllByEntry" });

        /**
         * Calls GetAllByEntry.
         * @function getAllByEntry
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getAllByEntryNumOrder}.
         * @memberof api.ProjectService
         * @typedef GetAllByEntryNumOrderCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ProjectList} [response] ProjectList
         */

        /**
         * Calls GetAllByEntryNumOrder.
         * @function getAllByEntryNumOrder
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.ProjectService.GetAllByEntryNumOrderCallback} callback Node-style callback called with the error, if any, and ProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getAllByEntryNumOrder = function getAllByEntryNumOrder(request, callback) {
            return this.rpcCall(getAllByEntryNumOrder, $root.common.Pager, $root.entity.ProjectList, request, callback);
        }, "name", { value: "GetAllByEntryNumOrder" });

        /**
         * Calls GetAllByEntryNumOrder.
         * @function getAllByEntryNumOrder
         * @memberof api.ProjectService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.ProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#get}.
         * @memberof api.ProjectService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Project} [response] Project
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.GetCallback} callback Node-style callback called with the error, if any, and Project
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.ProjectID, $root.entity.Project, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<entity.Project>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getCount}.
         * @memberof api.ProjectService
         * @typedef GetCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ProjectService.GetCountCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getCount = function getCount(request, callback) {
            return this.rpcCall(getCount, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCount" });

        /**
         * Calls GetCount.
         * @function getCount
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getCountByNewlyArrived}.
         * @memberof api.ProjectService
         * @typedef GetCountByNewlyArrivedCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountByNewlyArrived.
         * @function getCountByNewlyArrived
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ProjectService.GetCountByNewlyArrivedCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getCountByNewlyArrived = function getCountByNewlyArrived(request, callback) {
            return this.rpcCall(getCountByNewlyArrived, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCountByNewlyArrived" });

        /**
         * Calls GetCountByNewlyArrived.
         * @function getCountByNewlyArrived
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getCountBySearch}.
         * @memberof api.ProjectService
         * @typedef GetCountBySearchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountBySearch.
         * @function getCountBySearch
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISearchProjectCountRequest} request SearchProjectCountRequest message or plain object
         * @param {api.ProjectService.GetCountBySearchCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getCountBySearch = function getCountBySearch(request, callback) {
            return this.rpcCall(getCountBySearch, $root.api.SearchProjectCountRequest, $root.common.Count, request, callback);
        }, "name", { value: "GetCountBySearch" });

        /**
         * Calls GetCountBySearch.
         * @function getCountBySearch
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISearchProjectCountRequest} request SearchProjectCountRequest message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#getCountByEntry}.
         * @memberof api.ProjectService
         * @typedef GetCountByEntryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Count} [response] Count
         */

        /**
         * Calls GetCountByEntry.
         * @function getCountByEntry
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.ProjectService.GetCountByEntryCallback} callback Node-style callback called with the error, if any, and Count
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.getCountByEntry = function getCountByEntry(request, callback) {
            return this.rpcCall(getCountByEntry, $root.common.Empty, $root.common.Count, request, callback);
        }, "name", { value: "GetCountByEntry" });

        /**
         * Calls GetCountByEntry.
         * @function getCountByEntry
         * @memberof api.ProjectService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<common.Count>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#create}.
         * @memberof api.ProjectService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Project} [response] Project
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ProjectService
         * @instance
         * @param {api.ICreateProjectRequest} request CreateProjectRequest message or plain object
         * @param {api.ProjectService.CreateCallback} callback Node-style callback called with the error, if any, and Project
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateProjectRequest, $root.entity.Project, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ProjectService
         * @instance
         * @param {api.ICreateProjectRequest} request CreateProjectRequest message or plain object
         * @returns {Promise<entity.Project>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#update}.
         * @memberof api.ProjectService
         * @typedef UpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Project} [response] Project
         */

        /**
         * Calls Update.
         * @function update
         * @memberof api.ProjectService
         * @instance
         * @param {api.IUpdateProjectRequest} request UpdateProjectRequest message or plain object
         * @param {api.ProjectService.UpdateCallback} callback Node-style callback called with the error, if any, and Project
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.update = function update(request, callback) {
            return this.rpcCall(update, $root.api.UpdateProjectRequest, $root.entity.Project, request, callback);
        }, "name", { value: "Update" });

        /**
         * Calls Update.
         * @function update
         * @memberof api.ProjectService
         * @instance
         * @param {api.IUpdateProjectRequest} request UpdateProjectRequest message or plain object
         * @returns {Promise<entity.Project>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#draft}.
         * @memberof api.ProjectService
         * @typedef DraftCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Draft.
         * @function draft
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.DraftCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.draft = function draft(request, callback) {
            return this.rpcCall(draft, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Draft" });

        /**
         * Calls Draft.
         * @function draft
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#open}.
         * @memberof api.ProjectService
         * @typedef OpenCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Open.
         * @function open
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.OpenCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.open = function open(request, callback) {
            return this.rpcCall(open, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Open" });

        /**
         * Calls Open.
         * @function open
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#onlyScout}.
         * @memberof api.ProjectService
         * @typedef OnlyScoutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls OnlyScout.
         * @function onlyScout
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.OnlyScoutCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.onlyScout = function onlyScout(request, callback) {
            return this.rpcCall(onlyScout, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "OnlyScout" });

        /**
         * Calls OnlyScout.
         * @function onlyScout
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#close}.
         * @memberof api.ProjectService
         * @typedef CloseCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Close.
         * @function close
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.CloseCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.close = function close(request, callback) {
            return this.rpcCall(close, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Close" });

        /**
         * Calls Close.
         * @function close
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#delete_}.
         * @memberof api.ProjectService
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.entity.ProjectID, $root.common.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#generateProjectInfo}.
         * @memberof api.ProjectService
         * @typedef GenerateProjectInfoCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {api.GenerateProjectInfoResponse} [response] GenerateProjectInfoResponse
         */

        /**
         * Calls GenerateProjectInfo.
         * @function generateProjectInfo
         * @memberof api.ProjectService
         * @instance
         * @param {api.IGenerateProjectInfoRequest} request GenerateProjectInfoRequest message or plain object
         * @param {api.ProjectService.GenerateProjectInfoCallback} callback Node-style callback called with the error, if any, and GenerateProjectInfoResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.generateProjectInfo = function generateProjectInfo(request, callback) {
            return this.rpcCall(generateProjectInfo, $root.api.GenerateProjectInfoRequest, $root.api.GenerateProjectInfoResponse, request, callback);
        }, "name", { value: "GenerateProjectInfo" });

        /**
         * Calls GenerateProjectInfo.
         * @function generateProjectInfo
         * @memberof api.ProjectService
         * @instance
         * @param {api.IGenerateProjectInfoRequest} request GenerateProjectInfoRequest message or plain object
         * @returns {Promise<api.GenerateProjectInfoResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#copy}.
         * @memberof api.ProjectService
         * @typedef CopyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.Project} [response] Project
         */

        /**
         * Calls Copy.
         * @function copy
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @param {api.ProjectService.CopyCallback} callback Node-style callback called with the error, if any, and Project
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.copy = function copy(request, callback) {
            return this.rpcCall(copy, $root.entity.ProjectID, $root.entity.Project, request, callback);
        }, "name", { value: "Copy" });

        /**
         * Calls Copy.
         * @function copy
         * @memberof api.ProjectService
         * @instance
         * @param {entity.IProjectID} request ProjectID message or plain object
         * @returns {Promise<entity.Project>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.ProjectService#sharing}.
         * @memberof api.ProjectService
         * @typedef SharingCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.Empty} [response] Empty
         */

        /**
         * Calls Sharing.
         * @function sharing
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISharingProjectRequest} request SharingProjectRequest message or plain object
         * @param {api.ProjectService.SharingCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ProjectService.prototype.sharing = function sharing(request, callback) {
            return this.rpcCall(sharing, $root.api.SharingProjectRequest, $root.common.Empty, request, callback);
        }, "name", { value: "Sharing" });

        /**
         * Calls Sharing.
         * @function sharing
         * @memberof api.ProjectService
         * @instance
         * @param {api.ISharingProjectRequest} request SharingProjectRequest message or plain object
         * @returns {Promise<common.Empty>} Promise
         * @variation 2
         */

        return ProjectService;
    })();

    api.SearchProjectRequest = (function() {

        /**
         * Properties of a SearchProjectRequest.
         * @memberof api
         * @interface ISearchProjectRequest
         * @property {common.IPager|null} [pager] SearchProjectRequest pager
         * @property {string|null} [q] SearchProjectRequest q
         * @property {entity.Project.Occupation|null} [occupation] SearchProjectRequest occupation
         * @property {entity.Project.WorkingHourRange|null} [workingHourRange] SearchProjectRequest workingHourRange
         * @property {entity.Project.PaymentRange|null} [paymentRange] SearchProjectRequest paymentRange
         * @property {entity.Project.WorkingDuration|null} [workingDuration] SearchProjectRequest workingDuration
         * @property {string|null} [operatingDate] SearchProjectRequest operatingDate
         */

        /**
         * Constructs a new SearchProjectRequest.
         * @memberof api
         * @classdesc Represents a SearchProjectRequest.
         * @implements ISearchProjectRequest
         * @constructor
         * @param {api.ISearchProjectRequest=} [properties] Properties to set
         */
        function SearchProjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchProjectRequest pager.
         * @member {common.IPager|null|undefined} pager
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.pager = null;

        /**
         * SearchProjectRequest q.
         * @member {string} q
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.q = "";

        /**
         * SearchProjectRequest occupation.
         * @member {entity.Project.Occupation} occupation
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.occupation = 0;

        /**
         * SearchProjectRequest workingHourRange.
         * @member {entity.Project.WorkingHourRange} workingHourRange
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.workingHourRange = 0;

        /**
         * SearchProjectRequest paymentRange.
         * @member {entity.Project.PaymentRange} paymentRange
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.paymentRange = 0;

        /**
         * SearchProjectRequest workingDuration.
         * @member {entity.Project.WorkingDuration} workingDuration
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.workingDuration = 0;

        /**
         * SearchProjectRequest operatingDate.
         * @member {string} operatingDate
         * @memberof api.SearchProjectRequest
         * @instance
         */
        SearchProjectRequest.prototype.operatingDate = "";

        /**
         * Creates a new SearchProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.SearchProjectRequest
         * @static
         * @param {api.ISearchProjectRequest=} [properties] Properties to set
         * @returns {api.SearchProjectRequest} SearchProjectRequest instance
         */
        SearchProjectRequest.create = function create(properties) {
            return new SearchProjectRequest(properties);
        };

        /**
         * Encodes the specified SearchProjectRequest message. Does not implicitly {@link api.SearchProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SearchProjectRequest
         * @static
         * @param {api.ISearchProjectRequest} message SearchProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pager != null && Object.hasOwnProperty.call(message, "pager"))
                $root.common.Pager.encode(message.pager, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.q != null && Object.hasOwnProperty.call(message, "q"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.q);
            if (message.occupation != null && Object.hasOwnProperty.call(message, "occupation"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.occupation);
            if (message.workingHourRange != null && Object.hasOwnProperty.call(message, "workingHourRange"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.workingHourRange);
            if (message.paymentRange != null && Object.hasOwnProperty.call(message, "paymentRange"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.paymentRange);
            if (message.workingDuration != null && Object.hasOwnProperty.call(message, "workingDuration"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.workingDuration);
            if (message.operatingDate != null && Object.hasOwnProperty.call(message, "operatingDate"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.operatingDate);
            return writer;
        };

        /**
         * Encodes the specified SearchProjectRequest message, length delimited. Does not implicitly {@link api.SearchProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SearchProjectRequest
         * @static
         * @param {api.ISearchProjectRequest} message SearchProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SearchProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SearchProjectRequest} SearchProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SearchProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pager = $root.common.Pager.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.q = reader.string();
                    break;
                case 3:
                    message.occupation = reader.int32();
                    break;
                case 4:
                    message.workingHourRange = reader.int32();
                    break;
                case 5:
                    message.paymentRange = reader.int32();
                    break;
                case 6:
                    message.workingDuration = reader.int32();
                    break;
                case 7:
                    message.operatingDate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SearchProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SearchProjectRequest} SearchProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchProjectRequest message.
         * @function verify
         * @memberof api.SearchProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pager != null && message.hasOwnProperty("pager")) {
                var error = $root.common.Pager.verify(message.pager);
                if (error)
                    return "pager." + error;
            }
            if (message.q != null && message.hasOwnProperty("q"))
                if (!$util.isString(message.q))
                    return "q: string expected";
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                switch (message.occupation) {
                default:
                    return "occupation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                    break;
                }
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                switch (message.workingHourRange) {
                default:
                    return "workingHourRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                switch (message.paymentRange) {
                default:
                    return "paymentRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                switch (message.workingDuration) {
                default:
                    return "workingDuration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                if (!$util.isString(message.operatingDate))
                    return "operatingDate: string expected";
            return null;
        };

        /**
         * Creates a SearchProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SearchProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SearchProjectRequest} SearchProjectRequest
         */
        SearchProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SearchProjectRequest)
                return object;
            var message = new $root.api.SearchProjectRequest();
            if (object.pager != null) {
                if (typeof object.pager !== "object")
                    throw TypeError(".api.SearchProjectRequest.pager: object expected");
                message.pager = $root.common.Pager.fromObject(object.pager);
            }
            if (object.q != null)
                message.q = String(object.q);
            switch (object.occupation) {
            case "Occupation_Unknown":
            case 0:
                message.occupation = 0;
                break;
            case "Occupation_CorporateBusinessPlanning":
            case 1:
                message.occupation = 1;
                break;
            case "Occupation_BusinessDevelopment":
            case 2:
                message.occupation = 2;
                break;
            case "Occupation_Sales":
            case 3:
                message.occupation = 3;
                break;
            case "Occupation_PublicRelations":
            case 4:
                message.occupation = 4;
                break;
            case "Occupation_IPO":
            case 5:
                message.occupation = 5;
                break;
            case "Occupation_WebMarketing":
            case 6:
                message.occupation = 6;
                break;
            case "Occupation_HumanResource":
            case 7:
                message.occupation = 7;
                break;
            case "Occupation_HumanResource_Deprecate_1":
            case 8:
                message.occupation = 8;
                break;
            case "Occupation_HumanResource_Deprecate_2":
            case 9:
                message.occupation = 9;
                break;
            case "Occupation_HumanResource_Deprecate_3":
            case 10:
                message.occupation = 10;
                break;
            case "Occupation_IPO_Deprecate_1":
            case 11:
                message.occupation = 11;
                break;
            case "Occupation_Finance":
            case 12:
                message.occupation = 12;
                break;
            case "Occupation_Finance_Deprecate_1":
            case 13:
                message.occupation = 13;
                break;
            case "Occupation_Finance_Deprecate_2":
            case 14:
                message.occupation = 14;
                break;
            case "Occupation_MinistryOfJustice":
            case 15:
                message.occupation = 15;
                break;
            case "Occupation_Engineer":
            case 16:
                message.occupation = 16;
                break;
            case "Occupation_Designer":
            case 17:
                message.occupation = 17;
                break;
            case "Occupation_Other":
            case 18:
                message.occupation = 18;
                break;
            case "Occupation_InformationSystem":
            case 19:
                message.occupation = 19;
                break;
            case "Occupation_Professor":
            case 20:
                message.occupation = 20;
                break;
            case "Occupation_Marketing":
            case 21:
                message.occupation = 21;
                break;
            }
            switch (object.workingHourRange) {
            case "WorkingHourRange_Unknown":
            case 0:
                message.workingHourRange = 0;
                break;
            case "WorkingHourRange_20_40_Hour":
            case 1:
                message.workingHourRange = 1;
                break;
            case "WorkingHourRange_40_80_Hour":
            case 2:
                message.workingHourRange = 2;
                break;
            case "WorkingHourRange_80_120_Hour":
            case 3:
                message.workingHourRange = 3;
                break;
            case "WorkingHourRange_Over_120_Hour":
            case 4:
                message.workingHourRange = 4;
                break;
            case "WorkingHourRange_Other":
            case 5:
                message.workingHourRange = 5;
                break;
            }
            switch (object.paymentRange) {
            case "PaymentRange_Unknown":
            case 0:
                message.paymentRange = 0;
                break;
            case "PaymentRange_Under_100000_Yen":
            case 1:
                message.paymentRange = 1;
                break;
            case "PaymentRange_100000_300000_Yen":
            case 2:
                message.paymentRange = 2;
                break;
            case "PaymentRange_300000_500000_Yen":
            case 3:
                message.paymentRange = 3;
                break;
            case "PaymentRange_500000_1000000_Yen":
            case 4:
                message.paymentRange = 4;
                break;
            case "PaymentRange_Over_1000000_Yen":
            case 5:
                message.paymentRange = 5;
                break;
            }
            switch (object.workingDuration) {
            case "WorkingDuration_Unknown":
            case 0:
                message.workingDuration = 0;
                break;
            case "WorkingDuration_Under_1_Month":
            case 1:
                message.workingDuration = 1;
                break;
            case "WorkingDuration_1_3_Month":
            case 2:
                message.workingDuration = 2;
                break;
            case "WorkingDuration_3_6_Month":
            case 3:
                message.workingDuration = 3;
                break;
            case "WorkingDuration_6_12_Month":
            case 4:
                message.workingDuration = 4;
                break;
            case "WorkingDuration_Over_12_Month":
            case 5:
                message.workingDuration = 5;
                break;
            }
            if (object.operatingDate != null)
                message.operatingDate = String(object.operatingDate);
            return message;
        };

        /**
         * Creates a plain object from a SearchProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SearchProjectRequest
         * @static
         * @param {api.SearchProjectRequest} message SearchProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pager = null;
                object.q = "";
                object.occupation = options.enums === String ? "Occupation_Unknown" : 0;
                object.workingHourRange = options.enums === String ? "WorkingHourRange_Unknown" : 0;
                object.paymentRange = options.enums === String ? "PaymentRange_Unknown" : 0;
                object.workingDuration = options.enums === String ? "WorkingDuration_Unknown" : 0;
                object.operatingDate = "";
            }
            if (message.pager != null && message.hasOwnProperty("pager"))
                object.pager = $root.common.Pager.toObject(message.pager, options);
            if (message.q != null && message.hasOwnProperty("q"))
                object.q = message.q;
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                object.occupation = options.enums === String ? $root.entity.Project.Occupation[message.occupation] : message.occupation;
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                object.workingHourRange = options.enums === String ? $root.entity.Project.WorkingHourRange[message.workingHourRange] : message.workingHourRange;
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                object.paymentRange = options.enums === String ? $root.entity.Project.PaymentRange[message.paymentRange] : message.paymentRange;
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                object.workingDuration = options.enums === String ? $root.entity.Project.WorkingDuration[message.workingDuration] : message.workingDuration;
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                object.operatingDate = message.operatingDate;
            return object;
        };

        /**
         * Converts this SearchProjectRequest to JSON.
         * @function toJSON
         * @memberof api.SearchProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchProjectRequest;
    })();

    api.SearchProjectCountRequest = (function() {

        /**
         * Properties of a SearchProjectCountRequest.
         * @memberof api
         * @interface ISearchProjectCountRequest
         * @property {string|null} [q] SearchProjectCountRequest q
         * @property {entity.Project.Occupation|null} [occupation] SearchProjectCountRequest occupation
         * @property {entity.Project.WorkingHourRange|null} [workingHourRange] SearchProjectCountRequest workingHourRange
         * @property {entity.Project.PaymentRange|null} [paymentRange] SearchProjectCountRequest paymentRange
         * @property {entity.Project.WorkingDuration|null} [workingDuration] SearchProjectCountRequest workingDuration
         * @property {string|null} [operatingDate] SearchProjectCountRequest operatingDate
         */

        /**
         * Constructs a new SearchProjectCountRequest.
         * @memberof api
         * @classdesc Represents a SearchProjectCountRequest.
         * @implements ISearchProjectCountRequest
         * @constructor
         * @param {api.ISearchProjectCountRequest=} [properties] Properties to set
         */
        function SearchProjectCountRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SearchProjectCountRequest q.
         * @member {string} q
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.q = "";

        /**
         * SearchProjectCountRequest occupation.
         * @member {entity.Project.Occupation} occupation
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.occupation = 0;

        /**
         * SearchProjectCountRequest workingHourRange.
         * @member {entity.Project.WorkingHourRange} workingHourRange
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.workingHourRange = 0;

        /**
         * SearchProjectCountRequest paymentRange.
         * @member {entity.Project.PaymentRange} paymentRange
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.paymentRange = 0;

        /**
         * SearchProjectCountRequest workingDuration.
         * @member {entity.Project.WorkingDuration} workingDuration
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.workingDuration = 0;

        /**
         * SearchProjectCountRequest operatingDate.
         * @member {string} operatingDate
         * @memberof api.SearchProjectCountRequest
         * @instance
         */
        SearchProjectCountRequest.prototype.operatingDate = "";

        /**
         * Creates a new SearchProjectCountRequest instance using the specified properties.
         * @function create
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {api.ISearchProjectCountRequest=} [properties] Properties to set
         * @returns {api.SearchProjectCountRequest} SearchProjectCountRequest instance
         */
        SearchProjectCountRequest.create = function create(properties) {
            return new SearchProjectCountRequest(properties);
        };

        /**
         * Encodes the specified SearchProjectCountRequest message. Does not implicitly {@link api.SearchProjectCountRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {api.ISearchProjectCountRequest} message SearchProjectCountRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchProjectCountRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.q != null && Object.hasOwnProperty.call(message, "q"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.q);
            if (message.occupation != null && Object.hasOwnProperty.call(message, "occupation"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.occupation);
            if (message.workingHourRange != null && Object.hasOwnProperty.call(message, "workingHourRange"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.workingHourRange);
            if (message.paymentRange != null && Object.hasOwnProperty.call(message, "paymentRange"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paymentRange);
            if (message.workingDuration != null && Object.hasOwnProperty.call(message, "workingDuration"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.workingDuration);
            if (message.operatingDate != null && Object.hasOwnProperty.call(message, "operatingDate"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.operatingDate);
            return writer;
        };

        /**
         * Encodes the specified SearchProjectCountRequest message, length delimited. Does not implicitly {@link api.SearchProjectCountRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {api.ISearchProjectCountRequest} message SearchProjectCountRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchProjectCountRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchProjectCountRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SearchProjectCountRequest} SearchProjectCountRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchProjectCountRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SearchProjectCountRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.q = reader.string();
                    break;
                case 2:
                    message.occupation = reader.int32();
                    break;
                case 3:
                    message.workingHourRange = reader.int32();
                    break;
                case 4:
                    message.paymentRange = reader.int32();
                    break;
                case 5:
                    message.workingDuration = reader.int32();
                    break;
                case 6:
                    message.operatingDate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchProjectCountRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SearchProjectCountRequest} SearchProjectCountRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchProjectCountRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchProjectCountRequest message.
         * @function verify
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchProjectCountRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.q != null && message.hasOwnProperty("q"))
                if (!$util.isString(message.q))
                    return "q: string expected";
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                switch (message.occupation) {
                default:
                    return "occupation: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                    break;
                }
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                switch (message.workingHourRange) {
                default:
                    return "workingHourRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                switch (message.paymentRange) {
                default:
                    return "paymentRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                switch (message.workingDuration) {
                default:
                    return "workingDuration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                if (!$util.isString(message.operatingDate))
                    return "operatingDate: string expected";
            return null;
        };

        /**
         * Creates a SearchProjectCountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SearchProjectCountRequest} SearchProjectCountRequest
         */
        SearchProjectCountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SearchProjectCountRequest)
                return object;
            var message = new $root.api.SearchProjectCountRequest();
            if (object.q != null)
                message.q = String(object.q);
            switch (object.occupation) {
            case "Occupation_Unknown":
            case 0:
                message.occupation = 0;
                break;
            case "Occupation_CorporateBusinessPlanning":
            case 1:
                message.occupation = 1;
                break;
            case "Occupation_BusinessDevelopment":
            case 2:
                message.occupation = 2;
                break;
            case "Occupation_Sales":
            case 3:
                message.occupation = 3;
                break;
            case "Occupation_PublicRelations":
            case 4:
                message.occupation = 4;
                break;
            case "Occupation_IPO":
            case 5:
                message.occupation = 5;
                break;
            case "Occupation_WebMarketing":
            case 6:
                message.occupation = 6;
                break;
            case "Occupation_HumanResource":
            case 7:
                message.occupation = 7;
                break;
            case "Occupation_HumanResource_Deprecate_1":
            case 8:
                message.occupation = 8;
                break;
            case "Occupation_HumanResource_Deprecate_2":
            case 9:
                message.occupation = 9;
                break;
            case "Occupation_HumanResource_Deprecate_3":
            case 10:
                message.occupation = 10;
                break;
            case "Occupation_IPO_Deprecate_1":
            case 11:
                message.occupation = 11;
                break;
            case "Occupation_Finance":
            case 12:
                message.occupation = 12;
                break;
            case "Occupation_Finance_Deprecate_1":
            case 13:
                message.occupation = 13;
                break;
            case "Occupation_Finance_Deprecate_2":
            case 14:
                message.occupation = 14;
                break;
            case "Occupation_MinistryOfJustice":
            case 15:
                message.occupation = 15;
                break;
            case "Occupation_Engineer":
            case 16:
                message.occupation = 16;
                break;
            case "Occupation_Designer":
            case 17:
                message.occupation = 17;
                break;
            case "Occupation_Other":
            case 18:
                message.occupation = 18;
                break;
            case "Occupation_InformationSystem":
            case 19:
                message.occupation = 19;
                break;
            case "Occupation_Professor":
            case 20:
                message.occupation = 20;
                break;
            case "Occupation_Marketing":
            case 21:
                message.occupation = 21;
                break;
            }
            switch (object.workingHourRange) {
            case "WorkingHourRange_Unknown":
            case 0:
                message.workingHourRange = 0;
                break;
            case "WorkingHourRange_20_40_Hour":
            case 1:
                message.workingHourRange = 1;
                break;
            case "WorkingHourRange_40_80_Hour":
            case 2:
                message.workingHourRange = 2;
                break;
            case "WorkingHourRange_80_120_Hour":
            case 3:
                message.workingHourRange = 3;
                break;
            case "WorkingHourRange_Over_120_Hour":
            case 4:
                message.workingHourRange = 4;
                break;
            case "WorkingHourRange_Other":
            case 5:
                message.workingHourRange = 5;
                break;
            }
            switch (object.paymentRange) {
            case "PaymentRange_Unknown":
            case 0:
                message.paymentRange = 0;
                break;
            case "PaymentRange_Under_100000_Yen":
            case 1:
                message.paymentRange = 1;
                break;
            case "PaymentRange_100000_300000_Yen":
            case 2:
                message.paymentRange = 2;
                break;
            case "PaymentRange_300000_500000_Yen":
            case 3:
                message.paymentRange = 3;
                break;
            case "PaymentRange_500000_1000000_Yen":
            case 4:
                message.paymentRange = 4;
                break;
            case "PaymentRange_Over_1000000_Yen":
            case 5:
                message.paymentRange = 5;
                break;
            }
            switch (object.workingDuration) {
            case "WorkingDuration_Unknown":
            case 0:
                message.workingDuration = 0;
                break;
            case "WorkingDuration_Under_1_Month":
            case 1:
                message.workingDuration = 1;
                break;
            case "WorkingDuration_1_3_Month":
            case 2:
                message.workingDuration = 2;
                break;
            case "WorkingDuration_3_6_Month":
            case 3:
                message.workingDuration = 3;
                break;
            case "WorkingDuration_6_12_Month":
            case 4:
                message.workingDuration = 4;
                break;
            case "WorkingDuration_Over_12_Month":
            case 5:
                message.workingDuration = 5;
                break;
            }
            if (object.operatingDate != null)
                message.operatingDate = String(object.operatingDate);
            return message;
        };

        /**
         * Creates a plain object from a SearchProjectCountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SearchProjectCountRequest
         * @static
         * @param {api.SearchProjectCountRequest} message SearchProjectCountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchProjectCountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.q = "";
                object.occupation = options.enums === String ? "Occupation_Unknown" : 0;
                object.workingHourRange = options.enums === String ? "WorkingHourRange_Unknown" : 0;
                object.paymentRange = options.enums === String ? "PaymentRange_Unknown" : 0;
                object.workingDuration = options.enums === String ? "WorkingDuration_Unknown" : 0;
                object.operatingDate = "";
            }
            if (message.q != null && message.hasOwnProperty("q"))
                object.q = message.q;
            if (message.occupation != null && message.hasOwnProperty("occupation"))
                object.occupation = options.enums === String ? $root.entity.Project.Occupation[message.occupation] : message.occupation;
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                object.workingHourRange = options.enums === String ? $root.entity.Project.WorkingHourRange[message.workingHourRange] : message.workingHourRange;
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                object.paymentRange = options.enums === String ? $root.entity.Project.PaymentRange[message.paymentRange] : message.paymentRange;
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                object.workingDuration = options.enums === String ? $root.entity.Project.WorkingDuration[message.workingDuration] : message.workingDuration;
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                object.operatingDate = message.operatingDate;
            return object;
        };

        /**
         * Converts this SearchProjectCountRequest to JSON.
         * @function toJSON
         * @memberof api.SearchProjectCountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchProjectCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SearchProjectCountRequest;
    })();

    api.CreateProjectRequest = (function() {

        /**
         * Properties of a CreateProjectRequest.
         * @memberof api
         * @interface ICreateProjectRequest
         * @property {string|null} [name] CreateProjectRequest name
         * @property {string|null} [description] CreateProjectRequest description
         * @property {string|null} [background] CreateProjectRequest background
         * @property {string|null} [preferentialExperience] CreateProjectRequest preferentialExperience
         * @property {string|null} [thumbnailURL] CreateProjectRequest thumbnailURL
         * @property {entity.Project.Place|null} [place] CreateProjectRequest place
         * @property {entity.Project.WorkingHourRange|null} [workingHourRange] CreateProjectRequest workingHourRange
         * @property {entity.Project.PaymentRange|null} [paymentRange] CreateProjectRequest paymentRange
         * @property {entity.Project.WorkingDuration|null} [workingDuration] CreateProjectRequest workingDuration
         * @property {Array.<entity.Project.Occupation>|null} [occupations] CreateProjectRequest occupations
         * @property {string|null} [operatingDate] CreateProjectRequest operatingDate
         * @property {boolean|null} [isHideCompany] CreateProjectRequest isHideCompany
         * @property {boolean|null} [isOpen] CreateProjectRequest isOpen
         */

        /**
         * Constructs a new CreateProjectRequest.
         * @memberof api
         * @classdesc Represents a CreateProjectRequest.
         * @implements ICreateProjectRequest
         * @constructor
         * @param {api.ICreateProjectRequest=} [properties] Properties to set
         */
        function CreateProjectRequest(properties) {
            this.occupations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateProjectRequest name.
         * @member {string} name
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.name = "";

        /**
         * CreateProjectRequest description.
         * @member {string} description
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.description = "";

        /**
         * CreateProjectRequest background.
         * @member {string} background
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.background = "";

        /**
         * CreateProjectRequest preferentialExperience.
         * @member {string} preferentialExperience
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.preferentialExperience = "";

        /**
         * CreateProjectRequest thumbnailURL.
         * @member {string} thumbnailURL
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.thumbnailURL = "";

        /**
         * CreateProjectRequest place.
         * @member {entity.Project.Place} place
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.place = 0;

        /**
         * CreateProjectRequest workingHourRange.
         * @member {entity.Project.WorkingHourRange} workingHourRange
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.workingHourRange = 0;

        /**
         * CreateProjectRequest paymentRange.
         * @member {entity.Project.PaymentRange} paymentRange
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.paymentRange = 0;

        /**
         * CreateProjectRequest workingDuration.
         * @member {entity.Project.WorkingDuration} workingDuration
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.workingDuration = 0;

        /**
         * CreateProjectRequest occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.occupations = $util.emptyArray;

        /**
         * CreateProjectRequest operatingDate.
         * @member {string} operatingDate
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.operatingDate = "";

        /**
         * CreateProjectRequest isHideCompany.
         * @member {boolean} isHideCompany
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.isHideCompany = false;

        /**
         * CreateProjectRequest isOpen.
         * @member {boolean} isOpen
         * @memberof api.CreateProjectRequest
         * @instance
         */
        CreateProjectRequest.prototype.isOpen = false;

        /**
         * Creates a new CreateProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateProjectRequest
         * @static
         * @param {api.ICreateProjectRequest=} [properties] Properties to set
         * @returns {api.CreateProjectRequest} CreateProjectRequest instance
         */
        CreateProjectRequest.create = function create(properties) {
            return new CreateProjectRequest(properties);
        };

        /**
         * Encodes the specified CreateProjectRequest message. Does not implicitly {@link api.CreateProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateProjectRequest
         * @static
         * @param {api.ICreateProjectRequest} message CreateProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.background);
            if (message.preferentialExperience != null && Object.hasOwnProperty.call(message, "preferentialExperience"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.preferentialExperience);
            if (message.thumbnailURL != null && Object.hasOwnProperty.call(message, "thumbnailURL"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.thumbnailURL);
            if (message.place != null && Object.hasOwnProperty.call(message, "place"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.place);
            if (message.workingHourRange != null && Object.hasOwnProperty.call(message, "workingHourRange"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.workingHourRange);
            if (message.paymentRange != null && Object.hasOwnProperty.call(message, "paymentRange"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.paymentRange);
            if (message.workingDuration != null && Object.hasOwnProperty.call(message, "workingDuration"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.workingDuration);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 10, wireType 2 =*/82).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.operatingDate != null && Object.hasOwnProperty.call(message, "operatingDate"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.operatingDate);
            if (message.isHideCompany != null && Object.hasOwnProperty.call(message, "isHideCompany"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isHideCompany);
            if (message.isOpen != null && Object.hasOwnProperty.call(message, "isOpen"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isOpen);
            return writer;
        };

        /**
         * Encodes the specified CreateProjectRequest message, length delimited. Does not implicitly {@link api.CreateProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateProjectRequest
         * @static
         * @param {api.ICreateProjectRequest} message CreateProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateProjectRequest} CreateProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.background = reader.string();
                    break;
                case 4:
                    message.preferentialExperience = reader.string();
                    break;
                case 5:
                    message.thumbnailURL = reader.string();
                    break;
                case 6:
                    message.place = reader.int32();
                    break;
                case 7:
                    message.workingHourRange = reader.int32();
                    break;
                case 8:
                    message.paymentRange = reader.int32();
                    break;
                case 9:
                    message.workingDuration = reader.int32();
                    break;
                case 10:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 11:
                    message.operatingDate = reader.string();
                    break;
                case 12:
                    message.isHideCompany = reader.bool();
                    break;
                case 13:
                    message.isOpen = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateProjectRequest} CreateProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateProjectRequest message.
         * @function verify
         * @memberof api.CreateProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.background != null && message.hasOwnProperty("background"))
                if (!$util.isString(message.background))
                    return "background: string expected";
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                if (!$util.isString(message.preferentialExperience))
                    return "preferentialExperience: string expected";
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                if (!$util.isString(message.thumbnailURL))
                    return "thumbnailURL: string expected";
            if (message.place != null && message.hasOwnProperty("place"))
                switch (message.place) {
                default:
                    return "place: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                switch (message.workingHourRange) {
                default:
                    return "workingHourRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                switch (message.paymentRange) {
                default:
                    return "paymentRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                switch (message.workingDuration) {
                default:
                    return "workingDuration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                if (!$util.isString(message.operatingDate))
                    return "operatingDate: string expected";
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                if (typeof message.isHideCompany !== "boolean")
                    return "isHideCompany: boolean expected";
            if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                if (typeof message.isOpen !== "boolean")
                    return "isOpen: boolean expected";
            return null;
        };

        /**
         * Creates a CreateProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateProjectRequest} CreateProjectRequest
         */
        CreateProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateProjectRequest)
                return object;
            var message = new $root.api.CreateProjectRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.background != null)
                message.background = String(object.background);
            if (object.preferentialExperience != null)
                message.preferentialExperience = String(object.preferentialExperience);
            if (object.thumbnailURL != null)
                message.thumbnailURL = String(object.thumbnailURL);
            switch (object.place) {
            case "Place_Unknown":
            case 0:
                message.place = 0;
                break;
            case "Place_InHouse":
            case 1:
                message.place = 1;
                break;
            case "Place_Remote":
            case 2:
                message.place = 2;
                break;
            case "Place_Other":
            case 3:
                message.place = 3;
                break;
            }
            switch (object.workingHourRange) {
            case "WorkingHourRange_Unknown":
            case 0:
                message.workingHourRange = 0;
                break;
            case "WorkingHourRange_20_40_Hour":
            case 1:
                message.workingHourRange = 1;
                break;
            case "WorkingHourRange_40_80_Hour":
            case 2:
                message.workingHourRange = 2;
                break;
            case "WorkingHourRange_80_120_Hour":
            case 3:
                message.workingHourRange = 3;
                break;
            case "WorkingHourRange_Over_120_Hour":
            case 4:
                message.workingHourRange = 4;
                break;
            case "WorkingHourRange_Other":
            case 5:
                message.workingHourRange = 5;
                break;
            }
            switch (object.paymentRange) {
            case "PaymentRange_Unknown":
            case 0:
                message.paymentRange = 0;
                break;
            case "PaymentRange_Under_100000_Yen":
            case 1:
                message.paymentRange = 1;
                break;
            case "PaymentRange_100000_300000_Yen":
            case 2:
                message.paymentRange = 2;
                break;
            case "PaymentRange_300000_500000_Yen":
            case 3:
                message.paymentRange = 3;
                break;
            case "PaymentRange_500000_1000000_Yen":
            case 4:
                message.paymentRange = 4;
                break;
            case "PaymentRange_Over_1000000_Yen":
            case 5:
                message.paymentRange = 5;
                break;
            }
            switch (object.workingDuration) {
            case "WorkingDuration_Unknown":
            case 0:
                message.workingDuration = 0;
                break;
            case "WorkingDuration_Under_1_Month":
            case 1:
                message.workingDuration = 1;
                break;
            case "WorkingDuration_1_3_Month":
            case 2:
                message.workingDuration = 2;
                break;
            case "WorkingDuration_3_6_Month":
            case 3:
                message.workingDuration = 3;
                break;
            case "WorkingDuration_6_12_Month":
            case 4:
                message.workingDuration = 4;
                break;
            case "WorkingDuration_Over_12_Month":
            case 5:
                message.workingDuration = 5;
                break;
            }
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".api.CreateProjectRequest.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            if (object.operatingDate != null)
                message.operatingDate = String(object.operatingDate);
            if (object.isHideCompany != null)
                message.isHideCompany = Boolean(object.isHideCompany);
            if (object.isOpen != null)
                message.isOpen = Boolean(object.isOpen);
            return message;
        };

        /**
         * Creates a plain object from a CreateProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateProjectRequest
         * @static
         * @param {api.CreateProjectRequest} message CreateProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.occupations = [];
            if (options.defaults) {
                object.name = "";
                object.description = "";
                object.background = "";
                object.preferentialExperience = "";
                object.thumbnailURL = "";
                object.place = options.enums === String ? "Place_Unknown" : 0;
                object.workingHourRange = options.enums === String ? "WorkingHourRange_Unknown" : 0;
                object.paymentRange = options.enums === String ? "PaymentRange_Unknown" : 0;
                object.workingDuration = options.enums === String ? "WorkingDuration_Unknown" : 0;
                object.operatingDate = "";
                object.isHideCompany = false;
                object.isOpen = false;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.background != null && message.hasOwnProperty("background"))
                object.background = message.background;
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                object.preferentialExperience = message.preferentialExperience;
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                object.thumbnailURL = message.thumbnailURL;
            if (message.place != null && message.hasOwnProperty("place"))
                object.place = options.enums === String ? $root.entity.Project.Place[message.place] : message.place;
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                object.workingHourRange = options.enums === String ? $root.entity.Project.WorkingHourRange[message.workingHourRange] : message.workingHourRange;
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                object.paymentRange = options.enums === String ? $root.entity.Project.PaymentRange[message.paymentRange] : message.paymentRange;
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                object.workingDuration = options.enums === String ? $root.entity.Project.WorkingDuration[message.workingDuration] : message.workingDuration;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                object.operatingDate = message.operatingDate;
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                object.isHideCompany = message.isHideCompany;
            if (message.isOpen != null && message.hasOwnProperty("isOpen"))
                object.isOpen = message.isOpen;
            return object;
        };

        /**
         * Converts this CreateProjectRequest to JSON.
         * @function toJSON
         * @memberof api.CreateProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateProjectRequest;
    })();

    api.UpdateProjectRequest = (function() {

        /**
         * Properties of an UpdateProjectRequest.
         * @memberof api
         * @interface IUpdateProjectRequest
         * @property {string|null} [id] UpdateProjectRequest id
         * @property {string|null} [name] UpdateProjectRequest name
         * @property {string|null} [description] UpdateProjectRequest description
         * @property {string|null} [background] UpdateProjectRequest background
         * @property {string|null} [preferentialExperience] UpdateProjectRequest preferentialExperience
         * @property {string|null} [thumbnailURL] UpdateProjectRequest thumbnailURL
         * @property {entity.Project.Place|null} [place] UpdateProjectRequest place
         * @property {entity.Project.WorkingHourRange|null} [workingHourRange] UpdateProjectRequest workingHourRange
         * @property {entity.Project.PaymentRange|null} [paymentRange] UpdateProjectRequest paymentRange
         * @property {entity.Project.WorkingDuration|null} [workingDuration] UpdateProjectRequest workingDuration
         * @property {Array.<entity.Project.Occupation>|null} [occupations] UpdateProjectRequest occupations
         * @property {string|null} [operatingDate] UpdateProjectRequest operatingDate
         * @property {boolean|null} [isHideCompany] UpdateProjectRequest isHideCompany
         */

        /**
         * Constructs a new UpdateProjectRequest.
         * @memberof api
         * @classdesc Represents an UpdateProjectRequest.
         * @implements IUpdateProjectRequest
         * @constructor
         * @param {api.IUpdateProjectRequest=} [properties] Properties to set
         */
        function UpdateProjectRequest(properties) {
            this.occupations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateProjectRequest id.
         * @member {string} id
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.id = "";

        /**
         * UpdateProjectRequest name.
         * @member {string} name
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.name = "";

        /**
         * UpdateProjectRequest description.
         * @member {string} description
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.description = "";

        /**
         * UpdateProjectRequest background.
         * @member {string} background
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.background = "";

        /**
         * UpdateProjectRequest preferentialExperience.
         * @member {string} preferentialExperience
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.preferentialExperience = "";

        /**
         * UpdateProjectRequest thumbnailURL.
         * @member {string} thumbnailURL
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.thumbnailURL = "";

        /**
         * UpdateProjectRequest place.
         * @member {entity.Project.Place} place
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.place = 0;

        /**
         * UpdateProjectRequest workingHourRange.
         * @member {entity.Project.WorkingHourRange} workingHourRange
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.workingHourRange = 0;

        /**
         * UpdateProjectRequest paymentRange.
         * @member {entity.Project.PaymentRange} paymentRange
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.paymentRange = 0;

        /**
         * UpdateProjectRequest workingDuration.
         * @member {entity.Project.WorkingDuration} workingDuration
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.workingDuration = 0;

        /**
         * UpdateProjectRequest occupations.
         * @member {Array.<entity.Project.Occupation>} occupations
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.occupations = $util.emptyArray;

        /**
         * UpdateProjectRequest operatingDate.
         * @member {string} operatingDate
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.operatingDate = "";

        /**
         * UpdateProjectRequest isHideCompany.
         * @member {boolean} isHideCompany
         * @memberof api.UpdateProjectRequest
         * @instance
         */
        UpdateProjectRequest.prototype.isHideCompany = false;

        /**
         * Creates a new UpdateProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {api.IUpdateProjectRequest=} [properties] Properties to set
         * @returns {api.UpdateProjectRequest} UpdateProjectRequest instance
         */
        UpdateProjectRequest.create = function create(properties) {
            return new UpdateProjectRequest(properties);
        };

        /**
         * Encodes the specified UpdateProjectRequest message. Does not implicitly {@link api.UpdateProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {api.IUpdateProjectRequest} message UpdateProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.background);
            if (message.preferentialExperience != null && Object.hasOwnProperty.call(message, "preferentialExperience"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.preferentialExperience);
            if (message.thumbnailURL != null && Object.hasOwnProperty.call(message, "thumbnailURL"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.thumbnailURL);
            if (message.place != null && Object.hasOwnProperty.call(message, "place"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.place);
            if (message.workingHourRange != null && Object.hasOwnProperty.call(message, "workingHourRange"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.workingHourRange);
            if (message.paymentRange != null && Object.hasOwnProperty.call(message, "paymentRange"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.paymentRange);
            if (message.workingDuration != null && Object.hasOwnProperty.call(message, "workingDuration"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.workingDuration);
            if (message.occupations != null && message.occupations.length) {
                writer.uint32(/* id 11, wireType 2 =*/90).fork();
                for (var i = 0; i < message.occupations.length; ++i)
                    writer.int32(message.occupations[i]);
                writer.ldelim();
            }
            if (message.operatingDate != null && Object.hasOwnProperty.call(message, "operatingDate"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.operatingDate);
            if (message.isHideCompany != null && Object.hasOwnProperty.call(message, "isHideCompany"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isHideCompany);
            return writer;
        };

        /**
         * Encodes the specified UpdateProjectRequest message, length delimited. Does not implicitly {@link api.UpdateProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {api.IUpdateProjectRequest} message UpdateProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.UpdateProjectRequest} UpdateProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.UpdateProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.background = reader.string();
                    break;
                case 5:
                    message.preferentialExperience = reader.string();
                    break;
                case 6:
                    message.thumbnailURL = reader.string();
                    break;
                case 7:
                    message.place = reader.int32();
                    break;
                case 8:
                    message.workingHourRange = reader.int32();
                    break;
                case 9:
                    message.paymentRange = reader.int32();
                    break;
                case 10:
                    message.workingDuration = reader.int32();
                    break;
                case 11:
                    if (!(message.occupations && message.occupations.length))
                        message.occupations = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.occupations.push(reader.int32());
                    } else
                        message.occupations.push(reader.int32());
                    break;
                case 12:
                    message.operatingDate = reader.string();
                    break;
                case 13:
                    message.isHideCompany = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.UpdateProjectRequest} UpdateProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateProjectRequest message.
         * @function verify
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.background != null && message.hasOwnProperty("background"))
                if (!$util.isString(message.background))
                    return "background: string expected";
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                if (!$util.isString(message.preferentialExperience))
                    return "preferentialExperience: string expected";
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                if (!$util.isString(message.thumbnailURL))
                    return "thumbnailURL: string expected";
            if (message.place != null && message.hasOwnProperty("place"))
                switch (message.place) {
                default:
                    return "place: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                switch (message.workingHourRange) {
                default:
                    return "workingHourRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                switch (message.paymentRange) {
                default:
                    return "paymentRange: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                switch (message.workingDuration) {
                default:
                    return "workingDuration: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.occupations != null && message.hasOwnProperty("occupations")) {
                if (!Array.isArray(message.occupations))
                    return "occupations: array expected";
                for (var i = 0; i < message.occupations.length; ++i)
                    switch (message.occupations[i]) {
                    default:
                        return "occupations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                        break;
                    }
            }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                if (!$util.isString(message.operatingDate))
                    return "operatingDate: string expected";
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                if (typeof message.isHideCompany !== "boolean")
                    return "isHideCompany: boolean expected";
            return null;
        };

        /**
         * Creates an UpdateProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.UpdateProjectRequest} UpdateProjectRequest
         */
        UpdateProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.UpdateProjectRequest)
                return object;
            var message = new $root.api.UpdateProjectRequest();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.background != null)
                message.background = String(object.background);
            if (object.preferentialExperience != null)
                message.preferentialExperience = String(object.preferentialExperience);
            if (object.thumbnailURL != null)
                message.thumbnailURL = String(object.thumbnailURL);
            switch (object.place) {
            case "Place_Unknown":
            case 0:
                message.place = 0;
                break;
            case "Place_InHouse":
            case 1:
                message.place = 1;
                break;
            case "Place_Remote":
            case 2:
                message.place = 2;
                break;
            case "Place_Other":
            case 3:
                message.place = 3;
                break;
            }
            switch (object.workingHourRange) {
            case "WorkingHourRange_Unknown":
            case 0:
                message.workingHourRange = 0;
                break;
            case "WorkingHourRange_20_40_Hour":
            case 1:
                message.workingHourRange = 1;
                break;
            case "WorkingHourRange_40_80_Hour":
            case 2:
                message.workingHourRange = 2;
                break;
            case "WorkingHourRange_80_120_Hour":
            case 3:
                message.workingHourRange = 3;
                break;
            case "WorkingHourRange_Over_120_Hour":
            case 4:
                message.workingHourRange = 4;
                break;
            case "WorkingHourRange_Other":
            case 5:
                message.workingHourRange = 5;
                break;
            }
            switch (object.paymentRange) {
            case "PaymentRange_Unknown":
            case 0:
                message.paymentRange = 0;
                break;
            case "PaymentRange_Under_100000_Yen":
            case 1:
                message.paymentRange = 1;
                break;
            case "PaymentRange_100000_300000_Yen":
            case 2:
                message.paymentRange = 2;
                break;
            case "PaymentRange_300000_500000_Yen":
            case 3:
                message.paymentRange = 3;
                break;
            case "PaymentRange_500000_1000000_Yen":
            case 4:
                message.paymentRange = 4;
                break;
            case "PaymentRange_Over_1000000_Yen":
            case 5:
                message.paymentRange = 5;
                break;
            }
            switch (object.workingDuration) {
            case "WorkingDuration_Unknown":
            case 0:
                message.workingDuration = 0;
                break;
            case "WorkingDuration_Under_1_Month":
            case 1:
                message.workingDuration = 1;
                break;
            case "WorkingDuration_1_3_Month":
            case 2:
                message.workingDuration = 2;
                break;
            case "WorkingDuration_3_6_Month":
            case 3:
                message.workingDuration = 3;
                break;
            case "WorkingDuration_6_12_Month":
            case 4:
                message.workingDuration = 4;
                break;
            case "WorkingDuration_Over_12_Month":
            case 5:
                message.workingDuration = 5;
                break;
            }
            if (object.occupations) {
                if (!Array.isArray(object.occupations))
                    throw TypeError(".api.UpdateProjectRequest.occupations: array expected");
                message.occupations = [];
                for (var i = 0; i < object.occupations.length; ++i)
                    switch (object.occupations[i]) {
                    default:
                    case "Occupation_Unknown":
                    case 0:
                        message.occupations[i] = 0;
                        break;
                    case "Occupation_CorporateBusinessPlanning":
                    case 1:
                        message.occupations[i] = 1;
                        break;
                    case "Occupation_BusinessDevelopment":
                    case 2:
                        message.occupations[i] = 2;
                        break;
                    case "Occupation_Sales":
                    case 3:
                        message.occupations[i] = 3;
                        break;
                    case "Occupation_PublicRelations":
                    case 4:
                        message.occupations[i] = 4;
                        break;
                    case "Occupation_IPO":
                    case 5:
                        message.occupations[i] = 5;
                        break;
                    case "Occupation_WebMarketing":
                    case 6:
                        message.occupations[i] = 6;
                        break;
                    case "Occupation_HumanResource":
                    case 7:
                        message.occupations[i] = 7;
                        break;
                    case "Occupation_HumanResource_Deprecate_1":
                    case 8:
                        message.occupations[i] = 8;
                        break;
                    case "Occupation_HumanResource_Deprecate_2":
                    case 9:
                        message.occupations[i] = 9;
                        break;
                    case "Occupation_HumanResource_Deprecate_3":
                    case 10:
                        message.occupations[i] = 10;
                        break;
                    case "Occupation_IPO_Deprecate_1":
                    case 11:
                        message.occupations[i] = 11;
                        break;
                    case "Occupation_Finance":
                    case 12:
                        message.occupations[i] = 12;
                        break;
                    case "Occupation_Finance_Deprecate_1":
                    case 13:
                        message.occupations[i] = 13;
                        break;
                    case "Occupation_Finance_Deprecate_2":
                    case 14:
                        message.occupations[i] = 14;
                        break;
                    case "Occupation_MinistryOfJustice":
                    case 15:
                        message.occupations[i] = 15;
                        break;
                    case "Occupation_Engineer":
                    case 16:
                        message.occupations[i] = 16;
                        break;
                    case "Occupation_Designer":
                    case 17:
                        message.occupations[i] = 17;
                        break;
                    case "Occupation_Other":
                    case 18:
                        message.occupations[i] = 18;
                        break;
                    case "Occupation_InformationSystem":
                    case 19:
                        message.occupations[i] = 19;
                        break;
                    case "Occupation_Professor":
                    case 20:
                        message.occupations[i] = 20;
                        break;
                    case "Occupation_Marketing":
                    case 21:
                        message.occupations[i] = 21;
                        break;
                    }
            }
            if (object.operatingDate != null)
                message.operatingDate = String(object.operatingDate);
            if (object.isHideCompany != null)
                message.isHideCompany = Boolean(object.isHideCompany);
            return message;
        };

        /**
         * Creates a plain object from an UpdateProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.UpdateProjectRequest
         * @static
         * @param {api.UpdateProjectRequest} message UpdateProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.occupations = [];
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.description = "";
                object.background = "";
                object.preferentialExperience = "";
                object.thumbnailURL = "";
                object.place = options.enums === String ? "Place_Unknown" : 0;
                object.workingHourRange = options.enums === String ? "WorkingHourRange_Unknown" : 0;
                object.paymentRange = options.enums === String ? "PaymentRange_Unknown" : 0;
                object.workingDuration = options.enums === String ? "WorkingDuration_Unknown" : 0;
                object.operatingDate = "";
                object.isHideCompany = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.background != null && message.hasOwnProperty("background"))
                object.background = message.background;
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                object.preferentialExperience = message.preferentialExperience;
            if (message.thumbnailURL != null && message.hasOwnProperty("thumbnailURL"))
                object.thumbnailURL = message.thumbnailURL;
            if (message.place != null && message.hasOwnProperty("place"))
                object.place = options.enums === String ? $root.entity.Project.Place[message.place] : message.place;
            if (message.workingHourRange != null && message.hasOwnProperty("workingHourRange"))
                object.workingHourRange = options.enums === String ? $root.entity.Project.WorkingHourRange[message.workingHourRange] : message.workingHourRange;
            if (message.paymentRange != null && message.hasOwnProperty("paymentRange"))
                object.paymentRange = options.enums === String ? $root.entity.Project.PaymentRange[message.paymentRange] : message.paymentRange;
            if (message.workingDuration != null && message.hasOwnProperty("workingDuration"))
                object.workingDuration = options.enums === String ? $root.entity.Project.WorkingDuration[message.workingDuration] : message.workingDuration;
            if (message.occupations && message.occupations.length) {
                object.occupations = [];
                for (var j = 0; j < message.occupations.length; ++j)
                    object.occupations[j] = options.enums === String ? $root.entity.Project.Occupation[message.occupations[j]] : message.occupations[j];
            }
            if (message.operatingDate != null && message.hasOwnProperty("operatingDate"))
                object.operatingDate = message.operatingDate;
            if (message.isHideCompany != null && message.hasOwnProperty("isHideCompany"))
                object.isHideCompany = message.isHideCompany;
            return object;
        };

        /**
         * Converts this UpdateProjectRequest to JSON.
         * @function toJSON
         * @memberof api.UpdateProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateProjectRequest;
    })();

    api.GenerateProjectInfoRequest = (function() {

        /**
         * Properties of a GenerateProjectInfoRequest.
         * @memberof api
         * @interface IGenerateProjectInfoRequest
         * @property {string|null} [requirements] GenerateProjectInfoRequest requirements
         */

        /**
         * Constructs a new GenerateProjectInfoRequest.
         * @memberof api
         * @classdesc Represents a GenerateProjectInfoRequest.
         * @implements IGenerateProjectInfoRequest
         * @constructor
         * @param {api.IGenerateProjectInfoRequest=} [properties] Properties to set
         */
        function GenerateProjectInfoRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GenerateProjectInfoRequest requirements.
         * @member {string} requirements
         * @memberof api.GenerateProjectInfoRequest
         * @instance
         */
        GenerateProjectInfoRequest.prototype.requirements = "";

        /**
         * Creates a new GenerateProjectInfoRequest instance using the specified properties.
         * @function create
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {api.IGenerateProjectInfoRequest=} [properties] Properties to set
         * @returns {api.GenerateProjectInfoRequest} GenerateProjectInfoRequest instance
         */
        GenerateProjectInfoRequest.create = function create(properties) {
            return new GenerateProjectInfoRequest(properties);
        };

        /**
         * Encodes the specified GenerateProjectInfoRequest message. Does not implicitly {@link api.GenerateProjectInfoRequest.verify|verify} messages.
         * @function encode
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {api.IGenerateProjectInfoRequest} message GenerateProjectInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenerateProjectInfoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.requirements != null && Object.hasOwnProperty.call(message, "requirements"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.requirements);
            return writer;
        };

        /**
         * Encodes the specified GenerateProjectInfoRequest message, length delimited. Does not implicitly {@link api.GenerateProjectInfoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {api.IGenerateProjectInfoRequest} message GenerateProjectInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenerateProjectInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GenerateProjectInfoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.GenerateProjectInfoRequest} GenerateProjectInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenerateProjectInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.GenerateProjectInfoRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.requirements = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GenerateProjectInfoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.GenerateProjectInfoRequest} GenerateProjectInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenerateProjectInfoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GenerateProjectInfoRequest message.
         * @function verify
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GenerateProjectInfoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.requirements != null && message.hasOwnProperty("requirements"))
                if (!$util.isString(message.requirements))
                    return "requirements: string expected";
            return null;
        };

        /**
         * Creates a GenerateProjectInfoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.GenerateProjectInfoRequest} GenerateProjectInfoRequest
         */
        GenerateProjectInfoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.GenerateProjectInfoRequest)
                return object;
            var message = new $root.api.GenerateProjectInfoRequest();
            if (object.requirements != null)
                message.requirements = String(object.requirements);
            return message;
        };

        /**
         * Creates a plain object from a GenerateProjectInfoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.GenerateProjectInfoRequest
         * @static
         * @param {api.GenerateProjectInfoRequest} message GenerateProjectInfoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GenerateProjectInfoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.requirements = "";
            if (message.requirements != null && message.hasOwnProperty("requirements"))
                object.requirements = message.requirements;
            return object;
        };

        /**
         * Converts this GenerateProjectInfoRequest to JSON.
         * @function toJSON
         * @memberof api.GenerateProjectInfoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GenerateProjectInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GenerateProjectInfoRequest;
    })();

    api.GenerateProjectInfoResponse = (function() {

        /**
         * Properties of a GenerateProjectInfoResponse.
         * @memberof api
         * @interface IGenerateProjectInfoResponse
         * @property {string|null} [title] GenerateProjectInfoResponse title
         * @property {string|null} [description] GenerateProjectInfoResponse description
         * @property {string|null} [background] GenerateProjectInfoResponse background
         * @property {string|null} [preferentialExperience] GenerateProjectInfoResponse preferentialExperience
         */

        /**
         * Constructs a new GenerateProjectInfoResponse.
         * @memberof api
         * @classdesc Represents a GenerateProjectInfoResponse.
         * @implements IGenerateProjectInfoResponse
         * @constructor
         * @param {api.IGenerateProjectInfoResponse=} [properties] Properties to set
         */
        function GenerateProjectInfoResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GenerateProjectInfoResponse title.
         * @member {string} title
         * @memberof api.GenerateProjectInfoResponse
         * @instance
         */
        GenerateProjectInfoResponse.prototype.title = "";

        /**
         * GenerateProjectInfoResponse description.
         * @member {string} description
         * @memberof api.GenerateProjectInfoResponse
         * @instance
         */
        GenerateProjectInfoResponse.prototype.description = "";

        /**
         * GenerateProjectInfoResponse background.
         * @member {string} background
         * @memberof api.GenerateProjectInfoResponse
         * @instance
         */
        GenerateProjectInfoResponse.prototype.background = "";

        /**
         * GenerateProjectInfoResponse preferentialExperience.
         * @member {string} preferentialExperience
         * @memberof api.GenerateProjectInfoResponse
         * @instance
         */
        GenerateProjectInfoResponse.prototype.preferentialExperience = "";

        /**
         * Creates a new GenerateProjectInfoResponse instance using the specified properties.
         * @function create
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {api.IGenerateProjectInfoResponse=} [properties] Properties to set
         * @returns {api.GenerateProjectInfoResponse} GenerateProjectInfoResponse instance
         */
        GenerateProjectInfoResponse.create = function create(properties) {
            return new GenerateProjectInfoResponse(properties);
        };

        /**
         * Encodes the specified GenerateProjectInfoResponse message. Does not implicitly {@link api.GenerateProjectInfoResponse.verify|verify} messages.
         * @function encode
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {api.IGenerateProjectInfoResponse} message GenerateProjectInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenerateProjectInfoResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.background);
            if (message.preferentialExperience != null && Object.hasOwnProperty.call(message, "preferentialExperience"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.preferentialExperience);
            return writer;
        };

        /**
         * Encodes the specified GenerateProjectInfoResponse message, length delimited. Does not implicitly {@link api.GenerateProjectInfoResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {api.IGenerateProjectInfoResponse} message GenerateProjectInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenerateProjectInfoResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GenerateProjectInfoResponse message from the specified reader or buffer.
         * @function decode
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.GenerateProjectInfoResponse} GenerateProjectInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenerateProjectInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.GenerateProjectInfoResponse();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.background = reader.string();
                    break;
                case 4:
                    message.preferentialExperience = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GenerateProjectInfoResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.GenerateProjectInfoResponse} GenerateProjectInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenerateProjectInfoResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GenerateProjectInfoResponse message.
         * @function verify
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GenerateProjectInfoResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.background != null && message.hasOwnProperty("background"))
                if (!$util.isString(message.background))
                    return "background: string expected";
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                if (!$util.isString(message.preferentialExperience))
                    return "preferentialExperience: string expected";
            return null;
        };

        /**
         * Creates a GenerateProjectInfoResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.GenerateProjectInfoResponse} GenerateProjectInfoResponse
         */
        GenerateProjectInfoResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.api.GenerateProjectInfoResponse)
                return object;
            var message = new $root.api.GenerateProjectInfoResponse();
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.background != null)
                message.background = String(object.background);
            if (object.preferentialExperience != null)
                message.preferentialExperience = String(object.preferentialExperience);
            return message;
        };

        /**
         * Creates a plain object from a GenerateProjectInfoResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.GenerateProjectInfoResponse
         * @static
         * @param {api.GenerateProjectInfoResponse} message GenerateProjectInfoResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GenerateProjectInfoResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.title = "";
                object.description = "";
                object.background = "";
                object.preferentialExperience = "";
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.background != null && message.hasOwnProperty("background"))
                object.background = message.background;
            if (message.preferentialExperience != null && message.hasOwnProperty("preferentialExperience"))
                object.preferentialExperience = message.preferentialExperience;
            return object;
        };

        /**
         * Converts this GenerateProjectInfoResponse to JSON.
         * @function toJSON
         * @memberof api.GenerateProjectInfoResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GenerateProjectInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GenerateProjectInfoResponse;
    })();

    api.SharingProjectRequest = (function() {

        /**
         * Properties of a SharingProjectRequest.
         * @memberof api
         * @interface ISharingProjectRequest
         * @property {string|null} [customerName] SharingProjectRequest customerName
         * @property {string|null} [customerEmail] SharingProjectRequest customerEmail
         * @property {string|null} [customerPhoneNumber] SharingProjectRequest customerPhoneNumber
         * @property {string|null} [referralCompanyName] SharingProjectRequest referralCompanyName
         * @property {string|null} [mayConcernName] SharingProjectRequest mayConcernName
         * @property {string|null} [department] SharingProjectRequest department
         * @property {string|null} [position] SharingProjectRequest position
         * @property {string|null} [mayConcernEmail] SharingProjectRequest mayConcernEmail
         * @property {string|null} [mayConcernPhoneNumber] SharingProjectRequest mayConcernPhoneNumber
         * @property {string|null} [projectTitle] SharingProjectRequest projectTitle
         * @property {api.SharingProjectRequest.Priority|null} [priority] SharingProjectRequest priority
         * @property {string|null} [message] SharingProjectRequest message
         * @property {boolean|null} [isNeedPreliminaryMeeting] SharingProjectRequest isNeedPreliminaryMeeting
         */

        /**
         * Constructs a new SharingProjectRequest.
         * @memberof api
         * @classdesc Represents a SharingProjectRequest.
         * @implements ISharingProjectRequest
         * @constructor
         * @param {api.ISharingProjectRequest=} [properties] Properties to set
         */
        function SharingProjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SharingProjectRequest customerName.
         * @member {string} customerName
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.customerName = "";

        /**
         * SharingProjectRequest customerEmail.
         * @member {string} customerEmail
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.customerEmail = "";

        /**
         * SharingProjectRequest customerPhoneNumber.
         * @member {string} customerPhoneNumber
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.customerPhoneNumber = "";

        /**
         * SharingProjectRequest referralCompanyName.
         * @member {string} referralCompanyName
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.referralCompanyName = "";

        /**
         * SharingProjectRequest mayConcernName.
         * @member {string} mayConcernName
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.mayConcernName = "";

        /**
         * SharingProjectRequest department.
         * @member {string} department
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.department = "";

        /**
         * SharingProjectRequest position.
         * @member {string} position
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.position = "";

        /**
         * SharingProjectRequest mayConcernEmail.
         * @member {string} mayConcernEmail
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.mayConcernEmail = "";

        /**
         * SharingProjectRequest mayConcernPhoneNumber.
         * @member {string} mayConcernPhoneNumber
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.mayConcernPhoneNumber = "";

        /**
         * SharingProjectRequest projectTitle.
         * @member {string} projectTitle
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.projectTitle = "";

        /**
         * SharingProjectRequest priority.
         * @member {api.SharingProjectRequest.Priority} priority
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.priority = 0;

        /**
         * SharingProjectRequest message.
         * @member {string} message
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.message = "";

        /**
         * SharingProjectRequest isNeedPreliminaryMeeting.
         * @member {boolean} isNeedPreliminaryMeeting
         * @memberof api.SharingProjectRequest
         * @instance
         */
        SharingProjectRequest.prototype.isNeedPreliminaryMeeting = false;

        /**
         * Creates a new SharingProjectRequest instance using the specified properties.
         * @function create
         * @memberof api.SharingProjectRequest
         * @static
         * @param {api.ISharingProjectRequest=} [properties] Properties to set
         * @returns {api.SharingProjectRequest} SharingProjectRequest instance
         */
        SharingProjectRequest.create = function create(properties) {
            return new SharingProjectRequest(properties);
        };

        /**
         * Encodes the specified SharingProjectRequest message. Does not implicitly {@link api.SharingProjectRequest.verify|verify} messages.
         * @function encode
         * @memberof api.SharingProjectRequest
         * @static
         * @param {api.ISharingProjectRequest} message SharingProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SharingProjectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customerName);
            if (message.customerEmail != null && Object.hasOwnProperty.call(message, "customerEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customerEmail);
            if (message.customerPhoneNumber != null && Object.hasOwnProperty.call(message, "customerPhoneNumber"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.customerPhoneNumber);
            if (message.referralCompanyName != null && Object.hasOwnProperty.call(message, "referralCompanyName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.referralCompanyName);
            if (message.mayConcernName != null && Object.hasOwnProperty.call(message, "mayConcernName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.mayConcernName);
            if (message.department != null && Object.hasOwnProperty.call(message, "department"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.department);
            if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.position);
            if (message.mayConcernEmail != null && Object.hasOwnProperty.call(message, "mayConcernEmail"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.mayConcernEmail);
            if (message.mayConcernPhoneNumber != null && Object.hasOwnProperty.call(message, "mayConcernPhoneNumber"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.mayConcernPhoneNumber);
            if (message.projectTitle != null && Object.hasOwnProperty.call(message, "projectTitle"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.projectTitle);
            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.priority);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.message);
            if (message.isNeedPreliminaryMeeting != null && Object.hasOwnProperty.call(message, "isNeedPreliminaryMeeting"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isNeedPreliminaryMeeting);
            return writer;
        };

        /**
         * Encodes the specified SharingProjectRequest message, length delimited. Does not implicitly {@link api.SharingProjectRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.SharingProjectRequest
         * @static
         * @param {api.ISharingProjectRequest} message SharingProjectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SharingProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SharingProjectRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.SharingProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.SharingProjectRequest} SharingProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SharingProjectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.SharingProjectRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customerName = reader.string();
                    break;
                case 2:
                    message.customerEmail = reader.string();
                    break;
                case 3:
                    message.customerPhoneNumber = reader.string();
                    break;
                case 4:
                    message.referralCompanyName = reader.string();
                    break;
                case 5:
                    message.mayConcernName = reader.string();
                    break;
                case 6:
                    message.department = reader.string();
                    break;
                case 7:
                    message.position = reader.string();
                    break;
                case 8:
                    message.mayConcernEmail = reader.string();
                    break;
                case 9:
                    message.mayConcernPhoneNumber = reader.string();
                    break;
                case 10:
                    message.projectTitle = reader.string();
                    break;
                case 11:
                    message.priority = reader.int32();
                    break;
                case 12:
                    message.message = reader.string();
                    break;
                case 13:
                    message.isNeedPreliminaryMeeting = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SharingProjectRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.SharingProjectRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.SharingProjectRequest} SharingProjectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SharingProjectRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SharingProjectRequest message.
         * @function verify
         * @memberof api.SharingProjectRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SharingProjectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                if (!$util.isString(message.customerEmail))
                    return "customerEmail: string expected";
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                if (!$util.isString(message.customerPhoneNumber))
                    return "customerPhoneNumber: string expected";
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                if (!$util.isString(message.referralCompanyName))
                    return "referralCompanyName: string expected";
            if (message.mayConcernName != null && message.hasOwnProperty("mayConcernName"))
                if (!$util.isString(message.mayConcernName))
                    return "mayConcernName: string expected";
            if (message.department != null && message.hasOwnProperty("department"))
                if (!$util.isString(message.department))
                    return "department: string expected";
            if (message.position != null && message.hasOwnProperty("position"))
                if (!$util.isString(message.position))
                    return "position: string expected";
            if (message.mayConcernEmail != null && message.hasOwnProperty("mayConcernEmail"))
                if (!$util.isString(message.mayConcernEmail))
                    return "mayConcernEmail: string expected";
            if (message.mayConcernPhoneNumber != null && message.hasOwnProperty("mayConcernPhoneNumber"))
                if (!$util.isString(message.mayConcernPhoneNumber))
                    return "mayConcernPhoneNumber: string expected";
            if (message.projectTitle != null && message.hasOwnProperty("projectTitle"))
                if (!$util.isString(message.projectTitle))
                    return "projectTitle: string expected";
            if (message.priority != null && message.hasOwnProperty("priority"))
                switch (message.priority) {
                default:
                    return "priority: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.isNeedPreliminaryMeeting != null && message.hasOwnProperty("isNeedPreliminaryMeeting"))
                if (typeof message.isNeedPreliminaryMeeting !== "boolean")
                    return "isNeedPreliminaryMeeting: boolean expected";
            return null;
        };

        /**
         * Creates a SharingProjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.SharingProjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.SharingProjectRequest} SharingProjectRequest
         */
        SharingProjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.SharingProjectRequest)
                return object;
            var message = new $root.api.SharingProjectRequest();
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.customerEmail != null)
                message.customerEmail = String(object.customerEmail);
            if (object.customerPhoneNumber != null)
                message.customerPhoneNumber = String(object.customerPhoneNumber);
            if (object.referralCompanyName != null)
                message.referralCompanyName = String(object.referralCompanyName);
            if (object.mayConcernName != null)
                message.mayConcernName = String(object.mayConcernName);
            if (object.department != null)
                message.department = String(object.department);
            if (object.position != null)
                message.position = String(object.position);
            if (object.mayConcernEmail != null)
                message.mayConcernEmail = String(object.mayConcernEmail);
            if (object.mayConcernPhoneNumber != null)
                message.mayConcernPhoneNumber = String(object.mayConcernPhoneNumber);
            if (object.projectTitle != null)
                message.projectTitle = String(object.projectTitle);
            switch (object.priority) {
            case "Priority_Unknown":
            case 0:
                message.priority = 0;
                break;
            case "Priority_High":
            case 1:
                message.priority = 1;
                break;
            case "Priority_Middle":
            case 2:
                message.priority = 2;
                break;
            case "Priority_Low":
            case 3:
                message.priority = 3;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.isNeedPreliminaryMeeting != null)
                message.isNeedPreliminaryMeeting = Boolean(object.isNeedPreliminaryMeeting);
            return message;
        };

        /**
         * Creates a plain object from a SharingProjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.SharingProjectRequest
         * @static
         * @param {api.SharingProjectRequest} message SharingProjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SharingProjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.customerName = "";
                object.customerEmail = "";
                object.customerPhoneNumber = "";
                object.referralCompanyName = "";
                object.mayConcernName = "";
                object.department = "";
                object.position = "";
                object.mayConcernEmail = "";
                object.mayConcernPhoneNumber = "";
                object.projectTitle = "";
                object.priority = options.enums === String ? "Priority_Unknown" : 0;
                object.message = "";
                object.isNeedPreliminaryMeeting = false;
            }
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                object.customerEmail = message.customerEmail;
            if (message.customerPhoneNumber != null && message.hasOwnProperty("customerPhoneNumber"))
                object.customerPhoneNumber = message.customerPhoneNumber;
            if (message.referralCompanyName != null && message.hasOwnProperty("referralCompanyName"))
                object.referralCompanyName = message.referralCompanyName;
            if (message.mayConcernName != null && message.hasOwnProperty("mayConcernName"))
                object.mayConcernName = message.mayConcernName;
            if (message.department != null && message.hasOwnProperty("department"))
                object.department = message.department;
            if (message.position != null && message.hasOwnProperty("position"))
                object.position = message.position;
            if (message.mayConcernEmail != null && message.hasOwnProperty("mayConcernEmail"))
                object.mayConcernEmail = message.mayConcernEmail;
            if (message.mayConcernPhoneNumber != null && message.hasOwnProperty("mayConcernPhoneNumber"))
                object.mayConcernPhoneNumber = message.mayConcernPhoneNumber;
            if (message.projectTitle != null && message.hasOwnProperty("projectTitle"))
                object.projectTitle = message.projectTitle;
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = options.enums === String ? $root.api.SharingProjectRequest.Priority[message.priority] : message.priority;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.isNeedPreliminaryMeeting != null && message.hasOwnProperty("isNeedPreliminaryMeeting"))
                object.isNeedPreliminaryMeeting = message.isNeedPreliminaryMeeting;
            return object;
        };

        /**
         * Converts this SharingProjectRequest to JSON.
         * @function toJSON
         * @memberof api.SharingProjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SharingProjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Priority enum.
         * @name api.SharingProjectRequest.Priority
         * @enum {number}
         * @property {number} Priority_Unknown=0 Priority_Unknown value
         * @property {number} Priority_High=1 Priority_High value
         * @property {number} Priority_Middle=2 Priority_Middle value
         * @property {number} Priority_Low=3 Priority_Low value
         */
        SharingProjectRequest.Priority = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Priority_Unknown"] = 0;
            values[valuesById[1] = "Priority_High"] = 1;
            values[valuesById[2] = "Priority_Middle"] = 2;
            values[valuesById[3] = "Priority_Low"] = 3;
            return values;
        })();

        return SharingProjectRequest;
    })();

    api.PublicService = (function() {

        /**
         * Constructs a new PublicService service.
         * @memberof api
         * @classdesc Represents a PublicService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PublicService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PublicService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PublicService;

        /**
         * Creates new PublicService service using the specified rpc implementation.
         * @function create
         * @memberof api.PublicService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PublicService} RPC service. Useful where requests and/or responses are streamed.
         */
        PublicService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.PublicService#getCustomer}.
         * @memberof api.PublicService
         * @typedef GetCustomerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomer} [response] SafeCustomer
         */

        /**
         * Calls GetCustomer.
         * @function getCustomer
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.PublicService.GetCustomerCallback} callback Node-style callback called with the error, if any, and SafeCustomer
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getCustomer = function getCustomer(request, callback) {
            return this.rpcCall(getCustomer, $root.entity.CustomerID, $root.entity.SafeCustomer, request, callback);
        }, "name", { value: "GetCustomer" });

        /**
         * Calls GetCustomer.
         * @function getCustomer
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomer>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getRecommendCustomerByMatch}.
         * @memberof api.PublicService
         * @typedef GetRecommendCustomerByMatchCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetRecommendCustomerByMatch.
         * @function getRecommendCustomerByMatch
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.PublicService.GetRecommendCustomerByMatchCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getRecommendCustomerByMatch = function getRecommendCustomerByMatch(request, callback) {
            return this.rpcCall(getRecommendCustomerByMatch, $root.entity.CustomerID, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetRecommendCustomerByMatch" });

        /**
         * Calls GetRecommendCustomerByMatch.
         * @function getRecommendCustomerByMatch
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getRecommendCustomerByTrend}.
         * @memberof api.PublicService
         * @typedef GetRecommendCustomerByTrendCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SafeCustomerList} [response] SafeCustomerList
         */

        /**
         * Calls GetRecommendCustomerByTrend.
         * @function getRecommendCustomerByTrend
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.PublicService.GetRecommendCustomerByTrendCallback} callback Node-style callback called with the error, if any, and SafeCustomerList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getRecommendCustomerByTrend = function getRecommendCustomerByTrend(request, callback) {
            return this.rpcCall(getRecommendCustomerByTrend, $root.entity.CustomerID, $root.entity.SafeCustomerList, request, callback);
        }, "name", { value: "GetRecommendCustomerByTrend" });

        /**
         * Calls GetRecommendCustomerByTrend.
         * @function getRecommendCustomerByTrend
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.SafeCustomerList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getAllJobCareerByCustomerIDs}.
         * @memberof api.PublicService
         * @typedef GetAllJobCareerByCustomerIDsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.JobCareerWithCustomerIDList} [response] JobCareerWithCustomerIDList
         */

        /**
         * Calls GetAllJobCareerByCustomerIDs.
         * @function getAllJobCareerByCustomerIDs
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @param {api.PublicService.GetAllJobCareerByCustomerIDsCallback} callback Node-style callback called with the error, if any, and JobCareerWithCustomerIDList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getAllJobCareerByCustomerIDs = function getAllJobCareerByCustomerIDs(request, callback) {
            return this.rpcCall(getAllJobCareerByCustomerIDs, $root.entity.CustomerIDList, $root.entity.JobCareerWithCustomerIDList, request, callback);
        }, "name", { value: "GetAllJobCareerByCustomerIDs" });

        /**
         * Calls GetAllJobCareerByCustomerIDs.
         * @function getAllJobCareerByCustomerIDs
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerIDList} request CustomerIDList message or plain object
         * @returns {Promise<entity.JobCareerWithCustomerIDList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getAllPastCaseProject}.
         * @memberof api.PublicService
         * @typedef GetAllPastCaseProjectCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.PastCaseProjectList} [response] PastCaseProjectList
         */

        /**
         * Calls GetAllPastCaseProject.
         * @function getAllPastCaseProject
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @param {api.PublicService.GetAllPastCaseProjectCallback} callback Node-style callback called with the error, if any, and PastCaseProjectList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getAllPastCaseProject = function getAllPastCaseProject(request, callback) {
            return this.rpcCall(getAllPastCaseProject, $root.entity.CustomerID, $root.entity.PastCaseProjectList, request, callback);
        }, "name", { value: "GetAllPastCaseProject" });

        /**
         * Calls GetAllPastCaseProject.
         * @function getAllPastCaseProject
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerID} request CustomerID message or plain object
         * @returns {Promise<entity.PastCaseProjectList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getAllOccupationSkillTag}.
         * @memberof api.PublicService
         * @typedef GetAllOccupationSkillTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.OccupationSkillTagList} [response] OccupationSkillTagList
         */

        /**
         * Calls GetAllOccupationSkillTag.
         * @function getAllOccupationSkillTag
         * @memberof api.PublicService
         * @instance
         * @param {entity.IOccupationSkillTagIDWithPager} request OccupationSkillTagIDWithPager message or plain object
         * @param {api.PublicService.GetAllOccupationSkillTagCallback} callback Node-style callback called with the error, if any, and OccupationSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getAllOccupationSkillTag = function getAllOccupationSkillTag(request, callback) {
            return this.rpcCall(getAllOccupationSkillTag, $root.entity.OccupationSkillTagIDWithPager, $root.entity.OccupationSkillTagList, request, callback);
        }, "name", { value: "GetAllOccupationSkillTag" });

        /**
         * Calls GetAllOccupationSkillTag.
         * @function getAllOccupationSkillTag
         * @memberof api.PublicService
         * @instance
         * @param {entity.IOccupationSkillTagIDWithPager} request OccupationSkillTagIDWithPager message or plain object
         * @returns {Promise<entity.OccupationSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.PublicService#getAllReviewByCustomer}.
         * @memberof api.PublicService
         * @typedef GetAllReviewByCustomerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ReviewList} [response] ReviewList
         */

        /**
         * Calls GetAllReviewByCustomer.
         * @function getAllReviewByCustomer
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerIDWithPager} request CustomerIDWithPager message or plain object
         * @param {api.PublicService.GetAllReviewByCustomerCallback} callback Node-style callback called with the error, if any, and ReviewList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PublicService.prototype.getAllReviewByCustomer = function getAllReviewByCustomer(request, callback) {
            return this.rpcCall(getAllReviewByCustomer, $root.entity.CustomerIDWithPager, $root.entity.ReviewList, request, callback);
        }, "name", { value: "GetAllReviewByCustomer" });

        /**
         * Calls GetAllReviewByCustomer.
         * @function getAllReviewByCustomer
         * @memberof api.PublicService
         * @instance
         * @param {entity.ICustomerIDWithPager} request CustomerIDWithPager message or plain object
         * @returns {Promise<entity.ReviewList>} Promise
         * @variation 2
         */

        return PublicService;
    })();

    api.ReviewService = (function() {

        /**
         * Constructs a new ReviewService service.
         * @memberof api
         * @classdesc Represents a ReviewService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ReviewService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ReviewService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ReviewService;

        /**
         * Creates new ReviewService service using the specified rpc implementation.
         * @function create
         * @memberof api.ReviewService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ReviewService} RPC service. Useful where requests and/or responses are streamed.
         */
        ReviewService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ReviewService#getAllByCustomer}.
         * @memberof api.ReviewService
         * @typedef GetAllByCustomerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.ReviewList} [response] ReviewList
         */

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.ReviewService
         * @instance
         * @param {entity.ICustomerIDWithPager} request CustomerIDWithPager message or plain object
         * @param {api.ReviewService.GetAllByCustomerCallback} callback Node-style callback called with the error, if any, and ReviewList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ReviewService.prototype.getAllByCustomer = function getAllByCustomer(request, callback) {
            return this.rpcCall(getAllByCustomer, $root.entity.CustomerIDWithPager, $root.entity.ReviewList, request, callback);
        }, "name", { value: "GetAllByCustomer" });

        /**
         * Calls GetAllByCustomer.
         * @function getAllByCustomer
         * @memberof api.ReviewService
         * @instance
         * @param {entity.ICustomerIDWithPager} request CustomerIDWithPager message or plain object
         * @returns {Promise<entity.ReviewList>} Promise
         * @variation 2
         */

        return ReviewService;
    })();

    api.ScoutService = (function() {

        /**
         * Constructs a new ScoutService service.
         * @memberof api
         * @classdesc Represents a ScoutService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function ScoutService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (ScoutService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScoutService;

        /**
         * Creates new ScoutService service using the specified rpc implementation.
         * @function create
         * @memberof api.ScoutService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {ScoutService} RPC service. Useful where requests and/or responses are streamed.
         */
        ScoutService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.ScoutService#create}.
         * @memberof api.ScoutService
         * @typedef CreateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MessageRoom} [response] MessageRoom
         */

        /**
         * Calls Create.
         * @function create
         * @memberof api.ScoutService
         * @instance
         * @param {api.ICreateScoutRequest} request CreateScoutRequest message or plain object
         * @param {api.ScoutService.CreateCallback} callback Node-style callback called with the error, if any, and MessageRoom
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(ScoutService.prototype.create = function create(request, callback) {
            return this.rpcCall(create, $root.api.CreateScoutRequest, $root.entity.MessageRoom, request, callback);
        }, "name", { value: "Create" });

        /**
         * Calls Create.
         * @function create
         * @memberof api.ScoutService
         * @instance
         * @param {api.ICreateScoutRequest} request CreateScoutRequest message or plain object
         * @returns {Promise<entity.MessageRoom>} Promise
         * @variation 2
         */

        return ScoutService;
    })();

    api.CreateScoutRequest = (function() {

        /**
         * Properties of a CreateScoutRequest.
         * @memberof api
         * @interface ICreateScoutRequest
         * @property {string|null} [customerID] CreateScoutRequest customerID
         * @property {string|null} [projectID] CreateScoutRequest projectID
         * @property {string|null} [message] CreateScoutRequest message
         */

        /**
         * Constructs a new CreateScoutRequest.
         * @memberof api
         * @classdesc Represents a CreateScoutRequest.
         * @implements ICreateScoutRequest
         * @constructor
         * @param {api.ICreateScoutRequest=} [properties] Properties to set
         */
        function CreateScoutRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateScoutRequest customerID.
         * @member {string} customerID
         * @memberof api.CreateScoutRequest
         * @instance
         */
        CreateScoutRequest.prototype.customerID = "";

        /**
         * CreateScoutRequest projectID.
         * @member {string} projectID
         * @memberof api.CreateScoutRequest
         * @instance
         */
        CreateScoutRequest.prototype.projectID = "";

        /**
         * CreateScoutRequest message.
         * @member {string} message
         * @memberof api.CreateScoutRequest
         * @instance
         */
        CreateScoutRequest.prototype.message = "";

        /**
         * Creates a new CreateScoutRequest instance using the specified properties.
         * @function create
         * @memberof api.CreateScoutRequest
         * @static
         * @param {api.ICreateScoutRequest=} [properties] Properties to set
         * @returns {api.CreateScoutRequest} CreateScoutRequest instance
         */
        CreateScoutRequest.create = function create(properties) {
            return new CreateScoutRequest(properties);
        };

        /**
         * Encodes the specified CreateScoutRequest message. Does not implicitly {@link api.CreateScoutRequest.verify|verify} messages.
         * @function encode
         * @memberof api.CreateScoutRequest
         * @static
         * @param {api.ICreateScoutRequest} message CreateScoutRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateScoutRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customerID != null && Object.hasOwnProperty.call(message, "customerID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customerID);
            if (message.projectID != null && Object.hasOwnProperty.call(message, "projectID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.projectID);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified CreateScoutRequest message, length delimited. Does not implicitly {@link api.CreateScoutRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.CreateScoutRequest
         * @static
         * @param {api.ICreateScoutRequest} message CreateScoutRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateScoutRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateScoutRequest message from the specified reader or buffer.
         * @function decode
         * @memberof api.CreateScoutRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.CreateScoutRequest} CreateScoutRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateScoutRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.CreateScoutRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customerID = reader.string();
                    break;
                case 2:
                    message.projectID = reader.string();
                    break;
                case 3:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateScoutRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.CreateScoutRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.CreateScoutRequest} CreateScoutRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateScoutRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateScoutRequest message.
         * @function verify
         * @memberof api.CreateScoutRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateScoutRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                if (!$util.isString(message.customerID))
                    return "customerID: string expected";
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                if (!$util.isString(message.projectID))
                    return "projectID: string expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a CreateScoutRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.CreateScoutRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.CreateScoutRequest} CreateScoutRequest
         */
        CreateScoutRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.api.CreateScoutRequest)
                return object;
            var message = new $root.api.CreateScoutRequest();
            if (object.customerID != null)
                message.customerID = String(object.customerID);
            if (object.projectID != null)
                message.projectID = String(object.projectID);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a CreateScoutRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.CreateScoutRequest
         * @static
         * @param {api.CreateScoutRequest} message CreateScoutRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateScoutRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.customerID = "";
                object.projectID = "";
                object.message = "";
            }
            if (message.customerID != null && message.hasOwnProperty("customerID"))
                object.customerID = message.customerID;
            if (message.projectID != null && message.hasOwnProperty("projectID"))
                object.projectID = message.projectID;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this CreateScoutRequest to JSON.
         * @function toJSON
         * @memberof api.CreateScoutRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateScoutRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateScoutRequest;
    })();

    api.SingleSkillTagService = (function() {

        /**
         * Constructs a new SingleSkillTagService service.
         * @memberof api
         * @classdesc Represents a SingleSkillTagService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function SingleSkillTagService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (SingleSkillTagService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = SingleSkillTagService;

        /**
         * Creates new SingleSkillTagService service using the specified rpc implementation.
         * @function create
         * @memberof api.SingleSkillTagService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {SingleSkillTagService} RPC service. Useful where requests and/or responses are streamed.
         */
        SingleSkillTagService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.SingleSkillTagService#getAll}.
         * @memberof api.SingleSkillTagService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SingleSkillTagList} [response] SingleSkillTagList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.SingleSkillTagService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.SingleSkillTagService.GetAllCallback} callback Node-style callback called with the error, if any, and SingleSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(SingleSkillTagService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.SingleSkillTagList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.SingleSkillTagService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.SingleSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.SingleSkillTagService#getAllByCategory}.
         * @memberof api.SingleSkillTagService
         * @typedef GetAllByCategoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.SingleSkillTagList} [response] SingleSkillTagList
         */

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.SingleSkillTagService
         * @instance
         * @param {entity.ISingleSkillTagCategory} request SingleSkillTagCategory message or plain object
         * @param {api.SingleSkillTagService.GetAllByCategoryCallback} callback Node-style callback called with the error, if any, and SingleSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(SingleSkillTagService.prototype.getAllByCategory = function getAllByCategory(request, callback) {
            return this.rpcCall(getAllByCategory, $root.entity.SingleSkillTagCategory, $root.entity.SingleSkillTagList, request, callback);
        }, "name", { value: "GetAllByCategory" });

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.SingleSkillTagService
         * @instance
         * @param {entity.ISingleSkillTagCategory} request SingleSkillTagCategory message or plain object
         * @returns {Promise<entity.SingleSkillTagList>} Promise
         * @variation 2
         */

        return SingleSkillTagService;
    })();

    api.MultiSkillTagService = (function() {

        /**
         * Constructs a new MultiSkillTagService service.
         * @memberof api
         * @classdesc Represents a MultiSkillTagService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function MultiSkillTagService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (MultiSkillTagService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MultiSkillTagService;

        /**
         * Creates new MultiSkillTagService service using the specified rpc implementation.
         * @function create
         * @memberof api.MultiSkillTagService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {MultiSkillTagService} RPC service. Useful where requests and/or responses are streamed.
         */
        MultiSkillTagService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.MultiSkillTagService#getAll}.
         * @memberof api.MultiSkillTagService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MultiSkillTagList} [response] MultiSkillTagList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @param {api.MultiSkillTagService.GetAllCallback} callback Node-style callback called with the error, if any, and MultiSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MultiSkillTagService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.common.Pager, $root.entity.MultiSkillTagList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {common.IPager} request Pager message or plain object
         * @returns {Promise<entity.MultiSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MultiSkillTagService#getAllByCategory}.
         * @memberof api.MultiSkillTagService
         * @typedef GetAllByCategoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MultiSkillTagList} [response] MultiSkillTagList
         */

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {entity.IMultiSkillTagCategory} request MultiSkillTagCategory message or plain object
         * @param {api.MultiSkillTagService.GetAllByCategoryCallback} callback Node-style callback called with the error, if any, and MultiSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MultiSkillTagService.prototype.getAllByCategory = function getAllByCategory(request, callback) {
            return this.rpcCall(getAllByCategory, $root.entity.MultiSkillTagCategory, $root.entity.MultiSkillTagList, request, callback);
        }, "name", { value: "GetAllByCategory" });

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {entity.IMultiSkillTagCategory} request MultiSkillTagCategory message or plain object
         * @returns {Promise<entity.MultiSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.MultiSkillTagService#get}.
         * @memberof api.MultiSkillTagService
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.MultiSkillTag} [response] MultiSkillTag
         */

        /**
         * Calls Get.
         * @function get
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {entity.IMultiSkillTagID} request MultiSkillTagID message or plain object
         * @param {api.MultiSkillTagService.GetCallback} callback Node-style callback called with the error, if any, and MultiSkillTag
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(MultiSkillTagService.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.entity.MultiSkillTagID, $root.entity.MultiSkillTag, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof api.MultiSkillTagService
         * @instance
         * @param {entity.IMultiSkillTagID} request MultiSkillTagID message or plain object
         * @returns {Promise<entity.MultiSkillTag>} Promise
         * @variation 2
         */

        return MultiSkillTagService;
    })();

    api.OccupationSkillTagService = (function() {

        /**
         * Constructs a new OccupationSkillTagService service.
         * @memberof api
         * @classdesc Represents an OccupationSkillTagService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function OccupationSkillTagService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (OccupationSkillTagService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = OccupationSkillTagService;

        /**
         * Creates new OccupationSkillTagService service using the specified rpc implementation.
         * @function create
         * @memberof api.OccupationSkillTagService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {OccupationSkillTagService} RPC service. Useful where requests and/or responses are streamed.
         */
        OccupationSkillTagService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.OccupationSkillTagService#getAll}.
         * @memberof api.OccupationSkillTagService
         * @typedef GetAllCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.OccupationSkillTagList} [response] OccupationSkillTagList
         */

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {entity.IOccupationSkillTagIDWithPager} request OccupationSkillTagIDWithPager message or plain object
         * @param {api.OccupationSkillTagService.GetAllCallback} callback Node-style callback called with the error, if any, and OccupationSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(OccupationSkillTagService.prototype.getAll = function getAll(request, callback) {
            return this.rpcCall(getAll, $root.entity.OccupationSkillTagIDWithPager, $root.entity.OccupationSkillTagList, request, callback);
        }, "name", { value: "GetAll" });

        /**
         * Calls GetAll.
         * @function getAll
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {entity.IOccupationSkillTagIDWithPager} request OccupationSkillTagIDWithPager message or plain object
         * @returns {Promise<entity.OccupationSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.OccupationSkillTagService#getAllByCategory}.
         * @memberof api.OccupationSkillTagService
         * @typedef GetAllByCategoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.OccupationSkillTagList} [response] OccupationSkillTagList
         */

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {entity.IOccupationSkillTagCategory} request OccupationSkillTagCategory message or plain object
         * @param {api.OccupationSkillTagService.GetAllByCategoryCallback} callback Node-style callback called with the error, if any, and OccupationSkillTagList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(OccupationSkillTagService.prototype.getAllByCategory = function getAllByCategory(request, callback) {
            return this.rpcCall(getAllByCategory, $root.entity.OccupationSkillTagCategory, $root.entity.OccupationSkillTagList, request, callback);
        }, "name", { value: "GetAllByCategory" });

        /**
         * Calls GetAllByCategory.
         * @function getAllByCategory
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {entity.IOccupationSkillTagCategory} request OccupationSkillTagCategory message or plain object
         * @returns {Promise<entity.OccupationSkillTagList>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.OccupationSkillTagService#getAllCategory}.
         * @memberof api.OccupationSkillTagService
         * @typedef GetAllCategoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {entity.OccupationSkillTagCategoryList} [response] OccupationSkillTagCategoryList
         */

        /**
         * Calls GetAllCategory.
         * @function getAllCategory
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.OccupationSkillTagService.GetAllCategoryCallback} callback Node-style callback called with the error, if any, and OccupationSkillTagCategoryList
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(OccupationSkillTagService.prototype.getAllCategory = function getAllCategory(request, callback) {
            return this.rpcCall(getAllCategory, $root.common.Empty, $root.entity.OccupationSkillTagCategoryList, request, callback);
        }, "name", { value: "GetAllCategory" });

        /**
         * Calls GetAllCategory.
         * @function getAllCategory
         * @memberof api.OccupationSkillTagService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<entity.OccupationSkillTagCategoryList>} Promise
         * @variation 2
         */

        return OccupationSkillTagService;
    })();

    api.UserService = (function() {

        /**
         * Constructs a new UserService service.
         * @memberof api
         * @classdesc Represents a UserService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function UserService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (UserService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = UserService;

        /**
         * Creates new UserService service using the specified rpc implementation.
         * @function create
         * @memberof api.UserService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {UserService} RPC service. Useful where requests and/or responses are streamed.
         */
        UserService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link api.UserService#getMe}.
         * @memberof api.UserService
         * @typedef GetMeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {api.Me} [response] Me
         */

        /**
         * Calls GetMe.
         * @function getMe
         * @memberof api.UserService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @param {api.UserService.GetMeCallback} callback Node-style callback called with the error, if any, and Me
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(UserService.prototype.getMe = function getMe(request, callback) {
            return this.rpcCall(getMe, $root.common.Empty, $root.api.Me, request, callback);
        }, "name", { value: "GetMe" });

        /**
         * Calls GetMe.
         * @function getMe
         * @memberof api.UserService
         * @instance
         * @param {common.IEmpty} request Empty message or plain object
         * @returns {Promise<api.Me>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link api.UserService#getFileDownloadURL}.
         * @memberof api.UserService
         * @typedef GetFileDownloadURLCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {common.TextResult} [response] TextResult
         */

        /**
         * Calls GetFileDownloadURL.
         * @function getFileDownloadURL
         * @memberof api.UserService
         * @instance
         * @param {common.ITextResult} request TextResult message or plain object
         * @param {api.UserService.GetFileDownloadURLCallback} callback Node-style callback called with the error, if any, and TextResult
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(UserService.prototype.getFileDownloadURL = function getFileDownloadURL(request, callback) {
            return this.rpcCall(getFileDownloadURL, $root.common.TextResult, $root.common.TextResult, request, callback);
        }, "name", { value: "GetFileDownloadURL" });

        /**
         * Calls GetFileDownloadURL.
         * @function getFileDownloadURL
         * @memberof api.UserService
         * @instance
         * @param {common.ITextResult} request TextResult message or plain object
         * @returns {Promise<common.TextResult>} Promise
         * @variation 2
         */

        return UserService;
    })();

    api.Me = (function() {

        /**
         * Properties of a Me.
         * @memberof api
         * @interface IMe
         * @property {string|null} [email] Me email
         * @property {entity.User.Role|null} [role] Me role
         * @property {entity.ICustomer|null} [customer] Me customer
         * @property {entity.IClient|null} [client] Me client
         * @property {Array.<api.Me.IMessageState>|null} [messageStateList] Me messageStateList
         * @property {boolean|null} [shouldUpdateCompany] Me shouldUpdateCompany
         */

        /**
         * Constructs a new Me.
         * @memberof api
         * @classdesc Represents a Me.
         * @implements IMe
         * @constructor
         * @param {api.IMe=} [properties] Properties to set
         */
        function Me(properties) {
            this.messageStateList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Me email.
         * @member {string} email
         * @memberof api.Me
         * @instance
         */
        Me.prototype.email = "";

        /**
         * Me role.
         * @member {entity.User.Role} role
         * @memberof api.Me
         * @instance
         */
        Me.prototype.role = 0;

        /**
         * Me customer.
         * @member {entity.ICustomer|null|undefined} customer
         * @memberof api.Me
         * @instance
         */
        Me.prototype.customer = null;

        /**
         * Me client.
         * @member {entity.IClient|null|undefined} client
         * @memberof api.Me
         * @instance
         */
        Me.prototype.client = null;

        /**
         * Me messageStateList.
         * @member {Array.<api.Me.IMessageState>} messageStateList
         * @memberof api.Me
         * @instance
         */
        Me.prototype.messageStateList = $util.emptyArray;

        /**
         * Me shouldUpdateCompany.
         * @member {boolean} shouldUpdateCompany
         * @memberof api.Me
         * @instance
         */
        Me.prototype.shouldUpdateCompany = false;

        /**
         * Creates a new Me instance using the specified properties.
         * @function create
         * @memberof api.Me
         * @static
         * @param {api.IMe=} [properties] Properties to set
         * @returns {api.Me} Me instance
         */
        Me.create = function create(properties) {
            return new Me(properties);
        };

        /**
         * Encodes the specified Me message. Does not implicitly {@link api.Me.verify|verify} messages.
         * @function encode
         * @memberof api.Me
         * @static
         * @param {api.IMe} message Me message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Me.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.role);
            if (message.customer != null && Object.hasOwnProperty.call(message, "customer"))
                $root.entity.Customer.encode(message.customer, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.client != null && Object.hasOwnProperty.call(message, "client"))
                $root.entity.Client.encode(message.client, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.messageStateList != null && message.messageStateList.length)
                for (var i = 0; i < message.messageStateList.length; ++i)
                    $root.api.Me.MessageState.encode(message.messageStateList[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.shouldUpdateCompany != null && Object.hasOwnProperty.call(message, "shouldUpdateCompany"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.shouldUpdateCompany);
            return writer;
        };

        /**
         * Encodes the specified Me message, length delimited. Does not implicitly {@link api.Me.verify|verify} messages.
         * @function encodeDelimited
         * @memberof api.Me
         * @static
         * @param {api.IMe} message Me message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Me.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Me message from the specified reader or buffer.
         * @function decode
         * @memberof api.Me
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {api.Me} Me
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Me.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.Me();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.email = reader.string();
                    break;
                case 2:
                    message.role = reader.int32();
                    break;
                case 3:
                    message.customer = $root.entity.Customer.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.client = $root.entity.Client.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.messageStateList && message.messageStateList.length))
                        message.messageStateList = [];
                    message.messageStateList.push($root.api.Me.MessageState.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.shouldUpdateCompany = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Me message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof api.Me
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {api.Me} Me
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Me.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Me message.
         * @function verify
         * @memberof api.Me
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Me.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.customer != null && message.hasOwnProperty("customer")) {
                var error = $root.entity.Customer.verify(message.customer);
                if (error)
                    return "customer." + error;
            }
            if (message.client != null && message.hasOwnProperty("client")) {
                var error = $root.entity.Client.verify(message.client);
                if (error)
                    return "client." + error;
            }
            if (message.messageStateList != null && message.hasOwnProperty("messageStateList")) {
                if (!Array.isArray(message.messageStateList))
                    return "messageStateList: array expected";
                for (var i = 0; i < message.messageStateList.length; ++i) {
                    var error = $root.api.Me.MessageState.verify(message.messageStateList[i]);
                    if (error)
                        return "messageStateList." + error;
                }
            }
            if (message.shouldUpdateCompany != null && message.hasOwnProperty("shouldUpdateCompany"))
                if (typeof message.shouldUpdateCompany !== "boolean")
                    return "shouldUpdateCompany: boolean expected";
            return null;
        };

        /**
         * Creates a Me message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof api.Me
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {api.Me} Me
         */
        Me.fromObject = function fromObject(object) {
            if (object instanceof $root.api.Me)
                return object;
            var message = new $root.api.Me();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.role) {
            case "Role_Unknown":
            case 0:
                message.role = 0;
                break;
            case "Role_Customer":
            case 1:
                message.role = 1;
                break;
            case "Role_Client":
            case 2:
                message.role = 2;
                break;
            }
            if (object.customer != null) {
                if (typeof object.customer !== "object")
                    throw TypeError(".api.Me.customer: object expected");
                message.customer = $root.entity.Customer.fromObject(object.customer);
            }
            if (object.client != null) {
                if (typeof object.client !== "object")
                    throw TypeError(".api.Me.client: object expected");
                message.client = $root.entity.Client.fromObject(object.client);
            }
            if (object.messageStateList) {
                if (!Array.isArray(object.messageStateList))
                    throw TypeError(".api.Me.messageStateList: array expected");
                message.messageStateList = [];
                for (var i = 0; i < object.messageStateList.length; ++i) {
                    if (typeof object.messageStateList[i] !== "object")
                        throw TypeError(".api.Me.messageStateList: object expected");
                    message.messageStateList[i] = $root.api.Me.MessageState.fromObject(object.messageStateList[i]);
                }
            }
            if (object.shouldUpdateCompany != null)
                message.shouldUpdateCompany = Boolean(object.shouldUpdateCompany);
            return message;
        };

        /**
         * Creates a plain object from a Me message. Also converts values to other types if specified.
         * @function toObject
         * @memberof api.Me
         * @static
         * @param {api.Me} message Me
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Me.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.messageStateList = [];
            if (options.defaults) {
                object.email = "";
                object.role = options.enums === String ? "Role_Unknown" : 0;
                object.customer = null;
                object.client = null;
                object.shouldUpdateCompany = false;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.entity.User.Role[message.role] : message.role;
            if (message.customer != null && message.hasOwnProperty("customer"))
                object.customer = $root.entity.Customer.toObject(message.customer, options);
            if (message.client != null && message.hasOwnProperty("client"))
                object.client = $root.entity.Client.toObject(message.client, options);
            if (message.messageStateList && message.messageStateList.length) {
                object.messageStateList = [];
                for (var j = 0; j < message.messageStateList.length; ++j)
                    object.messageStateList[j] = $root.api.Me.MessageState.toObject(message.messageStateList[j], options);
            }
            if (message.shouldUpdateCompany != null && message.hasOwnProperty("shouldUpdateCompany"))
                object.shouldUpdateCompany = message.shouldUpdateCompany;
            return object;
        };

        /**
         * Converts this Me to JSON.
         * @function toJSON
         * @memberof api.Me
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Me.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Me.MessageState = (function() {

            /**
             * Properties of a MessageState.
             * @memberof api.Me
             * @interface IMessageState
             * @property {string|null} [roomID] MessageState roomID
             * @property {boolean|null} [isUnRead] MessageState isUnRead
             * @property {number|Long|null} [unReadCount] MessageState unReadCount
             */

            /**
             * Constructs a new MessageState.
             * @memberof api.Me
             * @classdesc Represents a MessageState.
             * @implements IMessageState
             * @constructor
             * @param {api.Me.IMessageState=} [properties] Properties to set
             */
            function MessageState(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MessageState roomID.
             * @member {string} roomID
             * @memberof api.Me.MessageState
             * @instance
             */
            MessageState.prototype.roomID = "";

            /**
             * MessageState isUnRead.
             * @member {boolean} isUnRead
             * @memberof api.Me.MessageState
             * @instance
             */
            MessageState.prototype.isUnRead = false;

            /**
             * MessageState unReadCount.
             * @member {number|Long} unReadCount
             * @memberof api.Me.MessageState
             * @instance
             */
            MessageState.prototype.unReadCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new MessageState instance using the specified properties.
             * @function create
             * @memberof api.Me.MessageState
             * @static
             * @param {api.Me.IMessageState=} [properties] Properties to set
             * @returns {api.Me.MessageState} MessageState instance
             */
            MessageState.create = function create(properties) {
                return new MessageState(properties);
            };

            /**
             * Encodes the specified MessageState message. Does not implicitly {@link api.Me.MessageState.verify|verify} messages.
             * @function encode
             * @memberof api.Me.MessageState
             * @static
             * @param {api.Me.IMessageState} message MessageState message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageState.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomID != null && Object.hasOwnProperty.call(message, "roomID"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomID);
                if (message.isUnRead != null && Object.hasOwnProperty.call(message, "isUnRead"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isUnRead);
                if (message.unReadCount != null && Object.hasOwnProperty.call(message, "unReadCount"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.unReadCount);
                return writer;
            };

            /**
             * Encodes the specified MessageState message, length delimited. Does not implicitly {@link api.Me.MessageState.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.Me.MessageState
             * @static
             * @param {api.Me.IMessageState} message MessageState message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageState.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MessageState message from the specified reader or buffer.
             * @function decode
             * @memberof api.Me.MessageState
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.Me.MessageState} MessageState
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageState.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.Me.MessageState();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomID = reader.string();
                        break;
                    case 2:
                        message.isUnRead = reader.bool();
                        break;
                    case 3:
                        message.unReadCount = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MessageState message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.Me.MessageState
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.Me.MessageState} MessageState
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageState.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MessageState message.
             * @function verify
             * @memberof api.Me.MessageState
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MessageState.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomID != null && message.hasOwnProperty("roomID"))
                    if (!$util.isString(message.roomID))
                        return "roomID: string expected";
                if (message.isUnRead != null && message.hasOwnProperty("isUnRead"))
                    if (typeof message.isUnRead !== "boolean")
                        return "isUnRead: boolean expected";
                if (message.unReadCount != null && message.hasOwnProperty("unReadCount"))
                    if (!$util.isInteger(message.unReadCount) && !(message.unReadCount && $util.isInteger(message.unReadCount.low) && $util.isInteger(message.unReadCount.high)))
                        return "unReadCount: integer|Long expected";
                return null;
            };

            /**
             * Creates a MessageState message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.Me.MessageState
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.Me.MessageState} MessageState
             */
            MessageState.fromObject = function fromObject(object) {
                if (object instanceof $root.api.Me.MessageState)
                    return object;
                var message = new $root.api.Me.MessageState();
                if (object.roomID != null)
                    message.roomID = String(object.roomID);
                if (object.isUnRead != null)
                    message.isUnRead = Boolean(object.isUnRead);
                if (object.unReadCount != null)
                    if ($util.Long)
                        (message.unReadCount = $util.Long.fromValue(object.unReadCount)).unsigned = false;
                    else if (typeof object.unReadCount === "string")
                        message.unReadCount = parseInt(object.unReadCount, 10);
                    else if (typeof object.unReadCount === "number")
                        message.unReadCount = object.unReadCount;
                    else if (typeof object.unReadCount === "object")
                        message.unReadCount = new $util.LongBits(object.unReadCount.low >>> 0, object.unReadCount.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a MessageState message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.Me.MessageState
             * @static
             * @param {api.Me.MessageState} message MessageState
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MessageState.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.roomID = "";
                    object.isUnRead = false;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.unReadCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.unReadCount = options.longs === String ? "0" : 0;
                }
                if (message.roomID != null && message.hasOwnProperty("roomID"))
                    object.roomID = message.roomID;
                if (message.isUnRead != null && message.hasOwnProperty("isUnRead"))
                    object.isUnRead = message.isUnRead;
                if (message.unReadCount != null && message.hasOwnProperty("unReadCount"))
                    if (typeof message.unReadCount === "number")
                        object.unReadCount = options.longs === String ? String(message.unReadCount) : message.unReadCount;
                    else
                        object.unReadCount = options.longs === String ? $util.Long.prototype.toString.call(message.unReadCount) : options.longs === Number ? new $util.LongBits(message.unReadCount.low >>> 0, message.unReadCount.high >>> 0).toNumber() : message.unReadCount;
                return object;
            };

            /**
             * Converts this MessageState to JSON.
             * @function toJSON
             * @memberof api.Me.MessageState
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MessageState.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MessageState;
        })();

        return Me;
    })();

    return api;
})();

module.exports = $root;



// WEBPACK FOOTER //
// ./src/infra/api/rpc/api.js